
import { immerable } from "immer";

export interface IReturn<T>
{
    createResponse(): T;
}

export interface IReturnVoid
{
    createResponse(): void;
}

export interface IHasSessionId
{
    sessionId?: string;
}

export interface IHasBearerToken
{
    bearerToken?: string;
}

export interface IGet
{
}

export interface IPost
{
}

export interface IPut
{
}

export class SquareCard
{
    public id: string;
    public card_brand: string;
    public exp_month: number;
    public exp_year: number;
    public last_4: string;
    public customer_id: string;
    public cardholder_name: string;

    public constructor(init?: Partial<SquareCard>) { (Object as any).assign(this, init); }
}
(SquareCard as unknown)[immerable] = true;

export class SquareMoneyAmount
{
    public amount: number;
    public currency: string;

    public constructor(init?: Partial<SquareMoneyAmount>) { (Object as any).assign(this, init); }
}
(SquareMoneyAmount as unknown)[immerable] = true;

export class SquareRefund
{
    public id: string;
    public created_at: string;
    public updated_at: string;
    public status: string;
    public amount_money: SquareMoneyAmount;
    public location_id: string;
    public payment_id: string;

    public constructor(init?: Partial<SquareRefund>) { (Object as any).assign(this, init); }
}
(SquareRefund as unknown)[immerable] = true;

export class SquareDeviceCode
{
    public code: string;
    public created_at: string;
    public device_id: string;
    public id: string;
    public location_id: string;
    public name: string;
    public paired_at: string;
    public product_type: string;
    public status: string;
    public status_changed_at: string;

    public constructor(init?: Partial<SquareDeviceCode>) { (Object as any).assign(this, init); }
}
(SquareDeviceCode as unknown)[immerable] = true;

export class SquareDeviceOptions
{
    public device_id: string;
    public skip_receipt_screen: boolean;

    public constructor(init?: Partial<SquareDeviceOptions>) { (Object as any).assign(this, init); }
}
(SquareDeviceOptions as unknown)[immerable] = true;

export class SquareTerminalCheckout
{
    public amount_money: SquareMoneyAmount;
    public created_at: string;
    public deadline_duration: string;
    public id: string;
    public note: string;
    public reference_id: string;
    public status: string;
    public updated_at: string;
    public payment_ids: string[];
    public device_options: SquareDeviceOptions;

    public constructor(init?: Partial<SquareTerminalCheckout>) { (Object as any).assign(this, init); }
}
(SquareTerminalCheckout as unknown)[immerable] = true;

export class SquareData
{
    public card: SquareCard;
    public refund: SquareRefund;
    public device_code: SquareDeviceCode;
    public checkout: SquareTerminalCheckout;

    public constructor(init?: Partial<SquareData>) { (Object as any).assign(this, init); }
}
(SquareData as unknown)[immerable] = true;

export class SquareWebhookData
{
    public type: string;
    public id: string;
    public object: SquareData;

    public constructor(init?: Partial<SquareWebhookData>) { (Object as any).assign(this, init); }
}
(SquareWebhookData as unknown)[immerable] = true;

// @Flags()
export enum DiscountStatus
{
    Inactive = 0,
    Active = 1,
}

export enum AlphaNumericFilterConditions
{
    StartsWith = 'StartsWith',
    EndsWith = 'EndsWith',
    Equals = 'Equals',
    DoesNotEqual = 'DoesNotEqual',
    DoesNotStartWith = 'DoesNotStartWith',
    DoesNotEndWith = 'DoesNotEndWith',
    Contains = 'Contains',
    DoesNotContain = 'DoesNotContain',
    IsSet = 'IsSet',
    IsNotSet = 'IsNotSet',
}

export class AlphaNumericSearch
{
    public selectedFilterOption: AlphaNumericFilterConditions;
    public alphaNumericSearchValue: string;
    public removeSpaces: boolean;

    public constructor(init?: Partial<AlphaNumericSearch>) { (Object as any).assign(this, init); }
}
(AlphaNumericSearch as unknown)[immerable] = true;

export enum LookUpFilterConditions
{
    IsOneOf = 'IsOneOf',
    IsNotOneOf = 'IsNotOneOf',
    Is = 'Is',
    IsNot = 'IsNot',
}

export enum LookUpSearchType
{
    Practitioners = 0,
    PatientTags = 1,
    Locations = 2,
    Groups = 3,
    HealthcodeGroups = 4,
    PaymentMethod = 5,
    PaymentStatus = 6,
    InvoiceStatus = 7,
    InvoiceBatch = 8,
    StockCategory = 9,
    StockTags = 10,
    LocationStatus = 11,
    BillingItemStatus = 12,
    InvoicePeriod = 13,
    CaseStatus = 14,
    BodySite = 15,
    Diagnosis = 16,
    Suppliers = 17,
    ExpenditureCategory = 18,
    GroupClassification = 19,
    PractitionerType = 20,
    AuditObjectTypes = 21,
    AuditActions = 22,
    AccountType = 23,
    DebtInvoiceStatus = 24,
    DebtAge = 25,
    CustomerStatus = 26,
    Gender = 27,
    Stock = 28,
    AppointmentStatus = 29,
    AppointmentType = 30,
    RpUserType = 31,
    Tags = 32,
    Skills = 33,
    GdsWorkSheetStatus = 34,
    JobSheetStatus = 34,
    TimelineType = 35,
    Vehicle = 36,
    PractitionerStatus = 37,
    ProntoStatus = 38,
    User = 39,
    TaskUser = 40,
    TaskStatus = 41,
    TaskLinkedObjectType = 42,
    WorkflowStatus = 43,
    Team = 44,
    WorkflowProcess = 45,
    Contract = 46,
    StockGroupName = 47,
    StockClassifications = 48,
    NM_BusinessProntoStatus = 49,
    DiscountStatus = 50,
    LedgerCode = 51,
    DocumentApprovalStatus = 52,
}

export class LookUpSearch
{
    public selectedFilterOption: LookUpFilterConditions;
    public lookUpSearchType: LookUpSearchType;
    public isJsonSearch: boolean;
    public lookUpDataType: string;
    public lookUpSearchValues: Object[];

    public constructor(init?: Partial<LookUpSearch>) { (Object as any).assign(this, init); }
}
(LookUpSearch as unknown)[immerable] = true;

export enum DateTimeFilterConditions
{
    IsBetween = 'IsBetween',
    IsNotBetween = 'IsNotBetween',
    IsOn = 'IsOn',
    IsNotOn = 'IsNotOn',
    IsBefore = 'IsBefore',
    IsBeforeExact = 'IsBeforeExact',
    IsOnOrBefore = 'IsOnOrBefore',
    IsAfter = 'IsAfter',
    IsOnOrAfter = 'IsOnOrAfter',
    IsSet = 'IsSet',
    IsNotSet = 'IsNotSet',
}

export class DateRange
{
    public from?: string;
    public to?: string;

    public constructor(init?: Partial<DateRange>) { (Object as any).assign(this, init); }
}
(DateRange as unknown)[immerable] = true;

export class DateTimeSearch
{
    public selectedFilterOption: DateTimeFilterConditions;
    public dateRangeValue: DateRange;

    public constructor(init?: Partial<DateTimeSearch>) { (Object as any).assign(this, init); }
}
(DateTimeSearch as unknown)[immerable] = true;

export enum BooleanFilterConditions
{
    IsSet = 'IsSet',
    IsNotSet = 'IsNotSet',
}

export class BooleanSearch
{
    public selectedFilterOption: BooleanFilterConditions;
    public booleanSearchValue: boolean;

    public constructor(init?: Partial<BooleanSearch>) { (Object as any).assign(this, init); }
}
(BooleanSearch as unknown)[immerable] = true;

export class SearchFilterConditionItem
{
    public alphaNumericSearchFieldCondition: AlphaNumericSearch;
    public lookUpSearchFieldCondition: LookUpSearch;
    public dateTimeSearchFieldCondition: DateTimeSearch;
    public booleanSearchFieldCondition: BooleanSearch;
    public integerSearchFieldCondition: NumericSearch<number>;
    public decimalSearchFieldCondition: NumericSearch<number>;

    public constructor(init?: Partial<SearchFilterConditionItem>) { (Object as any).assign(this, init); }
}
(SearchFilterConditionItem as unknown)[immerable] = true;

export enum SearchFieldDataType
{
    StringField = 'StringField',
    AlphaNumericField = 'AlphaNumericField',
    LookUpField = 'LookUpField',
    BooleanField = 'BooleanField',
    DateTimeField = 'DateTimeField',
    JsonField = 'JsonField',
    IntegerField = 'IntegerField',
    DecimalField = 'DecimalField',
}

export enum Delimiters
{
    None = 'None',
    Space = 'Space',
    Comma = 'Comma',
}

export class SearchFilterCondition
{
    public conditions: SearchFilterConditionItem[];
    public fieldName: string;
    public displayName: string;
    public fieldType: SearchFieldDataType;
    public displayOnGrid: boolean;
    public isFilterApplied: boolean;
    public isCustom: boolean;
    public dbFieldsToSearch: string[];
    public delimiters: Delimiters;
    public customIsSetText: string;
    public customIsNotSetText: string;
    public module: string;
    public redisSearchField: string;
    public useScanner: boolean;
    public order: number;

    public constructor(init?: Partial<SearchFilterCondition>) { (Object as any).assign(this, init); }
}
(SearchFilterCondition as unknown)[immerable] = true;

export class QueryField
{
    // @ApiMember(ExcludeInSchema=true)
    public customFieldNames: string[];

    /** @description Field Name to sort by */
    // @ApiMember(Description="Field Name to sort by")
    public field: string;

    /** @description Sort order - `asc` or `desc` */
    // @ApiMember(Description="Sort order - `asc` or `desc`")
    public dir: string;

    public constructor(init?: Partial<QueryField>) { (Object as any).assign(this, init); }
}
(QueryField as unknown)[immerable] = true;

export class BaseAdvancedSearchRequest implements ILocationIds, IFilterServiceTypeManually
{
    public filterConditions: SearchFilterCondition[];
    public appliedFilters: SearchFilterCondition[];
    public appliedCustomFilters: SearchFilterCondition[];
    public skip: number;
    public take?: number;
    public groups: QueryField[];
    public sort: QueryField[];
    public term: string;
    public baseSearchId?: string;
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<BaseAdvancedSearchRequest>) { (Object as any).assign(this, init); }
}
(BaseAdvancedSearchRequest as unknown)[immerable] = true;

export interface ILocationIds
{
    locationIds: number[];
    requestLocationIds: number[];
}

export interface IFilterServiceTypeManually
{
}

export class BillingItem implements IHasId, ILocationId, IHasGlobalGuid
{
    public accountId: number;
    public customerId?: number;
    public practitionerId?: number;
    public soldByUserId?: number;
    public appointmentId?: number;
    public locationId: number;
    public invoiceId?: number;
    public stockId?: number;
    public billingEntityId?: number;
    public date?: string;
    public description: string;
    public total: number;
    public isPaid?: boolean;
    public isMigrated?: boolean;
    public totalExVat?: number;
    public quantity?: number;
    public price?: number;
    public vatRate?: number;
    public totalVat?: number;
    public id: number;
    public globalGuid: string;
    public category: string;
    public ledgerCode: string;
    public accountsExportId?: number;
    public prontoServiceId?: string;
    public parentId?: number;
    public subscriptionId?: number;
    public discountCodeId?: string;
    public sequenceNo?: number;
    public sectionId?: number;
    public caseId?: number;
    public workflowId?: number;
    public subWorkflowId?: number;
    public treatmentId?: number;
    public stockInventoryLevelId?: number;
    // @Ignore()
    public guid: string;

    // @Ignore()
    public parentGuid?: string;

    public barcode: string;

    public constructor(init?: Partial<BillingItem>) { (Object as any).assign(this, init); }
}
(BillingItem as unknown)[immerable] = true;

export enum DiscountType
{
    Amount = 'Amount',
    Percentage = 'Percentage',
}

export enum DiscountApplyTo
{
    Invoice = 'Invoice',
    Charge = 'Charge',
}

export enum DiscountRestriction
{
    None = 'None',
    Tags = 'Tags',
    StockItems = 'StockItems',
}

export interface ILocationId
{
    locationId: number;
}

export interface ISecurityId
{
    securityId: number;
}

export enum ResetMode
{
    None = 'None',
    PassKey = 'PassKey',
    MFA = 'MFA',
    Password = 'Password',
}

export class UserRoleLocationDto
{
    public id: number;
    public locationId: number;
    public userId: number;
    public roleId: number;
    public globalGuid: string;

    public constructor(init?: Partial<UserRoleLocationDto>) { (Object as any).assign(this, init); }
}
(UserRoleLocationDto as unknown)[immerable] = true;

export interface IHasPath
{
    path: string;
    safeRoot: string;
}

export class CommandBarRequest implements ILocationIds
{
    public term: string;
    public limit: number;
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<CommandBarRequest>) { (Object as any).assign(this, init); }
}
(CommandBarRequest as unknown)[immerable] = true;

export enum MergeFieldType
{
    Workflow = 'Workflow',
    SubWorkflow = 'SubWorkflow',
    Network = 'Network',
    NetworkClinician = 'NetworkClinician',
    NetworkLocation = 'NetworkLocation',
}

export enum MergeFieldDataType
{
    Text = 'Text',
    Date = 'Date',
    DateTime = 'DateTime',
}

export class MergeFieldMappingDto
{
    public id: string;
    public type: MergeFieldType;
    public name: string;
    public field: string;
    public dataType: MergeFieldDataType;

    public constructor(init?: Partial<MergeFieldMappingDto>) { (Object as any).assign(this, init); }
}
(MergeFieldMappingDto as unknown)[immerable] = true;

export class BatchInvoiceMergeDataRequestObject
{
    public id: number;
    public template: string;

    public constructor(init?: Partial<BatchInvoiceMergeDataRequestObject>) { (Object as any).assign(this, init); }
}
(BatchInvoiceMergeDataRequestObject as unknown)[immerable] = true;

export interface ISecurityIds
{
    securityIds: number[];
}

export class BatchMergeDataRequestObject
{
    public id: number;
    public template: string;
    public type: string;

    public constructor(init?: Partial<BatchMergeDataRequestObject>) { (Object as any).assign(this, init); }
}
(BatchMergeDataRequestObject as unknown)[immerable] = true;

export interface ISecurityType
{
    securityType: string;
}

export interface IDepartmentIds
{
    departmentIds: number[];
}

export interface IAllowedDepartmentIds
{
    allowedDepartmentIds: number[];
}

export interface ICustomerId
{
    customerId: number;
}

// @Flags()
export enum CreationSource
{
    Product = 1,
    Connect = 2,
    ReferralPortal = 4,
    ExternalApi = 8,
    ProductApi = 16,
    Pronto = 32,
    Pipedrive = 64,
    HubSpot = 128,
    Salesforce = 256,
}

export enum PackageBundleItemType
{
    Consultancy = 'Consultancy',
    Stock = 'Stock',
    Course = 'Course',
    Class = 'Class',
}

export interface IInvoiceId
{
    invoiceId: number;
}

export class CustomerCSVHeaderOverrides
{
    public status: string;
    public reference: string;
    public name: string;
    public address: string;
    public postCode: string;
    public dateOfBirth: string;
    public number: string;
    public email: string;
    public registrationDate: string;
    public balanceInvoiced: string;
    public locationName: string;
    public groupName: string;
    public practitionerName: string;

    public constructor(init?: Partial<CustomerCSVHeaderOverrides>) { (Object as any).assign(this, init); }
}
(CustomerCSVHeaderOverrides as unknown)[immerable] = true;

export class MedicalContactsCSVHeaderOverrides
{
    public status: string;
    public reference: string;
    public forename: string;
    public surname: string;
    public businessName: string;
    public address: string;
    public telephone: string;
    public email: string;
    public web: string;
    public locationName: string;

    public constructor(init?: Partial<MedicalContactsCSVHeaderOverrides>) { (Object as any).assign(this, init); }
}
(MedicalContactsCSVHeaderOverrides as unknown)[immerable] = true;

export interface IServiceTypeId
{
    serviceTypeId: number;
}

export enum ContactLayoutMode
{
    Default = 'Default',
    Customer = 'Customer',
    Business = 'Business',
    MedicalContact = 'MedicalContact',
    Supplier = 'Supplier',
    Practitioner = 'Practitioner',
    NetworkManagementBusiness = 'NetworkManagementBusiness',
}

export enum TimelineType
{
    Log = 'Log',
    Note = 'Note',
    Alert = 'Alert',
    CloudRxPrescription = 'CloudRxPrescription',
    Authorisation = 'Authorisation',
    PharmaciergesPrescription = 'PharmaciergesPrescription',
}

export enum TimelineLinkedObjectType
{
    Default = 'Default',
    Payment = 'Payment',
    Invoice = 'Invoice',
    Charge = 'Charge',
    Appointment = 'Appointment',
    Class = 'Class',
    Document = 'Document',
    Form = 'Form',
    Download = 'Download',
    Worksheet = 'Worksheet',
    Vehicle = 'Vehicle',
    Case = 'Case',
    Task = 'Task',
    Note = 'Note',
    Authorisation = 'Authorisation',
    Practitioner = 'Practitioner',
    Room = 'Room',
    Workflow = 'Workflow',
}

export enum TimelineContextObjectType
{
    Default = 'Default',
    Vehicle = 'Vehicle',
}

export interface IClientSpecificCacheService
{
}

export interface IClientDbAccess
{
    cache: IClientSpecificCacheService;
}

export class SecurityDto implements ISecurityId, ISecurityType, ISecurityGuid
{
    public securityId: number;
    public securityType: string;
    public securityGuid: string;

    public constructor(init?: Partial<SecurityDto>) { (Object as any).assign(this, init); }
}
(SecurityDto as unknown)[immerable] = true;

export interface ISecurityLocator
{
    securityLocator: Func<Object, IClientDbAccess, SecurityDto>;
}

export class DiaryListBase extends BaseAdvancedSearchRequest
{
    public date: string;
    public isWeek: boolean;
    public practitionerIds: number[];
    public locationId: number;
    public appointmentId?: number;

    public constructor(init?: Partial<DiaryListBase>) { super(init); (Object as any).assign(this, init); }
}
(DiaryListBase as unknown)[immerable] = true;

export interface IHasAutoRefresh
{
    autoRefresh: boolean;
}

export enum ResourceMode
{
    Room = 'Room',
    Practitioner = 'Practitioner',
}

// @Flags()
export enum WorkingTimeRestriction
{
    None = 0,
    Tags = 1,
    StockItems = 2,
}

export enum RecurrenceType
{
    None = 'None',
    Day = 'Day',
    Week = 'Week',
    Fortnight = 'Fortnight',
    Month = 'Month',
    Quarter = 'Quarter',
    Year = 'Year',
    Custom = 'Custom',
    WorkingDay = 'WorkingDay',
}

export interface IGroupId
{
    groupId: number;
}

export enum InvoicePeriod
{
    All = 'All',
    Monthly = 'Monthly',
    AfterEachAppointment = 'AfterEachAppointment',
    AdHoc = 'AdHoc',
    Manual = 'Manual',
    Discharge = 'Discharge',
}

export enum InvoicedStatusToInclude
{
    All = 'All',
    Uninvoiced = 'Uninvoiced',
    Invoiced = 'Invoiced',
}

export class ChargeGroup
{
    public accountId: number;
    public type: string;
    public charges: number[];

    public constructor(init?: Partial<ChargeGroup>) { (Object as any).assign(this, init); }
}
(ChargeGroup as unknown)[immerable] = true;

export class InvoiceBatch implements IHasId
{
    public id: number;
    public date?: string;

    public constructor(init?: Partial<InvoiceBatch>) { (Object as any).assign(this, init); }
}
(InvoiceBatch as unknown)[immerable] = true;

export class BillingItemWithNames extends BillingItem
{
    public practitionerForename: string;
    public practitionerTitle: string;
    public practitionerSurname: string;
    public practitionerCode: string;
    public practitionerLocationCode: string;
    public practitionerGroupProviderNo: string;
    // @Ignore()
    public providerNo: string;

    public employmentStatus: string;
    // @Ignore()
    public practitionerName: string;

    public customerForename: string;
    public customerTitle: string;
    public customerSurname: string;
    // @Ignore()
    public customerName: string;

    public auditId?: string;

    public constructor(init?: Partial<BillingItemWithNames>) { super(init); (Object as any).assign(this, init); }
}
(BillingItemWithNames as unknown)[immerable] = true;

export class LineItemResponse extends BillingItemWithNames
{
    public heading: string;
    public isHeading: boolean;
    public stockBatchCode: string;
    public stockBatchExpiryDate?: string;
    public type: string;

    public constructor(init?: Partial<LineItemResponse>) { super(init); (Object as any).assign(this, init); }
}
(LineItemResponse as unknown)[immerable] = true;

export class BillingItemSection implements IHasId
{
    public id: number;
    // @Required()
    public invoiceId: number;

    // @StringLength(255)
    // @Required()
    public heading: string;

    public sequenceNo?: number;

    public constructor(init?: Partial<BillingItemSection>) { (Object as any).assign(this, init); }
}
(BillingItemSection as unknown)[immerable] = true;

export interface IHasId extends IHasIdMarker
{
    id: number;
}

export interface IHasIdMarker
{
}

export class Charge
{
    public locationId: number;
    public accountId: number;
    public customerId?: number;
    public appointmentId: number;
    public practitionerId?: number;
    public invoiceId?: number;
    public stockId: number;
    public paid: number;
    public migrated: number;
    public transferred: number;
    public roomId: number;
    public accountsExportId?: number;
    public createdByUserId: number;
    public description: string;
    public category: string;
    public ledgerCode: string;
    public discriminatorType: string;
    public stockBarcode: string;
    public stockInventoryLevelId?: number;
    public totalExVat: number;
    public quantity: number;
    public price: number;
    public vatRate: number;
    public totalVat: number;
    public total: number;
    public date?: string;
    public parentId?: number;
    public sequenceNo: number;

    public constructor(init?: Partial<Charge>) { (Object as any).assign(this, init); }
}
(Charge as unknown)[immerable] = true;

export class CurrencyRange
{
    public min?: number;
    public max?: number;

    public constructor(init?: Partial<CurrencyRange>) { (Object as any).assign(this, init); }
}
(CurrencyRange as unknown)[immerable] = true;

export class Invoice implements ILocationId, IHasReference, IHasDocuments
{
    public id: number;
    public status: string;
    public reference: string;
    public date: string;
    public dueDate: string;
    public fullyPaidDate?: string;
    public grandTotal: number;
    public amountPaid: number;
    public customerId?: number;
    public locationId: number;
    public accountId: number;
    public addressTo: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public addressLine5: string;
    public postCode: string;
    public reminder?: string;
    public secondReminder?: string;
    public totalExcludingVat: number;
    public vatAmount: number;
    public batchId?: number;
    public notes: string;
    public globalId?: string;
    public globalType: number;
    public paymentStatus: string;
    public medipassTransactionId: string;
    public medipassStatus: string;
    public purchaseOrderNumber: string;
    public medicalContactId?: number;
    public referralDate?: string;
    public documentsLoaded: boolean;
    public isSquarePrepayment: boolean;
    // @Ignore()
    public documentsSubDirectory: string;

    public constructor(init?: Partial<Invoice>) { (Object as any).assign(this, init); }
}
(Invoice as unknown)[immerable] = true;

export class Income implements ILocationId, IHasReference
{
    public id: number;
    public onlineGuid: string;
    public amount: number;
    public paymentMethod: string;
    public otherPaymentMethod: string;
    public customerId?: number;
    public status: string;
    public date?: string;
    public reference: string;
    public lodgementRef: string;
    public accountId: number;
    public accountsExportId?: number;
    public locationId: number;
    public receivedAtLocationId: number;
    public notes: string;
    public cardType: string;
    public cardNumber: string;
    public expiry: string;
    public chequeNumber: string;
    public migrated?: boolean;
    public transferred?: boolean;
    public paidBy: string;
    public refundReason: string;
    public paymentIntentId: string;
    public electronicPaymentDate?: string;
    public importDate?: string;
    public importBatchId?: string;
    public merchantReference: string;
    public authorisationCode: string;
    public squarePaymentId: string;
    // @Ignore()
    public meta: { [index:string]: Object; };

    public data: { [index:string]: string; };

    public constructor(init?: Partial<Income>) { (Object as any).assign(this, init); }
}
(Income as unknown)[immerable] = true;

export interface IHasReference extends IHasId
{
    reference: string;
}

export class ReconciliationResponse
{
    public id: number;
    public status: string;
    public date?: string;
    public paymentId?: number;
    public reference: string;
    public name: string;
    public total?: number;
    public paid?: number;
    public reconciled?: number;
    public customerName: string;

    public constructor(init?: Partial<ReconciliationResponse>) { (Object as any).assign(this, init); }
}
(ReconciliationResponse as unknown)[immerable] = true;

export enum QuickBillMode
{
    Patient = 'Patient',
    Appointment = 'Appointment',
    MyClinics = 'MyClinics',
    Business = 'Business',
}

// @Flags()
export enum EPrePaidType
{
    Items = 0,
    Credits = 1,
}

export enum QuickPayType
{
    Customer = 'Customer',
    Group = 'Group',
    Medipass = 'Medipass',
}

export enum QuickPayMode
{
    PayLater = 'PayLater',
    DoNotBill = 'DoNotBill',
    InvoiceAndDoMore = 'InvoiceAndDoMore',
    Cash = 'Cash',
    Cheque = 'Cheque',
    Card = 'Card',
    Chase = 'Chase',
    Token = 'Token',
    Medipass = 'Medipass',
    Terminal = 'Terminal',
    Prepayment = 'Prepayment',
    AccountCredit = 'AccountCredit',
    VirtualTerminal = 'VirtualTerminal',
}

export enum PaymentProviderName
{
    None = 'None',
    Stripe = 'Stripe',
    Worldpay = 'Worldpay',
    Square = 'Square',
    ClearAccept = 'ClearAccept',
}

export enum TerminalPaymentProviderPaymentStatus
{
    None = 'None',
    InProgress = 'InProgress',
    Complete = 'Complete',
    Error = 'Error',
    Cancelled = 'Cancelled',
}

export enum PaymentProviderPaymentStatus
{
    None = 'None',
    NotFound = 'NotFound',
    Pending = 'Pending',
    Success = 'Success',
    Error = 'Error',
    Cancelled = 'Cancelled',
    Refunded = 'Refunded',
    Voided = 'Voided',
}

export class TerminalPaymentDto
{
    public provider: PaymentProviderName;
    public data: { [index:string]: string; };
    public merchantReference: string;
    public terminalStatus: TerminalPaymentProviderPaymentStatus;
    public status: PaymentProviderPaymentStatus;
    public message: string;
    public invoiceId?: number;
    public terminalId: string;
    public cardType: string;
    public transactionId: string;
    public incomeId: number;

    public constructor(init?: Partial<TerminalPaymentDto>) { (Object as any).assign(this, init); }
}
(TerminalPaymentDto as unknown)[immerable] = true;

export class QuickPayment
{
    public type: QuickPayType;
    public mode: QuickPayMode;
    public amount: number;
    public locationId: number;
    public receivedAtLocationId?: number;
    public invoicePeriod: string;
    public accountId: number;
    public chequeNo: string;
    public token: string;
    public customerId: number;
    public isNewCard: boolean;
    public terminalPayment: TerminalPaymentDto;
    public meta: { [index:string]: Object; };

    public constructor(init?: Partial<QuickPayment>) { (Object as any).assign(this, init); }
}
(QuickPayment as unknown)[immerable] = true;

export class ValidateDiscountCodeResponse
{
    public id: string;
    public code: string;
    public amount: number;
    public billingItemId?: number;
    public billingItemGuid?: string;

    public constructor(init?: Partial<ValidateDiscountCodeResponse>) { (Object as any).assign(this, init); }
}
(ValidateDiscountCodeResponse as unknown)[immerable] = true;

export interface IHasNewPath
{
    newName: string;
    safeRoot: string;
}

export interface ICookies
{
    collection: Cookie[];
}

export interface IHttpResponse
{
    cookies: ICookies;
}

export interface IHttpRequest
{
    httpResponse: IHttpResponse;
    httpMethod: string;
    xForwardedFor: string;
    xForwardedPort?: number;
    xForwardedProtocol: string;
    xRealIp: string;
    accept: string;
}

// @DataContract
export class ResponseError
{
    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public fieldName: string;

    // @DataMember(Order=3)
    public message: string;

    // @DataMember(Order=4)
    public meta?: { [index:string]: string; };

    public constructor(init?: Partial<ResponseError>) { (Object as any).assign(this, init); }
}
(ResponseError as unknown)[immerable] = true;

// @DataContract
export class ResponseStatus
{
    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public message?: string;

    // @DataMember(Order=3)
    public stackTrace?: string;

    // @DataMember(Order=4)
    public errors?: ResponseError[];

    // @DataMember(Order=5)
    public meta?: { [index:string]: string; };

    public constructor(init?: Partial<ResponseStatus>) { (Object as any).assign(this, init); }
}
(ResponseStatus as unknown)[immerable] = true;

export class DownloadBatchRequestObject
{
    public path: string;
    public fileName: string;

    public constructor(init?: Partial<DownloadBatchRequestObject>) { (Object as any).assign(this, init); }
}
(DownloadBatchRequestObject as unknown)[immerable] = true;

export interface IHasPaths
{
    securityPaths: string[];
}

export enum DocumentType
{
    Letter = 'Letter',
    SMS = 'SMS',
    Email = 'Email',
}

export class GroupsCSVHeaderOverrides
{
    public status: string;
    public reference: string;
    public name: string;
    public contact: string;
    public address: string;
    public telephone: string;
    public email: string;
    public web: string;
    public balanceInvoiced: string;
    public locations: string;

    public constructor(init?: Partial<GroupsCSVHeaderOverrides>) { (Object as any).assign(this, init); }
}
(GroupsCSVHeaderOverrides as unknown)[immerable] = true;

export class StockLocationItem
{
    public locId: number;
    public stockId: number;

    public constructor(init?: Partial<StockLocationItem>) { (Object as any).assign(this, init); }
}
(StockLocationItem as unknown)[immerable] = true;

export class GroupProfileDto implements IHasId
{
    public id: number;
    public profileField1: boolean;
    public profileField2: boolean;
    public profileField3: boolean;
    public profileField4: boolean;
    public profileField5: boolean;
    public profileField6: boolean;
    public profileField7: boolean;
    public profileField8: boolean;

    public constructor(init?: Partial<GroupProfileDto>) { (Object as any).assign(this, init); }
}
(GroupProfileDto as unknown)[immerable] = true;

export class NotificationSubscription implements IHasId
{
    public id: number;
    public type: string;
    public typeId: number;
    public handlerId: string;

    public constructor(init?: Partial<NotificationSubscription>) { (Object as any).assign(this, init); }
}
(NotificationSubscription as unknown)[immerable] = true;

export class GroupStockResponse
{
    public id?: number;
    public stockId: number;
    public reference: string;
    public totalPrice: number;
    public priceExVAT: number;
    public ledgerCode: string;
    public description: string;
    public appointmentLength: number;
    public groupLocationLocationId: number;
    public serviceTypeId: number;
    public stockIsCancel: boolean;
    public stockIsFirst: boolean;
    public stockIsFollowUp: boolean;
    public stockIsDNA: boolean;
    public category: string;
    public onlineGuid: string;
    public billingEntityId?: number;
    public hasBillingEntityOverride: boolean;
    public isMultiLocation: boolean;
    public isFromPricingProfile: boolean;
    public pricingProfileId?: number;
    public pricingProfileName: string;
    public parentStockId?: number;
    public isOverridden: boolean;

    public constructor(init?: Partial<GroupStockResponse>) { (Object as any).assign(this, init); }
}
(GroupStockResponse as unknown)[immerable] = true;

export class LocResponse
{
    public id: number;
    public groupLocationId: number;
    public groupId: number;
    public locationId: number;
    public firstAppointmentStockId?: number;
    public nextAppointmentStockId?: number;
    public providerNo: string;
    public name: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public addressLine5: string;
    public address: string;
    public postCode: string;
    public fax: string;
    public web: string;
    public telephone: string;
    public email: string;
    public stock: GroupStockResponse[];
    public specificStock: GroupStockResponse[];

    public constructor(init?: Partial<LocResponse>) { (Object as any).assign(this, init); }
}
(LocResponse as unknown)[immerable] = true;

export class AddBusinessModel
{
    public id: number;
    public name: string;
    public isActive: boolean;

    public constructor(init?: Partial<AddBusinessModel>) { (Object as any).assign(this, init); }
}
(AddBusinessModel as unknown)[immerable] = true;

export class PractitionerLocationPair
{
    public locationId: number;
    public practitionerId: number;

    public constructor(init?: Partial<PractitionerLocationPair>) { (Object as any).assign(this, init); }
}
(PractitionerLocationPair as unknown)[immerable] = true;

export enum PractitionerStatus
{
    Inactive = 'Inactive',
    Active = 'Active',
    PayAsYouGo = 'PayAsYouGo',
}

export class PractitionerStatusUpdate
{
    public id: number;
    public status: PractitionerStatus;

    public constructor(init?: Partial<PractitionerStatusUpdate>) { (Object as any).assign(this, init); }
}
(PractitionerStatusUpdate as unknown)[immerable] = true;

export class PractitionerSkillBaseRequest
{
    public practitionerGuid: string;
    public specialismId: string;

    public constructor(init?: Partial<PractitionerSkillBaseRequest>) { (Object as any).assign(this, init); }
}
(PractitionerSkillBaseRequest as unknown)[immerable] = true;

export class BulkUpdateField
{
    public name: string;
    public propertyName: string;
    public type: string;
    public searchType?: LookUpSearchType;
    public isCustom: boolean;
    public includeNone: boolean;
    public module: string;

    public constructor(init?: Partial<BulkUpdateField>) { (Object as any).assign(this, init); }
}
(BulkUpdateField as unknown)[immerable] = true;

export enum BulkActionRecordType
{
    Patient = 'Patient',
    Diary = 'Diary',
    Stock = 'Stock',
    Practitioner = 'Practitioner',
    Record = 'Record',
    Workflow = 'Workflow',
}

export class BulkActionBaseRequest<T> implements ILocationIds, IBulkAction
{
    public recordType: BulkActionRecordType;
    public selectedIds: number[];
    public selectAll: boolean;
    public searchRequest: T;
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<BulkActionBaseRequest<T>>) { (Object as any).assign(this, init); }
}

export class GeneralPractitionerResponse
{
    public id: number;
    public fullName: string;
    public name: string;
    public defaultRoomId?: number;
    public code: string;
    public fullAddress: string;
    public locationName: string;
    public title: string;
    public forename: string;
    public surname: string;
    public gender: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public addressLine5: string;
    public postCode: string;
    public telephone: string;
    public mobile: string;
    public homeTelephone: string;
    public email: string;
    public fax: string;
    public web: string;
    public online?: boolean;
    public status?: number;
    public type: string;
    public contractNumber: string;
    public onlineGuid?: string;
    public physitrackToken: string;
    public defaultLocationId?: number;
    public serviceTypeId: number;
    public regNumber: string;
    public commissionFlatRate?: number;
    public commissionPercent?: number;
    public employmentStatus: string;
    public timeSlot?: number;
    public providerNo: string;
    public taxNo: string;
    public hasAlerts: boolean;
    public locationIds: number[];
    public skills: string[];
    public zoomUserId: string;
    public orderId: number;

    public constructor(init?: Partial<GeneralPractitionerResponse>) { (Object as any).assign(this, init); }
}

// @Route("/practitioners/all")
export class AllPractitionersRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<GeneralPractitionerResponse>>
{
    public fullname: string;
    public code: string;
    public status?: number;
    public address: string;

    public constructor(init?: Partial<AllPractitionersRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'AllPractitionersRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GeneralPractitionerResponse>(); }
}
(AllPractitionersRequest as unknown)[immerable] = true;

export class PractitionerBulkActionBaseRequest extends BulkActionBaseRequest<AllPractitionersRequest>
{

    public constructor(init?: Partial<PractitionerBulkActionBaseRequest>) { super(init); (Object as any).assign(this, init); }
}
(PractitionerBulkActionBaseRequest as unknown)[immerable] = true;

export interface IBulkAction
{
    selectedIds: number[];
    selectAll: boolean;
}

// @Flags()
export enum AppointmentSubStatus
{
    None = 0,
    InProgress = 1,
    Finished = 2,
}

export class RestrictedCustomerAlertDetails
{
    public title: string;
    public notes: string;
    public objectId: number;
    public userId?: number;
    public future: boolean;
    public startDateTime: string;
    public flagType?: number;
    public id: number;
    public discriminatorType: string;
    public complete?: boolean;
    public requiresAcknowledgement?: boolean;

    public constructor(init?: Partial<RestrictedCustomerAlertDetails>) { (Object as any).assign(this, init); }
}
(RestrictedCustomerAlertDetails as unknown)[immerable] = true;

export class RestrictedCustomerDetails
{
    public id: number;
    public title: string;
    public forename: string;
    public surname: string;
    public gender: string;
    public status?: number;
    public locationId: number;
    public smsEnabled: boolean;
    public reference: string;
    public email: string;
    public mobileTelephone: string;
    public dateOfBirth?: string;
    public alerts: RestrictedCustomerAlertDetails[];

    public constructor(init?: Partial<RestrictedCustomerDetails>) { (Object as any).assign(this, init); }
}
(RestrictedCustomerDetails as unknown)[immerable] = true;

// @Flags()
export enum CreditTransactionType
{
    Purchase = 0,
    Refund = 1,
    CancellationCharge = 2,
}

export class AppointmentResponse
{
    public id: number;
    public startDateTime: string;
    public endDateTime: string;
    public name: string;
    public status: number;
    public subStatus: AppointmentSubStatus;
    public type: string;
    public reference: string;
    public bookingMethod: string;
    public bookedByName: string;
    public bookingDateTime?: string;
    public duration?: number;
    public firstAppointment: boolean;
    public comment: string;
    public title: string;
    public customerId?: number;
    public recallDate?: string;
    public practitionerId: number;
    public locationId: number;
    public roomId?: number;
    public stockId?: number;
    public practitioner: string;
    public practitionerStatus: number;
    public location: string;
    public roomName: string;
    public stock: string;
    public inDebt: boolean;
    public isNew: boolean;
    public isFirstAppointment: boolean;
    public colour?: number;
    public stockColour?: number;
    public description: string;
    public hexColour: string;
    public classMax: number;
    public classAttendees: number;
    public customerAlert: boolean;
    public customerLastAppointment?: string;
    public reminderSentType: string;
    public reminderType?: string;
    public payAtEachAppt: boolean;
    public authId?: number;
    public groupId?: number;
    public groupName: string;
    public groupAddressTo: string;
    public authCode: string;
    public caseId: number;
    public auditId?: string;
    public prontoAuditId?: string;
    public prontoAppointmentId?: string;
    public prontoServiceId?: string;
    public patient: RestrictedCustomerDetails;
    public meta: { [index:string]: Object; };
    public serviceTypeId?: number;
    public serviceType: string;
    public isVideo?: boolean;
    public videoCode: string;
    public discountCodeId?: string;
    public discountCodeAppliedDate?: string;
    public discountCodeAdvance: boolean;
    public cancellationReason: string;
    public videoLink: string;
    public videoMeetingParticipantJoinUrl: string;
    public videoMeetingPassword: string;
    public creditUsage: number;
    public transactionType: CreditTransactionType;
    public procedureId?: number;

    public constructor(init?: Partial<AppointmentResponse>) { (Object as any).assign(this, init); }
}
(AppointmentResponse as unknown)[immerable] = true;

export enum NetworkServiceType
{
    Appointment = 'Appointment',
    Cancellation = 'Cancellation',
    DNA = 'DNA',
}

export class ServiceCharge
{
    public exVat: number;
    public vatRate: number;
    public canBillCXX: boolean;
    public canBillDNA: boolean;
    public cancellationChargeServiceId?: string;
    public dnaChargeServiceId?: string;
    public id?: string;
    public name: string;
    public stockOnlineGuid?: string;
    public overrides: { [index:string]: string; };
    public serviceType: NetworkServiceType;
    public serviceNextAppointmentType: string;

    public constructor(init?: Partial<ServiceCharge>) { (Object as any).assign(this, init); }
}
(ServiceCharge as unknown)[immerable] = true;

export class ReferralAppointment
{
    public id: string;
    public date: string;
    public status: number;
    public invoiced: boolean;
    public serviceId: string;
    public locationId: string;
    public practitionerId: string;
    public appointmentId: string;
    public tm3AppointmentId: number;
    public authCode: string;
    public imported: boolean;
    public isLocked: boolean;
    public success: boolean;
    public errors: string[];
    public warnings: string[];

    public constructor(init?: Partial<ReferralAppointment>) { (Object as any).assign(this, init); }
}
(ReferralAppointment as unknown)[immerable] = true;

export class ReferralAppointmentResponse extends ReferralAppointment
{
    public exVat: number;
    public vatRate: number;
    public description: string;

    public constructor(init?: Partial<ReferralAppointmentResponse>) { super(init); (Object as any).assign(this, init); }
}
(ReferralAppointmentResponse as unknown)[immerable] = true;

export class ReferralAuthorisation
{
    public id: string;
    public amount: number;
    public reportId?: string;
    public timeStamp: string;
    public isNewAdditionalAuth: boolean;
    public isRevoked: boolean;
    public initialAmount: number;
    public revokedAmount: number;
    public revokedTimeStamp: string;

    public constructor(init?: Partial<ReferralAuthorisation>) { (Object as any).assign(this, init); }
}
(ReferralAuthorisation as unknown)[immerable] = true;

export class PractitionerDto
{
    public id: string;
    public title: string;
    public forename: string;
    public surname: string;
    public gender: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public addressLine5: string;
    public postCode: string;
    public telephone: string;
    public mobile: string;
    public email: string;
    public fax: string;
    public web: string;
    public online?: boolean;
    public status?: boolean;
    public type: string;
    public contractNumber: string;
    public onlineGuid: string;
    public defaultLocation: string;
    public disciplines: string[];
    public name: string;
    public shortName: string;

    public constructor(init?: Partial<PractitionerDto>) { (Object as any).assign(this, init); }
}
(PractitionerDto as unknown)[immerable] = true;

export class BookingAuditResponse
{
    public id: string;
    public userId: number;
    public appointmentId: string;
    public appointmentStartDateTime?: string;
    public appointmentBookingDateTime: string;
    public appointmentCustomerId: string;
    public customerReference: string;
    public bookingType: string;
    public serviceId: string;
    public clinicReference: string;
    public referrerReference: string;
    public targetId: string;
    public bookerId: string;
    public systemType: string;
    public referralStatus: number;
    public triageReport?: string;
    public initialReport?: string;
    public rfatReport?: string;
    public dischargeReport?: string;
    public triageReportName: string;
    public initialReportName: string;
    public rfatReportName: string;
    public dischargeReportName: string;
    public needsAction: boolean;
    public serviceCharges: { [index:string]: ServiceCharge; };
    public appointments: ReferralAppointmentResponse[];
    public authorisations: ReferralAuthorisation[];
    public practitioners: PractitionerDto[];
    public workflowId?: number;
    public reminderSentType?: number;
    public initialReportSubmissionDueDate?: string;
    public firstReminderSentDate?: string;
    public finalReminderSentDate?: string;
    public expiredReminderSentDate?: string;

    public constructor(init?: Partial<BookingAuditResponse>) { (Object as any).assign(this, init); }
}
(BookingAuditResponse as unknown)[immerable] = true;

export class Dictionary<T> { [Key: string]: T; }

export class JsonField extends Dictionary<Object>
{

    public constructor(init?: Partial<JsonField>) { super(); (Object as any).assign(this, init); }
}
(JsonField as unknown)[immerable] = true;

export enum ReportTemplateType
{
    D = 68,
    M = 77,
}

export class ReferralReport
{
    public id: string;
    public rootId?: string;
    public templateId: string;
    public bookerId: string;
    public targetId: string;
    public data: JsonField;
    public timeStamp: string;
    public auditId: string;
    public status: number;
    public message: string;
    public title: string;
    public reportTemplateType?: ReportTemplateType;

    public constructor(init?: Partial<ReferralReport>) { (Object as any).assign(this, init); }
}
(ReferralReport as unknown)[immerable] = true;

export enum VideoMeetingProvider
{
    Twilio = 0,
    Zoom = 1,
    Other = 99,
}

export class Appointment implements ILocationId, IHasReference
{
    public id: number;
    public globalId: string;
    public startDateTime: string;
    public endDateTime: string;
    public name: string;
    public customerId?: number;
    public practitionerId: number;
    public locationId: number;
    public status: number;
    public subStatus: AppointmentSubStatus;
    public type: string;
    public reference: string;
    public roomId?: number;
    public stockId?: number;
    public caseId?: number;
    public groupId?: number;
    public masterWorkflowId?: number;
    public subWorkflowId?: number;
    public bookedBy?: number;
    public authId?: number;
    public serviceTypeId?: number;
    public firstAppointment?: boolean;
    public bookingDateTime?: string;
    public arrivalDateTime?: string;
    public inProgressTime?: string;
    public finishedTime?: string;
    public comment: string;
    public colour?: number;
    public billingItemID?: number;
    public location: string;
    public equipment: string;
    public reminderType?: string;
    public reminderDate?: string;
    // @Ignore()
    public title: string;

    public auditId?: string;
    public prontoAppointmentId?: string;
    public prontoServiceId?: string;
    public discountCodeId?: string;
    public discountCodeAppliedDate?: string;
    public discountCodeAdvance: boolean;
    public prePaidId?: number;
    public prePaymentIncomeId?: number;
    public connectServiceId?: string;
    public owesCredit: boolean;
    public isVideo?: boolean;
    public videoCode: string;
    public videoMeetingHostJoinUrl: string;
    public videoMeetingProvider?: VideoMeetingProvider;
    public videoMeetingPassword: string;
    public videoMeetingParticipantJoinUrl: string;
    public videoMeetingId: string;
    public batchNo?: number;
    // @Ignore()
    public videoLink: string;

    public cancelUsesAuth: boolean;
    public dnaUsesAuth: boolean;
    public prepaymentStatus?: string;
    public cancelMethod: string;
    public recallStatus: string;
    public prepaymentType: string;
    public recallDate?: string;

    public constructor(init?: Partial<Appointment>) { (Object as any).assign(this, init); }
}
(Appointment as unknown)[immerable] = true;

export class ProntoBillingItem
{
    public apptGuid?: string;
    public id: number;
    public date: string;
    public service: { [index:string]: string; };
    public location: { [index:string]: string; };
    public practitioner: { [index:string]: string; };
    public vatRate: number;
    public amount: number;
    public amountExVat: number;
    public metadata: string;
    public appointment: Appointment;
    public isPreviouslyBilledFromTM3: boolean;
    public isBillingPartOfFailedInvoice: boolean;

    public constructor(init?: Partial<ProntoBillingItem>) { (Object as any).assign(this, init); }
}
(ProntoBillingItem as unknown)[immerable] = true;

export class ProntoInvoice
{
    public id: string;
    public auditId: string;
    public bookerId: string;
    public targetId: string;
    public templateId: string;
    public timeStamp: string;
    public status: number;
    public message: string;
    public authCode: string;
    public admissionDate: string;
    public ref: string;
    public date: string;
    public locationId: string;
    public primaryPracitionerId: string;
    public patientMemberId: string;
    public patientPostcode: string;
    public patientForename: string;
    public patientSurname: string;
    public patientDateOfBirth?: string;
    public totalAmount: number;
    public items: ProntoBillingItem[];
    public metadata: string;
    public mappings: string;

    public constructor(init?: Partial<ProntoInvoice>) { (Object as any).assign(this, init); }
}
(ProntoInvoice as unknown)[immerable] = true;

export class LocationInfo
{
    public id: string;
    public exclude: boolean;
    public cancellationPolicy: string;
    public generalInfo: string;

    public constructor(init?: Partial<LocationInfo>) { (Object as any).assign(this, init); }
}
(LocationInfo as unknown)[immerable] = true;

export class OnlineSettings implements IHasId
{
    public id: number;
    public siteTitle: string;
    public showSiteTitle: boolean;
    public title: string;
    public logoUrl: string;
    public appIconUrl: string;
    public skin: string;
    public customColourPrimary: string;
    public customColourSecondary: string;
    public customColourNav: string;
    public customColourNavText: string;
    public message: string;
    public confirmSubject: string;
    public clinicFromEmail: string;
    public clinicNumber: string;
    public minBookingDays: number;
    public maxBookingDays: number;
    public isSiteLive: boolean;
    public registerProvisional: boolean;
    public maxBookings?: number;
    public allowClassBooking: boolean;
    public allowRegister: boolean;
    public allowPayAtClinic: boolean;
    public locationInfo: LocationInfo[];
    public googleTrackingId: string;
    public googleTagManagerContainerId: string;
    public useAllDeliveryMethodsForAccessCode: boolean;
    public accessCodeDeliveryMethod: string;
    // @Ignore()
    public businessId?: number;

    // @Ignore()
    public isCustom: boolean;

    public classes: boolean;
    public payments: boolean;
    public clinical: boolean;
    public generalInfo: string;
    public cancellationPolicy: string;
    public privacyPolicy: string;
    public termsAndConditions: string;
    public shareCancellationPolicy: boolean;
    public shareGeneralInfo: boolean;
    public url: string;
    public notifyOfAppointments: boolean;
    public unauthenticatedMessage: string;
    public useSSO: boolean;
    public usingSimplifiedRegistration: boolean;
    public allowPatientEditDetails: boolean;
    // @Ignore()
    public addressRequired: boolean;

    // @Ignore()
    public connectThemeSurface: string;

    // @Ignore()
    public connectThemeSurfaceMuted: string;

    // @Ignore()
    public connectThemeSurfaceSubtle: string;

    // @Ignore()
    public connectThemeSurfaceElevated: string;

    // @Ignore()
    public connectThemeTextDefault: string;

    // @Ignore()
    public connectThemeTextMuted: string;

    // @Ignore()
    public connectThemeTextSubtle: string;

    // @Ignore()
    public connectThemeBorderDefault: string;

    // @Ignore()
    public connectThemeBorderMuted: string;

    // @Ignore()
    public connectThemeFocusRing: string;

    // @Ignore()
    public connectThemeStatusSuccess: string;

    // @Ignore()
    public connectThemeStatusSuccessSurface: string;

    // @Ignore()
    public connectThemeStatusWarning: string;

    // @Ignore()
    public connectThemeStatusWarningSurface: string;

    // @Ignore()
    public connectThemeStatusCritical: string;

    // @Ignore()
    public connectThemeStatusCriticalSurface: string;

    // @Ignore()
    public connectFontBodyFamily: string;

    // @Ignore()
    public connectFontHeadingFamily: string;

    public connectBookingFlowMode: string;
    public sendConnectPaymentReceipt: boolean;
    public connectPaymentReceiptTemplate: string;
    public magicLinkEmailTemplate: string;
    public magicLinkSentMessage: string;
    public insuranceDetailsMessage: string;

    public constructor(init?: Partial<OnlineSettings>) { (Object as any).assign(this, init); }
}
(OnlineSettings as unknown)[immerable] = true;

export class ClinicSettings
{
    public url: string;
    public shareCancellationPolicy: boolean;
    public shareGeneralInfo: boolean;
    public referrerName: string;
    public receptionName: string;
    public clinicEmail: string;
    public allowClinicProntoEmails: boolean;
    public clinicNumber: string;
    public onlineSettings: OnlineSettings;
    public onlineBookingMinimumDays: number;
    public onlineBookingMaximumDays: number;
    public classOrder: number[];
    public serviceOrder: string[];
    public cancellationPolicy: string;
    public generalInfo: string;
    public noAppointmentsFoundText: string;
    public locationInfo: LocationInfo[];
    public excludeLocations: { [index:string]: string[]; };
    public excludePractitioners: { [index:string]: string[]; };
    public excludeSessionIds: { [index:string]: number[]; };
    public excludeNormalSessionIds: { [index:string]: number[]; };
    public defaultServices: { [index:string]: string; };
    public clientId: string;
    public ppsId: string;
    public ppsUserName: string;
    public ppsKey: string;
    public ppsUrl: string;
    public remoteProxyUrl: string;
    public remoteSecret: string;
    public clinicCurrency: string;

    public constructor(init?: Partial<ClinicSettings>) { (Object as any).assign(this, init); }
}
(ClinicSettings as unknown)[immerable] = true;

export class GroupLinker
{
    public globalId: string;
    public onlineGuid: string;

    public constructor(init?: Partial<GroupLinker>) { (Object as any).assign(this, init); }
}
(GroupLinker as unknown)[immerable] = true;

export class StockOverrideDto
{
    public stockId: number;
    public locationId: string;
    public locId: number;
    public price: number;
    public priceExVat: number;
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<StockOverrideDto>) { (Object as any).assign(this, init); }
}
(StockOverrideDto as unknown)[immerable] = true;

export class ProntoStockDto
{
    public id: string;
    public reference: string;
    public description: string;
    public locationGuid: string;
    public priceExVat?: number;
    public vatRate?: number;
    public vatAmount?: number;
    public totalPrice: number;
    public price: number;
    public colourCss: string;
    public colour?: number;
    public onlineGuid: string;
    public appointmentLength: number;
    public consultancyTime: number;
    public overrides: StockOverrideDto[];
    public ledgerCode: string;
    // @Ignore()
    public objId: string;

    public category?: string;

    public constructor(init?: Partial<ProntoStockDto>) { (Object as any).assign(this, init); }
}
(ProntoStockDto as unknown)[immerable] = true;

export class AvailabilitySummary
{
    public next?: string;
    public nextLocations: string[];
    public otherLocations: string[];
    public price: number;

    public constructor(init?: Partial<AvailabilitySummary>) { (Object as any).assign(this, init); }
}
(AvailabilitySummary as unknown)[immerable] = true;

export class ClinicService
{
    public networkServiceId: string;
    public networkId: string;
    public name: string;
    public description: string;
    public discipline: string;
    public colour: string;
    public isOnline: boolean;
    public sortIndex: number;
    public availability: AvailabilitySummary;
    public meta: { [index:string]: string; };
    public excludeGroups: string[];
    public excludeLocations: string[];
    public excludePractitioners: string[];
    public overrides: { [index:string]: string; };
    public stockId: string;
    public excludeSessionIds: number[];
    public excludeNormalSessionIds: number[];

    public constructor(init?: Partial<ClinicService>) { (Object as any).assign(this, init); }
}
(ClinicService as unknown)[immerable] = true;

// @Flags()
export enum EPathologyProvider
{
    Nationwide = 0,
    TheDoctorsLaboratory = 1,
}

export class StockResponse
{
    public id: number;
    public reference: string;
    public totalPrice?: number;
    public description: string;
    public appointmentLength?: number;
    public groupLocationLocationId: number;
    public locationId?: number;
    public colour?: number;
    public online: boolean;
    public onlineGuid?: string;
    public inUse?: boolean;
    public priceExVAT?: number;
    public vatRate?: number;
    public vatAmount?: number;
    public costAmount?: number;
    public costVATRate?: number;
    public costExVAT?: number;
    public costVATAmount?: number;
    public longDescription: string;
    public category?: string;
    public batchTraceable?: boolean;
    public categoryText: string;
    public ledgerCode: string;
    public level?: number;
    public minimumLevel?: number;
    public displayInPriceList?: boolean;
    public totalWorth: number;
    public supplierId?: number;
    public serviceTypeId?: number;
    public isPrivateCharge?: boolean;
    public stockIsCancel: boolean;
    public stockIsFirst: boolean;
    public stockIsFollowUp: boolean;
    public stockIsDNA: boolean;
    public isMultiple?: boolean;
    public groupName: string;
    public isVideo?: boolean;
    public managementFee?: boolean;
    public cancellationCharge?: number;
    public didNotAttendCharge?: number;
    public cancellationStockId?: number;
    public didNotAttendStockId?: number;
    public billingEntityId?: number;
    public notes: string;
    public colourCss: string;
    public ccsd: string;
    public iscCodeID?: number;
    public classification: string;
    public pathologyProvider?: EPathologyProvider;
    public tags: string[];
    public specialismId: string;
    public credits?: number;
    public eligibleForTaxExemption: boolean;
    public unitOfIssue: number;
    public paymentOption: number;
    public paymentOptionValue: number;
    public depositPaymentApply: number;
    public stockLevel: number;
    public barcode: string;
    public locationBased: boolean;

    public constructor(init?: Partial<StockResponse>) { (Object as any).assign(this, init); }
}
(StockResponse as unknown)[immerable] = true;

export class LocationFacilities
{
    public allFacilities: string[];
    public selectedFacilities: string[];

    public constructor(init?: Partial<LocationFacilities>) { (Object as any).assign(this, init); }
}
(LocationFacilities as unknown)[immerable] = true;

export enum OpeningHoursDay
{
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
    Sunday = 7,
}

export class LocationOpeningHours implements IHasIdMarker
{
    public id: number;
    public locationId: number;
    public day: OpeningHoursDay;
    public start: string;
    public end: string;
    public isClosed: boolean;

    public constructor(init?: Partial<LocationOpeningHours>) { (Object as any).assign(this, init); }
}
(LocationOpeningHours as unknown)[immerable] = true;

export class LocationOpeningHoursResponse extends LocationOpeningHours
{

    public constructor(init?: Partial<LocationOpeningHoursResponse>) { super(init); (Object as any).assign(this, init); }
}
(LocationOpeningHoursResponse as unknown)[immerable] = true;

export class LocationResponse
{
    public id: number;
    public name: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public addressLine5: string;
    public postCode: string;
    public fullAddressMultiLine: string;
    public telephone: string;
    public fax: string;
    public email: string;
    public web: string;
    public dnaStockId?: number;
    public cancelStockId?: number;
    public status: string;
    public directions: string;
    public reminderTemplateEmail_TM3: string;
    public reminderTemplateSMS_TM3: string;
    public onlineGuid: string;
    public facilities: LocationFacilities;
    public isMainLocation: boolean;
    public merchantReference: string;
    public locationLong: number;
    public locationLat: number;
    public trackingCategory: string;
    public openingHours: LocationOpeningHoursResponse[];

    public constructor(init?: Partial<LocationResponse>) { (Object as any).assign(this, init); }
}
(LocationResponse as unknown)[immerable] = true;

export class StockOverrideResponse
{
    public id: number;
    public locationId: number;
    public locationGuid: string;
    public stockId: number;
    public stockGuid: string;
    public priceExVAT: number;
    public totalPrice: number;
    public stockLevel?: number;
    public stockMinimum?: number;
    public paymentOptionValue: number;

    public constructor(init?: Partial<StockOverrideResponse>) { (Object as any).assign(this, init); }
}
(StockOverrideResponse as unknown)[immerable] = true;

export class GroupStockOverrideResponse
{
    public id: string;
    public groupId: number;
    public stockId: number;
    public locationId?: number;
    public priceExVAT?: number;
    public totalPrice?: number;
    public vatRate?: number;
    public ledgerCode: string;
    public reference: string;
    public billingEntityId?: number;
    public hasBillingEntityOverride: boolean;
    public isFromPricingProfile: boolean;
    public priceProfileId?: number;
    public priceProfileName: string;
    public linkedStockIds: number[];

    public constructor(init?: Partial<GroupStockOverrideResponse>) { (Object as any).assign(this, init); }
}
(GroupStockOverrideResponse as unknown)[immerable] = true;

export class PackageBundleItemWithQuantity
{
    public quantity: number;
    public typeId: number;
    public packageId: string;

    public constructor(init?: Partial<PackageBundleItemWithQuantity>) { (Object as any).assign(this, init); }
}
(PackageBundleItemWithQuantity as unknown)[immerable] = true;

export enum AccountingSystemProviderName
{
    None = 'None',
    Xero = 'Xero',
    Quickbooks = 'Quickbooks',
    Sage = 'Sage',
}

export class AccountingStockLedgerLookup implements IHasId
{
    public id: number;
    public stockId: number;
    public systemId: string;
    public systemName: AccountingSystemProviderName;
    public accountingSystemLedgerId: string;
    public accountingSystemLedgerCode: string;

    public constructor(init?: Partial<AccountingStockLedgerLookup>) { (Object as any).assign(this, init); }
}
(AccountingStockLedgerLookup as unknown)[immerable] = true;

export class StockWithLocationResponse extends StockResponse
{
    public locationName: string;
    public billingEntityName: string;
    public groups: number[];
    public locations: LocationResponse[];
    public overrides: StockOverrideResponse[];
    public groupOverrides: GroupStockOverrideResponse[];
    public packageItems: PackageBundleItemWithQuantity[];
    public ledgerCodeOverrides: AccountingStockLedgerLookup[];
    public legderCodeAccountId: string;
    public accountingSystemLedgerCode: string;
    public earliestExpirationDate?: string;

    public constructor(init?: Partial<StockWithLocationResponse>) { super(init); (Object as any).assign(this, init); }
}
(StockWithLocationResponse as unknown)[immerable] = true;

// @Route("/all/stock")
export class AllStockRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<StockWithLocationResponse>>
{
    public description: string;
    public reference: string;
    public category: string;
    public type: string;
    public private?: boolean;
    public status?: boolean;
    public amount: CurrencyRange;
    public includeTags: string[];
    public excludeTags: string[];

    public constructor(init?: Partial<AllStockRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'AllStockRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<StockWithLocationResponse>(); }
}
(AllStockRequest as unknown)[immerable] = true;

export class StockBulkActionBaseRequest extends BulkActionBaseRequest<AllStockRequest>
{

    public constructor(init?: Partial<StockBulkActionBaseRequest>) { super(init); (Object as any).assign(this, init); }
}
(StockBulkActionBaseRequest as unknown)[immerable] = true;

export class SingleCacheRequest
{
    public version: string;

    public constructor(init?: Partial<SingleCacheRequest>) { (Object as any).assign(this, init); }
}

export class LabelItem
{
    public id: string;
    public text: string;

    public constructor(init?: Partial<LabelItem>) { (Object as any).assign(this, init); }
}
(LabelItem as unknown)[immerable] = true;

export interface ISecurityGuid
{
    securityGuid: string;
}

export class DynamicLabelRequest
{

    public constructor(init?: Partial<DynamicLabelRequest>) { (Object as any).assign(this, init); }
}
(DynamicLabelRequest as unknown)[immerable] = true;

export class TaskChecklistTemplateStepDto
{
    public id: number;
    public templateId: number;
    public text: string;
    public sortOrder: number;
    public stepType: string;
    public stepPayloadJson: string;
    public isDone?: boolean;

    public constructor(init?: Partial<TaskChecklistTemplateStepDto>) { (Object as any).assign(this, init); }
}
(TaskChecklistTemplateStepDto as unknown)[immerable] = true;

export enum RecurFrequency
{
    Daily = 'Daily',
    WorkingDays = 'WorkingDays',
    Weekly = 'Weekly',
    Fortnightly = 'Fortnightly',
    Monthly = 'Monthly',
    Yearly = 'Yearly',
}

export class TaskForUser implements IHasId
{
    public id: number;
    public globalId?: string;
    public createdDate?: string;
    public dueDate: string;
    public description: string;
    public status: string;
    public userId?: number;
    public teamId?: string;
    public reminder: boolean;
    public priority: boolean;
    public createdUserId: number;
    public dateCompleted?: string;
    public completedByUserId?: number;
    public patientId?: number;
    public private?: boolean;
    // @Ignore()
    public recur: boolean;

    // @Ignore()
    public recurFreq: RecurFrequency;

    // @Ignore()
    public recurDate: string;

    public tags: string[];
    public longDescription: string;
    public targetType: string;
    public targetId?: number;
    public targetContext: string;
    public originKey: string;
    public taskKind: string;
    // @Ignore()
    public checklistTemplateId?: number;

    public constructor(init?: Partial<TaskForUser>) { (Object as any).assign(this, init); }
}
(TaskForUser as unknown)[immerable] = true;

export class TaskChecklistAssignmentDefaultDto
{
    public id: number;
    public locationId: number;
    public workType: string;
    public defaultUserId?: number;
    public defaultTeamId?: string;

    public constructor(init?: Partial<TaskChecklistAssignmentDefaultDto>) { (Object as any).assign(this, init); }
}
(TaskChecklistAssignmentDefaultDto as unknown)[immerable] = true;

export class GetSsoProviderInfoResponse
{
    public provider: string;
    public isSsoOnlyLogin: boolean;

    public constructor(init?: Partial<GetSsoProviderInfoResponse>) { (Object as any).assign(this, init); }
}
(GetSsoProviderInfoResponse as unknown)[immerable] = true;

export class ScoresGoalsSettingsRequest
{
    public id: number;
    public type: string;
    public name: string;
    public max?: number;
    public min?: number;
    public enabled: boolean;
    public inUse: boolean;

    public constructor(init?: Partial<ScoresGoalsSettingsRequest>) { (Object as any).assign(this, init); }
}
(ScoresGoalsSettingsRequest as unknown)[immerable] = true;

export enum ReportPatientType
{
    AllPatients = 1,
    GroupPatientsOnly = 2,
    SelfFunding = 3,
}

export enum ReportLocationType
{
    AllLocations = 'AllLocations',
    ActiveAndViewOnly = 'ActiveAndViewOnly',
    InactiveHidden = 'InactiveHidden',
}

export enum ReportPractitionerType
{
    Inactive = 'Inactive',
    ActiveAndPAYG = 'ActiveAndPAYG',
    AllPractitioners = 'AllPractitioners',
}

export class BaseParamsForAllReports implements ILocationIds, ILocationId
{
    public displayAll: boolean;
    public skip: number;
    public take: number;
    public requestLocationIds: number[];
    public locationIds: number[];
    public practitionerIds: number[];
    public groupIds: number[];
    public userId: number;
    public term: string;
    public name: string;
    public date: DateRange;
    public locationId: number;
    public patientType: ReportPatientType;
    public locationType: ReportLocationType;
    public practitionerType: ReportPractitionerType;

    public constructor(init?: Partial<BaseParamsForAllReports>) { (Object as any).assign(this, init); }
}
(BaseParamsForAllReports as unknown)[immerable] = true;

export enum InvoiceStatus
{
    All = 1,
    Invoiced = 2,
    Uninvoiced = 3,
}

export enum RemainingAuthorisationOption
{
    Both = 'Both',
    Yes = 'Yes',
    No = 'No',
}

export class DatePart
{
    public date: number;
    public month: number;

    public constructor(init?: Partial<DatePart>) { (Object as any).assign(this, init); }
}
(DatePart as unknown)[immerable] = true;

export class DatePartRange
{
    public from: DatePart;
    public to: DatePart;

    public constructor(init?: Partial<DatePartRange>) { (Object as any).assign(this, init); }
}
(DatePartRange as unknown)[immerable] = true;

export class RegistrationRequest
{
    public subdomain: string;
    public title: string;
    public forename: string;
    public surname: string;
    public email: string;
    public businessName: string;
    public address: string;
    public town: string;
    public postCode: string;
    public locationId: number;
    public password: string;
    public marketingConsent: boolean;
    public enquirySource: string;

    public constructor(init?: Partial<RegistrationRequest>) { (Object as any).assign(this, init); }
}
(RegistrationRequest as unknown)[immerable] = true;

export enum EnquiryType
{
    Healthcode = 'Healthcode',
    Reception = 'Reception',
}

export class QuickStartWizardGroupStock
{
    public stockId: number;
    public groupStockId: number;
    public hasChanged: boolean;

    public constructor(init?: Partial<QuickStartWizardGroupStock>) { (Object as any).assign(this, init); }
}
(QuickStartWizardGroupStock as unknown)[immerable] = true;

export enum TemplatePackOptions
{
    None = 'None',
    Physiotherapy = 'Physiotherapy',
    Osteopathy = 'Osteopathy',
    Chiropractic = 'Chiropractic',
    Podiatry = 'Podiatry',
}

export class ClinicServiceSetupDto
{
    public networkServiceId: string;
    public networkId: string;
    public name: string;
    public description: string;
    public discipline: string;
    public colour: string;
    public isOnline: boolean;
    // @Ignore()
    public sortIndex: number;

    public meta: { [index:string]: string; };
    public excludeGroups: string[];
    public excludeLocations: string[];
    public excludePractitioners: string[];
    public overrides: { [index:string]: string; };
    public stockId?: string;
    public stockName: string;
    public stockLength: number;
    public stockPrice: number;
    public existingCharge: number;
    public excludeSessionIds: number[];
    public excludeNormalSessionIds: number[];

    public constructor(init?: Partial<ClinicServiceSetupDto>) { (Object as any).assign(this, init); }
}
(ClinicServiceSetupDto as unknown)[immerable] = true;

export class PrescriptionItem implements IHasId
{
    public id: number;
    public prescriptionId: number;
    public vpid: string;
    public description: string;
    public quantity: string;
    public directions: string;
    public notes: string;

    public constructor(init?: Partial<PrescriptionItem>) { (Object as any).assign(this, init); }
}
(PrescriptionItem as unknown)[immerable] = true;

export class PathologyStockItem
{
    // @Required()
    public description: string;

    // @Required()
    public profileCode: string;

    // @Required()
    public price: number;

    // @Required()
    public turnaround: string;

    // @Required()
    public sampleType: string;

    public notes: string;
    public tests: string;

    public constructor(init?: Partial<PathologyStockItem>) { (Object as any).assign(this, init); }
}
(PathologyStockItem as unknown)[immerable] = true;

export enum PrescriptionActions
{
    draft = 'draft',
    issueForCollection = 'issueForCollection',
    issueToContact = 'issueToContact',
    issueForDelivery = 'issueForDelivery',
    issueOnly = 'issueOnly',
    printPrescription = 'printPrescription',
}

export class MedicationRequestItem
{
    // @Required()
    public vpid: string;

    // @Required()
    public description: string;

    // @Required()
    public quantity: string;

    // @Required()
    public directions: string;

    public constructor(init?: Partial<MedicationRequestItem>) { (Object as any).assign(this, init); }
}
(MedicationRequestItem as unknown)[immerable] = true;

export class PharmaciergeSettingsBase
{
    public integrationCode: string;
    public lastName: string;

    public constructor(init?: Partial<PharmaciergeSettingsBase>) { (Object as any).assign(this, init); }
}

export class PharmaciergeMedicationPack
{
    public packSize: number;
    public uom: string;
    public stock: string;

    public constructor(init?: Partial<PharmaciergeMedicationPack>) { (Object as any).assign(this, init); }
}
(PharmaciergeMedicationPack as unknown)[immerable] = true;

export class PharmaciergeSearchMedicationItem
{
    public medicationId: string;
    public strength: string;
    public form: string;
    public description: string;
    public extendedDescription: string;
    public name: string;
    public packs: PharmaciergeMedicationPack[];
    public fridge: boolean;
    public fP10PCDRequired: boolean;
    public cannotBeSplit: boolean;

    public constructor(init?: Partial<PharmaciergeSearchMedicationItem>) { (Object as any).assign(this, init); }
}
(PharmaciergeSearchMedicationItem as unknown)[immerable] = true;

export class PharmaciergePrescribedItem extends PharmaciergeSearchMedicationItem
{
    public quantity: string;
    public notes: string;
    public repeats: number;
    public medicationName: string;
    public dose: string;

    public constructor(init?: Partial<PharmaciergePrescribedItem>) { super(init); (Object as any).assign(this, init); }
}
(PharmaciergePrescribedItem as unknown)[immerable] = true;

export class CloudRxPrescribedItemDto
{
    public dmdCode: number;
    public productId: number;
    public pack: number;
    public packSize: number;
    public medication: string;
    public dosageInstructions: string;
    public quantity: number;
    public unitPrice: number;
    public units: string;
    public controlDrug: boolean;

    public constructor(init?: Partial<CloudRxPrescribedItemDto>) { (Object as any).assign(this, init); }
}
(CloudRxPrescribedItemDto as unknown)[immerable] = true;

export enum CourierMethod
{
    RMT24 = 'RMT24',
    RMNXT = 'RMNXT',
    DPDND = 'DPDND',
    DPDSA = 'DPDSA',
}

export class CloudRxFetchBase
{
    public id: string;

    public constructor(init?: Partial<CloudRxFetchBase>) { (Object as any).assign(this, init); }
}
(CloudRxFetchBase as unknown)[immerable] = true;

export class Update
{
    public type: string;
    public data: string;
    public local: string;

    public constructor(init?: Partial<Update>) { (Object as any).assign(this, init); }
}
(Update as unknown)[immerable] = true;

// @Flags()
export enum FormStatus
{
    Sent = 1,
    Draft = 2,
    Submitted = 3,
    Completed = 4,
    Cancelled = 5,
    Declined = 6,
}

// @Flags()
export enum EEquipmentStatus
{
    Active = 0,
    Inactive = 1,
    OutOfOrder = 3,
    Maintenance = 4,
}

export enum DocumentApprovalStatus
{
    Draft = 'Draft',
    PendingApproval = 'PendingApproval',
    Approved = 'Approved',
    Sent = 'Sent',
}

export enum CrmService
{
    Pipedrive = 'Pipedrive',
    Hubspot = 'Hubspot',
    Salesforce = 'Salesforce',
}

export enum CrmPatientSyncMode
{
    In = 1,
    Out = 2,
    Both = 3,
}

export enum CrmNoteSyncMode
{
    In = 1,
    Out = 2,
    Both = 3,
}

export class CrmCustomField
{
    public id: string;
    public apiId: string;
    public apiSubId: string;
    public name: string;
    public mappingField: string;

    public constructor(init?: Partial<CrmCustomField>) { (Object as any).assign(this, init); }
}
(CrmCustomField as unknown)[immerable] = true;

export class OnlineConsent
{
    public emailConsent: boolean;
    public smsConsent: boolean;
    public phoneConsent: boolean;
    public generalConsent: boolean;
    public smsEnabled: boolean;

    public constructor(init?: Partial<OnlineConsent>) { (Object as any).assign(this, init); }
}
(OnlineConsent as unknown)[immerable] = true;

export class BatchEmailRequestObject
{
    public id: number;
    public template: string;

    public constructor(init?: Partial<BatchEmailRequestObject>) { (Object as any).assign(this, init); }
}
(BatchEmailRequestObject as unknown)[immerable] = true;

export class Attachment
{
    public name: string;
    public path: string;
    public content: string;

    public constructor(init?: Partial<Attachment>) { (Object as any).assign(this, init); }
}
(Attachment as unknown)[immerable] = true;

export class AttachmentGroup
{
    public files: Attachment[];
    public templates: Attachment[];
    public mergedTemplates: Attachment[];

    public constructor(init?: Partial<AttachmentGroup>) { (Object as any).assign(this, init); }
}
(AttachmentGroup as unknown)[immerable] = true;

export class ModiyEmailToFromAddressSettingsReq
{
    public email: string;

    public constructor(init?: Partial<ModiyEmailToFromAddressSettingsReq>) { (Object as any).assign(this, init); }
}

export enum BlockTemplateFormat
{
    Draft = 'Draft',
    Block = 'Block',
}

export class SystemConfig implements IHasId
{
    public id: number;
    public description: string;
    public value: string;

    public constructor(init?: Partial<SystemConfig>) { (Object as any).assign(this, init); }
}
(SystemConfig as unknown)[immerable] = true;

export enum FromMode
{
    OurNumber = 'OurNumber',
    TheirNumber = 'TheirNumber',
    FromText = 'FromText',
}

export class CasePrintingItem
{
    public id: number;
    public type: string;

    public constructor(init?: Partial<CasePrintingItem>) { (Object as any).assign(this, init); }
}
(CasePrintingItem as unknown)[immerable] = true;

export class CaseReport
{
    public id: string;
    public rootId?: string;
    public templateId: string;
    public bookerId: string;
    public targetId: string;
    public data: string;
    public timeStamp: string;
    public auditId: string;
    public status: number;
    public message: string;

    public constructor(init?: Partial<CaseReport>) { (Object as any).assign(this, init); }
}
(CaseReport as unknown)[immerable] = true;

export interface IHasCaseId
{
    caseId: number;
}

export class AutoSaveUpdate
{
    public id: number;
    public type: string;
    public local: string;
    public data: { [index:string]: Object; };

    public constructor(init?: Partial<AutoSaveUpdate>) { (Object as any).assign(this, init); }
}
(AutoSaveUpdate as unknown)[immerable] = true;

export class BillingItemWithDetails extends BillingItem
{
    public practitionerForename: string;
    public practitionerTitle: string;
    public practitionerSurname: string;
    public employmentStatus: string;
    // @Ignore()
    public practitionerName: string;

    public customerForename: string;
    public customerTitle: string;
    public customerSurname: string;
    // @Ignore()
    public customerName: string;

    public stockType: string;
    public locationName: string;
    public invoiceRef: string;
    public accountName: string;
    public accountType: string;
    public groupOrPatientReference: string;
    public paidDate?: string;
    public customerInvoicePeriod: string;
    public groupInvoicePeriod: string;
    public groupName: string;
    public groupId?: number;
    // @Ignore()
    public status: string;

    public accountingSystemLineItemId: string;
    public accountingSystemCreditNoteId: string;

    public constructor(init?: Partial<BillingItemWithDetails>) { super(init); (Object as any).assign(this, init); }
}
(BillingItemWithDetails as unknown)[immerable] = true;

export class CaseDischargeSnapshot
{
    public date?: string;
    public previousStatus: number;
    public dischargeStatus: string;
    public dischargedByUserId?: number;
    public templateId: string;
    public revokedDate?: string;
    public revokedByUserId?: number;
    public revokedReason: string;
    public answers: { [index:string]: Object; };

    public constructor(init?: Partial<CaseDischargeSnapshot>) { (Object as any).assign(this, init); }
}
(CaseDischargeSnapshot as unknown)[immerable] = true;

export class Case implements ICascade, ILocationId, IHasReference, IHasDocuments
{
    public id: number;
    public customerId: number;
    public practitionerId?: number;
    public createdByUserId?: number;
    public dischargedByUserId?: number;
    public medicalContactId?: number;
    public admissionDate?: string;
    public referralReason: string;
    public diagnosis: string;
    public diagnosisKey: string;
    public diagnosisCode: string;
    public dischargeDate?: string;
    public patientOutcome: string;
    public practitionerOutcome: string;
    public dischargeStatus: string;
    public numberOfAppointments: number;
    public reference: string;
    public admissionCode: string;
    public reviewDate?: string;
    public referralDate?: string;
    public bodySite: string;
    public bodySide: string;
    public timePresent?: number;
    public timePresentUnit: string;
    public injuryCause: string;
    public preExistingConditions: string;
    public admissionPainScale?: number;
    public admissionLetterDate?: string;
    public dischargePainScale?: number;
    public dischargeLetterDate?: string;
    public clinicNotes: string;
    public agreedFunctionalOutcome: string;
    public closed: boolean;
    public closedUser: string;
    public closedDateTime?: string;
    public lastUnlockReason: string;
    public lastUnlockDate?: string;
    public lastUndischargeReason: string;
    public lastUndischargeDate?: string;
    public patientType: string;
    public auditUser: string;
    public auditNotes: string;
    public auditDate?: string;
    public standardPathwayFollowed: boolean;
    public locationId: number;
    public ofInterest?: boolean;
    public firstAppointmentId?: number;
    public serviceTypeId?: number;
    public linkedCaseId?: number;
    public status: number;
    public autoSaved: boolean;
    public data: { [index:string]: Object; };
    public dischargeHistory: CaseDischargeSnapshot[];
    public admissionTemplateId?: string;
    public dischargeTemplateId: string;
    public admissionHighlight: { [index:string]: number[]; };
    public dischargeHighlight: { [index:string]: number[]; };
    public type: string;
    public bookingAuditId?: string;
    public goalOrder: number[];
    public scoreOrder: number[];
    public viewed: boolean;
    public documentsLoaded: boolean;
    public consent?: boolean;
    public taxExempt: boolean;
    // @Ignore()
    public documentsSubDirectory: string;

    public additionalPractitioners: number[];

    public constructor(init?: Partial<Case>) { (Object as any).assign(this, init); }
}
(Case as unknown)[immerable] = true;

export class Psfs implements IHasId
{
    public id: number;
    public caseId: number;
    public activity: string;
    public linkedGoalId: number;

    public constructor(init?: Partial<Psfs>) { (Object as any).assign(this, init); }
}
(Psfs as unknown)[immerable] = true;

export class CaseWithCustomerPractitionerLocationDetails extends Case
{
    public customerForename: string;
    public customerSurname: string;
    public customerTitle: string;
    public customerHomeTelephone: string;
    public customerWorkTelephone: string;
    public customerMobileTelephone: string;
    public customerEmail: string;
    public customerCategory: string;
    public customerDateOfBirth: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public addressLine5: string;
    public postCode: string;
    public location: string;
    public practitionerTitle: string;
    public practitionerForename: string;
    public practitionerSurname: string;
    public practitionerEmail: string;
    public practitionerCode: string;
    public contractNumber: string;
    public regNumber: string;
    // @Ignore()
    public practitionerName: string;

    // @Ignore()
    public practitionerNameWithAwards: string;

    // @Ignore()
    public createdByName: string;

    // @Ignore()
    public dischargedByName: string;

    // @Ignore()
    public isAudited: boolean;

    // @Ignore()
    public auditUserName: string;

    public serviceType: string;
    // @Ignore()
    public psfs: Psfs[];

    public constructor(init?: Partial<CaseWithCustomerPractitionerLocationDetails>) { super(init); (Object as any).assign(this, init); }
}
(CaseWithCustomerPractitionerLocationDetails as unknown)[immerable] = true;

export class GraphicResult
{
    public id: number;
    public caseId: number;
    public date: string;
    public value: string;

    public constructor(init?: Partial<GraphicResult>) { (Object as any).assign(this, init); }
}
(GraphicResult as unknown)[immerable] = true;

export class PainAnnotation
{
    public id: number;
    public chartId?: number;
    public annotation: string;
    public x?: number;
    public y?: number;
    public rectX?: number;
    public rectY?: number;
    public title: string;
    public treatmentId?: number;
    public point?: number;
    public caseId?: number;
    public painType: string;
    public dateTime?: string;

    public constructor(init?: Partial<PainAnnotation>) { (Object as any).assign(this, init); }
}
(PainAnnotation as unknown)[immerable] = true;

export class ImageResult
{
    public id: number;
    public caseId: number;
    public date: string;
    public filename: string;
    public type: string;
    public closed: boolean;
    public closedUser: string;
    public closedDateTime?: string;
    public annotations: PainAnnotation[];

    public constructor(init?: Partial<ImageResult>) { (Object as any).assign(this, init); }
}
(ImageResult as unknown)[immerable] = true;

export class CaseSummaryResult
{
    public id: number;
    public admissionDate?: string;
    public reference: string;
    public diagnosis: string;
    public bodySite: string;
    public dischargeDate?: string;
    public treatments: number;

    public constructor(init?: Partial<CaseSummaryResult>) { (Object as any).assign(this, init); }
}
(CaseSummaryResult as unknown)[immerable] = true;

export enum ConsultationItemType
{
    Assessment = 'Assessment',
    Modality = 'Modality',
    Goal = 'Goal',
    Score = 'Score',
    Image = 'Image',
}

export class ConsultationItem implements IHasId, ICascade
{
    public id: number;
    public treatmentId: number;
    public type: ConsultationItemType;
    public title: string;
    public data: { [index:string]: Object; };
    public date?: string;
    public templateId: string;
    public highlights: { [index:string]: number[]; };

    public constructor(init?: Partial<ConsultationItem>) { (Object as any).assign(this, init); }
}
(ConsultationItem as unknown)[immerable] = true;

export class PostCloseNotes implements IHasId
{
    public id: number;
    public caseId: number;
    public treatmentId?: number;
    public userId: number;
    public notes: string;
    public date: string;
    public type: string;

    public constructor(init?: Partial<PostCloseNotes>) { (Object as any).assign(this, init); }
}
(PostCloseNotes as unknown)[immerable] = true;

export class PostCloseNotesWithUser extends PostCloseNotes
{
    public userName: string;
    public userFullName: string;

    public constructor(init?: Partial<PostCloseNotesWithUser>) { super(init); (Object as any).assign(this, init); }
}
(PostCloseNotesWithUser as unknown)[immerable] = true;

export class CaseScoreGoalResponse
{
    public id: number;
    public name: string;

    public constructor(init?: Partial<CaseScoreGoalResponse>) { (Object as any).assign(this, init); }
}
(CaseScoreGoalResponse as unknown)[immerable] = true;

export class PathologyOrderResponse
{
    public orderId: number;
    public orderRef: string;
    public panelName: string;
    public resultsReceived?: string;
    public provider: EPathologyProvider;
    public stockId: number;
    public hasCriticalResult: boolean;
    public clientCode: string;

    public constructor(init?: Partial<PathologyOrderResponse>) { (Object as any).assign(this, init); }
}
(PathologyOrderResponse as unknown)[immerable] = true;

// @Flags()
export enum EImagingOrderStatus
{
    Booked = 0,
    Complete = 1,
    Cancelled = 2,
    Rescheduled = 3,
}

export class MedicalImagingOrderDetails
{
    public orderRef: string;
    public procedureCode: string;
    public procedureDescription: string;
    public modalityCode: string;
    public modalityDescription: string;
    public aeTitle: string;
    public orderId: number;
    public status: EImagingOrderStatus;
    public createdDate: string;
    public appointmentStartDateTime?: string;

    public constructor(init?: Partial<MedicalImagingOrderDetails>) { (Object as any).assign(this, init); }
}
(MedicalImagingOrderDetails as unknown)[immerable] = true;

export class NewPsfs
{
    public id?: number;
    public activity: string;
    public initialValue: number;
    public linkedGoalId: number;

    public constructor(init?: Partial<NewPsfs>) { (Object as any).assign(this, init); }
}
(NewPsfs as unknown)[immerable] = true;

export enum SessionRecordingStatus
{
    Recording = 'Recording',
    Paused = 'Paused',
    Stopped = 'Stopped',
    Transcribing = 'Transcribing',
    Completed = 'Completed',
    Failed = 'Failed',
    StoppedNoAllowance = 'StoppedNoAllowance',
}

export enum TranscriptSpeakerRole
{
    Clinician = 'Clinician',
    Patient = 'Patient',
    Unknown = 'Unknown',
}

export class TranscriptSegmentDto
{
    public id: number;
    public speakerRole: TranscriptSpeakerRole;
    public speakerLabel: string;
    public providerSpeakerId: string;
    public startMs: number;
    public endMs: number;
    public text: string;
    public confidence?: number;
    public sequenceOrder: number;

    public constructor(init?: Partial<TranscriptSegmentDto>) { (Object as any).assign(this, init); }
}
(TranscriptSegmentDto as unknown)[immerable] = true;

export class StructuringMatchDto
{
    public guid: string;
    public label: string;
    public value: string;
    public confidence?: number;
    public source: string;

    public constructor(init?: Partial<StructuringMatchDto>) { (Object as any).assign(this, init); }
}
(StructuringMatchDto as unknown)[immerable] = true;

export class TreatmentDetails
{
    public id: number;
    public caseId: number;
    public appointmentId?: number;
    public dateTime?: string;
    public initials: string;
    public notes: string;
    public length?: number;
    public assessLength: number;
    public cost?: number;
    public locationId?: number;
    public practitionerId?: number;
    public migrated?: boolean;
    public closed?: boolean;
    public closedUser: string;
    public closedDate?: string;
    public scale?: number;
    public measure: string;
    public data: { [index:string]: Object; };
    public templateId: string;
    public type: string;

    public constructor(init?: Partial<TreatmentDetails>) { (Object as any).assign(this, init); }
}
(TreatmentDetails as unknown)[immerable] = true;

export class DynamicUpdate
{
    public id: number;
    public type: string;
    public json: string;

    public constructor(init?: Partial<DynamicUpdate>) { (Object as any).assign(this, init); }
}
(DynamicUpdate as unknown)[immerable] = true;

export class ScoreEntryRequest implements ILocationId, ISecurityId
{
    public id: number;
    public dateAdded?: string;
    public scoreId: number;
    public score: number;
    public locationId: number;
    public caseId: number;
    public securityId: number;

    public constructor(init?: Partial<ScoreEntryRequest>) { (Object as any).assign(this, init); }
}
(ScoreEntryRequest as unknown)[immerable] = true;

export class ScoreRequest implements ILocationId, ISecurityId
{
    public id: number;
    public securityId: number;
    public title: string;
    public dateAdded?: string;
    public dateCompleted?: string;
    public caseId: number;
    public settingId: number;
    public locationId: number;

    public constructor(init?: Partial<ScoreRequest>) { (Object as any).assign(this, init); }
}
(ScoreRequest as unknown)[immerable] = true;

export class GoalEntryRequest implements ISecurityId
{
    public title: string;
    public id: number;
    public notes: string;
    public caseId: number;
    public securityId: number;
    public goalId: number;
    public completionPercentage: number;
    public dateAdded?: string;
    public locationId: number;

    public constructor(init?: Partial<GoalEntryRequest>) { (Object as any).assign(this, init); }
}
(GoalEntryRequest as unknown)[immerable] = true;

export class GoalRequest implements ISecurityId
{
    public id: number;
    public caseId: number;
    public securityId: number;
    public title: string;
    public averaged: boolean;
    public dateAdded?: string;
    public dateCompleted?: string;
    public settingId: number;
    public locationId: number;

    public constructor(init?: Partial<GoalRequest>) { (Object as any).assign(this, init); }
}
(GoalRequest as unknown)[immerable] = true;

// @Flags()
export enum EProcessStatus
{
    Inactive = 1,
    Draft = 2,
    Active = 4,
}

export class DiaryListResponse implements IHasId
{
    public id: number;
    public name: string;
    public startDateTime: string;
    public endDateTime: string;
    public type: string;
    public status: number;
    public subStatus: AppointmentSubStatus;
    public practitionerId: number;
    public locationId: number;
    public stockId: number;
    public comment: string;
    public customerId: number;
    public customerReference: string;
    public customerAltRef: string;
    public customerMobileTelephone: string;
    public customerEmail: string;
    public customerSMSEnabled: boolean;
    public customerTitle: string;
    public customerForename: string;
    public customerSurname: string;
    public customerDateOfBirth?: string;
    public customerGender: string;
    public insuranceNumber: string;
    public groupReference: string;
    public customerStatus: number;
    public customerRegistrationDate?: string;
    public registrationNumber: string;
    public procedureId?: number;

    public constructor(init?: Partial<DiaryListResponse>) { (Object as any).assign(this, init); }
}
(DiaryListResponse as unknown)[immerable] = true;

export class DiaryListRequest extends DiaryListBase implements IReturn<ResponseBase<DiaryListResponse>>
{

    public constructor(init?: Partial<DiaryListRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'DiaryListRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<DiaryListResponse>(); }
}
(DiaryListRequest as unknown)[immerable] = true;

export class DiaryBulkActionBaseRequest extends BulkActionBaseRequest<DiaryListRequest>
{

    public constructor(init?: Partial<DiaryBulkActionBaseRequest>) { super(init); (Object as any).assign(this, init); }
}
(DiaryBulkActionBaseRequest as unknown)[immerable] = true;

// @Flags()
export enum TagActionType
{
    AddTag = 0,
    RemoveTag = 1,
}

export class CustomerSearchResponse
{
    public id: number;
    public listOnly: boolean;
    public locMatch: boolean;
    public reference: string;
    public patientHospitalNumber: string;
    public status: string;
    public provisional: boolean;
    public forename: string;
    public surname: string;
    public title: string;
    public name: string;
    public gender: string;
    public address: string;
    public postCode: string;
    public registrationDate?: string;
    public number: string;
    public email: string;
    public dateOfBirth?: string;
    public locationName: string;
    public practitionerId?: number;
    public practitionerTitle: string;
    public practitionerForename: string;
    public practitionerSurname: string;
    public practitionerName: string;
    public groupId?: number;
    public groupName: string;
    public patientGroup: string;
    public balanceInvoiced?: number;
    public lastAppointmentDate?: string;
    public hasAlerts: boolean;
    public practitioner: string;
    public surnameHighlight: boolean;
    public postCodeHighlight: boolean;
    public doBHighlight: boolean;
    public matchLikelyhood: number;
    public levenshteinDistance: number;
    public emailConsent: boolean;
    public tags: string[];
    public meta: { [index:string]: Object; };
    public isBusiness: boolean;

    public constructor(init?: Partial<CustomerSearchResponse>) { (Object as any).assign(this, init); }
}
(CustomerSearchResponse as unknown)[immerable] = true;

// @Route("/customers/search")
export class CustomerAdvancedSearchRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<CustomerSearchResponse>>
{
    public name: string;
    public address: string;
    public email: string;
    public phoneNumbers: string;
    public reference: string;
    public status?: number;
    public provisional: boolean;
    public gender: string[];
    public dateOfBirth: DateRange;
    public registrationDate: DateRange;
    public lastAppointmentDate: DateRange;
    public practitionerIds: number[];
    public includeTags: string[];
    public excludeTags: string[];

    public constructor(init?: Partial<CustomerAdvancedSearchRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerAdvancedSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CustomerSearchResponse>(); }
}
(CustomerAdvancedSearchRequest as unknown)[immerable] = true;

export class CustomerBulkActionBaseRequest extends BulkActionBaseRequest<CustomerAdvancedSearchRequest>
{

    public constructor(init?: Partial<CustomerBulkActionBaseRequest>) { super(init); (Object as any).assign(this, init); }
}
(CustomerBulkActionBaseRequest as unknown)[immerable] = true;

export enum AutomationEventEntityType
{
    Appointment = 'Appointment',
    Patient = 'Patient',
    Invoice = 'Invoice',
    Case = 'Case',
    Task = 'Task',
    ClassAttendance = 'ClassAttendance',
    Charge = 'Charge',
    Form = 'Form',
    Stock = 'Stock',
    Authorisation = 'Authorisation',
    Vehicle = 'Vehicle',
}

export enum AutomationEventName
{
    Booked = 'Booked',
    Completed = 'Completed',
    Cancelled = 'Cancelled',
    DNAed = 'DNAed',
    ResetToBooked = 'ResetToBooked',
    Created = 'Created',
    Updated = 'Updated',
    Discharged = 'Discharged',
    Attended = 'Attended',
    Birthday = 'Birthday',
    PackageItemsExpiring = 'PackageItemsExpiring',
    BulkAction = 'BulkAction',
    Sent = 'Sent',
    Received = 'Received',
    AuthAdded = 'AuthAdded',
    ExpiringAuth = 'ExpiringAuth',
    FallsBelowAuthThreshold = 'FallsBelowAuthThreshold',
    FallsBelowTreatmentThreshold = 'FallsBelowTreatmentThreshold',
    HasReminder = 'HasReminder',
    RemainsInactive = 'RemainsInactive',
    ScanResultsReceived = 'ScanResultsReceived',
    FallsBelowCreditThreshold = 'FallsBelowCreditThreshold',
    PackageLinkedToCaseIsConsumed = 'PackageLinkedToCaseIsConsumed',
    HasExpiredPackageLinkedToCase = 'HasExpiredPackageLinkedToCase',
}

export enum AppointmentConditions
{
    IsFirstAppointment = 'IsFirstAppointment',
    IsFirstAppointmentAfterRegistration = 'IsFirstAppointmentAfterRegistration',
    HasCase = 'HasCase',
    LinkedToDischargedCase = 'LinkedToDischargedCase',
    LinkedToUndischargedCase = 'LinkedToUndischargedCase',
    HasFutureAuthorisations = 'HasFutureAuthorisations',
    IsLinkedToSpecificGroups = 'IsLinkedToSpecificGroups',
    IsLinkedToGroupWithClassifications = 'IsLinkedToGroupWithClassifications',
    IsLinkedToGroup = 'IsLinkedToGroup',
    AppointmentChargeHasAllTheTags = 'AppointmentChargeHasAllTheTags',
    AppointmentChargeHasNoneOfTheTags = 'AppointmentChargeHasNoneOfTheTags',
    AppointmentChargeHasAnyOfTheTags = 'AppointmentChargeHasAnyOfTheTags',
    HasNoFutureAppointments = 'HasNoFutureAppointments',
    HasFutureAppointments = 'HasFutureAppointments',
    IsNotLinkedToGroup = 'IsNotLinkedToGroup',
    HasBeenRecalled = 'HasBeenRecalled',
    HasNotBeenRecalled = 'HasNotBeenRecalled',
    IsAtLocation = 'IsAtLocation',
    WasBookedFrom = 'WasBookedFrom',
    WithinCancellationChargeWindow = 'WithinCancellationChargeWindow',
}

export enum TaskConditions
{
    HasAllTheTags = 'HasAllTheTags',
    HasAnyOfTheTags = 'HasAnyOfTheTags',
    HasNoneOfTheTags = 'HasNoneOfTheTags',
}

export enum InvoiceConditions
{
    InvoiceHasTheStatus = 'InvoiceHasTheStatus',
    IsAtLocation = 'IsAtLocation',
}

export enum CaseConditions
{
    IsDischarged = 'IsDischarged',
    IsNotDischarged = 'IsNotDischarged',
}

export enum CustomerConditions
{
    HasNoneOfTheTags = 'HasNoneOfTheTags',
    HasAnyOfTheTags = 'HasAnyOfTheTags',
    HasAllTheTags = 'HasAllTheTags',
    HasTheStatus = 'HasTheStatus',
    IsLinkedToGroup = 'IsLinkedToGroup',
    HasNoFutureAppointments = 'HasNoFutureAppointments',
    HasFutureAppointments = 'HasFutureAppointments',
    IsLinkedToSpecificGroups = 'IsLinkedToSpecificGroups',
    IsNotLinkedToGroup = 'IsNotLinkedToGroup',
    IsLinkedToGroupWithClassifications = 'IsLinkedToGroupWithClassifications',
    HasFutureAuthorisations = 'HasFutureAuthorisations',
    HasNoFutureAuthorisations = 'HasNoFutureAuthorisations',
    HasFutureClasses = 'HasFutureClasses',
    HasNoFutureClasses = 'HasNoFutureClasses',
    HasConsentedToEmails = 'HasConsentedToEmails',
    HasConsentedToTextMessages = 'HasConsentedToTextMessages',
    HasConsentedToPhoneCalls = 'HasConsentedToPhoneCalls',
    HasConsentedToTreatment = 'HasConsentedToTreatment',
    IsAtLocation = 'IsAtLocation',
    HasSomeCompletedAppointments = 'HasSomeCompletedAppointments',
    HasAttendedSomeClasses = 'HasAttendedSomeClasses',
    HasHad = 'HasHad',
    HasNotHad = 'HasNotHad',
    WasCreatedFrom = 'WasCreatedFrom',
}

export enum ClassAttendanceConditions
{
    HasAttended = 'HasAttended',
    HasNotAttended = 'HasNotAttended',
    HasCancelled = 'HasCancelled',
    HasNotCancelled = 'HasNotCancelled',
    HasNotBeenRecalled = 'HasNotBeenRecalled',
    HasBeenRecalled = 'HasBeenRecalled',
    IsAtLocation = 'IsAtLocation',
}

export enum ChargeConditions
{
    IsDiscount = 'IsDiscount',
    IsWriteOff = 'IsWriteOff',
    IsCredit = 'IsCredit',
    IsForPhysicalStock = 'IsForPhysicalStock',
    IsForConnectPackage = 'IsForConnectPackage',
    IsASubscription = 'IsASubscription',
    IsNotASubscription = 'IsNotASubscription',
    StockItemIs = 'StockItemIs',
    HasAllTheTags = 'HasAllTheTags',
    HasAnyOfTheTags = 'HasAnyOfTheTags',
    HasNoneOfTheTags = 'HasNoneOfTheTags',
    IsAtLocation = 'IsAtLocation',
    IsTransfer = 'IsTransfer',
}

export enum FormConditions
{
    IsComplete = 'IsComplete',
    IsIncomplete = 'IsIncomplete',
}

export enum StockConditions
{
    HasAllTheTags = 'HasAllTheTags',
    HasAnyOfTheTags = 'HasAnyOfTheTags',
    HasNoneOfTheTags = 'HasNoneOfTheTags',
}

export class EventCondition
{
    public type: AutomationEventEntityType;
    public appointmentFunction: AppointmentConditions;
    public taskFunction: TaskConditions;
    public invoiceFunction: InvoiceConditions;
    public caseFunction: CaseConditions;
    public patientFunction: CustomerConditions;
    public classattendanceFunction: ClassAttendanceConditions;
    public parameters: { [index:string]: Object; };
    public chargeFunction: ChargeConditions;
    public formFunction: FormConditions;
    public stockFunction: StockConditions;

    public constructor(init?: Partial<EventCondition>) { (Object as any).assign(this, init); }
}
(EventCondition as unknown)[immerable] = true;

export enum EventActionType
{
    Task = 'Task',
    AddTag = 'AddTag',
    RemoveTag = 'RemoveTag',
    Email = 'Email',
    SMS = 'SMS',
    Form = 'Form',
    AddTagsFromCharge = 'AddTagsFromCharge',
    UpdateField = 'UpdateField',
    Mailchimp = 'Mailchimp',
    AddAlert = 'AddAlert',
    AddNote = 'AddNote',
    CrmSyncContact = 'CrmSyncContact',
    CrmSyncDeal = 'CrmSyncDeal',
    ExecuteJourneyStep = 'ExecuteJourneyStep',
    TriggerJourneysForEvent = 'TriggerJourneysForEvent',
}

export enum TimeUnit
{
    Immediate = 'Immediate',
    Hours = 'Hours',
    Days = 'Days',
    Weeks = 'Weeks',
    Months = 'Months',
    AppointmentDate = 'AppointmentDate',
}

export class FutureDateSpecifier
{
    public value: number;
    public unit: TimeUnit;

    public constructor(init?: Partial<FutureDateSpecifier>) { (Object as any).assign(this, init); }
}
(FutureDateSpecifier as unknown)[immerable] = true;

export class FutureTimeSpecifier
{
    public hour: number;
    public minutes: number;

    public constructor(init?: Partial<FutureTimeSpecifier>) { (Object as any).assign(this, init); }
}
(FutureTimeSpecifier as unknown)[immerable] = true;

export enum EEventActionTarget
{
    EventLinkedPractitioner = 'EventLinkedPractitioner',
    Patient = 'Patient',
    PatientLinkedBusiness = 'PatientLinkedBusiness',
    PatientLinkedPractitioner = 'PatientLinkedPractitioner',
    Specified = 'Specified',
    EventObject = 'EventObject',
    EventLinkedPatient = 'EventLinkedPatient',
}

// @Flags()
export enum EAlertForUser
{
    Everyone = 0,
    Specific = 1,
}

// @Flags()
export enum NoteLockMode
{
    Location = 76,
    Me = 77,
    None = 78,
    Role = 82,
}

export class CrmDealSettings
{
    public status: string;

    public constructor(init?: Partial<CrmDealSettings>) { (Object as any).assign(this, init); }
}
(CrmDealSettings as unknown)[immerable] = true;

export class EventAction
{
    public eventType: AutomationEventEntityType;
    public actionType: EventActionType;
    public due: FutureDateSpecifier;
    public time: FutureTimeSpecifier;
    public conditions: EventCondition[];
    public template: string;
    public taskDescription: string;
    public tags: string[];
    public taskDue: FutureDateSpecifier;
    public taskFor: number;
    public taskPriority: boolean;
    public taskReminder: boolean;
    public taskStatus: string;
    public formTemplateId: string;
    public customMessage: string;
    public audienceId: string;
    public target?: EEventActionTarget;
    public emailAddress: string;
    public title: string;
    public notes: string;
    public alertRequiresAcknowledgement: boolean;
    public alertForUser: EAlertForUser;
    public userId?: number;
    public noteLockMode: NoteLockMode;
    public noteLockValue: number;
    public isAlert: boolean;
    public crmDealSettings: CrmDealSettings;

    public constructor(init?: Partial<EventAction>) { (Object as any).assign(this, init); }
}
(EventAction as unknown)[immerable] = true;

export class AutomationEvent implements IHasGuidId
{
    public id: string;
    public type: AutomationEventEntityType;
    public eventName: AutomationEventName;
    public name: string;
    public description: string;
    public isActive: boolean;
    public isArchived: boolean;
    public conditions: EventCondition[];
    public actions: EventAction[];
    public isBulkAction: boolean;
    public createdDate?: string;
    public lookupValue: string;
    public beforeDays: number;

    public constructor(init?: Partial<AutomationEvent>) { (Object as any).assign(this, init); }
}
(AutomationEvent as unknown)[immerable] = true;

export interface IHasGuidId extends IHasIdMarker
{
    id: string;
}

export enum TagEntityType
{
    General = 'General',
    Patient = 'Patient',
    Stock = 'Stock',
    Equipment = 'Equipment',
}

export class Tag implements IHasGuidId
{
    public id: string;
    public name: string;
    public type: TagEntityType;
    public colour: string;
    public isActive: boolean;
    public isInverted: boolean;
    public showInLists: boolean;

    public constructor(init?: Partial<Tag>) { (Object as any).assign(this, init); }
}
(Tag as unknown)[immerable] = true;

export class AssertionResponse
{
    public authenticatorData: string;
    public signature: string;
    public clientDataJson: string;
    public userHandle: string;

    public constructor(init?: Partial<AssertionResponse>) { (Object as any).assign(this, init); }
}

export enum PublicKeyCredentialType
{
    PublicKey = 'public-key',
}

export class AuthenticationExtensionsClientOutputs
{
    public appID: boolean;
    public authenticatorSelection: boolean;

    public constructor(init?: Partial<AuthenticationExtensionsClientOutputs>) { (Object as any).assign(this, init); }
}
(AuthenticationExtensionsClientOutputs as unknown)[immerable] = true;

export class ResponseData
{
    public attestationObject: string;
    public clientDataJson: string;

    public constructor(init?: Partial<ResponseData>) { (Object as any).assign(this, init); }
}

export enum PackageTier
{
    Core = 'Core',
    Standard = 'Standard',
    Premium = 'Premium',
    Enterprise = 'Enterprise',
}

export class AddOnRate
{
    public addOnId: string;
    public price: number;
    public pricingMode: string;

    public constructor(init?: Partial<AddOnRate>) { (Object as any).assign(this, init); }
}
(AddOnRate as unknown)[immerable] = true;

export class AssignedCustomAttributeDto
{
    public id: string;
    public objectId: number;
    public objectType: string;
    public customAttributeType: string;
    public customAttributeId: string;
    public objectGuid: string;
    public name: string;

    public constructor(init?: Partial<AssignedCustomAttributeDto>) { (Object as any).assign(this, init); }
}
(AssignedCustomAttributeDto as unknown)[immerable] = true;

export class BillingEntitySaveRequestBase
{
    public name: string;
    public contactName: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public addressLine5: string;
    public postCode: string;
    public telephone: string;
    public email: string;
    public tm3InvoiceTemplate: string;
    public isActive?: boolean;

    public constructor(init?: Partial<BillingEntitySaveRequestBase>) { (Object as any).assign(this, init); }
}

export enum AccessMode
{
    Private = 'Private',
    ViewOnly = 'ViewOnly',
    FullAccess = 'FullAccess',
}

export enum DefaultStockTypes
{
    First = 'First',
    FollowUp = 'FollowUp',
    Dna = 'Dna',
    Cancel = 'Cancel',
    Unknown = 'Unknown',
}

export class TreatmentAuthResponse
{
    public id: number;
    public authCode: string;
    public expired?: string;
    public isExpired: boolean;
    public maxTreatments: number;
    public maxValue?: number;
    public expiryDate?: string;
    public usedTreatments: number;
    public usedValue?: number;
    public usedFor: string;
    public startDate?: string;
    public groupId?: number;
    public caseId?: number;
    public customerId: number;
    public contactId: number;
    public valueRemaining?: number;
    public appointmentsRemaining: number;
    public bodySite: string;
    public groupName: string;
    public serviceType: string;
    public serviceTypeId?: number;
    public prontoBookingAuditId?: string;
    public authCodeCustomerReference: string;

    public constructor(init?: Partial<TreatmentAuthResponse>) { (Object as any).assign(this, init); }
}
(TreatmentAuthResponse as unknown)[immerable] = true;

export enum PrepaymentType
{
    PayLater = 'PayLater',
    Autopay = 'Autopay',
    Deposit = 'Deposit',
    ChaseOnly = 'ChaseOnly',
}

export class AppointmentAdditionalChargeRequest
{
    public stockId: number;
    public quantity: number;

    public constructor(init?: Partial<AppointmentAdditionalChargeRequest>) { (Object as any).assign(this, init); }
}
(AppointmentAdditionalChargeRequest as unknown)[immerable] = true;

export enum DepositPaymentType
{
    DepositOnlinePayment = 'DepositOnlinePayment',
    DepositAutoPay = 'DepositAutoPay',
    DepositPhysicalTerminal = 'DepositPhysicalTerminal',
    DepositVirtualTerminal = 'DepositVirtualTerminal',
}

export class AppointmentProcedureSelection
{
    public procedureId: number;
    public radiologistGroup: string;
    public priority: boolean;

    public constructor(init?: Partial<AppointmentProcedureSelection>) { (Object as any).assign(this, init); }
}
(AppointmentProcedureSelection as unknown)[immerable] = true;

export enum Classification
{
    Asset = 'Asset',
    Equity = 'Equity',
    Expense = 'Expense',
    Liability = 'Liability',
    Revenue = 'Revenue',
    Income = 'Income',
    OtherIncome = 'OtherIncome',
    OtherExpense = 'OtherExpense',
    CostsOfSales = 'CostsOfSales',
    Other = 'Other',
}

export interface IAlertRequest
{
}

export class IdDescriminatorType
{
    public objectId: number;
    public descriminatorType: string;

    public constructor(init?: Partial<IdDescriminatorType>) { (Object as any).assign(this, init); }
}
(IdDescriminatorType as unknown)[immerable] = true;

export class AiRequest implements ISecurityId
{
    /** @description Target scope to route to the LLM processor (e.g. clinical/summary) */
    // @ApiMember(Description="Target scope to route to the LLM processor (e.g. clinical/summary)", IsRequired=true)
    public scope: string;

    /** @description Context object type (patient, case, treatment) */
    // @ApiMember(Description="Context object type (patient, case, treatment)", IsRequired=true)
    public objectType: string;

    /** @description Context object identifier */
    // @ApiMember(Description="Context object identifier", IsRequired=true)
    public objectId: number;

    /** @description Force refresh even if a persisted summary exists */
    // @ApiMember(Description="Force refresh even if a persisted summary exists")
    public forceRefresh: boolean;

    /** @description Optional free-text context for the request */
    // @ApiMember(Description="Optional free-text context for the request")
    public context: string;

    /** @description Optional key/value attributes for the request */
    // @ApiMember(Description="Optional key/value attributes for the request")
    public attributes: { [index:string]: string; };

    public securityId: number;

    public constructor(init?: Partial<AiRequest>) { (Object as any).assign(this, init); }
}
(AiRequest as unknown)[immerable] = true;

export class NextActionsChatMessage
{
    public role: string;
    public content: string;

    public constructor(init?: Partial<NextActionsChatMessage>) { (Object as any).assign(this, init); }
}
(NextActionsChatMessage as unknown)[immerable] = true;

export class ConsultationFieldDto
{
    public guid: string;
    public label: string;

    public constructor(init?: Partial<ConsultationFieldDto>) { (Object as any).assign(this, init); }
}
(ConsultationFieldDto as unknown)[immerable] = true;

export enum SearchModuleEntityType
{
    Audit = 'Audit',
    AutomationRules = 'AutomationRules',
    Business = 'Business',
    Case = 'Case',
    Charge = 'Charge',
    Debtor = 'Debtor',
    Diary = 'Diary',
    Expenditure = 'Expenditure',
    Invoice = 'Invoice',
    JobSheet = 'JobSheet',
    Patient = 'Patient',
    Location = 'Location',
    MedicalContact = 'MedicalContact',
    Payment = 'Payment',
    Practitioner = 'Practitioner',
    Procedure = 'Procedure',
    Room = 'Room',
    RpReferrals = 'RpReferrals',
    RpReferralsAction = 'RpReferralsAction',
    RpFiles = 'RpFiles',
    Supplier = 'Supplier',
    Subscription = 'Subscription',
    RpUser = 'RpUser',
    Stock = 'Stock',
    StockTransactionHistory = 'StockTransactionHistory',
    Timeline = 'Timeline',
    User = 'User',
    Vehicle = 'Vehicle',
    Pronto = 'Pronto',
    Workflow = 'Workflow',
    Journey = 'Journey',
    NM_Network = 'NM_Network',
    NM_Location = 'NM_Location',
    NM_Business = 'NM_Business',
    IncomingInvoice = 'IncomingInvoice',
    Team = 'Team',
    Task = 'Task',
    InvoiceWizard = 'InvoiceWizard',
    DiscountCode = 'DiscountCode',
    WF_PatientSearch = 'WF_PatientSearch',
    Documents = 'Documents',
    RpLiteReferrals = 'RpLiteReferrals',
}

export enum FilterAssignmentType
{
    All = 'All',
    Me = 'Me',
    Team = 'Team',
}

export class SearchFilter implements IHasGuidId
{
    public id: string;
    public filterModule: SearchModuleEntityType;
    public filterName: string;
    public filterDescription: string;
    public isActive: boolean;
    public filterConditions: SearchFilterCondition[];
    public lastResultCount?: number;
    public pinned?: boolean;
    public teamId?: string;
    public userId?: string;

    public constructor(init?: Partial<SearchFilter>) { (Object as any).assign(this, init); }
}
(SearchFilter as unknown)[immerable] = true;

export class LedgerAccountInfo
{
    public id: string;
    public accountName: string;
    public code: string;
    public type: string;
    public override: boolean;

    public constructor(init?: Partial<LedgerAccountInfo>) { (Object as any).assign(this, init); }
}
(LedgerAccountInfo as unknown)[immerable] = true;

export enum LedgerCodeCategory
{
    DefaultSales = 'DefaultSales',
    DefaultIncome = 'DefaultIncome',
    Stock = 'Stock',
    Consultation = 'Consultation',
    Class = 'Class',
    Package = 'Package',
    CreditNote = 'CreditNote',
    WriteOff = 'WriteOff',
    Discount = 'Discount',
    Transfer = 'Transfer',
    Cancellation = 'Cancellation',
    Dna = 'Dna',
}

export class LedgerAccountInfoWithCategory extends LedgerAccountInfo
{
    public ledgerCategory: LedgerCodeCategory;

    public constructor(init?: Partial<LedgerAccountInfoWithCategory>) { super(init); (Object as any).assign(this, init); }
}
(LedgerAccountInfoWithCategory as unknown)[immerable] = true;

export class TaxRateInfo
{
    public id: string;
    public name: string;
    public code: string;
    public totalTaxRate?: number;

    public constructor(init?: Partial<TaxRateInfo>) { (Object as any).assign(this, init); }
}
(TaxRateInfo as unknown)[immerable] = true;

export enum TaxRateCategory
{
    Taxable = 'Taxable',
    NonTaxable = 'NonTaxable',
}

export class TaxRateInfoWithCategory extends TaxRateInfo
{
    public taxCategory: TaxRateCategory;

    public constructor(init?: Partial<TaxRateInfoWithCategory>) { super(init); (Object as any).assign(this, init); }
}
(TaxRateInfoWithCategory as unknown)[immerable] = true;

export class AccountingSettingInfo
{
    public tenantId: string;
    public status: string;
    public systemName: AccountingSystemProviderName;
    public serviceId: string;
    public salesLedgerCodeId: string;
    public incomeLedgerCodeId: string;
    public nonTaxableRateId: string;
    public taxableRateId: string;
    public appointmentItemsLedgerCodeId: string;
    public classItemsLedgerCodeId: string;
    public packageItemsLedgerCodeId: string;
    public stockItemsLedgerCodeId: string;
    public discountItemsLedgerCodeId: string;
    public creditItemsLedgerCodeId: string;
    public transferItemsLedgerCodeId: string;
    public writeoffItemsLedgerCodeId: string;
    public cancellationItemsLedgerCodeId: string;
    public dnaItemsLedgerCodeId: string;
    public syncEnabled: boolean;
    public syncStartDate: string;
    public deactivationDate?: string;
    public setupComplete: boolean;
    public deactivated: boolean;
    public ledgerAccountInfos: LedgerAccountInfoWithCategory[];
    public taxRateInfos: TaxRateInfoWithCategory[];
    public activationHistory: string[];

    public constructor(init?: Partial<AccountingSettingInfo>) { (Object as any).assign(this, init); }
}
(AccountingSettingInfo as unknown)[immerable] = true;

export interface IVirtualReceptionRequest
{
}

export enum TimeOfDay
{
    AnyTime = 'AnyTime',
    Morning = 'Morning',
    Afternoon = 'Afternoon',
    Evening = 'Evening',
    Custom = 'Custom',
}

export enum SubscriptionStatus
{
    Active = 1,
    Cancelled = 2,
    Expired = 3,
    Removed = 4,
}

export enum SubscriptionBillingMode
{
    Now = 'Now',
    Later = 'Later',
}

export enum SubscriptionPaymentMode
{
    Now = 'Now',
    Later = 'Later',
}

export enum SubscriptionPaymentMethod
{
    Cash = 'Cash',
    ExistingCard = 'ExistingCard',
    Other = 'Other',
    SynchronousTempCardOnly = 'SynchronousTempCardOnly',
    SquareTerminal = 'SquareTerminal',
}

export enum SubscriptionRecurrenceInterval
{
    Day = 'Day',
    Week = 'Week',
    Fortnight = 'Fortnight',
    Month = 'Month',
    Quarter = 'Quarter',
    Year = 'Year',
}

export class PackageBundleItemResponse
{
    public id: string;
    public bundleId: string;
    public type: PackageBundleItemType;
    public typeId: number;
    public description: string;

    public constructor(init?: Partial<PackageBundleItemResponse>) { (Object as any).assign(this, init); }
}
(PackageBundleItemResponse as unknown)[immerable] = true;

export class PackageBundleResponse
{
    public id: string;
    public quantity: number;
    public type: PackageBundleItemType;
    public items: PackageBundleItemResponse[];
    public packageId?: string;

    public constructor(init?: Partial<PackageBundleResponse>) { (Object as any).assign(this, init); }
}
(PackageBundleResponse as unknown)[immerable] = true;

// @Flags()
export enum PackageType
{
    ITEM = 0,
    CREDIT = 1,
}

export enum WaitListGender
{
    Unspecified = 'Unspecified',
    Male = 'Male',
    Female = 'Female',
    Specified = 'Specified',
}

export enum WaitingListType
{
    Appointment = 'Appointment',
    Class = 'Class',
    Course = 'Course',
}

export enum LocationType
{
    Any = 'Any',
    Specific = 'Specific',
}

export enum WaitingListUrgency
{
    Normal = 'Normal',
    High = 'High',
}

export enum WaitingListStatus
{
    Waiting = 'Waiting',
    AwaitingConfirmation = 'AwaitingConfirmation',
    Booked = 'Booked',
    Declined = 'Declined',
    Expired = 'Expired',
}

export enum WaitingListSubStatus
{
    Awaiting = 'Awaiting',
    Confirmed = 'Confirmed',
    Declined = 'Declined',
    DidNotRespond = 'DidNotRespond',
    RespondedButNotBooked = 'RespondedButNotBooked',
}

export enum WaitingListNotificationType
{
    KeepNotifying = 'KeepNotifying',
    Pause = 'Pause',
    Remove = 'Remove',
}

export enum WaitingListBookingType
{
    TM3 = 'TM3',
    ONLINE = 'ONLINE',
}

export class Qualification
{
    public id: string;
    public isSet: boolean;
    public name: string;
    public body: string;
    public expiryDate?: string;
    public startDate?: string;

    public constructor(init?: Partial<Qualification>) { (Object as any).assign(this, init); }
}
(Qualification as unknown)[immerable] = true;

export class AppointmentPractitionerObject
{
    public title: string;
    public forename: string;
    public surname: string;
    public gender: string;
    public id: string;
    public practitionerId: number;
    public name: string;
    public shortName: string;
    public qualifications: Qualification[];

    public constructor(init?: Partial<AppointmentPractitionerObject>) { (Object as any).assign(this, init); }
}
(AppointmentPractitionerObject as unknown)[immerable] = true;

export class AppointmentLocationObject
{
    public name: string;
    public id: string;
    public locationId: number;

    public constructor(init?: Partial<AppointmentLocationObject>) { (Object as any).assign(this, init); }
}
(AppointmentLocationObject as unknown)[immerable] = true;

export class AppointmentRoomObject
{
    public id: number;

    public constructor(init?: Partial<AppointmentRoomObject>) { (Object as any).assign(this, init); }
}
(AppointmentRoomObject as unknown)[immerable] = true;

export enum AppointmentType
{
    Pronto = 'Pronto',
    Internal = 'Internal',
}

export class AppointmentSearchPriceLine
{
    public serviceId: string;
    public stockId?: string;
    public price: number;
    public priceExVat: number;

    public constructor(init?: Partial<AppointmentSearchPriceLine>) { (Object as any).assign(this, init); }
}
(AppointmentSearchPriceLine as unknown)[immerable] = true;

export class AppointmentSearchResult
{
    public price: number;
    public priceExVat: number;
    public creditValue?: number;
    public vatRate: number;
    public bookingMethod: string;
    public startDateTime: string;
    public endDateTime: string;
    public practitioner: AppointmentPractitionerObject;
    public location: AppointmentLocationObject;
    public room: AppointmentRoomObject;
    public patientId: string;
    public stockId?: string;
    public networkId: string;
    public serviceId: string;
    public serviceTypeId: number;
    public appointmentType: AppointmentType;
    public returnAppointmentTimesAsUnspecified: boolean;
    public isFollowUp: boolean;
    public paymentOption?: number;
    public paymentOptionValue?: number;
    public additionalServicePrices: AppointmentSearchPriceLine[];

    public constructor(init?: Partial<AppointmentSearchResult>) { (Object as any).assign(this, init); }
}
(AppointmentSearchResult as unknown)[immerable] = true;

export enum PaymentMode
{
    Credit = 1,
    Card = 2,
    SubscriptionPackage = 3,
    Clinic = 4,
    PrePaid = 5,
    FutureCredit = 6,
    CreditBasedPackage = 7,
}

export class CustomerCardDemographics
{
    public name: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public addressLine5: string;
    public postCode: string;

    public constructor(init?: Partial<CustomerCardDemographics>) { (Object as any).assign(this, init); }
}
(CustomerCardDemographics as unknown)[immerable] = true;

export class TakePaymentRequest
{
    public provider: PaymentProviderName;
    public data: { [index:string]: string; };
    public saveCard: boolean;
    public useSavedCard: boolean;
    public customerDetails: CustomerCardDemographics;
    public useLocationMerchantId: boolean;

    public constructor(init?: Partial<TakePaymentRequest>) { (Object as any).assign(this, init); }
}
(TakePaymentRequest as unknown)[immerable] = true;

export class InsuranceDetails
{
    public token: string;
    public groupId: number;
    public insuranceNumber: string;
    public preAuthorisationCode: string;
    public generateMagicLink: boolean;
    public insuranceConsentGiven: boolean;

    public constructor(init?: Partial<InsuranceDetails>) { (Object as any).assign(this, init); }
}
(InsuranceDetails as unknown)[immerable] = true;

export class MarketingAttribution
{
    public marketingSource: string;
    public marketingMedium: string;
    public marketingCampaign: string;
    public marketingClickId: string;
    public marketingClickIdType: string;
    public analyticsClientId: string;

    public constructor(init?: Partial<MarketingAttribution>) { (Object as any).assign(this, init); }
}
(MarketingAttribution as unknown)[immerable] = true;

export class AppointmentSummary
{
    public startDateTime: string;
    public endDateTime: string;
    public locationName: string;
    public locationAddress1: string;
    public locationAddress2: string;
    public locationEmail: string;
    public email: string;
    public reference: string;
    public bookingReference: string;
    public practitionerId: number;
    public locationId: number;
    public id: number;
    public mobileNumber: string;
    public customerId: number;
    public smsEnabled: boolean;
    public status: number;
    public stockId?: number;
    public isNetworkBooking: boolean;
    public marketingAttribution: MarketingAttribution;
    public isNewPatient: boolean;

    public constructor(init?: Partial<AppointmentSummary>) { (Object as any).assign(this, init); }
}
(AppointmentSummary as unknown)[immerable] = true;

export class OnlineGroupDto
{
    public id: number;
    public name: string;

    public constructor(init?: Partial<OnlineGroupDto>) { (Object as any).assign(this, init); }
}
(OnlineGroupDto as unknown)[immerable] = true;

export class OnlineCustomerDto implements IReturn<ResponseBase<T>>
{
    public title: string;
    public forename: string;
    public surname: string;
    public dateOfBirth?: string;
    public homeTelephone: string;
    public workTelephone: string;
    public mobileTelephone: string;
    public gender: string;
    public email: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public addressLine5: string;
    public postCode: string;
    public id?: number;
    public group: OnlineGroupDto;
    public groupId?: number;
    public insuranceNumber: string;
    public canBookAppointments: boolean;
    public practitionerGuid: string;
    public locationGuid: string;
    public groupReference: string;
    public excludedPackages: string[];
    public lastAppointmentPractitionerGuid?: string;
    public overridePayAtClinic: boolean;
    public oAuthProvider: string;
    public oAuthUserId: string;

    public constructor(init?: Partial<OnlineCustomerDto>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineCustomerDto'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(OnlineCustomerDto as unknown)[immerable] = true;

export class AppointmentConfirmRequest implements IReturn<ResponseBase<AppointmentSummary>>, IPut
{
    public selectedAppointment: AppointmentSearchResult;
    public offeredAppointment: AppointmentSearchResult;
    public customer: OnlineCustomerDto;
    public id: string;
    public prepaymentId: number;
    public usePrepayment: boolean;
    public paymentType: PaymentMode;
    public packageId?: string;
    public stockId: string;
    public serviceId: string;
    public medicalImagingProcedureId?: number;
    public discountCodeId?: string;
    public takePaymentRequest: TakePaymentRequest;
    public payFullAmount: boolean;
    public metadata: JsonField;
    public appointmentType: AppointmentType;
    public isFollowUp: boolean;
    public overrideProductServiceId?: string;
    public workflowId?: number;
    public temporaryFolderId?: string;
    public insuranceDetails: InsuranceDetails;
    public marketingAttribution: MarketingAttribution;

    public constructor(init?: Partial<AppointmentConfirmRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AppointmentConfirmRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<AppointmentSummary>(); }
}
(AppointmentConfirmRequest as unknown)[immerable] = true;

export class AdditionalAppointmentConfirmItem
{
    public appointment: AppointmentConfirmRequest;
    public ruleId: string;

    public constructor(init?: Partial<AdditionalAppointmentConfirmItem>) { (Object as any).assign(this, init); }
}
(AdditionalAppointmentConfirmItem as unknown)[immerable] = true;

export class CardDetails
{
    public brand: string;
    public elementType: string;
    public cardName: string;
    public expiryMonth: number;
    public expiryYear: number;
    public lastFourDigits: string;
    public insuranceConsentGiven: boolean;
    public canDeleteCard: boolean;
    public hasFutureInsuranceAppointments: boolean;

    public constructor(init?: Partial<CardDetails>) { (Object as any).assign(this, init); }
}
(CardDetails as unknown)[immerable] = true;

export class MsContact
{
    public name: string;
    public email: string;

    public constructor(init?: Partial<MsContact>) { (Object as any).assign(this, init); }
}
(MsContact as unknown)[immerable] = true;

export class MsApiAccessSettings
{
    public hasLimit: boolean;
    public dailyLimit?: number;
    public monthlyLimit?: number;

    public constructor(init?: Partial<MsApiAccessSettings>) { (Object as any).assign(this, init); }
}
(MsApiAccessSettings as unknown)[immerable] = true;

export class MsReferralPortalSettings
{
    public hasLimit: boolean;
    public dailyLimit?: number;
    public monthlyLimit?: number;

    public constructor(init?: Partial<MsReferralPortalSettings>) { (Object as any).assign(this, init); }
}
(MsReferralPortalSettings as unknown)[immerable] = true;

export class MsLicenceEntitlementsResponse
{
    public tierId: string;
    public tierName: string;
    public packageId: string;
    public addOnIds: string[];
    public addOnQuantities: { [index:string]: number; };
    public moduleIds: string[];
    public apiAccess: MsApiAccessSettings;
    public referralPortal: MsReferralPortalSettings;
    public isLegacy: boolean;
    public legacyTierName: string;
    public legacyTierDescription: string;
    public product: string;
    public subscription: string;
    public source: string;
    public updatedAt?: string;

    public constructor(init?: Partial<MsLicenceEntitlementsResponse>) { (Object as any).assign(this, init); }
}
(MsLicenceEntitlementsResponse as unknown)[immerable] = true;

export class StripeEntity implements IStripeEntity
{

    public constructor(init?: Partial<StripeEntity>) { (Object as any).assign(this, init); }
}

export class StripeEntity_1<T> extends StripeEntity
{

    public constructor(init?: Partial<StripeEntity_1<T>>) { super(init); (Object as any).assign(this, init); }
}

export class PaymentMethodAcssDebit extends StripeEntity_1<PaymentMethodAcssDebit>
{
    public bankName: string;
    public fingerprint: string;
    public institutionNumber: string;
    public last4: string;
    public transitNumber: string;

    public constructor(init?: Partial<PaymentMethodAcssDebit>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodAcssDebit as unknown)[immerable] = true;

export class PaymentMethodAffirm extends StripeEntity_1<PaymentMethodAffirm>
{

    public constructor(init?: Partial<PaymentMethodAffirm>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodAffirm as unknown)[immerable] = true;

export class PaymentMethodAfterpayClearpay extends StripeEntity_1<PaymentMethodAfterpayClearpay>
{

    public constructor(init?: Partial<PaymentMethodAfterpayClearpay>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodAfterpayClearpay as unknown)[immerable] = true;

export class PaymentMethodAlipay extends StripeEntity_1<PaymentMethodAlipay>
{

    public constructor(init?: Partial<PaymentMethodAlipay>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodAlipay as unknown)[immerable] = true;

export class PaymentMethodAlma extends StripeEntity_1<PaymentMethodAlma>
{

    public constructor(init?: Partial<PaymentMethodAlma>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodAlma as unknown)[immerable] = true;

export class PaymentMethodAmazonPay extends StripeEntity_1<PaymentMethodAmazonPay>
{

    public constructor(init?: Partial<PaymentMethodAmazonPay>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodAmazonPay as unknown)[immerable] = true;

export class PaymentMethodAuBecsDebit extends StripeEntity_1<PaymentMethodAuBecsDebit>
{
    public bsbNumber: string;
    public fingerprint: string;
    public last4: string;

    public constructor(init?: Partial<PaymentMethodAuBecsDebit>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodAuBecsDebit as unknown)[immerable] = true;

export class PaymentMethodBacsDebit extends StripeEntity_1<PaymentMethodBacsDebit>
{
    public fingerprint: string;
    public last4: string;
    public sortCode: string;

    public constructor(init?: Partial<PaymentMethodBacsDebit>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodBacsDebit as unknown)[immerable] = true;

export class PaymentMethodBancontact extends StripeEntity_1<PaymentMethodBancontact>
{

    public constructor(init?: Partial<PaymentMethodBancontact>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodBancontact as unknown)[immerable] = true;

export class Address extends StripeEntity_1<Address>
{
    public city: string;
    public country: string;
    public line1: string;
    public line2: string;
    public postalCode: string;
    public state: string;

    public constructor(init?: Partial<Address>) { super(init); (Object as any).assign(this, init); }
}
(Address as unknown)[immerable] = true;

export class PaymentMethodBillingDetails extends StripeEntity_1<PaymentMethodBillingDetails>
{
    public address: Address;
    public email: string;
    public name: string;
    public phone: string;

    public constructor(init?: Partial<PaymentMethodBillingDetails>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodBillingDetails as unknown)[immerable] = true;

export class PaymentMethodBlik extends StripeEntity_1<PaymentMethodBlik>
{

    public constructor(init?: Partial<PaymentMethodBlik>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodBlik as unknown)[immerable] = true;

export class PaymentMethodBoleto extends StripeEntity_1<PaymentMethodBoleto>
{
    public taxId: string;

    public constructor(init?: Partial<PaymentMethodBoleto>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodBoleto as unknown)[immerable] = true;

export class PaymentMethodCardChecks extends StripeEntity_1<PaymentMethodCardChecks>
{
    public addressLine1Check: string;
    public addressPostalCodeCheck: string;
    public cvcCheck: string;

    public constructor(init?: Partial<PaymentMethodCardChecks>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardChecks as unknown)[immerable] = true;

export class PaymentMethodCardGeneratedFromPaymentMethodDetailsCardPresentOffline extends StripeEntity_1<PaymentMethodCardGeneratedFromPaymentMethodDetailsCardPresentOffline>
{
    public storedAt?: string;
    public type: string;

    public constructor(init?: Partial<PaymentMethodCardGeneratedFromPaymentMethodDetailsCardPresentOffline>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardGeneratedFromPaymentMethodDetailsCardPresentOffline as unknown)[immerable] = true;

export class PaymentMethodCardGeneratedFromPaymentMethodDetailsCardPresentReceipt extends StripeEntity_1<PaymentMethodCardGeneratedFromPaymentMethodDetailsCardPresentReceipt>
{
    public accountType: string;
    public applicationCryptogram: string;
    public applicationPreferredName: string;
    public authorizationCode: string;
    public authorizationResponseCode: string;
    public cardholderVerificationMethod: string;
    public dedicatedFileName: string;
    public terminalVerificationResults: string;
    public transactionStatusInformation: string;

    public constructor(init?: Partial<PaymentMethodCardGeneratedFromPaymentMethodDetailsCardPresentReceipt>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardGeneratedFromPaymentMethodDetailsCardPresentReceipt as unknown)[immerable] = true;

export class PaymentMethodCardGeneratedFromPaymentMethodDetailsCardPresentWallet extends StripeEntity_1<PaymentMethodCardGeneratedFromPaymentMethodDetailsCardPresentWallet>
{
    public type: string;

    public constructor(init?: Partial<PaymentMethodCardGeneratedFromPaymentMethodDetailsCardPresentWallet>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardGeneratedFromPaymentMethodDetailsCardPresentWallet as unknown)[immerable] = true;

export class PaymentMethodCardGeneratedFromPaymentMethodDetailsCardPresent extends StripeEntity_1<PaymentMethodCardGeneratedFromPaymentMethodDetailsCardPresent>
{
    public amountAuthorized?: number;
    public brand: string;
    public brandProduct: string;
    public captureBefore: string;
    public cardholderName: string;
    public country: string;
    public description: string;
    public emvAuthData: string;
    public expMonth: number;
    public expYear: number;
    public fingerprint: string;
    public funding: string;
    public generatedCard: string;
    public iin: string;
    public incrementalAuthorizationSupported: boolean;
    public issuer: string;
    public last4: string;
    public network: string;
    public networkTransactionId: string;
    public offline: PaymentMethodCardGeneratedFromPaymentMethodDetailsCardPresentOffline;
    public overcaptureSupported: boolean;
    public preferredLocales: string[];
    public readMethod: string;
    public receipt: PaymentMethodCardGeneratedFromPaymentMethodDetailsCardPresentReceipt;
    public wallet: PaymentMethodCardGeneratedFromPaymentMethodDetailsCardPresentWallet;

    public constructor(init?: Partial<PaymentMethodCardGeneratedFromPaymentMethodDetailsCardPresent>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardGeneratedFromPaymentMethodDetailsCardPresent as unknown)[immerable] = true;

export class PaymentMethodCardGeneratedFromPaymentMethodDetails extends StripeEntity_1<PaymentMethodCardGeneratedFromPaymentMethodDetails>
{
    public cardPresent: PaymentMethodCardGeneratedFromPaymentMethodDetailsCardPresent;
    public type: string;

    public constructor(init?: Partial<PaymentMethodCardGeneratedFromPaymentMethodDetails>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardGeneratedFromPaymentMethodDetails as unknown)[immerable] = true;

export class PaymentMethodCardGeneratedFrom extends StripeEntity_1<PaymentMethodCardGeneratedFrom>
{
    public charge: string;
    public paymentMethodDetails: PaymentMethodCardGeneratedFromPaymentMethodDetails;

    public constructor(init?: Partial<PaymentMethodCardGeneratedFrom>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardGeneratedFrom as unknown)[immerable] = true;

export class PaymentMethodCardNetworks extends StripeEntity_1<PaymentMethodCardNetworks>
{
    public available: string[];
    public preferred: string;

    public constructor(init?: Partial<PaymentMethodCardNetworks>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardNetworks as unknown)[immerable] = true;

export class PaymentMethodCardThreeDSecureUsage extends StripeEntity_1<PaymentMethodCardThreeDSecureUsage>
{
    public supported: boolean;

    public constructor(init?: Partial<PaymentMethodCardThreeDSecureUsage>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardThreeDSecureUsage as unknown)[immerable] = true;

export class PaymentMethodCardWalletAmexExpressCheckout extends StripeEntity_1<PaymentMethodCardWalletAmexExpressCheckout>
{

    public constructor(init?: Partial<PaymentMethodCardWalletAmexExpressCheckout>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardWalletAmexExpressCheckout as unknown)[immerable] = true;

export class PaymentMethodCardWalletApplePay extends StripeEntity_1<PaymentMethodCardWalletApplePay>
{

    public constructor(init?: Partial<PaymentMethodCardWalletApplePay>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardWalletApplePay as unknown)[immerable] = true;

export class PaymentMethodCardWalletGooglePay extends StripeEntity_1<PaymentMethodCardWalletGooglePay>
{

    public constructor(init?: Partial<PaymentMethodCardWalletGooglePay>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardWalletGooglePay as unknown)[immerable] = true;

export class PaymentMethodCardWalletLink extends StripeEntity_1<PaymentMethodCardWalletLink>
{

    public constructor(init?: Partial<PaymentMethodCardWalletLink>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardWalletLink as unknown)[immerable] = true;

export class PaymentMethodCardWalletMasterpass extends StripeEntity_1<PaymentMethodCardWalletMasterpass>
{
    public billingAddress: Address;
    public email: string;
    public name: string;
    public shippingAddress: Address;

    public constructor(init?: Partial<PaymentMethodCardWalletMasterpass>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardWalletMasterpass as unknown)[immerable] = true;

export class PaymentMethodCardWalletSamsungPay extends StripeEntity_1<PaymentMethodCardWalletSamsungPay>
{

    public constructor(init?: Partial<PaymentMethodCardWalletSamsungPay>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardWalletSamsungPay as unknown)[immerable] = true;

export class PaymentMethodCardWalletVisaCheckout extends StripeEntity_1<PaymentMethodCardWalletVisaCheckout>
{
    public billingAddress: Address;
    public email: string;
    public name: string;
    public shippingAddress: Address;

    public constructor(init?: Partial<PaymentMethodCardWalletVisaCheckout>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardWalletVisaCheckout as unknown)[immerable] = true;

export class PaymentMethodCardWallet extends StripeEntity_1<PaymentMethodCardWallet>
{
    public amexExpressCheckout: PaymentMethodCardWalletAmexExpressCheckout;
    public applePay: PaymentMethodCardWalletApplePay;
    public dynamicLast4: string;
    public googlePay: PaymentMethodCardWalletGooglePay;
    public link: PaymentMethodCardWalletLink;
    public masterpass: PaymentMethodCardWalletMasterpass;
    public samsungPay: PaymentMethodCardWalletSamsungPay;
    public type: string;
    public visaCheckout: PaymentMethodCardWalletVisaCheckout;

    public constructor(init?: Partial<PaymentMethodCardWallet>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardWallet as unknown)[immerable] = true;

export class PaymentMethodCard extends StripeEntity_1<PaymentMethodCard>
{
    public brand: string;
    public checks: PaymentMethodCardChecks;
    public country: string;
    public description: string;
    public displayBrand: string;
    public expMonth: number;
    public expYear: number;
    public fingerprint: string;
    public funding: string;
    public generatedFrom: PaymentMethodCardGeneratedFrom;
    public iin: string;
    public issuer: string;
    public last4: string;
    public networks: PaymentMethodCardNetworks;
    public regulatedStatus: string;
    public threeDSecureUsage: PaymentMethodCardThreeDSecureUsage;
    public wallet: PaymentMethodCardWallet;

    public constructor(init?: Partial<PaymentMethodCard>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCard as unknown)[immerable] = true;

export class PaymentMethodCardPresentNetworks extends StripeEntity_1<PaymentMethodCardPresentNetworks>
{
    public available: string[];
    public preferred: string;

    public constructor(init?: Partial<PaymentMethodCardPresentNetworks>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardPresentNetworks as unknown)[immerable] = true;

export class PaymentMethodCardPresentOffline extends StripeEntity_1<PaymentMethodCardPresentOffline>
{
    public storedAt?: string;
    public type: string;

    public constructor(init?: Partial<PaymentMethodCardPresentOffline>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardPresentOffline as unknown)[immerable] = true;

export class PaymentMethodCardPresentWallet extends StripeEntity_1<PaymentMethodCardPresentWallet>
{
    public type: string;

    public constructor(init?: Partial<PaymentMethodCardPresentWallet>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardPresentWallet as unknown)[immerable] = true;

export class PaymentMethodCardPresent extends StripeEntity_1<PaymentMethodCardPresent>
{
    public brand: string;
    public brandProduct: string;
    public cardholderName: string;
    public country: string;
    public description: string;
    public expMonth: number;
    public expYear: number;
    public fingerprint: string;
    public funding: string;
    public iin: string;
    public issuer: string;
    public last4: string;
    public networks: PaymentMethodCardPresentNetworks;
    public offline: PaymentMethodCardPresentOffline;
    public preferredLocales: string[];
    public readMethod: string;
    public wallet: PaymentMethodCardPresentWallet;

    public constructor(init?: Partial<PaymentMethodCardPresent>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCardPresent as unknown)[immerable] = true;

export class PaymentMethodCashapp extends StripeEntity_1<PaymentMethodCashapp>
{
    public buyerId: string;
    public cashtag: string;

    public constructor(init?: Partial<PaymentMethodCashapp>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCashapp as unknown)[immerable] = true;

export class PaymentMethodCustomerBalance extends StripeEntity_1<PaymentMethodCustomerBalance>
{

    public constructor(init?: Partial<PaymentMethodCustomerBalance>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodCustomerBalance as unknown)[immerable] = true;

export class PaymentMethodEps extends StripeEntity_1<PaymentMethodEps>
{
    public bank: string;

    public constructor(init?: Partial<PaymentMethodEps>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodEps as unknown)[immerable] = true;

export class PaymentMethodFpx extends StripeEntity_1<PaymentMethodFpx>
{
    public accountHolderType: string;
    public bank: string;

    public constructor(init?: Partial<PaymentMethodFpx>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodFpx as unknown)[immerable] = true;

export class PaymentMethodGiropay extends StripeEntity_1<PaymentMethodGiropay>
{

    public constructor(init?: Partial<PaymentMethodGiropay>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodGiropay as unknown)[immerable] = true;

export class PaymentMethodGrabpay extends StripeEntity_1<PaymentMethodGrabpay>
{

    public constructor(init?: Partial<PaymentMethodGrabpay>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodGrabpay as unknown)[immerable] = true;

export class PaymentMethodIdeal extends StripeEntity_1<PaymentMethodIdeal>
{
    public bank: string;
    public bic: string;

    public constructor(init?: Partial<PaymentMethodIdeal>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodIdeal as unknown)[immerable] = true;

export class PaymentMethodInteracPresentNetworks extends StripeEntity_1<PaymentMethodInteracPresentNetworks>
{
    public available: string[];
    public preferred: string;

    public constructor(init?: Partial<PaymentMethodInteracPresentNetworks>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodInteracPresentNetworks as unknown)[immerable] = true;

export class PaymentMethodInteracPresent extends StripeEntity_1<PaymentMethodInteracPresent>
{
    public brand: string;
    public cardholderName: string;
    public country: string;
    public description: string;
    public expMonth: number;
    public expYear: number;
    public fingerprint: string;
    public funding: string;
    public iin: string;
    public issuer: string;
    public last4: string;
    public networks: PaymentMethodInteracPresentNetworks;
    public preferredLocales: string[];
    public readMethod: string;

    public constructor(init?: Partial<PaymentMethodInteracPresent>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodInteracPresent as unknown)[immerable] = true;

export class PaymentMethodKakaoPay extends StripeEntity_1<PaymentMethodKakaoPay>
{

    public constructor(init?: Partial<PaymentMethodKakaoPay>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodKakaoPay as unknown)[immerable] = true;

export class PaymentMethodKlarnaDob extends StripeEntity_1<PaymentMethodKlarnaDob>
{
    public day?: number;
    public month?: number;
    public year?: number;

    public constructor(init?: Partial<PaymentMethodKlarnaDob>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodKlarnaDob as unknown)[immerable] = true;

export class PaymentMethodKlarna extends StripeEntity_1<PaymentMethodKlarna>
{
    public dob: PaymentMethodKlarnaDob;

    public constructor(init?: Partial<PaymentMethodKlarna>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodKlarna as unknown)[immerable] = true;

export class PaymentMethodKonbini extends StripeEntity_1<PaymentMethodKonbini>
{

    public constructor(init?: Partial<PaymentMethodKonbini>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodKonbini as unknown)[immerable] = true;

export class PaymentMethodKrCard extends StripeEntity_1<PaymentMethodKrCard>
{
    public brand: string;
    public last4: string;

    public constructor(init?: Partial<PaymentMethodKrCard>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodKrCard as unknown)[immerable] = true;

export class PaymentMethodLink extends StripeEntity_1<PaymentMethodLink>
{
    public email: string;
    public persistentToken: string;

    public constructor(init?: Partial<PaymentMethodLink>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodLink as unknown)[immerable] = true;

export class PaymentMethodMobilepay extends StripeEntity_1<PaymentMethodMobilepay>
{

    public constructor(init?: Partial<PaymentMethodMobilepay>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodMobilepay as unknown)[immerable] = true;

export class PaymentMethodMultibanco extends StripeEntity_1<PaymentMethodMultibanco>
{

    public constructor(init?: Partial<PaymentMethodMultibanco>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodMultibanco as unknown)[immerable] = true;

export class PaymentMethodNaverPay extends StripeEntity_1<PaymentMethodNaverPay>
{
    public funding: string;

    public constructor(init?: Partial<PaymentMethodNaverPay>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodNaverPay as unknown)[immerable] = true;

export class PaymentMethodOxxo extends StripeEntity_1<PaymentMethodOxxo>
{

    public constructor(init?: Partial<PaymentMethodOxxo>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodOxxo as unknown)[immerable] = true;

export class PaymentMethodP24 extends StripeEntity_1<PaymentMethodP24>
{
    public bank: string;

    public constructor(init?: Partial<PaymentMethodP24>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodP24 as unknown)[immerable] = true;

export class PaymentMethodPayByBank extends StripeEntity_1<PaymentMethodPayByBank>
{

    public constructor(init?: Partial<PaymentMethodPayByBank>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodPayByBank as unknown)[immerable] = true;

export class PaymentMethodPayco extends StripeEntity_1<PaymentMethodPayco>
{

    public constructor(init?: Partial<PaymentMethodPayco>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodPayco as unknown)[immerable] = true;

export class PaymentMethodPaynow extends StripeEntity_1<PaymentMethodPaynow>
{

    public constructor(init?: Partial<PaymentMethodPaynow>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodPaynow as unknown)[immerable] = true;

export class PaymentMethodPaypal extends StripeEntity_1<PaymentMethodPaypal>
{
    public country: string;
    public payerEmail: string;
    public payerId: string;

    public constructor(init?: Partial<PaymentMethodPaypal>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodPaypal as unknown)[immerable] = true;

export class PaymentMethodPix extends StripeEntity_1<PaymentMethodPix>
{

    public constructor(init?: Partial<PaymentMethodPix>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodPix as unknown)[immerable] = true;

export class PaymentMethodPromptpay extends StripeEntity_1<PaymentMethodPromptpay>
{

    public constructor(init?: Partial<PaymentMethodPromptpay>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodPromptpay as unknown)[immerable] = true;

export class PaymentMethodRadarOptions extends StripeEntity_1<PaymentMethodRadarOptions>
{
    public session: string;

    public constructor(init?: Partial<PaymentMethodRadarOptions>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodRadarOptions as unknown)[immerable] = true;

export class PaymentMethodRevolutPay extends StripeEntity_1<PaymentMethodRevolutPay>
{

    public constructor(init?: Partial<PaymentMethodRevolutPay>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodRevolutPay as unknown)[immerable] = true;

export class PaymentMethodSamsungPay extends StripeEntity_1<PaymentMethodSamsungPay>
{

    public constructor(init?: Partial<PaymentMethodSamsungPay>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodSamsungPay as unknown)[immerable] = true;

export class PaymentMethodSepaDebitGeneratedFrom extends StripeEntity_1<PaymentMethodSepaDebitGeneratedFrom>
{

    public constructor(init?: Partial<PaymentMethodSepaDebitGeneratedFrom>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodSepaDebitGeneratedFrom as unknown)[immerable] = true;

export class PaymentMethodSepaDebit extends StripeEntity_1<PaymentMethodSepaDebit>
{
    public bankCode: string;
    public branchCode: string;
    public country: string;
    public fingerprint: string;
    public generatedFrom: PaymentMethodSepaDebitGeneratedFrom;
    public last4: string;

    public constructor(init?: Partial<PaymentMethodSepaDebit>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodSepaDebit as unknown)[immerable] = true;

export class PaymentMethodSofort extends StripeEntity_1<PaymentMethodSofort>
{
    public country: string;

    public constructor(init?: Partial<PaymentMethodSofort>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodSofort as unknown)[immerable] = true;

export class PaymentMethodSwish extends StripeEntity_1<PaymentMethodSwish>
{

    public constructor(init?: Partial<PaymentMethodSwish>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodSwish as unknown)[immerable] = true;

export class PaymentMethodTwint extends StripeEntity_1<PaymentMethodTwint>
{

    public constructor(init?: Partial<PaymentMethodTwint>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodTwint as unknown)[immerable] = true;

export class PaymentMethodUsBankAccountNetworks extends StripeEntity_1<PaymentMethodUsBankAccountNetworks>
{
    public preferred: string;
    public supported: string[];

    public constructor(init?: Partial<PaymentMethodUsBankAccountNetworks>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodUsBankAccountNetworks as unknown)[immerable] = true;

export class PaymentMethodUsBankAccountStatusDetailsBlocked extends StripeEntity_1<PaymentMethodUsBankAccountStatusDetailsBlocked>
{
    public networkCode: string;
    public reason: string;

    public constructor(init?: Partial<PaymentMethodUsBankAccountStatusDetailsBlocked>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodUsBankAccountStatusDetailsBlocked as unknown)[immerable] = true;

export class PaymentMethodUsBankAccountStatusDetails extends StripeEntity_1<PaymentMethodUsBankAccountStatusDetails>
{
    public blocked: PaymentMethodUsBankAccountStatusDetailsBlocked;

    public constructor(init?: Partial<PaymentMethodUsBankAccountStatusDetails>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodUsBankAccountStatusDetails as unknown)[immerable] = true;

export class PaymentMethodUsBankAccount extends StripeEntity_1<PaymentMethodUsBankAccount>
{
    public accountHolderType: string;
    public accountType: string;
    public bankName: string;
    public financialConnectionsAccount: string;
    public fingerprint: string;
    public last4: string;
    public networks: PaymentMethodUsBankAccountNetworks;
    public routingNumber: string;
    public statusDetails: PaymentMethodUsBankAccountStatusDetails;

    public constructor(init?: Partial<PaymentMethodUsBankAccount>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodUsBankAccount as unknown)[immerable] = true;

export class PaymentMethodWechatPay extends StripeEntity_1<PaymentMethodWechatPay>
{

    public constructor(init?: Partial<PaymentMethodWechatPay>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodWechatPay as unknown)[immerable] = true;

export class PaymentMethodZip extends StripeEntity_1<PaymentMethodZip>
{

    public constructor(init?: Partial<PaymentMethodZip>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethodZip as unknown)[immerable] = true;

export class PaymentMethod extends StripeEntity_1<PaymentMethod> implements IHasId, IHasMetadata, IHasObject
{
    public id: string;
    public object: string;
    public acssDebit: PaymentMethodAcssDebit;
    public affirm: PaymentMethodAffirm;
    public afterpayClearpay: PaymentMethodAfterpayClearpay;
    public alipay: PaymentMethodAlipay;
    public allowRedisplay: string;
    public alma: PaymentMethodAlma;
    public amazonPay: PaymentMethodAmazonPay;
    public auBecsDebit: PaymentMethodAuBecsDebit;
    public bacsDebit: PaymentMethodBacsDebit;
    public bancontact: PaymentMethodBancontact;
    public billingDetails: PaymentMethodBillingDetails;
    public blik: PaymentMethodBlik;
    public boleto: PaymentMethodBoleto;
    public card: PaymentMethodCard;
    public cardPresent: PaymentMethodCardPresent;
    public cashapp: PaymentMethodCashapp;
    public created: string;
    public customerBalance: PaymentMethodCustomerBalance;
    public eps: PaymentMethodEps;
    public fpx: PaymentMethodFpx;
    public giropay: PaymentMethodGiropay;
    public grabpay: PaymentMethodGrabpay;
    public ideal: PaymentMethodIdeal;
    public interacPresent: PaymentMethodInteracPresent;
    public kakaoPay: PaymentMethodKakaoPay;
    public klarna: PaymentMethodKlarna;
    public konbini: PaymentMethodKonbini;
    public krCard: PaymentMethodKrCard;
    public link: PaymentMethodLink;
    public livemode: boolean;
    public metadata: { [index:string]: string; };
    public mobilepay: PaymentMethodMobilepay;
    public multibanco: PaymentMethodMultibanco;
    public naverPay: PaymentMethodNaverPay;
    public oxxo: PaymentMethodOxxo;
    public p24: PaymentMethodP24;
    public payByBank: PaymentMethodPayByBank;
    public payco: PaymentMethodPayco;
    public paynow: PaymentMethodPaynow;
    public paypal: PaymentMethodPaypal;
    public pix: PaymentMethodPix;
    public promptpay: PaymentMethodPromptpay;
    public radarOptions: PaymentMethodRadarOptions;
    public revolutPay: PaymentMethodRevolutPay;
    public samsungPay: PaymentMethodSamsungPay;
    public sepaDebit: PaymentMethodSepaDebit;
    public sofort: PaymentMethodSofort;
    public swish: PaymentMethodSwish;
    public twint: PaymentMethodTwint;
    public type: string;
    public usBankAccount: PaymentMethodUsBankAccount;
    public wechatPay: PaymentMethodWechatPay;
    public zip: PaymentMethodZip;

    public constructor(init?: Partial<PaymentMethod>) { super(init); (Object as any).assign(this, init); }
}
(PaymentMethod as unknown)[immerable] = true;

export enum ItemType
{
    ClassSessionDelete = 'ClassSessionDelete',
    AppointmentDelete = 'AppointmentDelete',
    Appointment = 'Appointment',
    ClassSession = 'ClassSession',
    StripeCommission = 'StripeCommission',
    OnlineAppointment = 'OnlineAppointment',
    OnlineClassSession = 'OnlineClassSession',
    VideoCall = 'VideoCall',
    ClickVideoCall = 'ClickVideoCall',
    AutomationAction = 'AutomationAction',
    FormSent = 'FormSent',
    ProntoReferral = 'ProntoReferral',
    SMS = 'SMS',
    AddressLookup = 'AddressLookup',
    ReferralPortalReferral = 'ReferralPortalReferral',
    PatientPortalReferral = 'PatientPortalReferral',
    ManualReferral = 'ManualReferral',
    APIReferral = 'APIReferral',
    ApiUsage = 'ApiUsage',
    SystemCredit = 'SystemCredit',
    AiTokenUsage = 'AiTokenUsage',
}

export enum TrafficReportOrdering
{
    All = 1,
    Appointments = 2,
    Classes = 3,
}

export class OnlineClinicService implements IHasGuidId
{
    public hidden: boolean;
    public networkServiceId: string;
    public networkId: string;
    public name: string;
    public description: string;
    public longDescription: string;
    public imageUrl: string;
    public discipline: string;
    public colour: string;
    public isOnline: boolean;
    public isClassService: boolean;
    public isCaseflowService: boolean;
    // @Ignore()
    public isCourse: boolean;

    public isMultiClass: boolean;
    public classTypeIds: number[];
    public classTypeId?: number;
    public excludeLocations: string[];
    public excludePractitioners: string[];
    public excludeDiscountCodes: string[];
    public restrictedDiscountCodes: string[];
    public stockId: string;
    public excludeSessionIds: number[];
    public excludeNormalSessionIds: number[];
    public sortIndex: Object;
    public urlSlug: string;
    public canCancel: boolean;
    public isHidden: boolean;
    public hidePrices: boolean;
    public insurancePaid: boolean;
    public businessId?: number;
    public contractId?: string;
    public productId?: string;
    public productServiceId?: string;
    public simpleWorkflowEnabled: boolean;
    public startJourneyOnBooking: boolean;
    public allowAppointmentlessReferral: boolean;
    public minimumBookingNoticeHours?: number;
    public referralFormTemplateId?: string;
    public registrationFormTemplateId?: string;
    public journeyProcessId?: string;
    public extendedSettings: string;
    public expiryDate?: string;
    public accessCode: string;
    public cfBookingAction?: string;
    // @Ignore()
    public hasAccessCode: boolean;

    // @Ignore()
    public accessCodeLength: number;

    // @Ignore()
    public isLocationBased?: boolean;

    // @Ignore()
    public isDigitalTriage: boolean;

    // @Ignore()
    public serviceName: string;

    // @Ignore()
    public isPlaceholderService: boolean;

    // @Ignore()
    public supportedGroupIds: number[];

    // @Ignore()
    public authCodeRequiredGroupIds: number[];

    public id: string;

    public constructor(init?: Partial<OnlineClinicService>) { (Object as any).assign(this, init); }
}
(OnlineClinicService as unknown)[immerable] = true;

export class OnlineServiceCategory implements IHasGuidId
{
    public id: string;
    public parentId?: string;
    public title: string;
    public urlSlug: string;
    public description: string;
    public longDescription: string;
    public imageUrl: string;
    public isOnline: boolean;
    public sortIndex: number;
    public orderedServices: string[];
    public businessId?: number;
    // @Ignore()
    public hasClasses: boolean;

    // @Ignore()
    public hasAppointments: boolean;

    // @Ignore()
    public rootSlug: string;

    public hideFromExplore: boolean;
    public insuranceDetailsPlacement: string;

    public constructor(init?: Partial<OnlineServiceCategory>) { (Object as any).assign(this, init); }
}
(OnlineServiceCategory as unknown)[immerable] = true;

export enum OnlineSectionTypes
{
    Header = 'Header',
    Search = 'Search',
    AppointmentSearch = 'AppointmentSearch',
    ClassSearch = 'ClassSearch',
    Categories = 'Categories',
    Services = 'Services',
    Offers = 'Offers',
    Packages = 'Packages',
    GuidedBookingSelector = 'GuidedBookingSelector',
}

export class OnlineSection implements IHasId
{
    public sortIndex: number;
    public type: OnlineSectionTypes;
    public params: { [index:string]: string; };
    public mode: string;
    public id: number;

    public constructor(init?: Partial<OnlineSection>) { (Object as any).assign(this, init); }
}
(OnlineSection as unknown)[immerable] = true;

export class BookingClassResponse
{
    public success: boolean;
    public isFull: boolean;
    public attendanceIds: number[];
    public attendeeId?: number;
    public backgroundJobId: string;

    public constructor(init?: Partial<BookingClassResponse>) { (Object as any).assign(this, init); }
}
(BookingClassResponse as unknown)[immerable] = true;

export class WaitingList implements IHasId
{
    public id: number;
    public createdDate: string;
    public waitingListGlobalId: string;
    public customerId: number;
    public description: string;
    public nextAppointment?: string;
    public expiryDate?: string;
    public practitionerId?: number;
    public practitionerGender: WaitListGender;
    public locationId?: number;
    public timeOfDay: TimeOfDay;
    public listType: WaitingListType;
    public locationPreference: LocationType;
    public dayPreference: string;
    public stockId?: number;
    public classTypeId?: number;
    public classSessionId?: number;
    public temporaryAppointmentId?: number;
    public temporaryClassSessionId?: number;
    public temporaryCourseId?: number;
    public dateTimeBookingOffered?: string;
    public urgency: WaitingListUrgency;
    public status: WaitingListStatus;
    public subStatus?: WaitingListSubStatus;
    public notificationType?: WaitingListNotificationType;
    public dateTimeOfferDeclined?: string;
    public pauseUntilDateTime?: string;
    public dateTimeNotResponded?: string;
    public bookingType: WaitingListBookingType;
    public dateTimeBookingDone?: string;
    public linkedToAppointmentId?: number;
    public startDate?: string;

    public constructor(init?: Partial<WaitingList>) { (Object as any).assign(this, init); }
}
(WaitingList as unknown)[immerable] = true;

export class TeamUserDto
{
    public userId: string;
    public name: string;
    public fullName: string;
    public teamId: string;

    public constructor(init?: Partial<TeamUserDto>) { (Object as any).assign(this, init); }
}
(TeamUserDto as unknown)[immerable] = true;

export enum SentryApmAction
{
    on = 'on',
    off = 'off',
}

export enum SecureDocumentShareRecipientType
{
    Patient = 1,
    MedicalContact = 2,
}

export class CreateSecureDocumentShareRecipientRequest
{
    public recipientType: SecureDocumentShareRecipientType;
    public contactId?: number;
    public recipientName: string;
    public email: string;
    public mobile: string;
    public dateOfBirth?: string;
    public pin: string;

    public constructor(init?: Partial<CreateSecureDocumentShareRecipientRequest>) { (Object as any).assign(this, init); }
}
(CreateSecureDocumentShareRecipientRequest as unknown)[immerable] = true;

export enum SecureDocumentShareEditAuditAction
{
    OriginalSaved = 1,
    CopySaved = 2,
}

export class Theme
{
    public accent: string;
    public primary: string;
    public secondary: string;

    public constructor(init?: Partial<Theme>) { (Object as any).assign(this, init); }
}
(Theme as unknown)[immerable] = true;

export class ThemeResponse extends Theme
{
    public themeId: number;

    public constructor(init?: Partial<ThemeResponse>) { super(init); (Object as any).assign(this, init); }
}
(ThemeResponse as unknown)[immerable] = true;

export enum EReferralPortalAppointmentAggregate
{
    NONE = 'NONE',
    DATE = 'DATE',
}

export enum ReferralCommunicationType
{
    None = 'None',
    SMS = 'SMS',
    Email = 'Email',
    Both = 'Both',
}

export enum ReferralPortalAuditType
{
    Misc = 'Misc',
    Creation = 'Creation',
    AppointmentAdded = 'AppointmentAdded',
    AppointmentArrived = 'AppointmentArrived',
    AppointmentCancelled = 'AppointmentCancelled',
    AppointmentDna = 'AppointmentDna',
    AppointmentRescheduled = 'AppointmentRescheduled',
    AppointmentCompleted = 'AppointmentCompleted',
    AppointmentDeleted = 'AppointmentDeleted',
    AppointmentProviderChanged = 'AppointmentProviderChanged',
    AuthorisationRequested = 'AuthorisationRequested',
    AuthorisationApproved = 'AuthorisationApproved',
    AuthorisationDeclined = 'AuthorisationDeclined',
    AuthorisationQueried = 'AuthorisationQueried',
    ReportAdded = 'ReportAdded',
    ReportAccepted = 'ReportAccepted',
    ReportRejected = 'ReportRejected',
    ReportQueried = 'ReportQueried',
    ReportRevoked = 'ReportRevoked',
    FileAdded = 'FileAdded',
    OwnerChanged = 'OwnerChanged',
    StatusUpdated = 'StatusUpdated',
    InvoiceAdded = 'InvoiceAdded',
    ReportUpdated = 'ReportUpdated',
    FileRevoked = 'FileRevoked',
    LinkAdded = 'LinkAdded',
    LinkRevoked = 'LinkRevoked',
}

// @Flags()
export enum ReferralSearchType
{
    Ignore = 0,
    ReportApprovals = 1,
    ActionsRequired = 2,
    AuthorisationsNeeded = 3,
}

export enum AppointmentStatus
{
    Booked = 0,
    Arrived = 1,
    Completed = 2,
    DNA = 3,
    Cancelled = 4,
    Temporary = 6,
    Provisional = 7,
}

export class ClickInvoiceReqBase
{
    public invoiceId: number;

    public constructor(init?: Partial<ClickInvoiceReqBase>) { (Object as any).assign(this, init); }
}
(ClickInvoiceReqBase as unknown)[immerable] = true;

export enum CommunicationMode
{
    Email = 'Email',
    SMS = 'SMS',
}

export enum ClassDateCreationMode
{
    WeeklyRecurrence = 'WeeklyRecurrence',
    DateRange = 'DateRange',
    CustomDates = 'CustomDates',
}

export enum ClashMode
{
    UpdateOnlyIfNoClashes = 'UpdateOnlyIfNoClashes',
    UpdateNonClashing = 'UpdateNonClashing',
    UpdateAllAnyway = 'UpdateAllAnyway',
    NeverUpdate = 'NeverUpdate',
    CreateExcludingClashes = 'CreateExcludingClashes',
}

export enum ClassBillingMode
{
    Attendance = 'Attendance',
    BillNow = 'BillNow',
    NewPackage = 'NewPackage',
    ExistingPackage = 'ExistingPackage',
    NewSubscription = 'NewSubscription',
    Autopay = 'Autopay',
    ExistingCreditPackage = 'ExistingCreditPackage',
    DoNotBill = 'DoNotBill',
}

export enum ClassPaymentMode
{
    DoNotBill = 'DoNotBill',
    PayLater = 'PayLater',
    PayNowCash = 'PayNowCash',
    PayNowCard = 'PayNowCard',
    UsePrePayment = 'UsePrePayment',
    PayNowMerchant = 'PayNowMerchant',
    PayNowMerchantTerminal = 'PayNowMerchantTerminal',
}

export enum SessionUpdateAppliesTo
{
    ThisSessionOnly = 'ThisSessionOnly',
    SameTimeEachWeek = 'SameTimeEachWeek',
    Custom = 'Custom',
}

export enum ClassEditType
{
    Practitioner = 'Practitioner',
    Room = 'Room',
    EditSessionDate = 'EditSessionDate',
    EditSessionTime = 'EditSessionTime',
    Space = 'Space',
}

export class ClassPackageResponse
{
    public id: string;
    public name: string;
    public price: number;
    public classTypeId: number;
    public stockId: number;
    public validForDaysFromPurchase?: number;
    public credits?: number;
    public creditPackageStockExclusions: number[];
    public creditPackageClassTypeExclusions: number[];
    public restrictToPrivateCharges: boolean;

    public constructor(init?: Partial<ClassPackageResponse>) { (Object as any).assign(this, init); }
}
(ClassPackageResponse as unknown)[immerable] = true;

export enum CourseBillingMode
{
    FirstAttendance = 'FirstAttendance',
    BillNow = 'BillNow',
    NewPackage = 'NewPackage',
    ExistingPackage = 'ExistingPackage',
    NewSubscription = 'NewSubscription',
    ExistingCredits = 'ExistingCredits',
    ExistingCreditPackage = 'ExistingCreditPackage',
}

export enum CourseEditAppliesTo
{
    ThisSessionOnly = 'ThisSessionOnly',
    ThisAndAllSubsequentSessions = 'ThisAndAllSubsequentSessions',
}

export class ActionExecutionOverrides
{
    public nextStatusId?: string;
    public ownerType: string;
    public userId?: string;
    public teamId?: string;
    public dueDate?: string;

    public constructor(init?: Partial<ActionExecutionOverrides>) { (Object as any).assign(this, init); }
}
(ActionExecutionOverrides as unknown)[immerable] = true;

export enum PortalBookingModes
{
    NotReferred = 'NotReferred',
    ReferralNoBooking = 'ReferralNoBooking',
    ReferralWithOptionalBooking = 'ReferralWithOptionalBooking',
    ReferralWithMandatoryBooking = 'ReferralWithMandatoryBooking',
}

export class MedicalContactV1RequestBase
{
    /** @description Contact status */
    // @ApiMember(Description="Contact status", ParameterType="model")
    public current?: boolean;

    /** @description Contact category */
    // @ApiMember(Description="Contact category", ParameterType="model")
    public category: string;

    /** @description Title */
    // @ApiMember(Description="Title", ParameterType="model")
    public title: string;

    /** @description Business name */
    // @ApiMember(Description="Business name", ParameterType="model")
    public businessName: string;

    /** @description Address line 1 */
    // @ApiMember(Description="Address line 1", ParameterType="model")
    public addressLine1: string;

    /** @description Address line 2 */
    // @ApiMember(Description="Address line 2", ParameterType="model")
    public addressLine2: string;

    /** @description Address line 3 */
    // @ApiMember(Description="Address line 3", ParameterType="model")
    public addressLine3: string;

    /** @description Address line 4 */
    // @ApiMember(Description="Address line 4", ParameterType="model")
    public addressLine4: string;

    /** @description Address line 5 */
    // @ApiMember(Description="Address line 5", ParameterType="model")
    public addressLine5: string;

    /** @description Mobile telephone */
    // @ApiMember(Description="Mobile telephone", ParameterType="model")
    public mobile: string;

    /** @description Postcode */
    // @ApiMember(Description="Postcode", ParameterType="model")
    public postCode: string;

    /** @description Telephone */
    // @ApiMember(Description="Telephone", ParameterType="model")
    public telephone: string;

    /** @description Alternative telephone 1 */
    // @ApiMember(Description="Alternative telephone 1", ParameterType="model")
    public altTelephone1: string;

    /** @description Alternative telephone 2 */
    // @ApiMember(Description="Alternative telephone 2", ParameterType="model")
    public altTelephone2: string;

    /** @description Fax */
    // @ApiMember(Description="Fax", ParameterType="model")
    public fax: string;

    /** @description Email address */
    // @ApiMember(Description="Email address", ParameterType="model")
    public email: string;

    /** @description Website */
    // @ApiMember(Description="Website", ParameterType="model")
    public web: string;

    /** @description Location GUID */
    // @ApiMember(Description="Location GUID", ParameterType="model")
    public locationId?: string;

    /** @description Provider number */
    // @ApiMember(Description="Provider number", ParameterType="model")
    public providerNumber: string;

    /** @description NHS GNC code */
    // @ApiMember(Description="NHS GNC code", ParameterType="model")
    public nhsGncCode: string;

    public constructor(init?: Partial<MedicalContactV1RequestBase>) { (Object as any).assign(this, init); }
}

export class ResponseBase<T>
{
    // @ApiMember(ExcludeInSchema=true)
    public responseStatus: ResponseStatus;

    /** @description This will be returned when there is a single result available. (e.g. get single object by id) */
    // @ApiMember(Description="This will be returned when there is a single result available. (e.g. get single object by id)")
    public result: T;

    /** @description This will be returned when there is a multiple results available (e.g. search or listing requests). */
    // @ApiMember(Description="This will be returned when there is a multiple results available (e.g. search or listing requests).")
    public results: T[];

    /** @description This will be returned when there is a multiple results available (e.g. search or listing requests). */
    // @ApiMember(Description="This will be returned when there is a multiple results available (e.g. search or listing requests).")
    public total?: number;

    /** @description This will be return the amount of skipped rows when paginating */
    // @ApiMember(Description="This will be return the amount of skipped rows when paginating")
    public skip?: number;

    public constructor(init?: Partial<ResponseBase<T>>) { (Object as any).assign(this, init); }
}

export enum ConnectionState
{
    Available = 'Available',
    Callable = 'Callable',
    Added = 'Added',
    Authorized = 'Authorized',
    Invalid = 'Invalid',
}

export enum IntegrationState
{
    Disabled = 'Disabled',
    NeedsConfiguration = 'NeedsConfiguration',
    Configured = 'Configured',
}

export enum AuthType
{
    Oauth2 = 'Oauth2',
    ApiKey = 'ApiKey',
    Basic = 'Basic',
    Custom = 'Custom',
    None = 'None',
}

export enum OAuthGrantType
{
    AuthorizationCode = 'AuthorizationCode',
    ClientCredentials = 'ClientCredentials',
    Password = 'Password',
}

export enum ConnectionStatus
{
    Live = 'Live',
    Upcoming = 'Upcoming',
    Requested = 'Requested',
}

export enum FormFieldType
{
    Text = 'Text',
    Checkbox = 'Checkbox',
    Tel = 'Tel',
    Email = 'Email',
    Url = 'Url',
    Textarea = 'Textarea',
    Select = 'Select',
    FilteredSelect = 'FilteredSelect',
    MultiSelect = 'MultiSelect',
    Datetime = 'Datetime',
    Date = 'Date',
    Time = 'Time',
    Number = 'Number',
    Password = 'Password',
}

export class Value5Type
{
    public value: string;

    public constructor(init?: Partial<Value5Type>) { (Object as any).assign(this, init); }
}
(Value5Type as unknown)[immerable] = true;

export class Value5
{
    public str?: string;
    public integer?: number;
    public number?: number;
    public type: Value5Type;

    public constructor(init?: Partial<Value5>) { (Object as any).assign(this, init); }
}
(Value5 as unknown)[immerable] = true;

export class SimpleFormFieldOptionValueType
{
    public value: string;

    public constructor(init?: Partial<SimpleFormFieldOptionValueType>) { (Object as any).assign(this, init); }
}
(SimpleFormFieldOptionValueType as unknown)[immerable] = true;

export class SimpleFormFieldOptionValue
{
    public str?: string;
    public integer?: number;
    public number?: number;
    public boolean?: boolean;
    public arrayOfValue5?: Value5[];
    public type: SimpleFormFieldOptionValueType;

    public constructor(init?: Partial<SimpleFormFieldOptionValue>) { (Object as any).assign(this, init); }
}
(SimpleFormFieldOptionValue as unknown)[immerable] = true;

export enum OptionType
{
    Simple = 'Simple',
}

export class SimpleFormFieldOption
{
    public label: string;
    public value?: SimpleFormFieldOptionValue;
    public optionType: OptionType;

    public constructor(init?: Partial<SimpleFormFieldOption>) { (Object as any).assign(this, init); }
}
(SimpleFormFieldOption as unknown)[immerable] = true;

export enum FormFieldOptionGroupOptionType
{
    Group = 'Group',
}

export class FormFieldOptionGroup
{
    public id?: string;
    public label: string;
    public options: SimpleFormFieldOption[] = [];
    public optionType: FormFieldOptionGroupOptionType;

    public constructor(init?: Partial<FormFieldOptionGroup>) { (Object as any).assign(this, init); }
}
(FormFieldOptionGroup as unknown)[immerable] = true;

export class FormFieldOptionType
{
    public value: string;

    public constructor(init?: Partial<FormFieldOptionType>) { (Object as any).assign(this, init); }
}
(FormFieldOptionType as unknown)[immerable] = true;

export class FormFieldOption
{
    public simpleFormFieldOption?: SimpleFormFieldOption;
    public formFieldOptionGroup?: FormFieldOptionGroup;
    public type: FormFieldOptionType;

    public constructor(init?: Partial<FormFieldOption>) { (Object as any).assign(this, init); }
}
(FormFieldOption as unknown)[immerable] = true;

export class FormField
{
    public id?: string;
    public label?: string;
    public placeholder?: string;
    public description?: string;
    public type?: FormFieldType;
    public required?: boolean;
    public customField?: boolean;
    public allowCustomValues?: boolean;
    public disabled?: boolean;
    public hidden?: boolean;
    public deprecated?: boolean;
    public sensitive?: boolean;
    public prefix?: string;
    public suffix?: string;
    public options?: FormFieldOption[];

    public constructor(init?: Partial<FormField>) { (Object as any).assign(this, init); }
}
(FormField as unknown)[immerable] = true;

export enum Target
{
    CustomFields = 'CustomFields',
    Resource = 'Resource',
}

export class ConnectionValue5Type
{
    public value: string;

    public constructor(init?: Partial<ConnectionValue5Type>) { (Object as any).assign(this, init); }
}
(ConnectionValue5Type as unknown)[immerable] = true;

export class ConnectionValue5
{
    public str?: string;
    public integer?: number;
    public number?: number;
    public type: ConnectionValue5Type;

    public constructor(init?: Partial<ConnectionValue5>) { (Object as any).assign(this, init); }
}
(ConnectionValue5 as unknown)[immerable] = true;

export class ConnectionValueType
{
    public value: string;

    public constructor(init?: Partial<ConnectionValueType>) { (Object as any).assign(this, init); }
}
(ConnectionValueType as unknown)[immerable] = true;

export class ConnectionValue
{
    public str?: string;
    public integer?: number;
    public number?: number;
    public boolean?: boolean;
    public arrayOfConnectionValue5?: ConnectionValue5[];
    public type: ConnectionValueType;

    public constructor(init?: Partial<ConnectionValue>) { (Object as any).assign(this, init); }
}
(ConnectionValue as unknown)[immerable] = true;

export class Defaults
{
    public target?: Target;
    public id?: string;
    public options?: FormFieldOption[];
    public value?: ConnectionValue;

    public constructor(init?: Partial<Defaults>) { (Object as any).assign(this, init); }
}
(Defaults as unknown)[immerable] = true;

export class Configuration
{
    public resource?: string;
    public defaults?: Defaults[];

    public constructor(init?: Partial<Configuration>) { (Object as any).assign(this, init); }
}
(Configuration as unknown)[immerable] = true;

export class WebhookSubscription
{
    public downstreamId?: string;
    public unifyEventTypes?: string[];
    public downstreamEventTypes?: string[];
    public executeUrl?: string;
    public createdAt?: string;

    public constructor(init?: Partial<WebhookSubscription>) { (Object as any).assign(this, init); }
}
(WebhookSubscription as unknown)[immerable] = true;

export class CustomMapping
{
    public id?: string;
    public label?: string;
    public description?: string;
    public value?: string;
    public key?: string;
    public required?: boolean;
    public customField?: boolean;
    public consumerId?: string;
    public example?: string;

    public constructor(init?: Partial<CustomMapping>) { (Object as any).assign(this, init); }
}
(CustomMapping as unknown)[immerable] = true;

export enum ConsentState
{
    Implicit = 'Implicit',
    Pending = 'Pending',
    Granted = 'Granted',
    Denied = 'Denied',
    Revoked = 'Revoked',
    RequiresReconsent = 'RequiresReconsent',
}

export enum DataScopesResources2
{
    Wildcard = 'Wildcard',
}

export class DataScopesResourcesType
{
    public value: string;

    public constructor(init?: Partial<DataScopesResourcesType>) { (Object as any).assign(this, init); }
}
(DataScopesResourcesType as unknown)[immerable] = true;

export class DataScopesResources
{
    public mapOfMapOfDataScopesResources1?: { [index:string]: { [index:string]: DataScopesResources1; }; };
    public dataScopesResources2?: DataScopesResources2;
    public type: DataScopesResourcesType;

    public constructor(init?: Partial<DataScopesResources>) { (Object as any).assign(this, init); }
}
(DataScopesResources as unknown)[immerable] = true;

export class ConsentRecord
{
    public id: string;
    public createdAt: string;
    public granted: boolean;
    public resources: DataScopesResources;

    public constructor(init?: Partial<ConsentRecord>) { (Object as any).assign(this, init); }
}
(ConsentRecord as unknown)[immerable] = true;

export class DataScopes
{
    public enabled?: boolean;
    public updatedAt?: string;
    public resources?: DataScopesResources;

    public constructor(init?: Partial<DataScopes>) { (Object as any).assign(this, init); }
}
(DataScopes as unknown)[immerable] = true;

export enum Health
{
    Revoked = 'Revoked',
    MissingSettings = 'MissingSettings',
    NeedsConsent = 'NeedsConsent',
    NeedsAuth = 'NeedsAuth',
    PendingRefresh = 'PendingRefresh',
    Ok = 'Ok',
}

export class Connection
{
    public id?: string;
    public serviceId?: string;
    public name?: string;
    public tagLine?: string;
    public unifiedApi?: string;
    public state?: ConnectionState;
    public integrationState?: IntegrationState;
    public authType?: AuthType;
    public oauthGrantType?: OAuthGrantType;
    public status?: ConnectionStatus;
    public enabled?: boolean;
    public website?: string;
    public icon?: string;
    public logo?: string;
    public authorizeUrl?: string;
    public revokeUrl?: string;
    public settings?: { [index:string]: Object; };
    public metadata?: { [index:string]: Object; };
    public formFields?: FormField[];
    public configuration?: Configuration[];
    public configurableResources?: string[];
    public resourceSchemaSupport?: string[];
    public resourceSettingsSupport?: string[];
    public validationSupport?: boolean;
    public schemaSupport?: boolean;
    public settingsRequiredForAuthorization?: string[];
    public subscriptions?: WebhookSubscription[];
    public hasGuide?: boolean;
    public customMappings?: CustomMapping[];
    public consentState?: ConsentState;
    public consents?: ConsentRecord[];
    public latestConsent?: ConsentRecord;
    public applicationDataScopes?: DataScopes;
    public health?: Health;
    public credentialsExpireAt?: number;
    public lastRefreshFailedAt?: number;
    public createdAt?: number;
    public updatedAt?: number;

    public constructor(init?: Partial<Connection>) { (Object as any).assign(this, init); }
}
(Connection as unknown)[immerable] = true;

export class DigitalPrescriptionDMDResponse
{
    public name: string;
    public productId: BigInteger;

    public constructor(init?: Partial<DigitalPrescriptionDMDResponse>) { (Object as any).assign(this, init); }
}
(DigitalPrescriptionDMDResponse as unknown)[immerable] = true;

export class GPResult
{
    public gncCode: string;
    public name: string;
    public surname: string;
    public forename: string;
    public practiceName: string;
    public practiceOdsCode: string;
    public addressLine1: string;
    public addressLine2: string;
    public town: string;
    public postcode: string;
    public telephone: string;
    public status: string;

    public constructor(init?: Partial<GPResult>) { (Object as any).assign(this, init); }
}
(GPResult as unknown)[immerable] = true;

export class TwilioRoomResponse
{
    public roomId: string;
    public roomName: string;
    public token: string;
    public startDateTime?: string;
    public endDateTime?: string;
    public practitionerName: string;
    public status: number;
    public roomCreated: boolean;
    public videoCode: string;
    public smsEnabled: boolean;

    public constructor(init?: Partial<TwilioRoomResponse>) { (Object as any).assign(this, init); }
}
(TwilioRoomResponse as unknown)[immerable] = true;

export interface IVirtualDirectory
{
}

export interface IVirtualPathProvider
{
    rootDirectory: IVirtualDirectory;
    virtualPathSeparator: string;
    realPathSeparator: string;
}

export interface IVirtualFile
{
    virtualPathProvider: IVirtualPathProvider;
    extension: string;
    length: number;
}

// @Flags()
export enum CacheControl
{
    None = 0,
    Public = 1,
    Private = 2,
    MustRevalidate = 4,
    NoCache = 8,
    NoStore = 16,
    NoTransform = 32,
    ProxyRevalidate = 64,
}

export interface IContentTypeWriter
{
}

// @Flags()
export enum RequestAttributes
{
    None = 0,
    Localhost = 1,
    LocalSubnet = 2,
    External = 4,
    Secure = 8,
    InSecure = 16,
    AnySecurityMode = 24,
    HttpHead = 32,
    HttpGet = 64,
    HttpPost = 128,
    HttpPut = 256,
    HttpDelete = 512,
    HttpPatch = 1024,
    HttpOptions = 2048,
    HttpOther = 4096,
    AnyHttpMethod = 8160,
    OneWay = 8192,
    Reply = 16384,
    AnyCallStyle = 24576,
    Soap11 = 32768,
    Soap12 = 65536,
    Xml = 131072,
    Json = 262144,
    Jsv = 524288,
    ProtoBuf = 1048576,
    Csv = 2097152,
    Html = 4194304,
    Jsonl = 8388608,
    MsgPack = 16777216,
    FormatOther = 33554432,
    AnyFormat = 67076096,
    Http = 67108864,
    MessageQueue = 134217728,
    Tcp = 268435456,
    Grpc = 536870912,
    EndpointOther = 1073741824,
    AnyEndpoint = 2080374784,
    InProcess = -2147483648,
    InternalNetworkAccess = -2147483645,
    AnyNetworkAccessType = -2147483641,
    Any = -1,
}

export interface IRequestPreferences
{
    acceptsBrotli: boolean;
    acceptsDeflate: boolean;
    acceptsGzip: boolean;
}

export interface IHttpFile
{
    name: string;
    fileName: string;
    contentLength: number;
    contentType: string;
    inputStream: string;
}

export interface IRequest
{
    originalRequest: Object;
    response: IResponse;
    operationName: string;
    verb: string;
    requestAttributes: RequestAttributes;
    requestPreferences: IRequestPreferences;
    dto: Object;
    contentType: string;
    isLocal: boolean;
    userAgent: string;
    cookies: { [index:string]: Cookie; };
    responseContentType: string;
    hasExplicitResponseContentType: boolean;
    items: { [index:string]: Object; };
    headers: NameValueCollection;
    queryString: NameValueCollection;
    formData: NameValueCollection;
    useBufferedStream: boolean;
    rawUrl: string;
    absoluteUri: string;
    userHostAddress: string;
    remoteIp: string;
    authorization: string;
    isSecureConnection: boolean;
    acceptTypes: string[];
    pathInfo: string;
    originalPathInfo: string;
    inputStream: string;
    contentLength: number;
    files: IHttpFile[];
    urlReferrer: string;
}

export interface IResponse
{
    originalResponse: Object;
    request: IRequest;
    statusCode: number;
    statusDescription: string;
    contentType: string;
    outputStream: string;
    dto: Object;
    useBufferedStream: boolean;
    isClosed: boolean;
    keepAlive: boolean;
    hasStarted: boolean;
    items: { [index:string]: Object; };
}

export class WorldPayResponse
{
    public success: boolean;
    public errorCode: string;
    public errorMessage: string;
    public pgtr: string;
    public paymentPageUrl: string;
    public authorisationCode: string;

    public constructor(init?: Partial<WorldPayResponse>) { (Object as any).assign(this, init); }
}
(WorldPayResponse as unknown)[immerable] = true;

export class StripeTerminal
{
    public id: string;
    public displayName: string;
    public locationId: string;

    public constructor(init?: Partial<StripeTerminal>) { (Object as any).assign(this, init); }
}
(StripeTerminal as unknown)[immerable] = true;

export class StripeTerminalLocation
{
    public id: string;
    public displayName: string;
    public locationTerminals: StripeTerminal[];
    public hasTerminals: boolean;

    public constructor(init?: Partial<StripeTerminalLocation>) { (Object as any).assign(this, init); }
}
(StripeTerminalLocation as unknown)[immerable] = true;

export class StripeTerminalLocationsResponse
{
    public terminalLocations: StripeTerminalLocation[];

    public constructor(init?: Partial<StripeTerminalLocationsResponse>) { (Object as any).assign(this, init); }
}
(StripeTerminalLocationsResponse as unknown)[immerable] = true;

export class AutopayChargeDateResponse
{
    public chargeDate: string;

    public constructor(init?: Partial<AutopayChargeDateResponse>) { (Object as any).assign(this, init); }
}
(AutopayChargeDateResponse as unknown)[immerable] = true;

export enum AutoPayStatus
{
    InProgress = 'InProgress',
    PaidbyAutoPay = 'PaidbyAutoPay',
    Failed = 'Failed',
    Paid = 'Paid',
}

export class AutoPayResponse
{
    public status: AutoPayStatus;

    public constructor(init?: Partial<AutoPayResponse>) { (Object as any).assign(this, init); }
}
(AutoPayResponse as unknown)[immerable] = true;

export class AddressFindResponse
{
    public id: string;
    public type: string;
    public text: string;
    public highlight: string;
    public description: string;

    public constructor(init?: Partial<AddressFindResponse>) { (Object as any).assign(this, init); }
}
(AddressFindResponse as unknown)[immerable] = true;

export class AddressRetrieveResponse
{
    public id: string;
    public domesticId: string;
    public language: string;
    public languageAlternative: string;
    public department: string;
    public company: string;
    public subBuilding: string;
    public buildingNumber: string;
    public buildingName: string;
    public secondaryStreet: string;
    public street: string;
    public block: string;
    public neighbourhood: string;
    public district: string;
    public city: string;
    public line1: string;
    public line2: string;
    public line3: string;
    public line4: string;
    public line5: string;
    public adminAreaName: string;
    public adminAreaCode: string;
    public province: string;
    public provinceName: string;
    public provinceCode: string;
    public postalCode: string;
    public countryName: string;
    public countryIso2: string;
    public countryIso3: string;
    public countryIsoNumber: string;
    public sortingNumber1: string;
    public sortingNumber2: string;
    public barcode: string;
    public poBoxNumber: string;
    public label: string;
    public type: string;
    public dataLevel: string;

    public constructor(init?: Partial<AddressRetrieveResponse>) { (Object as any).assign(this, init); }
}
(AddressRetrieveResponse as unknown)[immerable] = true;

export class ReminderDataResponse
{
    public id: number;
    public practitionerName: string;
    public appointmentName: string;
    public mobileTelephone: string;
    public customerEmail: string;
    public customerName: string;
    public customerSmsEnabled: boolean;
    public customerGivenConsent: boolean;

    public constructor(init?: Partial<ReminderDataResponse>) { (Object as any).assign(this, init); }
}
(ReminderDataResponse as unknown)[immerable] = true;

export class JsonPermissionResponse
{
    public id: number;
    public shortDescription: string;
    public type: string;
    public level: string;

    public constructor(init?: Partial<JsonPermissionResponse>) { (Object as any).assign(this, init); }
}
(JsonPermissionResponse as unknown)[immerable] = true;

export class JsonPermissionGetResponse
{
    public id: number;
    public shortDescription: string;
    public descriptor: string;
    public jsonPermissions: string[];
    public readOnly: boolean;

    public constructor(init?: Partial<JsonPermissionGetResponse>) { (Object as any).assign(this, init); }
}
(JsonPermissionGetResponse as unknown)[immerable] = true;

export class Permission
{
    public description: string;
    public descriptor: string;
    public hiddenFromNonAdmin: boolean;
    public allowed: string[];
    public revoked: string[];
    public reports: string[];
    public accessablePractitioners: number[];
    public multiDiaryRestricted: boolean;
    public autoLogout: number;

    public constructor(init?: Partial<Permission>) { (Object as any).assign(this, init); }
}
(Permission as unknown)[immerable] = true;

export class JsonPermission implements IHasId, IHasGlobalGuid
{
    public id: number;
    public type: string;
    public permission: Permission;
    public level: string;
    public readOnly: boolean;
    public globalGuid: string;
    // @Ignore()
    public shortDescription: string;

    // @Ignore()
    public descriptor: string;

    // @Ignore()
    public jsonPermissions: string[];

    public constructor(init?: Partial<JsonPermission>) { (Object as any).assign(this, init); }
}
(JsonPermission as unknown)[immerable] = true;

export class UsersSearchResponse
{
    public id: number;
    public name: string;
    public fullName: string;
    public firstName: string;
    public lastName: string;
    public current: boolean;
    public email: string;
    public mobileNumber: string;
    public position: string;
    public locationId: number;
    public locationName: string;
    public practitionerId?: number;
    public migrated?: boolean;
    public accessiblePractitioners: number[];
    public practitionerTitle: string;
    public practitionerForename: string;
    public practitionerSurname: string;
    public departments: number[];
    public permissionId?: number;
    public practitioner: string;
    public globalGuid: string;
    public avatar: string;
    public cloudRxUserCode: string;
    public cloudRxClinicCode: string;

    public constructor(init?: Partial<UsersSearchResponse>) { (Object as any).assign(this, init); }
}
(UsersSearchResponse as unknown)[immerable] = true;

export class UserRoleLocation implements IHasId, IHasGlobalGuid
{
    public id: number;
    public locationId: number;
    // @Ignore()
    public locationGuid: string;

    public userId: number;
    // @Ignore()
    public userGuid: string;

    public roleId: number;
    // @Ignore()
    public roleGuid: string;

    public globalGuid: string;

    public constructor(init?: Partial<UserRoleLocation>) { (Object as any).assign(this, init); }
}
(UserRoleLocation as unknown)[immerable] = true;

export class UserRoleLocationWithDetails extends UserRoleLocation
{
    public userName: string;
    public fullName: string;
    public locationName: string;
    public userType: string;
    public userCurrent: boolean;
    public roleName: string;

    public constructor(init?: Partial<UserRoleLocationWithDetails>) { super(init); (Object as any).assign(this, init); }
}
(UserRoleLocationWithDetails as unknown)[immerable] = true;

export class UserLocationsResponse
{
    public id: number;
    public userId: number;
    public locationId: number;
    public roleId: number;
    public locationName: string;
    public globalGuid: string;

    public constructor(init?: Partial<UserLocationsResponse>) { (Object as any).assign(this, init); }
}
(UserLocationsResponse as unknown)[immerable] = true;

export class BusinessProfileResponse
{
    public id: number;
    public businessName: string;
    public tradingName: string;
    public description: string;
    public termsAndConditions: string;
    public privacyPolicy: string;
    public cancellationPolicy: string;

    public constructor(init?: Partial<BusinessProfileResponse>) { (Object as any).assign(this, init); }
}
(BusinessProfileResponse as unknown)[immerable] = true;

export class ExtractionResponse
{
    public signature: string;
    public creation: string;
    public completion?: string;

    public constructor(init?: Partial<ExtractionResponse>) { (Object as any).assign(this, init); }
}
(ExtractionResponse as unknown)[immerable] = true;

// @DataContract
export class Folder
{
    // @DataMember(Order=1)
    public name: string;

    // @DataMember(Order=2)
    public modifiedDate: string;

    // @DataMember(Order=3)
    public path: string;

    // @DataMember(Order=4)
    public isGlobal: boolean;

    // @DataMember(Order=5)
    public isOverride: boolean;

    public constructor(init?: Partial<Folder>) { (Object as any).assign(this, init); }
}
(Folder as unknown)[immerable] = true;

// @DataContract
export class File
{
    // @DataMember(Order=1)
    public name: string;

    // @DataMember(Order=2)
    public extension: string;

    // @DataMember(Order=3)
    public fileSizeBytes: number;

    // @DataMember(Order=4)
    public createdDate?: string;

    // @DataMember(Order=5)
    public modifiedDate?: string;

    // @DataMember(Order=6)
    public accessedDate?: string;

    // @DataMember(Order=7)
    public path: string;

    // @DataMember(Order=8)
    public isGlobal: boolean;

    // @DataMember(Order=9)
    public isOverride: boolean;

    // @DataMember(Order=10)
    public description: string;

    // @DataMember(Order=11)
    public createdBy: string;

    // @DataMember(Order=12)
    public hasActiveShare: boolean;

    // @DataMember(Order=13)
    public activeShareRecipientCount: number;

    public constructor(init?: Partial<File>) { (Object as any).assign(this, init); }
}
(File as unknown)[immerable] = true;

// @DataContract
export class FolderResult
{
    // @DataMember(Order=1)
    public folders: Folder[];

    // @DataMember(Order=2)
    public files: File[];

    public constructor(init?: Partial<FolderResult>) { (Object as any).assign(this, init); }
}
(FolderResult as unknown)[immerable] = true;

export class CaseImagingResult
{
    public width: number;
    public height: number;
    public src: string;
    public signature: string;

    public constructor(init?: Partial<CaseImagingResult>) { (Object as any).assign(this, init); }
}
(CaseImagingResult as unknown)[immerable] = true;

export class CommandBarResponse
{
    public id: number;
    public reference: string;
    public name: string;
    public description: string;

    public constructor(init?: Partial<CommandBarResponse>) { (Object as any).assign(this, init); }
}
(CommandBarResponse as unknown)[immerable] = true;

export class CommandBarPatientResponse extends CommandBarResponse
{
    public isProvisional: boolean;

    public constructor(init?: Partial<CommandBarPatientResponse>) { super(init); (Object as any).assign(this, init); }
}
(CommandBarPatientResponse as unknown)[immerable] = true;

export class MergeField
{
    public name: string;
    public group: string;
    public value: string;

    public constructor(init?: Partial<MergeField>) { (Object as any).assign(this, init); }
}
(MergeField as unknown)[immerable] = true;

export class MergeFieldResponse
{
    public group: string;
    public fields: MergeField[];

    public constructor(init?: Partial<MergeFieldResponse>) { (Object as any).assign(this, init); }
}
(MergeFieldResponse as unknown)[immerable] = true;

export class BatchMergeDataResponse
{
    public data: Object;
    public template: string;
    public id: number;

    public constructor(init?: Partial<BatchMergeDataResponse>) { (Object as any).assign(this, init); }
}
(BatchMergeDataResponse as unknown)[immerable] = true;

export class ContactMergeCheckResponse
{
    public contactId: number;
    public contactTitle: string;
    public contactForename: string;
    public contactSurname: string;
    public contactBusinessName: string;
    public contactcategory: string;
    public defaultContact: boolean;

    public constructor(init?: Partial<ContactMergeCheckResponse>) { (Object as any).assign(this, init); }
}
(ContactMergeCheckResponse as unknown)[immerable] = true;

export enum svcResponse
{
    Success = 'Success',
    GeneralException = 'GeneralException',
    InvalidClientID = 'InvalidClientID',
    EncryptionError = 'EncryptionError',
    DBError = 'DBError',
    LicenceNotActive = 'LicenceNotActive',
}

export class OdsDiffField
{
    public field: string;
    public stored: string;
    public live: string;

    public constructor(init?: Partial<OdsDiffField>) { (Object as any).assign(this, init); }
}
(OdsDiffField as unknown)[immerable] = true;

export class MedicalContactResponse
{
    public id: number;
    public current?: boolean;
    public defaultContact?: boolean;
    public contactable?: boolean;
    public category: string;
    public title: string;
    public forename: string;
    public surname: string;
    public name: string;
    public businessName: string;
    public relationship: string;
    public address: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public addressLine5: string;
    public mobile: string;
    public postCode: string;
    public telephone: string;
    public altTelephone1: string;
    public altTelephone2: string;
    public fax: string;
    public web: string;
    public email: string;
    public locationId: number;
    public locationName: string;
    public providerNumber: string;
    public hasDocumentSharingPin: boolean;
    public nhsGncCode: string;
    public nhsOdsSyncedAt?: string;
    public hasAlerts: boolean;
    public odsMismatches: OdsDiffField[];

    public constructor(init?: Partial<MedicalContactResponse>) { (Object as any).assign(this, init); }
}
(MedicalContactResponse as unknown)[immerable] = true;

export class GuardDeleteResponse
{
    public cases: number;
    public appointments: number;
    public invoices: number;
    public payments: number;
    public billingItems: number;
    public classes: number;

    public constructor(init?: Partial<GuardDeleteResponse>) { (Object as any).assign(this, init); }
}
(GuardDeleteResponse as unknown)[immerable] = true;

export class GeneralCustomerResponse
{
    public id: number;
    public reference: string;
    public accountingCode: string;
    public forename: string;
    public surname: string;
    public title: string;
    public name: string;
    public gender: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public addressLine5: string;
    public invoiceAddressLine1: string;
    public invoiceAddressLine2: string;
    public invoiceAddressLine3: string;
    public invoiceAddressLine4: string;
    public invoiceAddressLine5: string;
    public invoicePostCode: string;
    public useInvoiceAddress?: boolean;
    public address: string;
    public invoiceAddress: string;
    public groupAddressTo: string;
    public postCode: string;
    public registrationDate?: string;
    public homeTelephone: string;
    public workTelephone: string;
    public mobileTelephone: string;
    public email: string;
    public dateOfBirth?: string;
    public locationId: number;
    public groupId?: number;
    public locationName: string;
    public practitionerId?: number;
    public practitionerEmail: string;
    public practitionerTitle: string;
    public practitionerForename: string;
    public practitionerSurname: string;
    public practitionerName: string;
    public practitionerStatus: number;
    public groupName: string;
    public patientGroup: string;
    public status: number;
    public provisional: boolean;
    public height: number;
    public weight: number;
    public employer: string;
    public niNumber: string;
    public hospitalNumber: string;
    public patientHospitalNumber: string;
    public insuranceNumber: string;
    public initials: string;
    public alternativeRef1: string;
    public groupReference: string;
    public consent: string;
    public category: string;
    public enquiry: string;
    public invoicePeriod: string;
    public balanceInvoiced: number;
    public balanceOwed: number;
    public uninvoicedCharges: number;
    public uninvoicedTotal: number;
    public billTo: string;
    public online?: boolean;
    public smsEnabled?: boolean;
    public sarStatus: string;
    public isHealthcodeEligible: boolean;
    public hasAlerts: boolean;
    public guardDelete: GuardDeleteResponse[];
    public givenConsent?: boolean;
    public emailConsent?: boolean;
    public smsConsent?: boolean;
    public phoneConsent?: boolean;
    public meta: { [index:string]: Object; };
    public cardName: string;
    public lastFourDigits: string;
    public brand: string;
    public expiryMonth?: number;
    public expiryYear?: number;
    public flag: string;
    public irn: string;
    public medicareCardNo: string;
    public dvaNumber: string;
    public accountId: number;
    public accountType: string;
    public tags: string[];
    public overridePayAtClinic: boolean;
    public isBusiness: boolean;
    public emergencyContact: string;
    public emergencyContactName: string;
    public emergencyContactRelationship: string;
    public emergencyContactNumber: string;
    public isRequestingCard: boolean;
    public lastAppointmentDate?: string;

    public constructor(init?: Partial<GeneralCustomerResponse>) { (Object as any).assign(this, init); }
}

export class AlertResponse implements IHasId
{
    public title: string;
    public notes: string;
    public objectId: number;
    public userId?: number;
    public future: boolean;
    public startDateTime: string;
    public flagType?: number;
    public id: number;
    public discriminatorType: string;
    public complete?: boolean;
    public requiresAcknowledgement?: boolean;
    public serviceTypeId?: number;

    public constructor(init?: Partial<AlertResponse>) { (Object as any).assign(this, init); }
}
(AlertResponse as unknown)[immerable] = true;

export class PaymentCard implements IHasId
{
    public id: number;
    public cardObjectID?: number;
    public cardObjectType?: string;
    public cardExpiry: string;
    public cardIssue: string;
    public cardType: string;
    public cardFrom: string;
    public cardSecurity: string;
    public cardNotes: string;
    public cardNumber: string;
    public cardName: string;
    public cardUseAddress?: number;
    public cardAddress1: string;
    public cardAddress2: string;
    public cardAddress3: string;
    public cardAddress4: string;
    public cardPostCode: string;
    public cardVerified?: string;
    public lastFourDigits: string;
    public expiryMonth?: number;
    public expiryYear?: number;
    public brand: string;
    public clearAcceptMerchantId: string;

    public constructor(init?: Partial<PaymentCard>) { (Object as any).assign(this, init); }
}
(PaymentCard as unknown)[immerable] = true;

export class CustomerLiteDto
{
    public id: number;
    public reference: string;
    public forename: string;
    public surname: string;
    public title: string;
    public name: string;
    public address: string;
    public practitionerName: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public addressLine5: string;
    public groupName: string;
    public locationName: string;
    public locationId?: number;
    public groupId?: number;
    public practitionerId?: number;
    public groupAddressTo: string;
    public postCode: string;
    public mobileTelephone: string;
    public email: string;
    public smsEnabled: boolean;
    public dateOfBirth?: string;
    public alerts: AlertResponse[];
    public billTo: string;
    public practitionerForename: string;
    public practitionerSurname: string;
    public cardID?: number;
    public paymentCard: PaymentCard;

    public constructor(init?: Partial<CustomerLiteDto>) { (Object as any).assign(this, init); }
}
(CustomerLiteDto as unknown)[immerable] = true;

export class CustomerBatchConsentResponse
{
    public updated: boolean;

    public constructor(init?: Partial<CustomerBatchConsentResponse>) { (Object as any).assign(this, init); }
}
(CustomerBatchConsentResponse as unknown)[immerable] = true;

export class Customer implements IHasAddressDetails, IHasReference, IHasDocuments
{
    public title: string;
    public forename: string;
    public surname: string;
    public gender: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public addressLine5: string;
    public postCode: string;
    public invoiceAddressLine1: string;
    public invoiceAddressLine2: string;
    public invoiceAddressLine3: string;
    public invoiceAddressLine4: string;
    public invoiceAddressLine5: string;
    public invoicePostCode: string;
    public dateOfBirth?: string;
    public registrationDate?: string;
    public locationId: number;
    public practitionerId?: number;
    public accountId: number;
    public groupId?: number;
    public homeTelephone: string;
    public workTelephone: string;
    public mobileTelephone: string;
    public email: string;
    public reference: string;
    public accountingCode: string;
    public insuranceNumber: string;
    public groupReference: string;
    public smsEnabled: boolean;
    public defaultCharge: string;
    public invoicePeriod: string;
    public status?: number;
    public useInvoiceAddress?: boolean;
    public enquiry: string;
    public category: string;
    public employer: string;
    public height?: number;
    public weight?: number;
    public hospitalNumber: string;
    public patientHospitalNumber: string;
    public niNumber: string;
    public medication: string;
    public previousInjuries: string;
    public alternativeRef1: string;
    public alternativeRef2: string;
    public alternativeRef3: string;
    public alternativeRef4: string;
    public lastAppointmentDate?: string;
    public notes: string;
    public billTo: string;
    public online: boolean;
    public cardNo: string;
    public invoiceFrequency: number;
    public invoiceDeadline?: string;
    public consent: string;
    public groupDepartment: string;
    public id: number;
    public onlineGuid: string;
    public provisional: boolean;
    public givenConsent: boolean;
    public emailConsent: boolean;
    public smsConsent: boolean;
    public phoneConsent: boolean;
    public stripeCustomerId: string;
    public paymentMethodId: string;
    public cardID?: number;
    public tempPaymentMethodId: string;
    public insuranceConsentPaymentMethodId: string;
    public medicareCardNo: string;
    public irn: string;
    public dvaNumber: string;
    public flag: string;
    public documentsLoaded: boolean;
    // @Ignore()
    public documentsSubDirectory: string;

    public squareCustomerId: string;
    public squareCardId: string;
    // @Ignore()
    public name: string;

    public merchantCardId: string;
    public merchantCustomerId: string;
    public merchantCardToken: string;
    public tags: string[];
    public overridePayAtClinic: boolean;
    public isBusiness: boolean;
    public emergencyContactName: string;
    public emergencyContactRelationship: string;
    public emergencyContactNumber: string;
    public creationSource: CreationSource;
    public initials: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<Customer>) { (Object as any).assign(this, init); }
}
(Customer as unknown)[immerable] = true;

export class DupEmailResponse
{
    public consent: boolean;
    public customers: Customer[];
    public patient: Customer;

    public constructor(init?: Partial<DupEmailResponse>) { (Object as any).assign(this, init); }
}
(DupEmailResponse as unknown)[immerable] = true;

export class GeneralCustomerResponseOrdered extends GeneralCustomerResponse
{
    public order: number;

    public constructor(init?: Partial<GeneralCustomerResponseOrdered>) { super(init); (Object as any).assign(this, init); }
}

export class CustomerSaveResponse
{
    public patient: GeneralCustomerResponse;
    public suggested: boolean;
    public result: DupEmailResponse;
    public suggestedPatients: GeneralCustomerResponseOrdered[];

    public constructor(init?: Partial<CustomerSaveResponse>) { (Object as any).assign(this, init); }
}
(CustomerSaveResponse as unknown)[immerable] = true;

export interface IHasAddressDetails
{
    addressLine1: string;
    addressLine2: string;
    addressLine3: string;
    addressLine4: string;
    addressLine5: string;
    postCode: string;
}

export interface IHasDocuments
{
    documentsLoaded: boolean;
    documentsSubDirectory: string;
}

export class ClassTypeResponse
{
    public id: number;
    public name: string;
    public description: string;
    public imageUrl: string;
    public termsAndConditionsFormId: string;
    public colour?: number;
    public defaultSessionLength: number;
    public defaultMinAttendees: number;
    public defaultMaxAttendees: number;
    public isAvailableOnline: boolean;
    public cancellationChargeApplies: boolean;
    public cancellationHours: number;
    public cancellationCreditCharge?: number;
    public isCurrent: boolean;
    public isCourse: boolean;
    public isFavourite: boolean;
    public lateTransferChargeApplies: boolean;
    public lateTransferHours: number;
    public allowPayPerSession: boolean;
    public stockId?: number;
    public stockDesription: string;
    public stockPrice?: number;
    public colourCss: string;
    public packages: ClassPackageResponse[];
    public transferStockId?: number;
    public cancellationStockId?: number;
    public cancellationPrice?: number;
    public serviceTypeId: number;
    public numberOfSessions: number;
    public isVideo: boolean;
    public stockCredits?: number;
    public isPrivateCharge?: boolean;

    public constructor(init?: Partial<ClassTypeResponse>) { (Object as any).assign(this, init); }
}
(ClassTypeResponse as unknown)[immerable] = true;

export class ClassAttendanceResponse
{
    public id: number;
    public attendeeId: number;
    public hasAttended: boolean;
    public dna: boolean;
    public hasBilled: boolean;
    public hasPaid: boolean;
    public sessionId: number;
    public invoiceId?: number;
    public invoiceStatus?: string;
    public billingItemId?: number;
    public prePaidId?: number;
    public prePaymentIncomeId?: number;
    public customer: CustomerLiteDto;
    public customerId?: number;
    public customerForename: string;
    public customerSurname: string;
    public customerName: string;
    public treatmentId?: number;
    public treatmentClosed?: boolean;
    public caseClosed?: boolean;
    public treatmentClosedDate?: string;
    public caseClosedDate?: string;
    public isTemp: boolean;
    public bookingMethod: string;
    public hasCreditAvailable?: boolean;
    public customerEmail: string;
    public customerMobileTelephone: string;
    public customerSMSEnabled: boolean;
    public canCommunicate: boolean;
    public isCancelled: boolean;
    public classTypeId?: number;
    public owesCredit: boolean;
    public billingMode?: ClassBillingMode;

    public constructor(init?: Partial<ClassAttendanceResponse>) { (Object as any).assign(this, init); }
}
(ClassAttendanceResponse as unknown)[immerable] = true;

export class WaitingListWithDetails extends WaitingList
{
    public stockDescription: string;
    public appointmentLength?: number;
    public onlineGuid?: string;
    public classTypeName: string;
    public startDateTime: string;
    public endDateTime: string;
    public appointmentStatus: number;
    public customerTitle: string;
    public customerForename: string;
    public customerSurname: string;
    public customerName: string;
    public mobileTelephone: string;
    public email: string;
    public smsEnabled: boolean;
    public canCommunicate: boolean;
    public appointmentId: number;

    public constructor(init?: Partial<WaitingListWithDetails>) { super(init); (Object as any).assign(this, init); }
}
(WaitingListWithDetails as unknown)[immerable] = true;

export enum DepositPaymentOption
{
    Default = 1,
    NoUpfrontPayment = 2,
    FullDeposit = 3,
    FixedDepositAmount = 4,
    DepositPercentage = 5,
    FreeDepositRequired = 6,
}

export class ClassSessionBaseResponse
{
    public id: number;
    public courseId?: number;
    public startDateTime: string;
    public endDateTime: string;
    public appointmentId: number;
    public classTypeId: number;
    public locationName: string;
    public roomName: string;
    public locationId: number;
    public roomId: number;
    public practitionerId: number;
    public gender: string;
    public practitionerOnlineGuid: string;
    public minAttendees: number;
    public maxAttendees: number;
    public isAvailableOnline?: boolean;
    public type: ClassTypeResponse;
    public attendance: ClassAttendanceResponse[];
    public cancelled: ClassAttendanceResponse[];
    public enrolledCustomerIds: number[];
    public waitingListEnrolled: WaitingListWithDetails[];
    public appointmentStatus: number;
    public practitionerTitle: string;
    public practitionerForename: string;
    public practitionerSurname: string;
    public practitionerName: string;
    public isVideo: boolean;
    public videoMeetingParticipantJoinUrl: string;
    public videoMeetingHostJoinUrl: string;
    public videoMeetingProvider?: VideoMeetingProvider;
    public paymentOption: DepositPaymentOption;
    public paymentOptionValue?: number;

    public constructor(init?: Partial<ClassSessionBaseResponse>) { (Object as any).assign(this, init); }
}
(ClassSessionBaseResponse as unknown)[immerable] = true;

export class TransactionItemResponse
{
    public date?: string;
    public type: string;
    public status: string;
    public amount?: number;
    public displayName: string;

    public constructor(init?: Partial<TransactionItemResponse>) { (Object as any).assign(this, init); }
}
(TransactionItemResponse as unknown)[immerable] = true;

export class CaseSearchResponse
{
    public admissionDate: string;
    public appointmentCount: number;
    public appointmentsWithoutConsultations: number;
    public nextAppointmentDate: string;
    public auth: string;
    public authExpiryDate?: string;
    public bodySite: string;
    public bodySiteText: string;
    public closed: boolean;
    public closedDateTime?: string;
    public customerForename: string;
    public customerId: number;
    public customerSurname: string;
    public customerTitle: string;
    public diagnosis: string;
    public diagnosisCode: string;
    public dischargeDate?: string;
    public dischargeStatus: string;
    public statusText: string;
    public expired: boolean;
    public firstAppointmentId?: number;
    public groupName: string;
    public id: number;
    public incompleteNotes: boolean;
    public location: string;
    public locationId: number;
    public practitionerTitle: string;
    public practitionerForename: string;
    public practitionerSurname: string;
    public practitionerName: string;
    public practitionerId: number;
    public patientName: string;
    public reference: number;
    public restricted?: boolean;
    public statusValue: string;
    public status: number;
    public unclosedConsultations: number;
    public lastConsultationDate?: string;
    public type: string;
    public serviceType: string;
    public hasAlerts: boolean;

    public constructor(init?: Partial<CaseSearchResponse>) { (Object as any).assign(this, init); }
}
(CaseSearchResponse as unknown)[immerable] = true;

export class JoinedContactResponse
{
    public id: number;
    public reference: string;
    public forename: string;
    public surname: string;
    public title: string;
    public email: string;
    public type: string;
    public relationship: string;
    public number: string;
    public name: string;

    public constructor(init?: Partial<JoinedContactResponse>) { (Object as any).assign(this, init); }
}
(JoinedContactResponse as unknown)[immerable] = true;

export class AccountStatementResponse
{
    public id: number;
    public idKey: string;
    public date?: string;
    public ref: string;
    public type: string;
    public location: string;
    public debit: number;
    public credit: number;
    public status: string;
    public reason: string;
    public totalRows?: number;
    public meta: { [index:string]: Object; };

    public constructor(init?: Partial<AccountStatementResponse>) { (Object as any).assign(this, init); }
}
(AccountStatementResponse as unknown)[immerable] = true;

export class GroupAccountStatementResponse
{
    public id: number;
    public reference: string;
    public date?: string;
    public debitAmount?: number;
    public creditAmount?: number;
    public status: string;
    public groupName: string;
    public paymentType: string;
    public transactionType: string;
    public locationName: string;

    public constructor(init?: Partial<GroupAccountStatementResponse>) { (Object as any).assign(this, init); }
}
(GroupAccountStatementResponse as unknown)[immerable] = true;

export class BillingItemsResponse
{
    public id: number;
    public date?: string;
    public description: string;
    public total?: number;
    public accountName: string;
    public groupOrPatientReference: string;
    public isPaid: boolean;
    public invoiceRef: string;
    public paidDate?: string;
    public invoiceId: number;
    public stockType: string;
    public locationName: string;
    public practitionerName: string;
    public totalExVat?: number;
    public quantity?: number;
    public price?: number;
    public vatRate?: number;
    public totalVat?: number;
    public category: string;

    public constructor(init?: Partial<BillingItemsResponse>) { (Object as any).assign(this, init); }
}
(BillingItemsResponse as unknown)[immerable] = true;

export enum PrePaidStatus
{
    Active = 'Active',
    Expired = 'Expired',
    Used = 'Used',
    Removed = 'Removed',
}

export class GroupedPrePaidItems
{
    public id: number;
    public description: string;
    public items: string[];
    public classTypeIds: number[];
    public status: PrePaidStatus;
    public isCourse?: boolean;
    public itemsLeft?: number;
    public itemsUsed?: number;
    public used?: number;
    public totalQuantity?: number;
    public names: string;
    public expires: string;
    public remaining: string;

    public constructor(init?: Partial<GroupedPrePaidItems>) { (Object as any).assign(this, init); }
}
(GroupedPrePaidItems as unknown)[immerable] = true;

export class PrePaidItems
{
    public billingItemId: number;
    public packageId?: string;
    public packageName: string;
    public totalPrice: number;
    public items: GroupedPrePaidItems[];
    public itemIds: number[];
    public date?: string;
    public expiryDate?: string;
    public status: number;
    public totalCredits?: number;
    public creditsRemaining?: number;

    public constructor(init?: Partial<PrePaidItems>) { (Object as any).assign(this, init); }
}
(PrePaidItems as unknown)[immerable] = true;

export class InvoicePaymentsResponse
{
    public id: number;
    public invoiceId: number;
    public refundId?: number;
    public amount?: number;
    public paymentMethod: string;
    public otherPaymentMethod: string;
    public actualPaymentMethod: string;
    public customerId: number;
    public status: string;
    public date?: string;
    public reference: string;
    public lodgementRef: string;
    public paymentId: number;
    public paidBy: string;
    public notes: string;
    public cardType: string;
    public cardNumber: string;
    public expiry: string;
    public chequeNumber: string;
    public migrated?: boolean;
    public paymentAmount?: number;
    public transferred?: string;

    public constructor(init?: Partial<InvoicePaymentsResponse>) { (Object as any).assign(this, init); }
}
(InvoicePaymentsResponse as unknown)[immerable] = true;

export class ClickContactSearchResult
{
    public typeId: number;
    public id: string;
    public title: string;
    public forename: string;
    public surname: string;
    public addR1: string;
    public addR2: string;
    public addR3: string;
    public addR4: string;
    public addR5: string;
    public postcode: string;
    public isMedical: boolean;
    // @Ignore()
    public name: string;

    public category: string;

    public constructor(init?: Partial<ClickContactSearchResult>) { (Object as any).assign(this, init); }
}
(ClickContactSearchResult as unknown)[immerable] = true;

export class ClickCustomerNotesCheckResponse
{
    public caseId?: number;

    public constructor(init?: Partial<ClickCustomerNotesCheckResponse>) { (Object as any).assign(this, init); }
}
(ClickCustomerNotesCheckResponse as unknown)[immerable] = true;

export class Treatment implements IHasId, ICascade
{
    public id: number;
    public caseId: number;
    public appointmentId?: number;
    public dateTime?: string;
    public initials: string;
    public notes: string;
    public length?: number;
    public assessLength: number;
    public cost?: number;
    public locationId?: number;
    public practitionerId?: number;
    public migrated?: boolean;
    public closed?: boolean;
    public closedUser: string;
    public closedDate?: string;
    public scale?: number;
    public measure: string;
    public data: { [index:string]: Object; };
    public meta: { [index:string]: Object; };
    public autoSaved: boolean;
    public templateId: string;
    public highlights: { [index:string]: number[]; };
    public type?: string;
    public createdByUserId?: number;
    public createdDate?: string;
    public lastUpdatedDate?: string;
    public validated?: boolean;

    public constructor(init?: Partial<Treatment>) { (Object as any).assign(this, init); }
}
(Treatment as unknown)[immerable] = true;

export enum CaseStatus
{
    AwaitingFirstAppointment = 1,
    InTreatment = 3,
    OnHold = 7,
    Discharged = 8,
    ClosedButWaitingForReview = 12,
    ClosedAndReviewed = 14,
}

export class AppointmentCaseResponse
{
    public id: number;
    public bodySite: string;
    public admissionDate: string;
    public practitionerId: string;
    public description: string;
    public consultations: Treatment[];
    public dischargeDate?: string;
    public discharged?: boolean;
    public bookingAuditId?: string;
    public status: CaseStatus;
    public firstAppointmentStatus?: number;

    public constructor(init?: Partial<AppointmentCaseResponse>) { (Object as any).assign(this, init); }
}
(AppointmentCaseResponse as unknown)[immerable] = true;

export class OnlineUserPasswordResetResponse
{

    public constructor(init?: Partial<OnlineUserPasswordResetResponse>) { (Object as any).assign(this, init); }
}
(OnlineUserPasswordResetResponse as unknown)[immerable] = true;

export class GenerateOnlineBookingLinkResponse
{

    public constructor(init?: Partial<GenerateOnlineBookingLinkResponse>) { (Object as any).assign(this, init); }
}
(GenerateOnlineBookingLinkResponse as unknown)[immerable] = true;

export class CustomerServiceResponse
{
    public id: number;
    public customerSecurityLevel: number;
    public customerSecurityKeyWord: string;

    public constructor(init?: Partial<CustomerServiceResponse>) { (Object as any).assign(this, init); }
}
(CustomerServiceResponse as unknown)[immerable] = true;

export class PatientLogResponse
{
    public id: number;
    public customerId: number;
    public dateTime: string;
    public entry: string;
    public serviceTypeId?: number;

    public constructor(init?: Partial<PatientLogResponse>) { (Object as any).assign(this, init); }
}
(PatientLogResponse as unknown)[immerable] = true;

export class Patientlog implements IHasId
{
    public id: number;
    public customerId: number;
    public dateTime: string;
    public entry: string;
    public user: number;
    public type: string;
    public activityArea: string;
    public serviceTypeId?: number;
    public linkedObjectType: TimelineLinkedObjectType;
    public linkedObjectId?: number;
    public contextId?: number;
    public context?: TimelineContextObjectType;
    public linkedDocumentId?: string;
    public documentLinkedToObjectType: TimelineLinkedObjectType;
    public documentLinkedToObjectId?: number;

    public constructor(init?: Partial<Patientlog>) { (Object as any).assign(this, init); }
}
(Patientlog as unknown)[immerable] = true;

export class PatientInfoLogResponse implements IPatientInfoResponse
{
    public id: number;
    public responseType: string;
    public date: string;
    public description: string;
    public title: string;
    public pinned: boolean;
    public dateTime: string;
    public entry: string;
    public userName: string;
    public customerId: number;
    public type: string;
    public activityArea: string;
    public serviceTypeId?: number;

    public constructor(init?: Partial<PatientInfoLogResponse>) { (Object as any).assign(this, init); }
}
(PatientInfoLogResponse as unknown)[immerable] = true;

export class Timeline
{
    public id: number;
    public guid?: string;
    public userId: number;
    public userName: string;
    public title: string;
    public body: string;
    public icon: string;
    public isPriority: boolean;
    public requiresAcknowledgement: boolean;
    public colour: string;
    public date?: string;
    public type: TimelineType;
    public subType: string;
    public linkedObjectType: TimelineLinkedObjectType;
    public linkedObjectId?: number;
    public contextObjectType?: TimelineContextObjectType;
    public contextDescription: string;
    public contextId?: number;
    public totalRows: number;
    public documentPath: string;
    public documentName: string;
    public documentFilePath: string;
    public hiddenNote: boolean;

    public constructor(init?: Partial<Timeline>) { (Object as any).assign(this, init); }
}
(Timeline as unknown)[immerable] = true;

export class RoomResponse
{
    public id: number;
    public description: string;
    public locationId: number;
    public locationName: string;
    public status: boolean;
    public colour?: number;
    public hexColour: string;

    public constructor(init?: Partial<RoomResponse>) { (Object as any).assign(this, init); }
}
(RoomResponse as unknown)[immerable] = true;

export class PractitionerLocation
{
    public id: number;
    public practitionerId: number;
    public locationId: number;
    public diaryOrder: number;

    public constructor(init?: Partial<PractitionerLocation>) { (Object as any).assign(this, init); }
}

export class NonWorkingDate implements IHasId
{
    public id: number;
    public date: string;
    public practitionerId: number;
    public title: string;

    public constructor(init?: Partial<NonWorkingDate>) { (Object as any).assign(this, init); }
}
(NonWorkingDate as unknown)[immerable] = true;

export class NonWorkingDateResponse implements IHasId
{
    public id: number;
    public date: string;
    public practitionerId: number;
    public endDate: string;
    public title: string;

    public constructor(init?: Partial<NonWorkingDateResponse>) { (Object as any).assign(this, init); }
}
(NonWorkingDateResponse as unknown)[immerable] = true;

export class DiarySessionResponse
{
    public startDateTime: string;
    public endDateTime: string;
    public locationDescription: string;
    public practitionerDescription: string;
    public roomDescription: string;
    public isSpecialSession: boolean;
    public practitionerId: number;
    public roomId?: number;
    public usedFor: string;
    public locationId: number;
    public hexColour: string;
    public online: boolean;
    public occurrences: string[];
    public id: number;

    public constructor(init?: Partial<DiarySessionResponse>) { (Object as any).assign(this, init); }
}
(DiarySessionResponse as unknown)[immerable] = true;

export class ScheduleSession
{
    public id: number;
    public roomId?: number;
    public type: string;
    public isOnline: boolean;
    public isSpecial: boolean;
    public locationId: number;
    public usedFor: string;
    public hexColour: string;
    public scheduleId: string;
    public practitionerId: number;
    public endDateTime: string;
    public startDateTime: string;
    public dateDiff: number;
    public startTimeMinutes: number;
    public isBatch: boolean;
    public isFirstInBatch: boolean;
    public batchNo: number;
    public multiUsedFor: string[];
    public skillRestrictions: string[];
    public restriction: WorkingTimeRestriction;
    public allowedTags: string[];
    public allowedStockIds: number[];

    public constructor(init?: Partial<ScheduleSession>) { (Object as any).assign(this, init); }
}
(ScheduleSession as unknown)[immerable] = true;

export enum SchedulePrepaymentStatus
{
    Complete = 'Complete',
    Partial = 'Partial',
    None = 'None',
}

export class ScheduleAppointment
{
    public id: number;
    public locationId: number;
    public name: string;
    public authId: number;
    public authLeft: number;
    public startDateTime: string;
    public endDateTime: string;
    public actualStartDateTime: string;
    public actualEndDateTime: string;
    public dateDiff: number;
    public startTimeMinutes: number;
    public scheduleId: string;
    public hexColour: string;
    public type: string;
    public reminderType: string;
    public status: number;
    public subStatus: AppointmentSubStatus;
    public isMulti: boolean;
    public isMultiFirst: boolean;
    public inDebt: boolean;
    public isNew: boolean;
    public isFirstAppointment: boolean;
    public payAtEachAppt: string;
    public comment: string;
    public caseId: number;
    public firstAppointment: boolean;
    public stockDescription: string;
    public meta: { [index:string]: Object; };
    public serviceTypeId?: number;
    public alert: boolean;
    public prontoAuditId?: string;
    public prontoAppointmentId?: string;
    public prontoServiceId?: string;
    public practitionerId: number;
    public roomId?: number;
    public stockId: number;
    public customerId: number;
    public customerReference: string;
    public customerAltRef: string;
    public customerMobileTelephone: string;
    public customerEmail: string;
    public customerSMSEnabled: boolean;
    public customerTitle: string;
    public customerForename: string;
    public customerSurname: string;
    public customerName: string;
    public customerDateOfBirth?: string;
    public customerGender: string;
    public customerStatus?: number;
    public customerRegistrationDate?: string;
    public insuranceNumber: string;
    public groupReference: string;
    public groupId: number;
    public batchNo?: number;
    public isFirstInBatch: boolean;
    public isBatch: boolean;
    public customerIsBusiness: boolean;
    public schedulePrepaymentStatus: SchedulePrepaymentStatus;
    public procedureId?: number;
    public procedureNames: string[];

    public constructor(init?: Partial<ScheduleAppointment>) { (Object as any).assign(this, init); }
}
(ScheduleAppointment as unknown)[immerable] = true;

export class DayNote
{
    public resourceId?: number;
    public note: string;
    public lastModifiedUser: number;
    public lastModified: string;

    public constructor(init?: Partial<DayNote>) { (Object as any).assign(this, init); }
}
(DayNote as unknown)[immerable] = true;

export class Schedule
{
    public id: number;
    public name: string;
    public sessions: { [index:string]: ScheduleSession; };
    public appointments: { [index:string]: ScheduleAppointment; };
    public dayNote: DayNote;

    public constructor(init?: Partial<Schedule>) { (Object as any).assign(this, init); }
}
(Schedule as unknown)[immerable] = true;

export class ScheduleBlock
{
    public count: number;
    public holiday: boolean;
    public keys: string[];
    public values: { [index:string]: Schedule; };

    public constructor(init?: Partial<ScheduleBlock>) { (Object as any).assign(this, init); }
}
(ScheduleBlock as unknown)[immerable] = true;

export class ScheduleResponse
{
    public columns: number;
    public count: number;
    public keys: string[];
    public blocks: { [index:string]: ScheduleBlock; };

    public constructor(init?: Partial<ScheduleResponse>) { (Object as any).assign(this, init); }
}
(ScheduleResponse as unknown)[immerable] = true;

export class DayOverview
{
    public availableHours: number;
    public noOfAppointments: number;
    public noOfClasses: number;
    public noOfMeetings: number;
    public noOfOtherEvents: number;
    public noOfHolidays: number;
    public date: string;
    public nonWorkingDate: boolean;
    public utilizationPercentage: number;
    public noOfCancelled: number;
    public noOfDNA: number;

    public constructor(init?: Partial<DayOverview>) { (Object as any).assign(this, init); }
}
(DayOverview as unknown)[immerable] = true;

export class MonthlyScheduleResponse
{
    public days: DayOverview[];

    public constructor(init?: Partial<MonthlyScheduleResponse>) { (Object as any).assign(this, init); }
}
(MonthlyScheduleResponse as unknown)[immerable] = true;

export class OccurrenceResponse
{
    public occurrences: string[];
    public isLastInBatch: boolean;

    public constructor(init?: Partial<OccurrenceResponse>) { (Object as any).assign(this, init); }
}
(OccurrenceResponse as unknown)[immerable] = true;

export class SaveDayNoteResponse
{
    public success: boolean;

    public constructor(init?: Partial<SaveDayNoteResponse>) { (Object as any).assign(this, init); }
}
(SaveDayNoteResponse as unknown)[immerable] = true;

export interface IHasGlobalGuid
{
    globalGuid: string;
}

export class PaymentResponse extends Income
{
    public accountName: string;
    public smsEnabled: boolean;
    public customerMobileTelephone: string;
    public accountType: string;
    public accountTypeId: number;
    public locationName: string;
    public emailReceipt: boolean;
    public receiptTemplate: string;
    public statusName: string;
    public method: string;
    public accountingSystemPaymentId: string;

    public constructor(init?: Partial<PaymentResponse>) { super(init); (Object as any).assign(this, init); }
}
(PaymentResponse as unknown)[immerable] = true;

export class PaymentsResponse extends PaymentResponse
{
    public invoiceId: number;
    public refundId?: number;
    public paymentAmount?: number;
    public description: string;
    public type: string;
    public debit?: number;
    public credit?: number;
    public customerName: string;
    public remainingAmount?: number;
    public linkedAppointment: AppointmentResponse;

    public constructor(init?: Partial<PaymentsResponse>) { super(init); (Object as any).assign(this, init); }
}
(PaymentsResponse as unknown)[immerable] = true;

export class BillingItemWithNamesExtended extends BillingItemWithNames
{
    public customerReference: string;
    public customerAddressLine1: string;
    public customerAddressLine2: string;
    public customerAddressLine3: string;
    public customerAddressLine4: string;
    public customerAddressLine5: string;
    public customerPostcode: string;
    public customerDateOfBirth?: string;
    public customerGroupReference: string;
    public customerInsuranceNumber: string;
    public customerInitials: string;
    public regNumber: string;

    public constructor(init?: Partial<BillingItemWithNamesExtended>) { super(init); (Object as any).assign(this, init); }
}
(BillingItemWithNamesExtended as unknown)[immerable] = true;

export class BillingItemWithNamesAuth extends BillingItemWithNamesExtended
{
    public authId: number;
    public authCode: string;

    public constructor(init?: Partial<BillingItemWithNamesAuth>) { super(init); (Object as any).assign(this, init); }
}
(BillingItemWithNamesAuth as unknown)[immerable] = true;

export class AccountsExportChargesPreviewResponse
{
    public ledgerCode: string;
    public location: string;
    public amount?: number;
    public exVat?: number;
    public vat?: number;

    public constructor(init?: Partial<AccountsExportChargesPreviewResponse>) { (Object as any).assign(this, init); }
}
(AccountsExportChargesPreviewResponse as unknown)[immerable] = true;

export class AccountsExportPaymentsAlertsResponse
{
    public id: number;
    public date?: string;
    public amount?: number;
    public method: string;
    public reference: string;
    public name: string;
    public locationId: number;

    public constructor(init?: Partial<AccountsExportPaymentsAlertsResponse>) { (Object as any).assign(this, init); }
}
(AccountsExportPaymentsAlertsResponse as unknown)[immerable] = true;

export class AccountsExportPaymentsFilePreviewResponse
{
    public type: string;
    public reference: string;
    public location: string;
    public date?: string;
    public amount?: number;
    public paymentMethod: string;

    public constructor(init?: Partial<AccountsExportPaymentsFilePreviewResponse>) { (Object as any).assign(this, init); }
}
(AccountsExportPaymentsFilePreviewResponse as unknown)[immerable] = true;

export class AccountsExportPaymentsPreviewResponse
{
    public a: AccountsExportPaymentsAlertsResponse[];
    public b: AccountsExportPaymentsFilePreviewResponse[];

    public constructor(init?: Partial<AccountsExportPaymentsPreviewResponse>) { (Object as any).assign(this, init); }
}
(AccountsExportPaymentsPreviewResponse as unknown)[immerable] = true;

export class AccountExportHistoryResponse
{
    public id: number;
    public fromDate: string;
    public toDate: string;
    public type: string;
    public dateTime: string;

    public constructor(init?: Partial<AccountExportHistoryResponse>) { (Object as any).assign(this, init); }
}
(AccountExportHistoryResponse as unknown)[immerable] = true;

export class GroupBillingItemsResponse
{
    public id: number;
    public date?: string;
    public description: string;
    public total?: number;
    public accountName: string;
    public accountsExportId: number;
    public groupOrPatientReference: string;
    public customerInvoicePeriod: string;
    public groupInvoicePeriod: string;
    public invoicePeriod: string;
    public isPaid: boolean;
    public invoiceRef: string;
    public paidDate?: string;
    public invoiceId: number;
    public stockType: string;
    public locationName: string;
    public practitionerName: string;
    public customerName: string;
    public customerId: number;
    public status: string;
    public parentId?: number;
    public totalExVat?: number;
    public groupId?: number;
    public groupName: string;
    public accountingSystemLineItemId: string;
    public accountingSystemCreditNoteId: string;

    public constructor(init?: Partial<GroupBillingItemsResponse>) { (Object as any).assign(this, init); }
}
(GroupBillingItemsResponse as unknown)[immerable] = true;

export class GroupingResponse
{
    public total: number;
    public grouping: ChargeGroup[];

    public constructor(init?: Partial<GroupingResponse>) { (Object as any).assign(this, init); }
}
(GroupingResponse as unknown)[immerable] = true;

export class InvoiceGroupingResponse
{
    public batch: InvoiceBatch;
    public manifest: GroupingResponse[];

    public constructor(init?: Partial<InvoiceGroupingResponse>) { (Object as any).assign(this, init); }
}
(InvoiceGroupingResponse as unknown)[immerable] = true;

export class InvoiceWizardResponse
{
    public invoices: number[];
    public message: string;

    public constructor(init?: Partial<InvoiceWizardResponse>) { (Object as any).assign(this, init); }
}
(InvoiceWizardResponse as unknown)[immerable] = true;

export class DebtsResponse
{
    public id: number;
    public reference: string;
    public date: string;
    public dueDate: string;
    public grandTotal?: number;
    public amountPaid?: number;
    public amountRemaining?: number;
    public debtAge: string;
    public accountTypeName: string;
    public accountName: string;
    public mobileNumber: string;
    public smsEnabled: boolean;
    public status: string;
    public statusName: string;
    public customerId?: number;
    public customerName: string;
    public locationId: number;
    public accountId: number;
    public groupAccountId: number;
    public patientAccountId: number;
    public patientFullName: string;
    public template: string;
    public email: string;
    public paymentCardAvailability: boolean;
    public accountType: string;
    public paymentStatus: string;
    public chargeScheduledDate?: string;

    public constructor(init?: Partial<DebtsResponse>) { (Object as any).assign(this, init); }
}
(DebtsResponse as unknown)[immerable] = true;

export class ExpenditureResponse
{
    public id: number;
    public date: string;
    public description: string;
    public reference: string;
    public amountExVAT?: number;
    public vatRate?: number;
    public vatAmount?: number;
    public total?: number;
    public category: string;
    public supplierId?: number;
    public supplierName: string;
    public expenditureName: string;
    public locationId: number;
    public locationName: string;
    public otherPaymentMethod: string;
    public chequeNumber: string;
    public cardType: string;

    public constructor(init?: Partial<ExpenditureResponse>) { (Object as any).assign(this, init); }
}
(ExpenditureResponse as unknown)[immerable] = true;

export class InvoicesResponse
{
    public id: number;
    public reference: string;
    public date: string;
    public dueDate: string;
    public fullyPaidDate?: string;
    public grandTotal?: number;
    public amountPaid?: number;
    public mobileNumber: string;
    public smsEnabled: boolean;
    public status: string;
    public statusName: string;
    public customerId?: number;
    public locationId: number;
    public accountId: number;
    public patientAccountId: number;
    public healthCodeId?: number;
    public accountType: string;
    public accountTypeId: number;
    public groupAccountId: number;
    public groupName: string;
    public addressTo: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public addressLine5: string;
    public postCode: string;
    public invoiceAddress: string;
    public reminder?: string;
    public secondReminder?: string;
    public mostRecentReminder?: string;
    public notes: string;
    public customerForename: string;
    public customerSurname: string;
    public customerName: string;
    public customerAddress1: string;
    public customerPostCode: string;
    public patientPractitionerId?: number;
    public otherAmountAvailable?: number;
    public locationName: string;
    public billedFrom: string;
    public template: string;
    public email: string;
    public globalId?: string;
    public globalType: number;
    public metadata: ProntoInvoice;
    public paymentCard: PaymentCard;
    public paymentCardAvailability: boolean;
    public meta: { [index:string]: Object; };
    public paymentStatus: string;
    public chargeScheduledDate?: string;
    public medipassStatus: string;
    public purchaseOrderNumber: string;
    public medicalContactId?: number;
    public medicalContactName: string;
    public referralDate?: string;
    public uninvoicedBillingItemCount: number;
    public patientAmountAvailable: number;
    public accountingSystemInvoiceId: string;
    public registrationNumber: string;
    public vehicleId: number;
    public registrationOrigin: string;
    public locked: boolean;
    public existingPaymentsCount: number;
    public groupIsHealthcodeRegistered: boolean;

    public constructor(init?: Partial<InvoicesResponse>) { (Object as any).assign(this, init); }
}
(InvoicesResponse as unknown)[immerable] = true;

export class InvoiceDto
{
    public id: string;

    public constructor(init?: Partial<InvoiceDto>) { (Object as any).assign(this, init); }
}
(InvoiceDto as unknown)[immerable] = true;

export class ProntoInvoiceResponse
{
    public invoice: InvoiceDto;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ProntoInvoiceResponse>) { (Object as any).assign(this, init); }
}
(ProntoInvoiceResponse as unknown)[immerable] = true;

export class InvoiceSummaryResponse
{
    public outstandingAmount: number;
    public totalNet: number;
    public totalExVat: number;
    public totalVat: number;
    public totalPayments: number;
    public totalOtherCredits: number;
    public totalDebits: number;
    public totalDiscounts: number;
    public totalWriteOffs: number;
    public totalCreditNotes: number;
    public totalTransfers: number;
    public subtotal: number;
    public calculatedOutstandingAmount: number;
    public hasMultipleClientCharges: boolean;
    public adjustedVat: number;
    public adjustedExVat: number;

    public constructor(init?: Partial<InvoiceSummaryResponse>) { (Object as any).assign(this, init); }
}
(InvoiceSummaryResponse as unknown)[immerable] = true;

export class InvoicePayment implements IHasId
{
    public id: number;
    public invoiceId?: number;
    public paymentId?: number;
    public refundId?: number;
    public amount?: number;
    public paymentLocationID?: number;

    public constructor(init?: Partial<InvoicePayment>) { (Object as any).assign(this, init); }
}
(InvoicePayment as unknown)[immerable] = true;

export class PaymentReconciliation extends InvoicePayment
{
    public accountId?: number;
    public accountName: string;
    public status: string;
    public date?: string;
    public reference: string;
    public total: number;
    public paymentMethod: string;
    public notes: string;

    public constructor(init?: Partial<PaymentReconciliation>) { super(init); (Object as any).assign(this, init); }
}
(PaymentReconciliation as unknown)[immerable] = true;

export class TransactionResponse
{
    public id: number;
    public type: string;
    public date?: string;
    public description: string;
    public total?: number;
    public totalExVat?: number;
    public totalVat?: number;
    public practitioner: string;
    public practitionerId?: number;
    public customer: string;
    public reference: string;
    public method: string;
    public status: string;
    public paymentId?: number;
    public itemPrice?: number;
    public ledgerCode: string;
    public lodgementRef: string;
    public category: string;
    public accountId?: number;
    public customerId?: number;
    public accountsExportId?: number;
    public locationId: number;
    public invoiceStatus: string;
    public invoiceId?: number;
    public vatRate?: number;
    public invoiceStatusName: string;
    public prontoServiceId?: string;
    public quantity?: number;
    public sequenceNo: number;
    public parentId?: number;
    public discountCodeId?: string;

    public constructor(init?: Partial<TransactionResponse>) { (Object as any).assign(this, init); }
}
(TransactionResponse as unknown)[immerable] = true;

export class InvoiceBatchResponse
{
    public id: number;
    public date: string;

    public constructor(init?: Partial<InvoiceBatchResponse>) { (Object as any).assign(this, init); }
}
(InvoiceBatchResponse as unknown)[immerable] = true;

// @Flags()
export enum EGroupsAccountSearchResponseType
{
    Invoice = 0,
    Payment = 1,
}

// @Flags()
export enum EGroupsAccountSearchResponseStatus
{
    InvoicePaid = 0,
    InvoiceUnpaid = 1,
    InvoicePartPaid = 2,
    InvoiceWrittenOff = 3,
    PaymentReconciled = 4,
    PaymentUnreconciled = 5,
    PaymentPartReconciled = 6,
    PaymentVoided = 7,
}

export class GroupsAccountSearchResponse
{
    public id: number;
    public reference: string;
    public date?: string;
    public customerName: string;
    public customerId?: number;
    public locationId: number;
    public locationName: string;
    public debit?: number;
    public credit?: number;
    public type: EGroupsAccountSearchResponseType;
    public eStatus: EGroupsAccountSearchResponseStatus;

    public constructor(init?: Partial<GroupsAccountSearchResponse>) { (Object as any).assign(this, init); }
}
(GroupsAccountSearchResponse as unknown)[immerable] = true;

export class PaymentDetailsResponse
{
    public refundId?: number;
    public isLocked: boolean;
    public refund?: number;
    public available: number[];
    public reconciled: number[];
    public payment: PaymentResponse;
    public reconciliations: ReconciliationResponse[];
    public linkedAppointment: AppointmentResponse;

    public constructor(init?: Partial<PaymentDetailsResponse>) { (Object as any).assign(this, init); }
}
(PaymentDetailsResponse as unknown)[immerable] = true;

export class RemainingAuths
{
    public id: number;
    public remaining: number;

    public constructor(init?: Partial<RemainingAuths>) { (Object as any).assign(this, init); }
}
(RemainingAuths as unknown)[immerable] = true;

export class CancellationReasonResponse
{
    public appointmentAuthRemaining: RemainingAuths[];

    public constructor(init?: Partial<CancellationReasonResponse>) { (Object as any).assign(this, init); }
}
(CancellationReasonResponse as unknown)[immerable] = true;

export interface IHangfireJobQueueService
{
}

export class QuickBill extends Customer
{
    public formattedName: string;
    public paymentsAvailable: boolean;
    public cardDetails: CardDetails;

    public constructor(init?: Partial<QuickBill>) { super(init); (Object as any).assign(this, init); }
}

export class Group implements IHasId, IHasAddressDetails, IHasGlobalGuid, IHasDocuments
{
    public id: number;
    public name: string;
    public contact: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public addressLine5: string;
    public postCode: string;
    public telephone: string;
    public fax: string;
    public email: string;
    public web: string;
    public accountId?: number;
    // @Ignore()
    public accountGuid?: string;

    public profileId?: number;
    public locationId?: number;
    // @Ignore()
    public locationGuid?: string;

    public showReferrals?: boolean;
    public groupInvoices: string;
    public addressTo: string;
    public invoicePeriod: string;
    public contractNumber: string;
    public invoiceFrequency?: number;
    public invoiceWPID?: number;
    public showVAT?: boolean;
    public authorisationCode: string;
    public defaultMaxTreatments?: number;
    public classification: string;
    public cancellationHours?: number;
    public paysForDNA?: boolean;
    public paysForCancel?: boolean;
    public notificationEmail: string;
    public abbreviationPrefix: string;
    public online?: boolean;
    public globalId: string;
    public accountCode: string;
    public dueDaysOverride?: number;
    public invoiceTemplate: string;
    public onlineGuid: string;
    public tm3InvoiceTemplate: string;
    public invoicePaymentTerms: string;
    public useInvoicePaymentTerms: boolean;
    public groupInvoiceByStockId: boolean;
    public financialAddress: string;
    public medipassFunder: string;
    public medipassFunderCode: string;
    public isVatExempt: boolean;
    public vatExemptionNumber: string;
    public vatExemptionExpiryDate?: string;
    public allowedEmails: string;
    public onlineSettingsId?: number;
    public documentsLoaded: boolean;
    public businessPortalTwoFactorAuthenticationEnabled: boolean;
    public authorisationExpiryInDays?: number;
    public authorisationExpiryTriggerInDays?: number;
    public remainingAuthorisationThreshold?: number;
    // @Ignore()
    public documentsSubDirectory: string;

    // @Ignore()
    public reference: string;

    // @Ignore()
    public globalGuid: string;

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<Group>) { (Object as any).assign(this, init); }
}
(Group as unknown)[immerable] = true;

export class AppointmentAdditionalChargeResponse
{
    public id: number;
    public appointmentId: number;
    public stockId: number;
    public billingItemId?: number;
    public quantity: number;

    public constructor(init?: Partial<AppointmentAdditionalChargeResponse>) { (Object as any).assign(this, init); }
}
(AppointmentAdditionalChargeResponse as unknown)[immerable] = true;

export class PrePaid implements IHasId
{
    public id: number;
    public accountId: number;
    public customerId: number;
    public billingItemId: number;
    public quantity?: number;
    public used?: number;
    public status: PrePaidStatus;
    public prePaidLastUsedOn?: string;
    public expiryDate?: string;

    public constructor(init?: Partial<PrePaid>) { (Object as any).assign(this, init); }
}
(PrePaid as unknown)[immerable] = true;

export class PrePaidLegacy extends PrePaid
{
    public stockId?: number;

    public constructor(init?: Partial<PrePaidLegacy>) { super(init); (Object as any).assign(this, init); }
}
(PrePaidLegacy as unknown)[immerable] = true;

export class PrePaidLinkedCaseDetails
{
    public id: number;
    public bodySite: string;
    public bodySide: string;
    public admissionDate: string;
    public linkedToCurrentAppointment: boolean;

    public constructor(init?: Partial<PrePaidLinkedCaseDetails>) { (Object as any).assign(this, init); }
}
(PrePaidLinkedCaseDetails as unknown)[immerable] = true;

export class PrePaidWithBillingDescription extends PrePaidLegacy
{
    public billingItemDescription: string;
    public billingItemStockId?: number;
    public type: EPrePaidType;
    public billingItemAppointmentId?: number;
    public caseID: number;
    public linkedCaseDetails?: PrePaidLinkedCaseDetails;
    public caseId?: number;

    public constructor(init?: Partial<PrePaidWithBillingDescription>) { super(init); (Object as any).assign(this, init); }
}
(PrePaidWithBillingDescription as unknown)[immerable] = true;

export class GeneralBillingItemResponse extends BillingItem
{
    public accountName: string;
    public practitionerName: string;
    public reference: string;
    public accountType: string;
    public auditId?: string;
    public prontoAppointmentId?: string;
    public apptProntoServiceId?: string;
    public apptStockId?: number;
    public apptBillingItemID?: number;

    public constructor(init?: Partial<GeneralBillingItemResponse>) { super(init); (Object as any).assign(this, init); }
}

export class ProntoServiceStock
{
    public id?: string;
    public name: string;
    public exVat: number;
    public vatRate: number;
    public stockOnlineGuid?: string;
    public overrides: { [index:string]: string; };
    public canBillCXX: boolean;
    public canBillDNA: boolean;
    public cancellationChargeServiceId?: string;
    public dnaChargeServiceId?: string;
    public serviceType: NetworkServiceType;
    public serviceNextAppointmentType: string;

    public constructor(init?: Partial<ProntoServiceStock>) { (Object as any).assign(this, init); }
}
(ProntoServiceStock as unknown)[immerable] = true;

export class InvoiceTemplate
{
    public id: string;
    public type: number;
    public title: string;
    public bookerId: string;
    public template: string;
    public itemTemplate: string;
    public timeStamp: string;

    public constructor(init?: Partial<InvoiceTemplate>) { (Object as any).assign(this, init); }
}
(InvoiceTemplate as unknown)[immerable] = true;

export class ServiceStock extends ServiceCharge
{
    public id?: string;
    public name: string;
    public serviceType: NetworkServiceType;
    public serviceNextAppointmentType: string;
    public stockOnlineGuid?: string;
    public overrides: { [index:string]: string; };

    public constructor(init?: Partial<ServiceStock>) { super(init); (Object as any).assign(this, init); }
}
(ServiceStock as unknown)[immerable] = true;

export class ProntoInvoiceSearchResponse
{
    public invoice: ProntoInvoice;
    public schema: InvoiceTemplate;
    public inventory: ServiceStock[];

    public constructor(init?: Partial<ProntoInvoiceSearchResponse>) { (Object as any).assign(this, init); }
}
(ProntoInvoiceSearchResponse as unknown)[immerable] = true;

export class QuickBillResponse
{
    public appointment: Appointment;
    public customer: QuickBill;
    public group: Group;
    public additionalCharges: AppointmentAdditionalChargeResponse[];
    public stockId: number;
    public ownerPractitionerId: number;
    public filterMode: string;
    public unpaidInvoices: Invoice[];
    public prePaid: PrePaidWithBillingDescription[];
    public uninvoicedBillingItems: GeneralBillingItemResponse[];
    public selfEmployed: boolean;
    public defaultBillTo: number;
    public fee: number;
    public creditFee: number;
    public config: Object;
    public userLocationId?: number;
    public prontoServices: { [index:string]: ProntoServiceStock; };
    public cardDetails: CardDetails;
    public clientSecret: string;
    public paymentMethodId: string;
    public paymentIntentId: string;
    public showMedipass: boolean;
    public isMyClinicIntegration: boolean;
    public prontoInvoiceSearchResponse: ProntoInvoiceSearchResponse;
    public meta: { [index:string]: Object; };
    public failedProntoInvoices: number[];
    public isProntoReferralBooking: boolean;
    public prontoBillToReferrer: boolean;
    public creditAvailable: number;

    public constructor(init?: Partial<QuickBillResponse>) { (Object as any).assign(this, init); }
}
(QuickBillResponse as unknown)[immerable] = true;

export class ResponseEnhancerBase<T>
{
    public db: IClientDbAccess;
    public hangfireJobQueueService: IHangfireJobQueueService;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ResponseEnhancerBase<T>>) { (Object as any).assign(this, init); }
}

export class QuickbillMedipassResponse
{
    public invoiceId: number;

    public constructor(init?: Partial<QuickbillMedipassResponse>) { (Object as any).assign(this, init); }
}
(QuickbillMedipassResponse as unknown)[immerable] = true;

export class AppointmentPrePaidResponse
{

    public constructor(init?: Partial<AppointmentPrePaidResponse>) { (Object as any).assign(this, init); }
}
(AppointmentPrePaidResponse as unknown)[immerable] = true;

export class QuickBillCreatedInvoice
{
    public invoiceId: number;
    public accountId: number;
    public type: QuickPayType;
    public billingEntityId?: number;
    public billingEntityName: string;

    public constructor(init?: Partial<QuickBillCreatedInvoice>) { (Object as any).assign(this, init); }
}
(QuickBillCreatedInvoice as unknown)[immerable] = true;

export class ReferralAttachment
{
    public name: string;
    public extension: string;
    public fileSize: number;
    public dateCreated: string;
    public path: string;

    public constructor(init?: Partial<ReferralAttachment>) { (Object as any).assign(this, init); }
}
(ReferralAttachment as unknown)[immerable] = true;

export class AuditListDto
{
    public auditId: string;
    public id: string;
    public type: number;
    public status: number;
    public message: string;
    public timeStamp: string;
    public metadata: { [index:string]: string; };
    public attachments: ReferralAttachment[];
    public title: string;
    public templateId: string;
    public workflowId?: number;

    public constructor(init?: Partial<AuditListDto>) { (Object as any).assign(this, init); }
}
(AuditListDto as unknown)[immerable] = true;

export class MyClinicInvoiceResponse
{
    public invoice: AuditListDto;
    public appointments: ReferralAppointmentResponse[];

    public constructor(init?: Partial<MyClinicInvoiceResponse>) { (Object as any).assign(this, init); }
}
(MyClinicInvoiceResponse as unknown)[immerable] = true;

export class QuickBillCompleteResponse
{
    public customerInvoiceId?: number;
    public groupInvoiceId?: number;
    public customerPaymentId?: number;
    public customerInDebt?: boolean;
    public groupPaymentId?: number;
    public groupInvoiceTemplate: string;
    public createdInvoices: QuickBillCreatedInvoice[];
    public appointmentAuthRemaining: RemainingAuths[];
    public medipassPaymentInfo: { [index:string]: Object; };
    public showMedipass: boolean;
    public prontoInvoiceResponse: MyClinicInvoiceResponse;

    public constructor(init?: Partial<QuickBillCompleteResponse>) { (Object as any).assign(this, init); }
}
(QuickBillCompleteResponse as unknown)[immerable] = true;

export class GroupServiceTypeOptions implements IHasId, IHasGlobalGuid
{
    public id: number;
    public serviceTypeID: number;
    // @Ignore()
    public serviceTypeGuid: string;

    public groupID: number;
    // @Ignore()
    public groupGuid: string;

    public useAuthCodes?: boolean;
    public useDummyAuthCodes?: boolean;
    public dummyCodePrefix: string;
    public cancelAffectsAuthCount: boolean;
    public dnaAffectsAuthCount: boolean;
    public authCodeGenerateMode: number;
    public authCodeGenerateAssess: number;
    public authCodeGenerateTreat: number;
    public authCodeGenerateAll: number;
    public globalGuid: string;
    public cancelAlwaysAffectsAuthCount: boolean;
    public cancelAffectsAuthCountDays: number;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GroupServiceTypeOptions>) { (Object as any).assign(this, init); }
}
(GroupServiceTypeOptions as unknown)[immerable] = true;

export class GroupResponse
{
    public id: number;
    public name: string;
    public contact: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public addressLine5: string;
    public address: string;
    public postCode: string;
    public telephone: string;
    public fax: string;
    public web: string;
    public email: string;
    public locationId?: number;
    public showReferrals: boolean;
    public groupInvoices: string;
    public addressTo: string;
    public invoicePeriod: string;
    public contractNumber: string;
    public accountCode: string;
    public accountId?: number;
    public accountType: string;
    public profileId?: number;
    public invoiceFrequency?: number;
    public invoiceWPID?: number;
    public showVAT?: boolean;
    public authorisationCode: string;
    public defaultMaxTreatments?: number;
    public classification: string;
    public cancellationHours?: number;
    public paysForDNA?: boolean;
    public paysForCancel?: boolean;
    public notificationEmail: string;
    public abbreviationPrefix: string;
    public online?: boolean;
    public globalId: string;
    public cancelId: number;
    public dnaId: number;
    public hasAlerts: boolean;
    public locationIds: number[];
    public balanceOwed?: number;
    public balanceInvoiced?: number;
    public uninvoicedCharges: number;
    public uninvoicedTotal: number;
    public tm3InvoiceTemplate: string;
    public locationName: string;
    public meta: { [index:string]: Object; };
    public dueDaysOverride?: number;
    public serviceTypes: GroupServiceTypeOptions[];
    public distributorGroupId?: number;
    public isDistributor: boolean;
    public invoicePaymentTerms: string;
    public useInvoicePaymentTerms: boolean;
    public groupInvoiceByStockId: boolean;
    public billDistributor: boolean;
    public healthcodeEnabled: boolean;
    public minorUpperAgeLimit?: number;
    public adolescentUpperAgeLimit?: number;
    public medipassFunder: string;
    public medipassFunderCode: string;
    public isVatExempt: boolean;
    public financialAddress: string;
    public vatExemptionNumber: string;
    public vatExemptionExpiryDate?: string;
    public allowedEmails: string;
    public onlineGuid: string;
    public referralPortalEnabled: boolean;
    public businessPortalTwoFactorAuthenticationEnabled: boolean;
    public childGroups: number[];
    public authorisationExpiryInDays?: number;
    public authorisationExpiryTriggerInDays?: number;
    public remainingAuthorisationThreshold?: number;

    public constructor(init?: Partial<GroupResponse>) { (Object as any).assign(this, init); }
}
(GroupResponse as unknown)[immerable] = true;

export class GroupServiceTypeOptionsResponse
{
    public id: number;
    public serviceTypeID: number;
    public groupID: number;
    public useAuthCodes?: boolean;
    public useDummyAuthCodes?: boolean;
    public dummyCodePrefix: string;
    public groupDefaultAuthCount?: number;
    public nextDummyCode: string;
    public cancelAffectsAuthCount: boolean;
    public dnaAffectsAuthCount: boolean;
    public authCodeGenerateMode: number;
    public authCodeGenerateAssess: number;
    public authCodeGenerateTreat: number;
    public authCodeGenerateAll: number;
    public cancelAlwaysAffectsAuthCount: boolean;
    public cancelAffectsAuthCountDays: number;

    public constructor(init?: Partial<GroupServiceTypeOptionsResponse>) { (Object as any).assign(this, init); }
}
(GroupServiceTypeOptionsResponse as unknown)[immerable] = true;

export class AppointmentEventBase
{
    public id: string;
    public name: string;

    public constructor(init?: Partial<AppointmentEventBase>) { (Object as any).assign(this, init); }
}

export class GroupStockWithRestrictions
{
    public id: string;
    public description: string;
    public practRestrictions: string[];
    public depositLabel: string;
    public serviceTypeId?: number;

    public constructor(init?: Partial<GroupStockWithRestrictions>) { (Object as any).assign(this, init); }
}
(GroupStockWithRestrictions as unknown)[immerable] = true;

export enum HealthcodePolicyLookupOutcome
{
    SingleMatch = 'SingleMatch',
    Ambiguous = 'Ambiguous',
    NoMatch = 'NoMatch',
    Failure = 'Failure',
}

export class HealthcodePolicyLookupResponse
{
    public outcome: HealthcodePolicyLookupOutcome;
    public membershipNumber: string;
    public givenName: string;
    public familyName: string;
    public gender: string;
    public birthDate: string;
    public addressPostcode: string;
    public insurerName: string;
    public policyActive: boolean;
    public expiryDate: string;
    public schemePlan: string;
    public groupId?: number;
    public message: string;

    public constructor(init?: Partial<HealthcodePolicyLookupResponse>) { (Object as any).assign(this, init); }
}
(HealthcodePolicyLookupResponse as unknown)[immerable] = true;

export class BusinessResponse
{
    public name: string;
    public isActive: boolean;
    public id: number;

    public constructor(init?: Partial<BusinessResponse>) { (Object as any).assign(this, init); }
}
(BusinessResponse as unknown)[immerable] = true;

export class HealthcodeSettingsResponse
{
    public groups: BusinessResponse[];
    public username: string;
    public password: string;
    public siteId: string;
    public senderCode: string;

    public constructor(init?: Partial<HealthcodeSettingsResponse>) { (Object as any).assign(this, init); }
}
(HealthcodeSettingsResponse as unknown)[immerable] = true;

export class IscResponse
{
    public id: number;
    public description: string;
    public code: string;

    public constructor(init?: Partial<IscResponse>) { (Object as any).assign(this, init); }
}
(IscResponse as unknown)[immerable] = true;

export class HealthcodeApiCredentialsResponse
{
    public apiKey: string;
    public appId: string;

    public constructor(init?: Partial<HealthcodeApiCredentialsResponse>) { (Object as any).assign(this, init); }
}
(HealthcodeApiCredentialsResponse as unknown)[immerable] = true;

export class ExportIssueBillingItem
{
    public billingItemDate: string;
    public billingItemDescription: string;
    public billingItemTotal: number;
    public locationName: string;
    public problems: string[];

    public constructor(init?: Partial<ExportIssueBillingItem>) { (Object as any).assign(this, init); }
}
(ExportIssueBillingItem as unknown)[immerable] = true;

export class ExportIssueInvoice
{
    public invoiceReference: number;
    public customer: string;
    public problems: string[];
    public billingItems: ExportIssueBillingItem[];
    public problemCount: number;

    public constructor(init?: Partial<ExportIssueInvoice>) { (Object as any).assign(this, init); }
}
(ExportIssueInvoice as unknown)[immerable] = true;

export class ExportIssueResponse
{
    public accountName: string;
    public problemCount: number;
    public invoices: ExportIssueInvoice[];

    public constructor(init?: Partial<ExportIssueResponse>) { (Object as any).assign(this, init); }
}
(ExportIssueResponse as unknown)[immerable] = true;

export class SubmitInvoiceToHealthcodeResponse
{
    public success: boolean;
    public failureReason?: string;

    public constructor(init?: Partial<SubmitInvoiceToHealthcodeResponse>) { (Object as any).assign(this, init); }
}
(SubmitInvoiceToHealthcodeResponse as unknown)[immerable] = true;

export class ExportedInvoiceFileResponse
{
    public name: string;
    public date?: string;

    public constructor(init?: Partial<ExportedInvoiceFileResponse>) { (Object as any).assign(this, init); }
}
(ExportedInvoiceFileResponse as unknown)[immerable] = true;

export class HealthcodeImportSummaryResponse
{
    public account: string;
    public type: string;
    public reference: string;
    public message: string;
    public status: string;

    public constructor(init?: Partial<HealthcodeImportSummaryResponse>) { (Object as any).assign(this, init); }
}
(HealthcodeImportSummaryResponse as unknown)[immerable] = true;

export class HealthcodeExportSummaryResponse
{
    public invoiceReference: number;
    public date: string;
    public location: string;
    public patient: string;
    public total: number;

    public constructor(init?: Partial<HealthcodeExportSummaryResponse>) { (Object as any).assign(this, init); }
}
(HealthcodeExportSummaryResponse as unknown)[immerable] = true;

export class MailChimpLoginResponse
{
    public apiKey: string;
    public username: string;

    public constructor(init?: Partial<MailChimpLoginResponse>) { (Object as any).assign(this, init); }
}
(MailChimpLoginResponse as unknown)[immerable] = true;

export class MailchimpList
{
    public id: string;
    public name: string;
    public status: number;

    public constructor(init?: Partial<MailchimpList>) { (Object as any).assign(this, init); }
}
(MailchimpList as unknown)[immerable] = true;

export class AudiencesResponse
{
    public lists: MailchimpList[];
    public total: number;
    public success: number;
    public error: string;

    public constructor(init?: Partial<AudiencesResponse>) { (Object as any).assign(this, init); }
}
(AudiencesResponse as unknown)[immerable] = true;

export class MailChimpDuplicatesResponse
{
    public customers: { [index:string]: AudienceMember[]; };

    public constructor(init?: Partial<MailChimpDuplicatesResponse>) { (Object as any).assign(this, init); }
}
(MailChimpDuplicatesResponse as unknown)[immerable] = true;

export class PostcodeLookupResponse
{
    public fullAddress: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public addressLine5: string;
    public postCode: string;

    public constructor(init?: Partial<PostcodeLookupResponse>) { (Object as any).assign(this, init); }
}
(PostcodeLookupResponse as unknown)[immerable] = true;

export class CustomListItem
{
    public text: string;
    public order: number;
    public id?: number;
    public inUse: boolean;

    public constructor(init?: Partial<CustomListItem>) { (Object as any).assign(this, init); }
}
(CustomListItem as unknown)[immerable] = true;

export class CustomListItemResponse
{
    public id: number;
    public category: string;
    public values: CustomListItem[];

    public constructor(init?: Partial<CustomListItemResponse>) { (Object as any).assign(this, init); }
}
(CustomListItemResponse as unknown)[immerable] = true;

export class PractitionerGroupResponse
{
    public id: number;
    public groupId: number;
    public providerNo: string;
    public groupName: string;

    public constructor(init?: Partial<PractitionerGroupResponse>) { (Object as any).assign(this, init); }
}
(PractitionerGroupResponse as unknown)[immerable] = true;

export class GroupLocationsResponse
{
    public groupId: number;
    public groupName: string;

    public constructor(init?: Partial<GroupLocationsResponse>) { (Object as any).assign(this, init); }
}
(GroupLocationsResponse as unknown)[immerable] = true;

export class AddPractitionerResponse
{
    public currentPractitioners: number;
    public licensedPractitioners: number;
    public canAddPractitioner: boolean;

    public constructor(init?: Partial<AddPractitionerResponse>) { (Object as any).assign(this, init); }
}
(AddPractitionerResponse as unknown)[immerable] = true;

export class MinimalPractitioner
{
    public id: number;
    public forename: string;
    public surname: string;
    public title: string;
    public name: string;
    public status?: number;
    public serviceTypeId: number;

    public constructor(init?: Partial<MinimalPractitioner>) { (Object as any).assign(this, init); }
}

export class PracStockLoc
{
    public locationName: string;
    public locationId: number;
    public practitionerLocationLocationId: number;
    public practitionerServiceStockFirstStockId: number;
    public practitionerServiceStockFollowupStockId: number;
    public code: string;
    public firstStockDesc: string;
    public followUpStockDesc: string;
    public firstStockRef: string;
    public followUpStockRef: string;
    public firstStockTotalPrice: number;
    public followUpTotalPrice: number;
    public firstStockAppointmentLength: number;
    public followUpStockAppointmentLength: number;
    public firstServiceTypeId: number;
    public followUpServiceTypeId: number;
    public practitionerServiceTypeId: number;

    public constructor(init?: Partial<PracStockLoc>) { (Object as any).assign(this, init); }
}
(PracStockLoc as unknown)[immerable] = true;

export class PractitionerDiaryOrder
{
    public practitionerId: number;
    public name: string;
    public order: number;
    public shortName: string;
    public initials: string;

    public constructor(init?: Partial<PractitionerDiaryOrder>) { (Object as any).assign(this, init); }
}

export class PractitionerDiaryOrderResponse
{
    public locationId: number;
    public orderedPractitioners: PractitionerDiaryOrder[];
    public total: number;

    public constructor(init?: Partial<PractitionerDiaryOrderResponse>) { (Object as any).assign(this, init); }
}

export class SkillResponse
{
    public id: string;
    public name: string;
    public inUse: boolean;

    public constructor(init?: Partial<SkillResponse>) { (Object as any).assign(this, init); }
}
(SkillResponse as unknown)[immerable] = true;

export class UpdateFieldBulkActionResponse
{

    public constructor(init?: Partial<UpdateFieldBulkActionResponse>) { (Object as any).assign(this, init); }
}
(UpdateFieldBulkActionResponse as unknown)[immerable] = true;

export class MyBookingStatsResponse
{
    public allReferrals: number;
    public requireInitialReport: number;
    public uncompletedAppts: number;
    public newAuths: number;
    public needsAction: number;

    public constructor(init?: Partial<MyBookingStatsResponse>) { (Object as any).assign(this, init); }
}
(MyBookingStatsResponse as unknown)[immerable] = true;

export class AllowedReports
{
    public triage?: string;
    public initial?: string;
    public discharge?: string;
    public rfat?: string;

    public constructor(init?: Partial<AllowedReports>) { (Object as any).assign(this, init); }
}
(AllowedReports as unknown)[immerable] = true;

export class BookingAuditResult extends AllowedReports
{
    public id: string;
    public appointmentDate?: string;
    public referralDate?: string;
    public patient: string;
    public location: string;
    public practitioner: string;
    public group: string;
    public prontoStatus: string;
    public appointments: ReferralAppointment[];
    public authorisations: ReferralAuthorisation[];
    public serviceCharges: { [index:string]: ServiceCharge; };
    public canReport: boolean;
    public canInvoice: boolean;
    public hasCharges: boolean;
    public needsAction: boolean;
    public bookerId: string;
    public appointmentId: string;
    public patientId: string;
    public bookingType: string;
    public referralStatus?: number;
    public triageReportName: string;
    public initialReportName: string;
    public rfatReportName: string;
    public dischargeReportName: string;
    public customerForename: string;
    public customerTitle: string;
    public customerSurname: string;
    public customerName: string;
    public practitionerForename: string;
    public practitionerSurname: string;
    public practitionerTitle: string;
    // @Ignore()
    public practitionerName: string;

    public practitionerOnlineGuid: string;
    public workflowId?: number;
    public referencePrefix: string;
    public workflowIdWithReferrerPrefix: string;
    public initialReportSubmissionDueDate?: string;
    public hoursUntilReferralExpires: number;

    public constructor(init?: Partial<BookingAuditResult>) { super(init); (Object as any).assign(this, init); }
}
(BookingAuditResult as unknown)[immerable] = true;

export class LocationDto
{
    public name: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public addressLine5: string;
    public postCode: string;
    public telephone: string;
    public email: string;
    public web: string;
    public fax: string;
    public status: number;
    public onlineGuid: string;
    public fullAddressMultiLine: string;

    public constructor(init?: Partial<LocationDto>) { (Object as any).assign(this, init); }
}
(LocationDto as unknown)[immerable] = true;

export class AttachmentFile
{
    public name: string;
    public extension: string;
    public fileSize: number;
    public dateCreated: string;
    public path: string;

    public constructor(init?: Partial<AttachmentFile>) { (Object as any).assign(this, init); }
}
(AttachmentFile as unknown)[immerable] = true;

export class SingleBookingAuditResponse
{
    public canReport: boolean;
    public canInvoice: boolean;
    public authorisations: number;
    public referrer: string;
    public audit: BookingAuditResponse;
    public reports: AuditListDto[];
    public invoices: AuditListDto[];
    public inventory: ServiceStock[];
    public locations: LocationDto[];
    public practitioners: PractitionerDto[];
    public patient: { [index:string]: string; };
    public defaults: { [index:string]: string; };
    public attachments: AttachmentFile[];
    public appointments: ReferralAppointment[];
    public enableReportWizard: boolean;
    public isAppointmentLocationSelectionDisabled: boolean;
    public linkAppointmentsToReports: boolean;
    public linkInvoicesToReports: boolean;
    public onlyPastAppointmentsComplete: boolean;
    public disableInvoicingAppointmentsInThePast: boolean;
    public referencePrefix: string;
    public workflowIdWithReferrerPrefix: string;
    public referrerAlwaysRequiresAuthorisations: boolean;

    public constructor(init?: Partial<SingleBookingAuditResponse>) { (Object as any).assign(this, init); }
}
(SingleBookingAuditResponse as unknown)[immerable] = true;

export enum ProntoNetworkServiceType
{
    Appointment = 'Appointment',
    Cancellation = 'Cancellation',
    DNA = 'DNA',
}

export class ReferrerDto
{
    public id: string;
    public name: string;

    public constructor(init?: Partial<ReferrerDto>) { (Object as any).assign(this, init); }
}
(ReferrerDto as unknown)[immerable] = true;

export class ProntoClinicalService extends ClinicService
{
    public locations: LocationDto[];
    public practitioners: PractitionerDto[];
    public stock: string;
    public referrers: ReferrerDto[];

    public constructor(init?: Partial<ProntoClinicalService>) { super(init); (Object as any).assign(this, init); }
}
(ProntoClinicalService as unknown)[immerable] = true;

export class ProntoServiceDto
{
    public id: string;
    public name: string;
    public order: number;
    public type: ProntoNetworkServiceType;
    public clinicalService: ProntoClinicalService;

    public constructor(init?: Partial<ProntoServiceDto>) { (Object as any).assign(this, init); }
}
(ProntoServiceDto as unknown)[immerable] = true;

export class ProntoDisciplineDto
{
    public id: string;
    public name: string;
    public networkId: string;
    public description: string;
    public meta: { [index:string]: string; };
    public defaultService?: string;
    public services: ProntoServiceDto[];

    public constructor(init?: Partial<ProntoDisciplineDto>) { (Object as any).assign(this, init); }
}
(ProntoDisciplineDto as unknown)[immerable] = true;

export class ProntoNetworkDto
{
    public id: string;
    public name: string;
    public description: string;
    public disciplines: ProntoDisciplineDto[];

    public constructor(init?: Partial<ProntoNetworkDto>) { (Object as any).assign(this, init); }
}
(ProntoNetworkDto as unknown)[immerable] = true;

export class ServiceDto
{
    public clinicalService: ClinicService;

    public constructor(init?: Partial<ServiceDto>) { (Object as any).assign(this, init); }
}
(ServiceDto as unknown)[immerable] = true;

export class ClinicPractitionerResponse
{
    public name: string;
    public practitionerProntoId: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ClinicPractitionerResponse>) { (Object as any).assign(this, init); }
}
(ClinicPractitionerResponse as unknown)[immerable] = true;

export class MyClinicSummaryResponse
{
    public networks: ProntoNetworkDto[];
    public services: ServiceDto[];
    public referrers: ReferrerDto[];
    public practitioners: ClinicPractitionerResponse[];
    public locations: LocationDto[];
    public hasReferrals: boolean;
    public hasReception: boolean;
    public hasOnline: boolean;
    public referrals: number;
    public reception: number;
    public online: number;
    public dataPoints: { [index:string]: { [index:string]: DataPoint; }; };
    public provisional: boolean;

    public constructor(init?: Partial<MyClinicSummaryResponse>) { (Object as any).assign(this, init); }
}
(MyClinicSummaryResponse as unknown)[immerable] = true;

export class NestedLookupDto
{
    public id: string;
    public name: string;
    public value: string;
    public timeStamp: string;
    public bookerId: string;

    public constructor(init?: Partial<NestedLookupDto>) { (Object as any).assign(this, init); }
}
(NestedLookupDto as unknown)[immerable] = true;

export class SectionDto
{
    public id: string;
    public name: string;
    public body: string;
    public timeStamp: string;
    public bookerId: string;

    public constructor(init?: Partial<SectionDto>) { (Object as any).assign(this, init); }
}
(SectionDto as unknown)[immerable] = true;

export class ReportTemplateDto
{
    public id: string;
    public type: number;
    public enabled: boolean;
    public title: string;
    public reportTemplateType?: string;
    public bookerId: string;
    public template: string;
    public timeStamp: string;
    public lists: { [index:string]: NestedLookupDto; };
    public sections: SectionDto[];
    public mandatoryFieldOverrides: { [index:string]: { [index:string]: boolean; }; };
    public labelOverrides: { [index:string]: { [index:string]: string; }; };
    public customLists: { [index:string]: { [index:string]: string; }; };
    public allowsAttachments: boolean;
    public requiresAttachment: boolean;
    public attachmentPromptText: string;

    public constructor(init?: Partial<ReportTemplateDto>) { (Object as any).assign(this, init); }
}
(ReportTemplateDto as unknown)[immerable] = true;

export class ReportSearchResponse
{
    public report: ReferralReport;
    public schema: ReportTemplateDto;

    public constructor(init?: Partial<ReportSearchResponse>) { (Object as any).assign(this, init); }
}
(ReportSearchResponse as unknown)[immerable] = true;

export class SubmitReportResponse
{
    public report: ReferralReport;
    public invoice: AuditListDto;
    public appointments: ReferralAppointment[];

    public constructor(init?: Partial<SubmitReportResponse>) { (Object as any).assign(this, init); }
}
(SubmitReportResponse as unknown)[immerable] = true;

export class ClickLinkableAppointment extends ReferralAppointment
{
    public description: string;
    public length: number;

    public constructor(init?: Partial<ClickLinkableAppointment>) { super(init); (Object as any).assign(this, init); }
}
(ClickLinkableAppointment as unknown)[immerable] = true;

export class BookingAuthorization
{
    public applicationId: string;
    public bookerId: string;
    public extendedPermissions: { [index:string]: string; };
    public clinicEnabled?: boolean;
    public prontoActivated: boolean;
    public provisionals: boolean;

    public constructor(init?: Partial<BookingAuthorization>) { (Object as any).assign(this, init); }
}
(BookingAuthorization as unknown)[immerable] = true;

export class ClientWhoReceivesBookings implements IHasGuidId
{
    public id: string;
    public provisional: boolean;
    public clientId: string;
    public type: string;
    public name: string;
    public settings: ClinicSettings;
    public authorizations: BookingAuthorization[];
    public prontoPortalLockDate?: string;

    public constructor(init?: Partial<ClientWhoReceivesBookings>) { (Object as any).assign(this, init); }
}
(ClientWhoReceivesBookings as unknown)[immerable] = true;

export enum BookerType
{
    Reception = 'Reception',
    Referrer = 'Referrer',
    Online = 'Online',
    MyClinic = 'MyClinic',
    SysAdmin = 'SysAdmin',
}

export class UserActivations
{
    public userName: string;
    public userRole: string;
    public email: string;
    public displayName: string;
    public loginId: number;
    public enabled: boolean;
    public extendedPermissions: { [index:string]: string; };

    public constructor(init?: Partial<UserActivations>) { (Object as any).assign(this, init); }
}
(UserActivations as unknown)[immerable] = true;

export enum InvoicingMode
{
    Off = 'Off',
    Fixed = 'Fixed',
    Flexable = 'Flexable',
}

export enum ReportingMode
{
    Off = 'Off',
    Bespoke = 'Bespoke',
    Default = 'Default',
}

export class CWBSettings
{
    public slaHours: number;
    public authCodeSessions: number;
    public clinicalDetails: boolean;
    public successURL: string;
    public hiddenFromThirdParties: boolean;
    public defaultNetworkId: string;
    public defaultServices: { [index:string]: string; };
    public overridingClinicReferralCharge: { [index:string]: number; };
    public onlineTitle: string;
    public onlineMessage: string;
    public onlineLogoUrl: string;
    public onlineEmail: string;
    public tempAllowFallbackToGroupCharges: boolean;
    public allInWeekRange?: number;
    public confirmBooking: boolean;
    public sendPatientConfirmationEmail: boolean;
    public patientConfirmationTemplate: string;
    public invoicingMode: InvoicingMode;
    public reportingMode: ReportingMode;
    public sendOwnConfirmations: boolean;
    public referrerCurrency: string;
    public referralExpiryDays: number;

    public constructor(init?: Partial<CWBSettings>) { (Object as any).assign(this, init); }
}
(CWBSettings as unknown)[immerable] = true;

export class ClientWhoBooks implements IHasUsers
{
    public id: string;
    public clientID: string;
    public name: string;
    public title: string;
    public email: string;
    public description: string;
    public type: BookerType;
    public users: UserActivations[];
    public settings: CWBSettings;
    public currentSecret: string;
    public previousSecret: string;
    public enableSignUp: boolean;
    public caseflowUrl: string;
    public isTestReferrer: boolean;
    public disableAppointmentLocationSelection: boolean;
    public canSelectStock: boolean;
    public receivesActivationDeActivationEmails: boolean;
    public linkAppointmentsToReports: boolean;
    public linkInvoicesToReports: boolean;
    public authorization: BookingAuthorization;
    public referencePrefix: string;

    public constructor(init?: Partial<ClientWhoBooks>) { (Object as any).assign(this, init); }
}
(ClientWhoBooks as unknown)[immerable] = true;

export class MyClinicLocationResponse
{
    public responseStatus: ResponseStatus;
    public result: LocationDto[];

    public constructor(init?: Partial<MyClinicLocationResponse>) { (Object as any).assign(this, init); }
}
(MyClinicLocationResponse as unknown)[immerable] = true;

export class MyClinicPractitionerResponse
{
    public result: PractitionerDto[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<MyClinicPractitionerResponse>) { (Object as any).assign(this, init); }
}
(MyClinicPractitionerResponse as unknown)[immerable] = true;

export class GroupListResult
{
    public id: number;
    public name: string;
    public globalId?: string;
    public onlineGuid?: string;

    public constructor(init?: Partial<GroupListResult>) { (Object as any).assign(this, init); }
}
(GroupListResult as unknown)[immerable] = true;

export class MyClinicGroupListResponse
{
    public result: GroupListResult[];

    public constructor(init?: Partial<MyClinicGroupListResponse>) { (Object as any).assign(this, init); }
}
(MyClinicGroupListResponse as unknown)[immerable] = true;

export class MyClinicWhoReceivesBookingsResponse
{
    public clientWhoReceives: ClientWhoReceivesBookings;
    public clientsWhoBook: ClientWhoBooks[];
    public locations: MyClinicLocationResponse;
    public practitioners: MyClinicPractitionerResponse;
    public groups: MyClinicGroupListResponse;

    public constructor(init?: Partial<MyClinicWhoReceivesBookingsResponse>) { (Object as any).assign(this, init); }
}
(MyClinicWhoReceivesBookingsResponse as unknown)[immerable] = true;

export class ProntoNetworkSettingsResponse
{
    public myClinicWhoReceivesBookings: MyClinicWhoReceivesBookingsResponse;
    public networks: ProntoNetworkDto[];
    public stock: ProntoStockDto[];
    public locations: LocationDto[];
    public practitioners: PractitionerDto[];
    public referrers: GroupListResult[];

    public constructor(init?: Partial<ProntoNetworkSettingsResponse>) { (Object as any).assign(this, init); }
}
(ProntoNetworkSettingsResponse as unknown)[immerable] = true;

export class ClientWhoReceivesBookingsResponse extends ClientWhoReceivesBookings
{

    public constructor(init?: Partial<ClientWhoReceivesBookingsResponse>) { super(init); (Object as any).assign(this, init); }
}
(ClientWhoReceivesBookingsResponse as unknown)[immerable] = true;

export class ReportsResponse
{
    public id: string;
    public reportId: string;
    public category: string;
    public name: string;
    public isLive: boolean;
    public description: string;
    public data: string;
    public colour?: number;
    public url: string;
    public isFavourite: boolean;
    public colourCss: string;

    public constructor(init?: Partial<ReportsResponse>) { (Object as any).assign(this, init); }
}
(ReportsResponse as unknown)[immerable] = true;

export class PriceProfileResponse
{
    public id: number;
    public name: string;
    public code: string;
    public json: string;
    public isActive: boolean;
    public createdAt: string;
    public updatedAt: string;

    public constructor(init?: Partial<PriceProfileResponse>) { (Object as any).assign(this, init); }
}
(PriceProfileResponse as unknown)[immerable] = true;

export class PriceProfileLinkedGroupResponse
{
    public id: number;
    public name: string;

    public constructor(init?: Partial<PriceProfileLinkedGroupResponse>) { (Object as any).assign(this, init); }
}
(PriceProfileLinkedGroupResponse as unknown)[immerable] = true;

export class StockWithLocationAndTemplatesResponse extends StockWithLocationResponse
{
    public templateSetId?: number;
    public templateSetName: string;
    public bookingEmail: string;
    public bookingSMS: string;
    public cancellationEmail: string;
    public cancellationSMS: string;
    public reminderEmail: string;
    public reminderSMS: string;

    public constructor(init?: Partial<StockWithLocationAndTemplatesResponse>) { super(init); (Object as any).assign(this, init); }
}
(StockWithLocationAndTemplatesResponse as unknown)[immerable] = true;

export class StockWithLocationAndTemplatesAndOnlineServiceResponse extends StockWithLocationAndTemplatesResponse
{
    public showOnline: boolean;
    public fullDescription: string;
    public imgSrc: string;
    public otherServices: number;
    public linkedServiceId: string;

    public constructor(init?: Partial<StockWithLocationAndTemplatesAndOnlineServiceResponse>) { super(init); (Object as any).assign(this, init); }
}
(StockWithLocationAndTemplatesAndOnlineServiceResponse as unknown)[immerable] = true;

export class StockAtLocationResponse
{
    public id: number;
    public reference: string;
    public totalPrice?: number;
    public priceExVAT?: number;
    public vatAmount?: number;
    public vatRate?: number;
    public itemPrice?: number;
    public description: string;
    public category: string;

    public constructor(init?: Partial<StockAtLocationResponse>) { (Object as any).assign(this, init); }
}
(StockAtLocationResponse as unknown)[immerable] = true;

export class StockOverride implements IHasId, IHasGlobalGuid
{
    public id: number;
    public stockId: number;
    // @Ignore()
    public stockGuid: string;

    public locationId: number;
    // @Ignore()
    public locationGuid: string;

    public priceExVAT: number;
    public totalPrice: number;
    public meta: { [index:string]: string; };
    public globalGuid: string;
    public stockLevel?: number;
    public stockMinimum?: number;
    public paymentOption: number;
    public paymentOptionValue: number;

    public constructor(init?: Partial<StockOverride>) { (Object as any).assign(this, init); }
}
(StockOverride as unknown)[immerable] = true;

export class StockListResponse
{
    public stock: StockWithLocationResponse[];
    public overrides: StockOverride[];

    public constructor(init?: Partial<StockListResponse>) { (Object as any).assign(this, init); }
}
(StockListResponse as unknown)[immerable] = true;

export class StockOnlineCategoryResponse
{
    public id: string;
    public title: string;

    public constructor(init?: Partial<StockOnlineCategoryResponse>) { (Object as any).assign(this, init); }
}
(StockOnlineCategoryResponse as unknown)[immerable] = true;

export class StockWithCategoryResponse
{
    public stock: StockWithLocationResponse;
    public category: OnlineServiceCategory;

    public constructor(init?: Partial<StockWithCategoryResponse>) { (Object as any).assign(this, init); }
}
(StockWithCategoryResponse as unknown)[immerable] = true;

export enum StockInventoryAdjustmentType
{
    Delivery = 'Delivery',
    WriteOff = 'WriteOff',
    Sale = 'Sale',
    Transfer = 'Transfer',
}

export class StockInventoryAdjustmentResponse
{
    public id: number;
    public stockId: number;
    public locationId: number;
    public batchCode: string;
    public expiryDate?: string;
    public quantity: number;
    public adjustmentType: StockInventoryAdjustmentType;
    public createdBy: number;
    public createdDate: string;
    public billingItemId?: number;
    public reason: string;

    public constructor(init?: Partial<StockInventoryAdjustmentResponse>) { (Object as any).assign(this, init); }
}
(StockInventoryAdjustmentResponse as unknown)[immerable] = true;

export class StockInventoryBatchResponse
{
    public id: number;
    public stockId: number;
    public locationId: number;
    public batchCode: string;
    public expiryDate?: string;
    public availableQuantity: number;

    public constructor(init?: Partial<StockInventoryBatchResponse>) { (Object as any).assign(this, init); }
}
(StockInventoryBatchResponse as unknown)[immerable] = true;

export class SupplierResponse
{
    public id: number;
    public reference: string;
    public name: string;
    public contact: string;
    public telephone: string;
    public email: string;
    public address: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public addressLine5: string;
    public postCode: string;
    public accountNo: string;
    public web: string;
    public locationName: string;
    public locationId: number;
    public current: boolean;
    public vatNumber: string;

    public constructor(init?: Partial<SupplierResponse>) { (Object as any).assign(this, init); }
}
(SupplierResponse as unknown)[immerable] = true;

export class AuditResponse
{
    public id: number;
    public objectId: number;
    public objectType: string;
    public objectTypeString: string;
    public action: string;
    public actionString: string;
    public actionDetail: string;
    public dateTime: string;
    public user: string;
    public title: string;
    public forename: string;
    public surname: string;
    public name: string;
    public oldRowData: string;
    public newRowData: string;

    public constructor(init?: Partial<AuditResponse>) { (Object as any).assign(this, init); }
}
(AuditResponse as unknown)[immerable] = true;

export class ServiceTypeResponse
{
    public id: number;
    public name: string;
    public clinicalAccessMode: AccessMode;
    public patientAccessMode: AccessMode;
    public isCurrent: boolean;
    public usesScores: boolean;
    public usesGoals: boolean;
    public usesImages: boolean;
    public labelOverrides: { [index:string]: string; };
    public listOverrides: { [index:string]: string; };
    public configOverrides: { [index:string]: string; };
    public workflowAccessMode: AccessMode;
    public globalGuid: string;

    public constructor(init?: Partial<ServiceTypeResponse>) { (Object as any).assign(this, init); }
}
(ServiceTypeResponse as unknown)[immerable] = true;

export class TagResponse
{
    public id: string;
    public name: string;
    public type: TagEntityType;
    public colour: string;
    public isActive: boolean;
    public isInverted: boolean;
    public showInLists: boolean;

    public constructor(init?: Partial<TagResponse>) { (Object as any).assign(this, init); }
}
(TagResponse as unknown)[immerable] = true;

export class LookupResponse
{
    public id: number;
    public name: string;
    public value: string;
    public niceName: string;
    public values: string[];
    public order: number;

    public constructor(init?: Partial<LookupResponse>) { (Object as any).assign(this, init); }
}
(LookupResponse as unknown)[immerable] = true;

export class SecurityResponse
{
    public roleMap: { [index:number]: number; };
    public roles: { [index:number]: { [index:string]: boolean; }; };
    public editableServiceTypeIds: number[];

    public constructor(init?: Partial<SecurityResponse>) { (Object as any).assign(this, init); }
}
(SecurityResponse as unknown)[immerable] = true;

export class TeamResponse
{
    public id: string;
    public name: string;
    public assignmentCode: string;
    public email: string;
    public defaultTeamLeader: string;
    public defaultTeamLeaderName: string;
    public users: TeamUserDto[];
    public isCurrent: boolean;

    public constructor(init?: Partial<TeamResponse>) { (Object as any).assign(this, init); }
}
(TeamResponse as unknown)[immerable] = true;

export class NestedLookup implements IHasId, IHasGlobalGuid
{
    public id: number;
    public name: string;
    public value: string;
    public alternates: string[];
    public groupId?: number;
    public globalId: string;
    public syncToPronto?: boolean;
    public lastSyncDate?: string;
    public serviceTypeId?: number;
    // @Ignore()
    public serviceTypeGuid?: string;

    // @Ignore()
    public globalGuid: string;

    public constructor(init?: Partial<NestedLookup>) { (Object as any).assign(this, init); }
}
(NestedLookup as unknown)[immerable] = true;

export class DynamicLabelResponse
{
    public id: string;
    public languageSwitch: string;
    public text: string;
    public extraText: string;
    public extraTextType: string;

    public constructor(init?: Partial<DynamicLabelResponse>) { (Object as any).assign(this, init); }
}
(DynamicLabelResponse as unknown)[immerable] = true;

// @Route("/discountcode", "POST, PUT, DELETE")
export class DiscountCodeDto implements IReturn<DiscountCodeWithDiscountValueDto>
{
    public id: string;
    public code: string;
    public description: string;
    public value: number;
    public type: DiscountType;
    public validFrom?: string;
    public validTo?: string;
    public displayText: string;
    public isInUse: boolean;
    public enableForConnect: boolean;
    public enabledForAllServices: boolean;
    public status: DiscountStatus;
    public enforcePatientLimit: boolean;
    public limitPerPatient?: number;
    public applyTo: DiscountApplyTo;
    public restriction: DiscountRestriction;
    public restrictedTags: string[];
    public restrictedStockItems: number[];
    public enableForPackages: boolean;

    public constructor(init?: Partial<DiscountCodeDto>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiscountCodeDto'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DiscountCodeWithDiscountValueDto(); }
}
(DiscountCodeDto as unknown)[immerable] = true;

export class DiscountCodeWithDiscountValueDto extends DiscountCodeDto
{
    public totalExVat: Object;
    public price: Object;
    public total: Object;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DiscountCodeWithDiscountValueDto>) { super(init); (Object as any).assign(this, init); }
}
(DiscountCodeWithDiscountValueDto as unknown)[immerable] = true;

export class EquipmentEntry implements IHasId
{
    public id: number;
    public name: string;
    public model: string;
    public assetTag: string;
    public lastServiced?: string;
    public status: EEquipmentStatus;
    public roomId?: number;
    public locationId?: number;
    public modalityId?: number;
    public notes: string;

    public constructor(init?: Partial<EquipmentEntry>) { (Object as any).assign(this, init); }
}
(EquipmentEntry as unknown)[immerable] = true;

export class CacheResponse
{
    public inventory: { [index:string]: StockWithLocationResponse; };
    public locations: { [index:string]: LocationResponse; };
    public customerLocations: { [index:string]: LocationResponse; };
    public services: { [index:string]: ServiceTypeResponse; };
    public classTypes: { [index:string]: ClassTypeResponse; };
    public rooms: { [index:string]: RoomResponse; };
    public groups: { [index:string]: GroupResponse; };
    public tags: { [index:string]: TagResponse; };
    public practitioners: { [index:string]: GeneralPractitionerResponse; };
    public lookups: { [index:string]: LookupResponse; };
    public permissions: SecurityResponse;
    public practitionerLocations: { [index:string]: PractitionerLocation; };
    public teams: { [index:string]: TeamResponse; };
    public suppliers: { [index:string]: SupplierResponse; };
    public keys: { [index:string]: string; };
    public currentUserId: string;
    public alphabetical: boolean;
    public nestedLookups: { [index:string]: NestedLookup; };
    public dynamicLabels: { [index:string]: DynamicLabelResponse; };
    public skills: { [index:string]: SkillResponse; };
    public discountCodes: { [index:string]: DiscountCodeWithDiscountValueDto; };
    public equipment: { [index:string]: EquipmentEntry; };

    public constructor(init?: Partial<CacheResponse>) { (Object as any).assign(this, init); }
}
(CacheResponse as unknown)[immerable] = true;

export class SingleCacheMapResponse<T>
{
    public version: string;
    public value: { [index:string]: T; };

    public constructor(init?: Partial<SingleCacheMapResponse<T>>) { (Object as any).assign(this, init); }
}

export class LookupCacheResponse extends SingleCacheMapResponse<LookupResponse>
{

    public constructor(init?: Partial<LookupCacheResponse>) { super(init); (Object as any).assign(this, init); }
}
(LookupCacheResponse as unknown)[immerable] = true;

export class SystemDictionary implements IHasId, IHasGlobalGuid
{
    public id: number;
    public key: string;
    public value: string;
    public language: number;
    public visible: number;
    public keyID?: number;
    public globalGuid: string;
    // @Ignore()
    public pluralKey: string;

    // @Ignore()
    public plural: string;

    // @Ignore()
    public possessiveKey: string;

    // @Ignore()
    public possessive: string;

    // @Ignore()
    public pluralPossessiveKey: string;

    // @Ignore()
    public pluralPossessive: string;

    public constructor(init?: Partial<SystemDictionary>) { (Object as any).assign(this, init); }
}
(SystemDictionary as unknown)[immerable] = true;

export class ExtendedNotesResponse
{
    public id: number;
    public type: string;
    public typeId: string;
    public typeGuid: string;
    public title: string;
    public entry: string;
    public lockMode: string;
    public lockValue: number;
    public lastModified: string;
    public date: string;
    public alert: boolean;
    public userName: string;
    public hidden: boolean;
    public serviceTypeId?: number;
    public acknowledgementRequired: boolean;
    public alertStartDate?: string;
    public alertExpiryDate?: string;
    public crmSyncWarning: string;

    public constructor(init?: Partial<ExtendedNotesResponse>) { (Object as any).assign(this, init); }
}
(ExtendedNotesResponse as unknown)[immerable] = true;

export class ExtendedNotes implements IHasId
{
    public id: number;
    public onlineGuid: string;
    public type: string;
    public typeId?: number;
    public icon: string;
    public colour: string;
    public title: string;
    public entry: string;
    public lockMode: string;
    public lockValue: number;
    public lastModified: string;
    public alert: boolean;
    public lastUserId: number;
    public typeGuid?: string;
    public serviceTypeId?: number;
    public acknowledgementRequired: boolean;
    public alertStartDate?: string;
    public alertExpiryDate?: string;
    public contextObjectType?: TimelineContextObjectType;
    public contextId?: number;
    public linkedObjectType: TimelineLinkedObjectType;
    public linkedObjectId?: number;
    public noteType: string;
    public printOnDocument: boolean;
    public linkedObjectDate?: string;

    public constructor(init?: Partial<ExtendedNotes>) { (Object as any).assign(this, init); }
}
(ExtendedNotes as unknown)[immerable] = true;

export class ExtendedNotesWithUserName extends ExtendedNotes
{
    public userName: string;
    public fullName: string;
    public roleLevel: string;
    // @Ignore()
    public hidden: boolean;

    public constructor(init?: Partial<ExtendedNotesWithUserName>) { super(init); (Object as any).assign(this, init); }
}
(ExtendedNotesWithUserName as unknown)[immerable] = true;

export class NestedLookupResponse
{
    public id: number;
    public name: string;
    public value: string;
    public alternates: string[];
    public groupId?: number;
    public globalId: string;
    public syncToPronto?: boolean;
    public lastSyncDate?: string;
    public serviceTypeId?: number;

    public constructor(init?: Partial<NestedLookupResponse>) { (Object as any).assign(this, init); }
}
(NestedLookupResponse as unknown)[immerable] = true;

export class RegionalLookup implements IHasId, IHasGlobalGuid
{
    public id: number;
    public country: string;
    public city: string;
    public region: string;
    public globalGuid: string;

    public constructor(init?: Partial<RegionalLookup>) { (Object as any).assign(this, init); }
}
(RegionalLookup as unknown)[immerable] = true;

export enum SystemNotificationType
{
    Information = 'Information',
    Warning = 'Warning',
    Error = 'Error',
    Success = 'Success',
}

export enum SystemNotificationObjectType
{
    General = 'General',
    Tasks = 'Tasks',
    Stock = 'Stock',
}

export class SystemNotification implements IHasId
{
    public id: number;
    public title: string;
    public message: string;
    public userId?: number;
    public requireDismiss?: boolean;
    public type: SystemNotificationType;
    public objectType: SystemNotificationObjectType;
    public objectId?: number;
    public objectGuid?: string;
    public url: string;
    public read?: boolean;
    public expiryDate?: string;
    public createdDate?: string;
    public priority?: number;

    public constructor(init?: Partial<SystemNotification>) { (Object as any).assign(this, init); }
}
(SystemNotification as unknown)[immerable] = true;

export class SystemNotificationResponse extends SystemNotification
{
    public notify: boolean;

    public constructor(init?: Partial<SystemNotificationResponse>) { super(init); (Object as any).assign(this, init); }
}
(SystemNotificationResponse as unknown)[immerable] = true;

export class SecurityStat
{
    public requestName: string;
    public routes: string[];
    public methods: string[];
    public security: string[];
    public implemented: boolean;
    public hasIReturn: boolean;
    public isAuthenticated: boolean;

    public constructor(init?: Partial<SecurityStat>) { (Object as any).assign(this, init); }
}
(SecurityStat as unknown)[immerable] = true;

export class TaskChecklistSummary
{
    public totalItems: number;
    public completedItems: number;

    public constructor(init?: Partial<TaskChecklistSummary>) { (Object as any).assign(this, init); }
}
(TaskChecklistSummary as unknown)[immerable] = true;

export class TaskResponse
{
    public id: number;
    public createdDate?: string;
    public dueDate?: string;
    public description: string;
    public longDescription: string;
    public status: string;
    public userId?: number;
    public teamId?: string;
    public teamName: string;
    public reminder?: boolean;
    public priority?: boolean;
    public createdUserId: number;
    public dateCompleted?: string;
    public patientId: number;
    public customerTitle: string;
    public customerForename: string;
    public customerSurname: string;
    public targetType: string;
    public targetId?: number;
    public targetContext: string;
    public originKey: string;
    public taskKind: string;
    public checklistSummary: TaskChecklistSummary;
    public patientName: string;
    public private?: boolean;
    public tags: string[];
    public fullName: string;
    public createdByName: string;
    public completedByUserId?: number;
    public completedByName: string;

    public constructor(init?: Partial<TaskResponse>) { (Object as any).assign(this, init); }
}
(TaskResponse as unknown)[immerable] = true;

export class UserRoleLocationWithUserName extends UserRoleLocation
{
    public userName: string;
    public type: string;
    public current?: boolean;

    public constructor(init?: Partial<UserRoleLocationWithUserName>) { super(init); (Object as any).assign(this, init); }
}
(UserRoleLocationWithUserName as unknown)[immerable] = true;

export class TaskSidebarCountsResponse
{
    public shortcutCounts: { [index:string]: number; };

    public constructor(init?: Partial<TaskSidebarCountsResponse>) { (Object as any).assign(this, init); }
}
(TaskSidebarCountsResponse as unknown)[immerable] = true;

export class TrialStatusDto
{
    public scope: string;
    public limitMinutes: number;
    public limitSeconds: number;
    public usedSeconds: number;
    public remainingSeconds: number;
    public exhausted: boolean;
    public upgraded: boolean;
    public trialStartedAt?: string;
    public subscriptionStatus: string;
    public canAuthoriseUpgrade: boolean;
    public trialExpiresAt?: string;
    public expiryDays?: number;

    public constructor(init?: Partial<TrialStatusDto>) { (Object as any).assign(this, init); }
}
(TrialStatusDto as unknown)[immerable] = true;

export class UpgradeResultDto
{
    public status: string;
    public plan: string;
    public activatedAt: string;

    public constructor(init?: Partial<UpgradeResultDto>) { (Object as any).assign(this, init); }
}
(UpgradeResultDto as unknown)[immerable] = true;

export class RequestUpgradeResponse
{
    public success: boolean;
    public notifiedCount: number;
    public message: string;

    public constructor(init?: Partial<RequestUpgradeResponse>) { (Object as any).assign(this, init); }
}
(RequestUpgradeResponse as unknown)[immerable] = true;

export class AiSummaryStatusDto
{
    public enabled: boolean;
    public licensed: boolean;
    public allocated: boolean;
    public paid: boolean;
    public trialAvailable: boolean;
    public monthlyLimit: number;
    public monthlyUsed: number;
    public monthlyRemaining: number;
    public trialExhausted: boolean;
    public canAuthoriseUpgrade: boolean;
    public monthResetsAt: string;

    public constructor(init?: Partial<AiSummaryStatusDto>) { (Object as any).assign(this, init); }
}
(AiSummaryStatusDto as unknown)[immerable] = true;

export class BatchTranscriptSegmentDto
{
    public text: string;
    public confidence?: number;
    public language: string;
    public durationMs?: number;
    public providerSpeakerId: string;

    public constructor(init?: Partial<BatchTranscriptSegmentDto>) { (Object as any).assign(this, init); }
}
(BatchTranscriptSegmentDto as unknown)[immerable] = true;

export class BatchTranscriptionResultDto
{
    public correlationId: string;
    public status: string;
    public failureReason: string;
    public segments: BatchTranscriptSegmentDto[];

    public constructor(init?: Partial<BatchTranscriptionResultDto>) { (Object as any).assign(this, init); }
}
(BatchTranscriptionResultDto as unknown)[immerable] = true;

export class TranscriptionTicketResultDto
{
    public wsUrl: string;
    public ticket: string;
    public correlationId: string;
    public expiresInSeconds: number;

    public constructor(init?: Partial<TranscriptionTicketResultDto>) { (Object as any).assign(this, init); }
}
(TranscriptionTicketResultDto as unknown)[immerable] = true;

export class TaskChecklistItemDto
{
    public id: number;
    public taskId: number;
    public text: string;
    public isDone: boolean;
    public doneAt?: string;
    public doneByUserId?: number;
    public sortOrder: number;
    public stepType: string;
    public stepPayloadJson: string;

    public constructor(init?: Partial<TaskChecklistItemDto>) { (Object as any).assign(this, init); }
}
(TaskChecklistItemDto as unknown)[immerable] = true;

export class TaskChecklistTemplateDto
{
    public id: number;
    public name: string;
    public description: string;
    public taskDescription: string;
    public taskKind: string;
    public isActive: boolean;
    public createdDate?: string;
    public createdUserId?: number;
    public updatedDate?: string;
    public updatedUserId?: number;
    public steps: TaskChecklistTemplateStepDto[];

    public constructor(init?: Partial<TaskChecklistTemplateDto>) { (Object as any).assign(this, init); }
}
(TaskChecklistTemplateDto as unknown)[immerable] = true;

export class TaskChecklistAutoRuleDto
{
    public id: number;
    public name: string;
    public triggerType: string;
    public caseStatus?: number;
    public appointmentStockId?: number;
    public assignmentStrategy: string;
    public assignmentUserId?: number;
    public assignmentTeamId?: string;
    public assignmentWorkType: string;
    public dueDateMode: string;
    public dueDaysOffset?: number;
    public taskPriority?: boolean;
    public sendReminder?: boolean;
    public isActive: boolean;
    public createdDate?: string;
    public createdUserId?: number;
    public updatedDate?: string;
    public updatedUserId?: number;
    public templateIds: number[];

    public constructor(init?: Partial<TaskChecklistAutoRuleDto>) { (Object as any).assign(this, init); }
}
(TaskChecklistAutoRuleDto as unknown)[immerable] = true;

export class TaskChecklistRecurringRuleDto
{
    public id: number;
    public name: string;
    public taskDescription: string;
    public templateId?: number;
    public intervalType: string;
    public weeklyDayOfWeek?: number;
    public monthlyMode: string;
    public monthlyDayOfMonth?: number;
    public dueTime: string;
    public startDate?: string;
    public endDate?: string;
    public isActive: boolean;
    public createdDate?: string;
    public createdUserId?: number;
    public updatedDate?: string;
    public updatedUserId?: number;
    public userIds: number[];

    public constructor(init?: Partial<TaskChecklistRecurringRuleDto>) { (Object as any).assign(this, init); }
}
(TaskChecklistRecurringRuleDto as unknown)[immerable] = true;

export class ProcedureResponse
{
    public id: number;
    public name: string;
    public code: string;
    public bodyPart: string;
    public connectDisplayName: string;
    public locationIds: number[];
    public modalityId?: number;
    public stockItemId?: number;
    public stockItemName: string;
    public durationMinutes?: number;

    public constructor(init?: Partial<ProcedureResponse>) { (Object as any).assign(this, init); }
}
(ProcedureResponse as unknown)[immerable] = true;

export class ScoresGoalsSettingsResponse
{
    public id: number;
    public type: string;
    public name: string;
    public max?: number;
    public min?: number;
    public enabled: boolean;
    public inUse: boolean;

    public constructor(init?: Partial<ScoresGoalsSettingsResponse>) { (Object as any).assign(this, init); }
}
(ScoresGoalsSettingsResponse as unknown)[immerable] = true;

export class DnsInfo
{
    public valid: boolean;
    public type: string;
    public host: string;
    public data: string;

    public constructor(init?: Partial<DnsInfo>) { (Object as any).assign(this, init); }
}
(DnsInfo as unknown)[immerable] = true;

export class DomainAuthenticationStatusResponse
{
    public id: number;
    public user_id: number;
    public subdomain: string;
    public domain: string;
    public valid: boolean;
    public dns: { [index:string]: DnsInfo; };

    public constructor(init?: Partial<DomainAuthenticationStatusResponse>) { (Object as any).assign(this, init); }
}
(DomainAuthenticationStatusResponse as unknown)[immerable] = true;

export class AuthenticateDomainResponse
{
    public id: number;
    public user_id: number;
    public subdomain: string;
    public domain: string;
    public username: string;

    public constructor(init?: Partial<AuthenticateDomainResponse>) { (Object as any).assign(this, init); }
}
(AuthenticateDomainResponse as unknown)[immerable] = true;

export class ValidationModel
{
    public valid: boolean;
    public reason: string;

    public constructor(init?: Partial<ValidationModel>) { (Object as any).assign(this, init); }
}
(ValidationModel as unknown)[immerable] = true;

export class ValidateDomainResponse
{
    public id: number;
    public valid: boolean;
    public validation_results: { [index:string]: ValidationModel; };

    public constructor(init?: Partial<ValidateDomainResponse>) { (Object as any).assign(this, init); }
}
(ValidateDomainResponse as unknown)[immerable] = true;

// @Flags()
export enum LocationStatus
{
    Active = 0,
    ActiveViewOnly = 1,
    InactiveHidden = 2,
}

export class StockReorder
{
    public location: string;
    public locationStatus: LocationStatus;
    public stockDescription: string;
    public stockReference: string;
    public priceEXVAT?: number;
    public vatRate?: number;
    public vatAmount?: number;
    public totalPrice?: number;
    public costPrice?: number;
    public minimumLevel: number;
    public currentLevel: number;
    public stockStatus: string;
    public reorder: string;
    public supplier: string;

    public constructor(init?: Partial<StockReorder>) { (Object as any).assign(this, init); }
}
(StockReorder as unknown)[immerable] = true;

export class StockSales
{
    public stockDescription: string;
    public stockReference: string;
    public priceEXVAT: number;
    public vatRate: number;
    public vatAmount: number;
    public totalPrice: number;
    public quantity: number;
    public chargeTotal: number;
    public chargeDate: string;
    public stockLocation: string;
    public ageGrouping: string;

    public constructor(init?: Partial<StockSales>) { (Object as any).assign(this, init); }
}
(StockSales as unknown)[immerable] = true;

export class InvoiceAnalysisReport
{
    public invoiceLocation: string;
    public invoiceReference: string;
    public accountName: string;
    public customerForename: string;
    public customerSurname: string;
    public accountType: string;
    public invoiceDate?: string;
    public totalEXVAT: number;
    public vatAmount: number;
    public invoiceGrandTotal: number;
    public amountPaid: number;
    public remaining: number;
    public fullyPaidDate?: string;
    public invoiceStatus: string;
    public patientsOnInvoice: string;
    public practitionersOnInvoice: string;
    public practitionerStatus: number;
    public locationStatus: LocationStatus;
    public invoicePurchaseOrderNumber: string;

    public constructor(init?: Partial<InvoiceAnalysisReport>) { (Object as any).assign(this, init); }
}
(InvoiceAnalysisReport as unknown)[immerable] = true;

export class IncomeAnalysisReport
{
    public incomeLocation: string;
    public practitionerStatus: number;
    public locationStatus: LocationStatus;
    public accountName: string;
    public customerForename: string;
    public customerSurname: string;
    public accountType: string;
    public incomeReference: string;
    public lodgementReference: string;
    public incomeDate: string;
    public incomeAmount: number;
    public amountUsed: number;
    public remaining: number;
    public incomeOtherPaymentMethod: string;
    public incomeStatus: string;
    public associatedInvoices: string;
    public associatedPractitioners: string;

    public constructor(init?: Partial<IncomeAnalysisReport>) { (Object as any).assign(this, init); }
}
(IncomeAnalysisReport as unknown)[immerable] = true;

export class ExpenditureMonthSummary
{
    public year?: number;
    public monthNumber?: number;
    public month: string;
    public totalExpenditure: number;

    public constructor(init?: Partial<ExpenditureMonthSummary>) { (Object as any).assign(this, init); }
}
(ExpenditureMonthSummary as unknown)[immerable] = true;

export class ExpenditureAnalysisReportDto
{
    public expenditureCategory: string;
    public expenditureOtherPaymentMethod: string;
    public supplierName: string;
    public expenditureDate?: string;
    public expenditureReference: string;
    public description: string;
    public expenditureAmountExVAT?: number;
    public expenditureVATRate?: number;
    public expenditureVATAmount?: number;
    public expenditureTotal?: number;

    public constructor(init?: Partial<ExpenditureAnalysisReportDto>) { (Object as any).assign(this, init); }
}
(ExpenditureAnalysisReportDto as unknown)[immerable] = true;

export class AgedDebtors
{
    public accountName: string;
    public invoiceStatus: string;
    public invoiceStatusName: string;
    public invoiceGrandTotal?: number;
    public invoiceAmountPaid?: number;
    public invoiceAmountOutstanding?: number;
    public invoiceAge: number;
    public ageCategory: string;
    public invoiceReference: string;
    public accountType: string;
    public accountAddressLine1: string;
    public accountAddressLine2: string;
    public accountAddressLine3: string;
    public accountAddressLine4: string;
    public accountAddressLine5: string;
    public customerAddress: string;
    public accountPostCode: string;
    public invoiceDate?: string;
    public month: string;
    public year: string;
    public patientReference: string;
    public patientName: string;
    public customerForename: string;
    public customerSurname: string;
    public patientAge: number;
    public ageGrouping: string;
    public accountBalanceInvoiced: number;
    public locationName: string;
    public locationStatus: LocationStatus;
    public patientOnInvoice: string;

    public constructor(init?: Partial<AgedDebtors>) { (Object as any).assign(this, init); }
}
(AgedDebtors as unknown)[immerable] = true;

export class DebtorsByAccount
{
    public locationId: number;
    public locationStatus: LocationStatus;
    public accountLocation: string;
    public accountName: string;
    public invoiceStatus: string;
    public invoiceStatusName: string;
    public invoiceGrandTotal: number;
    public invoiceReference: string;
    public accountType: string;
    public accountTypeName: string;
    public accountAddressLine1: string;
    public accountAddressLine2: string;
    public accountAddressLine3: string;
    public accountAddressLine4: string;
    public accountAddressLine5: string;
    public customerAddress: string;
    public accountPostCode: string;
    public amountPaid: number;
    public invoiceDate?: string;
    public month: string;
    public year: string;
    public patientReference: string;
    public patientId?: number;
    public customerTitle: string;
    public customerForename: string;
    public customerSurname: string;
    public patientName: string;
    public accountBalanceInvoiced: number;
    public accountId: number;
    public accountDetails: string;
    public balanceText: string;
    public patientAge: number;
    public ageGrouping: string;
    public singlePatient: boolean;
    public invoiceAmountLeft: number;
    public patientOnInvoice: string;

    public constructor(init?: Partial<DebtorsByAccount>) { (Object as any).assign(this, init); }
}
(DebtorsByAccount as unknown)[immerable] = true;

export class DebtorsOnADate
{
    public accountID?: number;
    public accountingDate?: string;
    public accountingType: string;
    public accountType: string;
    public accountName: string;
    public accountTypeName: string;
    public ageGrouping: string;
    public daysInDebt?: number;
    public groupID?: number;
    public groupName: string;
    public incomeID: number;
    public incomeReference: string;
    public invoiceDescription: string;
    public invoiceID?: number;
    public invoiceStatusOnDate: string;
    public itemDate?: string;
    public date?: string;
    public dob?: string;
    public itemReference: string;
    public locationID?: number;
    public locationName: string;
    public locationStatus: LocationStatus;
    public patientAge: number;
    public patientName: string;
    public customerForename: string;
    public customerSurname: string;
    public customerReference: string;
    public paymentAmount?: number;
    public remaining?: number;
    public total?: number;
    public tType: string;

    public constructor(init?: Partial<DebtorsOnADate>) { (Object as any).assign(this, init); }
}
(DebtorsOnADate as unknown)[immerable] = true;

export class ChargesAnalysisReport
{
    public billingItemId: number;
    public accountId: number;
    public invoiceId?: number;
    public invoiceDate?: string;
    public stockId?: number;
    public chargeLocation: string;
    public billingItemDate: string;
    public billingItemLedgerCode: string;
    public patientName: string;
    public customerID: number;
    public customerForename: string;
    public customerSurname: string;
    public billedTo: string;
    public accountType: string;
    public chargeDescription: string;
    public billingItemCategory: string;
    public chargeQuantity: number;
    public totalExVat: number;
    public totalVAT: number;
    public chargeTotal: number;
    public deliveredByPractitionerId?: number;
    public soldByUserId?: number;
    public soldByName: string;
    public isPackageLine: boolean;
    public isSingleLine: boolean;
    public practitionerTitle: string;
    public practitionerForename: string;
    public practitionerSurname: string;
    public practitionerName: string;
    public practitionerStatus: number;
    public locationStatus: LocationStatus;
    public commissionType: string;
    public commissionValue: number;
    public stockReference: string;
    public invoiceReference: string;
    public authCode: string;

    public constructor(init?: Partial<ChargesAnalysisReport>) { (Object as any).assign(this, init); }
}
(ChargesAnalysisReport as unknown)[immerable] = true;

export class PractitionerAvailabilityReport
{
    public locationId: number;
    public location: string;
    public practitionerName: string;
    public totalSessionTime: number;
    public meetingDuration: number;
    public otherDuration: number;
    public holidayDuration: number;
    public completedAppointmentDuration: number;
    public cancelledAppointmentsDuration: number;
    public dnaAppointmentsDuration: number;
    public weekBeginning: string;
    public monthNumber: number;
    public year: number;
    public monthName: string;
    public actualAvailableTime: number;
    public completedClassesDuration: number;
    public diaryUtilisation: number;

    public constructor(init?: Partial<PractitionerAvailabilityReport>) { (Object as any).assign(this, init); }
}
(PractitionerAvailabilityReport as unknown)[immerable] = true;

export class PractitionerAvailabilityReportResponse
{
    public results: PractitionerAvailabilityReport[];
    public totals: { [index:string]: number; };
    public total: number;

    public constructor(init?: Partial<PractitionerAvailabilityReportResponse>) { (Object as any).assign(this, init); }
}
(PractitionerAvailabilityReportResponse as unknown)[immerable] = true;

export class AdmissionsAnalysisReport
{
    public admissionCode: string;
    public admissionDate: string;
    public referralDate?: string;
    public ageGrouping: string;
    public bodySite: string;
    public customerCategory: string;
    public customerContact: string;
    public customerHomeTelephone: string;
    public customerWorkTelephone: string;
    public customerMobileTelephone: string;
    public customerEmail: string;
    public customerDateOfBirth: string;
    public customerId: number;
    public customerName: string;
    public medicalContact: string;
    public locationName: string;
    public contactTitle: string;
    public contactForename: string;
    public contactSurname: string;
    public customerTitle: string;
    public customerForename: string;
    public customerSurname: string;
    public diagnosisCode: string;
    public groupId: number;
    public locationId: number;
    public groupName: string;
    public id: number;
    public practitionerId: number;
    public practitionerForename: string;
    public practitionerSurname: string;
    public practitionerName: string;
    public practitionerTitle: string;
    public reference?: number;

    public constructor(init?: Partial<AdmissionsAnalysisReport>) { (Object as any).assign(this, init); }
}
(AdmissionsAnalysisReport as unknown)[immerable] = true;

export class AverageTreatmentsReport
{
    public grouping: string;
    public locationId: number;
    public location: string;
    public totalCases: number;
    public totalTreatments: number;
    public averageTreatments: number;
    public averageDaysSpan: number;

    public constructor(init?: Partial<AverageTreatmentsReport>) { (Object as any).assign(this, init); }
}
(AverageTreatmentsReport as unknown)[immerable] = true;

export class AverageTreatmentsReportResponse
{
    public results: AverageTreatmentsReport[];
    public total: number;
    public totals: { [index:string]: number; };

    public constructor(init?: Partial<AverageTreatmentsReportResponse>) { (Object as any).assign(this, init); }
}
(AverageTreatmentsReportResponse as unknown)[immerable] = true;

export class CasesDueForReviewReport
{
    public locationName: string;
    public locationId: number;
    public caseReference: string;
    public customerReference: string;
    public clientName: string;
    public customerTitle: string;
    public customerForename: string;
    public customerSurname: string;
    public addressLine1: string;
    public postCode: string;
    public diagnosisCode: string;
    public dischargeDate?: string;
    public reviewDate?: string;
    public admissionDate?: string;
    public numberOfAppointments: number;
    public practitionerTitle: string;
    public practitionerForename: string;
    public practitionerSurname: string;
    public practitionerName: string;
    public practitionerId: number;
    public customerMobileTelephone: string;
    public customerHomeTelephone: string;
    public customerWorkTelephone: string;
    public customerContact: string;

    public constructor(init?: Partial<CasesDueForReviewReport>) { (Object as any).assign(this, init); }
}
(CasesDueForReviewReport as unknown)[immerable] = true;

export class CurrentCaseLoadReport
{
    public id: number;
    public admissionDate: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public addressLine5: string;
    public postCode: string;
    public diagnosisCode: string;
    public bodySite: string;
    public appointmentType: string;
    public customerAddress: string;
    public customerForename: string;
    public customerName: string;
    public customerSurname: string;
    public customerTitle: string;
    public customerEmail: string;
    public customerMobileTelephone: string;
    public customerHomeTelephone: string;
    public customerWorkTelephone: string;
    public customerContact: string;
    public groupName: string;
    public locationName: string;
    public locationId: number;
    public practitionerForename: string;
    public practitionerName: string;
    public practitionerSurname: string;
    public practitionerTitle: string;
    public practitionerId: number;
    public reference: string;
    public bookingMethod: string;
    public lastAppointmentDate?: string;

    public constructor(init?: Partial<CurrentCaseLoadReport>) { (Object as any).assign(this, init); }
}
(CurrentCaseLoadReport as unknown)[immerable] = true;

export class CurrentCaseLoadReportResponse
{
    public results: CurrentCaseLoadReport[];
    public total: number;
    public totals: { [index:string]: number; };

    public constructor(init?: Partial<CurrentCaseLoadReportResponse>) { (Object as any).assign(this, init); }
}
(CurrentCaseLoadReportResponse as unknown)[immerable] = true;

export class DischargeAnalysisReport
{
    public locationId?: number;
    public location: string;
    public admissionDate: string;
    public dischargeDate?: string;
    public referralDate?: string;
    public totalAppointments: string;
    public bodySite: string;
    public admissionCode: string;
    public diagnosisCode: string;
    public injuryCause: string;
    public dateOfBirth: string;
    public caseRef: string;
    public surname: string;
    public title: string;
    public forename: string;
    public customerName: string;
    public customerId?: number;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public addressLine5: string;
    public customerAddress: string;
    public mobile: string;
    public work: string;
    public home: string;
    public customerContact: string;
    public customerEmail: string;
    public postCode: string;
    public caseReferenceId?: number;
    public groupName: string;
    public clientRef: string;
    public ageGrouping: string;
    public practitionerTitle: string;
    public practitionerForename: string;
    public practitionerSurname: string;
    public practitionerName: string;

    public constructor(init?: Partial<DischargeAnalysisReport>) { (Object as any).assign(this, init); }
}
(DischargeAnalysisReport as unknown)[immerable] = true;

export class DischargeAnalysisReportResponse
{
    public results: DischargeAnalysisReport[];
    public totals: { [index:string]: number; };

    public constructor(init?: Partial<DischargeAnalysisReportResponse>) { (Object as any).assign(this, init); }
}
(DischargeAnalysisReportResponse as unknown)[immerable] = true;

export class LapsedPatientsReport
{
    public groupName: string;
    public locationName: string;
    public locationId: number;
    public practitionerTitle: string;
    public practitionerForename: string;
    public practitionerSurname: string;
    public practitionerName: string;
    public practitionerId: number;
    public admissionDate: string;
    public caseReference: string;
    public customerId: number;
    public customerTitle: string;
    public customerForename: string;
    public customerSurname: string;
    public clientName: string;
    public email: string;
    public mobileTelephone: string;
    public homeTelephone: string;
    public workTelephone: string;
    public customerContact: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public addressLine5: string;
    public customerReference: string;
    public customerAddress: string;
    public postCode: string;
    public diagnosisCode: string;
    public dischargeDate?: string;
    public bodySite: string;
    public myProperty: number;
    public lastAppointment?: string;
    public remainingAuthorisation: string;
    public authExpiryDate?: string;

    public constructor(init?: Partial<LapsedPatientsReport>) { (Object as any).assign(this, init); }
}
(LapsedPatientsReport as unknown)[immerable] = true;

export class ClientAnalysisReport
{
    public registeredLocation: string;
    public patientReference: string;
    public patientName: string;
    public customerForename: string;
    public customerSurname: string;
    public customerEmail: string;
    public mobile: string;
    public work: string;
    public home: string;
    public customerContact: string;
    public gender: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public addressLine5: string;
    public customerAddress: string;
    public patientPostCode: string;
    public patientDateOfBirth?: string;
    public customerRegistrationDate?: string;
    public ageGrouping: string;
    public practitionerTitle: string;
    public practitionerForename: string;
    public practitionerSurname: string;
    public practitionerName: string;
    public practitionerStatus: number;
    public locationStatus: LocationStatus;
    public patientGroup: string;
    public enquirySource: string;
    public futureBookedAppointments?: number;
    public futureBookedAppointmentsText: string;
    public customerGivenConsent: boolean;
    public customerSMSConsent: boolean;
    public customerEmailConsent: boolean;
    public customerPhoneConsent: boolean;

    public constructor(init?: Partial<ClientAnalysisReport>) { (Object as any).assign(this, init); }
}
(ClientAnalysisReport as unknown)[immerable] = true;

export class ClientAnalysisResponse
{
    public results: ClientAnalysisReport[];
    public totals: { [index:string]: number; };

    public constructor(init?: Partial<ClientAnalysisResponse>) { (Object as any).assign(this, init); }
}
(ClientAnalysisResponse as unknown)[immerable] = true;

export class ClientBirthdayReport
{
    public registeredLocation: string;
    public dateOfBirth?: string;
    public ageAsOfToday?: number;
    public patientReference: string;
    public patientName: string;
    public customerForename: string;
    public customerSurname: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public addressLine5: string;
    public customerAddress: string;
    public patientPostCode: string;
    public patientEmail: string;
    public mobile: string;
    public work: string;
    public home: string;
    public customerContact: string;
    public lastAppointmentDate?: string;
    public locationStatus: LocationStatus;

    public constructor(init?: Partial<ClientBirthdayReport>) { (Object as any).assign(this, init); }
}
(ClientBirthdayReport as unknown)[immerable] = true;

export class ClientTrackingReport
{
    public ageGrouping: string;
    public appointmentClassification: string;
    public appointmentDate?: string;
    public appointmentLocation: string;
    public appointmentStatus: string;
    public appointmentType: string;
    public chargeCreated: string;
    public chargeTotal?: number;
    public futureAppointment: string;
    public futureAppointmentDate: string;
    public hasFutureAppointment: string;
    public patientName: string;
    public customerForename: string;
    public customerSurname: string;
    public customerID: number;
    public customerMobileTelephone: string;
    public customerHomeTelephone: string;
    public customerWorkTelephone: string;
    public customerContact: string;
    public customerEmail: string;
    public patientReference: string;
    public patientStatus: string;
    public practitioner: string;
    public practitionerStatus: number;
    public locationStatus: LocationStatus;
    public practitionerName: string;
    public stockDescription: string;

    public constructor(init?: Partial<ClientTrackingReport>) { (Object as any).assign(this, init); }
}
(ClientTrackingReport as unknown)[immerable] = true;

export class ClientTrackingResponse
{
    public results: ClientTrackingReport[];
    public totals: { [index:string]: number; };

    public constructor(init?: Partial<ClientTrackingResponse>) { (Object as any).assign(this, init); }
}
(ClientTrackingResponse as unknown)[immerable] = true;

export class ClickReferrerImagePath
{
    public name: string;
    public path: string;

    public constructor(init?: Partial<ClickReferrerImagePath>) { (Object as any).assign(this, init); }
}
(ClickReferrerImagePath as unknown)[immerable] = true;

export class QuickStartWizardGroupResponse
{
    public id: number;
    public name: string;
    public email: string;
    public showReferrals: boolean;
    public useAuthCode: boolean;

    public constructor(init?: Partial<QuickStartWizardGroupResponse>) { (Object as any).assign(this, init); }
}
(QuickStartWizardGroupResponse as unknown)[immerable] = true;

export class QuickStartWizardPractitionerResponse
{
    public id: number;
    public email: string;
    public title: string;
    public forename: string;
    public surname: string;
    public gender: string;
    public isActive: boolean;
    public mobile: string;
    public firstStockId: number;
    public followupStockId: number;
    public locations: number[];
    public defaultLocationId?: number;
    public name: string;
    public onlineGuid: string;

    public constructor(init?: Partial<QuickStartWizardPractitionerResponse>) { (Object as any).assign(this, init); }
}
(QuickStartWizardPractitionerResponse as unknown)[immerable] = true;

export class ServiceType implements IHasId, IHasGlobalGuid
{
    public id: number;
    public name: string;
    public isCurrent: boolean;
    public clinicalAccessMode: AccessMode;
    public patientAccessMode: AccessMode;
    public usesScores: boolean;
    public usesGoals: boolean;
    public usesImages: boolean;
    public labelOverrides: { [index:string]: string; };
    public listOverrides: { [index:string]: string; };
    public configOverrides: { [index:string]: string; };
    public workflowAccessMode: AccessMode;
    public globalGuid: string;

    public constructor(init?: Partial<ServiceType>) { (Object as any).assign(this, init); }
}
(ServiceType as unknown)[immerable] = true;

export class Stock implements IHasId, IHasGlobalGuid
{
    public id: number;
    public totalPrice?: number;
    public description: string;
    public appointmentLength?: number;
    public serviceTypeId?: number;
    // @Ignore()
    public serviceTypeGuid?: string;

    public crossLocationThreadId?: string;
    public locationId?: number;
    // @Ignore()
    public locationGuid?: string;

    public colour?: number;
    public inUse?: boolean;
    public priceExVAT?: number;
    public vatRate?: number;
    public vatAmount?: number;
    public costAmount?: number;
    public costVATRate?: number;
    public costExVAT?: number;
    public costVATAmount?: number;
    public longDescription: string;
    public ledgerCode: string;
    public barCodeReference: string;
    public batchTraceable?: boolean;
    public reference: string;
    public category: string;
    public level?: number;
    public minimumLevel?: number;
    public displayInPriceList?: boolean;
    public isMultiple?: boolean;
    public isClass?: boolean;
    public migrated?: boolean;
    public supplierId?: number;
    public isPrivateCharge?: boolean;
    public groupName: string;
    public classification: string;
    public pathologyProvider?: EPathologyProvider;
    public pathologyIdentityKey: string;
    public online?: boolean;
    public onlineGuid?: string;
    public ccsd: string;
    public serviceCode?: string;
    public iscCodeID?: number;
    public templateSetId?: number;
    public isVideo?: boolean;
    public managementFee?: boolean;
    public cancellationStockId?: number;
    public didNotAttendStockId?: number;
    public billingEntityId?: number;
    public notes: string;
    // @Ignore()
    public globalGuid: string;

    public tags: string[];
    public specialismId?: string;
    public credits?: number;
    public eligibleForTaxExemption: boolean;
    public unitOfIssue: number;
    public paymentOption: number;
    public paymentOptionValue: number;
    public locationBased: boolean;
    public barcode: string;
    public earliestExpirationDate?: string;
    public depositPaymentApply: number;
    // @Ignore()
    public categoryText: string;

    public constructor(init?: Partial<Stock>) { (Object as any).assign(this, init); }
}
(Stock as unknown)[immerable] = true;

export class QuickStartWizardGetStocksResponse
{
    public consultations: Stock[];
    public cancellations: Stock[];

    public constructor(init?: Partial<QuickStartWizardGetStocksResponse>) { (Object as any).assign(this, init); }
}
(QuickStartWizardGetStocksResponse as unknown)[immerable] = true;

export class QuickStartWizardStock
{
    public id: number;
    public appointmentLength: number;
    public totalPrice: number;
    public isFirst: boolean;
    public isFollowup: boolean;
    public description: string;
    public reference: string;

    public constructor(init?: Partial<QuickStartWizardStock>) { (Object as any).assign(this, init); }
}
(QuickStartWizardStock as unknown)[immerable] = true;

export class Template implements IHasId, IHasGlobalGuid
{
    public id: number;
    public name: string;
    public description: string;
    public body: string;
    public type: string;
    public lastModified: string;
    public globalId: string;
    public isReadOnly: boolean;
    public syncToPronto?: boolean;
    public lastSyncDate?: string;
    public isRemoved: boolean;
    public serviceTypeId?: number;
    public format: BlockTemplateFormat;
    public archived: boolean;
    // @Ignore()
    public serviceTypeGuid?: string;

    // @Ignore()
    public globalGuid: string;

    public signatureRequired: boolean;
    public allowsAttachments: boolean;
    public requiresAttachment: boolean;
    public attachmentPromptText: string;

    public constructor(init?: Partial<Template>) { (Object as any).assign(this, init); }
}
(Template as unknown)[immerable] = true;

export class QuickStartWizardTemplateOptionsResponse
{
    public simple: Template;
    public advanced: Template;

    public constructor(init?: Partial<QuickStartWizardTemplateOptionsResponse>) { (Object as any).assign(this, init); }
}
(QuickStartWizardTemplateOptionsResponse as unknown)[immerable] = true;

export class ProntoInvoiceTemplate
{
    public id: string;
    public template: string;
    public itemTemplate: string;
    public timeStamp: string;

    public constructor(init?: Partial<ProntoInvoiceTemplate>) { (Object as any).assign(this, init); }
}
(ProntoInvoiceTemplate as unknown)[immerable] = true;

export class ProntoNetworkService
{
    public name: string;
    public stockId: string;
    public networkServiceId: string;
    public discipline: string;
    public serviceName: string;

    public constructor(init?: Partial<ProntoNetworkService>) { (Object as any).assign(this, init); }
}
(ProntoNetworkService as unknown)[immerable] = true;

export class ProntoCacheResponse
{
    public invoices: { [index:string]: ProntoInvoiceTemplate; };
    public services: { [index:string]: ProntoNetworkService; };

    public constructor(init?: Partial<ProntoCacheResponse>) { (Object as any).assign(this, init); }
}
(ProntoCacheResponse as unknown)[immerable] = true;

export class GetClinicDetailsResponse
{
    public clinicName: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public postCode: string;
    public homeTelephone: string;
    public category: string;
    public previousSystem: string;
    public clinicCurrencySymbol: string;

    public constructor(init?: Partial<GetClinicDetailsResponse>) { (Object as any).assign(this, init); }
}
(GetClinicDetailsResponse as unknown)[immerable] = true;

export class ReferrerOverrideNetworkCharge
{
    public referrerId: string;
    public networkId: string;
    public overridingClinicReferralCharge?: number;
    public isDefaultCharge: boolean;

    public constructor(init?: Partial<ReferrerOverrideNetworkCharge>) { (Object as any).assign(this, init); }
}
(ReferrerOverrideNetworkCharge as unknown)[immerable] = true;

export class GetClientPaymentDetailsResponse
{
    public cardExists: boolean;
    public cardName: string;
    public lastFourDigits: string;
    public expiryMonth?: number;
    public expiryYear?: number;
    public brand: string;
    public isDirectDebit: boolean;

    public constructor(init?: Partial<GetClientPaymentDetailsResponse>) { (Object as any).assign(this, init); }
}
(GetClientPaymentDetailsResponse as unknown)[immerable] = true;

export class ProntoPaymentResponse
{
    public paymentDetails: GetClientPaymentDetailsResponse;

    public constructor(init?: Partial<ProntoPaymentResponse>) { (Object as any).assign(this, init); }
}
(ProntoPaymentResponse as unknown)[immerable] = true;

export class ProntoRegistrationResponse
{

    public constructor(init?: Partial<ProntoRegistrationResponse>) { (Object as any).assign(this, init); }
}
(ProntoRegistrationResponse as unknown)[immerable] = true;

export class License
{
    public clientID: number;
    public locationId: number;
    public expiryDate?: string;
    public isTM3Connect: boolean;
    public isEClinic: boolean;
    public isPPM: boolean;
    public hasClass: boolean;
    public hasEnterprise: boolean;
    public hasHealthCode: boolean;
    public hasMultiDiscipline: boolean;
    public hasMultiLocation: boolean;
    public hasOnlinePatientBooking: boolean;
    public hasPostcode: boolean;
    public hasReferrals: boolean;
    public hasRemote: boolean;
    public hasRoomManager: boolean;
    public hasRoleManager: boolean;
    public hasOnlineReception: boolean;
    public hasOnlineReferralBookings: boolean;
    public hasStock: boolean;
    public hasTouch: boolean;
    public hasApi: boolean;
    public hasApiLimit: boolean;
    public dailyApiLimit: number;
    public monthlyApiLimit: number;
    public maxLocations: number;
    public maxUsers: number;
    public onlinePractitioners: number;
    public startDate?: string;
    public touchMaxUsers: number;
    public hasPatientPortalBasic: boolean;
    public hasPatientPortalAdvanced: boolean;
    public hasOnlinePatient: boolean;
    public practitionerLicensing: boolean;
    public practitioners: number;
    public hasWebClinicalNotes: boolean;
    public isCancelling: boolean;
    public hasCustomStripeCommission: boolean;
    public customStripeCommissionRate?: number;
    public hasCustomSquareCommission: boolean;
    public customSquareCommissionRate?: number;
    public isEvaluating: boolean;
    public isProntoPortal: boolean;
    public isClick: boolean;
    public isClickPlus: boolean;
    public isCaseflow: boolean;
    public hasCustomClearAcceptCommission: boolean;
    public customClearAcceptCommissionRate?: number;
    public isTM3Essentials: boolean;
    public bzProduct: string;
    public subscription: string;
    public emailRateLimitPerLicense: number;

    public constructor(init?: Partial<License>) { (Object as any).assign(this, init); }
}
(License as unknown)[immerable] = true;

export class StartTrialResponse
{
    public license: License;
    public url: string;
    public errorMessage: string;

    public constructor(init?: Partial<StartTrialResponse>) { (Object as any).assign(this, init); }
}
(StartTrialResponse as unknown)[immerable] = true;

export class ConfirmClientDowngradeToProntoResponse
{
    public success: boolean;
    public domain: string;
    public url: string;

    public constructor(init?: Partial<ConfirmClientDowngradeToProntoResponse>) { (Object as any).assign(this, init); }
}
(ConfirmClientDowngradeToProntoResponse as unknown)[immerable] = true;

export class PrescriptionDetails
{
    public id: number;
    public description: string;
    public dosage: string;
    public otherInstructions: string;
    public deliveryType: string;
    public dateIssued: string;
    public practitionerTitle: string;
    public practitionerForename: string;
    public practitionerSurname: string;
    public userName: string;
    public userFullName: string;
    public prescriptionItems: PrescriptionItem[];
    public srxPrescriptionId: string;
    // @Ignore()
    public practitionerName: string;

    // @Ignore()
    public issuedBy: string;

    public constructor(init?: Partial<PrescriptionDetails>) { (Object as any).assign(this, init); }
}
(PrescriptionDetails as unknown)[immerable] = true;

export class GetPatientPrescriptionsResponse
{
    public prescriptions: PrescriptionDetails[];
    public prescriptionPrintPath: string;

    public constructor(init?: Partial<GetPatientPrescriptionsResponse>) { (Object as any).assign(this, init); }
}
(GetPatientPrescriptionsResponse as unknown)[immerable] = true;

export class PrescriptionSummary
{
    public description: string;
    public createdAt: string;
    public prescriber: string;

    public constructor(init?: Partial<PrescriptionSummary>) { (Object as any).assign(this, init); }
}
(PrescriptionSummary as unknown)[immerable] = true;

export class CreateNonRxPrescriptionsResponse
{
    public prescriptionId: number;
    public prescriptionPrintPath: string;

    public constructor(init?: Partial<CreateNonRxPrescriptionsResponse>) { (Object as any).assign(this, init); }
}
(CreateNonRxPrescriptionsResponse as unknown)[immerable] = true;

export class PathologyLabReport
{
    public orderReference: string;
    public testName: string;
    public testCode: string;
    public value: string;
    public units: string;
    public referenceRange: string;
    public abnormalFlag: string;
    public criticalFlag: boolean;
    public timestamp: string;
    public comments: string;

    public constructor(init?: Partial<PathologyLabReport>) { (Object as any).assign(this, init); }
}
(PathologyLabReport as unknown)[immerable] = true;

export class PathologyLabPanel
{
    public orderReference: string;
    public panelCode: string;
    public panelName: string;
    public timestamp: string;
    public panelNotes: string;
    public reports: PathologyLabReport[];

    public constructor(init?: Partial<PathologyLabPanel>) { (Object as any).assign(this, init); }
}
(PathologyLabPanel as unknown)[immerable] = true;

export class PathologyResultsResponse
{
    public provider: EPathologyProvider;
    public panels: PathologyLabPanel[];

    public constructor(init?: Partial<PathologyResultsResponse>) { (Object as any).assign(this, init); }
}
(PathologyResultsResponse as unknown)[immerable] = true;

export class PlacePathologyOrderResponse
{
    public provider: EPathologyProvider;
    public orderRef: string;
    public billingItemIds: number[];
    public invoiceId?: number;
    public hl7Message: string;
    public clientCode: string;

    public constructor(init?: Partial<PlacePathologyOrderResponse>) { (Object as any).assign(this, init); }
}
(PlacePathologyOrderResponse as unknown)[immerable] = true;

export class PathologyPriceListValidationErrors
{
    public profileCode: string;
    public errors: ValidationResult[];

    public constructor(init?: Partial<PathologyPriceListValidationErrors>) { (Object as any).assign(this, init); }
}
(PathologyPriceListValidationErrors as unknown)[immerable] = true;

export class PathologyPriceListValidationResult
{
    public rowErrors: PathologyPriceListValidationErrors[];
    public validItems: PathologyStockItem[];

    public constructor(init?: Partial<PathologyPriceListValidationResult>) { (Object as any).assign(this, init); }
}
(PathologyPriceListValidationResult as unknown)[immerable] = true;

// @Flags()
export enum EPathologyPricingStatus
{
    InActive = 0,
    Active = 1,
    Scheduled = 2,
}

export class PathologyPricingImportHistory implements IHasGuidId
{
    public id: string;
    public filename: string;
    public status: EPathologyPricingStatus;
    public uploadedDate: string;
    public startDate?: string;
    public markup: number;
    public bespoke: boolean;
    public hangfireJobId: string;
    // @Required()
    public provider: EPathologyProvider;

    public constructor(init?: Partial<PathologyPricingImportHistory>) { (Object as any).assign(this, init); }
}
(PathologyPricingImportHistory as unknown)[immerable] = true;

export class PathologyPricingImportHistoryDto extends PathologyPricingImportHistory
{
    public records: number;

    public constructor(init?: Partial<PathologyPricingImportHistoryDto>) { super(init); (Object as any).assign(this, init); }
}
(PathologyPricingImportHistoryDto as unknown)[immerable] = true;

export class PathologyIntegrationUserResponse
{
    public provider: EPathologyProvider;
    public integrationCode: string;
    public clinicCode: string;
    public clientCodeMode: string;

    public constructor(init?: Partial<PathologyIntegrationUserResponse>) { (Object as any).assign(this, init); }
}
(PathologyIntegrationUserResponse as unknown)[immerable] = true;

// @Flags()
export enum EMedicalImagingProvider
{
    Intelerad = 0,
    Manual = 1,
}

export class MedicalImagingProcedure implements IHasId
{
    public id: number;
    public code: string;
    public description: string;
    public modalityId: number;
    public bodyPart: string;
    public connectDisplayName: string;
    public locationIds: number[];
    public expectedDurationInMinutes: number;
    public provider: EMedicalImagingProvider;
    public ccsd?: string;
    public healthcodeChargeCode?: string;

    public constructor(init?: Partial<MedicalImagingProcedure>) { (Object as any).assign(this, init); }
}
(MedicalImagingProcedure as unknown)[immerable] = true;

export class MedicalImagingModality
{
    public id: number;
    public code: string;
    public name: string;
    public description: string;

    public constructor(init?: Partial<MedicalImagingModality>) { (Object as any).assign(this, init); }
}
(MedicalImagingModality as unknown)[immerable] = true;

export enum EMedicalImagingOrderEventType
{
    Unknown = 'Unknown',
    OrderSubmitted = 'OrderSubmitted',
    StatusChange = 'StatusChange',
    Result = 'Result',
    Addendum = 'Addendum',
    SupportingDocument = 'SupportingDocument',
}

export class MedicalImagingOrderHistoryResponse
{
    public id: number;
    public orderId: number;
    public orderControl: string;
    public reportedBy: string;
    public scanImagesUrls: string[];
    public pdfLinks: string[];
    public createdDate: string;
    public eventType: EMedicalImagingOrderEventType;

    public constructor(init?: Partial<MedicalImagingOrderHistoryResponse>) { (Object as any).assign(this, init); }
}
(MedicalImagingOrderHistoryResponse as unknown)[immerable] = true;

export class MedicalImagingOrderUploadJourneyDocumentResponse
{
    public filePath: string;
    public fileName: string;

    public constructor(init?: Partial<MedicalImagingOrderUploadJourneyDocumentResponse>) { (Object as any).assign(this, init); }
}
(MedicalImagingOrderUploadJourneyDocumentResponse as unknown)[immerable] = true;

export class AddLocationResponse
{
    public currentLocations: number;
    public licensedLocations: number;
    public canAddLocation: boolean;

    public constructor(init?: Partial<AddLocationResponse>) { (Object as any).assign(this, init); }
}
(AddLocationResponse as unknown)[immerable] = true;

export class SignatureRxResponse
{
    public signatureRxIntegrationCode: string;

    public constructor(init?: Partial<SignatureRxResponse>) { (Object as any).assign(this, init); }
}
(SignatureRxResponse as unknown)[immerable] = true;

export class CreatePrescriptionResponse
{
    public isSuccess: boolean;
    public message: string;

    public constructor(init?: Partial<CreatePrescriptionResponse>) { (Object as any).assign(this, init); }
}
(CreatePrescriptionResponse as unknown)[immerable] = true;

export class PharmaciergePrescription implements IHasGuidId
{
    public id: string;
    public customerId: number;
    public userId: number;
    public createdAt: string;
    public updatedAt?: string;
    public locationId: number;
    public caseId?: number;
    public notes: string;

    public constructor(init?: Partial<PharmaciergePrescription>) { (Object as any).assign(this, init); }
}
(PharmaciergePrescription as unknown)[immerable] = true;

export class PharmaciergePrescriptionItem implements IHasGuidId
{
    public id: string;
    public prescriptionId: string;
    public medicationName: string;
    public medicationId: string;
    public quantity: string;
    public strength: string;
    public form: string;
    public dose: string;
    public repeats: number;
    public notes: string;
    public description: string;
    public extendedDescription: string;
    public fridge?: boolean;
    public controlled?: boolean;

    public constructor(init?: Partial<PharmaciergePrescriptionItem>) { (Object as any).assign(this, init); }
}
(PharmaciergePrescriptionItem as unknown)[immerable] = true;

export class PharmaciergePrescriptionFull extends PharmaciergePrescription
{
    public items: PharmaciergePrescriptionItem[];
    public userFullName: string;

    public constructor(init?: Partial<PharmaciergePrescriptionFull>) { super(init); (Object as any).assign(this, init); }
}
(PharmaciergePrescriptionFull as unknown)[immerable] = true;

export class HeidiParametersResponse
{
    public scriptUrl: string;
    public heidiRegion: string;

    public constructor(init?: Partial<HeidiParametersResponse>) { (Object as any).assign(this, init); }
}
(HeidiParametersResponse as unknown)[immerable] = true;

export class CloudRxProductDto
{
    public productId: number;
    public name: string;
    public units: string;
    public packSize: number;
    public outOfStock: boolean;
    public price: number;
    public controlDrug: boolean;

    public constructor(init?: Partial<CloudRxProductDto>) { (Object as any).assign(this, init); }
}
(CloudRxProductDto as unknown)[immerable] = true;

export class CloudRxPrescriptionBase
{
    public id: string;
    public vendorOrderId: string;
    public customerId: number;
    public userId: number;
    public createdDateTime: string;
    public courierMethod?: CourierMethod;
    public numberOfRepeats?: number;
    public clinicCode: string;

    public constructor(init?: Partial<CloudRxPrescriptionBase>) { (Object as any).assign(this, init); }
}
(CloudRxPrescriptionBase as unknown)[immerable] = true;

export class CloudRxPrescriptionItem implements IHasGuidId
{
    public id: string;
    public prescriptionId: string;
    public productId: string;
    public quantity: number;
    public usageDirections: string;
    public unitPrice: number;
    public units: string;
    public packSize: number;
    public productName: string;
    public controlDrug: boolean;

    public constructor(init?: Partial<CloudRxPrescriptionItem>) { (Object as any).assign(this, init); }
}
(CloudRxPrescriptionItem as unknown)[immerable] = true;

export class CloudRxPrescriptionFull extends CloudRxPrescriptionBase
{
    public items: CloudRxPrescriptionItem[];
    public name: string;

    public constructor(init?: Partial<CloudRxPrescriptionFull>) { super(init); (Object as any).assign(this, init); }
}
(CloudRxPrescriptionFull as unknown)[immerable] = true;

export class CloudRxStatus
{
    public clinicOrderId: string;
    public pharmacyOrderId: string;
    public orderStatus: string;
    public dispatchDate?: string;
    public trackingId: string;
    public cancelReason: string;

    public constructor(init?: Partial<CloudRxStatus>) { (Object as any).assign(this, init); }
}
(CloudRxStatus as unknown)[immerable] = true;

export class CcsdResponse
{
    public id: number;
    public code: string;
    public description: string;

    public constructor(init?: Partial<CcsdResponse>) { (Object as any).assign(this, init); }
}
(CcsdResponse as unknown)[immerable] = true;

export class ICD9
{
    public id: number;
    public code: string;
    public description: string;
    public globalId: string;

    public constructor(init?: Partial<ICD9>) { (Object as any).assign(this, init); }
}
(ICD9 as unknown)[immerable] = true;

export class JobHistoryDto
{
    public createdAt: string;
    public failedAt?: string;
    public exceptionType: string;
    public exceptionMessage: string;
    public exceptionDetails: string;
    public state: string;
    public reason: string;

    public constructor(init?: Partial<JobHistoryDto>) { (Object as any).assign(this, init); }
}
(JobHistoryDto as unknown)[immerable] = true;

export class JobDto
{
    public createdAt: string;
    public cron: string;
    public name: string;
    public nextExecution?: string;
    public lastExecution?: string;
    public lastJobId?: string;
    public lastRecurring: JobDto;
    public type: string;
    public state: string;
    public history: JobHistoryDto[];

    public constructor(init?: Partial<JobDto>) { (Object as any).assign(this, init); }
}
(JobDto as unknown)[immerable] = true;

export class FormReportResponse
{
    public id: number;
    public globalId: string;
    public templateId: string;
    public reportData: string;
    public dateSent?: string;
    public lastEdited?: string;
    public submissionDate?: string;
    public completionDate?: string;
    public cancellationDate?: string;
    public declinedDate?: string;
    public patientId: number;
    public caseId: number;
    public name: string;
    public status: number;
    public description: string;
    public type: string;
    public body: string;
    public recordedBy: number;
    public patientSubmitted: boolean;
    public format: BlockTemplateFormat;
    public signatureRequired: boolean;
    public signature?: string;
    public userFullName?: string;

    public constructor(init?: Partial<FormReportResponse>) { (Object as any).assign(this, init); }
}
(FormReportResponse as unknown)[immerable] = true;

export class FormTemplatesResponse
{
    public id: number;
    public name: string;
    public description: string;
    public type: string;
    public body: string;
    public globalId: string;
    public used: boolean;
    public smsTemplate: string;
    public emailTemplate: string;
    public archived: boolean;
    public format: BlockTemplateFormat;
    public signatureRequired: boolean;
    public allowsAttachments: boolean;
    public requiresAttachment: boolean;
    public attachmentPromptText: string;

    public constructor(init?: Partial<FormTemplatesResponse>) { (Object as any).assign(this, init); }
}
(FormTemplatesResponse as unknown)[immerable] = true;

export class OnlineDocumentListingFile extends File
{
    public listingId: string;

    public constructor(init?: Partial<OnlineDocumentListingFile>) { super(init); (Object as any).assign(this, init); }
}
(OnlineDocumentListingFile as unknown)[immerable] = true;

export class OnlineMyFilesResponse
{
    public files: OnlineDocumentListingFile[];

    public constructor(init?: Partial<OnlineMyFilesResponse>) { (Object as any).assign(this, init); }
}
(OnlineMyFilesResponse as unknown)[immerable] = true;

export class PatientReport implements IHasId, IHasGlobalGuid
{
    public id: number;
    public globalId: string;
    // @Ignore()
    public globalGuid: string;

    public templateId: string;
    public reportData: string;
    public dateSent?: string;
    public lastEdited?: string;
    public submissionDate?: string;
    public completionDate?: string;
    public cancellationDate?: string;
    public declinedDate?: string;
    public patientId: number;
    public caseId?: number;
    public status: number;
    public recordedBy?: number;
    public notificationType?: number;
    public signature?: string;
    public signedBy?: number;

    public constructor(init?: Partial<PatientReport>) { (Object as any).assign(this, init); }
}
(PatientReport as unknown)[immerable] = true;

export class EquipmentSearchResponse extends EquipmentEntry
{
    public tags: string[];

    public constructor(init?: Partial<EquipmentSearchResponse>) { super(init); (Object as any).assign(this, init); }
}
(EquipmentSearchResponse as unknown)[immerable] = true;

export class DocumentDto
{
    public id: string;
    public fileName: string;
    public filePath: string;
    public status?: DocumentApprovalStatus;
    public consultationDate?: string;
    public client: string;
    public approvedBy: string;
    public approvedDate?: string;
    public customerId?: number;

    public constructor(init?: Partial<DocumentDto>) { (Object as any).assign(this, init); }
}
(DocumentDto as unknown)[immerable] = true;

export class ClassesResponse
{
    public weeklyClasses: { [index:string]: ClassSessionWithDetails[]; };

    public constructor(init?: Partial<ClassesResponse>) { (Object as any).assign(this, init); }
}
(ClassesResponse as unknown)[immerable] = true;

export class PatientClass
{
    public sessionId: number;
    public name: string;
    public description: string;
    public practitionerForename: string;
    public practitionerSurname: string;
    // @Ignore()
    public practitionerName: string;

    public status: string;
    public locationName: string;
    public startDate: string;
    public endDate: string;

    public constructor(init?: Partial<PatientClass>) { (Object as any).assign(this, init); }
}
(PatientClass as unknown)[immerable] = true;

export class PatientClassResponse
{
    public classes: PatientClass[];

    public constructor(init?: Partial<PatientClassResponse>) { (Object as any).assign(this, init); }
}
(PatientClassResponse as unknown)[immerable] = true;

export class PatientClassWithCreditsUsage extends PatientClass
{
    public creditUsage: number;
    public transactionType: CreditTransactionType;

    public constructor(init?: Partial<PatientClassWithCreditsUsage>) { super(init); (Object as any).assign(this, init); }
}
(PatientClassWithCreditsUsage as unknown)[immerable] = true;

export class Point
{
    public x: number;
    public y: number;

    public constructor(init?: Partial<Point>) { (Object as any).assign(this, init); }
}
(Point as unknown)[immerable] = true;

export class GraphData
{
    public label: string;
    public values: Point[];

    public constructor(init?: Partial<GraphData>) { (Object as any).assign(this, init); }
}
(GraphData as unknown)[immerable] = true;

export class PieChartSegment
{
    public label: string;
    public value: number;

    public constructor(init?: Partial<PieChartSegment>) { (Object as any).assign(this, init); }
}
(PieChartSegment as unknown)[immerable] = true;

export class PieChartData
{
    public segments: PieChartSegment[];

    public constructor(init?: Partial<PieChartData>) { (Object as any).assign(this, init); }
}
(PieChartData as unknown)[immerable] = true;

export class TopClients
{
    public name: string;
    public type: string;
    public total: number;

    public constructor(init?: Partial<TopClients>) { (Object as any).assign(this, init); }
}
(TopClients as unknown)[immerable] = true;

export class DashboardResponse
{
    public dnas: GraphData[];
    public cancellations: GraphData[];
    public allAppointments: GraphData[];
    public newPatients: GraphData[];
    public turnover: GraphData[];
    public appointmentShare: PieChartData;
    public newPatientByType: PieChartData;
    public topClients: TopClients[];
    public debt: Object;
    public appointmentStats: Object;
    public dnaTotal: Object;

    public constructor(init?: Partial<DashboardResponse>) { (Object as any).assign(this, init); }
}
(DashboardResponse as unknown)[immerable] = true;

export class CustomerAppointmentStatsResponse
{
    public historical: number;
    public upcoming: number;

    public constructor(init?: Partial<CustomerAppointmentStatsResponse>) { (Object as any).assign(this, init); }
}
(CustomerAppointmentStatsResponse as unknown)[immerable] = true;

export class CrmPipelineStageResponse
{
    public id: string;
    public name: string;

    public constructor(init?: Partial<CrmPipelineStageResponse>) { (Object as any).assign(this, init); }
}
(CrmPipelineStageResponse as unknown)[immerable] = true;

export class CrmPipelinesResponse
{
    public id: string;
    public name: string;
    public stages: CrmPipelineStageResponse[];

    public constructor(init?: Partial<CrmPipelinesResponse>) { (Object as any).assign(this, init); }
}
(CrmPipelinesResponse as unknown)[immerable] = true;

export class CrmPipedrivePersonFieldSubfieldResponse
{
    public fieldName: string;
    public fieldCode: string;
    public fieldType: string;

    public constructor(init?: Partial<CrmPipedrivePersonFieldSubfieldResponse>) { (Object as any).assign(this, init); }
}
(CrmPipedrivePersonFieldSubfieldResponse as unknown)[immerable] = true;

export class CrmPipedrivePersonFieldResponse
{
    public fieldName: string;
    public fieldCode: string;
    public fieldType: string;
    public subfields: CrmPipedrivePersonFieldSubfieldResponse[];

    public constructor(init?: Partial<CrmPipedrivePersonFieldResponse>) { (Object as any).assign(this, init); }
}
(CrmPipedrivePersonFieldResponse as unknown)[immerable] = true;

export enum CrmEntityType
{
    Contact = 'Contact',
    Opportunity = 'Opportunity',
    Note = 'Note',
}

export class CrmSyncOutcomeResponse
{
    public id: number;
    public service: CrmService;
    public entityType: CrmEntityType;
    public internalId?: number;
    public relatedInternalId?: number;
    public externalId: string;
    public status: string;
    public reason: string;
    public meta: string;
    public createdDate: string;

    public constructor(init?: Partial<CrmSyncOutcomeResponse>) { (Object as any).assign(this, init); }
}
(CrmSyncOutcomeResponse as unknown)[immerable] = true;

export class CrmWebhookResponse
{
    public id: number;
    public name: string;
    public subscriptionUrl: string;
    public eventAction: string;
    public eventObject: string;
    public version: string;
    public isActive: boolean;
    public addTime: string;
    public removeTime?: string;
    public removeReason: string;
    public lastDeliveryTime?: string;
    public lastHttpStatus: string;
    public isConfigured: boolean;

    public constructor(init?: Partial<CrmWebhookResponse>) { (Object as any).assign(this, init); }
}
(CrmWebhookResponse as unknown)[immerable] = true;

export class OnlineConsentResponse extends OnlineConsent
{

    public constructor(init?: Partial<OnlineConsentResponse>) { super(init); (Object as any).assign(this, init); }
}
(OnlineConsentResponse as unknown)[immerable] = true;

export class ExperimentalFeatureDefinition
{
    public key: string;
    public label: string;
    public description: string;
    public enabled: boolean;
    public requiredModules: string[];
    public disclaimerKey: string;

    public constructor(init?: Partial<ExperimentalFeatureDefinition>) { (Object as any).assign(this, init); }
}
(ExperimentalFeatureDefinition as unknown)[immerable] = true;

export class ClinicalReportingFieldMap
{
    public name: string;
    public map: string[];

    public constructor(init?: Partial<ClinicalReportingFieldMap>) { (Object as any).assign(this, init); }
}
(ClinicalReportingFieldMap as unknown)[immerable] = true;

export class ClinicalReportingFieldResponse
{
    public fields: { [index:string]: ReportingField[]; };
    public mappings: { [index:string]: ClinicalReportingFieldMap; };

    public constructor(init?: Partial<ClinicalReportingFieldResponse>) { (Object as any).assign(this, init); }
}
(ClinicalReportingFieldResponse as unknown)[immerable] = true;

export class ClinicalMyTemplatesResponse
{
    public id: number;
    public name: string;
    public description: string;
    public type: string;
    public body: string;
    public globalId: string;
    public used: boolean;
    public background: boolean;
    public isDefault: boolean;
    public isFirst: boolean;
    public isFollow: boolean;
    public isReadOnly: boolean;
    public serviceTypeId?: number;
    public archived: boolean;
    public signatureRequired: boolean;
    public allowsAttachments: boolean;
    public requiresAttachment: boolean;
    public attachmentPromptText: string;

    public constructor(init?: Partial<ClinicalMyTemplatesResponse>) { (Object as any).assign(this, init); }
}
(ClinicalMyTemplatesResponse as unknown)[immerable] = true;

export class Lookup implements IHasId, IHasGlobalGuid
{
    public id: number;
    public name: string;
    public value: string;
    public order: number;
    public globalGuid: string;

    public constructor(init?: Partial<Lookup>) { (Object as any).assign(this, init); }
}
(Lookup as unknown)[immerable] = true;

export class ConfigResponse
{
    public id: number;
    public description: string;
    public value: string;

    public constructor(init?: Partial<ConfigResponse>) { (Object as any).assign(this, init); }
}
(ConfigResponse as unknown)[immerable] = true;

export class PractitionerResponse
{

    public constructor(init?: Partial<PractitionerResponse>) { (Object as any).assign(this, init); }
}
(PractitionerResponse as unknown)[immerable] = true;

export class PermissionHolderResult
{
    public userId: number;
    public fullName: string;
    public email: string;
    public locationId: number;
    public locationName: string;
    public roleName: string;

    public constructor(init?: Partial<PermissionHolderResult>) { (Object as any).assign(this, init); }
}
(PermissionHolderResult as unknown)[immerable] = true;

export class CustomLookupResponse
{
    public id: number;
    public name: string;
    public value: string;
    public globalId: string;
    public alternates: string[];
    public groupId?: number;
    public serviceTypeId?: number;

    public constructor(init?: Partial<CustomLookupResponse>) { (Object as any).assign(this, init); }
}
(CustomLookupResponse as unknown)[immerable] = true;

export class DryIocBenchmarkPhaseResult
{
    public name: string;
    public wallMs: number;
    public cpuMs: number;
    public notes: string;

    public constructor(init?: Partial<DryIocBenchmarkPhaseResult>) { (Object as any).assign(this, init); }
}
(DryIocBenchmarkPhaseResult as unknown)[immerable] = true;

export class DryIocBenchmarkSnapshot
{
    public label: string;
    public workingSetMb: number;
    public privateMemoryMb: number;
    public gcTotalMemoryMb: number;
    public gcHeapMb: number;
    public gcCommittedMb: number;
    public gcFragmentedMb: number;
    public gen0Collections: number;
    public gen1Collections: number;
    public gen2Collections: number;
    public timestampUtc: string;

    public constructor(init?: Partial<DryIocBenchmarkSnapshot>) { (Object as any).assign(this, init); }
}
(DryIocBenchmarkSnapshot as unknown)[immerable] = true;

export class ClinicalTemplatesResponse
{
    public templateMappings: { [index:string]: string; };
    public templates: { [index:string]: Template; };

    public constructor(init?: Partial<ClinicalTemplatesResponse>) { (Object as any).assign(this, init); }
}
(ClinicalTemplatesResponse as unknown)[immerable] = true;

export class TemplateResponse
{
    public id: number;
    public body: string;
    public name: string;
    public archived: boolean;
    public isReadOnly: boolean;
    public signatureRequired: boolean;
    public allowsAttachments: boolean;
    public requiresAttachment: boolean;
    public attachmentPromptText: string;

    public constructor(init?: Partial<TemplateResponse>) { (Object as any).assign(this, init); }
}
(TemplateResponse as unknown)[immerable] = true;

export class ClickAccountPaymentsStatsResponse
{
    public unreconciledPayments: number;
    public partReconciledPayments: number;

    public constructor(init?: Partial<ClickAccountPaymentsStatsResponse>) { (Object as any).assign(this, init); }
}
(ClickAccountPaymentsStatsResponse as unknown)[immerable] = true;

export class ClickAccountInvoiceStatsResponse
{
    public unpaidInvoices: number;
    public partPaidInvoices: number;
    public accountBalance?: number;

    public constructor(init?: Partial<ClickAccountInvoiceStatsResponse>) { (Object as any).assign(this, init); }
}
(ClickAccountInvoiceStatsResponse as unknown)[immerable] = true;

export class ClickAccountUninvoicedChargesCountResponse
{
    public uninvoicedCharges: number;

    public constructor(init?: Partial<ClickAccountUninvoicedChargesCountResponse>) { (Object as any).assign(this, init); }
}
(ClickAccountUninvoicedChargesCountResponse as unknown)[immerable] = true;

export class CasePrintingStats
{
    public image: number;
    public consultation: number;

    public constructor(init?: Partial<CasePrintingStats>) { (Object as any).assign(this, init); }
}
(CasePrintingStats as unknown)[immerable] = true;

export class HistoryResult
{
    public id: number;
    public type: string;
    public date?: string;
    public data: Object;

    public constructor(init?: Partial<HistoryResult>) { (Object as any).assign(this, init); }
}
(HistoryResult as unknown)[immerable] = true;

export class CaseAuditDetails
{
    public auditUserName: string;
    public auditDate?: string;
    public auditNotes: string;

    public constructor(init?: Partial<CaseAuditDetails>) { (Object as any).assign(this, init); }
}
(CaseAuditDetails as unknown)[immerable] = true;

export class CasePrintingResponse
{
    public stats: CasePrintingStats;
    public details: CaseWithCustomerPractitionerLocationDetails;
    public templates: { [index:string]: { [index:string]: string; }; };
    public content: HistoryResult[];
    public postCloseNotes: PostCloseNotesWithUser[];
    public closedUser: string;
    public closedDate?: string;
    public auditDetails: CaseAuditDetails;
    public scores: CasePrintingScore<ClinicalScoreEntry>[];
    public goals: CasePrintingGoal<GoalEntry>[];

    public constructor(init?: Partial<CasePrintingResponse>) { (Object as any).assign(this, init); }
}
(CasePrintingResponse as unknown)[immerable] = true;

export class CaseReportTemplate
{
    public type: number;
    public mode: string;
    public title: string;
    public template: string;
    public sections: string[];
    public mandatoryFieldOverrides: { [index:string]: { [index:string]: boolean; }; };
    public customLists: { [index:string]: { [index:string]: string; }; };
    public lists: { [index:string]: NestedLookupDto; };

    public constructor(init?: Partial<CaseReportTemplate>) { (Object as any).assign(this, init); }
}
(CaseReportTemplate as unknown)[immerable] = true;

export class CaseReportSectionTemplate
{
    public id: string;
    public name: string;
    public body: string;
    public timeStamp: string;
    public bookerId: string;

    public constructor(init?: Partial<CaseReportSectionTemplate>) { (Object as any).assign(this, init); }
}
(CaseReportSectionTemplate as unknown)[immerable] = true;

export class CaseReportSearchResponse
{
    public referralStatus: number;
    public bookerName: string;
    public bookerId: string;
    public treatments: HistoryResult[];
    public attachments: AttachmentFile[];
    public allowed: { [index:string]: string; };
    public reports: { [index:string]: CaseReport; };
    public templates: { [index:string]: CaseReportTemplate; };
    public sections: { [index:string]: CaseReportSectionTemplate; };
    public linkAppointmentsToReports: boolean;

    public constructor(init?: Partial<CaseReportSearchResponse>) { (Object as any).assign(this, init); }
}
(CaseReportSearchResponse as unknown)[immerable] = true;

export class CaseDashboardResponse
{
    public appointmentCount: number;
    public appointmentStartTime: string;
    public appointmentsWithoutConsultations: number;
    public auth: string;
    public bodySiteText: string;
    public closed: boolean;
    public customerId: number;
    public dateOfAdmission?: string;
    public diagnosis: string;
    public diagnosisCode: string;
    public dischargeDate?: string;
    public firstAppointmentId?: number;
    public id: number;
    public incompleteNotes: boolean;
    public name: string;
    public numberOfAppointments?: number;
    public unclosedConsultations: number;
    public status: number;
    public lastConsultationDate?: string;

    public constructor(init?: Partial<CaseDashboardResponse>) { (Object as any).assign(this, init); }
}
(CaseDashboardResponse as unknown)[immerable] = true;

export class Alert implements IHasId
{
    public id: number;
    public userId?: number;
    public createdByUserId?: number;
    public discriminatorType: string;
    public objectId?: number;
    public title: string;
    public notes: string;
    public createdDateTime?: string;
    public startDateTime?: string;
    public requiresAcknowledgement?: boolean;
    public complete?: boolean;
    public expiryDateTime?: string;
    public diaryDateTime?: string;
    public includeInMyWork?: boolean;
    public forYourEyesOnly?: boolean;
    public flagType?: number;
    public serviceTypeId?: number;
    // @Ignore()
    public future: boolean;

    public constructor(init?: Partial<Alert>) { (Object as any).assign(this, init); }
}
(Alert as unknown)[immerable] = true;

export class AutoSaveResult
{
    public flag: boolean;
    public alert: Alert;
    public question: Object;
    public tasksCreated: boolean;
    public id?: number;
    public data?: { [index:string]: Object; };

    public constructor(init?: Partial<AutoSaveResult>) { (Object as any).assign(this, init); }
}
(AutoSaveResult as unknown)[immerable] = true;

export class CaseDropDownResposne
{
    public id: number;
    public bodySite: string;
    public admissionDate: string;
    public dischargeDate?: string;
    public description: string;
    public customerId: number;
    public serviceTypeId: number;
    public locationId: number;

    public constructor(init?: Partial<CaseDropDownResposne>) { (Object as any).assign(this, init); }
}
(CaseDropDownResposne as unknown)[immerable] = true;

export class CustomerBackgroundResponse
{
    public id: number;
    public customerId: number;
    public data: { [index:string]: Object; };
    public modifiedBy: number;
    public lastModified: string;
    public templateId: string;
    public userFullName: string;
    public highlight: { [index:string]: number[]; };

    public constructor(init?: Partial<CustomerBackgroundResponse>) { (Object as any).assign(this, init); }
}
(CustomerBackgroundResponse as unknown)[immerable] = true;

export interface IPatientInfoResponse
{
    id: number;
    responseType: string;
    date: string;
    pinned: boolean;
    description: string;
    title: string;
    serviceTypeId?: number;
    customerId: number;
}

export class DiagnosisCodeTempResponse
{
    public key: string;
    public type: string;
    public json: string;

    public constructor(init?: Partial<DiagnosisCodeTempResponse>) { (Object as any).assign(this, init); }
}
(DiagnosisCodeTempResponse as unknown)[immerable] = true;

export class SessionRecordingDto
{
    public id: number;
    public caseId: number;
    public consultationId: number;
    public appointmentId?: number;
    public startedAt: string;
    public endedAt?: string;
    public durationSeconds: number;
    public status: SessionRecordingStatus;
    public provider: string;
    public correlationId: string;
    public createdByUserId?: number;
    public createdAt: string;
    public failureReason: string;
    public consentGiven?: boolean;
    public segments: TranscriptSegmentDto[];

    public constructor(init?: Partial<SessionRecordingDto>) { (Object as any).assign(this, init); }
}
(SessionRecordingDto as unknown)[immerable] = true;

export class AssessmentResult
{
    public id: number;
    public treatmentId: number;
    public type: string;
    public title: string;
    public notes: string;
    public date?: string;

    public constructor(init?: Partial<AssessmentResult>) { (Object as any).assign(this, init); }
}
(AssessmentResult as unknown)[immerable] = true;

export class CaseConsultationItem
{
    public id: number;
    public title: string;
    public templateId: string;
    public date?: string;
    public type: ConsultationItemType;
    public data: { [index:string]: Object; };
    public highlights: { [index:string]: number[]; };

    public constructor(init?: Partial<CaseConsultationItem>) { (Object as any).assign(this, init); }
}
(CaseConsultationItem as unknown)[immerable] = true;

export interface ICascade
{
    data: { [index:string]: Object; };
}

export class ScoreEntryResponse
{
    public id: number;
    public scoreId: number;
    public score: number;
    public dateAdded?: string;
    public patientSubmitted: boolean;

    public constructor(init?: Partial<ScoreEntryResponse>) { (Object as any).assign(this, init); }
}
(ScoreEntryResponse as unknown)[immerable] = true;

export class ScoreResponse implements IHasId
{
    public id: number;
    public title: string;
    public dateAdded: string;
    public dateCompleted?: string;
    public caseId: number;
    public entries: ScoreEntryResponse[];
    public min: number;
    public max: number;
    public settingId: number;
    public isPsfs: boolean;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ScoreResponse>) { (Object as any).assign(this, init); }
}
(ScoreResponse as unknown)[immerable] = true;

export class ScoreSearchResponse
{
    public order: string[];
    public scores: { [index:string]: ScoreResponse; };

    public constructor(init?: Partial<ScoreSearchResponse>) { (Object as any).assign(this, init); }
}
(ScoreSearchResponse as unknown)[immerable] = true;

export class GoalEntryResponse
{
    public id: number;
    public notes: string;
    public goalId: number;
    public caseId: number;
    public completionPercentage: number;
    public dateAdded?: string;
    public patientSubmitted: boolean;

    public constructor(init?: Partial<GoalEntryResponse>) { (Object as any).assign(this, init); }
}
(GoalEntryResponse as unknown)[immerable] = true;

export class GoalResponse implements IHasId
{
    public id: number;
    public title: string;
    public dateAdded: string;
    public dateCompleted?: string;
    public averaged: boolean;
    public caseId: number;
    public entries: GoalEntryResponse[];
    public isPsfs: boolean;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GoalResponse>) { (Object as any).assign(this, init); }
}
(GoalResponse as unknown)[immerable] = true;

export class GoalSearchResponse
{
    public order: string[];
    public goals: { [index:string]: GoalResponse; };

    public constructor(init?: Partial<GoalSearchResponse>) { (Object as any).assign(this, init); }
}
(GoalSearchResponse as unknown)[immerable] = true;

export class WorkflowStatusLookupRes
{
    public names: string[];
    public processNames: string[];
    public value: string;

    public constructor(init?: Partial<WorkflowStatusLookupRes>) { (Object as any).assign(this, init); }
}
(WorkflowStatusLookupRes as unknown)[immerable] = true;

export enum ProcessType
{
    caseflow = 'caseflow',
    lite = 'lite',
}

export class ProcessSummaryDto
{
    public id: string;
    public canonicalProcessId: string;
    public name: string;
    public type: ProcessType;
    public version?: number;
    public versionCount: number;
    public hasDraft: boolean;
    public isDraft: boolean;
    public lastModified?: string;
    public lastUsed?: string;
    public linkedJourneyCount: number;
    public status: string;

    public constructor(init?: Partial<ProcessSummaryDto>) { (Object as any).assign(this, init); }
}
(ProcessSummaryDto as unknown)[immerable] = true;

export class ActionTriggerConfigDto
{
    public delayDays?: number;
    public delayHours?: number;
    public eventType: string;
    public scope: string;
    public eventEntityType: string;
    public formTemplateId: string;

    public constructor(init?: Partial<ActionTriggerConfigDto>) { (Object as any).assign(this, init); }
}
(ActionTriggerConfigDto as unknown)[immerable] = true;

export class ActionStepDto
{
    public id: string;
    public name: string;
    public code: string;
    public config: { [index:string]: Object; };

    public constructor(init?: Partial<ActionStepDto>) { (Object as any).assign(this, init); }
}
(ActionStepDto as unknown)[immerable] = true;

export class ActionEdgeDto
{
    public id: string;
    public sourceStatusId: string;
    public targetStatusId: string;
    public name: string;
    public type: string;
    public triggerType: string;
    public triggerMode: string;
    public triggerConfig: ActionTriggerConfigDto;
    public steps: ActionStepDto[];
    public automationChainId?: string;
    public isAutomated: boolean;
    public delayDays?: number;
    public delayHours?: number;
    public externalTriggerType: string;
    public triggerConditions: string;

    public constructor(init?: Partial<ActionEdgeDto>) { (Object as any).assign(this, init); }
}
(ActionEdgeDto as unknown)[immerable] = true;

export class StatusNodeDto
{
    public id: string;
    public name: string;
    public code: string;
    public x: number;
    public y: number;
    public isTerminal: boolean;
    public isStart: boolean;
    public color: string;
    public instructions: string;
    public actions: ActionEdgeDto[];

    public constructor(init?: Partial<StatusNodeDto>) { (Object as any).assign(this, init); }
}
(StatusNodeDto as unknown)[immerable] = true;

export class ProcessChangeItemDto
{
    public severity: string;
    public summary: string;
    public type: string;

    public constructor(init?: Partial<ProcessChangeItemDto>) { (Object as any).assign(this, init); }
}
(ProcessChangeItemDto as unknown)[immerable] = true;

export class SMSBulkActionResponse
{

    public constructor(init?: Partial<SMSBulkActionResponse>) { (Object as any).assign(this, init); }
}
(SMSBulkActionResponse as unknown)[immerable] = true;

export class EmailBulkActionResponse
{

    public constructor(init?: Partial<EmailBulkActionResponse>) { (Object as any).assign(this, init); }
}
(EmailBulkActionResponse as unknown)[immerable] = true;

export class ContactBulkActionResponse
{

    public constructor(init?: Partial<ContactBulkActionResponse>) { (Object as any).assign(this, init); }
}
(ContactBulkActionResponse as unknown)[immerable] = true;

export class FormBulkActionResponse
{

    public constructor(init?: Partial<FormBulkActionResponse>) { (Object as any).assign(this, init); }
}
(FormBulkActionResponse as unknown)[immerable] = true;

export class TagBulkActionResponse
{

    public constructor(init?: Partial<TagBulkActionResponse>) { (Object as any).assign(this, init); }
}
(TagBulkActionResponse as unknown)[immerable] = true;

export class MailChimpSubscriptionBulkActionResponse
{

    public constructor(init?: Partial<MailChimpSubscriptionBulkActionResponse>) { (Object as any).assign(this, init); }
}
(MailChimpSubscriptionBulkActionResponse as unknown)[immerable] = true;

export class AutomationJob implements IHasGuidId
{
    public id: string;
    public createdAt?: string;
    public dueAt?: string;
    public executedAt?: string;
    public isComplete: boolean;
    public isError: boolean;
    public isActive: boolean;
    public errorMessage: string;
    public hangfireJobId: string;
    public entityType: AutomationEventEntityType;
    public actionType: EventActionType;
    public entityId: number;
    public name: string;
    public patientName: string;
    public isBulkAction: boolean;
    public automationJobTriggerUserId: number;
    public workflowId?: number;
    public subWorkflowId?: number;
    public listeningStatusId?: string;
    public processActionId?: string;
    public source: string;
    public includedInAllowance: boolean;
    public outcome: string;

    public constructor(init?: Partial<AutomationJob>) { (Object as any).assign(this, init); }
}
(AutomationJob as unknown)[immerable] = true;

export class WebinarResponse
{
    public id: number;
    public title: string;
    public date?: string;
    public text: string;
    public src: string;

    public constructor(init?: Partial<WebinarResponse>) { (Object as any).assign(this, init); }
}
(WebinarResponse as unknown)[immerable] = true;

export class SimpleUser
{
    public id: number;
    public name: string;
    public fullName: string;
    public type: string;
    public globalGuid: string;
    public practitionerId?: number;

    public constructor(init?: Partial<SimpleUser>) { (Object as any).assign(this, init); }
}
(SimpleUser as unknown)[immerable] = true;

export class PublicKeyCredentialDescriptor
{
    public type?: PublicKeyCredentialType;
    public id: string;

    public constructor(init?: Partial<PublicKeyCredentialDescriptor>) { (Object as any).assign(this, init); }
}
(PublicKeyCredentialDescriptor as unknown)[immerable] = true;

export enum UserVerificationRequirement
{
    Required = 'required',
    Preferred = 'preferred',
    Discouraged = 'discouraged',
}

export class Fido2ResponseBase
{
    public status: string;
    public errorMessage: string;

    public constructor(init?: Partial<Fido2ResponseBase>) { (Object as any).assign(this, init); }
}

export class AssertionVerificationResult extends Fido2ResponseBase
{
    public credentialId: string;
    public counter: number;

    public constructor(init?: Partial<AssertionVerificationResult>) { super(init); (Object as any).assign(this, init); }
}
(AssertionVerificationResult as unknown)[immerable] = true;

export class Fido2User
{
    public name: string;
    public id: string;
    public displayName: string;

    public constructor(init?: Partial<Fido2User>) { (Object as any).assign(this, init); }
}
(Fido2User as unknown)[immerable] = true;

export class AttestationVerificationSuccess extends AssertionVerificationResult
{
    public publicKey: string;
    public user: Fido2User;
    public credType: string;
    public aaGuid: string;
    public attestationCertificate?: X509Certificate2;
    public attestationCertificateChain: X509Certificate2[];

    public constructor(init?: Partial<AttestationVerificationSuccess>) { super(init); (Object as any).assign(this, init); }
}
(AttestationVerificationSuccess as unknown)[immerable] = true;

export class CredentialMakeResult extends Fido2ResponseBase
{
    public result?: AttestationVerificationSuccess;

    public constructor(init?: Partial<CredentialMakeResult>) { super(init); (Object as any).assign(this, init); }
}

export class LicenseDetailsResponse
{
    public license: License;

    public constructor(init?: Partial<LicenseDetailsResponse>) { (Object as any).assign(this, init); }
}
(LicenseDetailsResponse as unknown)[immerable] = true;

export class LicenceModule
{
    public id: string;
    public name: string;
    public description: string;
    public dependencies: LicenceModule[];
    public availabilityKind: string;
    public userConfigurableWhenEntitled: boolean;

    public constructor(init?: Partial<LicenceModule>) { (Object as any).assign(this, init); }
}
(LicenceModule as unknown)[immerable] = true;

export class ApiAccessSettings
{
    public hasLimit: boolean;
    public dailyLimit?: number;
    public monthlyLimit?: number;

    public constructor(init?: Partial<ApiAccessSettings>) { (Object as any).assign(this, init); }
}
(ApiAccessSettings as unknown)[immerable] = true;

export class ReferralPortalSettings
{
    public hasLimit: boolean;
    public dailyLimit?: number;
    public monthlyLimit?: number;

    public constructor(init?: Partial<ReferralPortalSettings>) { (Object as any).assign(this, init); }
}
(ReferralPortalSettings as unknown)[immerable] = true;

export class ModularLicence
{
    public name: string;
    public description: string;
    public number: string;
    public type: string;
    public modules: LicenceModule[];
    public availableModules: LicenceModule[];
    public apiAccess: ApiAccessSettings;
    public referralPortal: ReferralPortalSettings;

    public constructor(init?: Partial<ModularLicence>) { (Object as any).assign(this, init); }
}
(ModularLicence as unknown)[immerable] = true;

export class PackageTierAllowances
{
    public smsCredits: number;
    public automationCredits: number;
    public classCredits: number;
    public smsPpcRate: number;
    public automationPpcRate: number;
    public classPpcRate: number;

    public constructor(init?: Partial<PackageTierAllowances>) { (Object as any).assign(this, init); }
}
(PackageTierAllowances as unknown)[immerable] = true;

export class PackageTierInfo
{
    public tier: PackageTier;
    public packageId: string;
    public tierGroup: string;
    public name: string;
    public description: string;
    public price: number;
    public includedModules: LicenceModule[];
    public allowances: PackageTierAllowances;

    public constructor(init?: Partial<PackageTierInfo>) { (Object as any).assign(this, init); }
}
(PackageTierInfo as unknown)[immerable] = true;

export enum AddOnPricingMode
{
    FlatRate = 'FlatRate',
    PerLicence = 'PerLicence',
    PerUnit = 'PerUnit',
}

export class LicenceAddOn
{
    public id: string;
    public name: string;
    public description: string;
    public price: number;
    public pricingMode: AddOnPricingMode;
    public quantity: number;
    public isActive: boolean;
    public module: LicenceModule;
    public allowedTierIds: string[];
    public allowedTierNames: string[];
    public pendingRemovalDate?: string;
    public pendingTargetQuantity?: number;

    public constructor(init?: Partial<LicenceAddOn>) { (Object as any).assign(this, init); }
}
(LicenceAddOn as unknown)[immerable] = true;

export class ImmediateChargeSummary
{
    public chargedAmount: number;
    public perDayRate: number;
    public daysRemaining: number;

    public constructor(init?: Partial<ImmediateChargeSummary>) { (Object as any).assign(this, init); }
}
(ImmediateChargeSummary as unknown)[immerable] = true;

export class CurrentLicenceDetailsResponse extends ResponseBase<CurrentLicenceDetailsResponse>
{
    public currentLicence: ModularLicence;
    public currentTier: PackageTier;
    public currentPackageId: string;
    public pendingTierId: string;
    public pendingPackageId: string;
    public pendingTierEffectiveDate?: string;
    public availableTiers: PackageTierInfo[];
    public availableAddOns: LicenceAddOn[];
    public activeAddOns: LicenceAddOn[];
    public isLegacyTier: boolean;
    public legacyTierName: string;
    public legacyTierDescription: string;
    public lastImmediateCharge: ImmediateChargeSummary;

    public constructor(init?: Partial<CurrentLicenceDetailsResponse>) { super(init); (Object as any).assign(this, init); }
}
(CurrentLicenceDetailsResponse as unknown)[immerable] = true;

export class ActiveAddOnSummary
{
    public id: string;
    public name: string;
    public quantity: number;
    public pricingMode: string;

    public constructor(init?: Partial<ActiveAddOnSummary>) { (Object as any).assign(this, init); }
}
(ActiveAddOnSummary as unknown)[immerable] = true;

export class StandardPricing
{
    public pricePerSeat: number;
    public addOnRates: AddOnRate[];
    public smsPpcRate: number;
    public automationPpcRate: number;
    public classPpcRate: number;

    public constructor(init?: Partial<StandardPricing>) { (Object as any).assign(this, init); }
}
(StandardPricing as unknown)[immerable] = true;

export class PricingOverrides
{
    public pricePerSeat?: number;
    public addOnRates: AddOnRate[];
    public smsPpcRate?: number;
    public automationPpcRate?: number;
    public classPpcRate?: number;
    public note: string;
    public setByUserId: string;
    public setAt?: string;
    public effectiveFrom?: string;
    public effectiveTo?: string;
    public isActive: boolean;

    public constructor(init?: Partial<PricingOverrides>) { (Object as any).assign(this, init); }
}
(PricingOverrides as unknown)[immerable] = true;

export class LicencePromotion
{
    public pricePerSeat: number;
    public endDate?: string;
    public note: string;
    public revertPricePerSeat?: number;

    public constructor(init?: Partial<LicencePromotion>) { (Object as any).assign(this, init); }
}
(LicencePromotion as unknown)[immerable] = true;

export class LicencePricingInfo
{
    public isCustomPricing: boolean;
    public monthlyTotal: number;
    public billingFrequency: string;
    public vatRatePercent?: number;
    public nextPaymentDate: string;
    public standard: StandardPricing;
    public overrides: PricingOverrides;
    public promotion: LicencePromotion;

    public constructor(init?: Partial<LicencePricingInfo>) { (Object as any).assign(this, init); }
}
(LicencePricingInfo as unknown)[immerable] = true;

export class PendingSeatChange
{
    public newSeatCount?: number;
    public effectiveDate: string;

    public constructor(init?: Partial<PendingSeatChange>) { (Object as any).assign(this, init); }
}
(PendingSeatChange as unknown)[immerable] = true;

export class ModularClientLicenceResponse
{
    public clientId: string;
    public product: string;
    public licenceType: string;
    public packageId: string;
    public tierId: string;
    public tierName: string;
    public seatCount: number;
    public moduleIds: string[];
    public activeAddOns: ActiveAddOnSummary[];
    public pricing: LicencePricingInfo;
    public pendingSeatChange: PendingSeatChange;
    public availableTiers: PackageTierInfo[];
    public availableAddOns: LicenceAddOn[];
    public isCancelling: boolean;
    public lastImmediateCharge: ImmediateChargeSummary;

    public constructor(init?: Partial<ModularClientLicenceResponse>) { (Object as any).assign(this, init); }
}
(ModularClientLicenceResponse as unknown)[immerable] = true;

export class ClientLicenceUnion
{
    public isModular: boolean;
    public modular: ModularClientLicenceResponse;
    public legacy: CurrentLicenceDetailsResponse;

    public constructor(init?: Partial<ClientLicenceUnion>) { (Object as any).assign(this, init); }
}
(ClientLicenceUnion as unknown)[immerable] = true;

export class AddOnAllocationDto
{
    public userId: number;
    public allocatedAt: string;
    public allocatedByUserId: number;
    public revokedAt?: string;

    public constructor(init?: Partial<AddOnAllocationDto>) { (Object as any).assign(this, init); }
}
(AddOnAllocationDto as unknown)[immerable] = true;

export class AddOnAllocationSummaryResponse
{
    public addOnId: string;
    public purchasedQuantity: number;
    public allocatedCount: number;
    public availableCount: number;
    public isOverAllocated: boolean;
    public allocations: AddOnAllocationDto[];

    public constructor(init?: Partial<AddOnAllocationSummaryResponse>) { (Object as any).assign(this, init); }
}
(AddOnAllocationSummaryResponse as unknown)[immerable] = true;

export class AddOnReductionImpactResponse
{
    public addOnId: string;
    public purchasedQuantity: number;
    public allocatedCount: number;
    public targetQuantity: number;
    public removalCount: number;
    public usersToRemove: AddOnAllocationDto[];

    public constructor(init?: Partial<AddOnReductionImpactResponse>) { (Object as any).assign(this, init); }
}
(AddOnReductionImpactResponse as unknown)[immerable] = true;

export class CustomAttributeDto
{
    public id: string;
    public name: string;
    public type: string;
    public typeFriendlyName: string;

    public constructor(init?: Partial<CustomAttributeDto>) { (Object as any).assign(this, init); }
}
(CustomAttributeDto as unknown)[immerable] = true;

export class ConfigureCustomAttributeDto extends CustomAttributeDto
{
    public inUse: boolean;

    public constructor(init?: Partial<ConfigureCustomAttributeDto>) { super(init); (Object as any).assign(this, init); }
}
(ConfigureCustomAttributeDto as unknown)[immerable] = true;

export class GetCustomAttributeListsResponse
{
    public id: string;
    public niceName: string;
    public values: ConfigureCustomAttributeDto[];

    public constructor(init?: Partial<GetCustomAttributeListsResponse>) { (Object as any).assign(this, init); }
}
(GetCustomAttributeListsResponse as unknown)[immerable] = true;

export class CustomAttributes implements IHasGuidId, IHasGlobalGuid
{
    public id: string;
    public name: string;
    public typeId: string;
    // @Ignore()
    public globalGuid: string;

    public constructor(init?: Partial<CustomAttributes>) { (Object as any).assign(this, init); }
}
(CustomAttributes as unknown)[immerable] = true;

export class BillingEntity implements IHasId
{
    public id: number;
    // @Required()
    public name: string;

    public contactName: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public addressLine5: string;
    public postCode: string;
    public telephone: string;
    public email: string;
    public tm3InvoiceTemplate: string;
    public isActive: boolean;
    public createdDate?: string;
    public modifiedDate?: string;

    public constructor(init?: Partial<BillingEntity>) { (Object as any).assign(this, init); }
}
(BillingEntity as unknown)[immerable] = true;

export class BillingEntityDto extends BillingEntity
{

    public constructor(init?: Partial<BillingEntityDto>) { super(init); (Object as any).assign(this, init); }
}
(BillingEntityDto as unknown)[immerable] = true;

export class BillingEntityLinkedChargeDto
{
    public stockId: number;
    public name: string;
    public type: string;

    public constructor(init?: Partial<BillingEntityLinkedChargeDto>) { (Object as any).assign(this, init); }
}
(BillingEntityLinkedChargeDto as unknown)[immerable] = true;

export class BillingEntityDeactivationImpactDto
{
    public stockChargeCount: number;
    public groupChargeCount: number;
    public linkedChargeCount: number;
    public linkedCharges: BillingEntityLinkedChargeDto[];

    public constructor(init?: Partial<BillingEntityDeactivationImpactDto>) { (Object as any).assign(this, init); }
}
(BillingEntityDeactivationImpactDto as unknown)[immerable] = true;

export enum TokenStatus
{
    PotentialChange = 'PotentialChange',
    AwaitingToken = 'AwaitingToken',
    Available = 'Available',
    Expired = 'Expired',
}

export class TokenSearchResponse
{
    public id: string;
    public customerId: number;
    public pan: string;
    public token: string;
    public merchant: string;
    public expiryDate: string;
    public tokenStatus: TokenStatus;

    public constructor(init?: Partial<TokenSearchResponse>) { (Object as any).assign(this, init); }
}
(TokenSearchResponse as unknown)[immerable] = true;

export class TokenRegisterResponse
{
    public id: string;
    public customerId: number;
    public pan: string;
    public token: string;
    public merchant: string;
    public expiryDate: string;

    public constructor(init?: Partial<TokenRegisterResponse>) { (Object as any).assign(this, init); }
}
(TokenRegisterResponse as unknown)[immerable] = true;

export enum AppointmentBillingType
{
    None = 'None',
    CaseflowManaged = 'CaseflowManaged',
    ClinicManaged = 'ClinicManaged',
}

export class AppointmentDetailsResponse
{
    public id: number;
    public locationId: number;
    public bookingMethod: string;
    public bookedByName: string;
    public firstAppointment: boolean;
    public groupName: string;
    public authId: number;
    public authCode: string;
    public caseId: number;
    public casePractitionerId: number;
    public prontoAuditId?: string;
    public prontoAppointmentId?: string;
    public prontoServiceId?: string;
    public meta: { [index:string]: Object; };
    public isVideo?: boolean;
    public videoCode: string;
    public discountCodeId?: string;
    public discountCodeAppliedDate?: string;
    public discountCodeAdvance: boolean;
    public videoLink: string;
    public videoMeetingParticipantJoinUrl: string;
    public videoMeetingPassword: string;
    public authMaxTreatments: number;
    public authMaxValue: number;
    public authValueRemaining: number;
    public authStartDate: string;
    public authExpiryDate?: string;
    public authLeft: number;
    public reminderDate?: string;
    public reminderType?: string;
    public recallDate?: string;
    public videoMeetingHostJoinUrl: string;
    public videoMeetingProvider: VideoMeetingProvider;
    public videoMeetingId: string;
    public caseReference: string;
    public stockId: string;
    public stockReference: string;
    public stockTotalPrice: string;
    public casePractitioner: string;
    public caseBodySite: string;
    public caseDateOfAdmission: string;
    public caseFirstAppointmentId?: number;
    public caseNumberOfAppointments: number;
    public classSessionId: number;
    public isFirstAppointmentCase: boolean;
    public stockDescription: string;
    public batchNo?: number;
    public startDateTime: string;
    public endDateTime: string;
    public roomId?: number;
    public practitionerId?: number;
    public type: string;
    public patient: RestrictedCustomerDetails;
    public name: string;
    public prepaymentStatus: string;
    public prepaymentType: PrepaymentType;
    public appointmentBillingType: AppointmentBillingType;
    public prePaymentIncomeId?: number;
    public status: number;
    public subStatus: AppointmentSubStatus;
    public arrivalDateTime?: string;
    public inProgressTime?: string;
    public finishedTime?: string;
    public completedTime?: string;
    public additionalCharges: AppointmentAdditionalChargeResponse[];
    public procedureId?: number;
    public procedures: AppointmentProcedureSelection[];
    public skillRestrictions: string[];
    public restriction: WorkingTimeRestriction;
    public allowedTags: string[];
    public allowedStockIds: number[];

    public constructor(init?: Partial<AppointmentDetailsResponse>) { (Object as any).assign(this, init); }
}
(AppointmentDetailsResponse as unknown)[immerable] = true;

export class RecurrenceOccurrenceCheck
{
    public startDateTime: string;
    public errors: string[];
    public warnings: string[];

    public constructor(init?: Partial<RecurrenceOccurrenceCheck>) { (Object as any).assign(this, init); }
}
(RecurrenceOccurrenceCheck as unknown)[immerable] = true;

export class RecurrenceBookingCheck
{
    public occurrences: RecurrenceOccurrenceCheck[];
    public hasErrors: boolean;
    public hasWarnings: boolean;
    public totalOccurrences: number;

    public constructor(init?: Partial<RecurrenceBookingCheck>) { (Object as any).assign(this, init); }
}
(RecurrenceBookingCheck as unknown)[immerable] = true;

export class AppointmentBookResponse
{
    public appointments: { [index:string]: ScheduleAppointment[]; };
    public depositRequired: boolean;
    public depositAmount?: number;
    public recurrenceCheck: RecurrenceBookingCheck;

    public constructor(init?: Partial<AppointmentBookResponse>) { (Object as any).assign(this, init); }
}
(AppointmentBookResponse as unknown)[immerable] = true;

export class AppointmentCreateClickCaseResponse
{
    public caseId: number;

    public constructor(init?: Partial<AppointmentCreateClickCaseResponse>) { (Object as any).assign(this, init); }
}
(AppointmentCreateClickCaseResponse as unknown)[immerable] = true;

export class Tm3BookingAudit
{
    public id: string;
    public userId: number;
    public appointmentId: string;
    public appointmentStartDateTime?: string;
    public appointmentBookingDateTime: string;
    public appointmentCustomerId: string;
    public customerReference: string;
    public bookingType: string;
    public serviceId: string;
    public referrerReference: string;
    public locationId: string;
    public targetId: string;
    public bookerId: string;
    public referralStatus: number;
    public auditClash?: boolean;
    public triageReport?: string;
    public initialReport?: string;
    public rfatReport?: string;
    public dischargeReport?: string;
    public needsAction: boolean;
    public appointments: ReferralAppointment[];
    public authorisations: ReferralAuthorisation[];
    public serviceCharges: { [index:string]: ServiceCharge; };
    public workflowId?: number;
    public reminderSentType?: number;
    public initialReportSubmissionDueDate?: string;
    public firstReminderSentDate?: string;
    public finalReminderSentDate?: string;
    public expiredReminderSentDate?: string;
    public referrerAlwaysRequiresAuthorisations: boolean;

    public constructor(init?: Partial<Tm3BookingAudit>) { (Object as any).assign(this, init); }
}
(Tm3BookingAudit as unknown)[immerable] = true;

export class AppointmentBookingInfoResponse
{
    public customer: GeneralCustomerResponse;
    public defaultCharge: StockResponse;
    public authCodes: TreatmentAuthResponse[];
    public prePaid: StockResponse[];
    public cases: AppointmentCaseResponse[];
    public prontoBookings: Tm3BookingAudit[];
    public meta: { [index:string]: Object; };

    public constructor(init?: Partial<AppointmentBookingInfoResponse>) { (Object as any).assign(this, init); }
}
(AppointmentBookingInfoResponse as unknown)[immerable] = true;

export class AppointmentSessionRestrictionGroupResponse
{
    public classification: string;
    public items: string[];

    public constructor(init?: Partial<AppointmentSessionRestrictionGroupResponse>) { (Object as any).assign(this, init); }
}
(AppointmentSessionRestrictionGroupResponse as unknown)[immerable] = true;

export class AppointmentSessionRestrictionsResponse
{
    public groups: AppointmentSessionRestrictionGroupResponse[];

    public constructor(init?: Partial<AppointmentSessionRestrictionsResponse>) { (Object as any).assign(this, init); }
}
(AppointmentSessionRestrictionsResponse as unknown)[immerable] = true;

export class CreateTemporaryAppointmentResponse
{
    public id: number;
    public backgroundJobId: string;

    public constructor(init?: Partial<CreateTemporaryAppointmentResponse>) { (Object as any).assign(this, init); }
}
(CreateTemporaryAppointmentResponse as unknown)[immerable] = true;

export class AppointmentPrepaidIncomeResponse
{
    public merchantReference: string;
    public data: { [index:string]: string; };
    public paymentIntentId: string;
    public isPrepayment: boolean;

    public constructor(init?: Partial<AppointmentPrepaidIncomeResponse>) { (Object as any).assign(this, init); }
}
(AppointmentPrepaidIncomeResponse as unknown)[immerable] = true;

export class Components
{
    public id?: string;
    public name?: string;
    public rate?: number;
    public compound?: boolean;

    public constructor(init?: Partial<Components>) { (Object as any).assign(this, init); }
}
(Components as unknown)[immerable] = true;

export enum TaxRateStatus
{
    Active = 'Active',
    Inactive = 'Inactive',
    Archived = 'Archived',
}

export class ExtendPaths
{
    public path: string;
    public value: Object;

    public constructor(init?: Partial<ExtendPaths>) { (Object as any).assign(this, init); }
}
(ExtendPaths as unknown)[immerable] = true;

export class PassThroughBody
{
    public serviceId: string;
    public operationId?: string;
    public extendObject?: { [index:string]: Object; };
    public extendPaths?: ExtendPaths[];

    public constructor(init?: Partial<PassThroughBody>) { (Object as any).assign(this, init); }
}
(PassThroughBody as unknown)[immerable] = true;

export class Subsidiaries
{
    public id?: string;

    public constructor(init?: Partial<Subsidiaries>) { (Object as any).assign(this, init); }
}
(Subsidiaries as unknown)[immerable] = true;

export class FiveType
{
    public value: string;

    public constructor(init?: Partial<FiveType>) { (Object as any).assign(this, init); }
}
(FiveType as unknown)[immerable] = true;

export class Five
{
    public str?: string;
    public number?: number;
    public boolean?: boolean;
    public mapOfAny?: { [index:string]: Object; };
    public type: FiveType;

    public constructor(init?: Partial<Five>) { (Object as any).assign(this, init); }
}
(Five as unknown)[immerable] = true;

export class ValueType
{
    public value: string;

    public constructor(init?: Partial<ValueType>) { (Object as any).assign(this, init); }
}
(ValueType as unknown)[immerable] = true;

export class Value
{
    public str?: string;
    public number?: number;
    public boolean?: boolean;
    public mapOfAny?: { [index:string]: Object; };
    public arrayOf5?: Five[];
    public type: ValueType;

    public constructor(init?: Partial<Value>) { (Object as any).assign(this, init); }
}
(Value as unknown)[immerable] = true;

export class CustomField
{
    public id?: string;
    public name?: string;
    public description?: string;
    public value?: Value;

    public constructor(init?: Partial<CustomField>) { (Object as any).assign(this, init); }
}
(CustomField as unknown)[immerable] = true;

export class TaxRate
{
    public id?: string;
    public displayId?: string;
    public name?: string;
    public code?: string;
    public description?: string;
    public effectiveTaxRate?: number;
    public country?: string;
    public totalTaxRate?: number;
    public taxPayableAccountId?: string;
    public taxRemittedAccountId?: string;
    public components?: Components[];
    public type?: string;
    public reportTaxType?: string;
    public originalTaxRateId?: string;
    public status?: TaxRateStatus;
    public customMappings?: { [index:string]: Object; };
    public rowVersion?: string;
    public updatedBy?: string;
    public createdBy?: string;
    public updatedAt?: string;
    public createdAt?: string;
    public passThrough?: PassThroughBody[];
    public subsidiaries?: Subsidiaries[];
    public customFields?: CustomField[];

    public constructor(init?: Partial<TaxRate>) { (Object as any).assign(this, init); }
}
(TaxRate as unknown)[immerable] = true;

export enum LedgerAccountClassification
{
    Asset = 'Asset',
    Equity = 'Equity',
    Expense = 'Expense',
    Liability = 'Liability',
    Revenue = 'Revenue',
    Income = 'Income',
    OtherIncome = 'OtherIncome',
    OtherExpense = 'OtherExpense',
    CostsOfSales = 'CostsOfSales',
    Other = 'Other',
}

export enum LedgerAccountType
{
    AccountsPayable = 'AccountsPayable',
    AccountsReceivable = 'AccountsReceivable',
    Balancesheet = 'Balancesheet',
    Bank = 'Bank',
    CostsOfSales = 'CostsOfSales',
    CreditCard = 'CreditCard',
    CurrentAsset = 'CurrentAsset',
    CurrentLiability = 'CurrentLiability',
    Equity = 'Equity',
    Expense = 'Expense',
    FixedAsset = 'FixedAsset',
    NonCurrentAsset = 'NonCurrentAsset',
    NonCurrentLiability = 'NonCurrentLiability',
    OtherAsset = 'OtherAsset',
    OtherExpense = 'OtherExpense',
    OtherIncome = 'OtherIncome',
    OtherLiability = 'OtherLiability',
    Revenue = 'Revenue',
    Sales = 'Sales',
    Other = 'Other',
}

export enum Currency
{
    UnknownCurrency = 'UnknownCurrency',
    Aed = 'Aed',
    Afn = 'Afn',
    All = 'All',
    Amd = 'Amd',
    Ang = 'Ang',
    Aoa = 'Aoa',
    Ars = 'Ars',
    Aud = 'Aud',
    Awg = 'Awg',
    Azn = 'Azn',
    Bam = 'Bam',
    Bbd = 'Bbd',
    Bdt = 'Bdt',
    Bgn = 'Bgn',
    Bhd = 'Bhd',
    Bif = 'Bif',
    Bmd = 'Bmd',
    Bnd = 'Bnd',
    Bob = 'Bob',
    Bov = 'Bov',
    Brl = 'Brl',
    Bsd = 'Bsd',
    Btn = 'Btn',
    Bwp = 'Bwp',
    Byr = 'Byr',
    Bzd = 'Bzd',
    Cad = 'Cad',
    Cdf = 'Cdf',
    Che = 'Che',
    Chf = 'Chf',
    Chw = 'Chw',
    Clf = 'Clf',
    Clp = 'Clp',
    Cny = 'Cny',
    Cop = 'Cop',
    Cou = 'Cou',
    Crc = 'Crc',
    Cuc = 'Cuc',
    Cup = 'Cup',
    Cve = 'Cve',
    Czk = 'Czk',
    Djf = 'Djf',
    Dkk = 'Dkk',
    Dop = 'Dop',
    Dzd = 'Dzd',
    Egp = 'Egp',
    Ern = 'Ern',
    Etb = 'Etb',
    Eur = 'Eur',
    Fjd = 'Fjd',
    Fkp = 'Fkp',
    Gbp = 'Gbp',
    Gel = 'Gel',
    Ghs = 'Ghs',
    Gip = 'Gip',
    Gmd = 'Gmd',
    Gnf = 'Gnf',
    Gtq = 'Gtq',
    Gyd = 'Gyd',
    Hkd = 'Hkd',
    Hnl = 'Hnl',
    Hrk = 'Hrk',
    Htg = 'Htg',
    Huf = 'Huf',
    Idr = 'Idr',
    Ils = 'Ils',
    Inr = 'Inr',
    Iqd = 'Iqd',
    Irr = 'Irr',
    Isk = 'Isk',
    Jmd = 'Jmd',
    Jod = 'Jod',
    Jpy = 'Jpy',
    Kes = 'Kes',
    Kgs = 'Kgs',
    Khr = 'Khr',
    Kmf = 'Kmf',
    Kpw = 'Kpw',
    Krw = 'Krw',
    Kwd = 'Kwd',
    Kyd = 'Kyd',
    Kzt = 'Kzt',
    Lak = 'Lak',
    Lbp = 'Lbp',
    Lkr = 'Lkr',
    Lrd = 'Lrd',
    Lsl = 'Lsl',
    Ltl = 'Ltl',
    Lvl = 'Lvl',
    Lyd = 'Lyd',
    Mad = 'Mad',
    Mdl = 'Mdl',
    Mga = 'Mga',
    Mkd = 'Mkd',
    Mmk = 'Mmk',
    Mnt = 'Mnt',
    Mop = 'Mop',
    Mro = 'Mro',
    Mur = 'Mur',
    Mvr = 'Mvr',
    Mwk = 'Mwk',
    Mxn = 'Mxn',
    Mxv = 'Mxv',
    Myr = 'Myr',
    Mzn = 'Mzn',
    Nad = 'Nad',
    Ngn = 'Ngn',
    Nio = 'Nio',
    Nok = 'Nok',
    Npr = 'Npr',
    Nzd = 'Nzd',
    Omr = 'Omr',
    Pab = 'Pab',
    Pen = 'Pen',
    Pgk = 'Pgk',
    Php = 'Php',
    Pkr = 'Pkr',
    Pln = 'Pln',
    Pyg = 'Pyg',
    Qar = 'Qar',
    Ron = 'Ron',
    Rsd = 'Rsd',
    Rub = 'Rub',
    Rwf = 'Rwf',
    Sar = 'Sar',
    Sbd = 'Sbd',
    Scr = 'Scr',
    Sdg = 'Sdg',
    Sek = 'Sek',
    Sgd = 'Sgd',
    Shp = 'Shp',
    Sll = 'Sll',
    Sos = 'Sos',
    Srd = 'Srd',
    Ssp = 'Ssp',
    Std = 'Std',
    Svc = 'Svc',
    Syp = 'Syp',
    Szl = 'Szl',
    Thb = 'Thb',
    Tjs = 'Tjs',
    Tmt = 'Tmt',
    Tnd = 'Tnd',
    Top = 'Top',
    Trc = 'Trc',
    Try = 'Try',
    Ttd = 'Ttd',
    Twd = 'Twd',
    Tzs = 'Tzs',
    Uah = 'Uah',
    Ugx = 'Ugx',
    Usd = 'Usd',
    Usn = 'Usn',
    Uss = 'Uss',
    Uyi = 'Uyi',
    Uyu = 'Uyu',
    Uzs = 'Uzs',
    Vef = 'Vef',
    Vnd = 'Vnd',
    Vuv = 'Vuv',
    Wst = 'Wst',
    Xaf = 'Xaf',
    Xag = 'Xag',
    Xau = 'Xau',
    Xba = 'Xba',
    Xbb = 'Xbb',
    Xbc = 'Xbc',
    Xbd = 'Xbd',
    Xcd = 'Xcd',
    Xdr = 'Xdr',
    Xof = 'Xof',
    Xpd = 'Xpd',
    Xpf = 'Xpf',
    Xpt = 'Xpt',
    Xts = 'Xts',
    Xxx = 'Xxx',
    Yer = 'Yer',
    Zar = 'Zar',
    Zmk = 'Zmk',
    Zmw = 'Zmw',
    Btc = 'Btc',
    Eth = 'Eth',
}

export class LinkedTaxRate
{
    public id?: string;
    public code?: string;
    public name?: string;
    public rate?: number;

    public constructor(init?: Partial<LinkedTaxRate>) { (Object as any).assign(this, init); }
}
(LinkedTaxRate as unknown)[immerable] = true;

export enum AccountStatus
{
    Active = 'Active',
    Inactive = 'Inactive',
    Archived = 'Archived',
}

export enum AccountType
{
    BankAccount = 'BankAccount',
    CreditCard = 'CreditCard',
    Other = 'Other',
}

export class BankAccount
{
    public bankName?: string;
    public accountNumber?: string;
    public accountName?: string;
    public accountType?: AccountType;
    public iban?: string;
    public bic?: string;
    public routingNumber?: string;
    public bsbNumber?: string;
    public branchIdentifier?: string;
    public bankCode?: string;
    public currency?: Currency;
    public country?: string;

    public constructor(init?: Partial<BankAccount>) { (Object as any).assign(this, init); }
}
(BankAccount as unknown)[immerable] = true;

export class Categories
{
    public id?: string;
    public name?: string;

    public constructor(init?: Partial<Categories>) { (Object as any).assign(this, init); }
}
(Categories as unknown)[immerable] = true;

export class ParentAccount
{
    public id?: string;
    public name?: string;
    public displayId?: string;

    public constructor(init?: Partial<ParentAccount>) { (Object as any).assign(this, init); }
}
(ParentAccount as unknown)[immerable] = true;

export class SubAccounts
{
    public id?: string;
    public accountSubName?: string;

    public constructor(init?: Partial<SubAccounts>) { (Object as any).assign(this, init); }
}
(SubAccounts as unknown)[immerable] = true;

export class LedgerAccountSubsidiaries
{
    public id?: string;

    public constructor(init?: Partial<LedgerAccountSubsidiaries>) { (Object as any).assign(this, init); }
}
(LedgerAccountSubsidiaries as unknown)[immerable] = true;

export class LedgerAccount
{
    public id?: string;
    public displayId?: string;
    public nominalCode?: string;
    public code?: string;
    public classification?: LedgerAccountClassification;
    public type?: LedgerAccountType;
    public subType?: string;
    public name?: string;
    public fullyQualifiedName?: string;
    public description?: string;
    public openingBalance?: number;
    public currentBalance?: number;
    public currency?: Currency;
    public taxType?: string;
    public taxRate?: LinkedTaxRate;
    public level?: number;
    public active?: boolean;
    public status?: AccountStatus;
    public header?: boolean;
    public bankAccount?: BankAccount;
    public categories?: Categories[];
    public parentAccount?: ParentAccount;
    public subAccount?: boolean;
    public subAccounts?: SubAccounts[];
    public lastReconciliationDate?: LocalDate;
    public subsidiaries?: LedgerAccountSubsidiaries[];
    public customMappings?: { [index:string]: Object; };
    public customFields?: CustomField[];
    public rowVersion?: string;
    public updatedBy?: string;
    public createdBy?: string;
    public updatedAt?: string;
    public createdAt?: string;
    public passThrough?: PassThroughBody[];

    public constructor(init?: Partial<LedgerAccount>) { (Object as any).assign(this, init); }
}
(LedgerAccount as unknown)[immerable] = true;

export class CaseAlertFlagsResponse
{
    public quickPicks: Lookup[];
    public id: number;
    public description: string;
    public value: string;

    public constructor(init?: Partial<CaseAlertFlagsResponse>) { (Object as any).assign(this, init); }
}
(CaseAlertFlagsResponse as unknown)[immerable] = true;

export class ClinicalSummaryFact
{
    public label: string;
    public value: string;

    public constructor(init?: Partial<ClinicalSummaryFact>) { (Object as any).assign(this, init); }
}
(ClinicalSummaryFact as unknown)[immerable] = true;

export class ClinicalSummaryConsultation
{
    public date: string;
    public sortDate: string;
    public note: string;

    public constructor(init?: Partial<ClinicalSummaryConsultation>) { (Object as any).assign(this, init); }
}
(ClinicalSummaryConsultation as unknown)[immerable] = true;

export class ClinicalSummaryCase
{
    public caseId?: number;
    public date: string;
    public sortDate: string;
    public admission: string;
    public bodySite: string;
    public status: string;
    public statusLabel: string;
    public painScale?: number;
    public dischargeReason: string;
    public consultations: ClinicalSummaryConsultation[];

    public constructor(init?: Partial<ClinicalSummaryCase>) { (Object as any).assign(this, init); }
}
(ClinicalSummaryCase as unknown)[immerable] = true;

export class ClinicalSummary
{
    public pmh: string;
    public facts: ClinicalSummaryFact[];
    public cases: ClinicalSummaryCase[];

    public constructor(init?: Partial<ClinicalSummary>) { (Object as any).assign(this, init); }
}
(ClinicalSummary as unknown)[immerable] = true;

export class AiResponse
{
    public summaryText: string;
    public summaryMarkdown: string;
    public summary: ClinicalSummary;
    public model: string;
    public requestId: string;
    public payloadChecksum: string;
    public tokenCost?: number;
    public confidenceScore?: number;
    public hallucinationRisk?: number;
    public hallucinationFindings: string[];
    public summaryCreatedDate?: string;

    public constructor(init?: Partial<AiResponse>) { (Object as any).assign(this, init); }
}
(AiResponse as unknown)[immerable] = true;

export class AiClinicalSummaryDto
{
    public id: number;
    public customerId: number;
    public data: string;
    public createdDate: string;
    public caseStatus?: number;

    public constructor(init?: Partial<AiClinicalSummaryDto>) { (Object as any).assign(this, init); }
}
(AiClinicalSummaryDto as unknown)[immerable] = true;

export class AiClinicalSummaryCaseResponse
{
    public caseId?: number;

    public constructor(init?: Partial<AiClinicalSummaryCaseResponse>) { (Object as any).assign(this, init); }
}
(AiClinicalSummaryCaseResponse as unknown)[immerable] = true;

export class SuggestedTaskDto
{
    public id: string;
    public description: string;
    public teamId: string;
    public teamName: string;
    public evidence: string;

    public constructor(init?: Partial<SuggestedTaskDto>) { (Object as any).assign(this, init); }
}
(SuggestedTaskDto as unknown)[immerable] = true;

export class SuggestedJourneyDto
{
    public id: string;
    public processId: string;
    public processName: string;
    public reason: string;
    public evidence: string;

    public constructor(init?: Partial<SuggestedJourneyDto>) { (Object as any).assign(this, init); }
}
(SuggestedJourneyDto as unknown)[immerable] = true;

export class SuggestedFollowUpAppointmentDto
{
    public id: string;
    public reason: string;
    public evidence: string;

    public constructor(init?: Partial<SuggestedFollowUpAppointmentDto>) { (Object as any).assign(this, init); }
}
(SuggestedFollowUpAppointmentDto as unknown)[immerable] = true;

export class SuggestedAlertDto
{
    public id: string;
    public title: string;
    public notes: string;
    public evidence: string;

    public constructor(init?: Partial<SuggestedAlertDto>) { (Object as any).assign(this, init); }
}
(SuggestedAlertDto as unknown)[immerable] = true;

export class ConsultationNextActionsResponse
{
    public tasks: SuggestedTaskDto[];
    public journeys: SuggestedJourneyDto[];
    public followUpAppointments: SuggestedFollowUpAppointmentDto[];
    public alerts: SuggestedAlertDto[];
    public message: string;
    public initiation: string;
    public model: string;
    public requestId: string;
    public tokenCost?: number;

    public constructor(init?: Partial<ConsultationNextActionsResponse>) { (Object as any).assign(this, init); }
}
(ConsultationNextActionsResponse as unknown)[immerable] = true;

export class ConsultationFieldAnswer
{
    public value: string;
    public confidence?: number;
    public evidence: string;

    public constructor(init?: Partial<ConsultationFieldAnswer>) { (Object as any).assign(this, init); }
}
(ConsultationFieldAnswer as unknown)[immerable] = true;

export class ConsultationStructureResponse
{
    public fields: { [index:string]: ConsultationFieldAnswer; };
    public notes: string;
    public model: string;
    public requestId: string;
    public tokenCost?: number;

    public constructor(init?: Partial<ConsultationStructureResponse>) { (Object as any).assign(this, init); }
}
(ConsultationStructureResponse as unknown)[immerable] = true;

export class GetAllAdvancedSearchFiltersResponse
{
    public existingFilterResults: SearchFilter[];
    public searchConditions: SearchFilterCondition[];
    public term: string;

    public constructor(init?: Partial<GetAllAdvancedSearchFiltersResponse>) { (Object as any).assign(this, init); }
}
(GetAllAdvancedSearchFiltersResponse as unknown)[immerable] = true;

export class VaultSessionResponse
{
    public sessionToken: string;

    public constructor(init?: Partial<VaultSessionResponse>) { (Object as any).assign(this, init); }
}
(VaultSessionResponse as unknown)[immerable] = true;

export class GetInitialRegistrationSessionTokenResponse extends VaultSessionResponse
{

    public constructor(init?: Partial<GetInitialRegistrationSessionTokenResponse>) { super(init); (Object as any).assign(this, init); }
}
(GetInitialRegistrationSessionTokenResponse as unknown)[immerable] = true;

export enum TrackingCategoryStatus
{
    Active = 'Active',
    Inactive = 'Inactive',
}

export class AccountingTrackingCategory
{
    public trackingCategoryID: string;
    public name: string;
    public status: TrackingCategoryStatus;
    public key: string;
    public displayName: string;
    public parentId: string;
    public parentName: string;
    public optionId: string;
    public optionName: string;
    public legacyDisplayName: string;

    public constructor(init?: Partial<AccountingTrackingCategory>) { (Object as any).assign(this, init); }
}
(AccountingTrackingCategory as unknown)[immerable] = true;

export class AccountingSystemProviderInfo
{
    public displayName: string;
    public accountingSystemName: AccountingSystemProviderName;
    public imageUrl: string;
    public serviceId: string;

    public constructor(init?: Partial<AccountingSystemProviderInfo>) { (Object as any).assign(this, init); }
}
(AccountingSystemProviderInfo as unknown)[immerable] = true;

export class AllAccountingConfigAndSettings
{
    public accountingSettings: AccountingSettingInfo[];
    public allowedAccountingIntegrations: AccountingSystemProviderInfo[];

    public constructor(init?: Partial<AllAccountingConfigAndSettings>) { (Object as any).assign(this, init); }
}
(AllAccountingConfigAndSettings as unknown)[immerable] = true;

export enum AccountingPaymentType
{
    Overpayment = 'Overpayment',
    Prepayment = 'Prepayment',
    Refund = 'Refund',
}

export class IncomingAccountingPaymentResponse
{
    public accountingPaymentType: AccountingPaymentType;
    public paymentDate?: string;
    public totalAmount: number;
    public incomingPaymentId: string;
    public paymentMethod: string;
    public invoiceAllocationAmount: number;
    public remainingAmount: number;
    public paymentStatus: string;

    public constructor(init?: Partial<IncomingAccountingPaymentResponse>) { (Object as any).assign(this, init); }
}
(IncomingAccountingPaymentResponse as unknown)[immerable] = true;

export enum AccountingApiSyncState
{
    Initiated = 'Initiated',
    Success = 'Success',
    Failure = 'Failure',
    RateLimit = 'RateLimit',
    PayFailure = 'PayFailure',
}

export enum InvoiceTransactionEvent
{
    None = 'None',
    NewInvoiceCreate = 'NewInvoiceCreate',
    InvoiceUpdate = 'InvoiceUpdate',
    InvoiceDelete = 'InvoiceDelete',
    InvoiceTransfer = 'InvoiceTransfer',
    InvoiceChange = 'InvoiceChange',
    UseCharge = 'UseCharge',
    CreateCharges = 'CreateCharges',
    ChargeRemove = 'ChargeRemove',
    ChargeDelete = 'ChargeDelete',
    ChargeUpdate = 'ChargeUpdate',
}

export enum PaymentTransactionEvent
{
    None = 'None',
    PaymentCreate = 'PaymentCreate',
    PaymentUpdate = 'PaymentUpdate',
    PaymentDelete = 'PaymentDelete',
    PaymentReconcile = 'PaymentReconcile',
    MultiplePaymentsPerInvoiceReconcile = 'MultiplePaymentsPerInvoiceReconcile',
    PaymentUpdateReconciliation = 'PaymentUpdateReconciliation',
    PaymentUnReconcile = 'PaymentUnReconcile',
    PaymentRefund = 'PaymentRefund',
}

export class InvoiceWithAccountingSystemInfo extends Invoice
{
    public invoiceId: number;
    public systemId: string;
    public systemName: AccountingSystemProviderName;
    public systemInvoiceStatus: string;
    public accountingSystemInvoiceId: string;

    public constructor(init?: Partial<InvoiceWithAccountingSystemInfo>) { super(init); (Object as any).assign(this, init); }
}
(InvoiceWithAccountingSystemInfo as unknown)[immerable] = true;

export class IncomeWithAccountingSystemInfo extends Income
{
    public incomeId: number;
    public systemId: string;
    public systemName: AccountingSystemProviderName;
    public accountingSystemPaymentId: string;
    public accountingPaymentType: AccountingPaymentType;
    public systemPaymentStatus: string;

    public constructor(init?: Partial<IncomeWithAccountingSystemInfo>) { super(init); (Object as any).assign(this, init); }
}
(IncomeWithAccountingSystemInfo as unknown)[immerable] = true;

export class BillingItemWithAccountingSystemInfo extends BillingItem
{
    public billingItemId: number;
    public systemId: string;
    public systemName: AccountingSystemProviderName;
    public accountingSystemLineItemId: string;
    public accountingSystemCreditNoteId: string;
    public creditNoteAllocationId: string;

    public constructor(init?: Partial<BillingItemWithAccountingSystemInfo>) { super(init); (Object as any).assign(this, init); }
}
(BillingItemWithAccountingSystemInfo as unknown)[immerable] = true;

export class IncomeWithInvoicePayment extends InvoicePayment
{
    public paymentMethod: string;
    public otherPaymentMethod: string;
    public date?: string;
    public reference: string;
    public paidBy: string;
    public notes: string;
    public cardType: string;
    public cardNumber: string;
    public expiry: string;
    public chequeNumber: string;
    public migrated?: boolean;
    public paymentAmount?: number;
    public transferred?: string;
    public lodgementReference: string;
    public merchantReference: string;
    public status: string;
    public accountingSystemInvoiceId: string;
    public accountingSystemPaymentId: string;

    public constructor(init?: Partial<IncomeWithInvoicePayment>) { super(init); (Object as any).assign(this, init); }
}
(IncomeWithInvoicePayment as unknown)[immerable] = true;

export class InvoicePaymentWithAccountingSystemInfo extends IncomeWithInvoicePayment
{
    public invoicePaymentId: number;
    public systemId: string;
    public systemName: AccountingSystemProviderName;
    public accountingSystemAllocationId: string;

    public constructor(init?: Partial<InvoicePaymentWithAccountingSystemInfo>) { super(init); (Object as any).assign(this, init); }
}
(InvoicePaymentWithAccountingSystemInfo as unknown)[immerable] = true;

export class AccountingTransactionSyncJobRequest
{
    public batchId: string;
    public invoiceId: number;
    public transferredInvoiceId?: number;
    public invoiceEvent: InvoiceTransactionEvent;
    public paymentId: number;
    public refundPaymentId: number;
    public paymentEvent: PaymentTransactionEvent;
    public paymentType: AccountingPaymentType;
    public chargeIdToRemove: number;
    public invoicesToReconcile: number[];
    public multiplePaymentsToReconcile: number[];
    public invoiceToDelete: InvoiceWithAccountingSystemInfo;
    public paymentToDelete: IncomeWithAccountingSystemInfo;
    public chargeToDelete: BillingItemWithAccountingSystemInfo;
    public isCreditTypeBillingItem: boolean;
    public billingItemCategory: string;
    public creditNoteIdToReconcile: number;
    public invoicePaymentsToUnReconcile: InvoicePaymentWithAccountingSystemInfo[];
    public subTransactionProcess: AccountingTransactionSyncJobRequest;

    public constructor(init?: Partial<AccountingTransactionSyncJobRequest>) { (Object as any).assign(this, init); }
}
(AccountingTransactionSyncJobRequest as unknown)[immerable] = true;

export class AccountingApiSyncHistory implements IHasId
{
    public id: number;
    public batchId: string;
    public syncDateTime: string;
    public systemName: AccountingSystemProviderName;
    public apiSyncState: AccountingApiSyncState;
    public transactionDto: AccountingTransactionSyncJobRequest;
    public invoiceId?: number;
    public paymentId?: number;
    public invoiceEvent: InvoiceTransactionEvent;
    public paymentEvent: PaymentTransactionEvent;
    public requestUrl: string;
    public requestDescription: string;
    public requestPayload: string;
    public requestDuration: number;
    public statusCode: string;
    public responsePayload: string;
    public error: string;

    public constructor(init?: Partial<AccountingApiSyncHistory>) { (Object as any).assign(this, init); }
}
(AccountingApiSyncHistory as unknown)[immerable] = true;

export class AccountingApiSyncHistorySearchResponse extends AccountingApiSyncHistory
{

    public constructor(init?: Partial<AccountingApiSyncHistorySearchResponse>) { super(init); (Object as any).assign(this, init); }
}
(AccountingApiSyncHistorySearchResponse as unknown)[immerable] = true;

export class VirtualReceptionSlot
{
    public slotId: string;
    public startDateTime: string;
    public endDateTime: string;
    public practitionerName: string;
    public locationName: string;

    public constructor(init?: Partial<VirtualReceptionSlot>) { (Object as any).assign(this, init); }
}
(VirtualReceptionSlot as unknown)[immerable] = true;

export class VirtualReceptionAppointmentTypeResponse
{
    public id: string;
    public name: string;
    public description: string;
    public isOnline: boolean;
    public category: string;

    public constructor(init?: Partial<VirtualReceptionAppointmentTypeResponse>) { (Object as any).assign(this, init); }
}
(VirtualReceptionAppointmentTypeResponse as unknown)[immerable] = true;

export class VirtualReceptionPatientSearchResponse
{
    public id: number;
    public forename: string;
    public surname: string;
    public dateOfBirth: string;
    public email: string;
    public phone: string;
    public postcode: string;

    public constructor(init?: Partial<VirtualReceptionPatientSearchResponse>) { (Object as any).assign(this, init); }
}
(VirtualReceptionPatientSearchResponse as unknown)[immerable] = true;

export class VirtualReceptionPatientAppointment
{
    public id: number;
    public startDateTime: string;
    public endDateTime: string;
    public location: string;
    public practitionerFullName: string;
    public cancellationFee?: number;

    public constructor(init?: Partial<VirtualReceptionPatientAppointment>) { (Object as any).assign(this, init); }
}
(VirtualReceptionPatientAppointment as unknown)[immerable] = true;

export class RegisterVirtualReceptionResponse
{
    public tenantId: string;

    public constructor(init?: Partial<RegisterVirtualReceptionResponse>) { (Object as any).assign(this, init); }
}
(RegisterVirtualReceptionResponse as unknown)[immerable] = true;

export class VirtualReceptionSessionResponse
{
    public tenantId: string;
    public sessionToken: string;
    public expiry: number;
    public apiEndpoint: string;

    public constructor(init?: Partial<VirtualReceptionSessionResponse>) { (Object as any).assign(this, init); }
}
(VirtualReceptionSessionResponse as unknown)[immerable] = true;

export class SyncVirtualReceptionConfigResponse
{
    public ok: boolean;
    public syncedAt: string;

    public constructor(init?: Partial<SyncVirtualReceptionConfigResponse>) { (Object as any).assign(this, init); }
}
(SyncVirtualReceptionConfigResponse as unknown)[immerable] = true;

export class PhioConfigResponse
{
    public baseUrl: string;
    public accountName: string;
    public email: string;

    public constructor(init?: Partial<PhioConfigResponse>) { (Object as any).assign(this, init); }
}
(PhioConfigResponse as unknown)[immerable] = true;

export class DevFlagState
{
    public key: string;
    public displayName: string;
    public description: string;
    public enabled: boolean;

    public constructor(init?: Partial<DevFlagState>) { (Object as any).assign(this, init); }
}
(DevFlagState as unknown)[immerable] = true;

export class FeatureCatalogModule
{
    public id: string;
    public name: string;
    public description: string;
    public availabilityKind: string;
    public userConfigurableWhenEntitled: boolean;
    public legacyConfigKey: string;

    public constructor(init?: Partial<FeatureCatalogModule>) { (Object as any).assign(this, init); }
}
(FeatureCatalogModule as unknown)[immerable] = true;

export class LegacyFeatureFlagMigrationItem
{
    public configKey: string;
    public moduleId: string;
    public enabled: boolean;
    public alreadyEntitled: boolean;
    public willMigrate: boolean;
    public status: string;

    public constructor(init?: Partial<LegacyFeatureFlagMigrationItem>) { (Object as any).assign(this, init); }
}
(LegacyFeatureFlagMigrationItem as unknown)[immerable] = true;

export class SubscriptionResponse
{
    public id: number;
    public status: SubscriptionStatus;
    public startDate: string;
    public expiryDate?: string;
    public name: string;
    public packageId: string;
    public totalExVat: number;
    public vatRate: number;
    public totalIncVat: number;
    public locationId: number;
    public locationName: string;
    public practitionerForename: string;
    public practitionerSurname: string;
    public practitionerName: string;
    public customerForename: string;
    public customerSurname: string;
    public customerName: string;
    public customer: CustomerLiteDto;
    public practitionerId?: number;
    public nextDue?: string;
    public subscriptionInterval: number;
    public subscriptionIntervalUnit: SubscriptionRecurrenceInterval;
    public earliestAllowedCancellationDate?: string;
    public lastRunOn?: string;
    public bundles: PackageBundleResponse[];
    public customerId: number;
    public invoiceStatus: string;
    public invoiceStatusText: string;

    public constructor(init?: Partial<SubscriptionResponse>) { (Object as any).assign(this, init); }
}
(SubscriptionResponse as unknown)[immerable] = true;

export class SubscriptionHistoryResponse
{
    public billingItemItemId: number;
    public billingItemTotal: number;
    public invoiceId?: number;
    public invoiceStatus: string;
    public paymentMethod: string;
    public billingItemDate?: string;
    public invoiceDate?: string;
    public fullyPaidDate?: string;
    public invoiceReference: string;
    public invoiceStatusName: string;

    public constructor(init?: Partial<SubscriptionHistoryResponse>) { (Object as any).assign(this, init); }
}
(SubscriptionHistoryResponse as unknown)[immerable] = true;

export class BasicCardDetailsResponse
{
    public cardExists: boolean;
    public last4: string;

    public constructor(init?: Partial<BasicCardDetailsResponse>) { (Object as any).assign(this, init); }
}
(BasicCardDetailsResponse as unknown)[immerable] = true;

export class FullCardDetailsResponse extends CardDetails
{
    public cardExists: boolean;

    public constructor(init?: Partial<FullCardDetailsResponse>) { super(init); (Object as any).assign(this, init); }
}
(FullCardDetailsResponse as unknown)[immerable] = true;

export class DeleteCardDetailsResponse
{
    public success: boolean;

    public constructor(init?: Partial<DeleteCardDetailsResponse>) { (Object as any).assign(this, init); }
}
(DeleteCardDetailsResponse as unknown)[immerable] = true;

export class SquareOAuthResponse
{
    public success: boolean;
    public errorMessage: string;

    public constructor(init?: Partial<SquareOAuthResponse>) { (Object as any).assign(this, init); }
}
(SquareOAuthResponse as unknown)[immerable] = true;

export class SquareOAuthPermissionsResponse
{
    public permissions: string[];

    public constructor(init?: Partial<SquareOAuthPermissionsResponse>) { (Object as any).assign(this, init); }
}
(SquareOAuthPermissionsResponse as unknown)[immerable] = true;

export class ExcludedStockInfo
{
    public stockId?: number;
    public classTypeId?: number;
    public packageId: string;
    public name: string;
    public onlineId?: string;

    public constructor(init?: Partial<ExcludedStockInfo>) { (Object as any).assign(this, init); }
}
(ExcludedStockInfo as unknown)[immerable] = true;

export class PackageResponseBase
{
    public id: number;
    public reference: string;
    public totalPrice?: number;
    public description: string;
    public appointmentLength?: number;
    public groupLocationLocationId: number;
    public locationId?: number;
    public colour?: number;
    public online: boolean;
    public onlineGuid?: string;
    public inUse?: boolean;
    public priceExVAT?: number;
    public vatRate?: number;
    public vatAmount?: number;
    public costAmount?: number;
    public costVATRate?: number;
    public costExVAT?: number;
    public costVATAmount?: number;
    public longDescription: string;
    public ledgerCode: string;
    public category?: string;
    public level?: number;
    public minimumLevel?: number;
    public displayInPriceList?: boolean;
    public totalWorth: number;
    public supplierId?: number;
    public serviceTypeId?: number;
    public isPrivateCharge?: boolean;
    public stockIsCancel: boolean;
    public stockIsFirst: boolean;
    public stockIsFollowUp: boolean;
    public stockIsDNA: boolean;
    public isMultiple?: boolean;
    public groupName: string;
    public overrides: StockOverrideResponse[];
    public colourCss: string;
    public validForDaysFromPurchase?: number;
    public isSubscriptionType: boolean;
    public subscriptionInterval: number;
    public subscriptionIntervalUnit: SubscriptionRecurrenceInterval;
    public hasMinimumTerm: boolean;
    public minimumTermValue: number;
    public minimumTermInterval: number;
    public minimumTermIntervalUnit: SubscriptionRecurrenceInterval;
    public hasMaximumTerm: boolean;
    public maximumTermValue: number;
    public maximumTermInterval: number;
    public maximumTermIntervalUnit: SubscriptionRecurrenceInterval;
    public onePerCustomer: boolean;
    public newCustomersOnly: boolean;
    public allowDiscountCodes: boolean;
    public hasValidityPeriod: boolean;
    public validFrom?: string;
    public validTo?: string;
    public termsAndConditionsFormId?: string;
    public updateExistingSubscriptionsToUseNewBundles: boolean;
    public urlSlug: string;
    public imageName: string;
    public ledgerCodeOverrides: AccountingStockLedgerLookup[];
    public legderCodeAccountId: string;
    public creditAmount?: number;
    public packageType: PackageType;
    public excludedStock: ExcludedStockInfo[];
    public excludedClasses: ExcludedStockInfo[];
    public allExcludedClassNames: string[];
    public restrictToPrivateCharges: boolean;
    public eligibleForTaxExemption: boolean;
    public tags: string[];

    public constructor(init?: Partial<PackageResponseBase>) { (Object as any).assign(this, init); }
}
(PackageResponseBase as unknown)[immerable] = true;

export class PackageResponse extends PackageResponseBase implements IPrivateOnlyCharge
{
    public bundles: PackageBundleResponse[];
    public expirationValue: number;
    public quantityThreshold: number;
    public used?: number;

    public constructor(init?: Partial<PackageResponse>) { super(init); (Object as any).assign(this, init); }
}
(PackageResponse as unknown)[immerable] = true;

export class OnlineClientPortalCaseResponse
{
    public id: number;
    public workflowId: number;
    public subWorkflowId?: number;
    public reference: number;
    public serviceName: string;
    public statusName: string;
    public statusColour: string;
    public hasAppointments?: boolean;

    public constructor(init?: Partial<OnlineClientPortalCaseResponse>) { (Object as any).assign(this, init); }
}
(OnlineClientPortalCaseResponse as unknown)[immerable] = true;

export class OnlineAppointmentHistoryResult
{
    public appointmentId: number;
    public classAttendanceId?: number;
    public isCourse?: number;
    public startDateTime: string;
    public endDateTime: string;
    public status: number;
    public locationName: string;
    public onlineGuid: string;
    public locationGuid: string;
    public title: string;
    public forename: string;
    public surname: string;
    public practitionerName: string;
    public totalPrice: number;
    public overridePrice: number;
    public name: string;
    public type: string;
    public day: number;
    public prePaidId?: number;
    public serviceId?: string;
    public canCancel: boolean;
    public videoMeetingProvider?: VideoMeetingProvider;
    public videoMeetingParticipantJoinUrl: string;
    public isVideo: boolean;
    public videoCode: string;
    public isCaseflow: boolean;
    // @Ignore()
    public isConnectService: boolean;

    public bookingMethod: string;
    public billingItemId?: number;

    public constructor(init?: Partial<OnlineAppointmentHistoryResult>) { (Object as any).assign(this, init); }
}
(OnlineAppointmentHistoryResult as unknown)[immerable] = true;

export class CourseAttendeeResponse
{
    public id: number;
    public customerId: number;
    public name: string;
    public hasBilled: boolean;
    public hasPaid: boolean;
    public courseId?: number;
    public courseSessionId?: number;
    public invoiceId?: number;
    public billingItemId?: number;
    public prePaidId?: number;
    public invoiceStatus?: string;
    public customerForename: string;
    public customerSurname: string;
    public customerName: string;
    public customerEmail: string;
    public customerMobileTelephone: string;
    public customerSMSEnabled: boolean;
    public canCommunicate: boolean;

    public constructor(init?: Partial<CourseAttendeeResponse>) { (Object as any).assign(this, init); }
}
(CourseAttendeeResponse as unknown)[immerable] = true;

export class CourseResponse
{
    public id: number;
    public online: boolean;
    public startDate: string;
    public type: ClassTypeResponse;
    public sessions: ClassSessionBaseResponse[];
    public courseAttendees: CourseAttendeeResponse[];
    public totalAttendance: number;
    public waitingListEnrolled: WaitingListWithDetails[];
    public locationName: string;
    public roomName: string;
    public locationId: number;
    public practitionerId: number;
    public roomId?: number;
    public minAttendees: number;
    public maxAttendees: number;
    public locationGuid: string;
    public classTypeId?: number;
    public practitionerName: string;

    public constructor(init?: Partial<CourseResponse>) { (Object as any).assign(this, init); }
}
(CourseResponse as unknown)[immerable] = true;

export class WaitingListResponse
{
    public lists: { [index:string]: WaitingListWithDetails[]; };

    public constructor(init?: Partial<WaitingListResponse>) { (Object as any).assign(this, init); }
}
(WaitingListResponse as unknown)[immerable] = true;

export class OnlineLocationDto
{
    public id: number;
    public name: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public addressLine5: string;
    public postCode: string;
    public address: string;
    public telephone: string;
    public email: string;
    public web: string;
    public fax: string;
    public status: number;
    public onlineGuid: string;
    public facilities: string;
    public locationLat: number;
    public locationLong: number;
    public latLong: number[];
    public hasCoordinates?: boolean;
    public isMainLocation: boolean;
    public merchantReference: string;

    public constructor(init?: Partial<OnlineLocationDto>) { (Object as any).assign(this, init); }
}
(OnlineLocationDto as unknown)[immerable] = true;

export class OnlineWorkflowCaseDetails
{
    public id: number;
    public maxTreatments: number;
    public usedTreatments: number;
    public groupId?: number;
    public creationDate?: string;
    public locationId?: string;
    public productId?: string;
    public productServiceId?: string;
    public capturePointServiceId?: string;
    public connectServiceId?: string;
    public isFollowUp: boolean;
    public code: string;
    public canBook: boolean;
    public canBookFirstAppointment: boolean;

    public constructor(init?: Partial<OnlineWorkflowCaseDetails>) { (Object as any).assign(this, init); }
}
(OnlineWorkflowCaseDetails as unknown)[immerable] = true;

export class BusinessCategoryResponse
{
    public isMatch: boolean;
    public reason: string;
    public categories: OnlineServiceCategory[];
    public services: OnlineClinicService[];

    public constructor(init?: Partial<BusinessCategoryResponse>) { (Object as any).assign(this, init); }
}
(BusinessCategoryResponse as unknown)[immerable] = true;

export class MyDiaryResponse
{
    public appointments: OnlineAppointmentHistoryResult[];
    public classes: OnlineAppointmentHistoryResult[];
    public courses: CourseResponse[];
    public waitingLists: WaitingListResponse;
    public additionalLocations: OnlineLocationDto[];
    public workflowCases: OnlineWorkflowCaseDetails[];
    public customerId: number;
    public services: BusinessCategoryResponse;

    public constructor(init?: Partial<MyDiaryResponse>) { (Object as any).assign(this, init); }
}
(MyDiaryResponse as unknown)[immerable] = true;

export class DualAppointmentConfirmResponse
{
    public primary: AppointmentSummary;
    public companion: AppointmentSummary;
    public paymentId?: number;
    public invoiceId?: number;

    public constructor(init?: Partial<DualAppointmentConfirmResponse>) { (Object as any).assign(this, init); }
}
(DualAppointmentConfirmResponse as unknown)[immerable] = true;

export class AdditionalServicesAppointmentConfirmResponse
{
    public primary: AppointmentSummary;
    public addOns: AppointmentSummary[];
    public paymentId?: number;
    public invoiceId?: number;

    public constructor(init?: Partial<AdditionalServicesAppointmentConfirmResponse>) { (Object as any).assign(this, init); }
}
(AdditionalServicesAppointmentConfirmResponse as unknown)[immerable] = true;

export class OnlinePatientFormResponse
{
    public lookups: LookupResponse[];
    public nestedLists: NestedLookup[];
    public id: number;
    public globalId: string;
    public templateId: string;
    public reportData: string;
    public submissionDate?: string;
    public completionDate?: string;
    public lastEditedDate?: string;
    public lastEdited?: string;
    public patientId: number;
    public caseId?: number;
    public status: number;
    public templateName: string;
    public templateDescription: string;
    public templateBody: string;
    public templateType: string;
    public psfs: Psfs[];
    public templateFormat: BlockTemplateFormat;

    public constructor(init?: Partial<OnlinePatientFormResponse>) { (Object as any).assign(this, init); }
}
(OnlinePatientFormResponse as unknown)[immerable] = true;

export class OnlineCancellationOptions
{
    public chargeApplies: boolean;
    public isPrePaid: boolean;
    public isCreditBasedPackage: boolean;
    public prePaidId?: number;
    public totalPaid: number;
    public cancellationCreditCharge?: number;
    public cancellationCharge?: number;
    public cancellationChargeExVat?: number;
    public stockId: number;

    public constructor(init?: Partial<OnlineCancellationOptions>) { (Object as any).assign(this, init); }
}
(OnlineCancellationOptions as unknown)[immerable] = true;

export class OnlineCancellationOptionsResponse
{
    public cancellationOptions: OnlineCancellationOptions;
    public cardDetails: CardDetails;
    public cancellationReasons: string[];

    public constructor(init?: Partial<OnlineCancellationOptionsResponse>) { (Object as any).assign(this, init); }
}
(OnlineCancellationOptionsResponse as unknown)[immerable] = true;

export class OnlineInvoiceBillingItem
{
    public itemPrice: number;
    public description: string;

    public constructor(init?: Partial<OnlineInvoiceBillingItem>) { (Object as any).assign(this, init); }
}
(OnlineInvoiceBillingItem as unknown)[immerable] = true;

export class OnlineInvoice
{
    public id: number;
    public price: number;
    public date: string;
    public location: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public postCode: string;
    public isReceipt: boolean;
    public items: OnlineInvoiceBillingItem[];

    public constructor(init?: Partial<OnlineInvoice>) { (Object as any).assign(this, init); }
}
(OnlineInvoice as unknown)[immerable] = true;

export class OnlineInvoiceListResponse
{
    public receipts: OnlineInvoice[];

    public constructor(init?: Partial<OnlineInvoiceListResponse>) { (Object as any).assign(this, init); }
}
(OnlineInvoiceListResponse as unknown)[immerable] = true;

export class CreditBasedPackagePrePaidInfo extends PrePaid implements IPrivateOnlyCharge
{
    public stockOnlineGuid?: string;
    public restrictToPrivateCharges: boolean;
    public excludedClassTypes: ExcludedStockInfo[];
    public excludedStock: ExcludedStockInfo[];
    public packageName: string;

    public constructor(init?: Partial<CreditBasedPackagePrePaidInfo>) { super(init); (Object as any).assign(this, init); }
}
(CreditBasedPackagePrePaidInfo as unknown)[immerable] = true;

export class OnlinePaymentDetailsResponse
{
    public cardDetails: CardDetails;
    public packages: PackageResponse[];
    public creditBasedPackagesAvailable: CreditBasedPackagePrePaidInfo[];
    public hasCredit: boolean;
    public creditsAvailable: number;
    public hasPrePaid: boolean;
    public hasFutureCredit: boolean;
    public stockCreditValue?: number;

    public constructor(init?: Partial<OnlinePaymentDetailsResponse>) { (Object as any).assign(this, init); }
}
(OnlinePaymentDetailsResponse as unknown)[immerable] = true;

export class PackageBundleStatusResponse
{
    public quantity: number;
    public used: number;
    public total: number;
    public type: PackageBundleItemType;
    public items: PackageBundleItemResponse[];
    public packageId?: string;

    public constructor(init?: Partial<PackageBundleStatusResponse>) { (Object as any).assign(this, init); }
}
(PackageBundleStatusResponse as unknown)[immerable] = true;

export class CustomerPackagesResponse
{
    public id: string;
    public imageName: string;
    public colour?: number;
    public colourCss: string;
    public description: string;
    public totalPrice?: number;
    public bundles: PackageBundleStatusResponse[];
    public expiryDate?: string;
    public isSubscription?: boolean;
    public prePaidId: number;
    public billingItemId: number;
    public urlSlug: string;
    public status: PrePaidStatus;
    public validForDaysFromPurchase?: number;
    public packageType: PackageType;
    public creditAmount?: number;
    public creditsUsed?: number;
    public excludedStock: ExcludedStockInfo[];
    public excludedClasses: ExcludedStockInfo[];
    public allExcludedClassNames: string[];

    public constructor(init?: Partial<CustomerPackagesResponse>) { (Object as any).assign(this, init); }
}
(CustomerPackagesResponse as unknown)[immerable] = true;

export class CustomerSubscriptionResponse extends CustomerPackagesResponse
{
    public subscriptionId: number;
    public ableToCancel: boolean;
    public subscriptionStatus?: SubscriptionStatus;
    public subscriptionInterval: number;
    public earliestAllowedCancellationDate?: string;
    public subscriptionIntervalUnit: SubscriptionRecurrenceInterval;

    public constructor(init?: Partial<CustomerSubscriptionResponse>) { super(init); (Object as any).assign(this, init); }
}
(CustomerSubscriptionResponse as unknown)[immerable] = true;

export class OnlineMyPackagesResponse
{
    public packages: CustomerPackagesResponse[];
    public subscriptions: CustomerSubscriptionResponse[];

    public constructor(init?: Partial<OnlineMyPackagesResponse>) { (Object as any).assign(this, init); }
}
(OnlineMyPackagesResponse as unknown)[immerable] = true;

export class BuyPackageResponse
{
    public success: boolean;

    public constructor(init?: Partial<BuyPackageResponse>) { (Object as any).assign(this, init); }
}
(BuyPackageResponse as unknown)[immerable] = true;

export class ToursModel
{
    public homeScreenTour1: boolean;
    public diaryWorkingTimeTour1: boolean;
    public diaryCreateTour1: boolean;
    public diaryEditTour1: boolean;
    public diaryCompleteTour1: boolean;
    public diaryEventTour1: boolean;
    public invoiceWizardTour1: boolean;
    public licenseAgreement: boolean;
    public previewNewUx: boolean;
    public licenseAgreement0725: boolean;
    public seenWelcomeScreen: boolean;

    public constructor(init?: Partial<ToursModel>) { (Object as any).assign(this, init); }
}
(ToursModel as unknown)[immerable] = true;

export class User implements IHasId, IHasGlobalGuid
{
    public id: number;
    public name: string;
    public fullName: string;
    public current: boolean;
    public temporaryPassword: string;
    public migrated?: boolean;
    public email: string;
    public online: boolean;
    public type: string;
    public typeId?: number;
    public salt: string;
    public passwordHash: string;
    public locationId?: number;
    // @Ignore()
    public locationGuid?: string;

    public practitionerId?: number;
    // @Ignore()
    public practitionerGuid?: string;

    public position: string;
    public mobileNumber: string;
    public permissionId?: number;
    // @Ignore()
    public permissionGuid?: string;

    public passwordScore?: number;
    public passwordExpiry?: string;
    public tours: ToursModel;
    public saltBytes: string;
    public version: number;
    public status: number;
    // @Ignore()
    public onlineGuid: string;

    public globalGuid: string;
    public level: string;
    public verified: boolean;
    public avatar: string;
    public firstName: string;
    public lastName: string;
    public twoFactorSecret: string;
    public signatureRxIntegrationCode: string;
    public pinHash: string;
    public signature?: string;
    public cloudRxUserCode: string;
    public cloudRxClinicCode: string;
    public ssoProviderUserId: string;
    public ssoProviderName: string;
    public accountManager: boolean;

    public constructor(init?: Partial<User>) { (Object as any).assign(this, init); }
}
(User as unknown)[immerable] = true;

export class OnlineReportTemplateItem
{
    public id: string;
    public body: string;
    public name: string;
    public serviceTypeId?: number;

    public constructor(init?: Partial<OnlineReportTemplateItem>) { (Object as any).assign(this, init); }
}
(OnlineReportTemplateItem as unknown)[immerable] = true;

export class CaseflowTemplate
{
    public id: string;
    public name: string;
    public type: string;
    public groupGlobalId: string;
    public isActive: boolean;
    public isRemoved: boolean;
    public mandatoryFieldOverrides: { [index:string]: { [index:string]: boolean; }; };
    public labelOverrides: { [index:string]: { [index:string]: string; }; };
    public customLists: { [index:string]: { [index:string]: string; }; };
    public sections: OnlineReportTemplateItem[];
    public saveSections: string[];
    public lists: { [index:string]: NestedLookup; };
    public allowsAttachments: boolean;
    public requiresAttachment: boolean;
    public attachmentPromptText: string;
    public serviceTypeId?: string;

    public constructor(init?: Partial<CaseflowTemplate>) { (Object as any).assign(this, init); }
}
(CaseflowTemplate as unknown)[immerable] = true;

export class OnlineCaseflowFormResponse
{
    public lookups: LookupResponse[];
    public nestedLists: NestedLookup[];
    public productId: string;
    public template: CaseflowTemplate;

    public constructor(init?: Partial<OnlineCaseflowFormResponse>) { (Object as any).assign(this, init); }
}
(OnlineCaseflowFormResponse as unknown)[immerable] = true;

export enum WorkflowContactType
{
    Patient = 'Patient',
    Contact = 'Contact',
    GroupContact = 'GroupContact',
    NetworkLocation = 'NetworkLocation',
    NetworkClinician = 'NetworkClinician',
    Practitioner = 'Practitioner',
    Location = 'Location',
    Group = 'Group',
}

export class OnlineRole
{
    public id: string;
    public role: WorkflowContactType;
    public name: string;
    public stream: string;
    public canRefer: boolean;
    public isFinancial: boolean;
    public isAdministrative: boolean;
    public isClinical: boolean;
    public isClinicalAdmin: boolean;

    public constructor(init?: Partial<OnlineRole>) { (Object as any).assign(this, init); }
}
(OnlineRole as unknown)[immerable] = true;

export class OnlineCaseflowContact extends MedicalContactResponse
{
    public canRefer: boolean;
    public isFinancial: boolean;
    public isAdmin: boolean;
    public isClinical: boolean;
    public role: string;
    public roleDescription: string;
    public groupName: string;
    public groupId: number;

    public constructor(init?: Partial<OnlineCaseflowContact>) { super(init); (Object as any).assign(this, init); }
}
(OnlineCaseflowContact as unknown)[immerable] = true;

export enum ReportStatus
{
    Incomplete = 'Incomplete',
    Valid = 'Valid',
    Accepted = 'Accepted',
    Rejected = 'Rejected',
    Acknowleged = 'Acknowleged',
    Queried = 'Queried',
    Resubmitted = 'Resubmitted',
    Published = 'Published',
}

export class OnlineMyReportsResponse
{
    public id: number;
    public name: string;
    public needsApproval: boolean;
    public status: ReportStatus;
    public createdDate: string;
    public lastUpdateDate: string;

    public constructor(init?: Partial<OnlineMyReportsResponse>) { (Object as any).assign(this, init); }
}
(OnlineMyReportsResponse as unknown)[immerable] = true;

export class ReportTemplateItem
{
    public id: string;
    public body: string;
    public name: string;
    public serviceTypeId?: number;

    public constructor(init?: Partial<ReportTemplateItem>) { (Object as any).assign(this, init); }
}
(ReportTemplateItem as unknown)[immerable] = true;

export class CaseflowTemplateDto
{
    public id: string;
    public name: string;
    public type: string;
    public groupGlobalId: string;
    public isActive: boolean;
    public isRemoved: boolean;
    public mandatoryFieldOverrides: { [index:string]: { [index:string]: boolean; }; };
    public labelOverrides: { [index:string]: { [index:string]: string; }; };
    public customLists: { [index:string]: { [index:string]: string; }; };
    public sections: ReportTemplateItem[];
    public saveSections: string[];
    public lists: { [index:string]: NestedLookup; };
    public allowsAttachments: boolean;
    public requiresAttachment: boolean;
    public attachmentPromptText: string;
    public serviceTypeId?: string;

    public constructor(init?: Partial<CaseflowTemplateDto>) { (Object as any).assign(this, init); }
}
(CaseflowTemplateDto as unknown)[immerable] = true;

export class GetOnlineReportResponse
{
    public id: number;
    public name: string;
    public data: JsonField;
    public template: CaseflowTemplateDto;
    public createdDate: string;
    public lastUpdateDate: string;
    public needsApproval: boolean;
    public status: ReportStatus;

    public constructor(init?: Partial<GetOnlineReportResponse>) { (Object as any).assign(this, init); }
}
(GetOnlineReportResponse as unknown)[immerable] = true;

export class OnlineConnectReferralFormResponse
{
    public templateId: string;
    public templateName: string;
    public templateDescription: string;
    public templateBody: string;
    public templateType: string;
    public templateFormat: BlockTemplateFormat;
    public nestedLists: NestedLookup[];
    public lookups: LookupResponse[];
    public initialData: JsonField;

    public constructor(init?: Partial<OnlineConnectReferralFormResponse>) { (Object as any).assign(this, init); }
}
(OnlineConnectReferralFormResponse as unknown)[immerable] = true;

export class OnlineCategoryResponse
{
    public categories: OnlineServiceCategory[];
    public services: OnlineClinicService[];

    public constructor(init?: Partial<OnlineCategoryResponse>) { (Object as any).assign(this, init); }
}
(OnlineCategoryResponse as unknown)[immerable] = true;

export class OnlinePractitionerDto
{
    public id: string;
    public pId: number;
    public title: string;
    public forename: string;
    public surname: string;
    public name: string;
    public locationId: string;
    public practitionerId: string;
    public gender: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<OnlinePractitionerDto>) { (Object as any).assign(this, init); }
}
(OnlinePractitionerDto as unknown)[immerable] = true;

export class OnlineInitialResponse extends OnlineCategoryResponse
{
    public locations: OnlineLocationDto[];
    public practitioners: OnlinePractitionerDto[];
    public groups: Group[];
    public sections: OnlineSection[];
    public packages: PackageResponse[];
    public lookups: Lookup[];
    public dynamicLabels: DynamicLabelResponse[];
    public isWaitingListEnabled: boolean;
    public isCaseflow: boolean;
    public isJourneysEnabled: boolean;
    public isCaseflowPluginEnabled: boolean;
    public isMfaEnabled: boolean;
    public imagingProcedures: MedicalImagingProcedure[];

    public constructor(init?: Partial<OnlineInitialResponse>) { super(init); (Object as any).assign(this, init); }
}
(OnlineInitialResponse as unknown)[immerable] = true;

export class AvailabilitySession
{
    public date: string;
    public locationId: string;
    public practitionerId: string;

    public constructor(init?: Partial<AvailabilitySession>) { (Object as any).assign(this, init); }
}
(AvailabilitySession as unknown)[immerable] = true;

export class LocationFacility
{
    public id: string;
    public name: string;
    public icon: string;

    public constructor(init?: Partial<LocationFacility>) { (Object as any).assign(this, init); }
}
(LocationFacility as unknown)[immerable] = true;

export class OnlineNetworkLocation
{
    public distance?: number;
    public locationBusinessId: string;
    public locationId: string;
    public name: string;
    public publicDisplayName: string;
    public networkId: string;
    public networkName: string;
    public latLong: string;
    public hasCoordinates: boolean;
    public address: string;
    public addressLine1: string;
    public addressLine2: string;
    public locationProntoStatus: string;
    public telephone: string;
    public locationFacilities: LocationFacility[];

    public constructor(init?: Partial<OnlineNetworkLocation>) { (Object as any).assign(this, init); }
}
(OnlineNetworkLocation as unknown)[immerable] = true;

export class AppointmentDto
{
    public id: number;
    public startDateTime: string;
    public endDateTime: string;
    public name: string;
    public customerId: string;
    public practitionerId: number;
    public practitionerGuid: string;
    public locationId: number;
    public locationGuid: string;
    public status: number;
    public type: string;
    public reference: string;
    public roomId?: number;
    public stockId: string;
    public caseId?: number;
    public groupId?: number;
    public bookedBy?: number;
    public authId?: number;
    public serviceTypeId?: number;
    public firstAppointment?: boolean;
    public bookingMethod: string;
    public bookingDateTime?: string;
    public completedTime?: string;
    public duration?: number;
    public comment: string;
    public appointmentType: AppointmentType;
    public backgroundJobId: string;
    public videoCode: string;

    public constructor(init?: Partial<AppointmentDto>) { (Object as any).assign(this, init); }
}
(AppointmentDto as unknown)[immerable] = true;

export class ConnectQuickRegistrationResponse
{
    public id: number;
    public title: string;
    public forename: string;
    public surname: string;
    public email: string;
    public mobileTelephone: string;
    public gender: string;
    public dateOfBirth?: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public addressLine5: string;
    public postcode: string;

    public constructor(init?: Partial<ConnectQuickRegistrationResponse>) { (Object as any).assign(this, init); }
}
(ConnectQuickRegistrationResponse as unknown)[immerable] = true;

// @DataContract
export class AuthenticateResponse implements IHasSessionId, IHasBearerToken
{
    // @DataMember(Order=1)
    public userId: string;

    // @DataMember(Order=2)
    public sessionId: string;

    // @DataMember(Order=3)
    public userName: string;

    // @DataMember(Order=4)
    public displayName: string;

    // @DataMember(Order=5)
    public referrerUrl: string;

    // @DataMember(Order=6)
    public bearerToken: string;

    // @DataMember(Order=7)
    public refreshToken: string;

    // @DataMember(Order=8)
    public refreshTokenExpiry?: string;

    // @DataMember(Order=9)
    public profileUrl: string;

    // @DataMember(Order=10)
    public roles: string[];

    // @DataMember(Order=11)
    public permissions: string[];

    // @DataMember(Order=12)
    public authProvider: string;

    // @DataMember(Order=13)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=14)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<AuthenticateResponse>) { (Object as any).assign(this, init); }
}
(AuthenticateResponse as unknown)[immerable] = true;

// @Route("/tours/skip")
export class ToursResponse
{
    public homeScreenTour1: boolean;
    public diaryWorkingTimeTour1: boolean;
    public diaryCreateTour1: boolean;
    public diaryEditTour1: boolean;
    public diaryCompleteTour1: boolean;
    public diaryEventTour1: boolean;
    public invoiceWizardTour1: boolean;
    public licenseAgreement: boolean;
    public licenseAgreement0725: boolean;
    public seenWelcomeScreen: boolean;
    public previewNewUx: boolean;

    public constructor(init?: Partial<ToursResponse>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ToursResponse'; }
    public getMethod() { return 'PUT'; }
    public createResponse() {}
}
(ToursResponse as unknown)[immerable] = true;

export class CurrentUser extends AuthenticateResponse
{
    public id: string;
    public name: string;
    public lastName: string;
    public email: string;
    public mobileNumber: string;
    public clientId: number;
    public userType: string;
    public isAuthenticated: boolean;
    public isEvaluating: boolean;
    public settings: { [index:string]: Object; };
    public practitioner: GeneralPractitionerResponse;
    public location: LocationResponse;
    public roleId: number;
    public practitionerId?: number;
    public tM2UserName: string;
    public roleName: string;
    public userPermissionId?: number;
    public tours: ToursResponse;
    public departments: number[];
    public customer: OnlineCustomerDto;
    public userGlobalGuid: string;
    public hasTrialExpired: boolean;
    public needsVerified: boolean;
    public twoFactorSetup: boolean;
    public twoFactorRequired: boolean;
    public twoFactorAuthenticated: boolean;
    public hasPassKey: boolean;
    public twoFactorAllowSms: boolean;
    public avatar: string;
    public signatureRxIntegrationCode: string;
    public pinHash: string;
    public signature: string;
    public cloudRxUserCode: string;
    public cloudRxClinicCode: string;
    public pharmaciergeIntegrationCode: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CurrentUser>) { super(init); (Object as any).assign(this, init); }
}
(CurrentUser as unknown)[immerable] = true;

export class OnlineRegisterResponse extends ResponseBase<boolean>
{
    public success: boolean;
    public isSsoLogin: boolean;
    public oAuthProvider: string;
    public authenticatedUser: CurrentUser;

    public constructor(init?: Partial<OnlineRegisterResponse>) { super(init); (Object as any).assign(this, init); }
}
(OnlineRegisterResponse as unknown)[immerable] = true;

export class OnlineRegisterValidationResponse
{
    public emailValid: boolean;
    public mobileNumberValid: boolean;
    public message: string;
    public ignorePasswordCheck: boolean;

    public constructor(init?: Partial<OnlineRegisterValidationResponse>) { (Object as any).assign(this, init); }
}
(OnlineRegisterValidationResponse as unknown)[immerable] = true;

export class OnlineWaitingListReservationConfirmResponse
{
    public startDateTime: string;
    public endDateTime: string;
    public stockId: string;
    public courseId?: number;
    public classSessionId?: number;
    public hasClassSessionId: boolean;
    public stockDescription: string;
    public classTypeName: string;
    public bookingDateTime: string;
    public reservationEndDateTime: string;
    public duration?: number;
    public appointmentId?: number;
    public locationName: string;
    public locationId: number;
    public practitionerId: number;
    public appointmentStatus: number;
    public practitionerTitle: string;
    public practitionerForename: string;
    public practitionerSurname: string;
    public practitionerName: string;
    public isExpired: boolean;
    public customerTitle: string;
    public customerForename: string;
    public customerSurname: string;
    public customerName: string;
    public waitingListStatus: WaitingListStatus;
    public waitingListSubStatus?: WaitingListSubStatus;
    public waitingListType: WaitingListType;
    public courseSessions: ClassSessionBaseResponse[];
    public totalPrice: number;
    public priceExVAT: number;
    public linkedToAppointmentId?: number;
    public waitingListPaid: boolean;

    public constructor(init?: Partial<OnlineWaitingListReservationConfirmResponse>) { (Object as any).assign(this, init); }
}
(OnlineWaitingListReservationConfirmResponse as unknown)[immerable] = true;

export class ChasedPaymentDTO
{
    public paymentUrlCode: string;
    public paymentAmount: number;
    public paymentStatus: number;
    public locationId: number;
    public customerId: number;

    public constructor(init?: Partial<ChasedPaymentDTO>) { (Object as any).assign(this, init); }
}
(ChasedPaymentDTO as unknown)[immerable] = true;

export class GetSquareCustomerDetailsResponse
{
    public addressLines: string[];
    public familyName: string;
    public givenName: string;
    public email: string;
    public country: string;
    public phone: string;
    public region: string;
    public city: string;

    public constructor(init?: Partial<GetSquareCustomerDetailsResponse>) { (Object as any).assign(this, init); }
}
(GetSquareCustomerDetailsResponse as unknown)[immerable] = true;

export enum OnlineAutoLoginAuthenticationResult
{
    Success = 'Success',
    Fail = 'Fail',
    AccessCodeDoesntMatch = 'AccessCodeDoesntMatch',
    TokenDoesNotMatch = 'TokenDoesNotMatch',
    AccessCodeNotProvided = 'AccessCodeNotProvided',
    Expired = 'Expired',
    Redirect = 'Redirect',
    RegistrationRequired = 'RegistrationRequired',
}

export class ValidateBookingLinkResponse
{
    public service: OnlineClinicService;
    public locationId: string;
    public practitionerId: string;
    public groupId?: number;
    public token: string;
    public requireBackupCard: boolean;
    public authId?: number;

    public constructor(init?: Partial<ValidateBookingLinkResponse>) { (Object as any).assign(this, init); }
}
(ValidateBookingLinkResponse as unknown)[immerable] = true;

export class ConfirmCardFromBookingLinkResponse
{
    public hasCardDetails: boolean;

    public constructor(init?: Partial<ConfirmCardFromBookingLinkResponse>) { (Object as any).assign(this, init); }
}
(ConfirmCardFromBookingLinkResponse as unknown)[immerable] = true;

export class ChangeCardResponse
{
    public details: CardDetails;
    public paymentMethodId: string;
    public clientSecret: string;
    public paymentIntentId: string;

    public constructor(init?: Partial<ChangeCardResponse>) { (Object as any).assign(this, init); }
}
(ChangeCardResponse as unknown)[immerable] = true;

export class SeatEntitlementResponse
{
    public licenceType: string;
    public usedCount: number;
    public seatLimit: number;
    public isModular: boolean;

    public constructor(init?: Partial<SeatEntitlementResponse>) { (Object as any).assign(this, init); }
}
(SeatEntitlementResponse as unknown)[immerable] = true;

export class MsBillingItemResponse implements IHasId
{
    public id: number;
    public date?: string;
    public description: string;
    public totalExVAT: number;
    public quantity: number;
    public itemPrice: number;
    public vatRate: number;
    public totalVAT: number;
    public total: number;

    public constructor(init?: Partial<MsBillingItemResponse>) { (Object as any).assign(this, init); }
}
(MsBillingItemResponse as unknown)[immerable] = true;

export class MsInvoiceResponse
{
    public id: number;
    public reference: string;
    public addressTo: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public addressLine5: string;
    public postCode: string;
    public date?: string;
    public dueDate?: string;
    public fullyPaidDate?: string;
    public totalExcludingVAT: number;
    public vatAmount: number;
    public grandTotal: number;
    public amountPaid: number;
    public status: string;
    public paymentMethod: string;
    public locationId: number;
    public currencySymbol: string;
    public vatNumber: string;
    public salesStatus: string;
    public purchaseOrderNumber: string;
    public billingItems: MsBillingItemResponse[];
    public payments: Income[];
    public isBespoke: boolean;
    public creditNoteAmount: number;

    public constructor(init?: Partial<MsInvoiceResponse>) { (Object as any).assign(this, init); }
}
(MsInvoiceResponse as unknown)[immerable] = true;

export class Tm3License implements IHasId
{
    public id: number;
    public noOfDiarys: number;
    public modules: string[];
    public firstDiaryMonthly: number;
    public additionalDiaryMonthly: number;
    public firstDiaryMonthlyOverride: number;
    public additionalDiaryMonthlyOverride: number;
    public totalMonthly: number;
    public totalMonthlyPreDiscount: number;
    public totalMonthlyOverride: number;
    public totalMonthlyVatAmount: number;
    public creationDate: string;

    public constructor(init?: Partial<Tm3License>) { (Object as any).assign(this, init); }
}
(Tm3License as unknown)[immerable] = true;

export class GetClientPricingResponse
{
    public basePrice: number;
    public additionalPrice: number;
    public basePriceWithVAT: number;
    public additionalPriceWithVAT: number;
    public vatRate: number;
    public smsRate: number;
    public downgrading: number;
    public upgrading: number;

    public constructor(init?: Partial<GetClientPricingResponse>) { (Object as any).assign(this, init); }
}
(GetClientPricingResponse as unknown)[immerable] = true;

export class ConfirmClientSignUpResponse
{
    public success: boolean;

    public constructor(init?: Partial<ConfirmClientSignUpResponse>) { (Object as any).assign(this, init); }
}
(ConfirmClientSignUpResponse as unknown)[immerable] = true;

export class SaveClientPaymentDetailsResponse
{
    public clientSecret: string;

    public constructor(init?: Partial<SaveClientPaymentDetailsResponse>) { (Object as any).assign(this, init); }
}
(SaveClientPaymentDetailsResponse as unknown)[immerable] = true;

export class ClickPPCDetailsResponse
{
    public telehealthRate: number;
    public smsRate: number;
    public cardCommission: string;
    public formsRate: number;

    public constructor(init?: Partial<ClickPPCDetailsResponse>) { (Object as any).assign(this, init); }
}
(ClickPPCDetailsResponse as unknown)[immerable] = true;

export class ClickUpgradeDetailsResponse
{
    public upfront: number;
    public monthly: number;
    public cardCommission: string;

    public constructor(init?: Partial<ClickUpgradeDetailsResponse>) { (Object as any).assign(this, init); }
}
(ClickUpgradeDetailsResponse as unknown)[immerable] = true;

export class ClickTrialResponse
{
    public success: boolean;

    public constructor(init?: Partial<ClickTrialResponse>) { (Object as any).assign(this, init); }
}
(ClickTrialResponse as unknown)[immerable] = true;

export class ClickDowngradeResponse
{
    public success: boolean;

    public constructor(init?: Partial<ClickDowngradeResponse>) { (Object as any).assign(this, init); }
}
(ClickDowngradeResponse as unknown)[immerable] = true;

export class ClientDowngradeToSingleLicenseResponse
{
    public success: boolean;

    public constructor(init?: Partial<ClientDowngradeToSingleLicenseResponse>) { (Object as any).assign(this, init); }
}
(ClientDowngradeToSingleLicenseResponse as unknown)[immerable] = true;

export class ClientNoLongerWantsToCancelResponse
{
    public success: boolean;

    public constructor(init?: Partial<ClientNoLongerWantsToCancelResponse>) { (Object as any).assign(this, init); }
}
(ClientNoLongerWantsToCancelResponse as unknown)[immerable] = true;

export class ConfirmClientCancellationResponse
{
    public success: boolean;

    public constructor(init?: Partial<ConfirmClientCancellationResponse>) { (Object as any).assign(this, init); }
}
(ConfirmClientCancellationResponse as unknown)[immerable] = true;

export class MSCurrencyResponse
{
    public currencySymbol: string;
    public locationId: number;

    public constructor(init?: Partial<MSCurrencyResponse>) { (Object as any).assign(this, init); }
}
(MSCurrencyResponse as unknown)[immerable] = true;

export class MSSubscriptionResponse
{
    public date?: string;

    public constructor(init?: Partial<MSSubscriptionResponse>) { (Object as any).assign(this, init); }
}
(MSSubscriptionResponse as unknown)[immerable] = true;

export class CreditAutoTopUpAmountResponse
{
    public number: number;

    public constructor(init?: Partial<CreditAutoTopUpAmountResponse>) { (Object as any).assign(this, init); }
}
(CreditAutoTopUpAmountResponse as unknown)[immerable] = true;

export class SMSOrderHistoryResponse
{

    public constructor(init?: Partial<SMSOrderHistoryResponse>) { (Object as any).assign(this, init); }
}
(SMSOrderHistoryResponse as unknown)[immerable] = true;

export class BundleOption
{
    public number: number;
    public totalExVAT: number;
    public vatAmount: number;
    public total: number;
    public bundleType: string;

    public constructor(init?: Partial<BundleOption>) { (Object as any).assign(this, init); }
}
(BundleOption as unknown)[immerable] = true;

export class SMSBundleOptionsResponse
{
    public bundles: BundleOption[];
    public remaining: number;

    public constructor(init?: Partial<SMSBundleOptionsResponse>) { (Object as any).assign(this, init); }
}
(SMSBundleOptionsResponse as unknown)[immerable] = true;

export class ExtraSystemCreditResponse
{
    public amountPurchased: number;
    public purchaseDate: string;
    public amountRemaining: number;
    public expiryDate: string;

    public constructor(init?: Partial<ExtraSystemCreditResponse>) { (Object as any).assign(this, init); }
}
(ExtraSystemCreditResponse as unknown)[immerable] = true;

export class SystemCreditBundleOptionsResponse
{
    public bundles: BundleOption[];
    public remaining: number;
    public total: number;
    public extras: ExtraSystemCreditResponse[];

    public constructor(init?: Partial<SystemCreditBundleOptionsResponse>) { (Object as any).assign(this, init); }
}
(SystemCreditBundleOptionsResponse as unknown)[immerable] = true;

export class CreditOrderHistoryResponse
{

    public constructor(init?: Partial<CreditOrderHistoryResponse>) { (Object as any).assign(this, init); }
}
(CreditOrderHistoryResponse as unknown)[immerable] = true;

export class PayPerClickDetail
{
    public id: number;
    public date: string;
    public itemType: string;
    public itemId?: number;
    public itemGuid?: string;
    public userId: number;
    public practitionerId?: number;
    public locationId?: number;
    public locationName: string;
    public practitionerName: string;
    public userName: string;
    public includedInAllowance: boolean;
    public itemReference: string;
    public content: string;
    public value: number;

    public constructor(init?: Partial<PayPerClickDetail>) { (Object as any).assign(this, init); }
}
(PayPerClickDetail as unknown)[immerable] = true;

export class PayPerClickStats
{
    public activePractitioners: number;
    public paygPractitioners: number;
    public appointments: number;
    public paygAppointments: number;
    public classes: number;
    public paygClasses: number;
    public systemCredits: number;

    public constructor(init?: Partial<PayPerClickStats>) { (Object as any).assign(this, init); }
}
(PayPerClickStats as unknown)[immerable] = true;

export class PayPerClickStatsResponse
{
    public thisMonth: PayPerClickStats;
    public lastMonth: PayPerClickStats;

    public constructor(init?: Partial<PayPerClickStatsResponse>) { (Object as any).assign(this, init); }
}
(PayPerClickStatsResponse as unknown)[immerable] = true;

export class AccountAccessRestrictionResponse
{
    public restrictedToUserIds: number[];

    public constructor(init?: Partial<AccountAccessRestrictionResponse>) { (Object as any).assign(this, init); }
}
(AccountAccessRestrictionResponse as unknown)[immerable] = true;

export class CanAccessMyAccountResponse
{
    public canAccess: boolean;

    public constructor(init?: Partial<CanAccessMyAccountResponse>) { (Object as any).assign(this, init); }
}
(CanAccessMyAccountResponse as unknown)[immerable] = true;

export class UnrestrictedUserResponse
{
    public unrestricted: number[];

    public constructor(init?: Partial<UnrestrictedUserResponse>) { (Object as any).assign(this, init); }
}
(UnrestrictedUserResponse as unknown)[immerable] = true;

export class DiaryAnalysisReport
{
    public locationStatus: number;
    public locationName: string;
    // @Ignore()
    public practitionerName: string;

    public practitionerTitle: string;
    public practitionerForename: string;
    public practitionerSurname: string;
    public practitionerStatus: number;
    // @Ignore()
    public appointmentClassification: string;

    public groupId?: number;
    public groupName: string;
    public roomDescription: string;
    // @Ignore()
    public patientName: string;

    public customerTitle: string;
    public customerForename: string;
    public customerSurname: string;
    public email: string;
    public dateOfBirth?: string;
    public ageGrouping: string;
    public startDateTime: string;
    public appointmentName: string;
    // @Ignore()
    public details: string;

    public notes: string;
    public appointmentStatus: AppointmentStatus;
    public stockDescription: string;
    public isFirstAppointment: boolean;
    // @Ignore()
    public appointmentDescription: string;

    // @Ignore()
    public treatmentType: string;

    public appointmentType: string;
    // @Ignore()
    public diaryEventCategory: string;

    public bookingMethod: string;
    public bookingMethodText: string;
    public reason: string;
    // @Ignore()
    public cancellationReason: string;

    public username: string;
    // @Ignore()
    public bookedBy: string;

    public stockId?: number;
    public projectedIncome?: number;
    public authLeft: number;
    public _cancelMethod: string;
    // @Ignore()
    public cancelMethod: string;

    public _lastActionDateTime?: string;
    // @Ignore()
    public lastActionDateTime: string;

    public _lastActionUser: string;
    // @Ignore()
    public lastActionUser: string;

    public _prepaymentStatus?: string;
    // @Ignore()
    public prepaymentStatus: string;

    public _recallStatus: string;
    // @Ignore()
    public recallStatus: string;

    public constructor(init?: Partial<DiaryAnalysisReport>) { (Object as any).assign(this, init); }
}
(DiaryAnalysisReport as unknown)[immerable] = true;

export class DiaryAnalysisResponse
{
    public results: DiaryAnalysisReport[];
    public total: number;
    public totals: { [index:string]: number; };

    public constructor(init?: Partial<DiaryAnalysisResponse>) { (Object as any).assign(this, init); }
}
(DiaryAnalysisResponse as unknown)[immerable] = true;

export class NonReturningReportResponse
{
    public customerReference: string;
    public customerName: string;
    public totalAppointments: number;
    public lastAppointmentDate: string;
    public totalCharges: number;
    public practitionerName: string;
    public practitionerId: number;
    public locationName: string;
    public locationId: number;

    public constructor(init?: Partial<NonReturningReportResponse>) { (Object as any).assign(this, init); }
}
(NonReturningReportResponse as unknown)[immerable] = true;

export enum TrafficAttendance
{
    High = 'High',
    Low = 'Low',
}

export class TrafficReportResponse
{
    public customerId?: number;
    public accountId: number;
    public patientName: string;
    public totalAppointments: number;
    public booked: number;
    public completed: number;
    public dna: number;
    public cancelled: number;
    public totalClasses: number;
    public billedClient: number;
    public billedGroup: number;
    public attendance?: TrafficAttendance;
    public totalClassAttendance: number;
    public totalEvents: number;
    public bookingMethod: string;

    public constructor(init?: Partial<TrafficReportResponse>) { (Object as any).assign(this, init); }
}
(TrafficReportResponse as unknown)[immerable] = true;

export class AutopayReportResult
{
    public customerTitle: string;
    public customerForename: string;
    public customerSurname: string;
    // @Ignore()
    public customerName: string;

    public nextDue: string;
    public homeTelephone: string;
    public workTelephone: string;
    public mobileTelephone: string;
    public name: string;
    public totalIncVat: number;
    public status: SubscriptionStatus;
    // @Ignore()
    public number: string;

    public locationId: number;
    public locationName: string;
    public practitionerId: number;
    public practitionerTitle: string;
    public practitionerForename: string;
    public practitionerSurname: string;
    // @Ignore()
    public practitionerName: string;

    public expiresSoon: boolean;
    public hasStripe: boolean;
    public cardExpiresSoon: boolean;
    public expiryYear: number;
    public expiryMonth: number;
    public stripeCustomerId: string;
    public packageId: string;

    public constructor(init?: Partial<AutopayReportResult>) { (Object as any).assign(this, init); }
}
(AutopayReportResult as unknown)[immerable] = true;

export class GetSettingsResponse extends OnlineSettings
{
    public connectUrl: string;

    public constructor(init?: Partial<GetSettingsResponse>) { super(init); (Object as any).assign(this, init); }
}
(GetSettingsResponse as unknown)[immerable] = true;

export class CanDeleteImageResponse
{
    public isLogo: boolean;
    public isOffer: boolean;
    public isTitle: boolean;
    public packages: string[];
    public categories: string[];
    public services: string[];

    public constructor(init?: Partial<CanDeleteImageResponse>) { (Object as any).assign(this, init); }
}
(CanDeleteImageResponse as unknown)[immerable] = true;

export class BusinessSettingsIdResponse
{
    public settingsId: number;

    public constructor(init?: Partial<BusinessSettingsIdResponse>) { (Object as any).assign(this, init); }
}
(BusinessSettingsIdResponse as unknown)[immerable] = true;

export enum Gender
{
    Unspecified = 'Unspecified',
    Male = 'Male',
    Female = 'Female',
}

export class ClassSearchResult
{
    public id: number;
    public appointmentId: number;
    public courseId: number;
    public classTypeId: number;
    public stockId: number;
    public startDateTime: string;
    public endDateTime: string;
    public status: number;
    public locationId: number;
    public locationName: string;
    public onlineGuid: string;
    public price?: number;
    public priceExVat?: number;
    public creditValue?: number;
    public practitionerId: number;
    public practitionerForename: string;
    public practitionerSurname: string;
    public practitionerName: string;
    public practitionerGender: string;
    // @Ignore()
    public practGender: Gender;

    public isCourse: boolean;
    public name: string;
    public defaultMinAttendees: number;
    public defaultMaxAttendees: number;
    public stockOnlineGuid?: string;
    public waitingListEnrolled: WaitingListWithDetails[];
    public practitionerOnlineGuid: string;
    public isAttending: boolean;
    public courseSessionIndex: number;
    public courseTotalSessions: number;
    public serviceId: string;
    public paymentOption: number;
    public paymentOptionValue?: number;

    public constructor(init?: Partial<ClassSearchResult>) { (Object as any).assign(this, init); }
}
(ClassSearchResult as unknown)[immerable] = true;

export class ClassTypeBase implements IHasId
{
    public id: number;
    public name: string;
    public description: string;
    public imageUrl: string;
    public isCourse: boolean;
    public termsAndConditionsFormId: string;
    public colour?: number;
    public defaultSessionLength: number;
    public defaultMinAttendees: number;
    public defaultMaxAttendees: number;
    public isAvailableOnline: boolean;
    public cancellationChargeApplies: boolean;
    public cancellationHours: number;
    public cancellationStockId: number;
    public isCurrent: boolean;
    public isFavourite: boolean;
    public serviceTypeId: number;
    public isVideo: boolean;

    public constructor(init?: Partial<ClassTypeBase>) { (Object as any).assign(this, init); }
}

export class ClassType extends ClassTypeBase
{
    public lateTransferChargeApplies: boolean;
    public lateTransferHours?: number;
    public allowPayPerSession: boolean;
    public stockId?: number;
    public numberOfSessions: number;

    public constructor(init?: Partial<ClassType>) { super(init); (Object as any).assign(this, init); }
}
(ClassType as unknown)[immerable] = true;

export class ClassSearchResponse
{
    public classes: ClassSearchResult[];
    public locationIds: string[];
    public attendance: { [index:number]: number; };
    public classInfo: ClassType;
    public courseAppointmentDates: { [index:number]: string[]; };

    public constructor(init?: Partial<ClassSearchResponse>) { (Object as any).assign(this, init); }
}
(ClassSearchResponse as unknown)[immerable] = true;

export class SimilarClass
{
    public classSessionId: number;
    public startDateTime: string;

    public constructor(init?: Partial<SimilarClass>) { (Object as any).assign(this, init); }
}
(SimilarClass as unknown)[immerable] = true;

export class CreateConnectAppointmentlessJourneyResponse
{
    public workflowId?: number;
    public subWorkflowId?: number;
    public statusId?: string;
    public created: boolean;
    public message: string;

    public constructor(init?: Partial<CreateConnectAppointmentlessJourneyResponse>) { (Object as any).assign(this, init); }
}
(CreateConnectAppointmentlessJourneyResponse as unknown)[immerable] = true;

// @DataContract
export class ConvertSessionToTokenResponse
{
    // @DataMember(Order=1)
    public meta: { [index:string]: string; };

    // @DataMember(Order=2)
    public accessToken: string;

    // @DataMember(Order=3)
    public refreshToken: string;

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ConvertSessionToTokenResponse>) { (Object as any).assign(this, init); }
}
(ConvertSessionToTokenResponse as unknown)[immerable] = true;

export class ZoomSaveStateResponse
{
    public apiKey: string;
    public redirectUri: string;

    public constructor(init?: Partial<ZoomSaveStateResponse>) { (Object as any).assign(this, init); }
}
(ZoomSaveStateResponse as unknown)[immerable] = true;

export enum ZoomUserType
{
    Basic = 1,
    Licensed = 2,
    OnPrem = 3,
}

export class ZoomUser
{
    public id: string;
    public firstName: string;
    public lastName: string;
    public email: string;
    public type: ZoomUserType;
    public status: string;
    public pmi: number;
    public timezone: string;
    public dept: string;
    public createdAt: string;
    public lastLoginTime: string;
    public lastClientVersion: string;
    public groupIds: string[];
    public verified: number;
    public accountId: string;
    public fullName: string;

    public constructor(init?: Partial<ZoomUser>) { (Object as any).assign(this, init); }
}
(ZoomUser as unknown)[immerable] = true;

export class ZoomReauthResponse extends ZoomSaveStateResponse
{
    public isInvalid: boolean;

    public constructor(init?: Partial<ZoomReauthResponse>) { super(init); (Object as any).assign(this, init); }
}
(ZoomReauthResponse as unknown)[immerable] = true;

export class WaitingListByIdResponse extends WaitingList
{

    public constructor(init?: Partial<WaitingListByIdResponse>) { super(init); (Object as any).assign(this, init); }
}
(WaitingListByIdResponse as unknown)[immerable] = true;

export class WaitingListStateHistory implements IHasId
{
    public id: number;
    public waitingListId: number;
    public customerId: number;
    public description: string;
    public listType: WaitingListType;
    public stockId?: number;
    public classTypeId?: number;
    public temporaryClassSessionId?: number;
    public temporaryCourseId?: number;
    public temporaryAppointmentId?: number;
    public status: WaitingListStatus;
    public subStatus?: WaitingListSubStatus;
    public notificationType?: WaitingListNotificationType;
    public dateUpdated?: string;
    public startDateTime?: string;
    public pauseUntilDateTime?: string;

    public constructor(init?: Partial<WaitingListStateHistory>) { (Object as any).assign(this, init); }
}
(WaitingListStateHistory as unknown)[immerable] = true;

export class WaitingListStateHistoryResponse extends WaitingListStateHistory
{

    public constructor(init?: Partial<WaitingListStateHistoryResponse>) { super(init); (Object as any).assign(this, init); }
}
(WaitingListStateHistoryResponse as unknown)[immerable] = true;

export class AllowedIP implements IHasId
{
    public id: number;
    public address: string;

    public constructor(init?: Partial<AllowedIP>) { (Object as any).assign(this, init); }
}
(AllowedIP as unknown)[immerable] = true;

export class AllowedIPResponse
{
    public allowed: AllowedIP[];

    public constructor(init?: Partial<AllowedIPResponse>) { (Object as any).assign(this, init); }
}
(AllowedIPResponse as unknown)[immerable] = true;

export class SecureDocumentShareAccessRecipientResponse
{
    public shareId: string;
    public recipientId: string;
    public recipientType: SecureDocumentShareRecipientType;
    public recipientName: string;
    public deliveryMethod: string;
    public deliveryDestination: string;
    public verificationMethod: string;
    public fallbackVerificationMethod: string;
    public createdDate: string;
    public lastAccessedDate?: string;
    public tokenExpiresAt: string;
    public isExpired: boolean;
    public isRevoked: boolean;
    public status: string;

    public constructor(init?: Partial<SecureDocumentShareAccessRecipientResponse>) { (Object as any).assign(this, init); }
}
(SecureDocumentShareAccessRecipientResponse as unknown)[immerable] = true;

export class SecureDocumentSharePeopleResponse
{
    public documentListingId: string;
    public hasActiveConnectShare: boolean;
    public recipients: SecureDocumentShareAccessRecipientResponse[];

    public constructor(init?: Partial<SecureDocumentSharePeopleResponse>) { (Object as any).assign(this, init); }
}
(SecureDocumentSharePeopleResponse as unknown)[immerable] = true;

export class SecureDocumentShareDocumentResponse
{
    public documentListingId: string;
    public fileName: string;
    public filePath: string;
    public description: string;
    public modifiedDate?: string;

    public constructor(init?: Partial<SecureDocumentShareDocumentResponse>) { (Object as any).assign(this, init); }
}
(SecureDocumentShareDocumentResponse as unknown)[immerable] = true;

export class SecureDocumentSharePatientDocumentsResponse
{
    public documents: SecureDocumentShareDocumentResponse[];

    public constructor(init?: Partial<SecureDocumentSharePatientDocumentsResponse>) { (Object as any).assign(this, init); }
}
(SecureDocumentSharePatientDocumentsResponse as unknown)[immerable] = true;

export class SecureDocumentShareEditStatusResponse
{
    public documentListingId: string;
    public fileName: string;
    public hasActiveShare: boolean;
    public activeRecipientCount: number;

    public constructor(init?: Partial<SecureDocumentShareEditStatusResponse>) { (Object as any).assign(this, init); }
}
(SecureDocumentShareEditStatusResponse as unknown)[immerable] = true;

export class SecureDocumentShareRecipientResponse
{
    public recipientId: string;
    public recipientType: SecureDocumentShareRecipientType;
    public recipientName: string;
    public deliveryMethod: string;
    public verificationMethod: string;
    public accessToken: string;
    public expiresAt: string;

    public constructor(init?: Partial<SecureDocumentShareRecipientResponse>) { (Object as any).assign(this, init); }
}
(SecureDocumentShareRecipientResponse as unknown)[immerable] = true;

export class CreateSecureDocumentShareResponse
{
    public shareId: string;
    public recipients: SecureDocumentShareRecipientResponse[];

    public constructor(init?: Partial<CreateSecureDocumentShareResponse>) { (Object as any).assign(this, init); }
}
(CreateSecureDocumentShareResponse as unknown)[immerable] = true;

export class AuditSecureDocumentShareEditResponse
{
    public success: boolean;
    public auditedShareCount: number;
    public auditedCustomerCount: number;

    public constructor(init?: Partial<AuditSecureDocumentShareEditResponse>) { (Object as any).assign(this, init); }
}
(AuditSecureDocumentShareEditResponse as unknown)[immerable] = true;

export class SecureDocumentShareRevocationResponse
{
    public success: boolean;
    public revokedRecipientCount: number;

    public constructor(init?: Partial<SecureDocumentShareRevocationResponse>) { (Object as any).assign(this, init); }
}
(SecureDocumentShareRevocationResponse as unknown)[immerable] = true;

export class SecureDocumentShareAccessChallengeResponse
{
    public isAvailable: boolean;
    public isExpired: boolean;
    public isRevoked: boolean;
    public verificationRequired: boolean;
    public canRequestNewLink: boolean;
    public status: string;
    public recipientId: string;
    public documentListingId: string;
    public recipientType: SecureDocumentShareRecipientType;
    public recipientName: string;
    public documentFileName: string;
    public verificationMethod: string;
    public fallbackVerificationMethod: string;
    public expiresAt?: string;

    public constructor(init?: Partial<SecureDocumentShareAccessChallengeResponse>) { (Object as any).assign(this, init); }
}
(SecureDocumentShareAccessChallengeResponse as unknown)[immerable] = true;

export class SecureDocumentShareVerificationResponse
{
    public verified: boolean;
    public recipientId: string;
    public documentListingId: string;
    public documentFileName: string;
    public status: string;

    public constructor(init?: Partial<SecureDocumentShareVerificationResponse>) { (Object as any).assign(this, init); }
}
(SecureDocumentShareVerificationResponse as unknown)[immerable] = true;

export class RequestSecureDocumentShareSmsCodeResponse
{
    public success: boolean;
    public recipientId: string;
    public deliveryDestination: string;
    public status: string;

    public constructor(init?: Partial<RequestSecureDocumentShareSmsCodeResponse>) { (Object as any).assign(this, init); }
}
(RequestSecureDocumentShareSmsCodeResponse as unknown)[immerable] = true;

export class RequestNewSecureDocumentShareLinkResponse
{
    public success: boolean;
    public recipientId: string;
    public documentListingId: string;
    public deliveryMethod: string;
    public deliveryDestination: string;
    public expiresAt?: string;
    public status: string;

    public constructor(init?: Partial<RequestNewSecureDocumentShareLinkResponse>) { (Object as any).assign(this, init); }
}
(RequestNewSecureDocumentShareLinkResponse as unknown)[immerable] = true;

export class SecureDocumentShareDocumentDownloadResponse
{
    public file: string;
    public pathExtension: string;
    public mimeType: string;

    public constructor(init?: Partial<SecureDocumentShareDocumentDownloadResponse>) { (Object as any).assign(this, init); }
}
(SecureDocumentShareDocumentDownloadResponse as unknown)[immerable] = true;

export class EmbeddableDashboardToken
{
    public token: string;

    public constructor(init?: Partial<EmbeddableDashboardToken>) { (Object as any).assign(this, init); }
}
(EmbeddableDashboardToken as unknown)[immerable] = true;

export class ReferralPortalAppointmentSearchResult extends AppointmentSearchResult
{
    public inSla: boolean;

    public constructor(init?: Partial<ReferralPortalAppointmentSearchResult>) { super(init); (Object as any).assign(this, init); }
}
(ReferralPortalAppointmentSearchResult as unknown)[immerable] = true;

export class ReferralPortalReserveAppointmentResponse
{
    public appointment: AppointmentDto;

    public constructor(init?: Partial<ReferralPortalReserveAppointmentResponse>) { (Object as any).assign(this, init); }
}
(ReferralPortalReserveAppointmentResponse as unknown)[immerable] = true;

export class ReferralPortalConnectServiceResponse
{
    public id: string;
    public name: string;
    public description: string;
    public isLocationBased: boolean;
    public allowAppointmentlessReferral: boolean;
    public portalBookingMode: PortalBookingModes;

    public constructor(init?: Partial<ReferralPortalConnectServiceResponse>) { (Object as any).assign(this, init); }
}
(ReferralPortalConnectServiceResponse as unknown)[immerable] = true;

export class RoleResponse
{
    public id: string;
    public role: WorkflowContactType;
    public name: string;
    public stream: string;
    public canRefer: boolean;
    public isFinancial: boolean;
    public isAdministrative: boolean;
    public isClinical: boolean;
    public isClinicalAdmin: boolean;

    public constructor(init?: Partial<RoleResponse>) { (Object as any).assign(this, init); }
}
(RoleResponse as unknown)[immerable] = true;

export class ReferralPortalSettingsResponse
{
    public referrerName: string;
    public location: string;
    public twoFactorAuthRequired: boolean;
    public isCaseflow: boolean;

    public constructor(init?: Partial<ReferralPortalSettingsResponse>) { (Object as any).assign(this, init); }
}
(ReferralPortalSettingsResponse as unknown)[immerable] = true;

export class ReferralPortalCompaniesResponse
{
    public id: number;
    public parentId?: number;
    public logo: string;
    public name: string;

    public constructor(init?: Partial<ReferralPortalCompaniesResponse>) { (Object as any).assign(this, init); }
}
(ReferralPortalCompaniesResponse as unknown)[immerable] = true;

export class ReferralPortalAuthorisationDto
{
    public remainingCount: number;
    public maxCount: number;

    public constructor(init?: Partial<ReferralPortalAuthorisationDto>) { (Object as any).assign(this, init); }
}
(ReferralPortalAuthorisationDto as unknown)[immerable] = true;

export class WorkflowReportDto
{
    public id: number;
    public templateId: string;
    public templateName: string;
    public workflowId: number;
    public subWorkflowId: number;
    public rating?: number;
    public approved: boolean;
    public createdDate: string;
    public lastUpdateDate: string;
    public createdBy: number;
    public lastUpdatedBy: number;
    public data: string;
    public template: CaseflowTemplateDto;

    public constructor(init?: Partial<WorkflowReportDto>) { (Object as any).assign(this, init); }
}
(WorkflowReportDto as unknown)[immerable] = true;

// @Flags()
export enum ReferralActionType
{
    AuthorisationRequest = 1,
    ReportRequest = 2,
}

export class ReferralActionDto
{
    public id: string;
    public workflowId: number;
    public subworkflowId: number;
    public type: ReferralActionType;
    public typeId?: number;
    public typeName: string;
    public amount?: number;

    public constructor(init?: Partial<ReferralActionDto>) { (Object as any).assign(this, init); }
}
(ReferralActionDto as unknown)[immerable] = true;

export class ReferralPortalReferralResponse
{
    public id: number;
    public groupId: number;
    public childGroupId?: number;
    public createdById: number;
    public ownerId?: string;
    public templateId: string;
    public template: CaseflowTemplateDto;
    public createdDate: string;
    public lastUpdated: string;
    public status: string;
    public portalStatus: string;
    public isClosed: boolean;
    public isDeleted: boolean;
    public reportApprovalRequired: boolean;
    public authorisationApprovalRequired: boolean;
    public requiresAction: boolean;
    public numberOfSessionsRequested: number;
    public referralData: JsonField;
    public title: string;
    public forename: string;
    public surname: string;
    public gender: string;
    public dateOfBirth?: string;
    public email: string;
    public phone: string;
    public mobileTelephone: string;
    public workTelephone: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public postcode: string;
    public reference: string;
    public firstOfferedDate?: string;
    public ownerName: string;
    public teamName: string;
    public fullName: string;
    public authorisations: ReferralPortalAuthorisationDto;
    public reports: WorkflowReportDto[];
    public actions: ReferralActionDto[];
    public allowedServiceIds: string[];
    public autoLoginUrl: string;

    public constructor(init?: Partial<ReferralPortalReferralResponse>) { (Object as any).assign(this, init); }
}
(ReferralPortalReferralResponse as unknown)[immerable] = true;

export class GraphDataSet
{
    public label: string;
    public fill: string;
    public borderColor: string;
    public yAxisID: string;
    public tension: string;
    public data: number[];

    public constructor(init?: Partial<GraphDataSet>) { (Object as any).assign(this, init); }
}
(GraphDataSet as unknown)[immerable] = true;

export class DashboardGraphData
{
    public labels: string[];
    public datasets: GraphDataSet[];

    public constructor(init?: Partial<DashboardGraphData>) { (Object as any).assign(this, init); }
}
(DashboardGraphData as unknown)[immerable] = true;

export class SearchReferralPortalDashboardStatisticsResponse
{
    public activeReferrals: number;
    public reportApprovals: number;
    public authorisationsNeeded: number;
    public actionsRequired: number;
    public data: DashboardGraphData;

    public constructor(init?: Partial<SearchReferralPortalDashboardStatisticsResponse>) { (Object as any).assign(this, init); }
}
(SearchReferralPortalDashboardStatisticsResponse as unknown)[immerable] = true;

export class ReferralPortalTemporaryFileResponse
{
    public id: string;

    public constructor(init?: Partial<ReferralPortalTemporaryFileResponse>) { (Object as any).assign(this, init); }
}
(ReferralPortalTemporaryFileResponse as unknown)[immerable] = true;

export class ReferralPortalTemporaryFileListingResponse
{
    public directory: FolderResult;

    public constructor(init?: Partial<ReferralPortalTemporaryFileListingResponse>) { (Object as any).assign(this, init); }
}
(ReferralPortalTemporaryFileListingResponse as unknown)[immerable] = true;

export class ReferralPortalTemporaryFileDeleteResponse
{
    public success: boolean;

    public constructor(init?: Partial<ReferralPortalTemporaryFileDeleteResponse>) { (Object as any).assign(this, init); }
}
(ReferralPortalTemporaryFileDeleteResponse as unknown)[immerable] = true;

export class DocumentListingFile extends File
{
    public listingId: string;

    public constructor(init?: Partial<DocumentListingFile>) { super(init); (Object as any).assign(this, init); }
}
(DocumentListingFile as unknown)[immerable] = true;

export class ReferralPortalAuditResponse
{
    public id: string;
    public type: ReferralPortalAuditType;
    public typeId?: number;
    public typeGuid?: string;
    public userId: string;
    public userName: string;
    public date: string;
    public message: string;
    public title: string;

    public constructor(init?: Partial<ReferralPortalAuditResponse>) { (Object as any).assign(this, init); }
}
(ReferralPortalAuditResponse as unknown)[immerable] = true;

export class ReferralPortalSimpleWorkflowActionDto
{
    public id: string;
    public code: string;
    public name: string;
    public description: string;

    public constructor(init?: Partial<ReferralPortalSimpleWorkflowActionDto>) { (Object as any).assign(this, init); }
}
(ReferralPortalSimpleWorkflowActionDto as unknown)[immerable] = true;

export class ReferralPortalSimpleWorkflowResponse
{
    public workflowId: number;
    public subWorkflowId: number;
    public processId?: string;
    public statusId?: string;
    public statusName: string;
    public ownerId?: string;
    public ownerName: string;
    public teamId?: string;
    public teamName: string;
    public nextActionDate?: string;
    public dueDate?: string;
    public audits: ReferralPortalAuditResponse[];
    public actions: ReferralPortalSimpleWorkflowActionDto[];

    public constructor(init?: Partial<ReferralPortalSimpleWorkflowResponse>) { (Object as any).assign(this, init); }
}
(ReferralPortalSimpleWorkflowResponse as unknown)[immerable] = true;

export class ReferralPortalSharedFilesDownloadResponse
{
    public file: string;
    public pathExtension: string;
    public mimeType: string;

    public constructor(init?: Partial<ReferralPortalSharedFilesDownloadResponse>) { (Object as any).assign(this, init); }
}
(ReferralPortalSharedFilesDownloadResponse as unknown)[immerable] = true;

// @Flags()
export enum HyperlinkType
{
    InteleradLink = 0,
}

export class ReferralPortalWorkflowLinkResponse
{
    public id: string;
    public workflowId: number;
    public name: string;
    public url: string;
    public notes: string;
    public type?: HyperlinkType;
    public dateTimeStamp?: string;

    public constructor(init?: Partial<ReferralPortalWorkflowLinkResponse>) { (Object as any).assign(this, init); }
}
(ReferralPortalWorkflowLinkResponse as unknown)[immerable] = true;

export class ReferralPortalLocationResponse
{
    public id: string;
    public name: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public addressLine5: string;
    public postCode: string;
    public appointment: ReferralPortalAppointmentSearchResult;
    public appointmentInSla: boolean;
    public latLong: string;
    public linkedLocationId: string;

    public constructor(init?: Partial<ReferralPortalLocationResponse>) { (Object as any).assign(this, init); }
}
(ReferralPortalLocationResponse as unknown)[immerable] = true;

export class ReferralPortalLoginMessageResponse
{
    public title: string;
    public content: string;
    public style: string;

    public constructor(init?: Partial<ReferralPortalLoginMessageResponse>) { (Object as any).assign(this, init); }
}
(ReferralPortalLoginMessageResponse as unknown)[immerable] = true;

export enum ContractOrigin
{
    Inherited = 'Inherited',
    Clone = 'Clone',
    Standalone = 'Standalone',
}

export enum DistanceType
{
    StraightLine = 'StraightLine',
    FastestByRoad = 'FastestByRoad',
    ShortestByRoad = 'ShortestByRoad',
}

export class BaseContractDto<T>
{
    public id: string;
    public validFrom?: string;
    public validTo?: string;
    public name: string;
    public description: string;
    public notes: string;
    public isActive: boolean;
    public groupId: number;
    public contractOwnerId: number;
    public products: T[];
    public consentProfile: string;
    public meta: { [index:string]: Object; };
    public purchaseOrderNumber: string;
    public purchaseOrderNumberMandatory: boolean;
    public origin: ContractOrigin;
    public distanceType: DistanceType;

    public constructor(init?: Partial<BaseContractDto<T>>) { (Object as any).assign(this, init); }
}

export class ServiceNetworkMembershipDto
{
    public id: string;
    public includeInResultsByDefault: boolean;
    public isPreferred: boolean;
    public name: string;
    public hideFromResults: boolean;
    public serviceId: string;
    public networkId: string;
    public contractId?: string;
    public productId?: string;
    public defaultProntoInitialAppointmentCharge: string;
    public defaultProntoFollowUpAppointmentCharge: string;
    public modified: boolean;

    public constructor(init?: Partial<ServiceNetworkMembershipDto>) { (Object as any).assign(this, init); }
}
(ServiceNetworkMembershipDto as unknown)[immerable] = true;

export enum ProductServiceMode
{
    Booking = 'Booking',
    Placeholder = 'Placeholder',
    DigitalTriage = 'DigitalTriage',
}

export enum DateInterval
{
    Years = 'Years',
    Months = 'Months',
    Weeks = 'Weeks',
    Days = 'Days',
    Hours = 'Hours',
    Minutes = 'Minutes',
    Seconds = 'Seconds',
}

export enum DateIncrementType
{
    Days = 'Days',
    WorkingDays_DeadlineStartOfWorkingHours = 'WorkingDays_DeadlineStartOfWorkingHours',
    Hours = 'Hours',
    WorkingHours = 'WorkingHours',
    None = 'None',
    ManualNonMandatory = 'ManualNonMandatory',
    Manual = 'Manual',
    WorkingDays_DeadlineCurrentTime = 'WorkingDays_DeadlineCurrentTime',
}

export enum SlaRelativeTo
{
    CurrentServiceMostRecentAppointmentDate = 'CurrentServiceMostRecentAppointmentDate',
    AppointmentOfferedDate = 'AppointmentOfferedDate',
    CurrentServiceFirstAppointmentDate = 'CurrentServiceFirstAppointmentDate',
    ReferralDate = 'ReferralDate',
    AnyServiceMostRecentAppointmentDate = 'AnyServiceMostRecentAppointmentDate',
    CurrentServiceMostRecentAppointmentEndDate = 'CurrentServiceMostRecentAppointmentEndDate',
    FirstSuccessfulContactDate = 'FirstSuccessfulContactDate',
    CurrentServiceMostRecentlyAddedAppointmentDate = 'CurrentServiceMostRecentlyAddedAppointmentDate',
    AnyServiceMostRecentAppointmentEndDate = 'AnyServiceMostRecentAppointmentEndDate',
}

export class ServiceSlaDto
{
    public id: string;
    public serviceId: string;
    public slaTypeId: string;
    public occursWithin: number;
    public unit: DateIncrementType;
    public relativeTo: SlaRelativeTo;
    public modified: boolean;

    public constructor(init?: Partial<ServiceSlaDto>) { (Object as any).assign(this, init); }
}
(ServiceSlaDto as unknown)[immerable] = true;

export class ProductServiceDto
{
    public id: string;
    public basedOnServiceId?: string;
    public contractId?: string;
    public productId?: string;
    public processId: string;
    public productServiceTypeId?: string;
    public name: string;
    public displayName: string;
    public description: string;
    public isActive: boolean;
    public isLocationBased: boolean;
    public isPlaceHolderService: boolean;
    public hasFollowUps: boolean;
    public caseflowProductServiceTypes: string[];
    public portalBookingMode: PortalBookingModes;
    public sessionTypeRestriction: string[];
    public portalReferralDefaultActionId: string;
    public portalReferralWithBookingDefaultActionId: string;
    public manualReferralDefaultActionId: string;
    public sla_AppointmentOffer_Value: number;
    public sla_AppointmentOffer_Units: string;
    public sla_AppointmentOffer_RelativeTo: string;
    public sla_AppointmentDistanceMiles: number;
    public reports: { [index:string]: string; };
    public canBillCancellation: boolean;
    public cancellationDays: number;
    public maxCancellationsBeforeDischarge: number;
    public canBillDna: boolean;
    public dnaDays: number;
    public maxDnasBeforeDischarge: number;
    public cancellationAndDnaLimitBeforeAction: number;
    public isCombinedDnaCancellationLimit: boolean;
    public requireAuthorisation: boolean;
    public defaultAuthorisation: number;
    public requireInitialReportAfter1stAppointment: boolean;
    public initialAuthorisation: number;
    public subsequentAuthorisation: number;
    public requireReasonIfNotUsingFirstAppointmentOffered: boolean;
    public requireReasonIfNotUsingPreferredNetwork: boolean;
    public shouldCreateClinicalRecord: boolean;
    public networks: ServiceNetworkMembershipDto[];
    public code: string;
    public mode: ProductServiceMode;
    public firstAppointmentService: string;
    public followUpAppointmentService: string;
    public chargeTypeFirstAppointment: string;
    public chargeTypeFollowUpAppointment: string;
    public chargeTypeInitialCancellation: string;
    public chargeTypeInitialDna: string;
    public chargeTypeFollowupCancellation: string;
    public chargeTypeFollowupDna: string;
    public internalAppointmentTimeBuffer: number;
    public authorisationsExpire: boolean;
    public authorisationExpirationDays?: number;
    public subWorkflowReopenExpiration?: number;
    public subWorkflowReopenExpirationFormat?: DateInterval;
    public serviceSlas: ServiceSlaDto[];
    public serviceTypeId: number;
    public serviceType: ServiceType;
    public externalIdentifier: string;
    public canReReferClinic: boolean;
    public overrideGroupCancelDNASettings: boolean;
    public authorisationBillGroupDNA: boolean;
    public authorisationBillGroupCancellation: boolean;
    public authorisationIncludeInNewReferrals: boolean;
    public skipAuthCreationOnWorkflowCreation: boolean;
    public overrideGroupAuthUsageSettings: boolean;
    public authorisationCancellationAffectsAuthCount: boolean;
    public authorisationCancellationAffectsAuthCountDays: number;
    public authorisationCancellationAlwaysAffectsAuthCount: boolean;
    public authorisationDnaAffectsAuthCount: boolean;
    public patientPortalReferralWithoutBookingDefaultActionId?: string;
    public patientPortalReferralWithBookingDefaultActionId?: string;
    public digitalTriageProviderId?: string;
    public digitalTriageReportTemplateKey: string;
    public modified: boolean;

    public constructor(init?: Partial<ProductServiceDto>) { (Object as any).assign(this, init); }
}
(ProductServiceDto as unknown)[immerable] = true;

export enum NotificationType
{
    Patient = 'Patient',
    Admin = 'Admin',
    Financial = 'Financial',
    Clinical = 'Clinical',
    Network = 'Network',
    Group = 'Group',
    ClinicalAdmin = 'ClinicalAdmin',
    WorkflowOwner = 'WorkflowOwner',
    SubworkflowUser = 'SubworkflowUser',
    NetworkClinician = 'NetworkClinician',
    Custom = 'Custom',
}

export enum CommunicationType
{
    Email = 'Email',
    Letter = 'Letter',
    SMS = 'SMS',
}

export enum RecipientGroupType
{
    Child = 'Child',
    Distributor = 'Distributor',
}

export class ProductNotificationConfigurationNetworkDto
{
    public id: string;
    public notificationId: string;
    public networkId: string;
    public templatePath: string;
    public modified: boolean;

    public constructor(init?: Partial<ProductNotificationConfigurationNetworkDto>) { (Object as any).assign(this, init); }
}
(ProductNotificationConfigurationNetworkDto as unknown)[immerable] = true;

export enum SendFromType
{
    SystemDefault = 'SystemDefault',
    LoggedInUser = 'LoggedInUser',
    GroupInvoicingAddress = 'GroupInvoicingAddress',
}

export class ProductNotificationConfigurationDto
{
    public id: string;
    public productId: string;
    public contractId?: string;
    public templatePath: string;
    public subject?: string;
    public recipient: NotificationType;
    public recipientTypeId?: string;
    public recipientTypeName: string;
    public type: CommunicationType;
    public recipientGroupType: RecipientGroupType;
    public event: string;
    public previewBeforeSending: boolean;
    public networkOverrides: ProductNotificationConfigurationNetworkDto[];
    public sendFrom: SendFromType;
    public modified: boolean;
    public recipientDisplayName: string;

    public constructor(init?: Partial<ProductNotificationConfigurationDto>) { (Object as any).assign(this, init); }
}
(ProductNotificationConfigurationDto as unknown)[immerable] = true;

export class ProductFormConfigurationDto
{
    public id: string;
    public productId: string;
    public contractId?: string;
    public templateId: string;
    public type: CommunicationType;
    public event: string;
    public modified: boolean;

    public constructor(init?: Partial<ProductFormConfigurationDto>) { (Object as any).assign(this, init); }
}
(ProductFormConfigurationDto as unknown)[immerable] = true;

export class ChargeTypeStockDto
{
    public id: string;
    public stockOnlineGuid: string;
    public chargeTypeId: string;
    public productId: string;
    public contractId?: string;
    public overridePriceExVat: number;
    public limit?: number;
    public modified: boolean;

    public constructor(init?: Partial<ChargeTypeStockDto>) { (Object as any).assign(this, init); }
}
(ChargeTypeStockDto as unknown)[immerable] = true;

export enum NoConsentOption
{
    Discharge = 'Discharge',
    AlternativeReports = 'AlternativeReports',
    RestrictServices = 'RestrictServices',
}

export class ProductDto
{
    public id: string;
    public contractId?: string;
    public basedOnProductId?: string;
    public name: string;
    public displayName: string;
    public description: string;
    public caseflowServiceId: number;
    public isActive: boolean;
    public relatesToAPatient: boolean;
    public canBookAppointmentInPortal: boolean;
    public isDisplayedInClientPortal: boolean;
    public processId: string;
    public firstActionId: string;
    public services: ProductServiceDto[];
    public sla_FirstContact_Value: number;
    public sla_FirstContact_Units: string;
    public sla_FirstContact_RelativeTo: string;
    public minRequiredContactAttempts: number;
    public minRequiredContactAttemptsWithinDays: number;
    public requiresJointAgreement: boolean;
    public firstServiceId?: string;
    public referralFormTemplateId?: string;
    public ppReferralFormTemplateId?: string;
    public notifications: ProductNotificationConfigurationDto[];
    public forms: ProductFormConfigurationDto[];
    public chargeTypeStock: ChargeTypeStockDto[];
    public adminFallbackEmailAddress: string;
    public clinicalFallbackEmailAddress: string;
    public financialFallbackEmailAddress: string;
    public networkFallbackEmailAddress: string;
    public workflowOwnerFallbackEmailAddress: string;
    public subWorkflowUserFallbackEmailAddress: string;
    public networkClinicianFallbackEmailAddress: string;
    public noConsentRestrictedToServices: string[];
    public noReportSharingConsentType: NoConsentOption;
    public notes: string;
    public type: string;
    public ageCategory: number;
    public serviceTypeIds: number[];
    public allowCustomPricing: boolean;
    public modified: boolean;

    public constructor(init?: Partial<ProductDto>) { (Object as any).assign(this, init); }
}
(ProductDto as unknown)[immerable] = true;

export class ContractDto extends BaseContractDto<ProductDto>
{

    public constructor(init?: Partial<ContractDto>) { super(init); (Object as any).assign(this, init); }
}
(ContractDto as unknown)[immerable] = true;

export class ContractWithActiveStatusDto extends ContractDto
{
    public isActive: boolean;
    public origin: ContractOrigin;
    public groupName: string;

    public constructor(init?: Partial<ContractWithActiveStatusDto>) { super(init); (Object as any).assign(this, init); }
}
(ContractWithActiveStatusDto as unknown)[immerable] = true;

export class ReferralPortalProductResponse
{
    // @ApiMember(Format="uuid")
    public productId: string;

    /** @description The `ServiceId` is used for finding locations and appointment availability.         A product can have many services associated with e.g. (Triage, Virtual Treatment and In Person Treatment).         This endpoint returns the currently available `ServiceId` for the current product.         This is typically the first service of the pathway for the product. */
    // @ApiMember(Description="The `ServiceId` is used for finding locations and appointment availability. \n        A product can have many services associated with e.g. (Triage, Virtual Treatment and In Person Treatment). \n        This endpoint returns the currently available `ServiceId` for the current product. \n        This is typically the first service of the pathway for the product.", Format="uuid")
    public serviceId: string;

    /** @description Location based services are ones where services are delivered in person, and                 physical proximity is an important factor. You may require post code search,                 or mapping to identifier suitable service providers when using a location based service. */
    // @ApiMember(Description="Location based services are ones where services are delivered in person, and \n                physical proximity is an important factor. You may require post code search, \n                or mapping to identifier suitable service providers when using a location based service.")
    public isLocationBased: boolean;

    public name: string;
    /** @description A link to the `Referral Form Id`. As referral forms can depend on product and service,         this can be used to retrieve the form, and which can provide the additional fields that         might be required */
    // @ApiMember(Description="A link to the `Referral Form Id`. As referral forms can depend on product and service, \n        this can be used to retrieve the form, and which can provide the additional fields that \n        might be required", Format="uuid")
    public referralForm: string;

    /** @description Only used by portal */
    // @ApiMember(Description="Only used by portal", ExcludeInSchema=true)
    public slaAppointmentDistanceMiles: number;

    /** @description Only used by portal */
    // @ApiMember(Description="Only used by portal", ExcludeInSchema=true)
    public slaAppointmentOfferRelativeTo: string;

    /** @description Only used by portal */
    // @ApiMember(Description="Only used by portal", ExcludeInSchema=true)
    public slaAppointmentOfferUnits: string;

    /** @description Only used by portal */
    // @ApiMember(Description="Only used by portal", ExcludeInSchema=true)
    public slaAppointmentOfferValue: number;

    /** @description A friendly identifier that be used to locate the correct service. Note that this needs configured in the Caseflow Product Service. */
    // @ApiMember(Description="A friendly identifier that be used to locate the correct service. Note that this needs configured in the Caseflow Product Service.")
    public externalIdentifier: string;

    /** @description Only used by portal */
    // @ApiMember(Description="Only used by portal", ExcludeInSchema=true)
    public portalBookingMode: PortalBookingModes;

    /** @description Only used by portal */
    // @ApiMember(Description="Only used by portal", ExcludeInSchema=true)
    public canSendSMS: boolean;

    /** @description Only used by portal */
    // @ApiMember(Description="Only used by portal", ExcludeInSchema=true)
    public canSendEmail: boolean;

    public constructor(init?: Partial<ReferralPortalProductResponse>) { (Object as any).assign(this, init); }
}
(ReferralPortalProductResponse as unknown)[immerable] = true;

export class ReferralPortalFieldsResponse
{
    public fieldName: string;
    public required: boolean;
    public isEmail: boolean;
    public maxLength?: number;
    public min?: number;
    public max?: number;
    public regex: string;
    public label: string;
    public type: string;
    public listSrc: string;

    public constructor(init?: Partial<ReferralPortalFieldsResponse>) { (Object as any).assign(this, init); }
}
(ReferralPortalFieldsResponse as unknown)[immerable] = true;

export class ReferralPortalReferralAppointmentResponse
{
    public id: number;
    public startDateTime: string;
    public endDateTime: string;
    /** @description The service provider that is delivering this appointment. */
    // @ApiMember(Description="The service provider that is delivering this appointment.")
    public provider: string;

    /** @description The service being delivered in the appointment */
    // @ApiMember(Description="The service being delivered in the appointment")
    public service: string;

    /** @description This will be set to `true` if the Appointment is a Video type appointment, and has an associated `VideoUrl`. */
    // @ApiMember(Description="This will be set to `true` if the Appointment is a Video type appointment, and has an associated `VideoUrl`.")
    public isVideo: boolean;

    /** @description The URL that can be used to join the appointment video call. */
    // @ApiMember(Description="The URL that can be used to join the appointment video call.")
    public videoUrl: string;

    public status: AppointmentStatus;

    public constructor(init?: Partial<ReferralPortalReferralAppointmentResponse>) { (Object as any).assign(this, init); }
}
(ReferralPortalReferralAppointmentResponse as unknown)[immerable] = true;

export class ReferralPortalReferralReportResponse
{
    public id: number;
    public name: string;
    public created: string;
    public lastUpdated: string;

    public constructor(init?: Partial<ReferralPortalReferralReportResponse>) { (Object as any).assign(this, init); }
}
(ReferralPortalReferralReportResponse as unknown)[immerable] = true;

export class ReferralPortalReportBodyResponse
{
    public id: number;
    public template: CaseflowTemplateDto;
    public data: JsonField;

    public constructor(init?: Partial<ReferralPortalReportBodyResponse>) { (Object as any).assign(this, init); }
}
(ReferralPortalReportBodyResponse as unknown)[immerable] = true;

export class ReferralPortalReferralSearchResponse implements IHasId
{
    public id: number;
    public referralId: number;
    public workflowId: number;
    public group: Group;
    public ownerId: number;
    public ownerGuid?: string;
    public ownerName: string;
    public createdByUserId: number;
    public groupId: string;
    public createdDate: string;
    public lastUpdated: string;
    public templateId: string;
    public isClosed: boolean;
    public serviceId?: string;
    public statusId?: string;
    public teamId?: string;
    public teamName: string;
    public title: string;
    public forename: string;
    public surname: string;
    public gender: string;
    public dateOfBirth?: string;
    public email: string;
    public phone: string;
    public mobileTelephone: string;
    public workTelephone: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public postcode: string;
    public reference: string;
    public status: string;
    public portalStatus: string;
    public productName: string;
    public connectServiceName: string;
    public hasAppointment: boolean;
    public patientName: string;

    public constructor(init?: Partial<ReferralPortalReferralSearchResponse>) { (Object as any).assign(this, init); }
}
(ReferralPortalReferralSearchResponse as unknown)[immerable] = true;

export class ReferralPortalFilterOption
{
    /** @description The value to filter by. */
    // @ApiMember(Description="The value to filter by.")
    public id: string;

    /** @description The display label for this option. */
    // @ApiMember(Description="The display label for this option.")
    public name: string;

    public constructor(init?: Partial<ReferralPortalFilterOption>) { (Object as any).assign(this, init); }
}
(ReferralPortalFilterOption as unknown)[immerable] = true;

export class ReferralPortalReferralFilterOptionsResponse
{
    /** @description Services that referrals can belong to. */
    // @ApiMember(Description="Services that referrals can belong to.")
    public services: ReferralPortalFilterOption[];

    /** @description Workflow statuses a referral can be in. */
    // @ApiMember(Description="Workflow statuses a referral can be in.")
    public statuses: ReferralPortalFilterOption[];

    /** @description Users that a referral can be assigned to. */
    // @ApiMember(Description="Users that a referral can be assigned to.")
    public owners: ReferralPortalFilterOption[];

    /** @description Teams that a referral can be assigned to. */
    // @ApiMember(Description="Teams that a referral can be assigned to.")
    public teams: ReferralPortalFilterOption[];

    public constructor(init?: Partial<ReferralPortalReferralFilterOptionsResponse>) { (Object as any).assign(this, init); }
}
(ReferralPortalReferralFilterOptionsResponse as unknown)[immerable] = true;

export class ReferralPortalUserResponse
{
    public id: number;
    public userName: string;
    public current: boolean;
    public level: string;
    public email: string;
    public mobileNumber: string;
    public avatar: string;
    public firstName: string;
    public lastName: string;
    public fullName: string;
    public userGlobalGuid: string;
    public groups: number[];
    public linkedContactId?: number;
    public twoFactorEnabled: boolean;

    public constructor(init?: Partial<ReferralPortalUserResponse>) { (Object as any).assign(this, init); }
}
(ReferralPortalUserResponse as unknown)[immerable] = true;

export class SystemLog implements IHasId
{
    public id: number;
    public description: string;
    public requestId: string;
    public requestUrl: string;
    public requestMethod: string;
    public requestPayload: string;
    public responseStatus: string;
    public responsePayload: string;
    public date: string;
    public exception: string;
    public duration: number;
    public customerId: number;
    public objectId?: number;
    public objectType: string;
    public apiKey: string;
    public correlationId: string;

    public constructor(init?: Partial<SystemLog>) { (Object as any).assign(this, init); }
}
(SystemLog as unknown)[immerable] = true;

export class SystemLogWithCustomerName extends SystemLog
{
    public name: string;
    public forename: string;
    public surname: string;

    public constructor(init?: Partial<SystemLogWithCustomerName>) { super(init); (Object as any).assign(this, init); }
}
(SystemLogWithCustomerName as unknown)[immerable] = true;

export class SquareGetDeviceCodeResponse
{
    public code: string;

    public constructor(init?: Partial<SquareGetDeviceCodeResponse>) { (Object as any).assign(this, init); }
}
(SquareGetDeviceCodeResponse as unknown)[immerable] = true;

export class TerminalPairingResponse
{
    public deviceCode: string;
    public paired: boolean;

    public constructor(init?: Partial<TerminalPairingResponse>) { (Object as any).assign(this, init); }
}
(TerminalPairingResponse as unknown)[immerable] = true;

export class Terminal implements IHasId
{
    public id: number;
    public merchantId: string;
    public locationId: number;
    public deviceCode: string;
    public name: string;
    public pairedAt: string;
    public inUse: boolean;
    public provider: PaymentProviderName;

    public constructor(init?: Partial<Terminal>) { (Object as any).assign(this, init); }
}
(Terminal as unknown)[immerable] = true;

export class SquareTerminalPaymentResponse
{
    public checkoutId: string;

    public constructor(init?: Partial<SquareTerminalPaymentResponse>) { (Object as any).assign(this, init); }
}
(SquareTerminalPaymentResponse as unknown)[immerable] = true;

export class StripeTerminalPairResponse
{
    public success: boolean;

    public constructor(init?: Partial<StripeTerminalPairResponse>) { (Object as any).assign(this, init); }
}
(StripeTerminalPairResponse as unknown)[immerable] = true;

export class ClearAcceptConfigResponse
{
    public scriptUrl: string;
    public scriptSri: string;
    public componentScriptUrl: string;
    public componentScriptSri: string;

    public constructor(init?: Partial<ClearAcceptConfigResponse>) { (Object as any).assign(this, init); }
}
(ClearAcceptConfigResponse as unknown)[immerable] = true;

export class ApiCredentials implements IHasGuidId
{
    public id: string;
    public secret: string;
    public createdDate: string;
    public expiryDate?: string;
    public cancelledDate?: string;
    public notes: string;
    public isSoftDeleted: boolean;
    public isOutboundOnly: boolean;
    // @Ignore()
    public isValid: boolean;

    public userId?: number;

    public constructor(init?: Partial<ApiCredentials>) { (Object as any).assign(this, init); }
}
(ApiCredentials as unknown)[immerable] = true;

export class GetReportActionsResponse
{
    public approveActionTitle: string;
    public approveActionDescription: string;
    public rejectActionTitle: string;
    public rejectActionDescription: string;
    public queryActionTitle: string;
    public queryActionDescription: string;
    public hasApproveAction: boolean;
    public hasRejectAction: boolean;
    public hasQueryAction: boolean;

    public constructor(init?: Partial<GetReportActionsResponse>) { (Object as any).assign(this, init); }
}
(GetReportActionsResponse as unknown)[immerable] = true;

// @Flags()
export enum CreditProductType
{
    Class = 0,
    Course = 1,
    Appointment = 2,
}

export class CreditBasedPackageLineItemsResponse
{
    public id: string;
    public stockName: string;
    public productType: CreditProductType;
    public credits: number;
    public date: string;
    public practitionerTitle: string;
    public practitionerFirstName: string;
    public practitionerSurname: string;
    public startDateTime: string;
    public transactionType: CreditTransactionType;
    public locationName: string;

    public constructor(init?: Partial<CreditBasedPackageLineItemsResponse>) { (Object as any).assign(this, init); }
}
(CreditBasedPackageLineItemsResponse as unknown)[immerable] = true;

export class ClickBillResponse
{
    public invoiceId?: number;
    public invoiceStatus: string;
    public serviceName: string;
    public serviceTotalPrice: string;

    public constructor(init?: Partial<ClickBillResponse>) { (Object as any).assign(this, init); }
}
(ClickBillResponse as unknown)[immerable] = true;

export class ClickDownloadInvoiceResponse
{
    public invoiceId: number;
    public pdfReceipt: string;

    public constructor(init?: Partial<ClickDownloadInvoiceResponse>) { (Object as any).assign(this, init); }
}
(ClickDownloadInvoiceResponse as unknown)[immerable] = true;

export class ClickCreatePaymentResponse
{
    public paymentId?: number;
    public pdfReceipt: string;

    public constructor(init?: Partial<ClickCreatePaymentResponse>) { (Object as any).assign(this, init); }
}
(ClickCreatePaymentResponse as unknown)[immerable] = true;

export class ClickCommunicationResponse
{
    public subject: string;
    public to: string[];
    public cc: string[];
    public attachments: AttachmentGroup;
    public messageBody: string;

    public constructor(init?: Partial<ClickCommunicationResponse>) { (Object as any).assign(this, init); }
}
(ClickCommunicationResponse as unknown)[immerable] = true;

export class CreateClassResponse
{
    public success: boolean;
    public clashes: string[];
    public session: ClassSessionBaseResponse;

    public constructor(init?: Partial<CreateClassResponse>) { (Object as any).assign(this, init); }
}
(CreateClassResponse as unknown)[immerable] = true;

export class GetDesktopClassResponse
{
    public name: string;
    public maxAttendees: number;

    public constructor(init?: Partial<GetDesktopClassResponse>) { (Object as any).assign(this, init); }
}
(GetDesktopClassResponse as unknown)[immerable] = true;

export enum AddingAttendeeResponse
{
    SpaceAvailable = 'SpaceAvailable',
    SessionFull = 'SessionFull',
    AlreadyRegistered = 'AlreadyRegistered',
    PreviouslyCancelled = 'PreviouslyCancelled',
}

export class AddingAttendeeToSessionErrors
{
    public classSessionId: number;
    public startDateTime: string;
    public endDateTime: string;
    public availability: AddingAttendeeResponse;
    public errorMessage: string;
    public isSessionInThePast: boolean;

    public constructor(init?: Partial<AddingAttendeeToSessionErrors>) { (Object as any).assign(this, init); }
}
(AddingAttendeeToSessionErrors as unknown)[immerable] = true;

export class AddStudentToClassSessionResponse implements IClassFinanceResponse
{
    public invoiceId?: number;
    public paymentId?: number;
    public clashMode: ClashMode;
    public errors: AddingAttendeeToSessionErrors[];
    public hasErrors: boolean;
    public hasSessionFullErrors: boolean;
    public isAlreadyOnWaitingList: boolean;
    public hasSessionsInThePastErrors: boolean;
    public hasSpacesAvailable: boolean;
    public success: boolean;
    public customerId: number;

    public constructor(init?: Partial<AddStudentToClassSessionResponse>) { (Object as any).assign(this, init); }
}
(AddStudentToClassSessionResponse as unknown)[immerable] = true;

export class EditClassResponse
{
    public success: boolean;
    public clashes: ClassSessionBaseResponse[];
    public session: ClassSessionBaseResponse;

    public constructor(init?: Partial<EditClassResponse>) { (Object as any).assign(this, init); }
}
(EditClassResponse as unknown)[immerable] = true;

export class PayForClassResponse implements IClassFinanceResponse
{
    public invoiceId?: number;
    public paymentId?: number;
    public prePaidId?: number;
    public billingItemId?: number;

    public constructor(init?: Partial<PayForClassResponse>) { (Object as any).assign(this, init); }
}
(PayForClassResponse as unknown)[immerable] = true;

export class ClassCommunicationResponse
{
    public customerId: number;
    public customerEmail: string;
    public customerMobileTelephone: string;
    public customerSMSEnabled: boolean;
    public title: string;
    public forename: string;
    public surname: string;
    // @Ignore()
    public name: string;

    public constructor(init?: Partial<ClassCommunicationResponse>) { (Object as any).assign(this, init); }
}
(ClassCommunicationResponse as unknown)[immerable] = true;

export class PrePaidItemsForClassResponse
{
    public packageName: string;
    public totalPrice?: number;
    public itemDescription: string;
    public itemsLeft?: number;
    public id: number;

    public constructor(init?: Partial<PrePaidItemsForClassResponse>) { (Object as any).assign(this, init); }
}
(PrePaidItemsForClassResponse as unknown)[immerable] = true;

export class ClassesPrePaidCreditsResp
{
    public packageName: string;
    public quantity?: number;
    public used?: number;
    public id: number;

    public constructor(init?: Partial<ClassesPrePaidCreditsResp>) { (Object as any).assign(this, init); }
}
(ClassesPrePaidCreditsResp as unknown)[immerable] = true;

export class AddStudentToCourseResponse implements IClassFinanceResponse
{
    public result: CourseResponse;
    public invoiceId?: number;
    public paymentId?: number;
    public errors: AddingAttendeeToSessionErrors[];
    public clashMode: ClashMode;
    public hasErrors: boolean;
    public hasSessionFullErrors: boolean;
    public isAlreadyOnWaitingList: boolean;
    public hasSpacesAvailableInAllSessions: boolean;
    public success: boolean;

    public constructor(init?: Partial<AddStudentToCourseResponse>) { (Object as any).assign(this, init); }
}
(AddStudentToCourseResponse as unknown)[immerable] = true;

export class EditCourseResponse
{
    public success: boolean;
    public clashes: ClassSessionBaseResponse[];
    public course: CourseResponse;

    public constructor(init?: Partial<EditCourseResponse>) { (Object as any).assign(this, init); }
}
(EditCourseResponse as unknown)[immerable] = true;

export class CreateCourseResponse
{
    public success: boolean;
    public clashes: string[];
    public session: ClassSessionBaseResponse;

    public constructor(init?: Partial<CreateCourseResponse>) { (Object as any).assign(this, init); }
}
(CreateCourseResponse as unknown)[immerable] = true;

export class RemoveStudentFromClassResponse implements IClassFinanceResponse
{
    public invoiceId?: number;
    public paymentId?: number;
    public billingItemId?: number;

    public constructor(init?: Partial<RemoveStudentFromClassResponse>) { (Object as any).assign(this, init); }
}
(RemoveStudentFromClassResponse as unknown)[immerable] = true;

export class DocumentVisibilityResponse
{
    public documentId?: number;
    public isVisibleToPortal: boolean;
    public fileName: string;
    public workflowId?: number;
    public filePath: string;

    public constructor(init?: Partial<DocumentVisibilityResponse>) { (Object as any).assign(this, init); }
}
(DocumentVisibilityResponse as unknown)[immerable] = true;

export class ResolveDocumentPathResult
{
    public filePath: string;
    public documentId?: number;

    public constructor(init?: Partial<ResolveDocumentPathResult>) { (Object as any).assign(this, init); }
}
(ResolveDocumentPathResult as unknown)[immerable] = true;

export class ResolveWorkflowDocumentPathsResponse
{
    public results: ResolveDocumentPathResult[];

    public constructor(init?: Partial<ResolveWorkflowDocumentPathsResponse>) { (Object as any).assign(this, init); }
}
(ResolveWorkflowDocumentPathsResponse as unknown)[immerable] = true;

export class WorkflowPortalOwnerOption
{
    public ownerId: string;
    public name: string;
    public email: string;
    public mobile: string;

    public constructor(init?: Partial<WorkflowPortalOwnerOption>) { (Object as any).assign(this, init); }
}
(WorkflowPortalOwnerOption as unknown)[immerable] = true;

export class WorkflowDocumentNotificationRecipientResponse
{
    public target: string;
    public recipientName: string;
    public recipientEmail: string;
    public recipientMobile: string;
    public canEmail: boolean;
    public canSms: boolean;
    public canPublishTarget: boolean;
    public publishBlockedReason: string;
    public requiresPortalOwnerAssignment: boolean;
    public hasReferralLinked: boolean;
    public hasPatientLinked: boolean;
    public availablePortalOwners: WorkflowPortalOwnerOption[];

    public constructor(init?: Partial<WorkflowDocumentNotificationRecipientResponse>) { (Object as any).assign(this, init); }
}
(WorkflowDocumentNotificationRecipientResponse as unknown)[immerable] = true;

export class SimpleWorkflowListItem
{
    public id: number;
    public workflowId: number;
    public subWorkflowId?: number;
    public referralId?: number;
    public groupId?: number;
    public groupName: string;
    public referralName: string;
    public statusName: string;
    public statusId?: string;
    public statusColor: string;
    public ownerId?: string;
    public ownerName: string;
    public userId?: string;
    public userName: string;
    public overallOwnerId?: string;
    public overallOwnerName: string;
    public referralPortalOwnerId?: string;
    public referralPortalOwnerName: string;
    public teamId?: string;
    public teamName: string;
    public createdDate?: string;
    public dueDate?: string;
    public nextActionDate?: string;
    public nextActionIsAutomated?: boolean;
    public closed?: boolean;
    public processId?: string;
    public processName: string;
    public customerId?: number;
    public customerName: string;
    public hasPotentialDuplicate: boolean;

    public constructor(init?: Partial<SimpleWorkflowListItem>) { (Object as any).assign(this, init); }
}
(SimpleWorkflowListItem as unknown)[immerable] = true;

export class SimpleWorkflowListResponse
{
    public results: SimpleWorkflowListItem[];
    public total: number;

    public constructor(init?: Partial<SimpleWorkflowListResponse>) { (Object as any).assign(this, init); }
}
(SimpleWorkflowListResponse as unknown)[immerable] = true;

export class SimpleWorkflowPotentialCustomerMatchDto
{
    public customerId: number;
    public customerName: string;
    public dateOfBirth?: string;
    public addressLine1: string;
    public postcode: string;
    public email: string;
    public mobileTelephone: string;
    public matchReason: string;

    public constructor(init?: Partial<SimpleWorkflowPotentialCustomerMatchDto>) { (Object as any).assign(this, init); }
}
(SimpleWorkflowPotentialCustomerMatchDto as unknown)[immerable] = true;

export class SimpleWorkflowAuditDto
{
    public date?: string;
    public title: string;
    public notes: string;
    public userId?: string;
    public userName: string;

    public constructor(init?: Partial<SimpleWorkflowAuditDto>) { (Object as any).assign(this, init); }
}
(SimpleWorkflowAuditDto as unknown)[immerable] = true;

export class SimpleProcessActionDto
{
    public id: string;
    public name: string;
    public code: string;
    public newStatusId?: string;
    public triggerType: string;
    public triggerMode: string;
    public nextActionDays?: number;
    public nextActionHours?: number;
    public steps: ActionStepDto[];

    public constructor(init?: Partial<SimpleProcessActionDto>) { (Object as any).assign(this, init); }
}
(SimpleProcessActionDto as unknown)[immerable] = true;

export class SimpleStatusDto
{
    public id: string;
    public name: string;
    public color: string;

    public constructor(init?: Partial<SimpleStatusDto>) { (Object as any).assign(this, init); }
}
(SimpleStatusDto as unknown)[immerable] = true;

export class SimpleTeamDto
{
    public id: string;
    public name: string;

    public constructor(init?: Partial<SimpleTeamDto>) { (Object as any).assign(this, init); }
}
(SimpleTeamDto as unknown)[immerable] = true;

export class UserDto
{
    public id: string;
    public name: string;

    public constructor(init?: Partial<UserDto>) { (Object as any).assign(this, init); }
}
(UserDto as unknown)[immerable] = true;

export class ScheduledActionDto
{
    public id: string;
    public name: string;
    public dueAt?: string;
    public createdAt?: string;
    public processActionId?: string;
    public actionName: string;
    public isActive: boolean;
    public outcome: string;
    public actionParams: { [index:string]: Object; };

    public constructor(init?: Partial<ScheduledActionDto>) { (Object as any).assign(this, init); }
}
(ScheduledActionDto as unknown)[immerable] = true;

export class SimpleWorkflowAppointmentDto
{
    public appointmentId: number;
    public startDateTime: string;
    public endDateTime: string;
    public locationId: number;
    public locationName: string;
    public practitionerId: number;
    public practitionerName: string;
    public authCode: string;
    public status: number;
    public statusName: string;
    public stockDescription: string;

    public constructor(init?: Partial<SimpleWorkflowAppointmentDto>) { (Object as any).assign(this, init); }
}
(SimpleWorkflowAppointmentDto as unknown)[immerable] = true;

export class SimpleWorkflowFormReportDto
{
    public id: number;
    public globalId: string;
    public templateId: string;
    public templateName: string;
    public patientId: number;
    public caseId?: number;
    public dateSent?: string;
    public submissionDate?: string;
    public completionDate?: string;
    public declinedDate?: string;
    public cancellationDate?: string;
    public status: number;
    public patientSubmitted: boolean;
    public signatureRequired: boolean;
    public patientEmail: string;
    public patientMobileTelephone: string;
    public patientSmsEnabled: boolean;

    public constructor(init?: Partial<SimpleWorkflowFormReportDto>) { (Object as any).assign(this, init); }
}
(SimpleWorkflowFormReportDto as unknown)[immerable] = true;

export class SimpleWorkflowDetailResponse
{
    public workflowId: number;
    public subWorkflowId?: number;
    public referralId?: number;
    public referralName: string;
    public referralEmail: string;
    public referralPhone: string;
    public referralReference: string;
    public referralTemplateId?: string;
    public processId?: string;
    public processName: string;
    public statusId?: string;
    public statusName: string;
    public ownerId?: string;
    public ownerName: string;
    public userId?: string;
    public userName: string;
    public overallOwnerId?: string;
    public overallOwnerName: string;
    public referralPortalOwnerId?: string;
    public referralPortalOwnerName: string;
    public teamId?: string;
    public teamName: string;
    public createdDate?: string;
    public dueDate?: string;
    public closed?: boolean;
    public customerId?: number;
    public customerName: string;
    public customerDateOfBirth?: string;
    public customerAddressLine1: string;
    public referringContactId?: number;
    public referringContactName: string;
    public unresolvedCustomer: boolean;
    public potentialCustomerMatches: SimpleWorkflowPotentialCustomerMatchDto[];
    public billingModeId?: number;
    public caseId?: number;
    public audits: SimpleWorkflowAuditDto[];
    public availableActions: SimpleProcessActionDto[];
    public availableStatuses: SimpleStatusDto[];
    public availableTeams: SimpleTeamDto[];
    public availableOwners: UserDto[];
    public availableReferralPortalOwners: UserDto[];
    public referralData: JsonField;
    public groupId?: number;
    public groupName: string;
    public secondaryGroupId?: number;
    public secondaryGroupName: string;
    public scheduledActions: ScheduledActionDto[];
    public linkedAppointments: SimpleWorkflowAppointmentDto[];
    public formReports: SimpleWorkflowFormReportDto[];

    public constructor(init?: Partial<SimpleWorkflowDetailResponse>) { (Object as any).assign(this, init); }
}
(SimpleWorkflowDetailResponse as unknown)[immerable] = true;

export class SimpleWorkflowHyperlinkResponse
{
    public id: string;
    public workflowId: number;
    public name: string;
    public url: string;
    public notes: string;
    public type?: HyperlinkType;
    public dateTimeStamp?: string;
    public availableOnReferralPortal: boolean;

    public constructor(init?: Partial<SimpleWorkflowHyperlinkResponse>) { (Object as any).assign(this, init); }
}
(SimpleWorkflowHyperlinkResponse as unknown)[immerable] = true;

export class CreateSimpleWorkflowResponse
{
    public workflowId: number;
    public subWorkflowId: number;
    public referralId?: number;
    public statusId?: string;

    public constructor(init?: Partial<CreateSimpleWorkflowResponse>) { (Object as any).assign(this, init); }
}
(CreateSimpleWorkflowResponse as unknown)[immerable] = true;

export class SimpleWorkflowMappingDto
{
    public id: number;
    public groupId: number;
    public onlineClinicServiceId: string;
    public serviceName: string;
    public serviceDescription: string;
    public isLocationBased: boolean;
    public enabled: boolean;
    public allowAppointmentlessReferral: boolean;
    public portalBookingMode: PortalBookingModes;
    public processId: string;
    public defaultStatusId?: string;
    public defaultTeamId?: string;
    public defaultOwnerId?: string;
    public templateId?: string;

    public constructor(init?: Partial<SimpleWorkflowMappingDto>) { (Object as any).assign(this, init); }
}
(SimpleWorkflowMappingDto as unknown)[immerable] = true;

export class AutomationStepCodesDto
{
    public sendEmail: string;
    public sendSms: string;
    public addNote: string;
    public assignOwner: string;
    public assignTeamUser: string;
    public closeWorkflow: string;
    public startJourney: string;
    public sendForm: string;
    public generateBookingLink: string;
    public tagPatient: string;
    public sendBackupCardRequest: string;

    public constructor(init?: Partial<AutomationStepCodesDto>) { (Object as any).assign(this, init); }
}
(AutomationStepCodesDto as unknown)[immerable] = true;

export class SimpleWorkflowMappingsResponse
{
    public groupId: number;
    public referralPortalEnabled: boolean;
    public mappings: SimpleWorkflowMappingDto[];
    public defaultTemplateId?: string;
    public stepCodes: AutomationStepCodesDto;

    public constructor(init?: Partial<SimpleWorkflowMappingsResponse>) { (Object as any).assign(this, init); }
}
(SimpleWorkflowMappingsResponse as unknown)[immerable] = true;

export class SimpleWorkflowConnectServiceResponse
{
    public id: string;
    public name: string;
    public description: string;
    public isLocationBased: boolean;
    public isHidden: boolean;
    public isOnline: boolean;

    public constructor(init?: Partial<SimpleWorkflowConnectServiceResponse>) { (Object as any).assign(this, init); }
}
(SimpleWorkflowConnectServiceResponse as unknown)[immerable] = true;

export class LinksV1
{
    public self: string;
    public next: string;
    public previous: string;

    public constructor(init?: Partial<LinksV1>) { (Object as any).assign(this, init); }
}
(LinksV1 as unknown)[immerable] = true;

export class PaginationV1
{
    public page: number;
    public perPage: number;
    public totalEntries: number;
    public totalPages: number;
    public links: LinksV1;

    public constructor(init?: Partial<PaginationV1>) { (Object as any).assign(this, init); }
}
(PaginationV1 as unknown)[immerable] = true;

export class PaginatedResponseV1<T>
{
    public data: T[];
    public pagination: PaginationV1;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<PaginatedResponseV1<T>>) { (Object as any).assign(this, init); }
}

export class AvailabilitySlotV1Dto
{
    public startDateTime: string;
    public endDateTime: string;
    public durationMinutes: number;
    public locationId: string;
    public locationName: string;
    public practitionerId: string;
    public practitionerName: string;
    public roomId?: string;
    public roomName: string;
    public stockId?: string;
    public price?: number;
    public priceExVat?: number;

    public constructor(init?: Partial<AvailabilitySlotV1Dto>) { (Object as any).assign(this, init); }
}
(AvailabilitySlotV1Dto as unknown)[immerable] = true;

export class SessionV1Dto
{
    public startDateTime: string;
    public endDateTime: string;
    public locationId: string;
    public locationName: string;
    public practitionerId: string;
    public practitionerName: string;
    public isOnline: boolean;
    public sessionType: string;

    public constructor(init?: Partial<SessionV1Dto>) { (Object as any).assign(this, init); }
}
(SessionV1Dto as unknown)[immerable] = true;

export class PractitionerLocationV1Dto
{
    public id: string;
    public practitionerId: string;
    public locationId: string;
    public locationName: string;
    public firstAppointmentStockId?: string;
    public nextAppointmentStockId?: string;
    public code: string;
    public diaryOrder?: number;

    public constructor(init?: Partial<PractitionerLocationV1Dto>) { (Object as any).assign(this, init); }
}
(PractitionerLocationV1Dto as unknown)[immerable] = true;

export class ServiceTypeV1Dto
{
    public id: string;
    public name: string;
    public isCurrent: boolean;
    public createdAt: string;
    public updatedAt: string;

    public constructor(init?: Partial<ServiceTypeV1Dto>) { (Object as any).assign(this, init); }
}
(ServiceTypeV1Dto as unknown)[immerable] = true;

export class TagV1Dto
{
    public name: string;
    public colour: string;

    public constructor(init?: Partial<TagV1Dto>) { (Object as any).assign(this, init); }
}
(TagV1Dto as unknown)[immerable] = true;

export class StripeResponseBase
{
    public statusCode: HttpStatusCode;
    public headers: HttpResponseHeaders;
    public date?: string;
    public idempotencyKey: string;
    public requestId: string;

    public constructor(init?: Partial<StripeResponseBase>) { (Object as any).assign(this, init); }
}

export class StripeResponse extends StripeResponseBase
{
    public content: string;

    public constructor(init?: Partial<StripeResponse>) { super(init); (Object as any).assign(this, init); }
}
(StripeResponse as unknown)[immerable] = true;

export interface IStripeEntity
{
    stripeResponse: StripeResponse;
}

export interface IHasId
{
    id: string;
}

export interface IHasMetadata
{
    metadata: { [index:string]: string; };
}

export interface IHasObject
{
    object: string;
}

export class CustomerResponse
{

    public constructor(init?: Partial<CustomerResponse>) { (Object as any).assign(this, init); }
}
(CustomerResponse as unknown)[immerable] = true;

export class StockInventoryLevelRes
{
    public id: number;
    public batchCode: string;
    public expiryDate?: string;
    public quantity: number;

    public constructor(init?: Partial<StockInventoryLevelRes>) { (Object as any).assign(this, init); }
}
(StockInventoryLevelRes as unknown)[immerable] = true;

export interface IHasUsers
{
    users: UserActivations[];
}

export class ClinicalScore implements IHasId
{
    public id: number;
    public title: string;
    public dateAdded?: string;
    public dateCompleted?: string;
    public caseId: number;
    public settingId: number;

    public constructor(init?: Partial<ClinicalScore>) { (Object as any).assign(this, init); }
}
(ClinicalScore as unknown)[immerable] = true;

export class CasePrintingScore<T> extends ClinicalScore
{
    public entries: T[];

    public constructor(init?: Partial<CasePrintingScore<T>>) { super(init); (Object as any).assign(this, init); }
}

export class Goal implements IHasId
{
    public id: number;
    public title: string;
    public dateAdded?: string;
    public dateCompleted?: string;
    public caseId: number;
    public settingId: number;
    public averaged: boolean;

    public constructor(init?: Partial<Goal>) { (Object as any).assign(this, init); }
}
(Goal as unknown)[immerable] = true;

export class CasePrintingGoal<T> extends Goal
{
    public entries: T[];

    public constructor(init?: Partial<CasePrintingGoal<T>>) { super(init); (Object as any).assign(this, init); }
}

export class Fido2 implements IFido2
{

    public constructor(init?: Partial<Fido2>) { (Object as any).assign(this, init); }
}
(Fido2 as unknown)[immerable] = true;

export interface IPrivateOnlyCharge
{
    restrictToPrivateCharges: boolean;
}

export enum WorkflowContactType
{
    Patient = 'Patient',
    Contact = 'Contact',
    GroupContact = 'GroupContact',
    NetworkLocation = 'NetworkLocation',
    NetworkClinician = 'NetworkClinician',
    Practitioner = 'Practitioner',
    Location = 'Location',
    Group = 'Group',
}

export enum PortalBookingModes
{
    NotReferred = 'NotReferred',
    ReferralNoBooking = 'ReferralNoBooking',
    ReferralWithOptionalBooking = 'ReferralWithOptionalBooking',
    ReferralWithMandatoryBooking = 'ReferralWithMandatoryBooking',
}

export interface IClassFinanceResponse
{
    invoiceId?: number;
    paymentId?: number;
}

export enum NumericFilterConditions
{
    IsBetween = 'IsBetween',
    IsNotBetween = 'IsNotBetween',
    IsEqualTo = 'IsEqualTo',
    IsNotEqualTo = 'IsNotEqualTo',
    IsLessThan = 'IsLessThan',
    IsLessThanOrEqual = 'IsLessThanOrEqual',
    IsGreaterThan = 'IsGreaterThan',
    IsGreaterThanOrEqual = 'IsGreaterThanOrEqual',
}

export class NumericSearch<T>
{
    public selectedFilterOption: NumericFilterConditions;
    public numericRangeValue: NumericRange<T>;

    public constructor(init?: Partial<NumericSearch<T>>) { (Object as any).assign(this, init); }
}

export enum NetworkServiceType
{
    Appointment = 'Appointment',
    Cancellation = 'Cancellation',
    DNA = 'DNA',
}

export class BillingItemResponse
{

    public constructor(init?: Partial<BillingItemResponse>) { (Object as any).assign(this, init); }
}

export class AudienceMember
{
    public id: number;
    public num: number;
    public homeTelephone: string;
    public workTelephone: string;
    public mobileTelephone: string;
    public email: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public addressLine5: string;
    public postCode: string;
    public title: string;
    public forename: string;
    public surname: string;
    public emailConsent: boolean;

    public constructor(init?: Partial<AudienceMember>) { (Object as any).assign(this, init); }
}
(AudienceMember as unknown)[immerable] = true;

export class DataPoint
{
    public period: string;
    public date: string;
    public referral: number;
    public reception: number;
    public online: number;

    public constructor(init?: Partial<DataPoint>) { (Object as any).assign(this, init); }
}
(DataPoint as unknown)[immerable] = true;

export class ClassSessionWithDetails
{
    public sessionId: number;
    public name: string;
    public description: string;
    public practitionerForename: string;
    public practitionerSurname: string;
    // @Ignore()
    public practitionerName: string;

    public startDate: string;
    public endDate: string;
    public isVideo?: boolean;
    public videoMeetingPassword: string;
    public videoMeetingParticipantJoinUrl: string;
    public videoMeetingId: string;
    public videoMeetingHostJoinUrl: string;
    public videoMeetingProvider?: VideoMeetingProvider;
    public classCapacity: number;
    public minAttendees: number;
    public totalAttendees: number;
    public appointmentStatus: number;
    public colour?: number;
    public hexColour: string;
    public roomName: string;
    public locationName: string;

    public constructor(init?: Partial<ClassSessionWithDetails>) { (Object as any).assign(this, init); }
}
(ClassSessionWithDetails as unknown)[immerable] = true;

export class ReportingField
{
    public name: string;
    public field: string;
    public type: string;

    public constructor(init?: Partial<ReportingField>) { (Object as any).assign(this, init); }
}
(ReportingField as unknown)[immerable] = true;

export class ClinicalScoreEntry implements IHasId
{
    public id: number;
    public scoreId: number;
    public score: number;
    public dateAdded?: string;
    public patientSubmitted: boolean;
    public objectType: string;
    public objectId: number;

    public constructor(init?: Partial<ClinicalScoreEntry>) { (Object as any).assign(this, init); }
}
(ClinicalScoreEntry as unknown)[immerable] = true;

export class GoalEntry implements IHasId
{
    public id: number;
    public notes: string;
    public goalId: number;
    public completionPercentage: number;
    public dateAdded?: string;
    public patientSubmitted: boolean;
    public objectType: string;
    public objectId: number;

    public constructor(init?: Partial<GoalEntry>) { (Object as any).assign(this, init); }
}
(GoalEntry as unknown)[immerable] = true;

export interface IFido2
{
}

export class NumericRange<T>
{
    public from: string;
    public to: string;

    public constructor(init?: Partial<NumericRange<T>>) { (Object as any).assign(this, init); }
}

export class DataScopesResources1
{
    public read?: boolean;
    public write?: boolean;

    public constructor(init?: Partial<DataScopesResources1>) { (Object as any).assign(this, init); }
}
(DataScopesResources1 as unknown)[immerable] = true;

export class ZodSchemasResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ZodSchemasResponse>) { (Object as any).assign(this, init); }
}

export class HttpResult
{
    public responseText: string;
    public responseStream: string;
    public fileInfo: FileInfo;
    public virtualFile: IVirtualFile;
    public contentType: string;
    public headers: { [index:string]: string; };
    public cookies: Cookie[];
    public eTag: string;
    public age?: string;
    public maxAge?: string;
    public expires?: string;
    public lastModified?: string;
    public cacheControl: CacheControl;
    public resultScope: Func<IDisposable>;
    public allowsPartialResponse: boolean;
    public options: { [index:string]: string; };
    public status: number;
    public statusCode: HttpStatusCode;
    public statusDescription: string;
    public response: Object;
    public responseFilter: IContentTypeWriter;
    public requestContext: IRequest;
    public view: string;
    public template: string;
    public paddingLength: number;
    public isPartialRequest: boolean;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<HttpResult>) { (Object as any).assign(this, init); }
}
(HttpResult as unknown)[immerable] = true;

// @DataContract
export class FilesListingResponse
{
    // @DataMember(Order=1)
    public directory: FolderResult;

    // @DataMember(Order=2)
    public file: File;

    // @DataMember(Order=3)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<FilesListingResponse>) { (Object as any).assign(this, init); }
}
(FilesListingResponse as unknown)[immerable] = true;

export class CaseImagingResponse
{
    public images: { [index:string]: CaseImagingResult; };
    public custom: { [index:string]: CaseImagingResult; };
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CaseImagingResponse>) { (Object as any).assign(this, init); }
}
(CaseImagingResponse as unknown)[immerable] = true;

export class SmsResponse
{
    public success: svcResponse;
    public message: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SmsResponse>) { (Object as any).assign(this, init); }
}
(SmsResponse as unknown)[immerable] = true;

export class SmsConsentReponse
{
    public hasConsent: boolean;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SmsConsentReponse>) { (Object as any).assign(this, init); }
}
(SmsConsentReponse as unknown)[immerable] = true;

export class ContactRecentResponse
{
    public contactsCount: number;
    public document: File;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ContactRecentResponse>) { (Object as any).assign(this, init); }
}
(ContactRecentResponse as unknown)[immerable] = true;

export class PatientRecentResponse
{
    public nextAppointment: AppointmentResponse;
    public contact: MedicalContactResponse;
    public contactsCount: number;
    public bookedCount: number;
    public cancelledCount: number;
    public dnaCount: number;
    public completedCount: number;
    public auths: TreatmentAuthResponse[];
    public futureAuths: TreatmentAuthResponse[];
    public transactions: TransactionItemResponse[];
    public cases: CaseSearchResponse[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<PatientRecentResponse>) { (Object as any).assign(this, init); }
}
(PatientRecentResponse as unknown)[immerable] = true;

export class RecentDocumentResponse
{
    public document: File;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<RecentDocumentResponse>) { (Object as any).assign(this, init); }
}
(RecentDocumentResponse as unknown)[immerable] = true;

export class DiaryDefaultDataForUserResponse
{
    public currentLocation: LocationResponse;
    public currentPractitioner: GeneralPractitionerResponse;
    public currentRoom: RoomResponse;
    public practitioners: GeneralPractitionerResponse[];
    public locations: LocationResponse[];
    public rooms: RoomResponse[];
    public practitionerLocations: PractitionerLocation[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DiaryDefaultDataForUserResponse>) { (Object as any).assign(this, init); }
}
(DiaryDefaultDataForUserResponse as unknown)[immerable] = true;

export class DiaryStatsResponse
{
    public booked: number;
    public arrived: number;
    public inProgress: number;
    public finished: number;
    public complete: number;
    public cancel: number;
    public other: number;
    public class: number;
    public dna: number;
    public total: number;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DiaryStatsResponse>) { (Object as any).assign(this, init); }
}
(DiaryStatsResponse as unknown)[immerable] = true;

export class CalculateWorkingTimesResponse
{
    public workingTime: string;
    public lastestEndDate?: string;
    public totalSessions: number;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CalculateWorkingTimesResponse>) { (Object as any).assign(this, init); }
}
(CalculateWorkingTimesResponse as unknown)[immerable] = true;

export class Account implements IHasId, IHasGlobalGuid
{
    public id: number;
    public accountType: string;
    public name: string;
    public accountTypeId: number;
    // @Ignore()
    public accountTypeGuid: string;

    public balanceInvoiced: number;
    public balanceOwed: number;
    public transferred?: string;
    // @Ignore()
    public uninvoicedCharges: number;

    public globalGuid: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<Account>) { (Object as any).assign(this, init); }
}
(Account as unknown)[immerable] = true;

export class AccountExportResponse
{
    public exportId: number;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AccountExportResponse>) { (Object as any).assign(this, init); }
}
(AccountExportResponse as unknown)[immerable] = true;

export class TransferResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<TransferResponse>) { (Object as any).assign(this, init); }
}
(TransferResponse as unknown)[immerable] = true;

// @DataContract
export class DeleteResponse
{
    // @DataMember(Order=1)
    public success: boolean;

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteResponse>) { (Object as any).assign(this, init); }
}
(DeleteResponse as unknown)[immerable] = true;

// @DataContract
export class CopyResponse
{
    // @DataMember(Order=1)
    public success: boolean;

    // @DataMember(Order=2)
    public isGlobal: boolean;

    // @DataMember(Order=3)
    public renamedFiles: { [index:string]: string; };

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CopyResponse>) { (Object as any).assign(this, init); }
}
(CopyResponse as unknown)[immerable] = true;

// @DataContract
export class CreateFolderResponse
{
    // @DataMember(Order=1)
    public success: boolean;

    // @DataMember(Order=2)
    public folderName: string;

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CreateFolderResponse>) { (Object as any).assign(this, init); }
}
(CreateFolderResponse as unknown)[immerable] = true;

// @DataContract
export class RenameResponse
{
    // @DataMember(Order=1)
    public success: boolean;

    // @DataMember(Order=2)
    public fileName: string;

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<RenameResponse>) { (Object as any).assign(this, init); }
}
(RenameResponse as unknown)[immerable] = true;

// @DataContract
export class MoveResponse
{
    // @DataMember(Order=1)
    public success: boolean;

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<MoveResponse>) { (Object as any).assign(this, init); }
}
(MoveResponse as unknown)[immerable] = true;

// @DataContract
export class UploadResult
{
    // @DataMember(Order=1)
    public paths: string[];

    // @DataMember(Order=2)
    public uploadErrors: string[];

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UploadResult>) { (Object as any).assign(this, init); }
}
(UploadResult as unknown)[immerable] = true;

// @DataContract
export class UploadTempResult
{
    // @DataMember(Order=1)
    public id: string;

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UploadTempResult>) { (Object as any).assign(this, init); }
}
(UploadTempResult as unknown)[immerable] = true;

export class AttachmentSummaryResponse
{
    public files: Attachment[];
    public templates: Attachment[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AttachmentSummaryResponse>) { (Object as any).assign(this, init); }
}
(AttachmentSummaryResponse as unknown)[immerable] = true;

export class RecentFileResponse
{
    // @DataMember(Order=1)
    public file: File;

    // @DataMember(Order=2)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<RecentFileResponse>) { (Object as any).assign(this, init); }
}
(RecentFileResponse as unknown)[immerable] = true;

// @DataContract
export class FileResponse
{
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public contents: string;

    // @DataMember(Order=3)
    public contentLength: number;

    public constructor(init?: Partial<FileResponse>) { (Object as any).assign(this, init); }
}
(FileResponse as unknown)[immerable] = true;

export class FolderTree
{
    public folders: FolderTree[];
    public files: File[];
    public name: string;
    public path: string;
    public fileCount: number;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<FolderTree>) { (Object as any).assign(this, init); }
}
(FolderTree as unknown)[immerable] = true;

export class GroupFurtherDetailsResponse
{
    public location: string;
    public balanceOwed: number;
    public balanceInvoiced: number;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GroupFurtherDetailsResponse>) { (Object as any).assign(this, init); }
}
(GroupFurtherDetailsResponse as unknown)[immerable] = true;

export class GroupRecentResponse
{
    public contactsCount: number;
    public transactions: TransactionItemResponse[];
    public accountBalance: number;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GroupRecentResponse>) { (Object as any).assign(this, init); }
}
(GroupRecentResponse as unknown)[immerable] = true;

export class LocationStockResponse
{
    public locations: LocResponse[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<LocationStockResponse>) { (Object as any).assign(this, init); }
}
(LocationStockResponse as unknown)[immerable] = true;

export class PhysiotecPractitioner implements IHasId
{
    public id: number;
    public practitionerId: number;
    public userName: string;
    public password: string;
    public status: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<PhysiotecPractitioner>) { (Object as any).assign(this, init); }
}
(PhysiotecPractitioner as unknown)[immerable] = true;

// @Route("/pronto-my-clinic-url")
export class ProntoMyClinicRequest implements IReturn<ProntoMyClinicRequest>
{
    public result: string;

    public constructor(init?: Partial<ProntoMyClinicRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProntoMyClinicRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ProntoMyClinicRequest(); }
}
(ProntoMyClinicRequest as unknown)[immerable] = true;

export class MyBookingsResponse extends ResponseBase<BookingAuditResult>
{
    public all: number;
    public online: number;
    public referrals: number;
    public reception: number;
    public received: number;
    public awaiting: number;
    public rejected: number;
    public booking: number;
    public enterFirstReport: number;
    public inTreatment: number;
    public discharged: number;
    public complete: number;
    public none: number;
    public needsAction: number;
    public requiresIAReportSubmission: number;
    public appointmentsInThePast: number;
    public additionalAuthsAdded: number;
    public authsRevoked: number;
    public page: number;
    public totalPages: number;
    public filteredResultCount: number;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<MyBookingsResponse>) { super(init); (Object as any).assign(this, init); }
}
(MyBookingsResponse as unknown)[immerable] = true;

export class Room implements IHasId, IHasGlobalGuid
{
    public id: number;
    public description: string;
    public locationId: number;
    // @Ignore()
    public locationGuid: string;

    public status: boolean;
    public colour?: number;
    public discriminatorType?: string;
    public globalGuid: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<Room>) { (Object as any).assign(this, init); }
}
(Room as unknown)[immerable] = true;

export class SecurityStatsResponse
{
    public stats: SecurityStat[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SecurityStatsResponse>) { (Object as any).assign(this, init); }
}
(SecurityStatsResponse as unknown)[immerable] = true;

export class StockReorderResponse
{
    public results: StockReorder[];
    public totals: { [index:string]: number; };
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<StockReorderResponse>) { (Object as any).assign(this, init); }
}
(StockReorderResponse as unknown)[immerable] = true;

export class StockSalesResponse
{
    public results: StockSales[];
    public totals: { [index:string]: number; };
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<StockSalesResponse>) { (Object as any).assign(this, init); }
}
(StockSalesResponse as unknown)[immerable] = true;

export class InvoiceAnalysisResponse
{
    public results: InvoiceAnalysisReport[];
    public totals: { [index:string]: number; };
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<InvoiceAnalysisResponse>) { (Object as any).assign(this, init); }
}
(InvoiceAnalysisResponse as unknown)[immerable] = true;

export class IncomeAnalysisResponse
{
    public results: IncomeAnalysisReport[];
    public totals: { [index:string]: number; };
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<IncomeAnalysisResponse>) { (Object as any).assign(this, init); }
}
(IncomeAnalysisResponse as unknown)[immerable] = true;

export class ExpenditureMonthSummaryResponse
{
    public results: ExpenditureMonthSummary[];
    public totals: { [index:string]: number; };
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ExpenditureMonthSummaryResponse>) { (Object as any).assign(this, init); }
}
(ExpenditureMonthSummaryResponse as unknown)[immerable] = true;

export class ExpenditureAnalysisResponse
{
    public results: ExpenditureAnalysisReportDto[];
    public totals: { [index:string]: number; };
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ExpenditureAnalysisResponse>) { (Object as any).assign(this, init); }
}
(ExpenditureAnalysisResponse as unknown)[immerable] = true;

export class AgedDebtorsResponse
{
    public results: AgedDebtors[];
    public totals: { [index:string]: number; };
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AgedDebtorsResponse>) { (Object as any).assign(this, init); }
}
(AgedDebtorsResponse as unknown)[immerable] = true;

export class DebtorsByAccountResponse
{
    public results: DebtorsByAccount[];
    public totals: { [index:string]: number; };
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DebtorsByAccountResponse>) { (Object as any).assign(this, init); }
}
(DebtorsByAccountResponse as unknown)[immerable] = true;

export class DebtorsOnADateResponse
{
    public results: DebtorsOnADate[];
    public totals: { [index:string]: number; };
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DebtorsOnADateResponse>) { (Object as any).assign(this, init); }
}
(DebtorsOnADateResponse as unknown)[immerable] = true;

export class ChargeAnalysisResponse
{
    public results: ChargesAnalysisReport[];
    public totals: { [index:string]: number; };
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ChargeAnalysisResponse>) { (Object as any).assign(this, init); }
}
(ChargeAnalysisResponse as unknown)[immerable] = true;

export class AdmissionsAnalysisReportResponse
{
    public results: AdmissionsAnalysisReport[];
    public total: number;
    public totals: { [index:string]: number; };
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AdmissionsAnalysisReportResponse>) { (Object as any).assign(this, init); }
}
(AdmissionsAnalysisReportResponse as unknown)[immerable] = true;

export class CasesDueForReviewReportResponse
{
    public results: CasesDueForReviewReport[];
    public total: number;
    public totals: { [index:string]: number; };
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CasesDueForReviewReportResponse>) { (Object as any).assign(this, init); }
}
(CasesDueForReviewReportResponse as unknown)[immerable] = true;

export class LapsedPatientsReportResponse
{
    public results: LapsedPatientsReport[];
    public totals: { [index:string]: number; };
    public total: number;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<LapsedPatientsReportResponse>) { (Object as any).assign(this, init); }
}
(LapsedPatientsReportResponse as unknown)[immerable] = true;

export class ClientBirthdayResponse
{
    public results: ClientBirthdayReport[];
    public totals: { [index:string]: number; };
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ClientBirthdayResponse>) { (Object as any).assign(this, init); }
}
(ClientBirthdayResponse as unknown)[immerable] = true;

export class Location implements IHasId, ILocationId, IHasGlobalGuid
{
    public id: number;
    public name: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public addressLine5: string;
    public postCode: string;
    public telephone: string;
    public email: string;
    public web: string;
    public fax: string;
    public status: number;
    public onlineGuid: string;
    public dnaStockId?: number;
    public cancelStockId?: number;
    // @Ignore()
    public dnaStockGuid?: string;

    // @Ignore()
    public cancelStockGuid?: string;

    public isNetworkLocation?: boolean;
    public isTemplateLocation?: boolean;
    public directions: string;
    public services: string;
    public region: string;
    public reminderTemplateEmail_TM3: string;
    public reminderTemplateSMS_TM3: string;
    public facilities: string;
    public locationLong: number;
    public locationLat: number;
    public hasCoordinates?: boolean;
    public isMainLocation: boolean;
    // @Ignore()
    public fullAddressMultiLine: string;

    // @Ignore()
    public locationId: number;

    // @Ignore()
    public globalGuid: string;

    /** @description For ClearAccept, this is the Location's specific Merchant Id */
    public clearAcceptMerchantId: string;
    /** @description For ClearAccept, this is the Location's e-commerce Merchant Site ID */
    public ecommerceMerchantSiteId: string;
    /** @description For ClearAccept, this is the Location's Merchant Site ID */
    public merchantReference: string;
    public trackingCategory: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<Location>) { (Object as any).assign(this, init); }
}
(Location as unknown)[immerable] = true;

// @DataContract
export class EmptyResponse
{
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<EmptyResponse>) { (Object as any).assign(this, init); }
}
(EmptyResponse as unknown)[immerable] = true;

export class GetEmailFromAddressResponse
{
    public email: string;
    public name: string;
    public allowedFromAddresses: string[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetEmailFromAddressResponse>) { (Object as any).assign(this, init); }
}
(GetEmailFromAddressResponse as unknown)[immerable] = true;

export class GetEmailFromAddressSettingsResponse
{
    public fromAddresses: string[];
    public authenticatedDomains: string[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetEmailFromAddressSettingsResponse>) { (Object as any).assign(this, init); }
}
(GetEmailFromAddressSettingsResponse as unknown)[immerable] = true;

export class ClearCachedReloadMissingFilesResponse
{
    public result: string;
    public message: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ClearCachedReloadMissingFilesResponse>) { (Object as any).assign(this, init); }
}
(ClearCachedReloadMissingFilesResponse as unknown)[immerable] = true;

export class DiagnosisCode implements IHasId
{
    public id: number;
    public text: string;
    public bodySite: string;
    public mapping: string;
    public serviceTypeId: number;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DiagnosisCode>) { (Object as any).assign(this, init); }
}
(DiagnosisCode as unknown)[immerable] = true;

export class ClinicalSettingsFlagsResponse
{
    public flags: ConfigResponse[];
    public flagValues: CustomListItemResponse[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ClinicalSettingsFlagsResponse>) { (Object as any).assign(this, init); }
}
(ClinicalSettingsFlagsResponse as unknown)[immerable] = true;

export class DryIocBenchmarkResponse
{
    public mode: string;
    public iterations: number;
    public startedUtc: string;
    public completedUtc: string;
    public phases: DryIocBenchmarkPhaseResult[];
    public snapshots: DryIocBenchmarkSnapshot[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DryIocBenchmarkResponse>) { (Object as any).assign(this, init); }
}
(DryIocBenchmarkResponse as unknown)[immerable] = true;

// @Route("/client/sms/settings")
export class ClientSmsSettings implements IReturn<ClientSmsSettings>
{
    public clientId: number;
    public fromMode: FromMode;
    public fromText: string;
    public fromNumber: string;
    public returnEmail: string;
    public fromNumbers: string[];

    public constructor(init?: Partial<ClientSmsSettings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClientSmsSettings'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ClientSmsSettings(); }
}
(ClientSmsSettings as unknown)[immerable] = true;

// @Route("/client/sms/settings/code")
export class ClientCodeRequest implements IReturn<ClientCodeRequest>
{
    public clientId: number;
    public code: string;

    public constructor(init?: Partial<ClientCodeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClientCodeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ClientCodeRequest(); }
}
(ClientCodeRequest as unknown)[immerable] = true;

export class CaseAuditResponse
{
    public caseClosed?: boolean;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CaseAuditResponse>) { (Object as any).assign(this, init); }
}
(CaseAuditResponse as unknown)[immerable] = true;

// @Route("/cases/{Id}", "PUT")
// @Route("/cases/", "POST")
export class CaseDetailsDto implements IReturn<CaseDetailsDto>, ILocationIds, IServiceTypeId
{
    public id: number;
    public case: CaseWithCustomerPractitionerLocationDetails;
    public serviceTypeId: number;
    public graphics: GraphicResult[];
    public images: ImageResult[];
    public other: CaseSummaryResult[];
    public linked: CaseSummaryResult[];
    public stats: Object;
    public recentModalities: ConsultationItem[];
    public recentAssessments: ConsultationItem[];
    public postCloseNotes: PostCloseNotesWithUser[];
    public appointmentId: number;
    public locationIds: number[];
    public requestLocationIds: number[];
    public meta: { [index:string]: Object; };
    public availableGoals: CaseScoreGoalResponse[];
    public availableScores: CaseScoreGoalResponse[];
    public viewed: boolean;
    public pathologyOrders: PathologyOrderResponse[];
    public medicalImagingOrders: MedicalImagingOrderDetails[];

    public constructor(init?: Partial<CaseDetailsDto>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseDetailsDto'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CaseDetailsDto(); }
}
(CaseDetailsDto as unknown)[immerable] = true;

export class ClinicalCacheResponse
{
    public practitioners: { [index:number]: string; };
    public medicalContacts: { [index:number]: string; };
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ClinicalCacheResponse>) { (Object as any).assign(this, init); }
}
(ClinicalCacheResponse as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/consultation/{TreatmentId}/items", "POST")
// @Route("/cases/{CaseId}/consultation/{TreatmentId}/items/{Id}", "GET, PUT, DELETE")
export class ConsultationItemRequest implements IReturn<ConsultationItemRequest>, ISecurityId
{
    public id: number;
    public caseId: number;
    public treatmentId?: number;
    public templateId: string;
    public title: string;
    public date?: string;
    public type: ConsultationItemType;
    public data: { [index:string]: Object; };
    public securityId: number;

    public constructor(init?: Partial<ConsultationItemRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ConsultationItemRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ConsultationItemRequest(); }
}
(ConsultationItemRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/consultation/{TreatmentId}/items", "POST")
export class ConsultationAssessmentItemRequest implements IReturn<ConsultationAssessmentItemRequest>, ISecurityId
{
    public id: number;
    public caseId: number;
    public treatmentId?: number;
    public templateId: string;
    public title: string;
    public date?: string;
    public type: ConsultationItemType;
    public data: { [index:string]: Object; };
    public securityId: number;

    public constructor(init?: Partial<ConsultationAssessmentItemRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ConsultationAssessmentItemRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ConsultationAssessmentItemRequest(); }
}
(ConsultationAssessmentItemRequest as unknown)[immerable] = true;

export class ClinicalDiagram implements IHasId
{
    public id: number;
    public caseId: number;
    public treatmentId?: number;
    public closedUser: string;
    public dateTime?: string;
    public closedDateTime?: string;
    public closedUserId?: number;
    public value: { [index:string]: Object; }[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ClinicalDiagram>) { (Object as any).assign(this, init); }
}
(ClinicalDiagram as unknown)[immerable] = true;

export class TreatmentResult extends Treatment
{
    public practitioner: string;
    public practitionerNameWithAwards: string;
    public assessments: AssessmentResult[];
    public items: CaseConsultationItem[];
    public billingItems: BillingItemWithDetails[];
    public hexColour: string;
    public postCloseNotes: PostCloseNotesWithUser[];
    public createdByUserName: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<TreatmentResult>) { super(init); (Object as any).assign(this, init); }
}
(TreatmentResult as unknown)[immerable] = true;

export class ProcessDetailDto extends ProcessSummaryDto
{
    public statuses: StatusNodeDto[];
    public actions: ActionEdgeDto[];
    public draftProcessId?: string;
    public metadata: { [index:string]: string; };
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ProcessDetailDto>) { super(init); (Object as any).assign(this, init); }
}
(ProcessDetailDto as unknown)[immerable] = true;

export class ProcessIdResponse
{
    public id: string;
    public version?: number;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ProcessIdResponse>) { (Object as any).assign(this, init); }
}
(ProcessIdResponse as unknown)[immerable] = true;

export class ProcessDraftDto extends ProcessDetailDto
{
    public parentProcessId?: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ProcessDraftDto>) { super(init); (Object as any).assign(this, init); }
}
(ProcessDraftDto as unknown)[immerable] = true;

export class ProcessStatsDto
{
    public activeJourneyCount: number;
    public totalJourneyCount: number;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ProcessStatsDto>) { (Object as any).assign(this, init); }
}
(ProcessStatsDto as unknown)[immerable] = true;

export class ProcessPublishImpactDto
{
    public publishedProcessId?: string;
    public draftProcessId?: string;
    public publishedName: string;
    public draftName: string;
    public riskLevel: string;
    public activeJourneyCount: number;
    public totalJourneyCount: number;
    public affectedJourneyCount: number;
    public pendingAutomationCount: number;
    public hasDraft: boolean;
    public changes: ProcessChangeItemDto[];
    public excludedTestTags: string[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ProcessPublishImpactDto>) { (Object as any).assign(this, init); }
}
(ProcessPublishImpactDto as unknown)[immerable] = true;

export class AssertionOptions extends Fido2ResponseBase
{
    public challenge: string;
    public timeout: number;
    public rpId: string;
    public allowCredentials: PublicKeyCredentialDescriptor[];
    public userVerification?: UserVerificationRequirement;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AssertionOptions>) { super(init); (Object as any).assign(this, init); }
}
(AssertionOptions as unknown)[immerable] = true;

export class GetBillingEntitiesResponse extends ResponseBase<BillingEntityDto>
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetBillingEntitiesResponse>) { super(init); (Object as any).assign(this, init); }
}
(GetBillingEntitiesResponse as unknown)[immerable] = true;

export class GetBillingEntityResponse extends ResponseBase<BillingEntityDto>
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetBillingEntityResponse>) { super(init); (Object as any).assign(this, init); }
}
(GetBillingEntityResponse as unknown)[immerable] = true;

export class GetBillingEntityDeactivationImpactResponse extends ResponseBase<BillingEntityDeactivationImpactDto>
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetBillingEntityDeactivationImpactResponse>) { super(init); (Object as any).assign(this, init); }
}
(GetBillingEntityDeactivationImpactResponse as unknown)[immerable] = true;

export class CreateBillingEntityResponse extends ResponseBase<BillingEntityDto>
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CreateBillingEntityResponse>) { super(init); (Object as any).assign(this, init); }
}
(CreateBillingEntityResponse as unknown)[immerable] = true;

export class UpdateBillingEntityResponse extends ResponseBase<BillingEntityDto>
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UpdateBillingEntityResponse>) { super(init); (Object as any).assign(this, init); }
}
(UpdateBillingEntityResponse as unknown)[immerable] = true;

export class CaseAlertSearchResponse extends ResponseBase<AlertResponse>
{
    public customerHasAlertsFromMultipleCases: boolean;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CaseAlertSearchResponse>) { super(init); (Object as any).assign(this, init); }
}
(CaseAlertSearchResponse as unknown)[immerable] = true;

export class AlertDialogResponse extends Alert
{
    public alertForPerson: string;
    public alertForDate: string;
    public alertExpiryDate: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AlertDialogResponse>) { super(init); (Object as any).assign(this, init); }
}
(AlertDialogResponse as unknown)[immerable] = true;

export class OAuthCallbackResponse
{
    public idToken: string;
    public accessToken: string;
    public refreshToken: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<OAuthCallbackResponse>) { (Object as any).assign(this, init); }
}
(OAuthCallbackResponse as unknown)[immerable] = true;

export class VirtualReceptionAppointmentCancelResponse
{
    public success: boolean;
    public message: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<VirtualReceptionAppointmentCancelResponse>) { (Object as any).assign(this, init); }
}
(VirtualReceptionAppointmentCancelResponse as unknown)[immerable] = true;

export class VirtualReceptionAvailabilityResponse
{
    public slots: VirtualReceptionSlot[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<VirtualReceptionAvailabilityResponse>) { (Object as any).assign(this, init); }
}
(VirtualReceptionAvailabilityResponse as unknown)[immerable] = true;

export class VirtualReceptionRescheduleResponse
{
    public success: boolean;
    public message: string;
    public newStartDateTime?: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<VirtualReceptionRescheduleResponse>) { (Object as any).assign(this, init); }
}
(VirtualReceptionRescheduleResponse as unknown)[immerable] = true;

export class VirtualReceptionReserveResponse
{
    public appointmentId: number;
    public expiresAt: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<VirtualReceptionReserveResponse>) { (Object as any).assign(this, init); }
}
(VirtualReceptionReserveResponse as unknown)[immerable] = true;

export class VirtualReceptionReleaseResponse
{
    public success: boolean;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<VirtualReceptionReleaseResponse>) { (Object as any).assign(this, init); }
}
(VirtualReceptionReleaseResponse as unknown)[immerable] = true;

export class VirtualReceptionBookResponse
{
    public appointmentId: number;
    public confirmedAt: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<VirtualReceptionBookResponse>) { (Object as any).assign(this, init); }
}
(VirtualReceptionBookResponse as unknown)[immerable] = true;

export class VirtualReceptionAppointmentTypesCountResponse
{
    public count: number;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<VirtualReceptionAppointmentTypesCountResponse>) { (Object as any).assign(this, init); }
}
(VirtualReceptionAppointmentTypesCountResponse as unknown)[immerable] = true;

export class VirtualReceptionPatientAppointmentSearchResponse
{
    public appointments: VirtualReceptionPatientAppointment[];
    public total: number;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<VirtualReceptionPatientAppointmentSearchResponse>) { (Object as any).assign(this, init); }
}
(VirtualReceptionPatientAppointmentSearchResponse as unknown)[immerable] = true;

export class VirtualReceptionCreatePatientResponse
{
    public patientId?: number;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<VirtualReceptionCreatePatientResponse>) { (Object as any).assign(this, init); }
}
(VirtualReceptionCreatePatientResponse as unknown)[immerable] = true;

export class GetDevFlagsResponse
{
    public flags: DevFlagState[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetDevFlagsResponse>) { (Object as any).assign(this, init); }
}
(GetDevFlagsResponse as unknown)[immerable] = true;

export class GetFeatureCatalogResponse
{
    public modules: FeatureCatalogModule[];
    public devFlags: DevFlagState[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetFeatureCatalogResponse>) { (Object as any).assign(this, init); }
}
(GetFeatureCatalogResponse as unknown)[immerable] = true;

export class LegacyFeatureFlagMigrationResponse
{
    public preview: boolean;
    public migrationRequired: boolean;
    public migrated: boolean;
    public items: LegacyFeatureFlagMigrationItem[];
    public message: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<LegacyFeatureFlagMigrationResponse>) { (Object as any).assign(this, init); }
}
(LegacyFeatureFlagMigrationResponse as unknown)[immerable] = true;

export class OnlineUploadTempFileResponse
{
    public id: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<OnlineUploadTempFileResponse>) { (Object as any).assign(this, init); }
}
(OnlineUploadTempFileResponse as unknown)[immerable] = true;

export class OnlineSettingsResponse
{
    public isVHG: boolean;
    public isSiteLive: boolean;
    public siteTitle: string;
    public title: string;
    public logoUrl: string;
    public appIconUrl: string;
    public customColourPrimary: string;
    public customColourSecondary: string;
    public customColourNav: string;
    public customColourNavText: string;
    public message: string;
    public skin: string;
    public confirmSubject: string;
    public confirmFrom: string;
    public connectEnabled: boolean;
    public cancellationPolicy: string;
    public termsAndConditions: string;
    public privacyPolicy: string;
    public license: License;
    public clinical: boolean;
    public payments: boolean;
    public classes: boolean;
    public registerProvisional: boolean;
    public allowClassBooking: boolean;
    public allowRegister: boolean;
    public allowPayAtClinic: boolean;
    public currency: string;
    public googleTrackingId: string;
    public googleTagManagerContainerId: string;
    public dobRequired: boolean;
    public addressRequired: boolean;
    public connectThemeSurface: string;
    public connectThemeSurfaceMuted: string;
    public connectThemeSurfaceSubtle: string;
    public connectThemeSurfaceElevated: string;
    public connectThemeTextDefault: string;
    public connectThemeTextMuted: string;
    public connectThemeTextSubtle: string;
    public connectThemeBorderDefault: string;
    public connectThemeBorderMuted: string;
    public connectThemeFocusRing: string;
    public connectThemeStatusSuccess: string;
    public connectThemeStatusSuccessSurface: string;
    public connectThemeStatusWarning: string;
    public connectThemeStatusWarningSurface: string;
    public connectThemeStatusCritical: string;
    public connectThemeStatusCriticalSurface: string;
    public connectFontBodyFamily: string;
    public connectFontHeadingFamily: string;
    public stripeEnabled: boolean;
    public squareEnabled: boolean;
    public stripeApiKey: string;
    public squareApplicationId: string;
    public isSquareSandboxMode: boolean;
    public showSiteTitle: boolean;
    public useExtraAddressLine: boolean;
    public labels: DynamicLabelResponse[];
    public videoIntegration: string;
    public hasZoomPro: boolean;
    public stripeAccount: string;
    public saveCardMessage: string;
    public clearAcceptEnabled: boolean;
    public recaptchaSiteKey: string;
    public recaptchaEnabled: boolean;
    public allowWaitingListPayments: boolean;
    public useAllDeliveryMethodsForAccessCode: boolean;
    public accessCodeDeliveryMethod: string;
    public unauthenticatedMessage: string;
    public applePayEnabled: boolean;
    public currencyCode: string;
    public location: string;
    public useSSO: boolean;
    public ssoDomain: string;
    public usingSimplifiedRegistration: boolean;
    public allowPatientEditDetails: boolean;
    public connectBookingFlowMode: string;
    public magicLinkSentMessage: string;
    public insuranceDetailsMessage: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<OnlineSettingsResponse>) { (Object as any).assign(this, init); }
}
(OnlineSettingsResponse as unknown)[immerable] = true;

export class AppointmentSearchResponse
{
    public locationIds: string[];
    public responseStatus: ResponseStatus;
    public appointments: AppointmentSearchResult[];
    public latestAppointmentDate?: string;
    public earliestAppointmentDate?: string;
    public practitionerIds: string[];
    public practitionerGenders: string[];

    public constructor(init?: Partial<AppointmentSearchResponse>) { (Object as any).assign(this, init); }
}
(AppointmentSearchResponse as unknown)[immerable] = true;

export class ReserveAppointmentResponse
{
    public appointment: AppointmentDto;
    public backgroundJobId: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ReserveAppointmentResponse>) { (Object as any).assign(this, init); }
}
(ReserveAppointmentResponse as unknown)[immerable] = true;

export class GetSsoSessionInfoResponse
{
    public email: string;
    public fullName: string;
    public customer: ConnectQuickRegistrationResponse;
    public details: Object;
    public customerId: number;
    public isAuthenticated: boolean;
    public registrationRequired: boolean;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetSsoSessionInfoResponse>) { (Object as any).assign(this, init); }
}
(GetSsoSessionInfoResponse as unknown)[immerable] = true;

export class OnlineAutoLoginVerifyCodeResponse
{
    public onlineAutoLoginAuthenticationResult: OnlineAutoLoginAuthenticationResult;
    public response: AuthenticateResponse;
    public verifiedEmail: string;
    public redirectPath: string;
    public verifiedRegistrationToken: string;
    public bookingDraft: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<OnlineAutoLoginVerifyCodeResponse>) { (Object as any).assign(this, init); }
}
(OnlineAutoLoginVerifyCodeResponse as unknown)[immerable] = true;

export class StripeOAuthResponse
{
    public accountId?: string;
    public redirectUrl: string;
    public error?: string;
    public errorMessage: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<StripeOAuthResponse>) { (Object as any).assign(this, init); }
}
(StripeOAuthResponse as unknown)[immerable] = true;

export class ZoomLinkToTM3Response
{
    public status: HttpStatusCode;
    public redirectUri: string;
    public message: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ZoomLinkToTM3Response>) { (Object as any).assign(this, init); }
}
(ZoomLinkToTM3Response as unknown)[immerable] = true;

export class ListingFolderTree
{
    public folders: Folder[];
    public files: DocumentListingFile[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ListingFolderTree>) { (Object as any).assign(this, init); }
}
(ListingFolderTree as unknown)[immerable] = true;

export class AuthCodeV1Dto
{
    public id: string;
    public code: string;
    public businessId: string;
    public businessName: string;
    public customerId: string;
    public customerName: string;
    public caseId?: string;
    public serviceTypeId?: string;
    public bodySite: string;
    public usedFor: string;
    public maxTreatments: number;
    public maxValue?: number;
    public usedTreatments: number;
    public usedValue: number;
    public remainingTreatments: number;
    public remainingValue?: number;
    public startDate?: string;
    public expiryDate?: string;
    public isExpired: boolean;
    public isExhausted: boolean;
    public createdAt: string;
    public updatedAt: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AuthCodeV1Dto>) { (Object as any).assign(this, init); }
}
(AuthCodeV1Dto as unknown)[immerable] = true;

export class GetAuthCodesV1Response extends PaginatedResponseV1<AuthCodeV1Dto>
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetAuthCodesV1Response>) { super(init); (Object as any).assign(this, init); }
}
(GetAuthCodesV1Response as unknown)[immerable] = true;

export class GetAvailabilitySlotsV1Response
{
    public slots: AvailabilitySlotV1Dto[];
    public earliestAvailable?: string;
    public latestAvailable?: string;
    public totalSlots: number;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetAvailabilitySlotsV1Response>) { (Object as any).assign(this, init); }
}
(GetAvailabilitySlotsV1Response as unknown)[immerable] = true;

export class GetAvailabilitySessionsV1Response
{
    public sessions: SessionV1Dto[];
    public totalSessions: number;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetAvailabilitySessionsV1Response>) { (Object as any).assign(this, init); }
}
(GetAvailabilitySessionsV1Response as unknown)[immerable] = true;

export class CreateBookingV1Response
{
    public bookingId: string;
    public reference: string;
    public status: string;
    public startDateTime: string;
    public endDateTime: string;
    public confirmationSent: boolean;
    public videoJoinUrl: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CreateBookingV1Response>) { (Object as any).assign(this, init); }
}
(CreateBookingV1Response as unknown)[immerable] = true;

export class BookingV1Dto
{
    public id: string;
    public startDateTime: string;
    public endDateTime: string;
    public durationMinutes: number;
    public name: string;
    public reference: string;
    public status: number;
    public statusName: string;
    public type: string;
    public bookingMethod: string;
    public bookingDateTime?: string;
    public customerId?: string;
    public customerName: string;
    public practitionerId: string;
    public practitionerName: string;
    public locationId: string;
    public locationName: string;
    public roomId?: number;
    public roomGuid?: string;
    public roomName: string;
    public stockId?: string;
    public stockDescription: string;
    public connectServiceId?: string;
    public prontoServiceId?: string;
    public serviceTypeId?: string;
    public serviceTypeName: string;
    public businessId?: string;
    public businessName: string;
    public authId?: string;
    public authCode: string;
    public caseId?: string;
    public workflowId?: string;
    public firstAppointment: boolean;
    public isVideo: boolean;
    public videoCode: string;
    public videoJoinUrl: string;
    public comment: string;
    public arrivalTime?: string;
    public completedTime?: string;
    public createdAt: string;
    public updatedAt: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<BookingV1Dto>) { (Object as any).assign(this, init); }
}
(BookingV1Dto as unknown)[immerable] = true;

export class ReserveAppointmentV1Response
{
    public appointmentId: string;
    public backgroundJobId: string;
    public startDateTime: string;
    public endDateTime: string;
    public status: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ReserveAppointmentV1Response>) { (Object as any).assign(this, init); }
}
(ReserveAppointmentV1Response as unknown)[immerable] = true;

export class DeletedV1Response
{
    public deleted: boolean;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeletedV1Response>) { (Object as any).assign(this, init); }
}
(DeletedV1Response as unknown)[immerable] = true;

export class SearchBookingsV1Response
{
    public data: BookingV1Dto[];
    public pagination: PaginationV1;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SearchBookingsV1Response>) { (Object as any).assign(this, init); }
}
(SearchBookingsV1Response as unknown)[immerable] = true;

export class BusinessV1Dto
{
    public id: string;
    public name: string;
    public contact: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public addressLine5: string;
    public postCode: string;
    public telephone: string;
    public email: string;
    public web: string;
    public classification: string;
    public contractNumber: string;
    public accountingCode: string;
    public invoicePeriod: string;
    public invoiceFrequencyDays?: number;
    public online: boolean;
    public showVat: boolean;
    public isVatExempt: boolean;
    public defaultMaxTreatments?: number;
    public cancellationHours?: number;
    public paysForDna: boolean;
    public paysForCancel: boolean;
    public authorisationExpiryDays?: number;
    public createdAt: string;
    public updatedAt: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<BusinessV1Dto>) { (Object as any).assign(this, init); }
}
(BusinessV1Dto as unknown)[immerable] = true;

export class GetBusinessesV1Response extends PaginatedResponseV1<BusinessV1Dto>
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetBusinessesV1Response>) { super(init); (Object as any).assign(this, init); }
}
(GetBusinessesV1Response as unknown)[immerable] = true;

export class CaseV1Dto
{
    public id: string;
    public customerId: string;
    public customerName: string;
    public status: string;
    public serviceTypeId?: string;
    public serviceTypeName: string;
    public practitionerId?: string;
    public practitionerName: string;
    public locationId?: string;
    public diagnosis: string;
    public notes: string;
    public isClosed: boolean;
    public closedDate?: string;
    public dischargeDate?: string;
    public admissionDate?: string;
    public treatmentCount: number;
    public createdAt: string;
    public updatedAt: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CaseV1Dto>) { (Object as any).assign(this, init); }
}
(CaseV1Dto as unknown)[immerable] = true;

export class SendCustomerContactV1Response
{
    public sent: boolean;
    public type: string;
    public templatePath: string;
    public message: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SendCustomerContactV1Response>) { (Object as any).assign(this, init); }
}
(SendCustomerContactV1Response as unknown)[immerable] = true;

export class CreateCustomerV1Response
{
    public id: string;
    public reference: string;
    public externalReference: string;
    public medicalContactIds: string[];
    public createdAt: string;
    public provisional: boolean;
    public status: number;
    public registeredOnConnect: boolean;
    public connectRegistrationWarning: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CreateCustomerV1Response>) { (Object as any).assign(this, init); }
}
(CreateCustomerV1Response as unknown)[immerable] = true;

export class MedicalContactV1Dto
{
    public id: string;
    public current?: boolean;
    public defaultContact?: boolean;
    public contactable?: boolean;
    public category: string;
    public title: string;
    public foreName: string;
    public surname: string;
    public businessName: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public addressLine5: string;
    public mobile: string;
    public postCode: string;
    public telephone: string;
    public altTelephone1: string;
    public altTelephone2: string;
    public fax: string;
    public email: string;
    public web: string;
    public locationId?: string;
    public providerNumber: string;
    public nhsGncCode: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<MedicalContactV1Dto>) { (Object as any).assign(this, init); }
}
(MedicalContactV1Dto as unknown)[immerable] = true;

export class CustomerV1Dto
{
    public id: string;
    public reference: string;
    public accountingCode: string;
    public title: string;
    public foreName: string;
    public surname: string;
    public displayName: string;
    public dateOfBirth?: string;
    public gender: string;
    public email: string;
    public homeTelephone: string;
    public workTelephone: string;
    public mobileTelephone: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public postCode: string;
    public status: number;
    public online: boolean;
    public defaultPractitionerId?: string;
    public defaultLocationId?: string;
    public businessId?: string;
    public registrationDate?: string;
    public lastAppointmentDate?: string;
    public smsConsent: boolean;
    public emailConsent: boolean;
    public phoneConsent: boolean;
    public givenConsent: boolean;
    public billTo: string;
    public invoicePeriod: string;
    public employer: string;
    public businessReference: string;
    public niNumber: string;
    public hospitalNumber: string;
    public customerHospitalNumber: string;
    public insuranceNumber: string;
    public medicalContacts: MedicalContactV1Dto[];
    public createdAt: string;
    public updatedAt: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CustomerV1Dto>) { (Object as any).assign(this, init); }
}
(CustomerV1Dto as unknown)[immerable] = true;

export class SearchCustomersV1Response
{
    public data: CustomerV1Dto[];
    public pagination: PaginationV1;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SearchCustomersV1Response>) { (Object as any).assign(this, init); }
}
(SearchCustomersV1Response as unknown)[immerable] = true;

export class DocumentV1Dto
{
    public id: string;
    public customerId: string;
    public fileName: string;
    public description: string;
    public fileSizeBytes?: number;
    public uploadedByUserId: string;
    public uploadedAt?: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DocumentV1Dto>) { (Object as any).assign(this, init); }
}
(DocumentV1Dto as unknown)[immerable] = true;

export class LocationV1Dto
{
    public id: string;
    public name: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public postCode: string;
    public telephone: string;
    public email: string;
    public fax: string;
    public web: string;
    public status: number;
    public isNetworkLocation: boolean;
    public dnaStockId?: string;
    public cancelStockId?: string;
    public directions: string;
    public facilities: string;
    public latitude?: number;
    public longitude?: number;
    public createdAt: string;
    public updatedAt: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<LocationV1Dto>) { (Object as any).assign(this, init); }
}
(LocationV1Dto as unknown)[immerable] = true;

export class GetLocationsV1Response extends PaginatedResponseV1<LocationV1Dto>
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetLocationsV1Response>) { super(init); (Object as any).assign(this, init); }
}
(GetLocationsV1Response as unknown)[immerable] = true;

export class NoteV1Dto
{
    public id: string;
    public customerId: string;
    public content: string;
    public type: string;
    public title: string;
    public createdBy: string;
    public createdByUserId: string;
    public createdAt: string;
    public updatedAt: string;
    public isAlert: boolean;
    public isDeleted: boolean;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<NoteV1Dto>) { (Object as any).assign(this, init); }
}
(NoteV1Dto as unknown)[immerable] = true;

export class PractitionerV1Dto
{
    public id: string;
    public title: string;
    public forename: string;
    public surname: string;
    public displayName: string;
    public gender: string;
    public code: string;
    public type: string;
    public status: number;
    public online: boolean;
    public isNetworkPractitioner: boolean;
    public defaultLocationId?: string;
    public defaultRoomId?: string;
    public serviceTypeId?: string;
    public appointmentSlotMinutes?: number;
    public regNumber: string;
    public createdAt: string;
    public updatedAt: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<PractitionerV1Dto>) { (Object as any).assign(this, init); }
}
(PractitionerV1Dto as unknown)[immerable] = true;

export class RoomV1Dto
{
    public id: string;
    public name: string;
    public locationId: string;
    public locationName: string;
    public status: boolean;
    public type: string;
    public colour?: number;
    public createdAt: string;
    public updatedAt: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<RoomV1Dto>) { (Object as any).assign(this, init); }
}
(RoomV1Dto as unknown)[immerable] = true;

export class GetServiceTypesV1Response
{
    public data: ServiceTypeV1Dto[];
    public pagination: PaginationV1;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetServiceTypesV1Response>) { (Object as any).assign(this, init); }
}
(GetServiceTypesV1Response as unknown)[immerable] = true;

export class StockV1Dto
{
    public id: string;
    public reference: string;
    public description: string;
    public longDescription: string;
    public category: string;
    public priceIncVat?: number;
    public priceExVat?: number;
    public vatRate?: number;
    public appointmentLengthMinutes?: number;
    public inUse: boolean;
    public online: boolean;
    public isVideo: boolean;
    public isClass: boolean;
    public serviceTypeId?: string;
    public cancellationStockId?: string;
    public dnaStockId?: string;
    public credits?: number;
    public ledgerCode: string;
    public tags: string[];
    public createdAt: string;
    public updatedAt: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<StockV1Dto>) { (Object as any).assign(this, init); }
}
(StockV1Dto as unknown)[immerable] = true;

export class GetStocksV1Response extends PaginatedResponseV1<StockV1Dto>
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetStocksV1Response>) { super(init); (Object as any).assign(this, init); }
}
(GetStocksV1Response as unknown)[immerable] = true;

export class TaskV1Dto
{
    public id: string;
    public customerId: string;
    public description: string;
    public longDescription: string;
    public status: string;
    public dueDate: string;
    public priority: boolean;
    public reminder: boolean;
    public assignedUserId?: string;
    public createdByUserId: string;
    public createdAt?: string;
    public completedAt?: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<TaskV1Dto>) { (Object as any).assign(this, init); }
}
(TaskV1Dto as unknown)[immerable] = true;

export class TemplateV1Dto
{
    public templatePath: string;
    public name: string;
    public type: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<TemplateV1Dto>) { (Object as any).assign(this, init); }
}
(TemplateV1Dto as unknown)[immerable] = true;

export class SearchTemplatesV1Response extends PaginatedResponseV1<TemplateV1Dto>
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SearchTemplatesV1Response>) { super(init); (Object as any).assign(this, init); }
}
(SearchTemplatesV1Response as unknown)[immerable] = true;

// @DataContract
export class AssignRolesResponse
{
    // @DataMember(Order=1)
    public allRoles: string[];

    // @DataMember(Order=2)
    public allPermissions: string[];

    // @DataMember(Order=3)
    public meta: { [index:string]: string; };

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AssignRolesResponse>) { (Object as any).assign(this, init); }
}
(AssignRolesResponse as unknown)[immerable] = true;

// @DataContract
export class UnAssignRolesResponse
{
    // @DataMember(Order=1)
    public allRoles: string[];

    // @DataMember(Order=2)
    public allPermissions: string[];

    // @DataMember(Order=3)
    public meta: { [index:string]: string; };

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UnAssignRolesResponse>) { (Object as any).assign(this, init); }
}
(UnAssignRolesResponse as unknown)[immerable] = true;

// @DataContract
export class GetAccessTokenResponse
{
    // @DataMember(Order=1)
    public accessToken: string;

    // @DataMember(Order=2)
    public meta: { [index:string]: string; };

    // @DataMember(Order=3)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetAccessTokenResponse>) { (Object as any).assign(this, init); }
}
(GetAccessTokenResponse as unknown)[immerable] = true;

export class GetCompanyInfo implements IReturn<ResponseBase<GetCompanyInfoResponse>>
{

    public constructor(init?: Partial<GetCompanyInfo>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCompanyInfo'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GetCompanyInfoResponse>(); }
}
(GetCompanyInfo as unknown)[immerable] = true;

// @Route("/apideck/connector/deactivate", "POST")
export class ApiDeckDeactivateConnectorRequest implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<ApiDeckDeactivateConnectorRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ApiDeckDeactivateConnectorRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}

// @Route("/apideck/connector", "GET")
export class ApiDeckGetConnectorRequest implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<ApiDeckGetConnectorRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ApiDeckGetConnectorRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}

// @Route("/apideck/connectors", "GET")
export class ApiDeckListConnectorsRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<ApiDeckListConnectorsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ApiDeckListConnectorsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}

// @Route("/apideck/session", "POST")
export class ApiDeckCreateSessionRequest implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<ApiDeckCreateSessionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ApiDeckCreateSessionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}

export class DigitalPrescriptionDMDRequest implements IReturn<ResponseBase<DigitalPrescriptionDMDResponse>>
{
    public term: string;

    public constructor(init?: Partial<DigitalPrescriptionDMDRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DigitalPrescriptionDMDRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<DigitalPrescriptionDMDResponse>(); }
}
(DigitalPrescriptionDMDRequest as unknown)[immerable] = true;

// @Route("/gps", "GET")
export class SearchGPsRequest implements IReturn<ResponseBase<GPResult>>
{
    public query: string;
    public includeInactive: boolean;

    public constructor(init?: Partial<SearchGPsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SearchGPsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GPResult>(); }
}
(SearchGPsRequest as unknown)[immerable] = true;

// @Route("/gps/{GncCode}", "GET")
export class GetGPRequest implements IReturn<ResponseBase<GPResult>>
{
    public gncCode: string;

    public constructor(init?: Partial<GetGPRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetGPRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GPResult>(); }
}
(GetGPRequest as unknown)[immerable] = true;

// @Route("/validation")
export class GetZodSchemasRequest implements IReturn<ZodSchemasResponse>
{

    public constructor(init?: Partial<GetZodSchemasRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetZodSchemasRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ZodSchemasResponse(); }
}

export class GetTwilioRoom implements IReturn<ResponseBase<TwilioRoomResponse>>
{
    public appointmentId: number;

    public constructor(init?: Partial<GetTwilioRoom>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTwilioRoom'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<TwilioRoomResponse>(); }
}
(GetTwilioRoom as unknown)[immerable] = true;

export class TwilioReminderRequest implements IReturn<ResponseBase<boolean>>
{
    public videoCode: string;

    public constructor(init?: Partial<TwilioReminderRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TwilioReminderRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(TwilioReminderRequest as unknown)[immerable] = true;

export class GetTwilioOnlineRoom implements IReturn<ResponseBase<TwilioRoomResponse>>
{
    public videoCode: string;

    public constructor(init?: Partial<GetTwilioOnlineRoom>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTwilioOnlineRoom'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<TwilioRoomResponse>(); }
}
(GetTwilioOnlineRoom as unknown)[immerable] = true;

// @Route("/square/webhook")
export class SquareWebhookRequest implements IReturn<HttpResult>
{
    public merchant_id: string;
    public type: string;
    public event_id: string;
    public created_at: string;
    public data: SquareWebhookData;

    public constructor(init?: Partial<SquareWebhookRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SquareWebhookRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new HttpResult(); }
}
(SquareWebhookRequest as unknown)[immerable] = true;

// @Route("/worldpay/notification")
export class WorldPayNotificationRequest
{
    public requestStream: string;

    public constructor(init?: Partial<WorldPayNotificationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WorldPayNotificationRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(WorldPayNotificationRequest as unknown)[immerable] = true;

// @Route("/worldpay/dns/flush")
export class WorldPayFlushDnsCacheRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<WorldPayFlushDnsCacheRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WorldPayFlushDnsCacheRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(WorldPayFlushDnsCacheRequest as unknown)[immerable] = true;

export class WorldPayChargeTokenRequest implements IReturn<ResponseBase<WorldPayResponse>>
{
    public reference: string;
    public amount: number;
    public customerId: number;

    public constructor(init?: Partial<WorldPayChargeTokenRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WorldPayChargeTokenRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<WorldPayResponse>(); }
}
(WorldPayChargeTokenRequest as unknown)[immerable] = true;

export class WorldPayRefundRequest implements IReturn<ResponseBase<WorldPayResponse>>
{
    public incomeId: number;
    public reference: string;
    public amount: number;

    public constructor(init?: Partial<WorldPayRefundRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WorldPayRefundRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<WorldPayResponse>(); }
}
(WorldPayRefundRequest as unknown)[immerable] = true;

export class WorldPayHostedPaymentPageRequest implements IReturn<ResponseBase<WorldPayResponse>>
{
    public customerId: number;
    public amount: number;
    public reference: string;

    public constructor(init?: Partial<WorldPayHostedPaymentPageRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WorldPayHostedPaymentPageRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<WorldPayResponse>(); }
}
(WorldPayHostedPaymentPageRequest as unknown)[immerable] = true;

export class WorldPayWaitingTokenRequest implements IReturn<ResponseBase<T>>
{
    public orderCode: string;
    public customerId: number;

    public constructor(init?: Partial<WorldPayWaitingTokenRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WorldPayWaitingTokenRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(WorldPayWaitingTokenRequest as unknown)[immerable] = true;

export class StripeOnboardRequest
{
    public code: string;

    public constructor(init?: Partial<StripeOnboardRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StripeOnboardRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(StripeOnboardRequest as unknown)[immerable] = true;

export class StripeTerminalLocationsRequest implements IReturn<ResponseBase<StripeTerminalLocationsResponse>>
{
    public terminalLocationId?: string;

    public constructor(init?: Partial<StripeTerminalLocationsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StripeTerminalLocationsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<StripeTerminalLocationsResponse>(); }
}
(StripeTerminalLocationsRequest as unknown)[immerable] = true;

// @Route("/autopay/charge-date", "GET")
export class AutopayChargeDateRequest implements IReturn<ResponseBase<AutopayChargeDateResponse>>
{

    public constructor(init?: Partial<AutopayChargeDateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AutopayChargeDateRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<AutopayChargeDateResponse>(); }
}
(AutopayChargeDateRequest as unknown)[immerable] = true;

// @Route("/autopay")
export class AutoPayRequest implements IReturn<ResponseBase<T>>
{
    public invoiceIds: number[];
    public appointmentId: number;
    public chaseOnly?: boolean;
    public immediateCharge?: boolean;

    public constructor(init?: Partial<AutoPayRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AutoPayRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(AutoPayRequest as unknown)[immerable] = true;

// @Route("/autopay/cancel")
export class CancelChaseRequest
{
    public invoiceId: number;
    public appointmentId: number;

    public constructor(init?: Partial<CancelChaseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CancelChaseRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(CancelChaseRequest as unknown)[immerable] = true;

// @Route("/autopay/resend")
export class ResendChaseEmailRequest
{
    public invoiceId: number;
    public appointmentId: number;

    public constructor(init?: Partial<ResendChaseEmailRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ResendChaseEmailRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(ResendChaseEmailRequest as unknown)[immerable] = true;

// @Route("/autopay/reschedule", "POST")
export class RescheduleChaseRequest implements IReturn<ResponseBase<boolean>>
{
    public invoiceId: number;
    public newChargeDate: string;

    public constructor(init?: Partial<RescheduleChaseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RescheduleChaseRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(RescheduleChaseRequest as unknown)[immerable] = true;

export class GetDiscountCodesRequest implements IReturn<ResponseBase<DiscountCodeDto>>
{
    public appointmentDate?: string;
    public getInUseFlag: boolean;
    public discountCodeId?: string;

    public constructor(init?: Partial<GetDiscountCodesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDiscountCodesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<DiscountCodeDto>(); }
}
(GetDiscountCodesRequest as unknown)[immerable] = true;

export class DiscountCodeAdvancedSearchRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<DiscountCodeDto>>
{
    public code: string;
    public status: DiscountStatus;
    public description: string;
    public validFrom: string;
    public validTo: string;

    public constructor(init?: Partial<DiscountCodeAdvancedSearchRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'DiscountCodeAdvancedSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<DiscountCodeDto>(); }
}
(DiscountCodeAdvancedSearchRequest as unknown)[immerable] = true;

export class ValidateDiscountCodeAndCreateItems implements IReturn<ResponseBase<boolean>>
{
    public id?: string;
    public code: string;
    public charges: BillingItem[];
    public invoiceId: number;
    public ledgerCode: string;

    public constructor(init?: Partial<ValidateDiscountCodeAndCreateItems>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateDiscountCodeAndCreateItems'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ValidateDiscountCodeAndCreateItems as unknown)[immerable] = true;

export class ValidateDiscountCode implements IReturn<ResponseBase<ValidateDiscountCodeResponse>>
{
    public id?: string;
    public code: string;
    public charges: BillingItem[];

    public constructor(init?: Partial<ValidateDiscountCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateDiscountCode'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ValidateDiscountCodeResponse>(); }
}
(ValidateDiscountCode as unknown)[immerable] = true;

// @Route("/applicablediscountcodes/{InvoiceId}", "GET")
export class GetApplicableDiscountCodes implements IReturn<ResponseBase<DiscountCodeDto>>
{
    public invoiceId: number;

    public constructor(init?: Partial<GetApplicableDiscountCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetApplicableDiscountCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<DiscountCodeDto>(); }
}
(GetApplicableDiscountCodes as unknown)[immerable] = true;

// @Route("/getDiscountCodesBillingItem", "POST")
export class GetDiscountCodeBillingItem implements IReturn<ResponseBase<BillingItem>>
{
    public billingItem: BillingItem;
    public discountCodeId: string;

    public constructor(init?: Partial<GetDiscountCodeBillingItem>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDiscountCodeBillingItem'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<BillingItem>(); }
}
(GetDiscountCodeBillingItem as unknown)[immerable] = true;

// @Route("/diary/eventtypes", "GET, POST, DELETE")
export class DiaryEventTypesDto implements IReturn<ResponseBase<DiaryEventTypesDto>>
{
    public id: number;
    public name: string;
    public colour: string;

    public constructor(init?: Partial<DiaryEventTypesDto>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiaryEventTypesDto'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<DiaryEventTypesDto>(); }
}
(DiaryEventTypesDto as unknown)[immerable] = true;

// @Route("/files/referrer-logo/{Path*}")
export class ClickReferrerLogoRequest implements IReturn<HttpResult>
{
    public path: string;

    public constructor(init?: Partial<ClickReferrerLogoRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickReferrerLogoRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new HttpResult(); }
}
(ClickReferrerLogoRequest as unknown)[immerable] = true;

export class AddressSearchRequest implements IReturn<ResponseBase<AddressFindResponse>>
{
    public term: string;
    public container: string;

    public constructor(init?: Partial<AddressSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddressSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AddressFindResponse>(); }
}
(AddressSearchRequest as unknown)[immerable] = true;

export class AddressRetrieveRequest implements IReturn<ResponseBase<AddressRetrieveResponse>>
{
    public id: string;

    public constructor(init?: Partial<AddressRetrieveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddressRetrieveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AddressRetrieveResponse>(); }
}
(AddressRetrieveRequest as unknown)[immerable] = true;

// @Route("/reminder/data")
export class ReminderDataRequest implements IReturn<ResponseBase<ReminderDataResponse>>, ILocationId
{
    public isEmail: boolean;
    public practitionerIds: number[];
    public locationId: number;
    public appointmentId: number;
    public day: string;

    public constructor(init?: Partial<ReminderDataRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReminderDataRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ReminderDataResponse>(); }
}
(ReminderDataRequest as unknown)[immerable] = true;

// @Route("/reminder/last")
export class LastReminderRequest implements IReturn<ResponseBase<string>>
{

    public constructor(init?: Partial<LastReminderRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LastReminderRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<string>(); }
}
(LastReminderRequest as unknown)[immerable] = true;

// @Route("/reminder/send")
export class ReminderSendRequest implements ILocationId
{
    public sendSms: boolean;
    public sendEmail: boolean;
    public appointmentIds: number[];
    public locationId: number;
    public forceSend: boolean;

    public constructor(init?: Partial<ReminderSendRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReminderSendRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(ReminderSendRequest as unknown)[immerable] = true;

// @Route("/user/first/verify")
export class FirstUserVerifyRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<FirstUserVerifyRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FirstUserVerifyRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(FirstUserVerifyRequest as unknown)[immerable] = true;

// @Route("/user/email/verify")
export class EmailVerificationRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<EmailVerificationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EmailVerificationRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(EmailVerificationRequest as unknown)[immerable] = true;

// @Route("/user/auto/login")
export class AutoLoginRequest implements IReturn<CurrentUser>
{
    public token: string;

    public constructor(init?: Partial<AutoLoginRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AutoLoginRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CurrentUser(); }
}
(AutoLoginRequest as unknown)[immerable] = true;

// @Route("/user/auto/redirect")
export class AutoRedirectRequest implements IReturn<string>
{
    public password: string;
    public verificationCode: string;

    public constructor(init?: Partial<AutoRedirectRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AutoRedirectRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return ''; }
}
(AutoRedirectRequest as unknown)[immerable] = true;

// @Route("/permissions/rules", "GET")
export class JsonPermissionRuleRequest implements IReturn<ResponseBase<string>>
{

    public constructor(init?: Partial<JsonPermissionRuleRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'JsonPermissionRuleRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<string>(); }
}
(JsonPermissionRuleRequest as unknown)[immerable] = true;

// @Route("/permissions/all", "GET")
export class JsonPermissionRequest implements IReturn<ResponseBase<JsonPermissionResponse>>
{

    public constructor(init?: Partial<JsonPermissionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'JsonPermissionRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<JsonPermissionResponse>(); }
}
(JsonPermissionRequest as unknown)[immerable] = true;

// @Route("/permissions/roles", "GET")
export class JsonPermissionGetRequest implements IReturn<ResponseBase<JsonPermissionGetResponse>>
{

    public constructor(init?: Partial<JsonPermissionGetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'JsonPermissionGetRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<JsonPermissionGetResponse>(); }
}
(JsonPermissionGetRequest as unknown)[immerable] = true;

// @Route("/permissions/roles/rename", "POST")
export class JsonPermissionRenameRequest implements IReturn<ResponseBase<T>>
{
    public id: number;
    public shortDescription: string;
    public descriptor: string;

    public constructor(init?: Partial<JsonPermissionRenameRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'JsonPermissionRenameRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(JsonPermissionRenameRequest as unknown)[immerable] = true;

// @Route("/permissions/roles/update", "POST")
export class JsonPermissionUpdateRequest implements IReturn<ResponseBase<T>>
{
    public id: number;
    public shortDescription: string;
    public jsonPermissions: string;

    public constructor(init?: Partial<JsonPermissionUpdateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'JsonPermissionUpdateRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(JsonPermissionUpdateRequest as unknown)[immerable] = true;

// @Route("/permissions/roles/clone", "POST")
export class JsonPermissionCloneRequest implements IReturn<ResponseBase<T>>
{
    public id: number;

    public constructor(init?: Partial<JsonPermissionCloneRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'JsonPermissionCloneRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(JsonPermissionCloneRequest as unknown)[immerable] = true;

// @Route("/permissions/roles/add", "POST")
export class JsonPermissionAddRequest implements IReturn<ResponseBase<T>>
{
    public shortDescription: string;
    public descriptor: string;

    public constructor(init?: Partial<JsonPermissionAddRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'JsonPermissionAddRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(JsonPermissionAddRequest as unknown)[immerable] = true;

// @Route("/permissions/roles/delete", "POST")
export class JsonPermissionDeleteRequest implements IReturn<ResponseBase<T>>
{
    public id: number;
    public shortDescription: string;

    public constructor(init?: Partial<JsonPermissionDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'JsonPermissionDeleteRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(JsonPermissionDeleteRequest as unknown)[immerable] = true;

// @Route("/users/all")
export class AllUsersLocationRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<UsersSearchResponse>>
{
    public username: string;
    public status?: boolean;
    public fullname: string;
    public practitioner?: number;

    public constructor(init?: Partial<AllUsersLocationRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'AllUsersLocationRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<UsersSearchResponse>(); }
}
(AllUsersLocationRequest as unknown)[immerable] = true;

// @Route("/users/allWorkflowUsers")
export class AllWorkflowUsersLocationRequest implements IReturn<ResponseBase<UsersSearchResponse>>, ILocationIds
{
    public locationIds: number[];
    public requestLocationIds: number[];
    public username: string;
    public status?: boolean;
    public fullname: string;
    public practitioner?: number;
    public term: string;
    public sort: QueryField[];
    public skip: number;
    public take: number;

    public constructor(init?: Partial<AllWorkflowUsersLocationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AllWorkflowUsersLocationRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<UsersSearchResponse>(); }
}
(AllWorkflowUsersLocationRequest as unknown)[immerable] = true;

// @Route("/user/email/{Id}", "GET")
export class UserEmailRequest implements ISecurityId
{
    public id: number;
    public securityId: number;

    public constructor(init?: Partial<UserEmailRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UserEmailRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(UserEmailRequest as unknown)[immerable] = true;

// @Route("/user/email/reset")
export class UserEmailReset implements IReturn<ResponseBase<boolean>>
{
    public id: number;
    public email: string;
    public saveEmail: boolean;

    public constructor(init?: Partial<UserEmailReset>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UserEmailReset'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(UserEmailReset as unknown)[immerable] = true;

export class UserResetRequest implements IReturn<ResponseBase<boolean>>, ILocationId
{
    public mode: ResetMode;
    public id?: number;
    public customerId?: number;
    public locationId: number;
    public codeForExistingSecret: string;

    public constructor(init?: Partial<UserResetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UserResetRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(UserResetRequest as unknown)[immerable] = true;

// @Route("/users/allUsersWithRoles")
export class UsersWithRolesRequest implements IReturn<UserRoleLocationWithDetails[]>, ILocationIds
{
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<UsersWithRolesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UsersWithRolesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Array<UserRoleLocationWithDetails>(); }
}
(UsersWithRolesRequest as unknown)[immerable] = true;

export class UsersExportRequest implements IReturn<ResponseBase<string>>, ILocationIds
{
    public query: AllUsersLocationRequest;
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<UsersExportRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UsersExportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<string>(); }
}
(UsersExportRequest as unknown)[immerable] = true;

// @Route("/users/{Id}", "GET")
export class UserRequest implements IReturn<ResponseBase<UsersSearchResponse>>, ISecurityId
{
    public id: number;
    public securityId: number;

    public constructor(init?: Partial<UserRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UserRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<UsersSearchResponse>(); }
}
(UserRequest as unknown)[immerable] = true;

// @Route("/users/{UserId}/locations", "GET")
export class UserLocationsRequest implements IReturn<ResponseBase<UserLocationsResponse>>, ISecurityId
{
    public userId: number;
    public securityId: number;

    public constructor(init?: Partial<UserLocationsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UserLocationsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<UserLocationsResponse>(); }
}
(UserLocationsRequest as unknown)[immerable] = true;

// @Route("/users/{Id}/permissions", "GET")
export class UserPermissionRequest implements IReturn<ResponseBase<JsonPermission>>, ISecurityId
{
    public id: number;
    public securityId: number;

    public constructor(init?: Partial<UserPermissionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UserPermissionRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<JsonPermission>(); }
}
(UserPermissionRequest as unknown)[immerable] = true;

// @Route("/users")
export class UserSaveRequest implements IReturn<ResponseBase<number>>, ILocationId
{
    public id: number;
    public name: string;
    public fullName: string;
    public firstName: string;
    public lastName: string;
    public current: boolean;
    public email: string;
    public mobileNumber: string;
    public position: string;
    public pword: string;
    public locationId: number;
    public practitionerId?: number;
    public migrated?: boolean;
    public practitionerTitle: string;
    public practitionerForename: string;
    public practitionerSurname: string;
    public avatar: string;
    public locations: UserRoleLocationDto[];
    public accessiblePractitioners: number[];
    public departments: number[];
    public globalGuid: string;
    public cloudRxUserCode: string;
    public cloudRxClinicCode: string;

    public constructor(init?: Partial<UserSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UserSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<number>(); }
}
(UserSaveRequest as unknown)[immerable] = true;

// @Route("/users/deallocate-licence", "POST")
export class DeallocateUserLicencesRequest implements IReturn<ResponseBase<boolean>>
{
    public userIds: number[];

    public constructor(init?: Partial<DeallocateUserLicencesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeallocateUserLicencesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(DeallocateUserLicencesRequest as unknown)[immerable] = true;

// @Route("/businessprofile/{Id}", "GET")
export class BusinessProfileRequest implements IReturn<ResponseBase<BusinessProfileResponse>>
{
    public id: number;
    public businessName: string;
    public tradingName: string;
    public description: string;
    public termsAndConditions: string;
    public privacyPolicy: string;
    public cancellationPolicy: string;

    public constructor(init?: Partial<BusinessProfileRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BusinessProfileRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<BusinessProfileResponse>(); }
}
(BusinessProfileRequest as unknown)[immerable] = true;

// @Route("/businessprofile", "POST")
// @Route("/businessprofile/{Id}", "GET")
export class BusinessProfilePostRequest extends BusinessProfileRequest implements IReturn<ResponseBase<BusinessProfileResponse>>
{

    public constructor(init?: Partial<BusinessProfilePostRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BusinessProfilePostRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<BusinessProfileResponse>(); }
}
(BusinessProfilePostRequest as unknown)[immerable] = true;

// @Route("/businessprofile/{Id}", "PUT")
// @Route("/businessprofile/{Id}", "GET")
export class BusinessProfilePutRequest extends BusinessProfileRequest implements IReturn<ResponseBase<BusinessProfileResponse>>
{

    public constructor(init?: Partial<BusinessProfilePutRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BusinessProfilePutRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<BusinessProfileResponse>(); }
}
(BusinessProfilePutRequest as unknown)[immerable] = true;

// @Route("/businessprofile", "GET")
export class BusinessProfileGetRequest implements IReturn<ResponseBase<BusinessProfileResponse>>
{

    public constructor(init?: Partial<BusinessProfileGetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BusinessProfileGetRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<BusinessProfileResponse>(); }
}
(BusinessProfileGetRequest as unknown)[immerable] = true;

// @Route("/extraction/status", "GET")
export class ExtractionStatusRequest implements IReturn<ResponseBase<ExtractionResponse>>
{

    public constructor(init?: Partial<ExtractionStatusRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExtractionStatusRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ExtractionResponse>(); }
}
(ExtractionStatusRequest as unknown)[immerable] = true;

// @Route("/extraction/begin", "POST")
export class ExtractionRequest implements IReturn<ResponseBase<ExtractionResponse>>
{
    public outOfHours: boolean;

    public constructor(init?: Partial<ExtractionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExtractionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ExtractionResponse>(); }
}
(ExtractionRequest as unknown)[immerable] = true;

// @Route("/download/util", "GET")
export class DownloadUtilRequest
{
    public os: string;

    public constructor(init?: Partial<DownloadUtilRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadUtilRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(DownloadUtilRequest as unknown)[immerable] = true;

// @Route("/cxx/files")
export class CancellationFileExtract implements IReturn<FilesListingResponse>, IHasPath
{
    public safeRoot: string;
    // @DataMember(Order=1)
    public path: string;

    // @DataMember(Order=2)
    public recursive: boolean;

    // @DataMember(Order=3)
    public createDirectoryIfNotExists: boolean;

    public constructor(init?: Partial<CancellationFileExtract>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CancellationFileExtract'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FilesListingResponse(); }
}
(CancellationFileExtract as unknown)[immerable] = true;

// @Route("/cases/{id}/imaging")
export class CaseImagingRequest implements IReturn<CaseImagingResponse>, ISecurityId
{
    public id: number;
    public securityId: number;

    public constructor(init?: Partial<CaseImagingRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseImagingRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CaseImagingResponse(); }
}
(CaseImagingRequest as unknown)[immerable] = true;

export class CommandBarPatientRequest extends CommandBarRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<CommandBarPatientRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CommandBarPatientRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(CommandBarPatientRequest as unknown)[immerable] = true;

export class CommandBarGroupRequest extends CommandBarRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<CommandBarGroupRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CommandBarGroupRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(CommandBarGroupRequest as unknown)[immerable] = true;

export class CommandBarContactRequest extends CommandBarRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<CommandBarContactRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CommandBarContactRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(CommandBarContactRequest as unknown)[immerable] = true;

export class CommandBarInvoiceRequest extends CommandBarRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<CommandBarInvoiceRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CommandBarInvoiceRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(CommandBarInvoiceRequest as unknown)[immerable] = true;

export class CommandBarPaymentRequest extends CommandBarRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<CommandBarPaymentRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CommandBarPaymentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(CommandBarPaymentRequest as unknown)[immerable] = true;

// @Route("/mergefields")
export class MergeFieldsRequest implements IReturn<MergeFieldResponse[]>
{
    public type: string;
    public webSafe: boolean;

    public constructor(init?: Partial<MergeFieldsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MergeFieldsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Array<MergeFieldResponse>(); }
}
(MergeFieldsRequest as unknown)[immerable] = true;

export class GetCustomMergeFields implements IReturn<ResponseBase<MergeFieldMappingDto>>
{
    public mergeFieldTypes: MergeFieldType[];

    public constructor(init?: Partial<GetCustomMergeFields>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCustomMergeFields'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<MergeFieldMappingDto>(); }
}
(GetCustomMergeFields as unknown)[immerable] = true;

export class GetCustomMergeField implements IReturn<ResponseBase<MergeFieldMappingDto>>
{
    public id: string;

    public constructor(init?: Partial<GetCustomMergeField>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCustomMergeField'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<MergeFieldMappingDto>(); }
}
(GetCustomMergeField as unknown)[immerable] = true;

export class SaveCustomMergeField implements IReturn<ResponseBase<MergeFieldMappingDto>>
{
    public mergeFieldMapping: MergeFieldMappingDto;

    public constructor(init?: Partial<SaveCustomMergeField>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveCustomMergeField'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<MergeFieldMappingDto>(); }
}
(SaveCustomMergeField as unknown)[immerable] = true;

export class GetCustomFieldMappings implements IReturn<ResponseBase<{ [index:string]: string[]; }>>
{

    public constructor(init?: Partial<GetCustomFieldMappings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCustomFieldMappings'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<{ [index:string]: string[]; }>(); }
}
(GetCustomFieldMappings as unknown)[immerable] = true;

// @Route("/batchInvoiceMergeData")
export class BatchInvoiceMergeDataRequest implements IReturn<BatchMergeDataResponse[]>, ISecurityIds
{
    public ids: BatchInvoiceMergeDataRequestObject[];
    public securityIds: number[];

    public constructor(init?: Partial<BatchInvoiceMergeDataRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BatchInvoiceMergeDataRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Array<BatchMergeDataResponse>(); }
}
(BatchInvoiceMergeDataRequest as unknown)[immerable] = true;

// @Route("/batchMergeData")
export class BatchMergeDataRequest implements IReturn<BatchMergeDataResponse[]>, ISecurityIds, ISecurityType
{
    public ids: BatchMergeDataRequestObject[];
    public securityIds: number[];
    public securityType: string;

    public constructor(init?: Partial<BatchMergeDataRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BatchMergeDataRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Array<BatchMergeDataResponse>(); }
}
(BatchMergeDataRequest as unknown)[immerable] = true;

// @Route("/mergedatawithcontact/{Type}/{Id}/{ContactId}/{Path*}")
// @Route("/mergedata/{Type}/{Id}/{Path*}")
export class MergeDataRequest implements IHasPath, ISecurityId, ISecurityType, IFilterServiceTypeManually, IDepartmentIds, IAllowedDepartmentIds
{
    public id: number;
    public type: string;
    public path: string;
    public safeRoot: string;
    public contactId?: number;
    public appointmentId?: number;
    public securityId: number;
    public securityType: string;
    public onlineUrl: string;
    public validFor: number;
    public departmentIds: number[];
    public allowedDepartmentIds: number[];
    public isOnline?: boolean;
    public fallbackCustomerId?: number;
    public chaseId: string;
    public waitingListId: string;
    public saveCardUrl: string;
    public filesUrl: string;
    public magicLinkUrl: string;
    public secureDocumentLink: string;
    public recipientName: string;

    public constructor(init?: Partial<MergeDataRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MergeDataRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(MergeDataRequest as unknown)[immerable] = true;

// @Route("/contactmergecheck", "POST")
export class ContactMergeCheckRequest implements IReturn<ResponseBase<ContactMergeCheckResponse>>, IHasPath, ISecurityId, ISecurityType
{
    public mode: string;
    public id: string;
    public templateName: string;
    public path: string;
    public safeRoot: string;
    public securityId: number;
    public securityType: string;

    public constructor(init?: Partial<ContactMergeCheckRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ContactMergeCheckRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ContactMergeCheckResponse>(); }
}
(ContactMergeCheckRequest as unknown)[immerable] = true;

// @Route("/communication/sms")
export class SmsSendRequest implements IReturn<SmsResponse>, ISecurityId, ISecurityType
{
    public recipient: string;
    public source: string;
    public object: Object;
    public objectType: string;
    public objectId: number;
    public skipFileSave: boolean;
    public template: string;
    public securityId: number;
    public securityType: string;
    public isOnline?: boolean;
    public smsType: string;
    public metadata?: { [index:string]: string; };

    public constructor(init?: Partial<SmsSendRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SmsSendRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SmsResponse(); }
}
(SmsSendRequest as unknown)[immerable] = true;

// @Route("/communication/consent/{Mode}/{Id}")
export class SmsConsentCheck implements IReturn<SmsConsentReponse>
{
    public id: number;
    public mode: string;

    public constructor(init?: Partial<SmsConsentCheck>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SmsConsentCheck'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SmsConsentReponse(); }
}
(SmsConsentCheck as unknown)[immerable] = true;

// @Route("/customer/contacts", "GET")
// @Route("/customer/contacts/{Id}", "GET")
export class MedicalContactRequest implements IReturn<ResponseBase<MedicalContactResponse>>, ISecurityId
{
    public skip: number;
    public take: number;
    public id: number;
    public securityId: number;

    public constructor(init?: Partial<MedicalContactRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MedicalContactRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<MedicalContactResponse>(); }
}
(MedicalContactRequest as unknown)[immerable] = true;

// @Route("/customer/contacts/linked")
// @Route("/customer/contacts/linked/{CustomerId}")
export class LinkedPatientsRequest implements IReturn<ResponseBase<GeneralCustomerResponse>>, ICustomerId
{
    public customerId: number;

    public constructor(init?: Partial<LinkedPatientsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LinkedPatientsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GeneralCustomerResponse>(); }
}
(LinkedPatientsRequest as unknown)[immerable] = true;

// @Route("/contact/recent/{Id}", "GET")
export class ContactRecentRequest implements IReturn<ContactRecentResponse>, IHasPath, ISecurityId
{
    public id: number;
    public path: string;
    public safeRoot: string;
    public securityId: number;

    public constructor(init?: Partial<ContactRecentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ContactRecentRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ContactRecentResponse(); }
}
(ContactRecentRequest as unknown)[immerable] = true;

// @Route("/contacts/linkedCustomers/")
// @Route("/contacts/linkedCustomers/{ContactId}")
export class ContactsLinkedPatients implements IReturn<ResponseBase<GeneralCustomerResponse>>, ISecurityId, IFilterServiceTypeManually
{
    public skip: number;
    public take?: number;
    public contactId: number;
    public securityId: number;
    public sort: QueryField[];

    public constructor(init?: Partial<ContactsLinkedPatients>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ContactsLinkedPatients'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GeneralCustomerResponse>(); }
}
(ContactsLinkedPatients as unknown)[immerable] = true;

// @Route("/customers/contactsave")
export class MedicalContactSaveRequest implements IReturn<ResponseBase<MedicalContactResponse>>, ILocationId
{
    public id?: number;
    public current?: boolean;
    public category: string;
    public title: string;
    public forename: string;
    public surname: string;
    public businessName: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public addressLine5: string;
    public mobile: string;
    public postCode: string;
    public telephone: string;
    public altTelephone1: string;
    public altTelephone2: string;
    public fax: string;
    public email: string;
    public web: string;
    public locationId: number;
    public locationName: string;
    public providerNumber: string;
    public hasDocumentSharingPin: boolean;
    public documentSharingPin: string;
    public clearDocumentSharingPin: boolean;
    public nhsGncCode: string;

    public constructor(init?: Partial<MedicalContactSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MedicalContactSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<MedicalContactResponse>(); }
}
(MedicalContactSaveRequest as unknown)[immerable] = true;

// @Route("/medical-contacts/ods-apply", "POST")
export class MedicalContactOdsApplyRequest implements IReturn<ResponseBase<MedicalContactResponse>>
{
    public contactIds: number[];

    public constructor(init?: Partial<MedicalContactOdsApplyRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MedicalContactOdsApplyRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<MedicalContactResponse>(); }
}
(MedicalContactOdsApplyRequest as unknown)[immerable] = true;

// @Route("/customers/{CustomerId}")
// @Route("/customers")
export class CustomerRequest implements IReturn<ResponseBase<GeneralCustomerResponse>>, ICustomerId, IGet
{
    public customerId: number;
    public byCaseId?: number;
    public includeDiaryMetaData: boolean;

    public constructor(init?: Partial<CustomerRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GeneralCustomerResponse>(); }
}
(CustomerRequest as unknown)[immerable] = true;

export class CustomerLiteRequest implements IReturn<ResponseBase<CustomerLiteDto>>, ICustomerId
{
    public customerId: number;

    public constructor(init?: Partial<CustomerLiteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerLiteRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CustomerLiteDto>(); }
}
(CustomerLiteRequest as unknown)[immerable] = true;

// @Route("/customer/save/consent")
export class CustomerSaveConsentRequest implements IReturn<ResponseBase<Object>>, ILocationId, ICustomerId
{
    public id: number;
    public locationId: number;
    public customerId: number;
    public emailConsent: boolean;
    public smsConsent: boolean;
    public phoneConsent: boolean;
    public givenConsent: boolean;

    public constructor(init?: Partial<CustomerSaveConsentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerSaveConsentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<Object>(); }
}
(CustomerSaveConsentRequest as unknown)[immerable] = true;

// @Route("/customer/batch/consent")
export class CustomerBatchConsentRequest implements IReturn<ResponseBase<CustomerBatchConsentResponse>>
{
    public consent: boolean;
    public customerIds: number[];

    public constructor(init?: Partial<CustomerBatchConsentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerBatchConsentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CustomerBatchConsentResponse>(); }
}
(CustomerBatchConsentRequest as unknown)[immerable] = true;

export class CustomerEmailDuplicateCheck implements IReturn<ResponseBase<Customer>>, ILocationId
{
    public locationId: number;
    public email: string;
    public customerId?: number;

    public constructor(init?: Partial<CustomerEmailDuplicateCheck>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerEmailDuplicateCheck'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<Customer>(); }
}
(CustomerEmailDuplicateCheck as unknown)[immerable] = true;

// @Route("/customer/save")
export class CustomerSaveRequest implements IReturn<ResponseBase<CustomerSaveResponse>>, ILocationId
{
    public id: number;
    public reference: string;
    public accountingCode: string;
    public forename: string;
    public surname: string;
    public title: string;
    public initials: string;
    public gender: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public addressLine5: string;
    public postCode: string;
    public invoiceAddressLine1: string;
    public invoiceAddressLine2: string;
    public invoiceAddressLine3: string;
    public invoiceAddressLine4: string;
    public invoiceAddressLine5: string;
    public invoicePostCode: string;
    public registrationDate?: string;
    public homeTelephone: string;
    public workTelephone: string;
    public mobileTelephone: string;
    public stripeToken: string;
    public stripeCustomerId: string;
    public cardName: string;
    public lastFourDigits: string;
    public expiryMonth: number;
    public expiryYear: number;
    public brand: string;
    public isNewCard: boolean;
    public isDeletingCard: boolean;
    public elementType: string;
    public cardID?: number;
    public email: string;
    public dateOfBirth?: string;
    public locationName: string;
    public practitionerTitle: string;
    public practitionerForename: string;
    public practitionerSurname: string;
    public locationId: number;
    public practitionerId: number;
    public practitionerName: string;
    public groupName: string;
    public groupId?: number;
    public patientGroup: string;
    public accountId?: number;
    public status?: number;
    public insuranceNumber: string;
    public groupReference: string;
    public smsEnabled?: boolean;
    public defaultCharge: string;
    public invoicePeriod: string;
    public useInvoiceAddress?: boolean;
    public enquiry: string;
    public category: string;
    public employer: string;
    public height?: number;
    public weight?: number;
    public hospitalNumber: string;
    public patientHospitalNumber: string;
    public niNumber: string;
    public medication: string;
    public previousInjuries: string;
    public alternativeRef1: string;
    public lastAppointmentDate?: string;
    public alternativeRef2: string;
    public alternativeRef3: string;
    public alternativeRef4: string;
    public notes: string;
    public billTo: string;
    public online?: boolean;
    public cardNo: string;
    public invoiceFrequency?: number;
    public invoiceDeadline?: string;
    public consent: string;
    public forceSave: boolean;
    public customerId: number;
    public emailConsent: boolean;
    public smsConsent: boolean;
    public phoneConsent: boolean;
    public givenConsent: boolean;
    public updateAnyway: boolean;
    public paymentMethodId: string;
    public mailChimpEnabled: boolean;
    public flag: string;
    public medicareCardNo: string;
    public irn: string;
    public dvaNumber: string;
    public tags: string[];
    public overridePayAtClinic: boolean;
    public isBusiness: boolean;
    public emergencyContactName: string;
    public emergencyContactRelationship: string;
    public emergencyContactNumber: string;
    public creationSource: CreationSource;

    public constructor(init?: Partial<CustomerSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CustomerSaveResponse>(); }
}
(CustomerSaveRequest as unknown)[immerable] = true;

// @Route("/customer/sms/change")
export class ChangeCustomerSmsEnabled implements IReturn<Customer>, ILocationIds
{
    public id: number;
    public smsEnabled: boolean;
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<ChangeCustomerSmsEnabled>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ChangeCustomerSmsEnabled'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Customer(); }
}
(ChangeCustomerSmsEnabled as unknown)[immerable] = true;

// @Route("/patient/nextappointment/{CustomerId}")
export class PatientNextAppointmentRequest implements IReturn<ResponseBase<AppointmentResponse>>, ICustomerId
{
    public customerId: number;

    public constructor(init?: Partial<PatientNextAppointmentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientNextAppointmentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AppointmentResponse>(); }
}
(PatientNextAppointmentRequest as unknown)[immerable] = true;

export class PatientNextClassRequest implements IReturn<ResponseBase<ClassSessionBaseResponse>>, ICustomerId
{
    public customerId: number;

    public constructor(init?: Partial<PatientNextClassRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientNextClassRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClassSessionBaseResponse>(); }
}
(PatientNextClassRequest as unknown)[immerable] = true;

export class PatientClassCountRequest implements IReturn<ResponseBase<number>>, ICustomerId
{
    public customerId: number;

    public constructor(init?: Partial<PatientClassCountRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientClassCountRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<number>(); }
}
(PatientClassCountRequest as unknown)[immerable] = true;

// @Route("/patient/recent/{CustomerId}")
export class PatientRecentRequest implements IReturn<PatientRecentResponse>, IHasPath, ICustomerId, IFilterServiceTypeManually
{
    public customerId: number;
    public path: string;
    public safeRoot: string;

    public constructor(init?: Partial<PatientRecentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientRecentRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientRecentResponse(); }
}
(PatientRecentRequest as unknown)[immerable] = true;

// @Route("/patient/recentDocument/{CustomerId}")
export class RecentDocumentRequest implements IReturn<RecentDocumentResponse>, IHasPath, ICustomerId
{
    public customerId: number;
    public path: string;
    public safeRoot: string;

    public constructor(init?: Partial<RecentDocumentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RecentDocumentRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RecentDocumentResponse(); }
}
(RecentDocumentRequest as unknown)[immerable] = true;

// @Route("/customer/contacts/medical/{CustomerId}")
// @Route("/customer/contacts/medical")
export class CustomerMedicalContactsRequest implements IReturn<ResponseBase<MedicalContactResponse>>, ICustomerId
{
    public customerId: number;

    public constructor(init?: Partial<CustomerMedicalContactsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerMedicalContactsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<MedicalContactResponse>(); }
}
(CustomerMedicalContactsRequest as unknown)[immerable] = true;

// @Route("/customer/contacts/joined/{CustomerId}")
// @Route("/customer/contacts/joined")
export class JoinedContactsRequest implements IReturn<ResponseBase<JoinedContactResponse>>, ICustomerId
{
    public customerId: number;
    public term: string;
    public skip: number;
    public take: number;
    public sort: QueryField[];

    public constructor(init?: Partial<JoinedContactsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'JoinedContactsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<JoinedContactResponse>(); }
}
(JoinedContactsRequest as unknown)[immerable] = true;

// @Route("/customer/contacts/medical/default")
export class DefaultMedicalContactRequest implements IReturn<ResponseBase<boolean>>, ICustomerId
{
    public customerId: number;
    public contactId: number;

    public constructor(init?: Partial<DefaultMedicalContactRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DefaultMedicalContactRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(DefaultMedicalContactRequest as unknown)[immerable] = true;

// @Route("/customer/contacts/medical/contactable")
export class ContactableMedicalContactRequest implements IReturn<ResponseBase<boolean>>, ICustomerId
{
    public customerId: number;
    public contactId: number;

    public constructor(init?: Partial<ContactableMedicalContactRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ContactableMedicalContactRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ContactableMedicalContactRequest as unknown)[immerable] = true;

// @Route("/customer/contacts/patient/{CustomerId}")
// @Route("/customer/contacts/patient")
export class CustomerPatientContactsRequest implements IReturn<ResponseBase<MedicalContactResponse>>, ICustomerId
{
    public customerId: number;

    public constructor(init?: Partial<CustomerPatientContactsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerPatientContactsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<MedicalContactResponse>(); }
}
(CustomerPatientContactsRequest as unknown)[immerable] = true;

// @Route("/customer/contacts/relationship")
export class PatientContactRelationshipRequest implements IReturn<ResponseBase<boolean>>, ICustomerId
{
    public customerId: number;
    public contactId: number;
    public relationship: string;

    public constructor(init?: Partial<PatientContactRelationshipRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientContactRelationshipRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(PatientContactRelationshipRequest as unknown)[immerable] = true;

// @Route("/customer/contacts/patient/default")
export class DefaultPatientContactRequest implements IReturn<ResponseBase<boolean>>, ICustomerId
{
    public customerId: number;
    public contactId: number;

    public constructor(init?: Partial<DefaultPatientContactRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DefaultPatientContactRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(DefaultPatientContactRequest as unknown)[immerable] = true;

// @Route("/patient/delete")
export class DeleteCustomerRequest implements IReturn<ResponseBase<boolean>>, ICustomerId
{
    public customerId: number;
    public isProvisional: boolean;

    public constructor(init?: Partial<DeleteCustomerRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteCustomerRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(DeleteCustomerRequest as unknown)[immerable] = true;

// @Route("/patient/linkpatient")
export class LinkCustomerRequest implements IReturn<ResponseBase<boolean>>, ICustomerId
{
    public customerId: number;
    public existingPatientId: number;

    public constructor(init?: Partial<LinkCustomerRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LinkCustomerRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(LinkCustomerRequest as unknown)[immerable] = true;

// @Route("/patient/makereal")
export class MakeCustomerRealRequest implements IReturn<ResponseBase<boolean>>, ICustomerId
{
    public customerId: number;

    public constructor(init?: Partial<MakeCustomerRealRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MakeCustomerRealRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(MakeCustomerRealRequest as unknown)[immerable] = true;

// @Route("/customer/contacts/medical/remove")
export class RemoveMedicalContactRequest implements IReturn<ResponseBase<boolean>>, ICustomerId
{
    public customerId: number;
    public contactId: number;

    public constructor(init?: Partial<RemoveMedicalContactRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RemoveMedicalContactRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(RemoveMedicalContactRequest as unknown)[immerable] = true;

// @Route("/customer/contacts/patient/remove")
export class RemovePatientContactRequest implements IReturn<ResponseBase<boolean>>, ICustomerId
{
    public customerId: number;
    public contactId: number;

    public constructor(init?: Partial<RemovePatientContactRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RemovePatientContactRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(RemovePatientContactRequest as unknown)[immerable] = true;

// @Route("/customer/contacts/addTo")
export class CustomerContactAddRequest implements IReturn<ResponseBase<boolean>>, ICustomerId
{
    public customerId: number;
    public contactId: number;

    public constructor(init?: Partial<CustomerContactAddRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerContactAddRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CustomerContactAddRequest as unknown)[immerable] = true;

// @Route("/customer/patientcon/addTo")
export class CustomerPatientContactAddRequest implements IReturn<ResponseBase<boolean>>, ICustomerId
{
    public customerId: number;
    public contactId: number;
    public relationship: string;

    public constructor(init?: Partial<CustomerPatientContactAddRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerPatientContactAddRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CustomerPatientContactAddRequest as unknown)[immerable] = true;

// @Route("/finances/account")
// @Route("/finances/account/{CustomerId}")
export class AccountStatementRequest implements IReturn<ResponseBase<AccountStatementResponse>>, ILocationIds
{
    public sort: QueryField[];
    public customerId: number;
    public date: DateRange;
    public skip: number;
    public take: number;
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<AccountStatementRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AccountStatementRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AccountStatementResponse>(); }
}
(AccountStatementRequest as unknown)[immerable] = true;

// @Route("/finances/account/groups")
// @Route("/finances/account/groups/{CustomerId}")
export class GroupAccountStatementRequest implements IReturn<ResponseBase<GroupAccountStatementResponse>>, ILocationIds
{
    public sort: QueryField[];
    public customerId: number;
    public date: DateRange;
    public skip: number;
    public take: number;
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<GroupAccountStatementRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupAccountStatementRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GroupAccountStatementResponse>(); }
}
(GroupAccountStatementRequest as unknown)[immerable] = true;

// @Route("/invoices/{InvoiceId}/billingitems")
// @Route("/billing/items")
export class BillingItemsRequest implements IReturn<ResponseBase<BillingItemsResponse>>, ILocationIds
{
    public sort: QueryField[];
    public customerId: number;
    public invoiceId: number;
    public skip: number;
    public take: number;
    public locationIds: number[];
    public requestLocationIds: number[];
    public hideDiscountItems: boolean;

    public constructor(init?: Partial<BillingItemsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BillingItemsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<BillingItemsResponse>(); }
}
(BillingItemsRequest as unknown)[immerable] = true;

// @Route("/billing/items/group")
export class GroupBillingItemsRequest implements IReturn<ResponseBase<BillingItemsResponse>>, ILocationId
{
    public sort: QueryField[];
    public customerId: number;
    public invoiceId: number;
    public skip: number;
    public take: number;
    public locationId: number;
    public hideDiscountItems: boolean;

    public constructor(init?: Partial<GroupBillingItemsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupBillingItemsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<BillingItemsResponse>(); }
}
(GroupBillingItemsRequest as unknown)[immerable] = true;

// @Route("/customer/prepaidStock")
export class PrePaidStockRequest implements IReturn<ResponseBase<StockResponse>>, ICustomerId
{
    public customerId: number;
    public caseId?: number;

    public constructor(init?: Partial<PrePaidStockRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PrePaidStockRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<StockResponse>(); }
}
(PrePaidStockRequest as unknown)[immerable] = true;

// @Route("/billing/item/prepaid")
export class PrePaidItemRequest implements IReturn<ResponseBase<PrePaidItems>>, ICustomerId
{
    public customerId: number;
    public billingItemId?: number;
    public skip?: number;
    public take?: number;
    public sort: QueryField[];

    public constructor(init?: Partial<PrePaidItemRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PrePaidItemRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<PrePaidItems>(); }
}
(PrePaidItemRequest as unknown)[immerable] = true;

// @Route("/billing/item/prepaid/add")
export class PrePaidItemAddRequest implements IReturn<ResponseBase<boolean>>, ICustomerId
{
    public accountId: number;
    public clientId: number;
    public stockId: number;
    public customerId: number;
    public billingItemId?: number;
    public quantity?: number;
    public classTypeId?: number;
    public expiryDate?: string;
    public type?: PackageBundleItemType;

    public constructor(init?: Partial<PrePaidItemAddRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PrePaidItemAddRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(PrePaidItemAddRequest as unknown)[immerable] = true;

// @Route("/billing/item/prepaid/action")
export class PrePaidItemDeleteRequest implements IReturn<ResponseBase<boolean>>
{
    public prePaidId: number;
    public markAsRemoved: boolean;
    public incrementUsage: boolean;
    public updateQuantityAndUsage: boolean;
    public quantity?: number;
    public used?: number;

    public constructor(init?: Partial<PrePaidItemDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PrePaidItemDeleteRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(PrePaidItemDeleteRequest as unknown)[immerable] = true;

// @Route("/billing/item/prepaid/edit")
export class PrePaidItemsExpiryDateRequest implements IReturn<ResponseBase<boolean>>
{
    public billingItemId: number;
    public expiryDate: string;

    public constructor(init?: Partial<PrePaidItemsExpiryDateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PrePaidItemsExpiryDateRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(PrePaidItemsExpiryDateRequest as unknown)[immerable] = true;

// @Route("/invoices/{InvoiceId}/payments")
export class InvoicePaymentsRequest implements IReturn<ResponseBase<InvoicePaymentsResponse>>, IInvoiceId, ISecurityId
{
    public invoiceId: number;
    public skip: number;
    public take: number;
    public securityId: number;

    public constructor(init?: Partial<InvoicePaymentsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InvoicePaymentsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<InvoicePaymentsResponse>(); }
}
(InvoicePaymentsRequest as unknown)[immerable] = true;

// @Route("/customers/contactsearch/", "POST")
// @Route("/customers/contactsearch/{CustomerId}", "POST")
export class ContactQuickSearchRequest implements IReturn<ResponseBase<MedicalContactResponse>>, ILocationId
{
    public skip: number;
    public take: number;
    public term: string;
    public customerId: number;
    public locationId: number;

    public constructor(init?: Partial<ContactQuickSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ContactQuickSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<MedicalContactResponse>(); }
}
(ContactQuickSearchRequest as unknown)[immerable] = true;

// @Route("/click/contact-search", "POST")
// @Route("/click/contact-search/{CustomerId}", "POST")
export class ClickContactQuickSearchRequest implements IReturn<ResponseBase<ClickContactSearchResult>>, ILocationIds, IFilterServiceTypeManually
{
    public filterId: number;
    public term: string;
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<ClickContactQuickSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickContactQuickSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClickContactSearchResult>(); }
}
(ClickContactQuickSearchRequest as unknown)[immerable] = true;

// @Route("/customers/contactsearch/patient", "POST")
// @Route("/customers/contactsearch/patient/{CustomerId}", "POST")
export class ContactPatientQuickSearchRequest implements IReturn<ResponseBase<GeneralCustomerResponse>>, ICustomerId, ILocationIds, IFilterServiceTypeManually
{
    public startIdx: number;
    public endIdx: number;
    public realOnly: boolean;
    public includeDeceased: boolean;
    public term: string;
    public customerId: number;
    public sort: QueryField[];
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<ContactPatientQuickSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ContactPatientQuickSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GeneralCustomerResponse>(); }
}
(ContactPatientQuickSearchRequest as unknown)[immerable] = true;

// @Route("/customers/export/csv")
export class CustomerAdvancedSearchExportCSVRequest implements IReturn<string>, ILocationIds
{
    public customHeaders: CustomerCSVHeaderOverrides;
    public query: CustomerAdvancedSearchRequest;
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<CustomerAdvancedSearchExportCSVRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerAdvancedSearchExportCSVRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return ''; }
}
(CustomerAdvancedSearchExportCSVRequest as unknown)[immerable] = true;

// @Route("/customers/count")
export class PatientCountRequest implements IReturn<ResponseBase<number>>
{

    public constructor(init?: Partial<PatientCountRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientCountRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<number>(); }
}
(PatientCountRequest as unknown)[immerable] = true;

// @Route("/medicalContacts/count")
export class MedicalContactCountRequest implements IReturn<ResponseBase<number>>
{

    public constructor(init?: Partial<MedicalContactCountRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MedicalContactCountRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<number>(); }
}
(MedicalContactCountRequest as unknown)[immerable] = true;

// @Route("/customers/searchProvisionalPatients")
export class ProvisionalPatientsRequest implements IReturn<ResponseBase<GeneralCustomerResponse>>, ILocationIds
{
    public locationIds: number[];
    public status?: number;
    public provisional: boolean;
    public requestLocationIds: number[];

    public constructor(init?: Partial<ProvisionalPatientsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProvisionalPatientsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GeneralCustomerResponse>(); }
}
(ProvisionalPatientsRequest as unknown)[immerable] = true;

// @Route("/customers/potentialProvisionalMatches/{CustomerId}")
export class PotentialProvisionalMatchesRequest implements IReturn<ResponseBase<GeneralCustomerResponse>>, ICustomerId, ILocationIds, IFilterServiceTypeManually
{
    public customerId: number;
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<PotentialProvisionalMatchesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PotentialProvisionalMatchesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GeneralCustomerResponse>(); }
}
(PotentialProvisionalMatchesRequest as unknown)[immerable] = true;

export class GetPotentialMatchesRequest implements IReturn<ResponseBase<GeneralCustomerResponse>>, ILocationIds, IFilterServiceTypeManually
{
    public title: string;
    public forename: string;
    public surname: string;
    public postCode: string;
    public email: string;
    public mobileTelephone: string;
    public dateOfBirth?: string;
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<GetPotentialMatchesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPotentialMatchesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GeneralCustomerResponse>(); }
}
(GetPotentialMatchesRequest as unknown)[immerable] = true;

// @Route("/contacts/search")
export class MedicalContactsAdvancedSearchRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<MedicalContactResponse>>
{
    public surname: string;
    public status?: boolean;
    public address: string;
    public forename: string;
    public locationId?: number;
    public locationMulti: number[];
    public businessName: string;

    public constructor(init?: Partial<MedicalContactsAdvancedSearchRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'MedicalContactsAdvancedSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<MedicalContactResponse>(); }
}
(MedicalContactsAdvancedSearchRequest as unknown)[immerable] = true;

// @Route("/contacts/export/csv")
export class MedicalContactsAdvancedSearchExportCSVRequest implements IReturn<string>, ILocationIds
{
    public customHeaders: MedicalContactsCSVHeaderOverrides;
    public query: MedicalContactsAdvancedSearchRequest;
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<MedicalContactsAdvancedSearchExportCSVRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MedicalContactsAdvancedSearchExportCSVRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return ''; }
}
(MedicalContactsAdvancedSearchExportCSVRequest as unknown)[immerable] = true;

export class TreatmentAuthCountRequest implements IReturn<number>
{

    public constructor(init?: Partial<TreatmentAuthCountRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentAuthCountRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return 0; }
}
(TreatmentAuthCountRequest as unknown)[immerable] = true;

// @Route("/patient/{CustomerId}/authCodes")
export class TreatmentAuthRequest implements IReturn<ResponseBase<TreatmentAuthResponse>>, ICustomerId, IDepartmentIds
{
    public sort: QueryField[];
    public skip: number;
    public take: number;
    public customerId: number;
    public departmentIds: number[];
    public activeOnly: boolean;

    public constructor(init?: Partial<TreatmentAuthRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentAuthRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TreatmentAuthResponse>(); }
}
(TreatmentAuthRequest as unknown)[immerable] = true;

export class ClickCustomerNotesCheckRequest implements IReturn<ResponseBase<ClickCustomerNotesCheckResponse>>
{
    public customerId: number;

    public constructor(init?: Partial<ClickCustomerNotesCheckRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickCustomerNotesCheckRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ClickCustomerNotesCheckResponse>(); }
}
(ClickCustomerNotesCheckRequest as unknown)[immerable] = true;

export class ClickCustomerCreateCaseRequest implements IReturn<ResponseBase<ClickCustomerNotesCheckResponse>>
{
    public customerId: number;

    public constructor(init?: Partial<ClickCustomerCreateCaseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickCustomerCreateCaseRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClickCustomerNotesCheckResponse>(); }
}
(ClickCustomerCreateCaseRequest as unknown)[immerable] = true;

// @Route("/appointment/cases/{CustomerId}")
export class AppointmentCaseRequest implements IReturn<ResponseBase<AppointmentCaseResponse>>, ILocationIds, IServiceTypeId
{
    public customerId: number;
    public locationIds: number[];
    public requestLocationIds: number[];
    public serviceTypeId: number;

    public constructor(init?: Partial<AppointmentCaseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AppointmentCaseRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<AppointmentCaseResponse>(); }
}
(AppointmentCaseRequest as unknown)[immerable] = true;

// @Route("/appointment/auths")
export class AppointmentAuthCode implements IReturn<ResponseBase<TreatmentAuthResponse>>, ICustomerId, IServiceTypeId
{
    public customerId: number;
    public existingAuthId?: number;
    public serviceTypeId: number;

    public constructor(init?: Partial<AppointmentAuthCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AppointmentAuthCode'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TreatmentAuthResponse>(); }
}
(AppointmentAuthCode as unknown)[immerable] = true;

export class TreatmentAuthByIdRequest implements IReturn<ResponseBase<T>>
{
    public authId: number;

    public constructor(init?: Partial<TreatmentAuthByIdRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentAuthByIdRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(TreatmentAuthByIdRequest as unknown)[immerable] = true;

// @Route("/authcode/{AuthId}")
// @Route("/authcode")
export class TreatmentAuthIdRequest implements IReturn<ResponseBase<TreatmentAuthResponse>>, ILocationId, IFilterServiceTypeManually, IGet
{
    public skip: number;
    public take: number;
    public authId: number;
    public locationId: number;

    public constructor(init?: Partial<TreatmentAuthIdRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentAuthIdRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<TreatmentAuthResponse>(); }
}
(TreatmentAuthIdRequest as unknown)[immerable] = true;

// @Route("/authcode/delete")
// @Route("/authcode/delete/{AuthId}")
export class TreatmentAuthDeleteRequest implements IReturn<ResponseBase<boolean>>, ILocationId, IFilterServiceTypeManually
{
    public authId: number;
    public locationId: number;

    public constructor(init?: Partial<TreatmentAuthDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentAuthDeleteRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(TreatmentAuthDeleteRequest as unknown)[immerable] = true;

// @Route("/authcode/save/")
export class TreatmentAuthSave implements IReturn<ResponseBase<TreatmentAuthResponse>>, ICustomerId, IFilterServiceTypeManually
{
    public id: number;
    public authCode: string;
    public expired?: string;
    public maxTreatments: number;
    public maxValue: number;
    public expiryDate?: string;
    public usedTreatments: number;
    public usedValue?: number;
    public usedFor: string;
    public startDate?: string;
    public groupId?: number;
    public caseId?: number;
    public customerId: number;
    public serviceTypeId?: number;
    public contactId: number;

    public constructor(init?: Partial<TreatmentAuthSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentAuthSave'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<TreatmentAuthResponse>(); }
}
(TreatmentAuthSave as unknown)[immerable] = true;

// @Route("/customer/sar/status/{customerId}")
export class SarStatusRequest implements IReturn<ResponseBase<string>>, ICustomerId
{
    public customerId: number;

    public constructor(init?: Partial<SarStatusRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SarStatusRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<string>(); }
}
(SarStatusRequest as unknown)[immerable] = true;

// @Route("/customer/sar/delete")
export class SarDeleteRequest implements IReturn<ResponseBase<boolean>>, ICustomerId
{
    public customerId: number;
    public deleteFile: boolean;

    public constructor(init?: Partial<SarDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SarDeleteRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(SarDeleteRequest as unknown)[immerable] = true;

// @Route("/customer/sar/download/{customerId}")
export class SarDownloadRequest implements IReturn<ResponseBase<Object>>, ICustomerId
{
    public customerId: number;

    public constructor(init?: Partial<SarDownloadRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SarDownloadRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<Object>(); }
}
(SarDownloadRequest as unknown)[immerable] = true;

// @Route("/customer/OnlineUserPasswordReset/{customerId}")
export class OnlineUserPasswordResetRequest implements IReturn<ResponseBase<OnlineUserPasswordResetResponse>>, ICustomerId
{
    public customerId: number;
    public email: string;

    public constructor(init?: Partial<OnlineUserPasswordResetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineUserPasswordResetRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<OnlineUserPasswordResetResponse>(); }
}
(OnlineUserPasswordResetRequest as unknown)[immerable] = true;

// @Route("/customer/{customerId}/GenerateOnlineBookingLink")
export class GenerateOnlineBookingLinkRequest implements IReturn<ResponseBase<GenerateOnlineBookingLinkResponse>>, ICustomerId
{
    public customerId: number;
    public serviceId: string;
    public locationId: string;
    public groupId?: number;
    public practitionerId: string;
    public email: string;
    public mobile: string;
    public requireBackupCard: boolean;
    public authId?: number;

    public constructor(init?: Partial<GenerateOnlineBookingLinkRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GenerateOnlineBookingLinkRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GenerateOnlineBookingLinkResponse>(); }
}
(GenerateOnlineBookingLinkRequest as unknown)[immerable] = true;

// @Route("/customerservice/all")
export class CustomerServiceRequest implements IReturn<ResponseBase<CustomerServiceResponse>>
{

    public constructor(init?: Partial<CustomerServiceRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerServiceRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CustomerServiceResponse>(); }
}
(CustomerServiceRequest as unknown)[immerable] = true;

// @Route("/customerservice/save")
export class CustomerServiceUpdate implements IReturn<ResponseBase<CustomerServiceResponse>>
{
    public id: number;
    public customerSecurityLevel: number;
    public customerSecurityKeyWord: string;

    public constructor(init?: Partial<CustomerServiceUpdate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerServiceUpdate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CustomerServiceResponse>(); }
}
(CustomerServiceUpdate as unknown)[immerable] = true;

// @Route("/patient/log")
// @Route("/patient/log/{LogId}")
export class PatientLogRequest implements IReturn<ResponseBase<PatientLogResponse>>, ILocationId, IFilterServiceTypeManually
{
    public skip: number;
    public take: number;
    public logId: number;
    public locationId: number;

    public constructor(init?: Partial<PatientLogRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientLogRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<PatientLogResponse>(); }
}
(PatientLogRequest as unknown)[immerable] = true;

// @Route("/patient/log/delete")
// @Route("/patient/log/delete/{LogId}")
export class PatientLogDeleteRequest implements IReturn<ResponseBase<Patientlog>>, ILocationId, IFilterServiceTypeManually
{
    public logId: number;
    public locationId: number;

    public constructor(init?: Partial<PatientLogDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientLogDeleteRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<Patientlog>(); }
}
(PatientLogDeleteRequest as unknown)[immerable] = true;

// @Route("/patient/infoLog/{CustomerId}")
export class PatientInfoLogRequest implements IReturn<ResponseBase<PatientInfoLogResponse>>, ICustomerId, IDepartmentIds
{
    public skip: number;
    public take: number;
    public customerId: number;
    public departmentIds: number[];

    public constructor(init?: Partial<PatientInfoLogRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientInfoLogRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<PatientInfoLogResponse>(); }
}
(PatientInfoLogRequest as unknown)[immerable] = true;

// @Route("/patient/infoLogsave/")
export class PatientLogSave implements IReturn<ResponseBase<PatientLogResponse>>, ICustomerId, IFilterServiceTypeManually
{
    public id: number;
    public customerId: number;
    public dateTime: string;
    public entry: string;
    public serviceTypeId?: number;

    public constructor(init?: Partial<PatientLogSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientLogSave'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<PatientLogResponse>(); }
}
(PatientLogSave as unknown)[immerable] = true;

export class TimelineRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<Timeline>>, ISecurityLocator
{
    public mode: ContactLayoutMode;
    public id: number;
    public appointmentId?: number;
    public showAcknowledgements?: boolean;
    public types: TimelineType[];
    public subTypes: string[];
    public linkedObjectTypes: TimelineLinkedObjectType[];
    public contexts: TimelineContextObjectType[];
    public context: TimelineContextObjectType;
    public contextId?: number;
    public linkedObjectType: TimelineLinkedObjectType;
    public linkedObjectId?: number;
    public securityLocator: Func<Object, IClientDbAccess, SecurityDto>;

    public constructor(init?: Partial<TimelineRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TimelineRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<Timeline>(); }
}
(TimelineRequest as unknown)[immerable] = true;

// @Route("/diary")
export class DiaryRequest implements IReturn<DiaryDefaultDataForUserResponse>
{

    public constructor(init?: Partial<DiaryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiaryRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DiaryDefaultDataForUserResponse(); }
}
(DiaryRequest as unknown)[immerable] = true;

export class DiaryListExportCSVRequest extends DiaryListBase implements IReturn<ResponseBase<string>>
{

    public constructor(init?: Partial<DiaryListExportCSVRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'DiaryListExportCSVRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<string>(); }
}
(DiaryListExportCSVRequest as unknown)[immerable] = true;

// @Route("/diary/stats")
export class DiaryAppointmentStatsRequest implements IReturn<DiaryStatsResponse>, ILocationId, IHasAutoRefresh
{
    public startDate?: string;
    public endDate?: string;
    public locationIds: number[];
    public practitionerIds: number[];
    public roomIds: number[];
    public locationId: number;
    public autoRefresh: boolean;

    public constructor(init?: Partial<DiaryAppointmentStatsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiaryAppointmentStatsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DiaryStatsResponse(); }
}
(DiaryAppointmentStatsRequest as unknown)[immerable] = true;

// @Route("/diary/nonWorkingDays")
export class DiaryHolidayRequest implements IReturn<NonWorkingDate[]>, ILocationId
{
    public startDate?: string;
    public endDate?: string;
    public locationIds: number[];
    public practitionerIds: number[];
    public locationId: number;

    public constructor(init?: Partial<DiaryHolidayRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiaryHolidayRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Array<NonWorkingDate>(); }
}
(DiaryHolidayRequest as unknown)[immerable] = true;

// @Route("/diary/nonWorkingDays/all")
export class DiaryAllHolidaysRequest implements IReturn<NonWorkingDateResponse[]>, ILocationId
{
    public locationIds: number[];
    public practitionerIds: number[];
    public locationId: number;

    public constructor(init?: Partial<DiaryAllHolidaysRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiaryAllHolidaysRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Array<NonWorkingDateResponse>(); }
}
(DiaryAllHolidaysRequest as unknown)[immerable] = true;

// @Route("/diary/nonWorkingDays/save")
export class DiaryAddHolidayRequest implements IReturn<NonWorkingDateResponse[]>, ILocationId
{
    public date: string;
    public locationId: number;
    public endDate?: string;
    public title: string;

    public constructor(init?: Partial<DiaryAddHolidayRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiaryAddHolidayRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Array<NonWorkingDateResponse>(); }
}
(DiaryAddHolidayRequest as unknown)[immerable] = true;

// @Route("/diary/nonWorkingDays/remove")
export class DiaryRemoveHolidayRequest implements IReturn<NonWorkingDateResponse[]>, ILocationId
{
    public id: number;
    public locationId: number;

    public constructor(init?: Partial<DiaryRemoveHolidayRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiaryRemoveHolidayRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Array<NonWorkingDateResponse>(); }
}
(DiaryRemoveHolidayRequest as unknown)[immerable] = true;

// @Route("/diary/sessions")
export class DiarySessionRequest implements IReturn<DiarySessionResponse[]>, ILocationId
{
    public startDate?: string;
    public endDate?: string;
    public locationIds: number[];
    public practitionerIds: number[];
    public roomIds: number[];
    public locationId: number;

    public constructor(init?: Partial<DiarySessionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiarySessionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Array<DiarySessionResponse>(); }
}
(DiarySessionRequest as unknown)[immerable] = true;

// @Route("/diary/schedule")
export class ScheduleRequest implements IReturn<ResponseBase<ScheduleResponse>>, ILocationIds, IHasAutoRefresh
{
    public date?: string;
    public isWeek: boolean;
    public showWeekends: boolean;
    public withoutSessions: boolean;
    public allLocations: boolean;
    public location?: number;
    public mode?: ResourceMode;
    public locationIds: number[];
    public resourceIds: number[];
    public requestLocationIds: number[];
    public autoRefresh: boolean;

    public constructor(init?: Partial<ScheduleRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScheduleRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ScheduleResponse>(); }
}
(ScheduleRequest as unknown)[immerable] = true;

// @Route("/diary/schedule")
export class MonthlyScheduleRequest implements IReturn<ResponseBase<MonthlyScheduleResponse>>, ILocationIds, IHasAutoRefresh
{
    public date?: string;
    public location?: number;
    public mode?: ResourceMode;
    public locationIds: number[];
    public resourceIds: number[];
    public requestLocationIds: number[];
    public autoRefresh: boolean;
    public showCancellations: boolean;

    public constructor(init?: Partial<MonthlyScheduleRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MonthlyScheduleRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<MonthlyScheduleResponse>(); }
}
(MonthlyScheduleRequest as unknown)[immerable] = true;

export class OccurrenceRequest implements IReturn<ResponseBase<T>>
{
    public batchNo: number;
    public type: string;
    public typeId: number;

    public constructor(init?: Partial<OccurrenceRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OccurrenceRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(OccurrenceRequest as unknown)[immerable] = true;

export class SaveDayNoteRequest implements IReturn<ResponseBase<SaveDayNoteResponse>>
{
    public date: string;
    public resourceId: number;
    public note: string;
    public timelineLinkedObjectType: TimelineLinkedObjectType;

    public constructor(init?: Partial<SaveDayNoteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveDayNoteRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SaveDayNoteResponse>(); }
}
(SaveDayNoteRequest as unknown)[immerable] = true;

// @Route("/session/move", "POST")
export class SessionMoveRequest
{
    public id: number;
    public isSpecial: boolean;
    public startDateTime: string;
    public endDateTime: string;

    public constructor(init?: Partial<SessionMoveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SessionMoveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(SessionMoveRequest as unknown)[immerable] = true;

// @Route("/session/update", "POST")
export class SessionUpdateRequest implements IReturn<ResponseBase<{ [index:string]: ScheduleSession[]; }>>
{
    public id: number;
    public isSpecial: boolean;
    public startDateTime: string;
    public endDateTime: string;
    public online: boolean;
    public usedFor: string;
    public hexColour: string;
    public roomId: number;
    public practitionerId: number;
    public applyToAllSubsequent: boolean;
    public locationId: number;
    public multiUsedFor: string[];
    public isOnline: boolean;
    public skillRestrictions: string[];
    public restriction: WorkingTimeRestriction;
    public allowedTags: string[];
    public allowedStockIds: number[];

    public constructor(init?: Partial<SessionUpdateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SessionUpdateRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<{ [index:string]: ScheduleSession[]; }>(); }
}
(SessionUpdateRequest as unknown)[immerable] = true;

// @Route("/session/delete", "POST")
export class SessionDeleteRequest implements IReturn<ResponseBase<{ [index:string]: ScheduleSession[]; }>>, ISecurityId
{
    public id: number;
    public securityId: number;
    public isSpecial: boolean;
    public all: boolean;
    public includePast: boolean;

    public constructor(init?: Partial<SessionDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SessionDeleteRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<{ [index:string]: ScheduleSession[]; }>(); }
}
(SessionDeleteRequest as unknown)[immerable] = true;

// @Route("/session/create", "POST")
export class SessionCreateRequest implements IReturn<ResponseBase<{ [index:string]: ScheduleSession[]; }>>, ILocationId
{
    public yesToWarnings: boolean;
    public excludeWarnings: boolean;
    public startDateTime: string;
    public endDateTime: string;
    public locationId: number;
    public practitionerId: number;
    public duration: number;
    public online: boolean;
    public usedFor: string;
    public roomId?: number;
    public hexColour: string;
    public recurrenceInterval: RecurrenceType;
    public customDuration: number;
    public customFreq: number;
    public customInterval: string;
    public excludeNonWorkingDays: boolean;
    public multiUsedFor: string[];
    public skillRestrictions: string[];
    public storeBatchNo: boolean;
    public restriction: WorkingTimeRestriction;
    public allowedTags: string[];
    public allowedStockIds: number[];

    public constructor(init?: Partial<SessionCreateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SessionCreateRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<{ [index:string]: ScheduleSession[]; }>(); }
}
(SessionCreateRequest as unknown)[immerable] = true;

export class CalculateWorkingTimesRequest implements IReturn<CalculateWorkingTimesResponse>
{
    public locationId: number;

    public constructor(init?: Partial<CalculateWorkingTimesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CalculateWorkingTimesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CalculateWorkingTimesResponse(); }
}
(CalculateWorkingTimesRequest as unknown)[immerable] = true;

// @Route("/patient/{CustomerId}/account")
export class PatientAccountRequest implements IReturn<Account>, ICustomerId
{
    public customerId: number;

    public constructor(init?: Partial<PatientAccountRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientAccountRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Account(); }
}
(PatientAccountRequest as unknown)[immerable] = true;

export class GroupAccountRequest implements IReturn<Account>, IGroupId, ISecurityId
{
    public groupId: number;
    public securityId: number;

    public constructor(init?: Partial<GroupAccountRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupAccountRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Account(); }
}
(GroupAccountRequest as unknown)[immerable] = true;

// @Route("/account/{AccountId}/payments")
export class AccountPaymentsRequest implements IReturn<ResponseBase<PaymentsResponse>>, ILocationId
{
    public skip: number;
    public take: number;
    public accountId: number;
    public invoiceId: number;
    public locationId: number;

    public constructor(init?: Partial<AccountPaymentsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AccountPaymentsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<PaymentsResponse>(); }
}
(AccountPaymentsRequest as unknown)[immerable] = true;

// @Route("/account/{AccountId}/billedItems")
export class AccountBilledItemsRequest implements IReturn<ResponseBase<BillingItemWithNamesAuth>>, ILocationId
{
    public take: number;
    public skip: number;
    public accountId: number;
    public invoiceId: number;
    public locationId: number;
    public auditId: string;

    public constructor(init?: Partial<AccountBilledItemsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AccountBilledItemsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<BillingItemWithNamesAuth>(); }
}
(AccountBilledItemsRequest as unknown)[immerable] = true;

// @Route("/finances/export/preview/charges")
export class AccountsExportChargesPreviewRequest implements IReturn<ResponseBase<AccountsExportChargesPreviewResponse>>, ILocationId
{
    public locationId: number;
    public date: DateRange;

    public constructor(init?: Partial<AccountsExportChargesPreviewRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AccountsExportChargesPreviewRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AccountsExportChargesPreviewResponse>(); }
}
(AccountsExportChargesPreviewRequest as unknown)[immerable] = true;

// @Route("/finances/export/preview/payments")
export class AccountsExportPaymentsPreviewRequest implements IReturn<ResponseBase<AccountsExportPaymentsPreviewResponse>>, ILocationId
{
    public locationId: number;
    public date: DateRange;

    public constructor(init?: Partial<AccountsExportPaymentsPreviewRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AccountsExportPaymentsPreviewRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AccountsExportPaymentsPreviewResponse>(); }
}
(AccountsExportPaymentsPreviewRequest as unknown)[immerable] = true;

// @Route("/finances/export/charges")
export class AccountsExportChargesRequest implements IReturn<AccountExportResponse>, ILocationId
{
    public locationId: number;
    public date: DateRange;

    public constructor(init?: Partial<AccountsExportChargesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AccountsExportChargesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AccountExportResponse(); }
}
(AccountsExportChargesRequest as unknown)[immerable] = true;

// @Route("/finances/export/payments")
export class AccountsExportPaymentsRequest implements IReturn<AccountExportResponse>, ILocationId
{
    public locationId: number;
    public date: DateRange;

    public constructor(init?: Partial<AccountsExportPaymentsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AccountsExportPaymentsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AccountExportResponse(); }
}
(AccountsExportPaymentsRequest as unknown)[immerable] = true;

// @Route("/finances/export/charges/{Id}/{LocationId}/{Mode}")
export class AccountsChargesExportRequest implements IReturn<Object>, ILocationId
{
    public id: number;
    public mode: string;
    public locationId: number;
    public exportDate?: string;

    public constructor(init?: Partial<AccountsChargesExportRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AccountsChargesExportRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Object(); }
}
(AccountsChargesExportRequest as unknown)[immerable] = true;

// @Route("/finances/export/payments/{Id}/{LocationId}/{Mode}")
export class AccountsPaymentsExportRequest implements IReturn<Object>, ILocationId
{
    public id: number;
    public mode: string;
    public locationId: number;
    public exportDate?: string;

    public constructor(init?: Partial<AccountsPaymentsExportRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AccountsPaymentsExportRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Object(); }
}
(AccountsPaymentsExportRequest as unknown)[immerable] = true;

export class AccountExportHistoryRequest implements IReturn<ResponseBase<AccountExportHistoryResponse>>
{
    public fromDate: string;
    public toDate: string;
    public type: string;

    public constructor(init?: Partial<AccountExportHistoryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AccountExportHistoryRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<AccountExportHistoryResponse>(); }
}
(AccountExportHistoryRequest as unknown)[immerable] = true;

// @Route("/billingItem/{Id}", "GET")
export class BillingItemRequest implements IReturn<ResponseBase<BillingItem>>, ILocationIds
{
    public id: number;
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<BillingItemRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BillingItemRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<BillingItem>(); }
}
(BillingItemRequest as unknown)[immerable] = true;

// @Route("/billingItem", "POST")
// @Route("/billingItem/{Id}", "PUT")
export class BillingItemSaveRequest implements IReturn<ResponseBase<BillingItem>>, ILocationId
{
    public accountId: number;
    public customerId: number;
    public practitionerId?: number;
    public soldByUserId?: number;
    public appointmentId?: number;
    public locationId: number;
    public invoiceId?: number;
    public accountName: string;
    public stockId?: number;
    public date?: string;
    public description: string;
    public total: number;
    public isPaid?: boolean;
    public isMigrated?: boolean;
    public totalExVat?: number;
    public quantity?: number;
    public price?: number;
    public vatRate?: number;
    public totalVat?: number;
    public id: number;
    public category: string;
    public ledgerCode: string;
    public accountsExportId?: number;
    public stockInventoryLevelId?: number;

    public constructor(init?: Partial<BillingItemSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BillingItemSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<BillingItem>(); }
}
(BillingItemSaveRequest as unknown)[immerable] = true;

// @Route("/charges/count", "GET")
export class ChargeCountRequest implements IReturn<number>, ILocationIds
{
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<ChargeCountRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ChargeCountRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return 0; }
}
(ChargeCountRequest as unknown)[immerable] = true;

// @Route("/charges/search")
export class ChargesSearchRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<GroupBillingItemsResponse>>
{
    public isInvoiceWizard?: boolean;
    public useAdvancedSearchForInvoicePeriod: InvoicePeriod;
    public useAdvancedSearchForInvoiceStatusToInclude: InvoicedStatusToInclude;

    public constructor(init?: Partial<ChargesSearchRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ChargesSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GroupBillingItemsResponse>(); }
}
(ChargesSearchRequest as unknown)[immerable] = true;

// @Route("/finances/invoices/prepare-all", "POST")
export class InvoiceAllGroupingRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<InvoiceGroupingResponse>>, ILocationId
{
    public searchData: ChargesSearchRequest;
    public locationId: number;
    public isInvoiceWizard?: boolean;

    public constructor(init?: Partial<InvoiceAllGroupingRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'InvoiceAllGroupingRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<InvoiceGroupingResponse>(); }
}
(InvoiceAllGroupingRequest as unknown)[immerable] = true;

// @Route("/finances/invoices/prepare", "POST")
export class InvoiceGroupingRequest implements IReturn<ResponseBase<InvoiceGroupingResponse>>, ILocationId
{
    public chargeIds: number[];
    public locationId: number;

    public constructor(init?: Partial<InvoiceGroupingRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InvoiceGroupingRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<InvoiceGroupingResponse>(); }
}
(InvoiceGroupingRequest as unknown)[immerable] = true;

// @Route("/finances/invoices/generate", "POST")
export class InvoiceWizardRequest implements IReturn<ResponseBase<InvoiceWizardResponse>>, ILocationId
{
    public chargeGroups: ChargeGroup[];
    public date?: string;
    public batch: InvoiceBatch;
    public locationId: number;

    public constructor(init?: Partial<InvoiceWizardRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InvoiceWizardRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<InvoiceWizardResponse>(); }
}
(InvoiceWizardRequest as unknown)[immerable] = true;

// @Route("/debt/search")
export class DebtAdvancedSearchRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<DebtsResponse>>
{
    public reference: string;
    public status: string;
    public account: string;
    public accountName: string;
    public debtStatus: string[];
    public invoiceStatus: string;

    public constructor(init?: Partial<DebtAdvancedSearchRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'DebtAdvancedSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<DebtsResponse>(); }
}
(DebtAdvancedSearchRequest as unknown)[immerable] = true;

// @Route("/expenditure")
// @Route("/expenditure/{Id}")
export class ExpenditureRequest implements IReturn<ResponseBase<ExpenditureResponse>>, ISecurityId
{
    public id: number;
    public securityId: number;

    public constructor(init?: Partial<ExpenditureRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExpenditureRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ExpenditureResponse>(); }
}
(ExpenditureRequest as unknown)[immerable] = true;

// @Route("/expenditures/count")
export class ExpenditureCountRequest implements IReturn<number>
{

    public constructor(init?: Partial<ExpenditureCountRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExpenditureCountRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return 0; }
}
(ExpenditureCountRequest as unknown)[immerable] = true;

// @Route("/expenditure/search")
export class ExpenditureAdvancedSearchRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<ExpenditureResponse>>
{
    public category: string;
    public date: DateRange;

    public constructor(init?: Partial<ExpenditureAdvancedSearchRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ExpenditureAdvancedSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ExpenditureResponse>(); }
}
(ExpenditureAdvancedSearchRequest as unknown)[immerable] = true;

// @Route("/expenditure/save")
export class ExpenditureSaveRequest implements IReturn<ResponseBase<ExpenditureResponse>>, ILocationId
{
    public id: number;
    public date: string;
    public description: string;
    public reference: string;
    public amountExVAT?: number;
    public vatRate?: number;
    public vatAmount?: number;
    public total?: number;
    public category: string;
    public supplierId?: number;
    public name: string;
    public locationId: number;
    public otherPaymentMethod: string;
    public chequeNumber: string;
    public cardType: string;
    public recur: RecurrenceType;
    public recurFor: number;

    public constructor(init?: Partial<ExpenditureSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExpenditureSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ExpenditureResponse>(); }
}
(ExpenditureSaveRequest as unknown)[immerable] = true;

// @Route("/expenditure/delete/{Id}")
// @Route("/expenditure/delete")
export class ExpenditureDeleteRequest implements IReturn<ResponseBase<boolean>>, ISecurityId
{
    public id: number;
    public securityId: number;

    public constructor(init?: Partial<ExpenditureDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExpenditureDeleteRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ExpenditureDeleteRequest as unknown)[immerable] = true;

// @Route("/invoice/{id}", "GET")
export class InvoicesRequest implements IReturn<ResponseBase<InvoicesResponse>>, ISecurityId
{
    public id: number;
    public securityId: number;

    public constructor(init?: Partial<InvoicesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InvoicesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<InvoicesResponse>(); }
}
(InvoicesRequest as unknown)[immerable] = true;

// @Route("/invoice", "POST")
// @Route("/invoice/{id}", "PUT")
export class InvoiceSaveRequest implements IReturn<ResponseBase<InvoicesResponse>>, ISecurityId
{
    public id: number;
    public status: string;
    public reference: string;
    public date: string;
    public dueDate: string;
    public fullyPaidDate?: string;
    public grandTotal: number;
    public amountPaid: number;
    public customerId?: number;
    public locationId: number;
    public accountId: number;
    public addressTo: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public addressLine5: string;
    public postCode: string;
    public reminder?: string;
    public secondReminder?: string;
    public totalExcludingVat: number;
    public vatAmount: number;
    public batchId?: number;
    public notes: string;
    public accountType: string;
    public accountTypeId: number;
    public securityId: number;
    public purchaseOrderNumber: string;
    public meta: { [index:string]: Object; };
    public medicalContactId?: number;
    public referralDate?: string;

    public constructor(init?: Partial<InvoiceSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InvoiceSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<InvoicesResponse>(); }
}
(InvoiceSaveRequest as unknown)[immerable] = true;

// @Route("/invoice/{id}/acknowledge", "POST")
export class ProntoInvoiceAcknowledgeRequest implements IReturn<ResponseBase<T>>, ISecurityId
{
    public id: number;
    public securityId: number;

    public constructor(init?: Partial<ProntoInvoiceAcknowledgeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProntoInvoiceAcknowledgeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(ProntoInvoiceAcknowledgeRequest as unknown)[immerable] = true;

export class ProntoInvoiceResubmitRequest implements IReturn<ResponseBase<T>>, ISecurityId
{
    public id: number;
    public templateId: string;
    public securityId: number;

    public constructor(init?: Partial<ProntoInvoiceResubmitRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProntoInvoiceResubmitRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(ProntoInvoiceResubmitRequest as unknown)[immerable] = true;

export class ProntoQueriedInvoiceEditRequest implements IReturn<ResponseBase<T>>, ISecurityId
{
    public id: number;
    public securityId: number;

    public constructor(init?: Partial<ProntoQueriedInvoiceEditRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProntoQueriedInvoiceEditRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(ProntoQueriedInvoiceEditRequest as unknown)[immerable] = true;

// @Route("/invoices/count")
export class InvoiceCountRequest implements IReturn<number>
{

    public constructor(init?: Partial<InvoiceCountRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InvoiceCountRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return 0; }
}
(InvoiceCountRequest as unknown)[immerable] = true;

// @Route("/invoice/delete/{Id}", "DELETE")
export class InvoiceDeleteRequest implements IReturn<boolean>, ILocationId, ISecurityId
{
    public id: number;
    public locationId: number;
    public securityId: number;

    public constructor(init?: Partial<InvoiceDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InvoiceDeleteRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return false; }
}
(InvoiceDeleteRequest as unknown)[immerable] = true;

// @Route("/invoice/{id}/change", "POST")
export class InvoiceChangeRequest implements IReturn<ResponseBase<boolean>>, ISecurityId
{
    public id: number;
    public type: string;
    public changeToId: number;
    public securityId: number;

    public constructor(init?: Partial<InvoiceChangeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InvoiceChangeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(InvoiceChangeRequest as unknown)[immerable] = true;

// @Route("/invoices/payments/{id}")
export class InvoicePaymentRequest implements IReturn<ResponseBase<InvoicePaymentsResponse>>, ILocationId
{
    public id: number;
    public amount?: number;
    public locationId: number;

    public constructor(init?: Partial<InvoicePaymentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InvoicePaymentRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<InvoicePaymentsResponse>(); }
}
(InvoicePaymentRequest as unknown)[immerable] = true;

// @Route("/invoice/{InvoiceId}/usePayment", "POST")
export class InvoiceUsePaymentRequest implements IReturn<ResponseBase<InvoicePaymentsResponse>>, IInvoiceId, ILocationId
{
    public invoiceId: number;
    public paymentId?: number;
    public amount?: number;
    public locationId: number;
    public emailReceipt: boolean;
    public receiptTemplate: string;
    public customerId?: number;
    public forceApply?: boolean;
    public isPaymentCreatedFromInvoice: boolean;

    public constructor(init?: Partial<InvoiceUsePaymentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InvoiceUsePaymentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<InvoicePaymentsResponse>(); }
}
(InvoiceUsePaymentRequest as unknown)[immerable] = true;

// @Route("/invoice/{InvoiceId}/useCharge")
export class InvoiceUseBillingItemRequest implements IReturn<ResponseBase<boolean>>, IInvoiceId, ILocationId
{
    public id: number;
    public invoiceId: number;
    public locationId: number;

    public constructor(init?: Partial<InvoiceUseBillingItemRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InvoiceUseBillingItemRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(InvoiceUseBillingItemRequest as unknown)[immerable] = true;

export class GetInvoiceSummaryRequest implements IReturn<ResponseBase<InvoiceSummaryResponse>>
{
    public invoiceId: number;

    public constructor(init?: Partial<GetInvoiceSummaryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInvoiceSummaryRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<InvoiceSummaryResponse>(); }
}
(GetInvoiceSummaryRequest as unknown)[immerable] = true;

export class AddBillingItemSectionRequest implements IReturn<ResponseBase<BillingItemSection>>
{
    public invoiceId: number;
    public heading: string;
    public sequenceNo: number;
    public lineItems: LineItemResponse[];

    public constructor(init?: Partial<AddBillingItemSectionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddBillingItemSectionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<BillingItemSection>(); }
}
(AddBillingItemSectionRequest as unknown)[immerable] = true;

export class UpdateBillingItemSectionRequest extends BillingItemSection implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<UpdateBillingItemSectionRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateBillingItemSectionRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(UpdateBillingItemSectionRequest as unknown)[immerable] = true;

export class DeleteBillingItemSectionRequest extends BillingItemSection implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<DeleteBillingItemSectionRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteBillingItemSectionRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(DeleteBillingItemSectionRequest as unknown)[immerable] = true;

export class GetBillingItemSectionRequest extends BillingItemSection implements IReturn<ResponseBase<BillingItemSection>>
{

    public constructor(init?: Partial<GetBillingItemSectionRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetBillingItemSectionRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<BillingItemSection>(); }
}
(GetBillingItemSectionRequest as unknown)[immerable] = true;

export class GetAllBillingItemSectionsByInvoiceIdRequest implements IReturn<ResponseBase<BillingItemSection>>
{
    public invoiceId: number;

    public constructor(init?: Partial<GetAllBillingItemSectionsByInvoiceIdRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAllBillingItemSectionsByInvoiceIdRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<BillingItemSection>(); }
}
(GetAllBillingItemSectionsByInvoiceIdRequest as unknown)[immerable] = true;

export class GetAllPaymentsByInvoiceIdRequest implements IReturn<ResponseBase<PaymentReconciliation[]>>
{
    public invoiceId: number;

    public constructor(init?: Partial<GetAllPaymentsByInvoiceIdRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAllPaymentsByInvoiceIdRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<PaymentReconciliation[]>(); }
}
(GetAllPaymentsByInvoiceIdRequest as unknown)[immerable] = true;

// @Route("/invoice/{InvoiceId}/removeReconcilitation/{Id}")
export class InvoiceRemoveReconciliationRequest implements IReturn<ResponseBase<boolean>>, IInvoiceId, ILocationId
{
    public id: number;
    public invoiceId: number;
    public locationId: number;

    public constructor(init?: Partial<InvoiceRemoveReconciliationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InvoiceRemoveReconciliationRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(InvoiceRemoveReconciliationRequest as unknown)[immerable] = true;

// @Route("/invoice/{InvoiceId}/removeCharge/{Id}")
export class InvoiceRemoveChargeRequest implements IReturn<ResponseBase<boolean>>, IInvoiceId, ISecurityId
{
    public id: number;
    public invoiceId: number;
    public securityId: number;

    public constructor(init?: Partial<InvoiceRemoveChargeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InvoiceRemoveChargeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(InvoiceRemoveChargeRequest as unknown)[immerable] = true;

// @Route("/invoice/{InvoiceId}/deletePayment/{Id}")
export class InvoiceDeletePaymentRequest implements IReturn<ResponseBase<boolean>>, IInvoiceId, ISecurityId
{
    public id: number;
    public invoiceId: number;
    public securityId: number;

    public constructor(init?: Partial<InvoiceDeletePaymentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InvoiceDeletePaymentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(InvoiceDeletePaymentRequest as unknown)[immerable] = true;

// @Route("/invoice/removeAllReconciliations/{InvoiceId}")
export class InvoiceRemoveAllReconciliationsRequest implements IReturn<ResponseBase<boolean>>, IInvoiceId, ISecurityId
{
    public invoiceId: number;
    public securityId: number;

    public constructor(init?: Partial<InvoiceRemoveAllReconciliationsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InvoiceRemoveAllReconciliationsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(InvoiceRemoveAllReconciliationsRequest as unknown)[immerable] = true;

// @Route("/invoice/{InvoiceId}/createCharges")
export class CreateChargesRequest implements IReturn<ResponseBase<TransactionResponse>>, IInvoiceId, ILocationId
{
    public charges: Charge[];
    public invoiceId: number;
    public locationId: number;

    public constructor(init?: Partial<CreateChargesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateChargesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TransactionResponse>(); }
}
(CreateChargesRequest as unknown)[immerable] = true;

// @Route("/invoice/{InvoiceId}/createCharge")
export class CreateChargeRequest implements IReturn<ResponseBase<TransactionResponse>>, IInvoiceId, ILocationId
{
    public charge: Charge;
    public invoiceId: number;
    public locationId: number;

    public constructor(init?: Partial<CreateChargeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateChargeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TransactionResponse>(); }
}
(CreateChargeRequest as unknown)[immerable] = true;

export class AddChargeToInvoice implements IReturn<ResponseBase<TransactionResponse>>, IInvoiceId, ILocationId
{
    public charge: Charge;
    public invoiceId: number;
    public locationId: number;

    public constructor(init?: Partial<AddChargeToInvoice>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddChargeToInvoice'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TransactionResponse>(); }
}
(AddChargeToInvoice as unknown)[immerable] = true;

// @Route("/invoice/search")
export class InvoicesAdvancedSearchRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<InvoicesResponse>>
{
    public reference: string;
    public addressTo: string;
    public date: DateRange;
    public dueDate: DateRange;
    public amount: CurrencyRange;
    public locked: boolean;
    public status: string;
    public batchId?: number;
    public accountId?: number;
    public customerId?: number;
    public accountType: string;
    public registrationNumber: string;

    public constructor(init?: Partial<InvoicesAdvancedSearchRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'InvoicesAdvancedSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<InvoicesResponse>(); }
}
(InvoicesAdvancedSearchRequest as unknown)[immerable] = true;

// @Route("/invoice/batch")
export class InvoiceBatchRequest implements IReturn<ResponseBase<InvoiceBatchResponse>>, ILocationId
{
    public id: number;
    public locationId: number;

    public constructor(init?: Partial<InvoiceBatchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InvoiceBatchRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<InvoiceBatchResponse>(); }
}
(InvoiceBatchRequest as unknown)[immerable] = true;

// @Route("/groups/account")
// @Route("/groups/account/{GroupId}")
export class GroupsAccountSearchRequest implements IReturn<ResponseBase<GroupsAccountSearchResponse>>, ILocationId
{
    public skip: number;
    public take: number;
    public groupId: number;
    public customerId: number;
    public date: DateRange;
    public sort: QueryField[];
    public locationId: number;

    public constructor(init?: Partial<GroupsAccountSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupsAccountSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GroupsAccountSearchResponse>(); }
}
(GroupsAccountSearchRequest as unknown)[immerable] = true;

// @Route("/groups/billing")
// @Route("/groups/billing/{GroupId}")
export class GroupsBillingItemSearchRequest implements IReturn<ResponseBase<GroupBillingItemsResponse>>, ILocationId
{
    public skip: number;
    public take: number;
    public groupId: number;
    public sort: QueryField[];
    public locationId: number;

    public constructor(init?: Partial<GroupsBillingItemSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupsBillingItemSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GroupBillingItemsResponse>(); }
}
(GroupsBillingItemSearchRequest as unknown)[immerable] = true;

// @Route("/invoice/{InvoiceId}/deleteBillingItem/{Id}")
// @Route("/billingItem/delete/{Id}")
export class BillingItemDeleteRequest implements IReturn<ResponseBase<boolean>>, ILocationId, ISecurityId
{
    public id: number;
    public locationId: number;
    public securityId: number;

    public constructor(init?: Partial<BillingItemDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BillingItemDeleteRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(BillingItemDeleteRequest as unknown)[immerable] = true;

export class GetInvoiceLineItemsRequest implements IReturn<ResponseBase<LineItemResponse[]>>
{
    public invoiceId: number;

    public constructor(init?: Partial<GetInvoiceLineItemsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInvoiceLineItemsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<LineItemResponse[]>(); }
}
(GetInvoiceLineItemsRequest as unknown)[immerable] = true;

export class DeleteInvoiceLineItemRequest implements IReturn<ResponseBase<boolean>>
{
    public invoiceId: number;
    public id: number;

    public constructor(init?: Partial<DeleteInvoiceLineItemRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteInvoiceLineItemRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(DeleteInvoiceLineItemRequest as unknown)[immerable] = true;

export class DeleteInvoiceLineItemSectionRequest implements IReturn<ResponseBase<boolean>>
{
    public invoiceId: number;
    public sectionId: number;

    public constructor(init?: Partial<DeleteInvoiceLineItemSectionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteInvoiceLineItemSectionRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(DeleteInvoiceLineItemSectionRequest as unknown)[immerable] = true;

export class MoveInvoiceLineItemRequest implements IReturn<ResponseBase<boolean>>
{
    public invoiceId: number;
    public sequenceNo: number;
    public newSequenceNo: number;

    public constructor(init?: Partial<MoveInvoiceLineItemRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MoveInvoiceLineItemRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(MoveInvoiceLineItemRequest as unknown)[immerable] = true;

export class AddSectionRequest implements IReturn<ResponseBase<boolean>>
{
    public invoiceId: number;
    public insertAtSequenceNo: number;
    public sectionName: string;

    public constructor(init?: Partial<AddSectionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddSectionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(AddSectionRequest as unknown)[immerable] = true;

export class MoveInvoiceLineItemSectionRequest implements IReturn<ResponseBase<boolean>>
{
    public invoiceId: number;
    public sectionId: number;
    public newIndex: number;
    public currentIndex: number;

    public constructor(init?: Partial<MoveInvoiceLineItemSectionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MoveInvoiceLineItemSectionRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(MoveInvoiceLineItemSectionRequest as unknown)[immerable] = true;

// @Route("/invoice/{InvoiceId}/transactions")
export class TransactionRequest implements IReturn<ResponseBase<TransactionResponse>>, IInvoiceId, ISecurityId
{
    public invoiceId: number;
    public securityId: number;

    public constructor(init?: Partial<TransactionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TransactionRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<TransactionResponse>(); }
}
(TransactionRequest as unknown)[immerable] = true;

// @Route("/invoice/medipass/{InvoiceId}")
export class InvoiceMedipassRequest implements IReturn<ResponseBase<{ [index:string]: Object; }>>, IInvoiceId, ISecurityId
{
    public invoiceId: number;
    public securityId: number;

    public constructor(init?: Partial<InvoiceMedipassRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InvoiceMedipassRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<{ [index:string]: Object; }>(); }
}
(InvoiceMedipassRequest as unknown)[immerable] = true;

// @Route("/invoice/transfer")
export class TransferRequest implements IReturn<TransferResponse>, IInvoiceId, ISecurityId
{
    public invoice: Invoice;
    public item: Charge;
    public newInvoice: boolean;
    public useCredit: boolean;
    public invoiceId: number;
    public securityId: number;

    public constructor(init?: Partial<TransferRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TransferRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TransferResponse(); }
}
(TransferRequest as unknown)[immerable] = true;

export class ClickInvoiceUseChargesRequest implements IReturn<ResponseBase<boolean>>, ILocationId
{
    public chargeIds: number[];
    public invoiceId: number;
    public locationId: number;

    public constructor(init?: Partial<ClickInvoiceUseChargesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickInvoiceUseChargesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ClickInvoiceUseChargesRequest as unknown)[immerable] = true;

// @Route("/payment/{Id}", "GET")
export class GetPaymentRequest implements IReturn<ResponseBase<PaymentDetailsResponse>>, ISecurityId
{
    public id: number;
    public securityId: number;

    public constructor(init?: Partial<GetPaymentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPaymentRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<PaymentDetailsResponse>(); }
}
(GetPaymentRequest as unknown)[immerable] = true;

// @Route("/payments/count")
export class PaymentCountRequest implements IReturn<number>
{

    public constructor(init?: Partial<PaymentCountRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PaymentCountRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return 0; }
}
(PaymentCountRequest as unknown)[immerable] = true;

export class UnlinkAppointmentFromPaymentRequest implements IReturn<boolean>, ISecurityId
{
    public id: number;
    public securityId: number;

    public constructor(init?: Partial<UnlinkAppointmentFromPaymentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UnlinkAppointmentFromPaymentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return false; }
}
(UnlinkAppointmentFromPaymentRequest as unknown)[immerable] = true;

// @Route("/payment", "POST")
export class CreatePaymentRequest extends Income implements IReturn<number>
{
    public emailReceipt: boolean;
    public receiptTemplate: string;
    public isPaymentCreatedFromInvoice: boolean;

    public constructor(init?: Partial<CreatePaymentRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CreatePaymentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return 0; }
}
(CreatePaymentRequest as unknown)[immerable] = true;

// @Route("/payment/{Id}", "PUT")
export class SavePaymentRequest extends Income implements IReturn<ResponseBase<PaymentResponse>>
{

    public constructor(init?: Partial<SavePaymentRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SavePaymentRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<PaymentResponse>(); }
}
(SavePaymentRequest as unknown)[immerable] = true;

// @Route("/payment/{Id}", "DELETE")
export class DeletePaymentRequest implements IReturn<boolean>, ISecurityId
{
    public id: number;
    public securityId: number;

    public constructor(init?: Partial<DeletePaymentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeletePaymentRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return false; }
}
(DeletePaymentRequest as unknown)[immerable] = true;

export class VoidPaymentRequest implements IReturn<boolean>, ISecurityId
{
    public id: number;
    public securityId: number;

    public constructor(init?: Partial<VoidPaymentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VoidPaymentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return false; }
}
(VoidPaymentRequest as unknown)[immerable] = true;

// @Route("/payment/{Id}/refund", "POST")
export class PaymentRefundRequest extends Income implements IReturn<ResponseBase<PaymentResponse>>
{
    public paymentId: number;
    public unreconcile: boolean;

    public constructor(init?: Partial<PaymentRefundRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'PaymentRefundRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<PaymentResponse>(); }
}
(PaymentRefundRequest as unknown)[immerable] = true;

// @Route("/payment/{Id}/reconcile", "POST")
export class PaymentReconciliationRequest implements IReturn<ResponseBase<ReconciliationResponse>>, ISecurityId
{
    public id: number;
    public securityId: number;
    public reconciliations: ReconciliationResponse[];

    public constructor(init?: Partial<PaymentReconciliationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PaymentReconciliationRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ReconciliationResponse>(); }
}
(PaymentReconciliationRequest as unknown)[immerable] = true;

// @Route("/payment/search")
export class PaymentAdvancedSearchRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<PaymentResponse>>
{
    public reference: string;
    public paymentMethod: string;
    public lodgementReference: string;
    public status: string;
    public refunds: boolean;
    public amount: CurrencyRange;
    public date: DateRange;
    public receivedAtLocationIds: number[];
    public locked: boolean;
    public accountId?: number;

    public constructor(init?: Partial<PaymentAdvancedSearchRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'PaymentAdvancedSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<PaymentResponse>(); }
}
(PaymentAdvancedSearchRequest as unknown)[immerable] = true;

// @Route("/appointment/cancellationreason")
export class CancellationReasonRequest implements IReturn<ResponseBase<CancellationReasonResponse>>, ISecurityId
{
    public appointmentId: number;
    public securityId: number;
    public reason: string;
    public deleteCase: boolean;
    public updateAuths: boolean;

    public constructor(init?: Partial<CancellationReasonRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CancellationReasonRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CancellationReasonResponse>(); }
}
(CancellationReasonRequest as unknown)[immerable] = true;

// @Route("/quickbill/{Id}/{Mode}")
// @Route("/quickbill/{Id}/{Mode}/{Status}")
// @Route("/quickbill/{Id}/{Mode}/Pronto/{BookingAuditId}")
export class QuickBillRequest implements IReturn<ResponseEnhancerBase<QuickBillResponse>>
{
    public id: number;
    public mode: QuickBillMode;
    public status?: number;
    public billToPatient: boolean;
    public bookingAuditId?: string;

    public constructor(init?: Partial<QuickBillRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuickBillRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseEnhancerBase<QuickBillResponse>(); }
}
(QuickBillRequest as unknown)[immerable] = true;

// @Route("/quickbill/medipass")
export class QuickBillMedipassRequest implements IReturn<ResponseBase<QuickbillMedipassResponse>>, ILocationId, ICustomerId
{
    public customerId: number;
    public locationId: number;
    public appointmentId: number;
    public groupInvoiceId: number;
    public amount: number;

    public constructor(init?: Partial<QuickBillMedipassRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuickBillMedipassRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<QuickbillMedipassResponse>(); }
}
(QuickBillMedipassRequest as unknown)[immerable] = true;

// @Route("/quickbill/prepaid")
export class QuickBillPrePaidRequest implements IReturn<ResponseBase<AppointmentPrePaidResponse>>, ILocationIds, ICustomerId
{
    public id: number;
    public securityId: number;
    public appointmentStatus?: number;
    public appointmentId?: number;
    public customerId: number;
    public deleteCase: boolean;
    public creditFee: number;
    public locationIds: number[];
    public requestLocationIds: number[];
    public prePaidType: EPrePaidType;

    public constructor(init?: Partial<QuickBillPrePaidRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuickBillPrePaidRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AppointmentPrePaidResponse>(); }
}
(QuickBillPrePaidRequest as unknown)[immerable] = true;

// @Route("/quickpay")
export class QuickPayRequest implements IReturn<ResponseBase<QuickBillCompleteResponse>>, ISecurityId
{
    public id: number;
    public securityId: number;
    public payments: QuickPayment[];
    public invoices: Invoice[];
    public billingItems: BillingItem[];
    public discounts: ValidateDiscountCodeResponse[];
    public appointmentStatus?: number;
    public appointmentId?: number;
    public deleteCase: boolean;
    public reminderSent: boolean;
    public cardToken: string;
    public isMyClinicIntegration: boolean;
    public locationId: number;
    public furtherPaymentsAfterUsingPrepaid: boolean;
    public emailInvoice: boolean;
    public emailReceipt: boolean;
    public quickBillMode: QuickBillMode;

    public constructor(init?: Partial<QuickPayRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuickPayRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<QuickBillCompleteResponse>(); }
}
(QuickPayRequest as unknown)[immerable] = true;

// @Route("/files/", "DELETE")
// @Route("/delete", "POST")
// @DataContract
export class DeleteRequest implements IReturn<DeleteResponse>, IHasPath
{
    // @DataMember(Order=1)
    public path: string;

    // @DataMember(Order=2)
    public isGlobal: boolean;

    public constructor(init?: Partial<DeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new DeleteResponse(); }
}
(DeleteRequest as unknown)[immerable] = true;

// @Route("/communications/copy")
// @Route("/copy")
// @DataContract
export class CopyRequest implements IReturn<CopyResponse>, IHasPath, IHasNewPath, IPost
{
    // @DataMember(Order=1)
    public path: string;

    // @DataMember(Order=2)
    public newName: string;

    // @DataMember(Order=3)
    public moveFilesIfExists: boolean;

    // @DataMember(Order=4)
    public isGlobal: boolean;

    public constructor(init?: Partial<CopyRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CopyRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CopyResponse(); }
}
(CopyRequest as unknown)[immerable] = true;

// @Route("/createFolder")
// @DataContract
export class CreateFolderRequest implements IReturn<CreateFolderResponse>, IHasPath, IHasNewPath
{
    // @DataMember(Order=1)
    public path: string;

    // @DataMember(Order=2)
    public newName: string;

    public constructor(init?: Partial<CreateFolderRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateFolderRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateFolderResponse(); }
}
(CreateFolderRequest as unknown)[immerable] = true;

// @Route("/communications/rename")
// @Route("/rename")
// @DataContract
export class RenameRequest implements IReturn<RenameResponse>, IHasNewPath, IHasPath
{
    // @DataMember(Order=1)
    public path: string;

    // @DataMember(Order=2)
    public newName: string;

    // @DataMember(Order=3)
    public overwrite: boolean;

    // @DataMember(Order=4)
    public isGlobal: boolean;

    public constructor(init?: Partial<RenameRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RenameRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RenameResponse(); }
}
(RenameRequest as unknown)[immerable] = true;

// @Route("/move")
// @DataContract
export class MoveRequest implements IReturn<MoveResponse>, IHasPath, IHasNewPath
{
    // @DataMember(Order=1)
    public path: string;

    // @DataMember(Order=2)
    public newName: string;

    public constructor(init?: Partial<MoveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MoveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MoveResponse(); }
}
(MoveRequest as unknown)[immerable] = true;

// @Route("/folder/move")
// @DataContract
export class MoveFolderRequest implements IReturn<MoveResponse>, IHasPath, IHasNewPath
{
    // @DataMember(Order=1)
    public path: string;

    // @DataMember(Order=2)
    public newName: string;

    // @DataMember(Order=3)
    public isFolder: boolean;

    public constructor(init?: Partial<MoveFolderRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MoveFolderRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MoveResponse(); }
}
(MoveFolderRequest as unknown)[immerable] = true;

// @Route("/file", "POST")
// @DataContract
export class UploadFile implements IReturn<UploadResult>, IHasPath, ISecurityType, ISecurityId
{
    // @DataMember(Order=1)
    public path: string;

    // @DataMember(Order=2)
    public safeRoot: string;

    // @DataMember(Order=3)
    public httpRequest: IHttpRequest;

    // @DataMember(Order=4)
    public id: number;

    // @DataMember(Order=5)
    public mode: string;

    public constructor(init?: Partial<UploadFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UploadFile'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UploadResult(); }
}
(UploadFile as unknown)[immerable] = true;

// @Route("/tempfile", "POST")
// @DataContract
export class UploadTempFile implements IReturn<UploadTempResult>
{
    // @DataMember(Order=1)
    public id: string;

    public constructor(init?: Partial<UploadTempFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UploadTempFile'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UploadTempResult(); }
}
(UploadTempFile as unknown)[immerable] = true;

export class PublishTempFolder implements IReturn<Object>
{
    // @DataMember(Order=1)
    public folderId: string;

    // @DataMember(Order=2)
    public subWorkflowId: number;

    // @DataMember(Order=3)
    public workflowId: number;

    // @DataMember(Order=4)
    public publishToReferralPortal: boolean;

    public constructor(init?: Partial<PublishTempFolder>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PublishTempFolder'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Object(); }
}
(PublishTempFolder as unknown)[immerable] = true;

// @Route("/attachments/summary", "POST")
export class AttachmentSummaryRequest implements IReturn<AttachmentSummaryResponse>
{
    public mode: string;
    public onlyReturnTemplates: boolean;
    public id?: number;

    public constructor(init?: Partial<AttachmentSummaryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AttachmentSummaryRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AttachmentSummaryResponse(); }
}
(AttachmentSummaryRequest as unknown)[immerable] = true;

// @Route("/attachments/upload", "POST")
// @DataContract
export class AttachmentUploadRequest implements IReturn<UploadResult>, IHasPath
{
    // @DataMember(Order=1)
    public path: string;

    // @DataMember(Order=2)
    public safeRoot: string;

    // @DataMember(Order=3)
    public httpRequest: IHttpRequest;

    // @DataMember(Order=4)
    public id: number;

    // @DataMember(Order=5)
    public mode: string;

    // @DataMember(Order=6)
    public targetFolder: string;

    // @DataMember(Order=7)
    public maxWidth?: number;

    // @DataMember(Order=8)
    public maxHeight?: number;

    // @DataMember(Order=9)
    public forcedName?: string;

    public constructor(init?: Partial<AttachmentUploadRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AttachmentUploadRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UploadResult(); }
}
(AttachmentUploadRequest as unknown)[immerable] = true;

// @Route("/files/bypath/{Path*}", "GET, POST")
export class FileByPathRequest implements IReturn<HttpResult>, IHasPath
{
    public path: string;
    public isGlobal: boolean;
    public safeRoot: string;

    public constructor(init?: Partial<FileByPathRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FileByPathRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new HttpResult(); }
}
(FileByPathRequest as unknown)[immerable] = true;

// @Route("/file/recent", "GET")
// @DataContract
export class RecentFileRequest implements IReturn<RecentFileResponse>, IHasPath
{
    // @DataMember(Order=1)
    public path: string;

    // @DataMember(Order=2)
    public safeRoot: string;

    public constructor(init?: Partial<RecentFileRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RecentFileRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RecentFileResponse(); }
}
(RecentFileRequest as unknown)[immerable] = true;

// @Route("/files/listing", "POST")
export class UrlLessFileListing implements IReturn<FilesListingResponse>, IHasPath
{
    public safeRoot: string;
    // @DataMember(Order=1)
    public path: string;

    // @DataMember(Order=2)
    public recursive: boolean;

    public constructor(init?: Partial<UrlLessFileListing>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UrlLessFileListing'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FilesListingResponse(); }
}
(UrlLessFileListing as unknown)[immerable] = true;

// @Route("/file/get", "POST")
// @DataContract
export class UrlLessFileRequest implements IReturn<FileResponse>, IHasPath
{
    // @DataMember(Order=1)
    public path: string;

    // @DataMember(Order=2)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=3)
    public textMode: boolean;

    public constructor(init?: Partial<UrlLessFileRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UrlLessFileRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FileResponse(); }
}
(UrlLessFileRequest as unknown)[immerable] = true;

// @Route("/communications/letter")
// @Route("/files/{Path*}")
// @Route("/files")
// @DataContract
export class FileListing implements IReturn<FilesListingResponse>, IHasPath
{
    // @DataMember(Order=1)
    public path: string;

    // @DataMember(Order=2)
    public recursive: boolean;

    // @DataMember(Order=3)
    public createDirectoryIfNotExists: boolean;

    // @DataMember(Order=4)
    public foldersToIgnore: string;

    public constructor(init?: Partial<FileListing>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FileListing'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FilesListingResponse(); }
}
(FileListing as unknown)[immerable] = true;

// @Route("/tempfilelisting/{Id}", "POST")
export class GetTempFileListing implements IReturn<FilesListingResponse>
{
    public id: string;

    public constructor(init?: Partial<GetTempFileListing>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTempFileListing'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FilesListingResponse(); }
}
(GetTempFileListing as unknown)[immerable] = true;

// @Route("/removetempfile/{Id}/{FileName}", "POST")
export class RemoveTempFile
{
    public id: string;
    public fileName: string;

    public constructor(init?: Partial<RemoveTempFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RemoveTempFile'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(RemoveTempFile as unknown)[immerable] = true;

// @Route("/file", "GET")
// @Route("/file/{Path*}", "GET")
// @DataContract
export class FileRequest implements IReturn<FileResponse>, IHasPath
{
    // @DataMember(Order=1)
    public path: string;

    // @DataMember(Order=2)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=3)
    public textMode: boolean;

    // @DataMember(Order=4)
    public isGlobal: boolean;

    public constructor(init?: Partial<FileRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FileRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FileResponse(); }
}
(FileRequest as unknown)[immerable] = true;

// @Route("/download/{Path*}", "GET")
// @DataContract
export class DownloadFileRequest implements IHasPath, IGet
{
    // @DataMember(Order=1)
    public path: string;

    // @DataMember(Order=2)
    public isGlobal: boolean;

    public constructor(init?: Partial<DownloadFileRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadFileRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(DownloadFileRequest as unknown)[immerable] = true;

// @Route("/extractiondownload/{Path*}", "GET")
// @Route("/download/{Path*}", "GET")
// @DataContract
export class DownloadExtractionFileRequest extends DownloadFileRequest
{

    public constructor(init?: Partial<DownloadExtractionFileRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadExtractionFileRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(DownloadExtractionFileRequest as unknown)[immerable] = true;

// @Route("/file/view/{Path*}", "HEAD, GET")
// @DataContract
export class ViewFileRequest implements IHasPath
{
    // @DataMember(Order=1)
    public path: string;

    // @DataMember(Order=2)
    public isGlobal: boolean;

    public constructor(init?: Partial<ViewFileRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ViewFileRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(ViewFileRequest as unknown)[immerable] = true;

// @Route("/download/batch")
// @DataContract
export class DownloadBatchFileRequest implements IHasPaths
{
    // @DataMember(Order=1)
    public paths: DownloadBatchRequestObject[];

    // @DataMember(Order=2)
    public isGlobal: boolean;

    public constructor(init?: Partial<DownloadBatchFileRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadBatchFileRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(DownloadBatchFileRequest as unknown)[immerable] = true;

// @Route("/email/download/{Path*}", "GET")
// @DataContract
export class DownloadEmailRequest implements IHasPath
{
    // @DataMember(Order=1)
    public path: string;

    public constructor(init?: Partial<DownloadEmailRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadEmailRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(DownloadEmailRequest as unknown)[immerable] = true;

// @Route("/email/attachment/{Path*}", "GET")
export class DownloadAttachmentRequest implements IHasPath
{
    public path: string;
    public safeRoot: string;
    public attachmentName: string;

    public constructor(init?: Partial<DownloadAttachmentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadAttachmentRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(DownloadAttachmentRequest as unknown)[immerable] = true;

// @Route("/communications/documents/save", "POST")
// @DataContract
export class SaveDocument implements IReturn<Object>, IHasPath, ISecurityId, ISecurityType
{
    // @DataMember(Order=1)
    public text: string;

    // @DataMember(Order=2)
    public path: string;

    // @DataMember(Order=3)
    public action: string;

    // @DataMember(Order=4)
    public letterId: number;

    // @DataMember(Order=5)
    public title: string;

    // @DataMember(Order=6)
    public type: DocumentType;

    // @DataMember(Order=7)
    public rename: boolean;

    // @DataMember(Order=8)
    public oldPath: string;

    // @DataMember(Order=9)
    public objectId: number;

    // @DataMember(Order=10)
    public objectType: string;

    // @DataMember(Order=11)
    public bytes: string;

    // @DataMember(Order=12)
    public updatePatientLog: boolean;

    // @DataMember(Order=13)
    public consultationDate?: string;

    public constructor(init?: Partial<SaveDocument>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveDocument'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Object(); }
}
(SaveDocument as unknown)[immerable] = true;

// @Route("/managementreportfiles/{Id}")
export class ManagementReportDocumentFileListing implements IReturn<FolderTree>, ISecurityId, IGet
{
    public id: number;
    public securityId: number;

    public constructor(init?: Partial<ManagementReportDocumentFileListing>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ManagementReportDocumentFileListing'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FolderTree(); }
}
(ManagementReportDocumentFileListing as unknown)[immerable] = true;

// @Route("/{Mode}/files/{Id}")
// @Route("/{Mode}/files/{Id}/{ExcludedFileTypes}")
// @Route("/{Mode}/files/{Id}/{ExcludedFileTypes}/{FoldersToIgnore}")
// @Route("/{Mode}/files/{Id}/{ExcludedFileTypes}/{FoldersToIgnore}/{Recursive}")
// @Route("/{Mode}/files/{Id}/{ExcludedFileTypes}/{FoldersToIgnore}/{Recursive}/{IgnoreFiles}")
export class DocumentFileListing implements IReturn<FolderTree>, ISecurityId, ISecurityType, IGet
{
    public id: number;
    public mode: string;
    public excludedFileTypes: string;
    public foldersToIgnore: string;
    public recursive: boolean;
    public ignoreFiles: boolean;
    public path: string;
    public skip?: number;
    public take?: number;
    public sort: QueryField[];
    public securityId: number;
    public securityType: string;
    public ignoreFolders: boolean;

    public constructor(init?: Partial<DocumentFileListing>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DocumentFileListing'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FolderTree(); }
}
(DocumentFileListing as unknown)[immerable] = true;

// @Route("/templates")
export class TemplatesRequest implements IReturn<FolderTree>
{
    public folder: string;
    public filter: string[];
    public sortedByDate?: boolean;

    public constructor(init?: Partial<TemplatesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemplatesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FolderTree(); }
}
(TemplatesRequest as unknown)[immerable] = true;

// @Route("/charts")
export class ChartsRequest implements IReturn<FolderTree>
{
    public folder: string;
    public filter: string[];

    public constructor(init?: Partial<ChartsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ChartsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FolderTree(); }
}
(ChartsRequest as unknown)[immerable] = true;

// @Route("/download/extraction/{Id}", "GET")
export class DownloadExtractionRequest
{
    public id: number;

    public constructor(init?: Partial<DownloadExtractionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadExtractionRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(DownloadExtractionRequest as unknown)[immerable] = true;

export class UpdateDocumentListingRequest
{
    public fileName: string;
    public filePath: string;
    public description: string;

    public constructor(init?: Partial<UpdateDocumentListingRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateDocumentListingRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(UpdateDocumentListingRequest as unknown)[immerable] = true;

// @Route("/groups/locations/updateProviderNumber")
export class GroupLocationProviderNumberSaveRequest implements ISecurityId
{
    public providerNo: string;
    public id: number;
    public securityId: number;

    public constructor(init?: Partial<GroupLocationProviderNumberSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupLocationProviderNumberSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(GroupLocationProviderNumberSaveRequest as unknown)[immerable] = true;

// @Route("/groups")
// @Route("/groups/{Id}")
export class GroupRequest implements IReturn<ResponseBase<GroupResponse>>, ISecurityId
{
    public skip: number;
    public take: number;
    public id: number;
    public securityId: number;

    public constructor(init?: Partial<GroupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GroupResponse>(); }
}
(GroupRequest as unknown)[immerable] = true;

// @Route("/groups/count")
export class GroupCountRequest implements IReturn<ResponseBase<number>>
{

    public constructor(init?: Partial<GroupCountRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupCountRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<number>(); }
}
(GroupCountRequest as unknown)[immerable] = true;

// @Route("/group/further/{Id}")
export class GroupFurtherDetailsRequest implements IReturn<GroupFurtherDetailsResponse>, ILocationId
{
    public id: number;
    public locationId: number;

    public constructor(init?: Partial<GroupFurtherDetailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupFurtherDetailsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GroupFurtherDetailsResponse(); }
}
(GroupFurtherDetailsRequest as unknown)[immerable] = true;

// @Route("/group/recent/{Id}")
export class GroupRecentRequest implements IReturn<GroupRecentResponse>, ILocationId
{
    public id: number;
    public locationId: number;

    public constructor(init?: Partial<GroupRecentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupRecentRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GroupRecentResponse(); }
}
(GroupRecentRequest as unknown)[immerable] = true;

// @Route("/group/recentDocument/{GroupId}")
export class RecentGroupDocumentRequest implements IReturn<Object>, IHasPath, ILocationId
{
    public groupId: number;
    public path: string;
    public safeRoot: string;
    public locationId: number;

    public constructor(init?: Partial<RecentGroupDocumentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RecentGroupDocumentRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Object(); }
}
(RecentGroupDocumentRequest as unknown)[immerable] = true;

// @Route("/groups/search")
export class GroupsAdvancedSearchRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<GroupResponse>>
{
    public name: string;
    public status?: boolean;
    public classification: string;

    public constructor(init?: Partial<GroupsAdvancedSearchRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupsAdvancedSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GroupResponse>(); }
}
(GroupsAdvancedSearchRequest as unknown)[immerable] = true;

// @Route("/groups/export/csv")
export class GroupsAdvancedSearchExportCSVRequest implements IReturn<string>, ILocationIds
{
    public customHeaders: GroupsCSVHeaderOverrides;
    public query: GroupsAdvancedSearchRequest;
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<GroupsAdvancedSearchExportCSVRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupsAdvancedSearchExportCSVRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return ''; }
}
(GroupsAdvancedSearchExportCSVRequest as unknown)[immerable] = true;

// @Route("/group/contacts/search")
// @Route("/group/contacts/search/{GroupId}")
export class GroupContactsSearchRequest implements IReturn<ResponseBase<MedicalContactResponse>>, ILocationId
{
    public groupId: number;
    public locationId: number;

    public constructor(init?: Partial<GroupContactsSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupContactsSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<MedicalContactResponse>(); }
}
(GroupContactsSearchRequest as unknown)[immerable] = true;

// @Route("/group/contactsearch", "POST")
// @Route("/group/contactsearch/{GroupId}", "POST")
export class GroupContactQuickSearchRequest implements IReturn<ResponseBase<MedicalContactResponse>>, ISecurityId
{
    public skip: number;
    public take: number;
    public groupId: number;
    public securityId: number;
    public searchString: string;

    public constructor(init?: Partial<GroupContactQuickSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupContactQuickSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<MedicalContactResponse>(); }
}
(GroupContactQuickSearchRequest as unknown)[immerable] = true;

// @Route("/group/linked/{GroupId}", "POST")
// @Route("/group/linked", "POST")
export class LinkedPatientRequest implements IReturn<ResponseBase<GeneralCustomerResponse>>, ISecurityId, IFilterServiceTypeManually
{
    public groupId: number;
    public skip: number;
    public take: number;
    public sort: QueryField[];
    public securityId: number;

    public constructor(init?: Partial<LinkedPatientRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LinkedPatientRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GeneralCustomerResponse>(); }
}
(LinkedPatientRequest as unknown)[immerable] = true;

// @Route("/group/save", "POST")
export class SaveGroupRequest implements IReturn<ResponseBase<GroupResponse>>
{
    public id: number;
    public name: string;
    public contact: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public addressLine5: string;
    public address: string;
    public postCode: string;
    public telephone: string;
    public fax: string;
    public web: string;
    public email: string;
    public locationName: string;
    public locationId?: number;
    public balanceOwed?: number;
    public showReferrals: boolean;
    public groupInvoices: string;
    public addressTo: string;
    public invoicePeriod: string;
    public contractNumber: string;
    public accountCode: string;
    public accountId: number;
    public profileId: number;
    public invoiceFrequency?: number;
    public invoiceWPID?: number;
    public showVAT?: boolean;
    public authorisationCode: string;
    public defaultMaxTreatments?: number;
    public classification: string;
    public cancellationHours: number;
    public paysForDNA: boolean;
    public paysForCancel: boolean;
    public notificationEmail: string;
    public abbreviationPrefix: string;
    public online?: boolean;
    public firstId: number;
    public followUpId: number;
    public cancelId: number;
    public dnaId: number;
    public tm3InvoiceTemplate: string;
    public meta: { [index:string]: Object; };
    public dueDaysOverride?: number;
    public isDistributor: boolean;
    public distributorGroupId?: number;
    public groupInvoiceByStockId: boolean;
    public useInvoicePaymentTerms: boolean;
    public invoicePaymentTerms: string;
    public onlineGuid: string;
    public billDistributor: boolean;
    public minorUpperAgeLimit?: number;
    public adolescentUpperAgeLimit?: number;
    public medipassFunder: string;
    public medipassFunderCode: string;
    public isVatExempt: boolean;
    public financialAddress: string;
    public vatExemptionNumber: string;
    public vatExemptionExpiryDate?: string;
    public allowedEmails: string;
    public authorisationExpiryInDays?: number;
    public authorisationExpiryTriggerInDays?: number;
    public remainingAuthorisationThreshold?: number;

    public constructor(init?: Partial<SaveGroupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveGroupRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GroupResponse>(); }
}
(SaveGroupRequest as unknown)[immerable] = true;

// @Route("/group/location/search")
// @Route("/group/location/search/{GroupId}")
export class GroupLocationSearchRequest implements IReturn<LocationStockResponse>, ILocationId
{
    public groupId: number;
    public locationId: number;

    public constructor(init?: Partial<GroupLocationSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupLocationSearchRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new LocationStockResponse(); }
}
(GroupLocationSearchRequest as unknown)[immerable] = true;

// @Route("/group/new/stock/", "POST")
export class LocationNewStockRequest
{
    public groupId: number;
    public locationId: number;

    public constructor(init?: Partial<LocationNewStockRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LocationNewStockRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(LocationNewStockRequest as unknown)[immerable] = true;

// @Route("/group/stockType/add/", "POST")
export class UpdateDnaCancelStockRequest implements IReturn<Group>, ISecurityId
{
    public groupId: number;
    public stockType: string;
    public stock: StockLocationItem[];
    public securityId: number;

    public constructor(init?: Partial<UpdateDnaCancelStockRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateDnaCancelStockRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Group(); }
}
(UpdateDnaCancelStockRequest as unknown)[immerable] = true;

// @Route("/group/new/location/{id}")
export class LocationNewLocationRequest implements IReturn<Location[]>, ILocationIds
{
    public id: number;
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<LocationNewLocationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LocationNewLocationRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Array<Location>(); }
}
(LocationNewLocationRequest as unknown)[immerable] = true;

// @Route("/group/add/stock/all", "POST")
export class AddAllStockToGroupRequest implements IReturn<ResponseBase<boolean>>, ILocationId
{
    public groupId: number;
    public stockToAdd: number[];
    public stockToRemove: number[];
    public locationId: number;
    public serviceTypeId: number;

    public constructor(init?: Partial<AddAllStockToGroupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddAllStockToGroupRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(AddAllStockToGroupRequest as unknown)[immerable] = true;

// @Route("/group/select/stock", "POST")
export class ChangeStockOnGroupRequest implements IReturn<ResponseBase<boolean>>, ILocationId
{
    public groupId: number;
    public stockId: number;
    public locationId: number;
    public stockType: string;

    public constructor(init?: Partial<ChangeStockOnGroupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ChangeStockOnGroupRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ChangeStockOnGroupRequest as unknown)[immerable] = true;

// @Route("/group/add/location", "POST")
export class AddLocationToGroupRequest implements IReturn<LocationStockResponse>
{
    public groupId: number;
    public firstId: number;
    public followUpId: number;
    public cancelId: number;
    public dnaId: number;
    public locationId?: number;
    public serviceTypeId: number;

    public constructor(init?: Partial<AddLocationToGroupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddLocationToGroupRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new LocationStockResponse(); }
}
(AddLocationToGroupRequest as unknown)[immerable] = true;

// @Route("/group/delete/location", "POST")
export class RemoveLocationfromGroupRequest implements ILocationId
{
    public groupId: number;
    public locationId: number;

    public constructor(init?: Partial<RemoveLocationfromGroupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RemoveLocationfromGroupRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(RemoveLocationfromGroupRequest as unknown)[immerable] = true;

// @Route("/group/change/stock", "POST")
export class ChangeStockfromGroupRequest implements IReturn<ResponseBase<boolean>>, ILocationId
{
    public groupId: number;
    public stockToAddId: number;
    public stockToRemoveId: number;
    public locationId: number;
    public stockType: string;

    public constructor(init?: Partial<ChangeStockfromGroupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ChangeStockfromGroupRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ChangeStockfromGroupRequest as unknown)[immerable] = true;

// @Route("/group/settings/{Id}", "GET")
export class GroupSettingsRequest implements IReturn<ResponseBase<GroupServiceTypeOptionsResponse>>, ILocationId
{
    public id: number;
    public locationId: number;

    public constructor(init?: Partial<GroupSettingsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupSettingsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GroupServiceTypeOptionsResponse>(); }
}
(GroupSettingsRequest as unknown)[immerable] = true;

// @Route("/group/settings/customer")
export class GroupSettingsForCustomerRequest implements IReturn<ResponseBase<GroupServiceTypeOptionsResponse>>, IServiceTypeId
{
    public id: number;
    public customerId: number;
    public serviceTypeId: number;

    public constructor(init?: Partial<GroupSettingsForCustomerRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupSettingsForCustomerRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GroupServiceTypeOptionsResponse>(); }
}
(GroupSettingsForCustomerRequest as unknown)[immerable] = true;

// @Route("/group/notificationTypes")
// @Route("/group/notifications/{Id}")
export class GroupNotificationsRequest implements IReturn<AppointmentEventBase[]>, ILocationId
{
    public id: number;
    public locationId: number;

    public constructor(init?: Partial<GroupNotificationsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupNotificationsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Array<AppointmentEventBase>(); }
}
(GroupNotificationsRequest as unknown)[immerable] = true;

// @Route("/group/profile")
// @Route("/group/profile/{Id}")
export class GroupProfileRequest implements IReturn<ResponseBase<GroupProfileDto>>, ISecurityId
{
    public id: number;
    public securityId: number;

    public constructor(init?: Partial<GroupProfileRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupProfileRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GroupProfileDto>(); }
}
(GroupProfileRequest as unknown)[immerable] = true;

// @Route("/group/settings/save", "POST")
export class GroupServiceTypeOptionsRequest implements IReturn<GroupServiceTypeOptions>, ISecurityId
{
    public id: number;
    public serviceTypeID: number;
    public groupID: number;
    public securityId: number;
    public useAuthCodes?: boolean;
    public useDummyAuthCodes?: boolean;
    public dummyCodePrefix: string;
    public cancelAffectsAuthCount: boolean;
    public dnaAffectsAuthCount: boolean;
    public authCodeGenerateMode: number;
    public authCodeGenerateAssess: number;
    public authCodeGenerateTreat: number;
    public authCodeGenerateAll: number;
    public cancelAlwaysAffectsAuthCount: boolean;
    public cancelAffectsAuthCountDays: number;

    public constructor(init?: Partial<GroupServiceTypeOptionsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupServiceTypeOptionsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GroupServiceTypeOptions(); }
}
(GroupServiceTypeOptionsRequest as unknown)[immerable] = true;

// @Route("/group/save/all", "POST")
export class SaveAllGroupRequest implements IReturn<ResponseBase<GroupResponse>>, ISecurityId
{
    public securityId: number;
    public groupId: number;
    public group: SaveGroupRequest;
    public settings: GroupServiceTypeOptionsRequest[];
    public profile: GroupProfileDto;
    public notifications: NotificationSubscription[];
    public chargesToRemove: GroupStockResponse[];
    public chargesToUpdate: GroupStockResponse[];
    public locationsToUpdate: LocResponse[];
    public locationsToRemove: LocResponse[];

    public constructor(init?: Partial<SaveAllGroupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveAllGroupRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GroupResponse>(); }
}
(SaveAllGroupRequest as unknown)[immerable] = true;

// @Route("/groups/current")
export class GroupCurrentRequest implements IReturn<ResponseBase<GroupResponse>>
{

    public constructor(init?: Partial<GroupCurrentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupCurrentRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GroupResponse>(); }
}
(GroupCurrentRequest as unknown)[immerable] = true;

export class ClickGroupServicesRequest implements IReturn<ResponseBase<GroupStockResponse>>
{
    public skip: number;
    public take: number;
    public sort: QueryField[];
    public groupId: number;

    public constructor(init?: Partial<ClickGroupServicesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickGroupServicesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GroupStockResponse>(); }
}
(ClickGroupServicesRequest as unknown)[immerable] = true;

// @Route("/group/onlineBookingLink", "GET")
export class GroupOnlineBookingLinkRequest implements IReturn<ResponseBase<GroupStockWithRestrictions>>
{
    public groupId?: number;
    public locationId: string;

    public constructor(init?: Partial<GroupOnlineBookingLinkRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupOnlineBookingLinkRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GroupStockWithRestrictions>(); }
}
(GroupOnlineBookingLinkRequest as unknown)[immerable] = true;

// @Route("/healthcode/policy-lookup", "POST")
export class HealthcodePolicyLookupRequest implements IReturn<ResponseBase<HealthcodePolicyLookupResponse>>, ICustomerId
{
    public customerId: number;
    public groupId: number;
    public postCode: string;
    public sex: string;
    public membershipNumber: string;
    public policyActiveOn: string;

    public constructor(init?: Partial<HealthcodePolicyLookupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'HealthcodePolicyLookupRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<HealthcodePolicyLookupResponse>(); }
}
(HealthcodePolicyLookupRequest as unknown)[immerable] = true;

// @Route("/healthcode/getbusinesses")
export class GetBusinessesRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<GetBusinessesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetBusinessesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetBusinessesRequest as unknown)[immerable] = true;

// @Route("/healthcode/addbusiness")
export class AddBusinessRequest
{
    public businesses: AddBusinessModel[];

    public constructor(init?: Partial<AddBusinessRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddBusinessRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(AddBusinessRequest as unknown)[immerable] = true;

// @Route("/healthcode/setccsdlookup", "POST")
export class SetCcsdLookupRequest implements IReturn<ResponseBase<boolean>>
{
    public enabled: boolean;

    public constructor(init?: Partial<SetCcsdLookupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetCcsdLookupRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(SetCcsdLookupRequest as unknown)[immerable] = true;

// @Route("/healthcode/getallisc")
export class GetAllIscRequest implements IReturn<ResponseBase<IscResponse>>
{

    public constructor(init?: Partial<GetAllIscRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAllIscRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<IscResponse>(); }
}
(GetAllIscRequest as unknown)[immerable] = true;

// @Route("/healthcode/searchisc")
export class SearchIscRequest
{
    public term: string;

    public constructor(init?: Partial<SearchIscRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SearchIscRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(SearchIscRequest as unknown)[immerable] = true;

// @Route("/healthcode/business/providercodes")
export class GetProviderCodesRequest
{
    public provideCodeOption: number;
    public groupId: number;
    public skip: number;
    public take: number;

    public constructor(init?: Partial<GetProviderCodesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetProviderCodesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(GetProviderCodesRequest as unknown)[immerable] = true;

// @Route("/healthcode/business/{id}")
export class GetBusinessDetailsRequest
{
    public id: number;

    public constructor(init?: Partial<GetBusinessDetailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetBusinessDetailsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(GetBusinessDetailsRequest as unknown)[immerable] = true;

// @Route("/healthcode/login/update")
export class UpdateHealthcodeLoginDetailRequest
{
    public username: string;
    public password: string;

    public constructor(init?: Partial<UpdateHealthcodeLoginDetailRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateHealthcodeLoginDetailRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(UpdateHealthcodeLoginDetailRequest as unknown)[immerable] = true;

// @Route("/healthcode/api-credentials", "GET")
export class GetHealthcodeApiCredentialsRequest implements IReturn<ResponseBase<HealthcodeApiCredentialsResponse>>
{

    public constructor(init?: Partial<GetHealthcodeApiCredentialsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetHealthcodeApiCredentialsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<HealthcodeApiCredentialsResponse>(); }
}
(GetHealthcodeApiCredentialsRequest as unknown)[immerable] = true;

// @Route("/healthcode/api-credentials", "POST")
export class UpdateHealthcodeApiCredentialsRequest implements IReturn<ResponseBase<boolean>>
{
    public apiKey: string;
    public appId: string;

    public constructor(init?: Partial<UpdateHealthcodeApiCredentialsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateHealthcodeApiCredentialsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(UpdateHealthcodeApiCredentialsRequest as unknown)[immerable] = true;

// @Route("/healthcode/business/update")
export class UpdateBusinessDetailRequest
{
    public id: number;
    public locationId: number;
    public property: string;
    public value: Object;

    public constructor(init?: Partial<UpdateBusinessDetailRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateBusinessDetailRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(UpdateBusinessDetailRequest as unknown)[immerable] = true;

// @Route("/healthcode/business/update/providercode")
export class UpdateBusinessProviderCodeRequest
{
    public id: number;
    public groupId: number;
    public providerNoOption: number;
    public providerNo: string;

    public constructor(init?: Partial<UpdateBusinessProviderCodeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateBusinessProviderCodeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(UpdateBusinessProviderCodeRequest as unknown)[immerable] = true;

// @Route("/healthcode/stockitem/update")
export class UpdateStockItemDetailRequest
{
    public id: number;
    public property: string;
    public value: string;

    public constructor(init?: Partial<UpdateStockItemDetailRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateStockItemDetailRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(UpdateStockItemDetailRequest as unknown)[immerable] = true;

// @Route("/healthcode/invoices/export/validate")
export class ValidateExportRequest implements IReturn<ResponseBase<ExportIssueResponse>>, ILocationIds
{
    public startDate?: string;
    public endDate?: string;
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<ValidateExportRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateExportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ExportIssueResponse>(); }
}
(ValidateExportRequest as unknown)[immerable] = true;

export class ValidateInvoiceForHealthcodeSubmissionRequest implements IReturn<ResponseBase<ExportIssueResponse>>
{
    public invoiceId: number;

    public constructor(init?: Partial<ValidateInvoiceForHealthcodeSubmissionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateInvoiceForHealthcodeSubmissionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ExportIssueResponse>(); }
}
(ValidateInvoiceForHealthcodeSubmissionRequest as unknown)[immerable] = true;

export class SubmitInvoiceToHealthcodeRequest implements IReturn<ResponseBase<SubmitInvoiceToHealthcodeResponse>>
{
    public invoiceId: number;

    public constructor(init?: Partial<SubmitInvoiceToHealthcodeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SubmitInvoiceToHealthcodeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SubmitInvoiceToHealthcodeResponse>(); }
}
(SubmitInvoiceToHealthcodeRequest as unknown)[immerable] = true;

// @Route("/healthcode/invoices/export")
export class ExportHealthcodeInvoicesRequest implements ILocationIds
{
    public startDate?: string;
    public endDate?: string;
    public toExport: number[];
    public locationIds: number[];
    public requestLocationIds: number[];
    public upload: boolean;

    public constructor(init?: Partial<ExportHealthcodeInvoicesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExportHealthcodeInvoicesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(ExportHealthcodeInvoicesRequest as unknown)[immerable] = true;

// @Route("/healthcode/invoices/exportstatus")
export class GetInvoiceExportStatusRequest
{

    public constructor(init?: Partial<GetInvoiceExportStatusRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInvoiceExportStatusRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(GetInvoiceExportStatusRequest as unknown)[immerable] = true;

// @Route("/healthcode/invoices/uploadedfiles/{Type*}")
export class GetUploadedFilesListRequest implements IReturn<ResponseBase<ExportedInvoiceFileResponse>>
{
    // @DataMember(Order=1)
    public type: string;

    public constructor(init?: Partial<GetUploadedFilesListRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetUploadedFilesListRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ExportedInvoiceFileResponse>(); }
}
(GetUploadedFilesListRequest as unknown)[immerable] = true;

// @Route("/healthcode/invoices/download/{Filename}/{Type*}", "GET")
export class DownloadHealthcodeFileRequest
{
    public filename: string;
    public type: string;

    public constructor(init?: Partial<DownloadHealthcodeFileRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadHealthcodeFileRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(DownloadHealthcodeFileRequest as unknown)[immerable] = true;

// @Route("/healthcode/invoices/download/delete", "POST")
export class DeleteHealthcodeFileRequest implements IReturn<ResponseBase<T>>
{
    public filename: string;
    public type: string;

    public constructor(init?: Partial<DeleteHealthcodeFileRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteHealthcodeFileRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(DeleteHealthcodeFileRequest as unknown)[immerable] = true;

// @Route("/healthcode/invoices/uploadremittance", "POST")
// @DataContract
export class UploadRemittanceRequest
{

    public constructor(init?: Partial<UploadRemittanceRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UploadRemittanceRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(UploadRemittanceRequest as unknown)[immerable] = true;

// @Route("/healthcode/invoices/importstatus")
export class GetInvoiceImportStatusRequest
{

    public constructor(init?: Partial<GetInvoiceImportStatusRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInvoiceImportStatusRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(GetInvoiceImportStatusRequest as unknown)[immerable] = true;

// @Route("/healthcode/invoices/runningjob")
export class GetRunningBackgroundJobRequest
{

    public constructor(init?: Partial<GetRunningBackgroundJobRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetRunningBackgroundJobRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(GetRunningBackgroundJobRequest as unknown)[immerable] = true;

// @Route("/healthcode/invoices/importsummary")
export class GetInvoiceImportSummaryRequest implements IReturn<ResponseBase<HealthcodeImportSummaryResponse>>
{

    public constructor(init?: Partial<GetInvoiceImportSummaryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInvoiceImportSummaryRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<HealthcodeImportSummaryResponse>(); }
}
(GetInvoiceImportSummaryRequest as unknown)[immerable] = true;

// @Route("/healthcode/invoices/validationsummary")
export class GetInvoiceValidationSummaryRequest implements IReturn<ResponseBase<ExportIssueResponse>>
{

    public constructor(init?: Partial<GetInvoiceValidationSummaryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInvoiceValidationSummaryRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ExportIssueResponse>(); }
}
(GetInvoiceValidationSummaryRequest as unknown)[immerable] = true;

// @Route("/healthcode/invoices/exportsummary")
export class GetInvoiceExportSummaryRequest implements IReturn<ResponseBase<HealthcodeExportSummaryResponse>>
{

    public constructor(init?: Partial<GetInvoiceExportSummaryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInvoiceExportSummaryRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<HealthcodeExportSummaryResponse>(); }
}
(GetInvoiceExportSummaryRequest as unknown)[immerable] = true;

// @Route("/healthcode/businesstocks", "POST")
export class BusinessStocksRequest
{
    public sortBy: string;
    public skip: number;
    public take: number;
    public sortDir: string;
    public groupId: number;

    public constructor(init?: Partial<BusinessStocksRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BusinessStocksRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(BusinessStocksRequest as unknown)[immerable] = true;

export class MailChimpLoginRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<MailChimpLoginRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MailChimpLoginRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(MailChimpLoginRequest as unknown)[immerable] = true;

// @Route("/mailchimp/pushallemails")
export class PushAllEmailsRequest implements IReturn<ResponseBase<T>>
{
    public listId: string;

    public constructor(init?: Partial<PushAllEmailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PushAllEmailsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(PushAllEmailsRequest as unknown)[immerable] = true;

// @Route("/mailchimp/lists")
export class GetMailchimpListRequest implements IReturn<ResponseBase<AudiencesResponse>>
{

    public constructor(init?: Partial<GetMailchimpListRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMailchimpListRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<AudiencesResponse>(); }
}
(GetMailchimpListRequest as unknown)[immerable] = true;

// @Route("/mailchimp/sync-progress/{ListId}", "GET")
export class GetMailchimpSyncProgressRequest
{
    public listId: string;

    public constructor(init?: Partial<GetMailchimpSyncProgressRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMailchimpSyncProgressRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(GetMailchimpSyncProgressRequest as unknown)[immerable] = true;

// @Route("/mailchimp/sync-summary/{ListId}", "GET")
export class GetMailChimpSyncSummary
{
    public listId: string;

    public constructor(init?: Partial<GetMailChimpSyncSummary>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMailChimpSyncSummary'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(GetMailChimpSyncSummary as unknown)[immerable] = true;

// @Route("/mailchimp/sync-duplicates/{ListId}", "GET")
export class GetMailChimpSyncDuplicates
{
    public listId: string;

    public constructor(init?: Partial<GetMailChimpSyncDuplicates>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMailChimpSyncDuplicates'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(GetMailChimpSyncDuplicates as unknown)[immerable] = true;

// @Route("/mailchimp/sync-log/{ListId}", "GET")
export class GetMailchimpPushAllEmailsLog
{
    public listId: string;

    public constructor(init?: Partial<GetMailchimpPushAllEmailsLog>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMailchimpPushAllEmailsLog'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(GetMailchimpPushAllEmailsLog as unknown)[immerable] = true;

// @Route("/mailchimp/duplicates/{CustomerId}")
export class GetDuplicateRequest
{
    public customerId: number;

    public constructor(init?: Partial<GetDuplicateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDuplicateRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(GetDuplicateRequest as unknown)[immerable] = true;

// @Route("/mailchimp/duplicates", "POST")
export class DuplicatesRequest implements IReturn<ResponseBase<MailChimpDuplicatesResponse>>
{
    public customerIds: number[];

    public constructor(init?: Partial<DuplicatesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DuplicatesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<MailChimpDuplicatesResponse>(); }
}
(DuplicatesRequest as unknown)[immerable] = true;

// @Route("/mailchimp/subscriptions-lists/{CustomerId}", "GET")
export class GetSubscriptionListsRequest
{
    public customerId: number;

    public constructor(init?: Partial<GetSubscriptionListsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSubscriptionListsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(GetSubscriptionListsRequest as unknown)[immerable] = true;

// @Route("/mailchimp/subscribecustomertolist")
export class SubscribeCustomerToListRequest
{
    public customerId: number;
    public mailchimpListId: string;

    public constructor(init?: Partial<SubscribeCustomerToListRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SubscribeCustomerToListRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(SubscribeCustomerToListRequest as unknown)[immerable] = true;

// @Route("/mailchimp/unsubscribecustomerfromlist")
export class UnSubscribeCustomerFromListRequest
{
    public customerId: number;
    public mailchimpListId: string;

    public constructor(init?: Partial<UnSubscribeCustomerFromListRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UnSubscribeCustomerFromListRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(UnSubscribeCustomerFromListRequest as unknown)[immerable] = true;

// @Route("/mailchimp/unsubscribecustomerfromalllists")
export class UnSubscribeCustomerFromAllListsRequest
{
    public customerId: number;

    public constructor(init?: Partial<UnSubscribeCustomerFromAllListsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UnSubscribeCustomerFromAllListsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(UnSubscribeCustomerFromAllListsRequest as unknown)[immerable] = true;

// @Route("/mailchimp/subscribecustomerstolist")
export class SubscribeCustomersToListRequest implements IReturn<ResponseBase<boolean>>
{
    public customerIds: number[];
    public mailchimpListId: string;

    public constructor(init?: Partial<SubscribeCustomersToListRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SubscribeCustomersToListRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(SubscribeCustomersToListRequest as unknown)[immerable] = true;

// @Route("/mailchimp/statistic/{ListId}")
export class SyncStatisticRequest
{
    public listId: string;

    public constructor(init?: Partial<SyncStatisticRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SyncStatisticRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(SyncStatisticRequest as unknown)[immerable] = true;

// @Route("/mailchimp/unsync-audience/{ListId}")
export class UnsyncAudienceRequest
{
    public listId: string;

    public constructor(init?: Partial<UnsyncAudienceRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UnsyncAudienceRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(UnsyncAudienceRequest as unknown)[immerable] = true;

export class PostcodeLookupRequest implements IReturn<ResponseBase<PostcodeLookupResponse>>
{
    public houseNumber: string;
    public postcode: string;

    public constructor(init?: Partial<PostcodeLookupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostcodeLookupRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<PostcodeLookupResponse>(); }
}
(PostcodeLookupRequest as unknown)[immerable] = true;

// @Route("/physiotec-practitioners", "GET")
// @Route("/physiotec-practitioner/{Id}", "GET")
export class PhysiotecPractitionerGetRequest implements IReturn<ResponseBase<PhysiotecPractitioner>>
{
    public id: number;

    public constructor(init?: Partial<PhysiotecPractitionerGetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PhysiotecPractitionerGetRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<PhysiotecPractitioner>(); }
}
(PhysiotecPractitionerGetRequest as unknown)[immerable] = true;

// @Route("/physiotec-practitioners", "POST")
// @Route("/physiotec-practitioner/{Id}", "POST")
export class PhysiotecPractitionerPostRequest implements IReturn<ResponseBase<Object>>
{
    public id: number;
    public preexisting: boolean;

    public constructor(init?: Partial<PhysiotecPractitionerPostRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PhysiotecPractitionerPostRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<Object>(); }
}
(PhysiotecPractitionerPostRequest as unknown)[immerable] = true;

// @Route("/physiotec-practitioner/{Id}/credentials")
export class PhysiotecPractitionerCredentialsRequest implements IReturn<PhysiotecPractitioner>
{
    public id: number;

    public constructor(init?: Partial<PhysiotecPractitionerCredentialsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PhysiotecPractitionerCredentialsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PhysiotecPractitioner(); }
}
(PhysiotecPractitionerCredentialsRequest as unknown)[immerable] = true;

// @Route("/discipline/{PractitionerId}")
export class PractitionerDisciplineRequest implements IReturn<CustomListItemResponse[]>, ISecurityId
{
    public practitionerId: number;
    public securityId: number;

    public constructor(init?: Partial<PractitionerDisciplineRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PractitionerDisciplineRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Array<CustomListItemResponse>(); }
}
(PractitionerDisciplineRequest as unknown)[immerable] = true;

// @Route("/discipline/save")
export class DisciplineSave implements IReturn<CustomListItemResponse[]>, ISecurityId
{
    public practitionerId: number;
    public securityId: number;
    public disciplines: CustomListItemResponse[];

    public constructor(init?: Partial<DisciplineSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DisciplineSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Array<CustomListItemResponse>(); }
}
(DisciplineSave as unknown)[immerable] = true;

// @Route("/practitioner/group/{PractitionerId}")
export class PractitionerGroupRequest implements IReturn<ResponseBase<PractitionerGroupResponse>>, ISecurityId
{
    public skip: number;
    public take: number;
    public practitionerId: number;
    public securityId: number;

    public constructor(init?: Partial<PractitionerGroupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PractitionerGroupRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<PractitionerGroupResponse>(); }
}
(PractitionerGroupRequest as unknown)[immerable] = true;

// @Route("/practitioner/group/save/")
export class ProviderSave implements IReturn<ResponseBase<PractitionerGroupResponse>>, ISecurityId
{
    public id: number;
    public groupId: number;
    public providerNo: string;
    public practitionerId: number;
    public securityId: number;

    public constructor(init?: Partial<ProviderSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProviderSave'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<PractitionerGroupResponse>(); }
}
(ProviderSave as unknown)[immerable] = true;

// @Route("/practitioners/group/all/{PractitionerId}")
export class PractitionersGroupAllRequest implements IReturn<ResponseBase<GroupLocationsResponse>>, ISecurityId
{
    public skip: number;
    public take: number;
    public practitionerId: number;
    public securityId: number;

    public constructor(init?: Partial<PractitionersGroupAllRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PractitionersGroupAllRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GroupLocationsResponse>(); }
}
(PractitionersGroupAllRequest as unknown)[immerable] = true;

// @Route("/practitioner/group/remove/")
export class ProviderRemove implements IReturn<ResponseBase<PractitionerGroupResponse>>, ISecurityId
{
    public id: number;
    public groupId: number;
    public providerNo: string;
    public groupName: string;
    public practitionerId: number;
    public securityId: number;

    public constructor(init?: Partial<ProviderRemove>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProviderRemove'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<PractitionerGroupResponse>(); }
}
(ProviderRemove as unknown)[immerable] = true;

// @Route("/practitioners")
// @Route("/practitioners/{Id}")
export class PractitionerRequest implements IReturn<ResponseBase<GeneralPractitionerResponse>>, IGet
{
    public id: number;

    public constructor(init?: Partial<PractitionerRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PractitionerRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GeneralPractitionerResponse>(); }
}
(PractitionerRequest as unknown)[immerable] = true;

// @Route("/practitioners")
// @Route("/practitioners/onlineId/{Id}")
export class PractitionerByOnlineIdRequest implements IReturn<ResponseBase<GeneralPractitionerResponse>>
{
    public id: string;

    public constructor(init?: Partial<PractitionerByOnlineIdRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PractitionerByOnlineIdRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GeneralPractitionerResponse>(); }
}
(PractitionerByOnlineIdRequest as unknown)[immerable] = true;

// @Route("/locations/all/practitioners")
export class PractitionersAtAllLocationsRequest implements IReturn<ResponseBase<PractitionerLocation>>
{

    public constructor(init?: Partial<PractitionersAtAllLocationsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PractitionersAtAllLocationsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<PractitionerLocation>(); }
}
(PractitionersAtAllLocationsRequest as unknown)[immerable] = true;

// @Route("/practitioners/allowed/add/{LocationId}")
export class AddPractitionerRequest implements IReturn<ResponseBase<AddPractitionerResponse>>, ILocationId
{
    public locationId: number;

    public constructor(init?: Partial<AddPractitionerRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddPractitionerRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<AddPractitionerResponse>(); }
}
(AddPractitionerRequest as unknown)[immerable] = true;

// @Route("/practitioners/allPractitioners")
export class AllPractitionersAllRequest implements IReturn<ResponseBase<MinimalPractitioner>>, ILocationIds
{
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<AllPractitionersAllRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AllPractitionersAllRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<MinimalPractitioner>(); }
}
(AllPractitionersAllRequest as unknown)[immerable] = true;

// @Route("/practitioners/count")
export class PractitionerCountRequest implements IReturn<number>
{

    public constructor(init?: Partial<PractitionerCountRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PractitionerCountRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return 0; }
}
(PractitionerCountRequest as unknown)[immerable] = true;

// @Route("/practitioners/onlineId")
export class UserIdByPractitionerOnlineIdRequest implements IReturn<ResponseBase<number>>
{
    public practitionerOnlineId: string;

    public constructor(init?: Partial<UserIdByPractitionerOnlineIdRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UserIdByPractitionerOnlineIdRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<number>(); }
}
(UserIdByPractitionerOnlineIdRequest as unknown)[immerable] = true;

// @Route("/practitioner/updatePractitionerPatients")
export class UpdatePractitionersPatientsByLocation implements IReturn<boolean>, ISecurityId
{
    public updatedPracsByLocation: PractitionerLocationPair[];
    public id: number;
    public securityId: number;

    public constructor(init?: Partial<UpdatePractitionersPatientsByLocation>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdatePractitionersPatientsByLocation'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return false; }
}
(UpdatePractitionersPatientsByLocation as unknown)[immerable] = true;

export class LinkPractitionerToZoomUser implements IReturn<ResponseBase<T>>
{
    public id: number;
    public zoomUserId: string;

    public constructor(init?: Partial<LinkPractitionerToZoomUser>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LinkPractitionerToZoomUser'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(LinkPractitionerToZoomUser as unknown)[immerable] = true;

// @Route("/locations/{id}/practitioners")
export class PractitionersAtLocationRequest implements IReturn<ResponseBase<MinimalPractitioner>>
{
    public id: number;

    public constructor(init?: Partial<PractitionersAtLocationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PractitionersAtLocationRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<MinimalPractitioner>(); }
}
(PractitionersAtLocationRequest as unknown)[immerable] = true;

// @Route("/practitioner/patients/count")
// @Route("/practitioner/patients/count/{id}")
export class PractitionerPatientsCount implements IReturn<ResponseBase<{ [index:number]: number; }>>, ISecurityId
{
    public id: number;
    public securityId: number;

    public constructor(init?: Partial<PractitionerPatientsCount>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PractitionerPatientsCount'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<{ [index:number]: number; }>(); }
}
(PractitionerPatientsCount as unknown)[immerable] = true;

// @Route("/practitioner/recentDocument")
// @Route("/practitioner/recentDocument/{PractitionerId}")
export class RecentPractitionerDocumentRequest implements IReturn<RecentDocumentResponse>, IHasPath, ISecurityId
{
    public practitionerId: number;
    public securityId: number;
    public path: string;
    public safeRoot: string;

    public constructor(init?: Partial<RecentPractitionerDocumentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RecentPractitionerDocumentRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RecentDocumentResponse(); }
}
(RecentPractitionerDocumentRequest as unknown)[immerable] = true;

// @Route("/practitioner/save")
export class PractitionerSaveRequest implements IReturn<ResponseBase<GeneralPractitionerResponse>>, ILocationId
{
    public id: number;
    public name: string;
    public code: string;
    public fullAddress: string;
    public locationName: string;
    public title: string;
    public forename: string;
    public surname: string;
    public gender: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public addressLine5: string;
    public postCode: string;
    public telephone: string;
    public mobile: string;
    public homeTelephone: string;
    public email: string;
    public fax: string;
    public web: string;
    public online: boolean;
    public status?: number;
    public setInactiveDate?: string;
    public type: string;
    public contractNumber: string;
    public onlineGuid: string;
    public defaultLocationId: number;
    public regNumber: string;
    public commissionFlatRate: number;
    public commissionPercent: number;
    public employmentStatus: string;
    public taxNo: string;
    public firstId: number;
    public followupId: number;
    public locationId: number;
    public serviceTypeId: number;
    public enabledForAllServices: boolean;

    public constructor(init?: Partial<PractitionerSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PractitionerSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GeneralPractitionerResponse>(); }
}
(PractitionerSaveRequest as unknown)[immerable] = true;

// @Route("/practitioner/locs/save")
export class PractitionersLocationsSave implements IReturn<PracStockLoc[]>, ISecurityId
{
    public practitionerId: number;
    public securityId: number;
    public locationId: number;
    public practitionerServiceStockFirstStockId: number;
    public practitionerServiceStockFollowupStockId: number;
    public code: string;

    public constructor(init?: Partial<PractitionersLocationsSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PractitionersLocationsSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Array<PracStockLoc>(); }
}
(PractitionersLocationsSave as unknown)[immerable] = true;

// @Route("/practitioner/locs/code/save", "POST")
export class PractitionersLocationsCodeSave implements IReturn<ResponseBase<PracStockLoc>>, ISecurityId
{
    public practitionerId: number;
    public securityId: number;
    public locationId: number;
    public code: string;

    public constructor(init?: Partial<PractitionersLocationsCodeSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PractitionersLocationsCodeSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<PracStockLoc>(); }
}
(PractitionersLocationsCodeSave as unknown)[immerable] = true;

// @Route("/practitioner/locs/delete")
export class PractitionersLocationsDelete implements IReturn<PracStockLoc[]>, ILocationId, ISecurityId
{
    public practitionerId: number;
    public locationId: number;
    public securityId: number;

    public constructor(init?: Partial<PractitionersLocationsDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PractitionersLocationsDelete'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Array<PracStockLoc>(); }
}
(PractitionersLocationsDelete as unknown)[immerable] = true;

// @Route("/practitioners/locs/all")
// @Route("/practitioners/locs/all/{Id}")
export class PracLocationsWithStock implements IReturn<PracStockLoc[]>, ISecurityId
{
    public id: number;
    public securityId: number;
    public sort: QueryField[];

    public constructor(init?: Partial<PracLocationsWithStock>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PracLocationsWithStock'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Array<PracStockLoc>(); }
}
(PracLocationsWithStock as unknown)[immerable] = true;

// @Route("/practitioner/new/location/{id}")
export class NewLocationPractitionersRequest implements IReturn<Location[]>, ILocationIds
{
    public id: number;
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<NewLocationPractitionersRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'NewLocationPractitionersRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Array<Location>(); }
}
(NewLocationPractitionersRequest as unknown)[immerable] = true;

// @Route("/practitioners/diaryOrder")
export class PractitionerDiaryOrderRequest implements IReturn<ResponseBase<CustomListItemResponse>>
{
    public diaryOrder: CustomListItemResponse[];

    public constructor(init?: Partial<PractitionerDiaryOrderRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PractitionerDiaryOrderRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CustomListItemResponse>(); }
}
(PractitionerDiaryOrderRequest as unknown)[immerable] = true;

export class GetDiaryPractitioners implements IReturn<ResponseBase<PractitionerDiaryOrderResponse>>
{

    public constructor(init?: Partial<GetDiaryPractitioners>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDiaryPractitioners'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<PractitionerDiaryOrderResponse>(); }
}
(GetDiaryPractitioners as unknown)[immerable] = true;

// @Route("/practitionersWithLocations")
export class GetPractitionersWithLocationsRequest implements IReturn<ResponseBase<GeneralPractitionerResponse>>, IGet
{

    public constructor(init?: Partial<GetPractitionersWithLocationsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPractitionersWithLocationsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GeneralPractitionerResponse>(); }
}
(GetPractitionersWithLocationsRequest as unknown)[immerable] = true;

// @Route("/practitioner/status/update")
export class PractitionerStatusUpdateRequest implements ILocationId
{
    public updates: PractitionerStatusUpdate[];
    public locationId: number;
    public newLicensesAmount: number;

    public constructor(init?: Partial<PractitionerStatusUpdateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PractitionerStatusUpdateRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(PractitionerStatusUpdateRequest as unknown)[immerable] = true;

export class SavePractitionerSkillRequest extends PractitionerSkillBaseRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<SavePractitionerSkillRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SavePractitionerSkillRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(SavePractitionerSkillRequest as unknown)[immerable] = true;

export class DeletePractitionerSkillRequest extends PractitionerSkillBaseRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<DeletePractitionerSkillRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'DeletePractitionerSkillRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(DeletePractitionerSkillRequest as unknown)[immerable] = true;

export class CreateSkillRequest implements IReturn<ResponseBase<T>>
{
    public name: string;

    public constructor(init?: Partial<CreateSkillRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateSkillRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(CreateSkillRequest as unknown)[immerable] = true;

export class DeleteSkillRequest implements IReturn<ResponseBase<T>>
{
    public id: string;

    public constructor(init?: Partial<DeleteSkillRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteSkillRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(DeleteSkillRequest as unknown)[immerable] = true;

export class SkillRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<SkillRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SkillRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(SkillRequest as unknown)[immerable] = true;

export class PractitionerSkillsRequest implements IReturn<ResponseBase<SkillResponse>>
{
    public practitionerId: number;

    public constructor(init?: Partial<PractitionerSkillsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PractitionerSkillsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<SkillResponse>(); }
}
(PractitionerSkillsRequest as unknown)[immerable] = true;

export class PractitionerUpdateFieldBulkActionRequest extends PractitionerBulkActionBaseRequest implements IReturn<ResponseBase<UpdateFieldBulkActionResponse>>
{
    public field: BulkUpdateField;
    public value: string;

    public constructor(init?: Partial<PractitionerUpdateFieldBulkActionRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'PractitionerUpdateFieldBulkActionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<UpdateFieldBulkActionResponse>(); }
}
(PractitionerUpdateFieldBulkActionRequest as unknown)[immerable] = true;

export class MyBookingsStatsRequest implements IReturn<ResponseBase<MyBookingStatsResponse>>
{

    public constructor(init?: Partial<MyBookingsStatsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MyBookingsStatsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<MyBookingStatsResponse>(); }
}
(MyBookingsStatsRequest as unknown)[immerable] = true;

export class MyBookingsRequest extends BaseAdvancedSearchRequest implements IReturn<MyBookingsResponse>
{

    public constructor(init?: Partial<MyBookingsRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'MyBookingsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MyBookingsResponse(); }
}
(MyBookingsRequest as unknown)[immerable] = true;

export class BookingAuditsExportRequest implements IReturn<ResponseBase<string>>
{
    public skip: number;
    public take?: number;

    public constructor(init?: Partial<BookingAuditsExportRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BookingAuditsExportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<string>(); }
}
(BookingAuditsExportRequest as unknown)[immerable] = true;

export class SingleBookingAuditRequest implements IReturn<ResponseBase<SingleBookingAuditResponse>>
{
    public id: string;

    public constructor(init?: Partial<SingleBookingAuditRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SingleBookingAuditRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<SingleBookingAuditResponse>(); }
}
(SingleBookingAuditRequest as unknown)[immerable] = true;

export class LinkableAppointmentsRequest implements IReturn<ResponseBase<AppointmentResponse>>
{
    public id: string;

    public constructor(init?: Partial<LinkableAppointmentsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LinkableAppointmentsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<AppointmentResponse>(); }
}
(LinkableAppointmentsRequest as unknown)[immerable] = true;

export class LinkAppointmentsToReferralRequest implements IReturn<ResponseBase<boolean>>
{
    public auditId: string;
    public appointments: AppointmentResponse[];

    public constructor(init?: Partial<LinkAppointmentsToReferralRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LinkAppointmentsToReferralRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(LinkAppointmentsToReferralRequest as unknown)[immerable] = true;

export class MyClinicSummaryRequest implements IReturn<ResponseBase<MyClinicSummaryResponse>>
{

    public constructor(init?: Partial<MyClinicSummaryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MyClinicSummaryRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<MyClinicSummaryResponse>(); }
}
(MyClinicSummaryRequest as unknown)[immerable] = true;

export class ReferralAppointmentRequest extends ReferralAppointment implements IReturn<ResponseBase<ReferralAppointment>>
{
    public auditId: string;
    public yesToWarnings: boolean;
    public bookingAudit: BookingAuditResponse;

    public constructor(init?: Partial<ReferralAppointmentRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralAppointmentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ReferralAppointment>(); }
}
(ReferralAppointmentRequest as unknown)[immerable] = true;

export class ReportSearchRequest implements IReturn<ResponseBase<ReportSearchResponse>>
{
    public id?: string;
    public bookerId?: string;
    public templateId?: string;

    public constructor(init?: Partial<ReportSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReportSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ReportSearchResponse>(); }
}
(ReportSearchRequest as unknown)[immerable] = true;

export class EditReportRequest implements IReturn<ResponseBase<ReferralReport>>
{
    public id: string;

    public constructor(init?: Partial<EditReportRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EditReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ReferralReport>(); }
}
(EditReportRequest as unknown)[immerable] = true;

export class DraftReportRequest extends ReferralReport implements IReturn<ResponseBase<ReferralReport>>
{

    public constructor(init?: Partial<DraftReportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'DraftReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ReferralReport>(); }
}
(DraftReportRequest as unknown)[immerable] = true;

export class SubmitReportRequest extends ReferralReport implements IReturn<ResponseBase<SubmitReportResponse>>
{
    public appointmentsToLock: string[];
    public isSubmittedFromMyClinic: boolean;
    public prontoIntegrationEnabled: boolean;
    public linkInvoicesToReports: boolean;
    public bookingAuditResponse: BookingAuditResponse;

    public constructor(init?: Partial<SubmitReportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SubmitReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SubmitReportResponse>(); }
}
(SubmitReportRequest as unknown)[immerable] = true;

export class ProntoInvoiceSearchRequest implements IReturn<ResponseBase<ProntoInvoiceSearchResponse>>
{
    public id?: string;
    public auditId?: string;
    public isRequestFromQuickBill: boolean;

    public constructor(init?: Partial<ProntoInvoiceSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProntoInvoiceSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ProntoInvoiceSearchResponse>(); }
}
(ProntoInvoiceSearchRequest as unknown)[immerable] = true;

export class ProntoInvoiceRequest extends ProntoInvoice implements IReturn<ResponseBase<MyClinicInvoiceResponse>>
{
    public submittedFromTM3: boolean;

    public constructor(init?: Partial<ProntoInvoiceRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ProntoInvoiceRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<MyClinicInvoiceResponse>(); }
}
(ProntoInvoiceRequest as unknown)[immerable] = true;

export class ProntoInvoiceSubmitRequest extends ProntoInvoice implements IReturn<ResponseBase<MyClinicInvoiceResponse>>
{

    public constructor(init?: Partial<ProntoInvoiceSubmitRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ProntoInvoiceSubmitRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<MyClinicInvoiceResponse>(); }
}
(ProntoInvoiceSubmitRequest as unknown)[immerable] = true;

export class ProntoInvoiceEditRequest extends ProntoInvoice implements IReturn<ResponseBase<MyClinicInvoiceResponse>>
{

    public constructor(init?: Partial<ProntoInvoiceEditRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ProntoInvoiceEditRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<MyClinicInvoiceResponse>(); }
}
(ProntoInvoiceEditRequest as unknown)[immerable] = true;

// @Route("/referral/file/{Path*}", "GET")
export class ReferralAttachmentPathRequest implements IReturn<HttpResult>
{
    public path: string;

    public constructor(init?: Partial<ReferralAttachmentPathRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralAttachmentPathRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new HttpResult(); }
}
(ReferralAttachmentPathRequest as unknown)[immerable] = true;

export class GetClickAppointmentsLinkableToProntoReferralRequest implements IReturn<ResponseBase<ClickLinkableAppointment>>
{
    public customerId: number;

    public constructor(init?: Partial<GetClickAppointmentsLinkableToProntoReferralRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetClickAppointmentsLinkableToProntoReferralRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClickLinkableAppointment>(); }
}
(GetClickAppointmentsLinkableToProntoReferralRequest as unknown)[immerable] = true;

export class RejectNewReferralRequest implements IReturn<ResponseBase<boolean>>
{
    public id: string;

    public constructor(init?: Partial<RejectNewReferralRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RejectNewReferralRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(RejectNewReferralRequest as unknown)[immerable] = true;

export class AcceptNewReferralRequest implements IReturn<ResponseBase<boolean>>
{
    public id: string;

    public constructor(init?: Partial<AcceptNewReferralRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AcceptNewReferralRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(AcceptNewReferralRequest as unknown)[immerable] = true;

export class MyClinicWhoReceivesBookingsRequest implements IReturn<ResponseBase<MyClinicWhoReceivesBookingsResponse>>
{
    public firstTimeSetup: boolean;

    public constructor(init?: Partial<MyClinicWhoReceivesBookingsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MyClinicWhoReceivesBookingsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<MyClinicWhoReceivesBookingsResponse>(); }
}
(MyClinicWhoReceivesBookingsRequest as unknown)[immerable] = true;

export class ProntoNetworkSettingsRequest implements IReturn<ResponseBase<ProntoNetworkSettingsResponse>>
{

    public constructor(init?: Partial<ProntoNetworkSettingsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProntoNetworkSettingsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ProntoNetworkSettingsResponse>(); }
}
(ProntoNetworkSettingsRequest as unknown)[immerable] = true;

export class MyClinicSettingsRequest extends ClinicSettings implements IReturn<ResponseBase<ClientWhoReceivesBookingsResponse>>
{
    // @Ignore()
    public clinicId: string;

    // @Ignore()
    public accountName: string;

    public constructor(init?: Partial<MyClinicSettingsRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'MyClinicSettingsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClientWhoReceivesBookingsResponse>(); }
}
(MyClinicSettingsRequest as unknown)[immerable] = true;

export class MyClinicAuthorizationsRequest implements IReturn<ResponseBase<ClientWhoReceivesBookingsResponse>>
{
    public bookerId: string;
    public clinicEnabled: boolean;
    public provisionals: boolean;

    public constructor(init?: Partial<MyClinicAuthorizationsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MyClinicAuthorizationsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClientWhoReceivesBookingsResponse>(); }
}
(MyClinicAuthorizationsRequest as unknown)[immerable] = true;

export class ClinicActivatedOrDeactivatedEmailRequest implements IReturn<ResponseBase<boolean>>
{
    public bookerId: string;
    public clinicId: string;
    public enabled: boolean;

    public constructor(init?: Partial<ClinicActivatedOrDeactivatedEmailRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicActivatedOrDeactivatedEmailRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ClinicActivatedOrDeactivatedEmailRequest as unknown)[immerable] = true;

export class LinkUpGroupRequest implements IReturn<ResponseBase<boolean>>
{
    public groups: GroupLinker[];

    public constructor(init?: Partial<LinkUpGroupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LinkUpGroupRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(LinkUpGroupRequest as unknown)[immerable] = true;

export class RemoveServiceRequest implements IReturn<ResponseBase<boolean>>
{
    public id: string;

    public constructor(init?: Partial<RemoveServiceRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RemoveServiceRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(RemoveServiceRequest as unknown)[immerable] = true;

export class ProntoStockRequest extends ProntoStockDto implements IReturn<ResponseBase<ProntoStockDto>>
{

    public constructor(init?: Partial<ProntoStockRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ProntoStockRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ProntoStockDto>(); }
}
(ProntoStockRequest as unknown)[immerable] = true;

export class SaveServiceRequest extends ClinicService implements IReturn<ResponseBase<ClinicService>>
{
    public targetId: string;

    public constructor(init?: Partial<SaveServiceRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveServiceRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<ClinicService>(); }
}
(SaveServiceRequest as unknown)[immerable] = true;

export class ProntoPortalCardExpiryRequest
{
    public daysDiff: number;
    public lockDate: string;

    public constructor(init?: Partial<ProntoPortalCardExpiryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProntoPortalCardExpiryRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(ProntoPortalCardExpiryRequest as unknown)[immerable] = true;

export class ProntoPortalCardDetailsSaveRequest
{

    public constructor(init?: Partial<ProntoPortalCardDetailsSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProntoPortalCardDetailsSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(ProntoPortalCardDetailsSaveRequest as unknown)[immerable] = true;

// @Route("/reports/clinic-reports/{id}", "GET")
export class ClinicReportsRequestById implements IReturn<ResponseBase<ReportsResponse>>
{
    public id: string;

    public constructor(init?: Partial<ClinicReportsRequestById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicReportsRequestById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ReportsResponse>(); }
}
(ClinicReportsRequestById as unknown)[immerable] = true;

// @Route("/reports/clinic-reports/save", "POST")
export class ClinicReportsSaveRequest implements IReturn<ResponseBase<ReportsResponse>>
{
    public reportId: string;
    public name: string;
    public description: string;
    public data: string;

    public constructor(init?: Partial<ClinicReportsSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicReportsSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ReportsResponse>(); }
}
(ClinicReportsSaveRequest as unknown)[immerable] = true;

// @Route("/reports/clinic-reports/delete")
export class ClinicReportsDeleteRequest
{
    public reportId: string;

    public constructor(init?: Partial<ClinicReportsDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicReportsDeleteRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(ClinicReportsDeleteRequest as unknown)[immerable] = true;

// @Route("/reports")
export class ReportsRequest implements IReturn<ResponseBase<ReportsResponse>>
{

    public constructor(init?: Partial<ReportsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReportsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ReportsResponse>(); }
}
(ReportsRequest as unknown)[immerable] = true;

// @Route("/reports/bespoke")
export class GetBespokeReports implements IReturn<FolderTree>
{

    public constructor(init?: Partial<GetBespokeReports>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetBespokeReports'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FolderTree(); }
}
(GetBespokeReports as unknown)[immerable] = true;

// @Route("/reports/{ReportId}/favourite")
export class ReportsFavouriteRequest
{
    public reportId: string;

    public constructor(init?: Partial<ReportsFavouriteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReportsFavouriteRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(ReportsFavouriteRequest as unknown)[immerable] = true;

// @Route("/reports/{ReportId}/deleteFavourite")
export class ReportsDeleteFavouriteRequest
{
    public reportId: string;

    public constructor(init?: Partial<ReportsDeleteFavouriteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReportsDeleteFavouriteRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(ReportsDeleteFavouriteRequest as unknown)[immerable] = true;

// @Route("/rooms", "GET")
// @Route("/rooms/{Id}", "GET,PUT,DELETE")
export class RoomsRequest implements IReturn<ResponseBase<RoomResponse>>, ILocationId, ISecurityId
{
    public id: number;
    public description: string;
    public locationId: number;
    public status: boolean;
    public hexColour: string;
    public colour?: number;
    public securityId: number;

    public constructor(init?: Partial<RoomsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RoomsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<RoomResponse>(); }
}
(RoomsRequest as unknown)[immerable] = true;

// @Route("/rooms", "PUT")
export class EditRoomsRequest implements IReturn<ResponseBase<RoomResponse>>, ILocationId, ISecurityId
{
    public id: number;
    public description: string;
    public locationId: number;
    public status: boolean;
    public hexColour: string;
    public colour?: number;
    public securityId: number;

    public constructor(init?: Partial<EditRoomsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EditRoomsRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<RoomResponse>(); }
}
(EditRoomsRequest as unknown)[immerable] = true;

// @Route("/rooms", "POST")
export class CreateRoomsRequest implements IReturn<Room>, ILocationId, ISecurityId
{
    public id: number;
    public description: string;
    public locationId: number;
    public status: boolean;
    public hexColour: string;
    public colour?: number;
    public securityId: number;

    public constructor(init?: Partial<CreateRoomsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateRoomsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Room(); }
}
(CreateRoomsRequest as unknown)[immerable] = true;

// @Route("/rooms/search", "POST")
export class RoomSearchRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<RoomResponse>>
{
    public description: string;
    public status?: boolean;

    public constructor(init?: Partial<RoomSearchRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'RoomSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<RoomResponse>(); }
}
(RoomSearchRequest as unknown)[immerable] = true;

// @Route("/rooms/search")
// @Route("/rooms/list")
export class RoomsListRequest implements IReturn<Room[]>, ILocationId
{
    public locationId: number;

    public constructor(init?: Partial<RoomsListRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RoomsListRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Array<Room>(); }
}
(RoomsListRequest as unknown)[immerable] = true;

// @Route("/rooms/count")
export class RoomCountRequest implements IReturn<number>
{

    public constructor(init?: Partial<RoomCountRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RoomCountRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return 0; }
}
(RoomCountRequest as unknown)[immerable] = true;

// @Route("/diary/rooms/{LocationId}")
export class DiaryRoomsRequest implements IReturn<ResponseBase<RoomResponse>>, ILocationId
{
    public locationId: number;

    public constructor(init?: Partial<DiaryRoomsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiaryRoomsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<RoomResponse>(); }
}
(DiaryRoomsRequest as unknown)[immerable] = true;

// @Route("/reporting-fields-service", "POST")
export class ReportingFieldLookupDto implements IReturn<ResponseBase<ReportingFieldLookupDto>>
{
    public id: string;
    public objectType: string;
    public displayName: string;
    public fieldName: string;
    public fieldType: string;
    public propagate: boolean;

    public constructor(init?: Partial<ReportingFieldLookupDto>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReportingFieldLookupDto'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ReportingFieldLookupDto>(); }
}
(ReportingFieldLookupDto as unknown)[immerable] = true;

// @Route("/reporting-fields-service", "GET")
export class GetReportingFieldLookup implements IReturn<ResponseBase<ReportingFieldLookupDto>>
{
    public id: string;

    public constructor(init?: Partial<GetReportingFieldLookup>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetReportingFieldLookup'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ReportingFieldLookupDto>(); }
}
(GetReportingFieldLookup as unknown)[immerable] = true;

export class GroupStockOverrideSaveRequest implements IReturn<ResponseBase<boolean>>, ISecurityId
{
    public groupId: number;
    public stockId: number;
    public parentStockId?: number;
    public locationId?: number;
    public priceExVAT?: number;
    public totalPrice?: number;
    public vatRate?: number;
    public ledgerCode: string;
    public reference: string;
    public billingEntityId?: number;
    public hasBillingEntityOverride: boolean;
    public securityId: number;

    public constructor(init?: Partial<GroupStockOverrideSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupStockOverrideSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(GroupStockOverrideSaveRequest as unknown)[immerable] = true;

export class GroupStockOverrideResetRequest implements IReturn<ResponseBase<boolean>>, ISecurityId
{
    public groupId: number;
    public stockId: number;
    public locationId?: number;
    public securityId: number;

    public constructor(init?: Partial<GroupStockOverrideResetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupStockOverrideResetRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(GroupStockOverrideResetRequest as unknown)[immerable] = true;

// @Route("/price-profiles", "GET")
export class PriceProfileSearchRequest implements IReturn<ResponseBase<PriceProfileResponse>>
{

    public constructor(init?: Partial<PriceProfileSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PriceProfileSearchRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<PriceProfileResponse>(); }
}
(PriceProfileSearchRequest as unknown)[immerable] = true;

// @Route("/price-profiles/{Id}", "GET")
export class GetPriceProfileRequest implements IReturn<ResponseBase<PriceProfileResponse>>
{
    public id: number;

    public constructor(init?: Partial<GetPriceProfileRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPriceProfileRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<PriceProfileResponse>(); }
}
(GetPriceProfileRequest as unknown)[immerable] = true;

// @Route("/price-profiles", "POST")
export class SavePriceProfileRequest implements IReturn<ResponseBase<PriceProfileResponse>>
{
    public id: number;
    public name: string;
    public code: string;
    public json: string;
    public isActive: boolean;

    public constructor(init?: Partial<SavePriceProfileRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SavePriceProfileRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<PriceProfileResponse>(); }
}
(SavePriceProfileRequest as unknown)[immerable] = true;

// @Route("/price-profiles/{Id}", "DELETE")
export class DeletePriceProfileRequest implements IReturn<ResponseBase<boolean>>
{
    public id: number;

    public constructor(init?: Partial<DeletePriceProfileRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeletePriceProfileRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(DeletePriceProfileRequest as unknown)[immerable] = true;

// @Route("/price-profiles/{Id}/groups", "GET")
export class PriceProfileLinkedGroupsRequest implements IReturn<ResponseBase<PriceProfileLinkedGroupResponse>>
{
    public id: number;

    public constructor(init?: Partial<PriceProfileLinkedGroupsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PriceProfileLinkedGroupsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<PriceProfileLinkedGroupResponse>(); }
}
(PriceProfileLinkedGroupsRequest as unknown)[immerable] = true;

// @Route("/price-profiles/{Id}/groups/update", "POST")
export class PriceProfileUpdateLinkedGroupsRequest implements IReturn<ResponseBase<boolean>>
{
    public id: number;

    public constructor(init?: Partial<PriceProfileUpdateLinkedGroupsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PriceProfileUpdateLinkedGroupsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(PriceProfileUpdateLinkedGroupsRequest as unknown)[immerable] = true;

// @Route("/price-profiles/link", "POST")
export class LinkGroupToPriceProfileRequest implements IReturn<ResponseBase<boolean>>
{
    public groupId: number;
    public priceProfileId: number;

    public constructor(init?: Partial<LinkGroupToPriceProfileRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LinkGroupToPriceProfileRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(LinkGroupToPriceProfileRequest as unknown)[immerable] = true;

// @Route("/price-profiles/group/unlink", "POST")
export class UnlinkGroupFromPriceProfileRequest implements IReturn<ResponseBase<boolean>>
{
    public groupId: number;
    public priceProfileId: number;

    public constructor(init?: Partial<UnlinkGroupFromPriceProfileRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UnlinkGroupFromPriceProfileRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(UnlinkGroupFromPriceProfileRequest as unknown)[immerable] = true;

export class StockUpdateFieldBulkActionRequest extends StockBulkActionBaseRequest implements IReturn<ResponseBase<UpdateFieldBulkActionResponse>>
{
    public field: BulkUpdateField;
    public value: string;

    public constructor(init?: Partial<StockUpdateFieldBulkActionRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'StockUpdateFieldBulkActionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<UpdateFieldBulkActionResponse>(); }
}
(StockUpdateFieldBulkActionRequest as unknown)[immerable] = true;

// @Route("/stock/{StockId}")
export class StockRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<StockWithLocationAndTemplatesAndOnlineServiceResponse>>, IGet, IDepartmentIds
{
    public stockId: number;
    public departmentIds: number[];

    public constructor(init?: Partial<StockRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'StockRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<StockWithLocationAndTemplatesAndOnlineServiceResponse>(); }
}
(StockRequest as unknown)[immerable] = true;

// @Route("/stock/location/{LocationId}")
export class StockAtLocationRequest implements IReturn<ResponseBase<StockAtLocationResponse>>, ILocationId
{
    public locationId: number;
    public term: string;

    public constructor(init?: Partial<StockAtLocationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StockAtLocationRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<StockAtLocationResponse>(); }
}
(StockAtLocationRequest as unknown)[immerable] = true;

// @Route("/pricing/groups")
export class StockPricingGroupsRequest
{

    public constructor(init?: Partial<StockPricingGroupsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StockPricingGroupsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(StockPricingGroupsRequest as unknown)[immerable] = true;

// @Route("/stocksave/")
export class StockSave implements IReturn<ResponseBase<StockWithLocationAndTemplatesAndOnlineServiceResponse>>, ILocationIds, IDepartmentIds
{
    public locationIds: number[];
    public requestLocationIds: number[];
    public id: number;
    public reference: string;
    public totalPrice?: number;
    public description: string;
    public appointmentLength: number;
    public groupLocationLocationId: number;
    public locationId?: number;
    public onlineGuid?: string;
    public colourCss: string;
    public inUse?: boolean;
    public priceExVAT?: number;
    public vatRate?: number;
    public vatAmount?: number;
    public costAmount?: number;
    public costVATRate?: number;
    public costExVAT?: number;
    public costVATAmount?: number;
    public longDescription: string;
    public ledgerCode: string;
    public category?: string;
    public batchTraceable?: boolean;
    public level?: number;
    public minimumLevel?: number;
    public displayInPriceList?: boolean;
    public isPrivateCharge?: boolean;
    public isMultiple?: boolean;
    public isClass?: boolean;
    public serviceTypeId?: number;
    public migrated?: boolean;
    public supplierId?: number;
    public stockIsCancel: boolean;
    public stockIsFirst: boolean;
    public stockIsFollowUp: boolean;
    public stockIsDNA: boolean;
    public isVideo?: boolean;
    public managementFee?: boolean;
    public online: boolean;
    public templateSetId?: number;
    public billingEntityId?: number;
    public classification: string;
    public tags: string[];
    public overrides: StockOverrideResponse[];
    public ledgerCodeOverrides: AccountingStockLedgerLookup[];
    public legderCodeAccountId: string;
    public groupName: string;
    public image: string;
    public cancellationCharge?: number;
    public didNotAttendCharge?: number;
    public notes: string;
    public colour?: number;
    public departmentIds: number[];
    public specialismId?: string;
    // @Ignore()
    public templateSetName: string;

    // @Ignore()
    public bookingEmail: string;

    // @Ignore()
    public bookingSMS: string;

    // @Ignore()
    public cancellationEmail: string;

    // @Ignore()
    public cancellationSMS: string;

    // @Ignore()
    public reminderEmail: string;

    // @Ignore()
    public reminderSMS: string;

    // @Ignore()
    public showOnline: boolean;

    // @Ignore()
    public imgSrc: string;

    // @Ignore()
    public fullDescription: string;

    // @Ignore()
    public linkedServiceId: string;

    // @Ignore()
    public onlineCategory?: string;

    public credits?: number;
    public eligibleForTaxExemption: boolean;
    public unitOfIssue: number;
    public paymentOption: number;
    public paymentOptionValue: number;
    public depositPaymentApply: number;
    public locationBased: boolean;
    public barcode: string;

    public constructor(init?: Partial<StockSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StockSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<StockWithLocationAndTemplatesAndOnlineServiceResponse>(); }
}
(StockSave as unknown)[immerable] = true;

// @Route("/all/stock/all")
export class AllStockAllRequest implements IReturn<ResponseBase<StockListResponse>>, ILocationIds
{
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<AllStockAllRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AllStockAllRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<StockListResponse>(); }
}
(AllStockAllRequest as unknown)[immerable] = true;

// @Route("/stock/templateSets")
export class StockExistingTemplateSetsRequest
{

    public constructor(init?: Partial<StockExistingTemplateSetsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StockExistingTemplateSetsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(StockExistingTemplateSetsRequest as unknown)[immerable] = true;

// @Route("/stock/categories")
export class StockOnlineCategoriesRequest implements IReturn<ResponseBase<StockOnlineCategoryResponse>>
{

    public constructor(init?: Partial<StockOnlineCategoriesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StockOnlineCategoriesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<StockOnlineCategoryResponse>(); }
}
(StockOnlineCategoriesRequest as unknown)[immerable] = true;

// @Route("/categorystocksave/")
export class StockWithCategoryRequest implements IReturn<ResponseBase<StockWithCategoryResponse>>, ILocationIds, IDepartmentIds
{
    public locationIds: number[];
    public requestLocationIds: number[];
    public departmentIds: number[];
    public excludedLocations: string[];
    public stock: StockSave;
    public isAvailableOnline: boolean;

    public constructor(init?: Partial<StockWithCategoryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StockWithCategoryRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<StockWithCategoryResponse>(); }
}
(StockWithCategoryRequest as unknown)[immerable] = true;

// @Route("/all/stock")
export class StockExportRequest extends AllStockRequest implements IReturn<ResponseBase<StockWithLocationResponse>>
{

    public constructor(init?: Partial<StockExportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'StockExportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<StockWithLocationResponse>(); }
}
(StockExportRequest as unknown)[immerable] = true;

export class PipedriveStockExportRequest implements IReturn<ResponseBase<T>>
{
    public includeTags: string[];

    public constructor(init?: Partial<PipedriveStockExportRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PipedriveStockExportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(PipedriveStockExportRequest as unknown)[immerable] = true;

export class StockTransferReq implements IReturn<ResponseBase<boolean>>, ILocationIds
{
    public stockId: number;
    public from: number;
    public to: number;
    public batchCode: string;
    public expiryDate?: string;
    public quantity: number;
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<StockTransferReq>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StockTransferReq'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(StockTransferReq as unknown)[immerable] = true;

export class StockInventoryLevelReq implements IReturn<ResponseBase<{ [index:number]: StockInventoryLevelRes[]; }>>, ILocationIds
{
    public stockId: number;
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<StockInventoryLevelReq>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StockInventoryLevelReq'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<{ [index:number]: StockInventoryLevelRes[]; }>(); }
}
(StockInventoryLevelReq as unknown)[immerable] = true;

// @Route("/stock/inventory/delivery", "POST")
export class StockDeliveryRequest implements IReturn<ResponseBase<boolean>>, ILocationIds
{
    public stockId: number;
    public locationId: number;
    public quantity: number;
    public batchCode: string;
    public expiryDate?: string;
    public reason: string;
    public batchTraceable: boolean;
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<StockDeliveryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StockDeliveryRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(StockDeliveryRequest as unknown)[immerable] = true;

// @Route("/stock/inventory/writeoff", "POST")
export class StockWriteOffRequest implements IReturn<ResponseBase<boolean>>, ILocationIds
{
    public levelId: number;
    public locationId: number;
    public quantity: number;
    public reason: string;
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<StockWriteOffRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StockWriteOffRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(StockWriteOffRequest as unknown)[immerable] = true;

export class StockTransactionHistorySearchRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<StockInventoryAdjustmentResponse>>
{
    public stockId: number;
    public locationId?: number;

    public constructor(init?: Partial<StockTransactionHistorySearchRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'StockTransactionHistorySearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<StockInventoryAdjustmentResponse>(); }
}
(StockTransactionHistorySearchRequest as unknown)[immerable] = true;

// @Route("/stock/inventory/batches/{StockId}", "GET")
export class StockInventoryBatchLookupRequest implements IReturn<ResponseBase<StockInventoryBatchResponse>>, ILocationIds
{
    public stockId: number;
    public locationId: number;
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<StockInventoryBatchLookupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StockInventoryBatchLookupRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<StockInventoryBatchResponse>(); }
}
(StockInventoryBatchLookupRequest as unknown)[immerable] = true;

// @Route("/suppliers")
export class SupplierRequest implements IReturn<ResponseBase<T>>
{
    public id?: number;

    public constructor(init?: Partial<SupplierRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SupplierRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(SupplierRequest as unknown)[immerable] = true;

export class SupplierSaveRequest implements IReturn<ResponseBase<SupplierResponse>>, ILocationId
{
    public id: number;
    public reference: string;
    public name: string;
    public contact: string;
    public current: boolean;
    public email: string;
    public telephone: string;
    public web: string;
    public locationId: number;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public addressLine5: string;
    public postCode: string;
    public accountNo: string;
    public vatNumber: string;

    public constructor(init?: Partial<SupplierSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SupplierSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SupplierResponse>(); }
}
(SupplierSaveRequest as unknown)[immerable] = true;

export class SuppliersAdvancedSearchRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<SupplierResponse>>
{
    public status?: boolean;
    public address: string;
    public reference: string;
    public locationId?: number;
    public locationMulti: number[];
    public name: string;
    public accountNo: string;

    public constructor(init?: Partial<SuppliersAdvancedSearchRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SuppliersAdvancedSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SupplierResponse>(); }
}
(SuppliersAdvancedSearchRequest as unknown)[immerable] = true;

// @Route("/audit/search")
export class AuditSearchRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<AuditResponse>>
{
    public customerId: number;
    public objectId?: number;
    public objectType: string;
    public action: string;
    public actionDetail: string;
    public user: string;
    public date: DateRange;

    public constructor(init?: Partial<AuditSearchRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'AuditSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AuditResponse>(); }
}
(AuditSearchRequest as unknown)[immerable] = true;

// @Route("/audit/add")
export class AuditAddRequest implements IReturn<ResponseBase<boolean>>
{
    public objectId: number;
    public customerId?: number;
    public objectType: string;
    public action: string;
    public actionDetail: string;

    public constructor(init?: Partial<AuditAddRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AuditAddRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(AuditAddRequest as unknown)[immerable] = true;

// @Route("/cache/load", "POST")
export class CacheRequest implements IReturn<ResponseBase<CacheResponse>>
{
    public cachedUserId: number;
    public keys: { [index:string]: string; };

    public constructor(init?: Partial<CacheRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CacheRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CacheResponse>(); }
}
(CacheRequest as unknown)[immerable] = true;

export class LookupCacheRequest extends SingleCacheRequest implements IReturn<ResponseBase<LookupCacheResponse>>
{

    public constructor(init?: Partial<LookupCacheRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'LookupCacheRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<LookupCacheResponse>(); }
}
(LookupCacheRequest as unknown)[immerable] = true;

// @Route("/sys/dictionary/all", "Get")
export class DictionaryRequestAll implements IReturn<ResponseBase<SystemDictionary>>
{

    public constructor(init?: Partial<DictionaryRequestAll>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DictionaryRequestAll'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<SystemDictionary>(); }
}
(DictionaryRequestAll as unknown)[immerable] = true;

// @Route("/settings/labels/save")
export class DynamicLabelUpdate implements IReturn<ResponseBase<DynamicLabelResponse>>
{
    public labels: LabelItem[];

    public constructor(init?: Partial<DynamicLabelUpdate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DynamicLabelUpdate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<DynamicLabelResponse>(); }
}
(DynamicLabelUpdate as unknown)[immerable] = true;

// @Route("/extended/notes")
// @Route("/extended/notes/{NoteId}")
export class ExtendedNotesRequest implements IReturn<ResponseBase<ExtendedNotesResponse>>, ISecurityLocator, IDepartmentIds
{
    public skip: number;
    public take: number;
    public noteId: number;
    public departmentIds: number[];

    public constructor(init?: Partial<ExtendedNotesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExtendedNotesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ExtendedNotesResponse>(); }
}
(ExtendedNotesRequest as unknown)[immerable] = true;

// @Route("/extended/notes/delete", "POST")
export class ExtendedNotesDeleteRequest implements IReturn<ResponseBase<boolean>>, ILocationId, IFilterServiceTypeManually, ISecurityType
{
    public id: number;
    public locationId: number;
    public type: string;
    public securityType: string;

    public constructor(init?: Partial<ExtendedNotesDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExtendedNotesDeleteRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ExtendedNotesDeleteRequest as unknown)[immerable] = true;

// @Route("/group/notes/{Id}", "GET")
export class GroupExtendedNotesRequest implements IReturn<ResponseBase<ExtendedNotesResponse>>, ILocationId
{
    public skip: number;
    public take: number;
    public id: number;
    public locationId: number;

    public constructor(init?: Partial<GroupExtendedNotesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GroupExtendedNotesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ExtendedNotesResponse>(); }
}
(GroupExtendedNotesRequest as unknown)[immerable] = true;

// @Route("/medicalcontact/notes/{ContactId}", "GET")
export class MedicalContactExtendedNotesRequest implements IReturn<ResponseBase<ExtendedNotesResponse>>, ILocationId
{
    public skip: number;
    public take: number;
    public contactId: number;
    public locationId: number;

    public constructor(init?: Partial<MedicalContactExtendedNotesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MedicalContactExtendedNotesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ExtendedNotesResponse>(); }
}
(MedicalContactExtendedNotesRequest as unknown)[immerable] = true;

// @Route("/practitioner/notes/{PractitionerId}")
export class PractitionerExtendedNotesRequest implements IReturn<ResponseBase<ExtendedNotesWithUserName>>, ISecurityId
{
    public skip: number;
    public take: number;
    public practitionerId: number;
    public securityId: number;

    public constructor(init?: Partial<PractitionerExtendedNotesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PractitionerExtendedNotesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ExtendedNotesWithUserName>(); }
}
(PractitionerExtendedNotesRequest as unknown)[immerable] = true;

// @Route("/network-management/businesses/notes/{id}", "GET")
export class NMBusinessExtendedNotesRequest implements IReturn<ResponseBase<ExtendedNotesResponse>>
{
    public businessId: string;
    public alertsOnly: boolean;

    public constructor(init?: Partial<NMBusinessExtendedNotesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'NMBusinessExtendedNotesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ExtendedNotesResponse>(); }
}
(NMBusinessExtendedNotesRequest as unknown)[immerable] = true;

// @Route("/workflow/notes/{WorkflowId}", "GET")
export class WorkflowExtendedNotesRequest implements IReturn<ResponseBase<ExtendedNotesResponse>>
{
    public workflowId: number;
    public skip?: number;
    public take?: number;
    public requiresAcknowledgement: boolean;

    public constructor(init?: Partial<WorkflowExtendedNotesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WorkflowExtendedNotesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ExtendedNotesResponse>(); }
}
(WorkflowExtendedNotesRequest as unknown)[immerable] = true;

// @Route("/extended/notesave/")
export class ExtendedNotesSave implements IReturn<ResponseBase<ExtendedNotesResponse>>, ISecurityId, ISecurityType, IFilterServiceTypeManually, ISecurityGuid
{
    public id: number;
    public type: string;
    public typeId: string;
    public icon: string;
    public colour: string;
    public typeGuid: string;
    public title: string;
    public entry: string;
    public noteType: string;
    public lastModified: string;
    public lockMode: string;
    public lockValue: number;
    public alert: boolean;
    public securityId: number;
    public securityType: string;
    public serviceTypeId?: number;
    public securityGuid: string;
    public acknowledgementRequired?: boolean;
    public alertExpiryDate?: string;
    public alertStartDate?: string;
    public contextObjectType?: TimelineContextObjectType;
    public contextId?: number;
    public linkedObjectType: TimelineLinkedObjectType;
    public linkedObjectId?: number;
    public printOnDocument?: boolean;

    public constructor(init?: Partial<ExtendedNotesSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExtendedNotesSave'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<ExtendedNotesResponse>(); }
}
(ExtendedNotesSave as unknown)[immerable] = true;

export class MultiExtendedNotesSave
{
    public linkedObjectId: number;
    public notes: ExtendedNotesSave[];

    public constructor(init?: Partial<MultiExtendedNotesSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MultiExtendedNotesSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(MultiExtendedNotesSave as unknown)[immerable] = true;

// @Route("/locks/clear")
export class LockClearRequest
{

    public constructor(init?: Partial<LockClearRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LockClearRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(LockClearRequest as unknown)[immerable] = true;

// @Route("/lock/request")
export class LockObtainRequest implements IReturnVoid
{
    public objectType: string;
    public objectId: number;

    public constructor(init?: Partial<LockObtainRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LockObtainRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(LockObtainRequest as unknown)[immerable] = true;

// @Route("/lock/release")
export class LockReleaseRequest
{
    public objectType: string;
    public objectId: number;

    public constructor(init?: Partial<LockReleaseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LockReleaseRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(LockReleaseRequest as unknown)[immerable] = true;

// @Route("/lock/release/user")
export class LockReleaseByUserRequest
{

    public constructor(init?: Partial<LockReleaseByUserRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LockReleaseByUserRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(LockReleaseByUserRequest as unknown)[immerable] = true;

// @Route("/lock/same")
export class LockSameRequest
{
    public id: number;
    public type: string;
    public startDateTime: string;
    public endDateTime?: string;
    public status: number;
    public practitionerId: number;
    public locationId: number;
    public roomId: number;
    public name: string;
    public description: string;

    public constructor(init?: Partial<LockSameRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LockSameRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(LockSameRequest as unknown)[immerable] = true;

// @Route("/lookup")
export class LookupRequest implements IReturn<ResponseBase<LookupResponse>>
{
    public lookUpType: string;

    public constructor(init?: Partial<LookupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LookupRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<LookupResponse>(); }
}
(LookupRequest as unknown)[immerable] = true;

// @Route("/lookups/all")
export class AllLookupRequest implements IReturn<ResponseBase<LookupResponse>>, ILocationIds
{
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<AllLookupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AllLookupRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<LookupResponse>(); }
}
(AllLookupRequest as unknown)[immerable] = true;

export class NestedLookupsFromTemplateRequest implements IReturn<ResponseBase<NestedLookupResponse>>
{
    public templateId: string;

    public constructor(init?: Partial<NestedLookupsFromTemplateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'NestedLookupsFromTemplateRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<NestedLookupResponse>(); }
}
(NestedLookupsFromTemplateRequest as unknown)[immerable] = true;

// @Route("/lookups/regional")
export class RegionalLookupRequest implements IReturn<ResponseBase<RegionalLookup>>
{

    public constructor(init?: Partial<RegionalLookupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegionalLookupRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<RegionalLookup>(); }
}
(RegionalLookupRequest as unknown)[immerable] = true;

// @Route("/lookups/add")
export class AddLookupItem implements IReturn<ResponseBase<LookupResponse>>, ILocationId
{
    public lookupId: number;
    public name: string;
    public value: string;
    public locationId: number;

    public constructor(init?: Partial<AddLookupItem>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddLookupItem'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<LookupResponse>(); }
}
(AddLookupItem as unknown)[immerable] = true;

// @Route("/lookups/delete")
export class DeleteLookupItem implements IReturn<ResponseBase<LookupResponse>>
{
    public name: string;
    public value: string;

    public constructor(init?: Partial<DeleteLookupItem>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteLookupItem'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<LookupResponse>(); }
}
(DeleteLookupItem as unknown)[immerable] = true;

// @Route("/lookups/{Id}")
export class LookupItem implements IReturn<ResponseBase<LookupResponse>>
{
    public id: number;
    public name: string;
    public value: string;

    public constructor(init?: Partial<LookupItem>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LookupItem'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<LookupResponse>(); }
}
(LookupItem as unknown)[immerable] = true;

export class GetAllSystemNotifications implements IReturn<ResponseBase<SystemNotificationResponse>>
{
    public includeRead: boolean;
    public skip?: number;
    public take?: number;

    public constructor(init?: Partial<GetAllSystemNotifications>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAllSystemNotifications'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<SystemNotificationResponse>(); }
}
(GetAllSystemNotifications as unknown)[immerable] = true;

export class MarkNotificationRead implements IReturn<ResponseBase<T>>
{
    public id: number;

    public constructor(init?: Partial<MarkNotificationRead>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MarkNotificationRead'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(MarkNotificationRead as unknown)[immerable] = true;

export class BatchMarkNotificationRead implements IReturn<ResponseBase<T>>
{
    public ids: number[];

    public constructor(init?: Partial<BatchMarkNotificationRead>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BatchMarkNotificationRead'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(BatchMarkNotificationRead as unknown)[immerable] = true;

// @Route("/patterns", "GET")
export class PatternRequest implements IReturn<ResponseBase<{ [index:string]: string; }>>
{

    public constructor(init?: Partial<PatternRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatternRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<{ [index:string]: string; }>(); }
}
(PatternRequest as unknown)[immerable] = true;

// @Route("/security-stats")
export class SecurityStatsRequest implements IReturn<SecurityStatsResponse>
{

    public constructor(init?: Partial<SecurityStatsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SecurityStatsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SecurityStatsResponse(); }
}
(SecurityStatsRequest as unknown)[immerable] = true;

// @Route("/system/message", "GET")
export class SystemMessageRequest
{

    public constructor(init?: Partial<SystemMessageRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemMessageRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(SystemMessageRequest as unknown)[immerable] = true;

// @Route("/system/message/acknowledge", "POST")
export class AcknowledgeSystemMessageRequest
{
    public messageIds: number[];

    public constructor(init?: Partial<AcknowledgeSystemMessageRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AcknowledgeSystemMessageRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(AcknowledgeSystemMessageRequest as unknown)[immerable] = true;

// @Route("/sys/labels/all")
export class DynamicLblRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<DynamicLblRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DynamicLblRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}

// @Route("/task/{Id}")
export class TaskRequest implements IReturn<ResponseBase<TaskResponse>>, ILocationId, ISecurityId
{
    public id?: number;
    public ids: number[];
    public locationId: number;
    public securityId: number;

    public constructor(init?: Partial<TaskRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TaskRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<TaskResponse>(); }
}
(TaskRequest as unknown)[immerable] = true;

// @Route("/tasks/current/{LocationId}", "GET")
export class AllCurrentTasksRequest implements IReturn<TaskForUser[]>, ILocationId
{
    public locationId: number;

    public constructor(init?: Partial<AllCurrentTasksRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AllCurrentTasksRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Array<TaskForUser>(); }
}
(AllCurrentTasksRequest as unknown)[immerable] = true;

export class DeleteTaskRequest implements IReturn<ResponseBase<boolean>>, ISecurityId
{
    public id: number;
    public securityId: number;

    public constructor(init?: Partial<DeleteTaskRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteTaskRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(DeleteTaskRequest as unknown)[immerable] = true;

// @Route("/tasks/availableUsers", "GET")
export class TasksAvailableUsers implements IReturn<UserRoleLocationWithUserName[]>, ILocationIds
{
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<TasksAvailableUsers>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TasksAvailableUsers'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Array<UserRoleLocationWithUserName>(); }
}
(TasksAvailableUsers as unknown)[immerable] = true;

// @Route("/user/{Id}/tasks")
export class UserTaskRequest implements IReturn<ResponseBase<TaskResponse>>, ISecurityId
{
    public id: number;
    public startDate?: string;
    public endDate?: string;
    public securityId: number;
    public autoRefresh: boolean;

    public constructor(init?: Partial<UserTaskRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UserTaskRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<TaskResponse>(); }
}
(UserTaskRequest as unknown)[immerable] = true;

// @Route("/task", "POST")
// @Route("/task/{Id}", "PUT")
export class TaskSaveRequest extends TaskForUser implements IReturn<ResponseBase<TaskResponse>>
{
    public checklistItems: TaskChecklistTemplateStepDto[];

    public constructor(init?: Partial<TaskSaveRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TaskSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TaskResponse>(); }
}
(TaskSaveRequest as unknown)[immerable] = true;

// @Route("/user/tasks/search", "POST")
export class UserTasksSearchRequest implements IReturn<ResponseBase<TaskResponse>>, ISecurityId
{
    public term: string;
    public id: number;
    public securityId: number;
    public includeFuture: boolean;
    public showCompleted: boolean;
    public showOverdue: boolean;
    public includeChecklistTasks: boolean;
    public date: string;
    public orderByDescending?: boolean;
    public skip: number;
    public take: number;
    public highPriority: boolean;
    public teamId?: string;

    public constructor(init?: Partial<UserTasksSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UserTasksSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TaskResponse>(); }
}
(UserTasksSearchRequest as unknown)[immerable] = true;

// @Route("/task/advanced-search", "POST")
export class TaskAdvancedSearchRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<TaskResponse>>
{
    public patientId?: number;

    public constructor(init?: Partial<TaskAdvancedSearchRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TaskAdvancedSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TaskResponse>(); }
}
(TaskAdvancedSearchRequest as unknown)[immerable] = true;

export class TaskCountRequest implements IReturn<ResponseBase<number>>
{

    public constructor(init?: Partial<TaskCountRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TaskCountRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<number>(); }
}
(TaskCountRequest as unknown)[immerable] = true;

// @Route("/task/sidebar-counts", "GET")
export class TaskSidebarCountsRequest implements IReturn<ResponseBase<TaskSidebarCountsResponse>>
{
    public date: string;

    public constructor(init?: Partial<TaskSidebarCountsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TaskSidebarCountsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<TaskSidebarCountsResponse>(); }
}
(TaskSidebarCountsRequest as unknown)[immerable] = true;

// @Route("/trial/status", "GET")
export class GetTrialStatus implements IReturn<ResponseBase<TrialStatusDto>>
{

    public constructor(init?: Partial<GetTrialStatus>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialStatus'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<TrialStatusDto>(); }
}
(GetTrialStatus as unknown)[immerable] = true;

// @Route("/trial/start", "POST")
export class StartTrial implements IReturn<ResponseBase<TrialStatusDto>>
{

    public constructor(init?: Partial<StartTrial>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StartTrial'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TrialStatusDto>(); }
}
(StartTrial as unknown)[immerable] = true;

// @Route("/trial/usage", "POST")
export class AddTrialUsage implements IReturn<ResponseBase<TrialStatusDto>>
{
    public seconds: number;

    public constructor(init?: Partial<AddTrialUsage>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddTrialUsage'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TrialStatusDto>(); }
}
(AddTrialUsage as unknown)[immerable] = true;

// @Route("/subscription/upgrade", "POST")
export class UpgradeSubscription implements IReturn<ResponseBase<UpgradeResultDto>>
{
    public idempotencyKey: string;

    public constructor(init?: Partial<UpgradeSubscription>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpgradeSubscription'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<UpgradeResultDto>(); }
}
(UpgradeSubscription as unknown)[immerable] = true;

// @Route("/trial/request-upgrade", "POST")
export class RequestUpgrade implements IReturn<ResponseBase<RequestUpgradeResponse>>
{
    public featureName: string;

    public constructor(init?: Partial<RequestUpgrade>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RequestUpgrade'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<RequestUpgradeResponse>(); }
}
(RequestUpgrade as unknown)[immerable] = true;

// @Route("/ai-summary/status", "GET")
export class GetAiSummaryStatus implements IReturn<ResponseBase<AiSummaryStatusDto>>
{

    public constructor(init?: Partial<GetAiSummaryStatus>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAiSummaryStatus'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<AiSummaryStatusDto>(); }
}
(GetAiSummaryStatus as unknown)[immerable] = true;

export class TrialCancellationRequest implements IReturn<ResponseBase<boolean>>
{
    public comments: string;

    public constructor(init?: Partial<TrialCancellationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TrialCancellationRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(TrialCancellationRequest as unknown)[immerable] = true;

// @Route("/transcription/batch", "POST")
export class BatchTranscriptionRequest implements IReturn<ResponseBase<BatchTranscriptionResultDto>>
{
    public language: string;

    public constructor(init?: Partial<BatchTranscriptionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BatchTranscriptionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<BatchTranscriptionResultDto>(); }
}
(BatchTranscriptionRequest as unknown)[immerable] = true;

// @Route("/transcription/batch/{JobId}", "GET")
export class BatchTranscriptionStatusRequest implements IReturn<ResponseBase<BatchTranscriptionResultDto>>
{
    public jobId: string;

    public constructor(init?: Partial<BatchTranscriptionStatusRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BatchTranscriptionStatusRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<BatchTranscriptionResultDto>(); }
}
(BatchTranscriptionStatusRequest as unknown)[immerable] = true;

// @Route("/transcription/ticket", "POST")
export class TranscriptionTicketRequest implements IReturn<ResponseBase<TranscriptionTicketResultDto>>
{

    public constructor(init?: Partial<TranscriptionTicketRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TranscriptionTicketRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TranscriptionTicketResultDto>(); }
}
(TranscriptionTicketRequest as unknown)[immerable] = true;

// @Route("/tasks/target/{TargetType}/{TargetId}", "GET")
export class TaskChecklistByTargetRequest implements IReturn<ResponseBase<TaskResponse>>, ISecurityId, ISecurityType
{
    public targetType: string;
    public targetId: number;
    public includeCompleted: boolean;
    public includeAllTasks: boolean;
    public securityId: number;
    public securityType: string;

    public constructor(init?: Partial<TaskChecklistByTargetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TaskChecklistByTargetRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<TaskResponse>(); }
}
(TaskChecklistByTargetRequest as unknown)[immerable] = true;

// @Route("/task/{TaskId}/checklist", "GET")
export class TaskChecklistItemsRequest implements IReturn<ResponseBase<TaskChecklistItemDto>>, ISecurityId
{
    public taskId: number;
    public securityId: number;

    public constructor(init?: Partial<TaskChecklistItemsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TaskChecklistItemsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<TaskChecklistItemDto>(); }
}
(TaskChecklistItemsRequest as unknown)[immerable] = true;

// @Route("/task/{TaskId}/checklist", "POST")
export class TaskChecklistItemCreateRequest implements IReturn<ResponseBase<TaskChecklistItemDto>>, ISecurityId
{
    public taskId: number;
    public text: string;
    public sortOrder?: number;
    public stepType: string;
    public stepPayloadJson: string;
    public securityId: number;

    public constructor(init?: Partial<TaskChecklistItemCreateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TaskChecklistItemCreateRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TaskChecklistItemDto>(); }
}
(TaskChecklistItemCreateRequest as unknown)[immerable] = true;

// @Route("/task/{TaskId}/checklist/{ItemId}", "PUT")
export class TaskChecklistItemUpdateRequest implements IReturn<ResponseBase<TaskChecklistItemDto>>, ISecurityId
{
    public taskId: number;
    public itemId: number;
    public text: string;
    public isDone?: boolean;
    public sortOrder?: number;
    public stepType: string;
    public stepPayloadJson: string;
    public securityId: number;

    public constructor(init?: Partial<TaskChecklistItemUpdateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TaskChecklistItemUpdateRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<TaskChecklistItemDto>(); }
}
(TaskChecklistItemUpdateRequest as unknown)[immerable] = true;

// @Route("/task/{TaskId}/checklist/{ItemId}", "DELETE")
export class TaskChecklistItemDeleteRequest implements IReturn<ResponseBase<boolean>>, ISecurityId
{
    public taskId: number;
    public itemId: number;
    public securityId: number;

    public constructor(init?: Partial<TaskChecklistItemDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TaskChecklistItemDeleteRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(TaskChecklistItemDeleteRequest as unknown)[immerable] = true;

// @Route("/taskChecklistTemplates", "GET")
export class TaskChecklistTemplatesRequest implements IReturn<ResponseBase<TaskChecklistTemplateDto>>
{
    public id?: number;
    public includeSteps: boolean;

    public constructor(init?: Partial<TaskChecklistTemplatesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TaskChecklistTemplatesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<TaskChecklistTemplateDto>(); }
}
(TaskChecklistTemplatesRequest as unknown)[immerable] = true;

// @Route("/taskChecklistTemplates", "POST")
// @Route("/taskChecklistTemplates/{Id}", "PUT")
export class TaskChecklistTemplateSaveRequest implements IReturn<ResponseBase<TaskChecklistTemplateDto>>
{
    public id: number;
    public name: string;
    public description: string;
    public taskDescription: string;
    public taskKind: string;
    public isActive?: boolean;

    public constructor(init?: Partial<TaskChecklistTemplateSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TaskChecklistTemplateSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TaskChecklistTemplateDto>(); }
}
(TaskChecklistTemplateSaveRequest as unknown)[immerable] = true;

// @Route("/taskChecklistTemplates/{Id}", "DELETE")
export class TaskChecklistTemplateDeleteRequest implements IReturn<ResponseBase<boolean>>
{
    public id: number;

    public constructor(init?: Partial<TaskChecklistTemplateDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TaskChecklistTemplateDeleteRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(TaskChecklistTemplateDeleteRequest as unknown)[immerable] = true;

// @Route("/taskChecklistTemplates/{Id}/steps", "PUT")
export class TaskChecklistTemplateStepsSaveRequest implements IReturn<ResponseBase<TaskChecklistTemplateDto>>
{
    public id: number;
    public steps: TaskChecklistTemplateStepDto[];

    public constructor(init?: Partial<TaskChecklistTemplateStepsSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TaskChecklistTemplateStepsSaveRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<TaskChecklistTemplateDto>(); }
}
(TaskChecklistTemplateStepsSaveRequest as unknown)[immerable] = true;

// @Route("/taskChecklistTemplates/{Id}/apply", "POST")
export class TaskChecklistTemplateApplyRequest implements IReturn<ResponseBase<TaskResponse>>
{
    public id: number;
    public targetType: string;
    public targetId: number;
    public targetContext: string;
    public taskDescription: string;
    public dueDate?: string;
    public assignmentStrategy: string;
    public assignmentUserId?: number;
    public assignmentTeamId?: string;
    public assignmentWorkType: string;
    public originKey: string;

    public constructor(init?: Partial<TaskChecklistTemplateApplyRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TaskChecklistTemplateApplyRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TaskResponse>(); }
}
(TaskChecklistTemplateApplyRequest as unknown)[immerable] = true;

// @Route("/taskChecklistAutoRules", "GET")
export class TaskChecklistAutoRulesRequest implements IReturn<ResponseBase<TaskChecklistAutoRuleDto>>
{
    public id?: number;
    public includeTemplates: boolean;

    public constructor(init?: Partial<TaskChecklistAutoRulesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TaskChecklistAutoRulesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<TaskChecklistAutoRuleDto>(); }
}
(TaskChecklistAutoRulesRequest as unknown)[immerable] = true;

// @Route("/taskChecklistAutoRules", "POST")
// @Route("/taskChecklistAutoRules/{Id}", "PUT")
export class TaskChecklistAutoRuleSaveRequest implements IReturn<ResponseBase<TaskChecklistAutoRuleDto>>
{
    public id: number;
    public name: string;
    public triggerType: string;
    public caseStatus?: number;
    public appointmentStockId?: number;
    public assignmentStrategy: string;
    public assignmentUserId?: number;
    public assignmentTeamId?: string;
    public assignmentWorkType: string;
    public dueDateMode: string;
    public dueDaysOffset?: number;
    public taskPriority?: boolean;
    public sendReminder?: boolean;
    public isActive?: boolean;
    public templateIds: number[];

    public constructor(init?: Partial<TaskChecklistAutoRuleSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TaskChecklistAutoRuleSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TaskChecklistAutoRuleDto>(); }
}
(TaskChecklistAutoRuleSaveRequest as unknown)[immerable] = true;

// @Route("/taskChecklistAutoRules/{Id}", "DELETE")
export class TaskChecklistAutoRuleDeleteRequest implements IReturn<ResponseBase<boolean>>
{
    public id: number;

    public constructor(init?: Partial<TaskChecklistAutoRuleDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TaskChecklistAutoRuleDeleteRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(TaskChecklistAutoRuleDeleteRequest as unknown)[immerable] = true;

// @Route("/taskChecklistRecurringRules", "GET")
export class TaskChecklistRecurringRulesRequest implements IReturn<ResponseBase<TaskChecklistRecurringRuleDto>>
{
    public id?: number;
    public includeUsers: boolean;

    public constructor(init?: Partial<TaskChecklistRecurringRulesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TaskChecklistRecurringRulesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<TaskChecklistRecurringRuleDto>(); }
}
(TaskChecklistRecurringRulesRequest as unknown)[immerable] = true;

// @Route("/taskChecklistRecurringRules", "POST")
// @Route("/taskChecklistRecurringRules/{Id}", "PUT")
export class TaskChecklistRecurringRuleSaveRequest implements IReturn<ResponseBase<TaskChecklistRecurringRuleDto>>
{
    public id: number;
    public name: string;
    public taskDescription: string;
    public templateId?: number;
    public intervalType: string;
    public weeklyDayOfWeek?: number;
    public monthlyMode: string;
    public monthlyDayOfMonth?: number;
    public dueTime: string;
    public startDate?: string;
    public endDate?: string;
    public isActive?: boolean;
    public userIds: number[];

    public constructor(init?: Partial<TaskChecklistRecurringRuleSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TaskChecklistRecurringRuleSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TaskChecklistRecurringRuleDto>(); }
}
(TaskChecklistRecurringRuleSaveRequest as unknown)[immerable] = true;

// @Route("/taskChecklistRecurringRules/{Id}", "DELETE")
export class TaskChecklistRecurringRuleDeleteRequest implements IReturn<ResponseBase<boolean>>
{
    public id: number;

    public constructor(init?: Partial<TaskChecklistRecurringRuleDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TaskChecklistRecurringRuleDeleteRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(TaskChecklistRecurringRuleDeleteRequest as unknown)[immerable] = true;

// @Route("/taskChecklistAssignmentDefaults", "GET")
export class TaskChecklistAssignmentDefaultsRequest implements IReturn<ResponseBase<TaskChecklistAssignmentDefaultDto>>
{

    public constructor(init?: Partial<TaskChecklistAssignmentDefaultsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TaskChecklistAssignmentDefaultsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<TaskChecklistAssignmentDefaultDto>(); }
}
(TaskChecklistAssignmentDefaultsRequest as unknown)[immerable] = true;

// @Route("/taskChecklistAssignmentDefaults", "PUT")
export class TaskChecklistAssignmentDefaultsSaveRequest implements IReturn<ResponseBase<TaskChecklistAssignmentDefaultDto>>
{
    public defaults: TaskChecklistAssignmentDefaultDto[];

    public constructor(init?: Partial<TaskChecklistAssignmentDefaultsSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TaskChecklistAssignmentDefaultsSaveRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<TaskChecklistAssignmentDefaultDto>(); }
}
(TaskChecklistAssignmentDefaultsSaveRequest as unknown)[immerable] = true;

// @Route("/subdomain/clientId")
export class CorrectSubdomainRequest
{
    public clientId: string;
    public email: string;

    public constructor(init?: Partial<CorrectSubdomainRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CorrectSubdomainRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(CorrectSubdomainRequest as unknown)[immerable] = true;

export class DisconnectSsoProviderRequest extends ResponseBase<boolean> implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<DisconnectSsoProviderRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'DisconnectSsoProviderRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(DisconnectSsoProviderRequest as unknown)[immerable] = true;

export class GetSsoProviderInfoRequest extends ResponseBase<GetSsoProviderInfoResponse> implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<GetSsoProviderInfoRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSsoProviderInfoRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetSsoProviderInfoRequest as unknown)[immerable] = true;

// @Route("/settings/procedures/search", "POST")
export class AllProceduresRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<ProcedureResponse>>
{

    public constructor(init?: Partial<AllProceduresRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'AllProceduresRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ProcedureResponse>(); }
}
(AllProceduresRequest as unknown)[immerable] = true;

// @Route("/settings/procedures/{Id}", "GET")
export class GetProcedureRequest implements IReturn<ResponseBase<ProcedureResponse>>
{
    public id: number;

    public constructor(init?: Partial<GetProcedureRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetProcedureRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ProcedureResponse>(); }
}
(GetProcedureRequest as unknown)[immerable] = true;

// @Route("/settings/procedures", "POST")
// @Route("/settings/procedures/{Id}", "PUT")
export class SaveProcedureRequest implements IReturn<ResponseBase<ProcedureResponse>>
{
    public id?: number;
    public name: string;
    public code: string;
    public bodyPart: string;
    public connectDisplayName: string;
    public locationIds: number[];
    public modalityId?: number;
    public stockItemId?: number;
    public durationMinutes?: number;

    public constructor(init?: Partial<SaveProcedureRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveProcedureRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ProcedureResponse>(); }
}
(SaveProcedureRequest as unknown)[immerable] = true;

// @Route("/settings/procedures/{Id}", "DELETE")
export class DeleteProcedureRequest implements IReturn<ResponseBase<boolean>>
{
    public id: number;

    public constructor(init?: Partial<DeleteProcedureRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteProcedureRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(DeleteProcedureRequest as unknown)[immerable] = true;

// @Route("/settings/clinical/scores-goals/search", "POST")
export class ScoresGoalsSettingsSearchRequest implements IReturn<ResponseBase<ScoresGoalsSettingsResponse>>
{

    public constructor(init?: Partial<ScoresGoalsSettingsSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScoresGoalsSettingsSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ScoresGoalsSettingsResponse>(); }
}
(ScoresGoalsSettingsSearchRequest as unknown)[immerable] = true;

// @Route("/settings/clinical/scores-goals/{Id}", "GET")
export class ScoresGoalsSettingsGetRequest implements IReturn<ResponseBase<ScoresGoalsSettingsResponse>>
{
    public id: number;

    public constructor(init?: Partial<ScoresGoalsSettingsGetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScoresGoalsSettingsGetRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ScoresGoalsSettingsResponse>(); }
}
(ScoresGoalsSettingsGetRequest as unknown)[immerable] = true;

// @Route("/settings/clinical/scores-goals/", "POST")
export class ScoresGoalsSettingsPostRequest extends ScoresGoalsSettingsRequest implements IReturn<ResponseBase<ScoresGoalsSettingsResponse>>
{

    public constructor(init?: Partial<ScoresGoalsSettingsPostRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ScoresGoalsSettingsPostRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ScoresGoalsSettingsResponse>(); }
}
(ScoresGoalsSettingsPostRequest as unknown)[immerable] = true;

// @Route("/settings/clinical/scores-goals/{Id}", "PUT")
export class ScoresGoalsSettingsPutRequest extends ScoresGoalsSettingsRequest implements IReturn<ResponseBase<ScoresGoalsSettingsResponse>>
{

    public constructor(init?: Partial<ScoresGoalsSettingsPutRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ScoresGoalsSettingsPutRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<ScoresGoalsSettingsResponse>(); }
}
(ScoresGoalsSettingsPutRequest as unknown)[immerable] = true;

// @Route("/settings/clinical/scores-goals/{Id}", "DELETE")
export class ScoresGoalsSettingsDeleteRequest implements IReturn<ResponseBase<boolean>>
{
    public id: number;

    public constructor(init?: Partial<ScoresGoalsSettingsDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScoresGoalsSettingsDeleteRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ScoresGoalsSettingsDeleteRequest as unknown)[immerable] = true;

export class AdjustNumberOfDiariesRequest implements IReturn<ResponseBase<T>>
{
    public numberOfDiaries: number;

    public constructor(init?: Partial<AdjustNumberOfDiariesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdjustNumberOfDiariesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(AdjustNumberOfDiariesRequest as unknown)[immerable] = true;

export class GetDomainsRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<GetDomainsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDomainsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetDomainsRequest as unknown)[immerable] = true;

export class GetDomainsAuthenticationStatusRequest implements IReturn<ResponseBase<DomainAuthenticationStatusResponse>>
{
    public domains: string[];

    public constructor(init?: Partial<GetDomainsAuthenticationStatusRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDomainsAuthenticationStatusRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<DomainAuthenticationStatusResponse>(); }
}
(GetDomainsAuthenticationStatusRequest as unknown)[immerable] = true;

export class AuthenticateDomainRequest implements IReturn<ResponseBase<AuthenticateDomainResponse>>
{
    public domain: string;
    public id: number;

    public constructor(init?: Partial<AuthenticateDomainRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AuthenticateDomainRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AuthenticateDomainResponse>(); }
}
(AuthenticateDomainRequest as unknown)[immerable] = true;

export class ValidateDomainRequest implements IReturn<ResponseBase<ValidateDomainResponse>>
{
    public id: number;

    public constructor(init?: Partial<ValidateDomainRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateDomainRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ValidateDomainResponse>(); }
}
(ValidateDomainRequest as unknown)[immerable] = true;

export class DMARCWarningRequest implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<DMARCWarningRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DMARCWarningRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(DMARCWarningRequest as unknown)[immerable] = true;

export class DMARCAcknowledgementRequest implements IReturnVoid
{

    public constructor(init?: Partial<DMARCAcknowledgementRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DMARCAcknowledgementRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(DMARCAcknowledgementRequest as unknown)[immerable] = true;

// @Route("/reports/finances/stock-reorder")
export class StockReorderRequest extends BaseParamsForAllReports implements IReturn<StockReorderResponse>
{
    public minimumLevel: number;
    public stockDescription: string;
    public supplier: string;
    public stockStatuses: string[];
    public reorders: string;

    public constructor(init?: Partial<StockReorderRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'StockReorderRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StockReorderResponse(); }
}
(StockReorderRequest as unknown)[immerable] = true;

// @Route("/reports/finances/stock-sales")
export class StockSalesRequest extends BaseParamsForAllReports implements IReturn<StockSalesResponse>
{
    public reportDate: string;
    public stockDescription: string;
    public ageGroupings: string[];

    public constructor(init?: Partial<StockSalesRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'StockSalesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StockSalesResponse(); }
}
(StockSalesRequest as unknown)[immerable] = true;

// @Route("/reports/finances/invoice-analysis")
export class InvoiceAnalysisRequest extends BaseParamsForAllReports implements IReturn<InvoiceAnalysisResponse>
{
    public accountTypes: string[];
    public invoiceStatuses: string[];

    public constructor(init?: Partial<InvoiceAnalysisRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'InvoiceAnalysisRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new InvoiceAnalysisResponse(); }
}
(InvoiceAnalysisRequest as unknown)[immerable] = true;

// @Route("/reports/finances/income-analysis")
export class IncomeAnalysisRequest extends BaseParamsForAllReports implements IReturn<IncomeAnalysisResponse>
{
    public accountTypes: string[];
    public paymentMethods: string[];
    public incomeStatuses: string[];

    public constructor(init?: Partial<IncomeAnalysisRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'IncomeAnalysisRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new IncomeAnalysisResponse(); }
}
(IncomeAnalysisRequest as unknown)[immerable] = true;

// @Route("/reports/finances/expenditure-month-summary")
export class ExpenditureMonthSummaryRequest extends BaseParamsForAllReports implements IReturn<ExpenditureMonthSummaryResponse>
{

    public constructor(init?: Partial<ExpenditureMonthSummaryRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ExpenditureMonthSummaryRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ExpenditureMonthSummaryResponse(); }
}
(ExpenditureMonthSummaryRequest as unknown)[immerable] = true;

// @Route("/reports/finances/expenditure-analysis", "POST")
export class ExpenditureAnalysisRequest extends BaseParamsForAllReports implements IReturn<ExpenditureAnalysisResponse>
{
    public expenditureCategory: string[];
    public expenditureOtherPaymentMethods: string[];

    public constructor(init?: Partial<ExpenditureAnalysisRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ExpenditureAnalysisRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ExpenditureAnalysisResponse(); }
}
(ExpenditureAnalysisRequest as unknown)[immerable] = true;

// @Route("/reports/finances/aged-debtors")
export class AgedDebtorsReportRequest extends BaseParamsForAllReports implements IReturn<AgedDebtorsResponse>
{
    public invoiceStatuses: string[];
    public invoiceAges: string[];

    public constructor(init?: Partial<AgedDebtorsReportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'AgedDebtorsReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AgedDebtorsResponse(); }
}
(AgedDebtorsReportRequest as unknown)[immerable] = true;

// @Route("/reports/finances/debtors-by-account")
export class DebtorsByAccountRequest extends BaseParamsForAllReports implements IReturn<DebtorsByAccountResponse>
{
    public invoiceStatusNames: string[];
    public accountTypeNames: string[];

    public constructor(init?: Partial<DebtorsByAccountRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'DebtorsByAccountRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DebtorsByAccountResponse(); }
}
(DebtorsByAccountRequest as unknown)[immerable] = true;

// @Route("/reports/finances/debtors-on-a-date")
export class DebtorsOnADateReportRequest extends BaseParamsForAllReports implements IReturn<DebtorsOnADateResponse>
{
    public invoiceStatusOnDates: string[];
    public accountTypes: string[];

    public constructor(init?: Partial<DebtorsOnADateReportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'DebtorsOnADateReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DebtorsOnADateResponse(); }
}
(DebtorsOnADateReportRequest as unknown)[immerable] = true;

// @Route("/reports/finances/charge-analysis")
export class ChargesAnalysisReportRequest extends BaseParamsForAllReports implements IReturn<ChargeAnalysisResponse>
{
    public accountTypes: string[];
    public chargeDescription: string;
    public billedItemCategories: string[];
    public accountName: string;
    public useAccountingDate: boolean;
    public invoiceStatus: InvoiceStatus;

    public constructor(init?: Partial<ChargesAnalysisReportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ChargesAnalysisReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ChargeAnalysisResponse(); }
}
(ChargesAnalysisReportRequest as unknown)[immerable] = true;

// @Route("/reports/diary/practitioner-availability")
export class PractitionerAvailabilityReportRequest extends BaseParamsForAllReports implements IReturn<ResponseBase<PractitionerAvailabilityReportResponse>>
{

    public constructor(init?: Partial<PractitionerAvailabilityReportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'PractitionerAvailabilityReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<PractitionerAvailabilityReportResponse>(); }
}
(PractitionerAvailabilityReportRequest as unknown)[immerable] = true;

// @Route("/reports/clinical/admissions-analysis")
export class AdmissionsAnalysisReportRequest extends BaseParamsForAllReports implements IReturn<AdmissionsAnalysisReportResponse>
{
    public bodySite: string[];
    public categories: string[];
    public ageGrouping: string[];
    public medicalContact: string;

    public constructor(init?: Partial<AdmissionsAnalysisReportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'AdmissionsAnalysisReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AdmissionsAnalysisReportResponse(); }
}
(AdmissionsAnalysisReportRequest as unknown)[immerable] = true;

// @Route("/reports/clinical/average-treatments")
export class AverageTreatmentsReportRequest extends BaseParamsForAllReports implements IReturn<ResponseBase<AverageTreatmentsReportResponse>>
{
    public groupByItems: string;

    public constructor(init?: Partial<AverageTreatmentsReportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'AverageTreatmentsReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AverageTreatmentsReportResponse>(); }
}
(AverageTreatmentsReportRequest as unknown)[immerable] = true;

// @Route("/reports/clinical/cases-due-for-review")
export class CasesDueForReviewReportRequest extends BaseParamsForAllReports implements IReturn<CasesDueForReviewReportResponse>
{
    public reviewDate: DateRange;
    public medicalContact: string;

    public constructor(init?: Partial<CasesDueForReviewReportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CasesDueForReviewReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CasesDueForReviewReportResponse(); }
}
(CasesDueForReviewReportRequest as unknown)[immerable] = true;

// @Route("/reports/clinical/current-case-load")
export class CurrentCaseLoadReportRequest extends BaseParamsForAllReports implements IReturn<ResponseBase<CurrentCaseLoadReportResponse>>
{
    public bodySite: string[];
    public businesses: string;
    public diagnosis: string;
    public showFutureAppointments: number;
    public medicalContact: string;

    public constructor(init?: Partial<CurrentCaseLoadReportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CurrentCaseLoadReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CurrentCaseLoadReportResponse>(); }
}
(CurrentCaseLoadReportRequest as unknown)[immerable] = true;

// @Route("/reports/clinical/discharge-analysis")
export class DischargeAnalysisReportRequest extends BaseParamsForAllReports implements IReturn<ResponseBase<DischargeAnalysisReportResponse>>
{
    public bodySite: string[];
    public businesses: string;
    public patientName: string;
    public diagnosis: string;
    public ageGrouping: string[];

    public constructor(init?: Partial<DischargeAnalysisReportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'DischargeAnalysisReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<DischargeAnalysisReportResponse>(); }
}
(DischargeAnalysisReportRequest as unknown)[immerable] = true;

// @Route("/reports/clinical/lapsed-patients")
export class LapsedPatientsReportRequest extends BaseParamsForAllReports implements IReturn<LapsedPatientsReportResponse>
{
    public showRemainingAuths: number;
    public bodySite: string[];
    public diagnosisCode: string[];
    public remainingAuthorisation: RemainingAuthorisationOption;

    public constructor(init?: Partial<LapsedPatientsReportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'LapsedPatientsReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new LapsedPatientsReportResponse(); }
}
(LapsedPatientsReportRequest as unknown)[immerable] = true;

// @Route("/reports/clients/client-analysis")
export class ClientAnalysisReportRequest extends BaseParamsForAllReports implements IReturn<ResponseBase<ClientAnalysisResponse>>
{
    public gender: string[];
    public ageGrouping: string[];
    public businesses: string[];
    public enquirySources: string[];
    public showFutureAppointments: number;

    public constructor(init?: Partial<ClientAnalysisReportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ClientAnalysisReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClientAnalysisResponse>(); }
}
(ClientAnalysisReportRequest as unknown)[immerable] = true;

// @Route("/reports/clients/client-birthdays")
export class ClientBirthdayReportRequest extends BaseParamsForAllReports implements IReturn<ClientBirthdayResponse>
{
    public filterLastAppointmentDate: boolean;
    public range: DatePartRange;
    public contactMethods: number;

    public constructor(init?: Partial<ClientBirthdayReportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ClientBirthdayReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ClientBirthdayResponse(); }
}
(ClientBirthdayReportRequest as unknown)[immerable] = true;

// @Route("/reports/clients/client-tracking")
export class ClientTrackingReportRequest extends BaseParamsForAllReports implements IReturn<ResponseBase<ClientTrackingResponse>>
{
    public omitPatientsThatDontNeedAction: boolean;
    public businesses: string;
    public ageGrouping: string[];

    public constructor(init?: Partial<ClientTrackingReportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ClientTrackingReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClientTrackingResponse>(); }
}
(ClientTrackingReportRequest as unknown)[immerable] = true;

export class ClickReferrerImagePathRequest implements IReturn<ResponseBase<ClickReferrerImagePath>>
{
    public referrerId: string;

    public constructor(init?: Partial<ClickReferrerImagePathRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickReferrerImagePathRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClickReferrerImagePath>(); }
}
(ClickReferrerImagePathRequest as unknown)[immerable] = true;

// @Route("/register/click")
export class ClickRegistrationRequest extends RegistrationRequest implements IReturn<ResponseBase<string>>
{

    public constructor(init?: Partial<ClickRegistrationRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickRegistrationRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<string>(); }
}
(ClickRegistrationRequest as unknown)[immerable] = true;

// @Route("/subdomain/exists")
export class TM3SubdomainExistsRequest implements IReturn<ResponseBase<boolean>>
{
    public subdomain: string;

    public constructor(init?: Partial<TM3SubdomainExistsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TM3SubdomainExistsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(TM3SubdomainExistsRequest as unknown)[immerable] = true;

export class QuickStartWizardSendEnquiryEmailRequest implements IReturn<ResponseBase<boolean>>
{
    public locationId: number;
    public type: EnquiryType;

    public constructor(init?: Partial<QuickStartWizardSendEnquiryEmailRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuickStartWizardSendEnquiryEmailRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(QuickStartWizardSendEnquiryEmailRequest as unknown)[immerable] = true;

export class QuickStartWizardToggleGroupStocksRequest implements IReturn<ResponseBase<T>>
{
    public id: number;

    public constructor(init?: Partial<QuickStartWizardToggleGroupStocksRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuickStartWizardToggleGroupStocksRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(QuickStartWizardToggleGroupStocksRequest as unknown)[immerable] = true;

export class QuickStartWizardGetGroupRequest implements IReturn<ResponseBase<QuickStartWizardGroupResponse>>
{
    public id: number;

    public constructor(init?: Partial<QuickStartWizardGetGroupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuickStartWizardGetGroupRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<QuickStartWizardGroupResponse>(); }
}
(QuickStartWizardGetGroupRequest as unknown)[immerable] = true;

export class QuickStartWizardGetGroupsRequest implements IReturn<ResponseBase<QuickStartWizardGroupResponse>>
{

    public constructor(init?: Partial<QuickStartWizardGetGroupsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuickStartWizardGetGroupsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<QuickStartWizardGroupResponse>(); }
}
(QuickStartWizardGetGroupsRequest as unknown)[immerable] = true;

export class QuickStartWizardSaveGroupRequest implements IReturn<ResponseBase<QuickStartWizardGroupResponse>>
{
    public email: string;
    public name: string;
    public id: number;
    public useAuthCode: boolean;
    public locationId: number;
    public firstStockId: number;
    public followupStockId: number;
    public otherStocks: QuickStartWizardGroupStock[];

    public constructor(init?: Partial<QuickStartWizardSaveGroupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuickStartWizardSaveGroupRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<QuickStartWizardGroupResponse>(); }
}
(QuickStartWizardSaveGroupRequest as unknown)[immerable] = true;

export class QuickStartWizardPractitionersRequest implements IReturn<ResponseBase<QuickStartWizardPractitionerResponse>>
{
    public id: number;

    public constructor(init?: Partial<QuickStartWizardPractitionersRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuickStartWizardPractitionersRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<QuickStartWizardPractitionerResponse>(); }
}
(QuickStartWizardPractitionersRequest as unknown)[immerable] = true;

export class QuickStartWizardGetPractitionerRequest implements IReturn<ResponseBase<QuickStartWizardPractitionerResponse>>
{
    public id: number;

    public constructor(init?: Partial<QuickStartWizardGetPractitionerRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuickStartWizardGetPractitionerRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<QuickStartWizardPractitionerResponse>(); }
}
(QuickStartWizardGetPractitionerRequest as unknown)[immerable] = true;

export class QuickStartWizardSavePractitionerRequest implements IReturn<ResponseBase<number>>
{
    public id: number;
    public title: string;
    public gender: string;
    public forename: string;
    public surname: string;
    public email: string;
    public mobile: string;
    public firstStockId: number;
    public followupStockId: number;
    public locations: number[];
    public onlineGuid: string;
    public isActive: boolean;

    public constructor(init?: Partial<QuickStartWizardSavePractitionerRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuickStartWizardSavePractitionerRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<number>(); }
}
(QuickStartWizardSavePractitionerRequest as unknown)[immerable] = true;

export class QuickStartWizardUpdateDisciplineRequest implements IReturn<ResponseBase<boolean>>
{
    public disciplineName: string;

    public constructor(init?: Partial<QuickStartWizardUpdateDisciplineRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuickStartWizardUpdateDisciplineRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(QuickStartWizardUpdateDisciplineRequest as unknown)[immerable] = true;

export class QuickStartWizardGetDisciplineRequest implements IReturn<ResponseBase<ServiceType>>
{

    public constructor(init?: Partial<QuickStartWizardGetDisciplineRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuickStartWizardGetDisciplineRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ServiceType>(); }
}
(QuickStartWizardGetDisciplineRequest as unknown)[immerable] = true;

export class QuickStartWizardGetStocksRequest implements IReturn<ResponseBase<QuickStartWizardGetStocksResponse>>
{

    public constructor(init?: Partial<QuickStartWizardGetStocksRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuickStartWizardGetStocksRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<QuickStartWizardGetStocksResponse>(); }
}
(QuickStartWizardGetStocksRequest as unknown)[immerable] = true;

export class QuickStartWizardSaveStocksRequest implements IReturn<ResponseBase<QuickStartWizardStock>>
{
    public reference: string;
    public description: string;
    public totalPrice?: number;
    public appointmentLength?: number;
    public id: number;

    public constructor(init?: Partial<QuickStartWizardSaveStocksRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuickStartWizardSaveStocksRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<QuickStartWizardStock>(); }
}
(QuickStartWizardSaveStocksRequest as unknown)[immerable] = true;

export class QuickStartWizardStockReminderRequest implements IReturn<ResponseBase<boolean>>
{
    public reminderDate: string;

    public constructor(init?: Partial<QuickStartWizardStockReminderRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuickStartWizardStockReminderRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(QuickStartWizardStockReminderRequest as unknown)[immerable] = true;

export class QuickStartWizardSelectTemplatePackRequest implements IReturn<ResponseBase<boolean>>
{
    public selectedPack: TemplatePackOptions;

    public constructor(init?: Partial<QuickStartWizardSelectTemplatePackRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuickStartWizardSelectTemplatePackRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(QuickStartWizardSelectTemplatePackRequest as unknown)[immerable] = true;

export class QuickStartWizardTemplateOptionsRequest implements IReturn<ResponseBase<QuickStartWizardTemplateOptionsResponse>>
{
    public type: string;

    public constructor(init?: Partial<QuickStartWizardTemplateOptionsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuickStartWizardTemplateOptionsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<QuickStartWizardTemplateOptionsResponse>(); }
}
(QuickStartWizardTemplateOptionsRequest as unknown)[immerable] = true;

// @Route("/pronto/cache/load", "POST")
export class ProntoCacheRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<ProntoCacheRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProntoCacheRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(ProntoCacheRequest as unknown)[immerable] = true;

export class GetClinicDetailsRequest implements IReturn<ResponseBase<GetClinicDetailsResponse>>
{

    public constructor(init?: Partial<GetClinicDetailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetClinicDetailsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GetClinicDetailsResponse>(); }
}
(GetClinicDetailsRequest as unknown)[immerable] = true;

export class SubmitClinicDetailsRequest implements IReturn<ResponseBase<boolean>>
{
    public clinicName: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public postCode: string;
    public homeTelephone: string;
    public category: string;
    public previousSystem: string;
    public clinicCurrencySymbol: string;

    public constructor(init?: Partial<SubmitClinicDetailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SubmitClinicDetailsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(SubmitClinicDetailsRequest as unknown)[immerable] = true;

export class GetNetworksRequest implements IReturn<ResponseBase<ProntoNetworkDto[]>>
{

    public constructor(init?: Partial<GetNetworksRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetNetworksRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ProntoNetworkDto[]>(); }
}
(GetNetworksRequest as unknown)[immerable] = true;

export class GetDisciplinesRequest implements IReturn<ResponseBase<ProntoDisciplineDto[]>>
{
    public networkId: string;

    public constructor(init?: Partial<GetDisciplinesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDisciplinesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ProntoDisciplineDto[]>(); }
}
(GetDisciplinesRequest as unknown)[immerable] = true;

export class GetReferrersRequest implements IReturn<ResponseBase<ClientWhoBooks[]>>
{

    public constructor(init?: Partial<GetReferrersRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetReferrersRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ClientWhoBooks[]>(); }
}
(GetReferrersRequest as unknown)[immerable] = true;

export class GetReferralCharge implements IReturn<ResponseBase<ProntoStockDto[]>>
{

    public constructor(init?: Partial<GetReferralCharge>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetReferralCharge'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ProntoStockDto[]>(); }
}
(GetReferralCharge as unknown)[immerable] = true;

export class GetReferrersLocations implements IReturn<ResponseBase<LocationDto[]>>
{

    public constructor(init?: Partial<GetReferrersLocations>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetReferrersLocations'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<LocationDto[]>(); }
}
(GetReferrersLocations as unknown)[immerable] = true;

export class GetReferralChargeOverrides implements IReturn<ResponseBase<ReferrerOverrideNetworkCharge[]>>
{
    public networkId: string;
    public referrerIds: string[];

    public constructor(init?: Partial<GetReferralChargeOverrides>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetReferralChargeOverrides'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ReferrerOverrideNetworkCharge[]>(); }
}
(GetReferralChargeOverrides as unknown)[immerable] = true;

export class GetProntoPaymentDetailsRequest implements IReturn<ResponseBase<ProntoPaymentResponse>>
{
    public networkId: string;
    public referrerIds: string[];

    public constructor(init?: Partial<GetProntoPaymentDetailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetProntoPaymentDetailsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ProntoPaymentResponse>(); }
}
(GetProntoPaymentDetailsRequest as unknown)[immerable] = true;

export class ProntoRegistrationRequest implements IReturn<ResponseBase<ProntoRegistrationResponse>>
{
    public discountCode: string;
    public targetId: string;
    public networkId: string;
    public clinicServices: ClinicServiceSetupDto[];
    public referrers: string[];
    public referrerIds: string[];
    public isOnline: boolean;
    public autoActivate: boolean;
    public incrementDiscountCode: boolean;

    public constructor(init?: Partial<ProntoRegistrationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProntoRegistrationRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ProntoRegistrationResponse>(); }
}
(ProntoRegistrationRequest as unknown)[immerable] = true;

export class StartTrialRequest implements IReturn<ResponseBase<StartTrialResponse>>
{

    public constructor(init?: Partial<StartTrialRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StartTrialRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<StartTrialResponse>(); }
}
(StartTrialRequest as unknown)[immerable] = true;

export class StartSubscriptionRequest implements IReturn<ResponseBase<StartTrialResponse>>
{

    public constructor(init?: Partial<StartSubscriptionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StartSubscriptionRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<StartTrialResponse>(); }
}
(StartSubscriptionRequest as unknown)[immerable] = true;

export class ClientDowngradeToProntoOnlyRequest implements IReturn<ResponseBase<ConfirmClientDowngradeToProntoResponse>>
{

    public constructor(init?: Partial<ClientDowngradeToProntoOnlyRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClientDowngradeToProntoOnlyRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ConfirmClientDowngradeToProntoResponse>(); }
}
(ClientDowngradeToProntoOnlyRequest as unknown)[immerable] = true;

export class GetPatientPrescriptionsRequest implements IReturn<ResponseBase<GetPatientPrescriptionsResponse>>
{
    public customerId: number;
    public caseId?: number;
    public take?: number;

    public constructor(init?: Partial<GetPatientPrescriptionsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPatientPrescriptionsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GetPatientPrescriptionsResponse>(); }
}
(GetPatientPrescriptionsRequest as unknown)[immerable] = true;

export class GetPatientPrescriptionsSummaryRequest implements IReturn<ResponseBase<PrescriptionSummary>>
{
    public customerId: number;

    public constructor(init?: Partial<GetPatientPrescriptionsSummaryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPatientPrescriptionsSummaryRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<PrescriptionSummary>(); }
}
(GetPatientPrescriptionsSummaryRequest as unknown)[immerable] = true;

// @Route("/prescription/create/nonrx", "POST")
export class CreateNonRxPrescriptionsRequest implements IReturn<ResponseBase<CreateNonRxPrescriptionsResponse>>
{
    public customerId: number;
    public items: PrescriptionItem[];

    public constructor(init?: Partial<CreateNonRxPrescriptionsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateNonRxPrescriptionsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CreateNonRxPrescriptionsResponse>(); }
}
(CreateNonRxPrescriptionsRequest as unknown)[immerable] = true;

export class GetPathologyResults implements IReturn<ResponseBase<PathologyResultsResponse>>
{
    public orderId: number;

    public constructor(init?: Partial<GetPathologyResults>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPathologyResults'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<PathologyResultsResponse>(); }
}
(GetPathologyResults as unknown)[immerable] = true;

export class GetPathologyOrders implements IReturn<ResponseBase<PathologyOrderResponse>>
{
    public customerId?: number;
    public caseId?: number;

    public constructor(init?: Partial<GetPathologyOrders>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPathologyOrders'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<PathologyOrderResponse>(); }
}
(GetPathologyOrders as unknown)[immerable] = true;

export class PlacePathologyOrder implements IReturn<ResponseBase<PlacePathologyOrderResponse>>, ISecurityId
{
    public provider: EPathologyProvider;
    public customerId: number;
    public stockIds: number[];
    public caseId?: number;
    public createInvoice: boolean;
    public securityId: number;

    public constructor(init?: Partial<PlacePathologyOrder>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PlacePathologyOrder'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<PlacePathologyOrderResponse>(); }
}
(PlacePathologyOrder as unknown)[immerable] = true;

export class PathologyUploadValidationReq implements IReturn<ResponseBase<PathologyPriceListValidationResult>>
{
    public provider: EPathologyProvider;

    public constructor(init?: Partial<PathologyUploadValidationReq>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyUploadValidationReq'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<PathologyPriceListValidationResult>(); }
}
(PathologyUploadValidationReq as unknown)[immerable] = true;

export class PathologyUploadBespokePriceList implements IReturn<ResponseBase<boolean>>
{
    public provider: EPathologyProvider;
    public filename: string;
    public startDate?: string;
    public results: PathologyStockItem[];

    public constructor(init?: Partial<PathologyUploadBespokePriceList>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyUploadBespokePriceList'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(PathologyUploadBespokePriceList as unknown)[immerable] = true;

export class PathologyUploadHistoryRequest implements IReturn<ResponseBase<PathologyPricingImportHistoryDto>>
{
    public provider: EPathologyProvider;

    public constructor(init?: Partial<PathologyUploadHistoryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyUploadHistoryRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<PathologyPricingImportHistoryDto>(); }
}
(PathologyUploadHistoryRequest as unknown)[immerable] = true;

export class PathologyUploadHistoryItemRequest implements IReturn<ResponseBase<PathologyPricingImportHistoryDto>>
{
    public provider: EPathologyProvider;
    public id: string;

    public constructor(init?: Partial<PathologyUploadHistoryItemRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyUploadHistoryItemRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<PathologyPricingImportHistoryDto>(); }
}
(PathologyUploadHistoryItemRequest as unknown)[immerable] = true;

export class PathologyUploadCancel implements IReturnVoid
{
    public provider: EPathologyProvider;
    public id: string;

    public constructor(init?: Partial<PathologyUploadCancel>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyUploadCancel'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(PathologyUploadCancel as unknown)[immerable] = true;

export class PathologyUploadBasePriceList implements IReturn<ResponseBase<boolean>>
{
    public provider: EPathologyProvider;

    public constructor(init?: Partial<PathologyUploadBasePriceList>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyUploadBasePriceList'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(PathologyUploadBasePriceList as unknown)[immerable] = true;

export class PathologyApplyGlobalMarkup implements IReturn<ResponseBase<boolean>>
{
    public provider: EPathologyProvider;
    public markup: number;

    public constructor(init?: Partial<PathologyApplyGlobalMarkup>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyApplyGlobalMarkup'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(PathologyApplyGlobalMarkup as unknown)[immerable] = true;

export class PathologyUploadReschedule implements IReturn<ResponseBase<boolean>>
{
    public provider: EPathologyProvider;
    public id: string;
    public startDate: string;

    public constructor(init?: Partial<PathologyUploadReschedule>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyUploadReschedule'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(PathologyUploadReschedule as unknown)[immerable] = true;

// @Route("/pathology/integration-user/{Provider}", "GET")
export class PathologyIntegrationUserRequest implements IReturn<ResponseBase<PathologyIntegrationUserResponse>>
{
    public provider: EPathologyProvider;

    public constructor(init?: Partial<PathologyIntegrationUserRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyIntegrationUserRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<PathologyIntegrationUserResponse>(); }
}
(PathologyIntegrationUserRequest as unknown)[immerable] = true;

// @Route("/pathology/integration-user", "POST")
export class PathologyIntegrationUserSaveRequest implements IReturn<ResponseBase<PathologyIntegrationUserResponse>>
{
    public provider: EPathologyProvider;
    public integrationCode: string;

    public constructor(init?: Partial<PathologyIntegrationUserSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyIntegrationUserSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<PathologyIntegrationUserResponse>(); }
}
(PathologyIntegrationUserSaveRequest as unknown)[immerable] = true;

export class NationwideUploadValidationReq implements IReturn<ResponseBase<PathologyPriceListValidationResult>>
{

    public constructor(init?: Partial<NationwideUploadValidationReq>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'NationwideUploadValidationReq'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<PathologyPriceListValidationResult>(); }
}
(NationwideUploadValidationReq as unknown)[immerable] = true;

export class NationwideUploadBespokePriceList implements IReturn<ResponseBase<PathologyPriceListValidationResult>>
{
    public filename: string;
    public markup: number;
    public startDate?: string;
    public results: PathologyStockItem[];

    public constructor(init?: Partial<NationwideUploadBespokePriceList>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'NationwideUploadBespokePriceList'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<PathologyPriceListValidationResult>(); }
}
(NationwideUploadBespokePriceList as unknown)[immerable] = true;

export class NationwideUploadRequest implements IReturn<ResponseBase<PathologyPriceListValidationResult>>
{

    public constructor(init?: Partial<NationwideUploadRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'NationwideUploadRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<PathologyPriceListValidationResult>(); }
}
(NationwideUploadRequest as unknown)[immerable] = true;

export class SubmitNationwidePriceList implements IReturn<ResponseBase<PathologyPriceListValidationResult>>
{

    public constructor(init?: Partial<SubmitNationwidePriceList>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SubmitNationwidePriceList'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<PathologyPriceListValidationResult>(); }
}
(SubmitNationwidePriceList as unknown)[immerable] = true;

export class ProcedureSearchByModalityRequest implements IReturn<ResponseBase<MedicalImagingProcedure>>
{
    public modalityIds: number[];

    public constructor(init?: Partial<ProcedureSearchByModalityRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcedureSearchByModalityRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<MedicalImagingProcedure>(); }
}
(ProcedureSearchByModalityRequest as unknown)[immerable] = true;

export class MedicalImagingModalityCodeRequest implements IReturn<ResponseBase<MedicalImagingModality>>
{

    public constructor(init?: Partial<MedicalImagingModalityCodeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MedicalImagingModalityCodeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<MedicalImagingModality>(); }
}
(MedicalImagingModalityCodeRequest as unknown)[immerable] = true;

export class GetMedicalImagingProcedure implements IReturn<ResponseBase<MedicalImagingProcedure>>
{
    public procedureId: number;

    public constructor(init?: Partial<GetMedicalImagingProcedure>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMedicalImagingProcedure'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<MedicalImagingProcedure>(); }
}
(GetMedicalImagingProcedure as unknown)[immerable] = true;

export class MedicalImagingOrdersRequest implements IReturn<ResponseBase<MedicalImagingOrderDetails>>
{
    public customerId: number;
    public caseId?: number;

    public constructor(init?: Partial<MedicalImagingOrdersRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MedicalImagingOrdersRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<MedicalImagingOrderDetails>(); }
}
(MedicalImagingOrdersRequest as unknown)[immerable] = true;

export class MedicalImagingOrderHistoryRequest implements IReturn<ResponseBase<MedicalImagingOrderHistoryResponse>>
{
    public orderId: number;

    public constructor(init?: Partial<MedicalImagingOrderHistoryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MedicalImagingOrderHistoryRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<MedicalImagingOrderHistoryResponse>(); }
}
(MedicalImagingOrderHistoryRequest as unknown)[immerable] = true;

export class MedicalImagingProcedureStockRequest implements IReturn<ResponseBase<number>>
{
    public procedureId: number;

    public constructor(init?: Partial<MedicalImagingProcedureStockRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MedicalImagingProcedureStockRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<number>(); }
}
(MedicalImagingProcedureStockRequest as unknown)[immerable] = true;

export class SaveMedicalImagingProcedureCcsdRequest implements IReturn<ResponseBase<boolean>>
{
    public procedureId: number;
    public ccsd?: string;
    public healthcodeChargeCode?: string;

    public constructor(init?: Partial<SaveMedicalImagingProcedureCcsdRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveMedicalImagingProcedureCcsdRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(SaveMedicalImagingProcedureCcsdRequest as unknown)[immerable] = true;

export class GetAllMedicalImagingProceduresRequest implements IReturn<ResponseBase<MedicalImagingProcedure>>
{

    public constructor(init?: Partial<GetAllMedicalImagingProceduresRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAllMedicalImagingProceduresRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<MedicalImagingProcedure>(); }
}
(GetAllMedicalImagingProceduresRequest as unknown)[immerable] = true;

// @Route("/medical-imaging/upload-journey-document", "POST")
export class MedicalImagingOrderUploadJourneyDocumentRequest implements IReturn<ResponseBase<MedicalImagingOrderUploadJourneyDocumentResponse>>, ISecurityId
{
    public orderId: number;
    public workflowId: number;
    public caseId?: number;
    public securityId: number;

    public constructor(init?: Partial<MedicalImagingOrderUploadJourneyDocumentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MedicalImagingOrderUploadJourneyDocumentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<MedicalImagingOrderUploadJourneyDocumentResponse>(); }
}
(MedicalImagingOrderUploadJourneyDocumentRequest as unknown)[immerable] = true;

// @Route("/locations/allowed/add/{LocationId}")
export class AddLocationRequest implements IReturn<ResponseBase<AddLocationResponse>>, ILocationId
{
    public locationId: number;

    public constructor(init?: Partial<AddLocationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddLocationRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<AddLocationResponse>(); }
}
(AddLocationRequest as unknown)[immerable] = true;

// @Route("/locations/all", "GET")
export class AllLocationRequest implements IReturn<ResponseBase<LocationResponse>>, ILocationIds, IGet
{
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<AllLocationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AllLocationRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<LocationResponse>(); }
}
(AllLocationRequest as unknown)[immerable] = true;

// @Route("/locations/search", "POST")
export class LocationSearchRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<Location>>
{
    public name: string;
    public status?: number;

    public constructor(init?: Partial<LocationSearchRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'LocationSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<Location>(); }
}
(LocationSearchRequest as unknown)[immerable] = true;

// @Route("/locations/search/ids", "POST")
export class LocationsSearchIdsRequest implements IReturn<ResponseBase<Location>>, ILocationIds
{
    public ids: number[];
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<LocationsSearchIdsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LocationsSearchIdsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<Location>(); }
}
(LocationsSearchIdsRequest as unknown)[immerable] = true;

export class LocationsExportRequest implements IReturn<ResponseBase<string>>, ILocationIds
{
    public query: LocationSearchRequest;
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<LocationsExportRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LocationsExportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<string>(); }
}
(LocationsExportRequest as unknown)[immerable] = true;

// @Route("/locations/{LocationId}", "GET")
export class LocationGetRequest implements IReturn<ResponseBase<LocationResponse>>, ILocationId
{
    public locationId: number;
    public sort: QueryField[];
    public skip: number;
    public take: number;

    public constructor(init?: Partial<LocationGetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LocationGetRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<LocationResponse>(); }
}
(LocationGetRequest as unknown)[immerable] = true;

// @Route("/locations/facilities", "GET")
export class GetFacilitiesListRequest implements IReturn<ResponseBase<LocationFacilities>>
{

    public constructor(init?: Partial<GetFacilitiesListRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetFacilitiesListRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<LocationFacilities>(); }
}
(GetFacilitiesListRequest as unknown)[immerable] = true;

// @Route("/locations/save", "POST")
export class LocationPostRequest implements IReturn<Location>
{
    public id: number;
    public name: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public addressLine5: string;
    public postCode: string;
    public telephone: string;
    public fax: string;
    public email: string;
    public web: string;
    public dnaStockId: number;
    public cancelStockId: number;
    public dnaAmount: number;
    public cancelAmount: number;
    public status: string;
    public directions: string;
    public reminderTemplateEmail_TM3: string;
    public reminderTemplateSMS_TM3: string;
    public facilities: LocationFacilities;
    public onlineGuid: string;
    public openingHours: LocationOpeningHours[];
    public enabledForAllServices: boolean;

    public constructor(init?: Partial<LocationPostRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LocationPostRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Location(); }
}
(LocationPostRequest as unknown)[immerable] = true;

export class GetLocationOpeningHoursRequest implements IReturn<ResponseBase<LocationOpeningHoursResponse>>
{
    public id: number;

    public constructor(init?: Partial<GetLocationOpeningHoursRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetLocationOpeningHoursRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<LocationOpeningHoursResponse>(); }
}
(GetLocationOpeningHoursRequest as unknown)[immerable] = true;

// @Route("/exercise/{CustomerId}/{PractitionerId}")
export class ExercisePrescriberRequest implements ICustomerId
{
    public customerId: number;
    public practitionerId: number;

    public constructor(init?: Partial<ExercisePrescriberRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExercisePrescriberRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(ExercisePrescriberRequest as unknown)[immerable] = true;

// @Route("/wibbi/{CustomerId}/{PractitionerId}")
export class PhysiotecRequest implements ICustomerId
{
    public customerId: number;
    public practitionerId: number;

    public constructor(init?: Partial<PhysiotecRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PhysiotecRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(PhysiotecRequest as unknown)[immerable] = true;

// @Route("/physiotools/{CustomerId}/{PractitionerId}")
export class PhysiotoolsRequest implements ICustomerId
{
    public customerId: number;
    public practitionerId: number;

    public constructor(init?: Partial<PhysiotoolsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PhysiotoolsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(PhysiotoolsRequest as unknown)[immerable] = true;

// @Route("/physitrack/{CustomerId}/{PractitionerId}")
export class PhysitrackRequest implements ICustomerId
{
    public customerId: number;
    public practitionerId: number;

    public constructor(init?: Partial<PhysitrackRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PhysitrackRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(PhysitrackRequest as unknown)[immerable] = true;

// @Route("/salaso/{CustomerId}/{PractitionerId}", "GET")
export class SalasoRequest implements ICustomerId
{
    public customerId: number;
    public practitionerId: number;

    public constructor(init?: Partial<SalasoRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SalasoRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(SalasoRequest as unknown)[immerable] = true;

// @Route("/signaturerx/integration")
export class SignatureRxRequest implements IReturn<ResponseBase<SignatureRxResponse>>
{
    public signatureRxIntegrationCode: string;

    public constructor(init?: Partial<SignatureRxRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SignatureRxRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SignatureRxResponse>(); }
}
(SignatureRxRequest as unknown)[immerable] = true;

export class CreatePrescriptionRequest implements IReturn<ResponseBase<CreatePrescriptionResponse>>
{
    // @Required()
    public action: PrescriptionActions;

    public caseId?: number;
    public medications: MedicationRequestItem[];
    // @Required()
    public securePin: string;

    public customerId: number;

    public constructor(init?: Partial<CreatePrescriptionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreatePrescriptionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CreatePrescriptionResponse>(); }
}
(CreatePrescriptionRequest as unknown)[immerable] = true;

export class PharmaciergeSettingsRequest extends PharmaciergeSettingsBase implements IReturn<ResponseBase<SignatureRxResponse>>
{

    public constructor(init?: Partial<PharmaciergeSettingsRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'PharmaciergeSettingsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SignatureRxResponse>(); }
}
(PharmaciergeSettingsRequest as unknown)[immerable] = true;

export class PharmaciergeOrderRequest implements IReturn<ResponseBase<boolean>>
{
    public customerId: number;
    public caseId?: number;
    public medications: PharmaciergePrescribedItem[];
    public pin: string;
    public notes: string;

    public constructor(init?: Partial<PharmaciergeOrderRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PharmaciergeOrderRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(PharmaciergeOrderRequest as unknown)[immerable] = true;

export class PharmaciergeSearchMedication implements IReturn<ResponseBase<PharmaciergeSearchMedicationItem>>
{
    public searchTerm: string;

    public constructor(init?: Partial<PharmaciergeSearchMedication>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PharmaciergeSearchMedication'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<PharmaciergeSearchMedicationItem>(); }
}
(PharmaciergeSearchMedication as unknown)[immerable] = true;

export class PharmaciergeCasePrescriptionsRequest implements IReturn<ResponseBase<string>>
{
    public id: number;

    public constructor(init?: Partial<PharmaciergeCasePrescriptionsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PharmaciergeCasePrescriptionsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<string>(); }
}
(PharmaciergeCasePrescriptionsRequest as unknown)[immerable] = true;

export class PharmaciergePrescriptionDetailsRequest implements IReturn<ResponseBase<PharmaciergePrescriptionFull>>
{
    public id: string;

    public constructor(init?: Partial<PharmaciergePrescriptionDetailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PharmaciergePrescriptionDetailsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<PharmaciergePrescriptionFull>(); }
}
(PharmaciergePrescriptionDetailsRequest as unknown)[immerable] = true;

export class PharmaciergePrescriptionStatusRequest implements IReturn<ResponseBase<string>>
{
    public id: string;

    public constructor(init?: Partial<PharmaciergePrescriptionStatusRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PharmaciergePrescriptionStatusRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<string>(); }
}
(PharmaciergePrescriptionStatusRequest as unknown)[immerable] = true;

export class InteleradOrderRequest
{
    public appointmentId: number;
    public procedureId: number;
    public radiologistGroup: string;
    public priority: boolean;

    public constructor(init?: Partial<InteleradOrderRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InteleradOrderRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(InteleradOrderRequest as unknown)[immerable] = true;

export class MedicalImagingRequestLinkPinRequest implements IReturn<ResponseBase<string>>
{
    public orderId: number;
    public linkUrl: string;

    public constructor(init?: Partial<MedicalImagingRequestLinkPinRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MedicalImagingRequestLinkPinRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<string>(); }
}
(MedicalImagingRequestLinkPinRequest as unknown)[immerable] = true;

export class AttachDocumentToInteleradOrder implements IReturn<ResponseBase<boolean>>
{
    public treatmentId: number;
    public caseId: number;
    public orderId?: number;

    public constructor(init?: Partial<AttachDocumentToInteleradOrder>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AttachDocumentToInteleradOrder'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(AttachDocumentToInteleradOrder as unknown)[immerable] = true;

export class HeidiTokenRequest implements IReturn<ResponseBase<T>>
{
    public fetchNewToken: boolean;

    public constructor(init?: Partial<HeidiTokenRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'HeidiTokenRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(HeidiTokenRequest as unknown)[immerable] = true;

export class HeidiParametersRequest implements IReturn<ResponseBase<HeidiParametersResponse>>
{

    public constructor(init?: Partial<HeidiParametersRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'HeidiParametersRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<HeidiParametersResponse>(); }
}
(HeidiParametersRequest as unknown)[immerable] = true;

export class SearchCloudRxProductsRequest implements IReturn<ResponseBase<CloudRxProductDto>>
{
    public searchTerm: string;

    public constructor(init?: Partial<SearchCloudRxProductsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SearchCloudRxProductsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CloudRxProductDto>(); }
}
(SearchCloudRxProductsRequest as unknown)[immerable] = true;

export class CloudRxCasePrescriptionsRequest implements IReturn<ResponseBase<string>>
{
    public id: number;

    public constructor(init?: Partial<CloudRxCasePrescriptionsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CloudRxCasePrescriptionsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<string>(); }
}
(CloudRxCasePrescriptionsRequest as unknown)[immerable] = true;

export class CloudRxOrderRequest implements IReturn<ResponseBase<number>>
{
    public prescribedItems: CloudRxPrescribedItemDto[];
    public orderId: string;
    public customerId: number;
    public caseId?: number;
    public courierMethod: CourierMethod;
    public repeats: number;

    public constructor(init?: Partial<CloudRxOrderRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CloudRxOrderRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<number>(); }
}
(CloudRxOrderRequest as unknown)[immerable] = true;

export class CloudRxFetchRequest extends CloudRxFetchBase implements IReturn<ResponseBase<CloudRxPrescriptionFull>>
{

    public constructor(init?: Partial<CloudRxFetchRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CloudRxFetchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CloudRxPrescriptionFull>(); }
}
(CloudRxFetchRequest as unknown)[immerable] = true;

export class CloudRxStatusRequest extends CloudRxFetchBase implements IReturn<ResponseBase<CloudRxStatus>>
{

    public constructor(init?: Partial<CloudRxStatusRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CloudRxStatusRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CloudRxStatus>(); }
}
(CloudRxStatusRequest as unknown)[immerable] = true;

// @Route("/healthcode/searchccsd", "POST")
export class SearchCcsdRequest implements IReturn<ResponseBase<CcsdResponse>>
{
    public term: string;

    public constructor(init?: Partial<SearchCcsdRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SearchCcsdRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CcsdResponse>(); }
}
(SearchCcsdRequest as unknown)[immerable] = true;

// @Route("/icd9/search", "POST")
export class ICD9SearchRequest implements IReturn<ResponseBase<ICD9>>
{

    public constructor(init?: Partial<ICD9SearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ICD9SearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ICD9>(); }
}
(ICD9SearchRequest as unknown)[immerable] = true;

// @Route("/system/{Password}/jobs/")
export class HangfireRequest implements IReturn<ResponseBase<JobDto>>
{
    public password: string;
    public skip: number;
    public take: number;
    public recurring: boolean;

    public constructor(init?: Partial<HangfireRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'HangfireRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<JobDto>(); }
}
(HangfireRequest as unknown)[immerable] = true;

export class FormByGuidRequest implements IReturn<ResponseBase<FormReportResponse>>
{
    public globalId: string;

    public constructor(init?: Partial<FormByGuidRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormByGuidRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<FormReportResponse>(); }
}
(FormByGuidRequest as unknown)[immerable] = true;

// @Route("/form/reports/{PatientId}")
export class FormReportsRequest implements IReturn<ResponseBase<FormReportResponse>>
{
    public patientId: number;
    public includeClinical: boolean;
    public take?: number;
    public onlyRequiringAction?: boolean;

    public constructor(init?: Partial<FormReportsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormReportsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<FormReportResponse>(); }
}
(FormReportsRequest as unknown)[immerable] = true;

export class DeleteFormTemplateRequest implements IReturn<ResponseBase<boolean>>
{
    public id: number;

    public constructor(init?: Partial<DeleteFormTemplateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteFormTemplateRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(DeleteFormTemplateRequest as unknown)[immerable] = true;

export class ArchiveFormTemplateRequest implements IReturn<ResponseBase<boolean>>
{
    public id: number;

    public constructor(init?: Partial<ArchiveFormTemplateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ArchiveFormTemplateRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ArchiveFormTemplateRequest as unknown)[immerable] = true;

// @Route("/form/templates", "Post")
export class FormTemplatesRequest implements IReturn<ResponseBase<FormTemplatesResponse>>
{
    public types: string[];

    public constructor(init?: Partial<FormTemplatesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormTemplatesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<FormTemplatesResponse>(); }
}
(FormTemplatesRequest as unknown)[immerable] = true;

// @Route("/form/template/editor/{Id}")
export class FormTemplateEditorRequest
{
    public id: number;

    public constructor(init?: Partial<FormTemplateEditorRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormTemplateEditorRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(FormTemplateEditorRequest as unknown)[immerable] = true;

// @Route("/form/submit")
export class SubmitFormRequest implements IReturn<boolean>
{
    public recordedBy: number;
    public templateId: string;
    public globalId: string;
    public reportData: string;
    public updates: Update[];
    public patientId: number;
    public caseId?: number;

    public constructor(init?: Partial<SubmitFormRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SubmitFormRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return false; }
}
(SubmitFormRequest as unknown)[immerable] = true;

// @Route("/form/{FormId}/files", "GET")
export class GetFormFilesRequest implements IReturn<ResponseBase<OnlineMyFilesResponse>>
{
    public formId: string;
    public tempFolderId: string;

    public constructor(init?: Partial<GetFormFilesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetFormFilesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<OnlineMyFilesResponse>(); }
}
(GetFormFilesRequest as unknown)[immerable] = true;

// @Route("/form/{FormId}/files/download", "HEAD, GET")
export class DownloadFormFileRequest implements IReturn<Object>
{
    public formId: string;
    public listingId: string;

    public constructor(init?: Partial<DownloadFormFileRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadFormFileRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Object(); }
}
(DownloadFormFileRequest as unknown)[immerable] = true;

// @Route("/form/complete")
export class CompleteFormRequest implements IReturn<boolean>
{
    public id: string;
    public patientId: number;
    public templateId: string;
    public caseId: number;
    public updates: Update[];
    public reportData: string;
    public signature: string;

    public constructor(init?: Partial<CompleteFormRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CompleteFormRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return false; }
}
(CompleteFormRequest as unknown)[immerable] = true;

export class PinUnlockRequest implements IReturn<ResponseBase<boolean>>
{
    public pin: string;
    public unlock: boolean;

    public constructor(init?: Partial<PinUnlockRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PinUnlockRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(PinUnlockRequest as unknown)[immerable] = true;

// @Route("/form/send")
export class SendFormRequest implements IReturn<boolean>
{
    public patientId: number;
    public templateId: string;
    public caseId?: number;
    public type: string;
    public globalId: string;
    public isNew: boolean;

    public constructor(init?: Partial<SendFormRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendFormRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return false; }
}
(SendFormRequest as unknown)[immerable] = true;

// @Route("/form/cancel")
export class CancelFormRequest implements IReturn<boolean>
{
    public id: string;

    public constructor(init?: Partial<CancelFormRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CancelFormRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return false; }
}
(CancelFormRequest as unknown)[immerable] = true;

// @Route("/form/communication")
export class UpdateCommunicationTemplate implements IReturn<boolean>
{
    public templateId: string;
    public smsTemplate: string;
    public emailTemplate: string;

    public constructor(init?: Partial<UpdateCommunicationTemplate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateCommunicationTemplate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return false; }
}
(UpdateCommunicationTemplate as unknown)[immerable] = true;

export class UpdateFormStatusRequest implements IReturn<ResponseBase<T>>
{
    public status: FormStatus;
    public id: number;

    public constructor(init?: Partial<UpdateFormStatusRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateFormStatusRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(UpdateFormStatusRequest as unknown)[immerable] = true;

// @Route("/form/decline")
export class DeclineFormRequest implements IReturn<boolean>
{
    public id: string;

    public constructor(init?: Partial<DeclineFormRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeclineFormRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return false; }
}
(DeclineFormRequest as unknown)[immerable] = true;

export class EquipmentSaveRequest implements IReturn<ResponseBase<boolean>>
{
    public id?: number;
    public name: string;
    public model: string;
    public assetTag: string;
    public lastServiced?: string;
    public status: EEquipmentStatus;
    public roomId?: number;
    public locationId?: number;
    public notes: string;
    public tags: string[];
    public modalityId?: number;

    public constructor(init?: Partial<EquipmentSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EquipmentSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(EquipmentSaveRequest as unknown)[immerable] = true;

export class EquipmentItemRequest implements IReturn<ResponseBase<EquipmentSearchResponse>>
{
    public id: number;

    public constructor(init?: Partial<EquipmentItemRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EquipmentItemRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<EquipmentSearchResponse>(); }
}
(EquipmentItemRequest as unknown)[immerable] = true;

export class EquipmentSearchRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<EquipmentSearchResponse>>
{

    public constructor(init?: Partial<EquipmentSearchRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'EquipmentSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<EquipmentSearchResponse>(); }
}
(EquipmentSearchRequest as unknown)[immerable] = true;

export class EquipmentCountRequest implements IReturn<ResponseBase<number>>
{

    public constructor(init?: Partial<EquipmentCountRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EquipmentCountRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<number>(); }
}
(EquipmentCountRequest as unknown)[immerable] = true;

// @Route("/documents/search", "POST")
export class DocumentSearch extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<DocumentDto>>
{

    public constructor(init?: Partial<DocumentSearch>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'DocumentSearch'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<DocumentDto>(); }
}
(DocumentSearch as unknown)[immerable] = true;

// @Route("/documents/{Id}/approve", "POST")
export class DocumentApprove implements IReturn<EmptyResponse>
{
    public id: string;
    public targetStatus: DocumentApprovalStatus;

    public constructor(init?: Partial<DocumentApprove>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DocumentApprove'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EmptyResponse(); }
}
(DocumentApprove as unknown)[immerable] = true;

// @Route("/documents/{Id}", "DELETE")
export class DocumentDelete implements IReturn<EmptyResponse>, ICustomerId
{
    public id: string;
    public customerId: number;

    public constructor(init?: Partial<DocumentDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DocumentDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new EmptyResponse(); }
}
(DocumentDelete as unknown)[immerable] = true;

// @Route("/diary/classes", "POST")
export class ClassesRequest implements IReturn<ResponseBase<ClassesResponse>>
{
    public fromDate: string;
    public showWeekends: boolean;

    public constructor(init?: Partial<ClassesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClassesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClassesResponse>(); }
}
(ClassesRequest as unknown)[immerable] = true;

// @Route("/diary/classes/filter", "POST")
export class FilterClassesRequest implements IReturn<ResponseBase<ClassesResponse>>, IHasAutoRefresh
{
    public fromDate: string;
    public classTypeIds: number[];
    public courseTypeIds: number[];
    public locationIds: number[];
    public practitionerIds: number[];
    public hideCancellations: boolean;
    public showWeekends: boolean;
    public autoRefresh: boolean;

    public constructor(init?: Partial<FilterClassesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FilterClassesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClassesResponse>(); }
}
(FilterClassesRequest as unknown)[immerable] = true;

export class PatientClassesRequest implements IReturn<ResponseBase<PatientClassResponse>>
{
    public patientId: number;
    public skip?: number;
    public take?: number;

    public constructor(init?: Partial<PatientClassesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientClassesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<PatientClassResponse>(); }
}
(PatientClassesRequest as unknown)[immerable] = true;

// @Route("/patient/prepaid/classes/{PatientId}", "POST")
export class PatientPrePaidClassRequest implements IReturn<ResponseBase<PatientClassWithCreditsUsage>>
{
    public patientId: number;
    public prePaidItemIds: number[];
    public skip?: number;
    public take?: number;
    public sort: QueryField[];

    public constructor(init?: Partial<PatientPrePaidClassRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientPrePaidClassRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<PatientClassWithCreditsUsage>(); }
}
(PatientPrePaidClassRequest as unknown)[immerable] = true;

// @Route("/dashboard")
export class DashboardRequest implements IReturn<ResponseBase<DashboardResponse>>, IFilterServiceTypeManually
{

    public constructor(init?: Partial<DashboardRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DashboardRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<DashboardResponse>(); }
}
(DashboardRequest as unknown)[immerable] = true;

// @Route("/dashboard/list")
export class DashboardListRequest
{
    public startDate?: string;
    public endDate?: string;
    public locationIds: number[];
    public practitionerIds: number[];
    public roomIds: number[];

    public constructor(init?: Partial<DashboardListRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DashboardListRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(DashboardListRequest as unknown)[immerable] = true;

// @Route("/customer/anonymise")
export class AnonymiseCustomerRequest implements IReturn<ResponseBase<boolean>>, ICustomerId
{
    public id: number;
    public customerId: number;

    public constructor(init?: Partial<AnonymiseCustomerRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AnonymiseCustomerRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(AnonymiseCustomerRequest as unknown)[immerable] = true;

export class CustomerUpcomingAppointmentRequest implements IReturn<ResponseBase<number>>, ICustomerId, IFilterServiceTypeManually
{
    public customerId: number;

    public constructor(init?: Partial<CustomerUpcomingAppointmentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerUpcomingAppointmentRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<number>(); }
}
(CustomerUpcomingAppointmentRequest as unknown)[immerable] = true;

// @Route("/customer/appointments/{CustomerId}")
// @Route("/customer/appointments/{CustomerId}/{CaseId}")
export class CustomerAppointmentRequest implements IReturn<ResponseBase<AppointmentResponse>>, ICustomerId, IFilterServiceTypeManually
{
    public customerId: number;
    public appointmentId?: number;
    public prePaidItemIds: number[];
    public caseId?: number;
    public skip?: number;
    public take?: number;
    public sort: QueryField[];
    public appointmentTypes: string[];
    public recallOnly: boolean;

    public constructor(init?: Partial<CustomerAppointmentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerAppointmentRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<AppointmentResponse>(); }
}
(CustomerAppointmentRequest as unknown)[immerable] = true;

export class CustomerAppointmentStatsRequest implements IReturn<ResponseBase<CustomerAppointmentStatsResponse>>, ICustomerId
{
    public customerId: number;
    public appointmentTypes: string[];

    public constructor(init?: Partial<CustomerAppointmentStatsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerAppointmentStatsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CustomerAppointmentStatsResponse>(); }
}
(CustomerAppointmentStatsRequest as unknown)[immerable] = true;

// @Route("/download/patient")
export class DownloadPatientRequest implements ICustomerId
{
    public customerId: number;
    public requestDate?: string;
    public demographic: boolean;
    public clinical: boolean;
    public financial: boolean;
    public documents: boolean;
    public forms: boolean;
    public full: boolean;

    public constructor(init?: Partial<DownloadPatientRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadPatientRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(DownloadPatientRequest as unknown)[immerable] = true;

// @Route("/patient/{Id}/cases")
export class PatientCaseSearchRequest implements IReturn<ResponseBase<CaseSearchResponse>>, ILocationId
{
    public skip: number;
    public take: number;
    public id: number;
    public sort: QueryField[];
    public locationId: number;

    public constructor(init?: Partial<PatientCaseSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientCaseSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CaseSearchResponse>(); }
}
(PatientCaseSearchRequest as unknown)[immerable] = true;

export class CrmIntegrationSettings implements IReturn<ResponseBase<T>>
{
    public id: number;
    public service: CrmService;
    public enablePatientSync: boolean;
    public syncMode: CrmPatientSyncMode;
    public syncAfterDate?: string;
    public contactTagFilter: string;
    public applyTag: string;
    public matchForename: boolean;
    public matchSurname: boolean;
    public matchPostcode: boolean;
    public matchDateOfBirth: boolean;
    public matchEmail: boolean;
    public matchMobileNumber: boolean;
    public enableNoteSync: boolean;
    public noteSyncMode: CrmNoteSyncMode;
    public enableProductSync: boolean;
    public stockTagFilter: string;
    public dealPipelineId: string;
    public enableAppointmentSync: boolean;
    public dealCustomFields: CrmCustomField[];
    public contactCustomFields: CrmCustomField[];
    public dealBookedStageId: string;
    public dealCompletedStageId: string;
    public dealCancelledStageId: string;
    public dealDnaStageId: string;
    // @Ignore()
    public webhookUrl: string;

    public constructor(init?: Partial<CrmIntegrationSettings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CrmIntegrationSettings'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(CrmIntegrationSettings as unknown)[immerable] = true;

export class GetCrmSettings implements IReturn<ResponseBase<CrmIntegrationSettings>>
{
    public service: CrmService;

    public constructor(init?: Partial<GetCrmSettings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCrmSettings'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CrmIntegrationSettings>(); }
}
(GetCrmSettings as unknown)[immerable] = true;

export class CreateApiDeckSessionToken implements IReturn<ResponseBase<string>>
{

    public constructor(init?: Partial<CreateApiDeckSessionToken>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateApiDeckSessionToken'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<string>(); }
}
(CreateApiDeckSessionToken as unknown)[immerable] = true;

export class CrmCheckConnectorAuthorizedRequest implements IReturn<ResponseBase<boolean>>
{
    public service: CrmService;

    public constructor(init?: Partial<CrmCheckConnectorAuthorizedRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CrmCheckConnectorAuthorizedRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CrmCheckConnectorAuthorizedRequest as unknown)[immerable] = true;

export class CrmGetPipelinesRequest implements IReturn<ResponseBase<CrmPipelinesResponse>>
{
    public service: CrmService;

    public constructor(init?: Partial<CrmGetPipelinesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CrmGetPipelinesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CrmPipelinesResponse>(); }
}
(CrmGetPipelinesRequest as unknown)[immerable] = true;

export class CrmGetPipedrivePersonFieldsRequest implements IReturn<ResponseBase<CrmPipedrivePersonFieldResponse>>
{
    public service: CrmService;

    public constructor(init?: Partial<CrmGetPipedrivePersonFieldsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CrmGetPipedrivePersonFieldsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CrmPipedrivePersonFieldResponse>(); }
}
(CrmGetPipedrivePersonFieldsRequest as unknown)[immerable] = true;

export class CrmGetHubspotContactPropertiesRequest implements IReturn<ResponseBase<CrmPipedrivePersonFieldResponse>>
{
    public service: CrmService;

    public constructor(init?: Partial<CrmGetHubspotContactPropertiesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CrmGetHubspotContactPropertiesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CrmPipedrivePersonFieldResponse>(); }
}
(CrmGetHubspotContactPropertiesRequest as unknown)[immerable] = true;

export class CrmGetDealFieldsRequest implements IReturn<ResponseBase<CrmPipedrivePersonFieldResponse>>
{
    public service: CrmService;

    public constructor(init?: Partial<CrmGetDealFieldsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CrmGetDealFieldsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CrmPipedrivePersonFieldResponse>(); }
}
(CrmGetDealFieldsRequest as unknown)[immerable] = true;

export class CrmGetSyncOutcomesRequest implements IReturn<ResponseBase<CrmSyncOutcomeResponse>>
{
    public service: CrmService;
    public take: number;
    public skip: number;

    public constructor(init?: Partial<CrmGetSyncOutcomesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CrmGetSyncOutcomesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CrmSyncOutcomeResponse>(); }
}
(CrmGetSyncOutcomesRequest as unknown)[immerable] = true;

export class CrmDeleteConnectionRequest implements IReturn<ResponseBase<HttpResult>>
{
    public service: CrmService;

    public constructor(init?: Partial<CrmDeleteConnectionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CrmDeleteConnectionRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<HttpResult>(); }
}
(CrmDeleteConnectionRequest as unknown)[immerable] = true;

export class CrmCreateWebhooksRequest implements IReturn<ResponseBase<HttpResult>>
{
    public service: CrmService;

    public constructor(init?: Partial<CrmCreateWebhooksRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CrmCreateWebhooksRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<HttpResult>(); }
}
(CrmCreateWebhooksRequest as unknown)[immerable] = true;

export class CrmGetWebhooksRequest implements IReturn<ResponseBase<CrmWebhookResponse>>
{
    public service: CrmService;

    public constructor(init?: Partial<CrmGetWebhooksRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CrmGetWebhooksRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CrmWebhookResponse>(); }
}
(CrmGetWebhooksRequest as unknown)[immerable] = true;

export class CrmRecreateWebhookRequest implements IReturn<ResponseBase<HttpResult>>
{
    public service: CrmService;

    public constructor(init?: Partial<CrmRecreateWebhookRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CrmRecreateWebhookRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<HttpResult>(); }
}
(CrmRecreateWebhookRequest as unknown)[immerable] = true;

// @Route("/consent", "GET")
export class OnlineConsentRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<OnlineConsentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineConsentRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(OnlineConsentRequest as unknown)[immerable] = true;

// @Route("/consent/change", "POST")
export class OnlineConsentChangeRequest extends OnlineConsent implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<OnlineConsentChangeRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineConsentChangeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(OnlineConsentChangeRequest as unknown)[immerable] = true;

// @Route("/api/sys/experimental-features/registry", "GET")
export class GetExperimentalFeaturesRegistryRequest implements IReturn<ResponseBase<ExperimentalFeatureDefinition>>
{

    public constructor(init?: Partial<GetExperimentalFeaturesRegistryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetExperimentalFeaturesRegistryRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ExperimentalFeatureDefinition>(); }
}
(GetExperimentalFeaturesRegistryRequest as unknown)[immerable] = true;

// @Route("/batchEmail")
export class CustomBatchEmailRequest implements ISecurityIds
{
    public ids: BatchEmailRequestObject[];
    public template: string;
    public contactId: number;
    public securityIds: number[];

    public constructor(init?: Partial<CustomBatchEmailRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomBatchEmailRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(CustomBatchEmailRequest as unknown)[immerable] = true;

// @Route("/payment/emailReceipt")
export class PaymentReceiptRequest implements ISecurityId
{
    public id: number;
    public securityId: number;
    public mode: string;
    public template: string;

    public constructor(init?: Partial<PaymentReceiptRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PaymentReceiptRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(PaymentReceiptRequest as unknown)[immerable] = true;

// @Route("/quickbill/email")
export class QuickBillEmailRequest implements ISecurityId, ISecurityType
{
    public id: number;
    public securityId: number;
    public type: string;
    public securityType: string;

    public constructor(init?: Partial<QuickBillEmailRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuickBillEmailRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(QuickBillEmailRequest as unknown)[immerable] = true;

// @Route("/email")
export class CustomEmailRequest implements ISecurityId, ISecurityType
{
    public to: string[];
    public from: string;
    public fromName: string;
    public cc: string[];
    public bcc: string[];
    public subject: string;
    public message: string;
    public type: string;
    public typeId: number;
    public medicalContactId?: number;
    public fileName: string;
    public attachments: AttachmentGroup;
    public logMessage: string;
    public createLog: boolean;
    public createDocumentHistory: boolean;
    public securityId: number;
    public securityType: string;
    public calendar: string;
    public isOnline?: boolean;
    public fallbackCustomerId?: number;
    public typeGuid: string;
    public locationId?: number;

    public constructor(init?: Partial<CustomEmailRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomEmailRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(CustomEmailRequest as unknown)[immerable] = true;

// @Route("/emailFromAddress")
export class GetEmailFromAddress implements IReturn<GetEmailFromAddressResponse>
{
    public type: string;
    public typeId: number;
    public locationId: number;
    public teamId?: string;

    public constructor(init?: Partial<GetEmailFromAddress>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetEmailFromAddress'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetEmailFromAddressResponse(); }
}
(GetEmailFromAddress as unknown)[immerable] = true;

export class GetEmailFromAddressSettingsAllowed implements IReturn<ResponseBase<string>>
{

    public constructor(init?: Partial<GetEmailFromAddressSettingsAllowed>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetEmailFromAddressSettingsAllowed'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<string>(); }
}
(GetEmailFromAddressSettingsAllowed as unknown)[immerable] = true;

export class GetEmailFromAddressSettingsDomains implements IReturn<ResponseBase<string>>
{

    public constructor(init?: Partial<GetEmailFromAddressSettingsDomains>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetEmailFromAddressSettingsDomains'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<string>(); }
}
(GetEmailFromAddressSettingsDomains as unknown)[immerable] = true;

export class AddEmailToFromAddressSettingsReq extends ModiyEmailToFromAddressSettingsReq implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<AddEmailToFromAddressSettingsReq>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'AddEmailToFromAddressSettingsReq'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(AddEmailToFromAddressSettingsReq as unknown)[immerable] = true;

export class RemoveEmailFromAddressSettingsReq extends ModiyEmailToFromAddressSettingsReq implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<RemoveEmailFromAddressSettingsReq>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'RemoveEmailFromAddressSettingsReq'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(RemoveEmailFromAddressSettingsReq as unknown)[immerable] = true;

// @Route("/emailFromAddress/settings", "POST")
export class SaveEmailFromAddressSettings implements IReturn<GetEmailFromAddressSettingsResponse>
{
    public fromAddresses: string[];

    public constructor(init?: Partial<SaveEmailFromAddressSettings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveEmailFromAddressSettings'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetEmailFromAddressSettingsResponse(); }
}
(SaveEmailFromAddressSettings as unknown)[immerable] = true;

// @Route("/ccl/{ClientID}")
export class ClearCachedLicenseRequest implements IReturn<Object>
{
    public clientID: string;

    public constructor(init?: Partial<ClearCachedLicenseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClearCachedLicenseRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Object(); }
}
(ClearCachedLicenseRequest as unknown)[immerable] = true;

// @Route("/ccp/{ClientID}")
export class ClearCachedPermissionsRequest implements IReturn<Object>
{
    public clientID: string;

    public constructor(init?: Partial<ClearCachedPermissionsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClearCachedPermissionsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Object(); }
}
(ClearCachedPermissionsRequest as unknown)[immerable] = true;

// @Route("/ccc/{ClientID}")
export class ClearCachedConfigRequest implements IReturn<Object>
{
    public clientID: string;

    public constructor(init?: Partial<ClearCachedConfigRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClearCachedConfigRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Object(); }
}
(ClearCachedConfigRequest as unknown)[immerable] = true;

// @Route("/ccwt/{ClientID}")
export class ClearCachedWebTemplatesRequest implements IReturn<Object>
{
    public clientID: string;

    public constructor(init?: Partial<ClearCachedWebTemplatesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClearCachedWebTemplatesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Object(); }
}
(ClearCachedWebTemplatesRequest as unknown)[immerable] = true;

// @Route("/ccwr/{ClientID}")
export class ClearCachedWebReportsRequest implements IReturn<Object>
{
    public clientID: string;

    public constructor(init?: Partial<ClearCachedWebReportsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClearCachedWebReportsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Object(); }
}
(ClearCachedWebReportsRequest as unknown)[immerable] = true;

// @Route("/ccrmf/{ClientID}")
export class ClearCachedReloadMissingFilesRequest implements IReturn<ClearCachedReloadMissingFilesResponse>
{
    public clientID: string;

    public constructor(init?: Partial<ClearCachedReloadMissingFilesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClearCachedReloadMissingFilesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ClearCachedReloadMissingFilesResponse(); }
}
(ClearCachedReloadMissingFilesRequest as unknown)[immerable] = true;

// @Route("/config/clear/{ClientId}/{Key}")
export class ClearCachedConfig implements IReturn<Object>
{
    public key: string;
    public clientId: string;

    public constructor(init?: Partial<ClearCachedConfig>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClearCachedConfig'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Object(); }
}
(ClearCachedConfig as unknown)[immerable] = true;

// @Route("/ccek/{ClientID}")
export class ClearCachedExtractionKeyRequest implements IReturn<Object>
{
    public clientID: string;

    public constructor(init?: Partial<ClearCachedExtractionKeyRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClearCachedExtractionKeyRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Object(); }
}
(ClearCachedExtractionKeyRequest as unknown)[immerable] = true;

// @Route("/hangfire/trigger/{Code}/{Job}")
export class HangfireJobTrigger implements IReturn<Object>
{
    public job: string;
    public code: string;

    public constructor(init?: Partial<HangfireJobTrigger>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'HangfireJobTrigger'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Object(); }
}
(HangfireJobTrigger as unknown)[immerable] = true;

// @Route("/ccj/{ClientId}")
export class ClearCachedJobsRequest implements IReturn<Object>
{
    public clientID: string;

    public constructor(init?: Partial<ClearCachedJobsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClearCachedJobsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Object(); }
}
(ClearCachedJobsRequest as unknown)[immerable] = true;

// @Route("/clinical/settings/labels")
export class ClinicalLabelRequest
{

    public constructor(init?: Partial<ClinicalLabelRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalLabelRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(ClinicalLabelRequest as unknown)[immerable] = true;

// @Route("/clinical/settings/reportingfields")
export class ClinicalReportingFieldRequest implements IReturn<ResponseBase<ClinicalReportingFieldResponse>>
{

    public constructor(init?: Partial<ClinicalReportingFieldRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalReportingFieldRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ClinicalReportingFieldResponse>(); }
}
(ClinicalReportingFieldRequest as unknown)[immerable] = true;

// @Route("/clinical/settings/diagnosisCodes", "GET")
export class ClinicalSettingsDiagnosisRequest implements IReturn<ResponseBase<CustomListItemResponse>>
{
    public text: string;
    public bodySite: string;
    public mapping: string;

    public constructor(init?: Partial<ClinicalSettingsDiagnosisRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalSettingsDiagnosisRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CustomListItemResponse>(); }
}
(ClinicalSettingsDiagnosisRequest as unknown)[immerable] = true;

// @Route("/clinical/settings/diagnosisCodes", "POST")
export class ClinicalSettingsDiagnosisRequestPost implements IReturn<DiagnosisCode>
{
    public text: string;
    public bodySite: string;
    public mapping: string;
    public serviceTypeId: number;

    public constructor(init?: Partial<ClinicalSettingsDiagnosisRequestPost>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalSettingsDiagnosisRequestPost'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DiagnosisCode(); }
}
(ClinicalSettingsDiagnosisRequestPost as unknown)[immerable] = true;

// @Route("/clinical/settings/diagnosisCodes/delete")
export class ClinicalSettingsDeleteDiagnosisRequest implements IReturnVoid
{
    public text: string;
    public bodySite: string;

    public constructor(init?: Partial<ClinicalSettingsDeleteDiagnosisRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalSettingsDeleteDiagnosisRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(ClinicalSettingsDeleteDiagnosisRequest as unknown)[immerable] = true;

// @Route("/clinical/settings/mytemplates")
// @Route("/clinical/settings/mytemplates/{Id}")
export class ClinicalMyTemplatesRequest implements IReturn<ResponseBase<ClinicalMyTemplatesResponse>>, ILocationId
{
    public id: number;
    public name: string;
    public description: string;
    public type?: string;
    public body: string;
    public summary: string;
    public globalId: string;
    public locationId: number;
    public serviceTypeId?: number;
    public format: BlockTemplateFormat;
    public signatureRequired: boolean;
    public allowsAttachments: boolean;
    public requiresAttachment: boolean;
    public attachmentPromptText: string;

    public constructor(init?: Partial<ClinicalMyTemplatesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalMyTemplatesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ClinicalMyTemplatesResponse>(); }
}
(ClinicalMyTemplatesRequest as unknown)[immerable] = true;

// @Route("/clinical/settings/mytemplates/delete")
export class ClinicalMyTemplatesDeleteRequest implements IReturn<ResponseBase<ClinicalMyTemplatesResponse>>, ILocationId
{
    public id: number;
    public locationId: number;

    public constructor(init?: Partial<ClinicalMyTemplatesDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalMyTemplatesDeleteRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClinicalMyTemplatesResponse>(); }
}
(ClinicalMyTemplatesDeleteRequest as unknown)[immerable] = true;

// @Route("/clinical/settings/mytemplates/default")
export class ClinicalMyTemplatesDefaultRequest implements IReturn<ResponseBase<ClinicalMyTemplatesResponse>>, ILocationId
{
    public globalId: string;
    public serviceTypeId?: number;
    public type: string;
    public isFirst: boolean;
    public locationId: number;

    public constructor(init?: Partial<ClinicalMyTemplatesDefaultRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalMyTemplatesDefaultRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClinicalMyTemplatesResponse>(); }
}
(ClinicalMyTemplatesDefaultRequest as unknown)[immerable] = true;

// @Route("/clinical/settings/mytemplates/clone/{Id}")
export class ClinicalMyTemplatesCloneRequest implements IReturn<ResponseBase<ClinicalMyTemplatesResponse>>
{
    public id: number;

    public constructor(init?: Partial<ClinicalMyTemplatesCloneRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalMyTemplatesCloneRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ClinicalMyTemplatesResponse>(); }
}
(ClinicalMyTemplatesCloneRequest as unknown)[immerable] = true;

// @Route("/clinical/settings/flags/used", "GET")
export class UsedFlagsRequest implements IReturn<ResponseBase<Lookup>>
{

    public constructor(init?: Partial<UsedFlagsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UsedFlagsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<Lookup>(); }
}
(UsedFlagsRequest as unknown)[immerable] = true;

// @Route("/clinical/settings/flags", "GET")
export class ClinicalSettingsFlagsRequest implements IReturn<ClinicalSettingsFlagsResponse>
{
    public colour: string;
    public title: string;

    public constructor(init?: Partial<ClinicalSettingsFlagsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalSettingsFlagsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ClinicalSettingsFlagsResponse(); }
}
(ClinicalSettingsFlagsRequest as unknown)[immerable] = true;

// @Route("/clinical/settings/flags", "POST")
export class ClinicalSettingsFlagsRequestPost implements IReturn<ResponseBase<boolean>>
{
    public colour: string;
    public title: string;

    public constructor(init?: Partial<ClinicalSettingsFlagsRequestPost>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalSettingsFlagsRequestPost'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ClinicalSettingsFlagsRequestPost as unknown)[immerable] = true;

// @Route("/clinical/settings/flags/acknowledge")
export class ClinicalSettingsAcknowledgeFlagsRequest implements IReturn<ResponseBase<string>>, ILocationId
{
    public colour: string;
    public locationId: number;

    public constructor(init?: Partial<ClinicalSettingsAcknowledgeFlagsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalSettingsAcknowledgeFlagsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<string>(); }
}
(ClinicalSettingsAcknowledgeFlagsRequest as unknown)[immerable] = true;

// @Route("/integrations", "GET")
export class ClinicalSettingsIntegrationsRequest implements IReturn<ResponseBase<SystemConfig>>
{

    public constructor(init?: Partial<ClinicalSettingsIntegrationsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalSettingsIntegrationsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<SystemConfig>(); }
}
(ClinicalSettingsIntegrationsRequest as unknown)[immerable] = true;

// @Route("/integrations", "POST")
export class ClinicalSettingsIntegrationsRequestPost implements IReturn<ResponseBase<boolean>>
{
    public settingsToUpdate: SystemConfig[];

    public constructor(init?: Partial<ClinicalSettingsIntegrationsRequestPost>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalSettingsIntegrationsRequestPost'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ClinicalSettingsIntegrationsRequestPost as unknown)[immerable] = true;

// @Route("/integrations/physitrack")
export class ClinicalSettingsPhysitrackIntegrationRequest implements IReturn<ResponseBase<PractitionerResponse>>
{

    public constructor(init?: Partial<ClinicalSettingsPhysitrackIntegrationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalSettingsPhysitrackIntegrationRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<PractitionerResponse>(); }
}
(ClinicalSettingsPhysitrackIntegrationRequest as unknown)[immerable] = true;

// @Route("/clinical/settings/fixconvertedimages")
export class ClinicalSettingsFixConvertedImagesRequest implements IReturn<ResponseBase<boolean>>
{
    public email: string;

    public constructor(init?: Partial<ClinicalSettingsFixConvertedImagesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalSettingsFixConvertedImagesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ClinicalSettingsFixConvertedImagesRequest as unknown)[immerable] = true;

// @Route("/clinical/settings/mytemplates/hide")
export class ClinicalMyTemplatesHideRequest implements IReturn<ResponseBase<ClinicalMyTemplatesResponse>>
{
    public id: number;
    public archived: boolean;

    public constructor(init?: Partial<ClinicalMyTemplatesHideRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalMyTemplatesHideRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<ClinicalMyTemplatesResponse>(); }
}
(ClinicalMyTemplatesHideRequest as unknown)[immerable] = true;

// @Route("/clinical/settings/permission-holders", "GET")
export class PermissionHoldersRequest implements IReturn<ResponseBase<PermissionHolderResult>>
{
    public permission: string;

    public constructor(init?: Partial<PermissionHoldersRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PermissionHoldersRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<PermissionHolderResult>(); }
}
(PermissionHoldersRequest as unknown)[immerable] = true;

// @Route("/lookups/nested/search", "POST")
export class CustomLookupSearchRequest implements IReturn<ResponseBase<CustomLookupResponse>>
{
    public term: string;
    public terms: string[];

    public constructor(init?: Partial<CustomLookupSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomLookupSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CustomLookupResponse>(); }
}
(CustomLookupSearchRequest as unknown)[immerable] = true;

// @Route("/lookups/nested", "POST")
// @Route("/lookups/nested/{Id}", "GET, PUT, DELETE")
export class CustomLookupRequest implements IReturn<ResponseBase<CustomLookupResponse>>
{
    public id: number;
    public name: string;
    public value: string;
    public alternates: string[];
    public groupId?: number;
    public serviceTypeId?: number;

    public constructor(init?: Partial<CustomLookupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomLookupRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CustomLookupResponse>(); }
}
(CustomLookupRequest as unknown)[immerable] = true;

export class CustomLookupsPutRequest implements IReturn<ResponseBase<boolean>>
{
    public lookups: CustomLookupRequest[];

    public constructor(init?: Partial<CustomLookupsPutRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomLookupsPutRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CustomLookupsPutRequest as unknown)[immerable] = true;

// @Route("/lookups/nested/alternates")
export class AlternateLookupRequest implements IReturn<ResponseBase<{ [index:string]: { [index:string]: string; }; }>>
{

    public constructor(init?: Partial<AlternateLookupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AlternateLookupRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<{ [index:string]: { [index:string]: string; }; }>(); }
}
(AlternateLookupRequest as unknown)[immerable] = true;

// @Route("/diagnostics/dryioc-benchmark", "GET")
export class DryIocBenchmarkRequest implements IReturn<DryIocBenchmarkResponse>
{
    public iterations?: number;

    public constructor(init?: Partial<DryIocBenchmarkRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DryIocBenchmarkRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new DryIocBenchmarkResponse(); }
}
(DryIocBenchmarkRequest as unknown)[immerable] = true;

// @Route("/system/dryioc", "GET")
export class DryIocDiagnosticsRequest implements IReturn<string>
{
    public forceGc: boolean;
    public deep: boolean;
    public maxDepth: number;
    public maxObjects: number;

    public constructor(init?: Partial<DryIocDiagnosticsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DryIocDiagnosticsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return ''; }
}
(DryIocDiagnosticsRequest as unknown)[immerable] = true;

// @Route("/system/keepalive", "POST")
export class KeepAliveRequest implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<KeepAliveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'KeepAliveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(KeepAliveRequest as unknown)[immerable] = true;

// @Route("/sso")
export class SsoRequest
{
    public sso: string;
    public sig: string;

    public constructor(init?: Partial<SsoRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SsoRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(SsoRequest as unknown)[immerable] = true;

// @Route("/clinical/templates", "GET")
export class ClinicalTemplateRequest implements IReturn<ResponseBase<ClinicalTemplatesResponse>>
{

    public constructor(init?: Partial<ClinicalTemplateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalTemplateRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ClinicalTemplatesResponse>(); }
}
(ClinicalTemplateRequest as unknown)[immerable] = true;

// @Route("/templates/type", "POST")
// @Route("/templates/type/{Type}", "POST")
export class TemplatesByTypeRequest implements IReturn<ResponseBase<Template>>
{
    public type: string;
    public types: string[];

    public constructor(init?: Partial<TemplatesByTypeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemplatesByTypeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<Template>(); }
}
(TemplatesByTypeRequest as unknown)[immerable] = true;

export class TemplateRequest implements IReturn<ResponseBase<TemplateResponse>>
{
    public id: number;

    public constructor(init?: Partial<TemplateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TemplateRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<TemplateResponse>(); }
}
(TemplateRequest as unknown)[immerable] = true;

export class SaveTemplateRequest implements IReturn<ResponseBase<boolean>>
{
    public id: number;
    public body: string;
    public name: string;
    public signatureRequired: boolean;
    public allowsAttachments: boolean;
    public requiresAttachment: boolean;
    public attachmentPromptText: string;

    public constructor(init?: Partial<SaveTemplateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveTemplateRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(SaveTemplateRequest as unknown)[immerable] = true;

export class ClickAccountPaymentsStatsRequest implements IReturn<ResponseBase<ClickAccountPaymentsStatsResponse>>
{
    public accountId: number;

    public constructor(init?: Partial<ClickAccountPaymentsStatsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickAccountPaymentsStatsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClickAccountPaymentsStatsResponse>(); }
}
(ClickAccountPaymentsStatsRequest as unknown)[immerable] = true;

export class ClickAccountInvoiceStatsRequest implements IReturn<ResponseBase<ClickAccountInvoiceStatsResponse>>
{
    public accountId: number;

    public constructor(init?: Partial<ClickAccountInvoiceStatsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickAccountInvoiceStatsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClickAccountInvoiceStatsResponse>(); }
}
(ClickAccountInvoiceStatsRequest as unknown)[immerable] = true;

export class ClickAccountUninvoicedChargesCountRequest implements IReturn<ResponseBase<ClickAccountUninvoicedChargesCountResponse>>
{
    public accountId: number;

    public constructor(init?: Partial<ClickAccountUninvoicedChargesCountRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickAccountUninvoicedChargesCountRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClickAccountUninvoicedChargesCountResponse>(); }
}
(ClickAccountUninvoicedChargesCountRequest as unknown)[immerable] = true;

export class ClickAccountBusinessUninvoicedChargesCountRequest implements IReturn<ResponseBase<ClickAccountUninvoicedChargesCountResponse>>
{
    public accountId: number;

    public constructor(init?: Partial<ClickAccountBusinessUninvoicedChargesCountRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickAccountBusinessUninvoicedChargesCountRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClickAccountUninvoicedChargesCountResponse>(); }
}
(ClickAccountBusinessUninvoicedChargesCountRequest as unknown)[immerable] = true;

export class ClickAccountBusinessInvoiceStatsRequest implements IReturn<ResponseBase<ClickAccountInvoiceStatsResponse>>
{
    public accountId: number;

    public constructor(init?: Partial<ClickAccountBusinessInvoiceStatsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickAccountBusinessInvoiceStatsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClickAccountInvoiceStatsResponse>(); }
}
(ClickAccountBusinessInvoiceStatsRequest as unknown)[immerable] = true;

// @Route("/cases/{Id}/print", "POST")
export class CasePrintingRequest implements IReturn<ResponseBase<CasePrintingResponse>>, ISecurityId, IFilterServiceTypeManually
{
    public id: number;
    public locationIds: number[];
    public items: CasePrintingItem[];
    public goals: number[];
    public scores: number[];
    public discharge: boolean;
    public pmh: boolean;
    public securityId: number;

    public constructor(init?: Partial<CasePrintingRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CasePrintingRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CasePrintingResponse>(); }
}
(CasePrintingRequest as unknown)[immerable] = true;

// @Route("/cases/{id}/reports/search", "GET")
export class CaseReportSearchRequest implements IReturn<ResponseBase<CaseReportSearchResponse>>, ILocationIds, ISecurityId
{
    public id: number;
    public locationIds: number[];
    public requestLocationIds: number[];
    public securityId: number;

    public constructor(init?: Partial<CaseReportSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseReportSearchRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CaseReportSearchResponse>(); }
}
(CaseReportSearchRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/reports", "POST")
// @Route("/cases/{CaseId}/reports/{Id}", "PUT")
export class CaseReportRequest extends CaseReport implements IReturn<ResponseBase<CaseReport>>, IHasCaseId, ISecurityId
{
    public caseId: number;
    public securityId: number;

    public constructor(init?: Partial<CaseReportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CaseReport>(); }
}
(CaseReportRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/reports/{Id}/submit", "POST")
export class CaseReportSubmitRequest extends CaseReport implements IReturn<ResponseBase<CaseReport>>, IHasCaseId, ISecurityId
{
    public caseId: number;
    public securityId: number;

    public constructor(init?: Partial<CaseReportSubmitRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseReportSubmitRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CaseReport>(); }
}
(CaseReportSubmitRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/reports/{Id}/clone", "POST")
export class CaseReportCloneRequest extends CaseReport implements IReturn<ResponseBase<Object>>, IHasCaseId, ISecurityId
{
    public caseId: number;
    public securityId: number;

    public constructor(init?: Partial<CaseReportCloneRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseReportCloneRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<Object>(); }
}
(CaseReportCloneRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/reports/{Id}/acknowledge", "POST")
export class CaseReportAcknowledgeRequest implements IReturn<Object>, ISecurityId
{
    public id: string;
    public caseId: number;
    public securityId: number;

    public constructor(init?: Partial<CaseReportAcknowledgeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseReportAcknowledgeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Object(); }
}
(CaseReportAcknowledgeRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/attachments/{Name}", "GET")
export class CaseReportAttachmentRequest implements IReturn<Object>, ISecurityId
{
    public name: string;
    public caseId: number;
    public securityId: number;

    public constructor(init?: Partial<CaseReportAttachmentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseReportAttachmentRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Object(); }
}
(CaseReportAttachmentRequest as unknown)[immerable] = true;

// @Route("/cases/dashboard/search")
export class CaseDashboardSearchRequest implements IReturn<ResponseBase<CaseDashboardResponse>>, ILocationIds, IFilterServiceTypeManually
{
    public skip: number;
    public take: number;
    public awaiting: boolean;
    public inTreatment: boolean;
    public noNotes: boolean;
    public practitionerId: number;
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<CaseDashboardSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseDashboardSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CaseDashboardResponse>(); }
}
(CaseDashboardSearchRequest as unknown)[immerable] = true;

// @Route("/cases/search")
export class CaseSearchRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<CaseSearchResponse>>
{
    public admittedBetweenDates: DateRange;
    public dischargedBetweenDates: DateRange;
    public bodySites: string[];
    public diagnosisCode: string[];
    public practitionerIds: number[];
    public id?: number;
    public businessIds: number[];
    public statuses: number[];
    public name: string;
    public searchApplied: boolean;
    public userIsPractitioner: boolean;
    public dashboardRequest: boolean;
    public initialLoad: boolean;

    public constructor(init?: Partial<CaseSearchRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CaseSearchResponse>(); }
}
(CaseSearchRequest as unknown)[immerable] = true;

// @Route("/case/{Id}/audit", "POST")
export class CaseAudit implements IReturn<CaseAuditResponse>, ILocationIds, ISecurityId
{
    public id: number;
    public userId: number;
    public note: string;
    public locationIds: number[];
    public requestLocationIds: number[];
    public securityId: number;

    public constructor(init?: Partial<CaseAudit>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseAudit'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CaseAuditResponse(); }
}
(CaseAudit as unknown)[immerable] = true;

// @Route("/cases/{Id}/autosave", "POST")
export class CaseAutoSaveRequest implements IReturn<AutoSaveResult[]>, ILocationIds
{
    public id: number;
    public updates: AutoSaveUpdate[];
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<CaseAutoSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseAutoSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Array<AutoSaveResult>(); }
}
(CaseAutoSaveRequest as unknown)[immerable] = true;

// @Route("/cases/{Id}/close", "POST")
export class CaseCloseRequest implements IReturn<AutoSaveResult[]>, ILocationIds
{
    public id: number;
    public updates: AutoSaveUpdate[];
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<CaseCloseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseCloseRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Array<AutoSaveResult>(); }
}
(CaseCloseRequest as unknown)[immerable] = true;

// @Route("/cases/{Id}/unlock", "POST")
export class CaseUnlockRequest implements IReturn<ResponseBase<boolean>>, ILocationIds
{
    public id: number;
    public reason: string;
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<CaseUnlockRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseUnlockRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CaseUnlockRequest as unknown)[immerable] = true;

// @Route("/cases/{Id}/undischarge", "POST")
export class CaseUndischargeRequest implements IReturn<ResponseBase<CaseDischargeSnapshot[]>>, ILocationIds
{
    public id: number;
    public reason: string;
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<CaseUndischargeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseUndischargeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CaseDischargeSnapshot[]>(); }
}
(CaseUndischargeRequest as unknown)[immerable] = true;

// @Route("/cases/{Id}/delete", "POST")
export class CaseDeleteRequest implements IReturn<ResponseBase<boolean>>, ILocationIds
{
    public id: number;
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<CaseDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseDeleteRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CaseDeleteRequest as unknown)[immerable] = true;

// @Route("/cases/{Id}/delete", "POST")
export class CaseUnlinkAndDelete extends CaseDeleteRequest implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<CaseUnlinkAndDelete>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseUnlinkAndDelete'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CaseUnlinkAndDelete as unknown)[immerable] = true;

// @Route("/cases/{Id}/update", "POST")
export class CaseUpdateRequest implements IReturnVoid, ILocationIds
{
    public id: number;
    public updates: AutoSaveUpdate[];
    public lastModified?: string;
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<CaseUpdateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseUpdateRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(CaseUpdateRequest as unknown)[immerable] = true;

// @Route("/cases/{Id}/discharge", "POST")
export class CaseDischargeRequest implements IReturn<ResponseBase<string>>, ILocationIds
{
    public id: number;
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<CaseDischargeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseDischargeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<string>(); }
}
(CaseDischargeRequest as unknown)[immerable] = true;

export class CaseIsTaxExempt implements IReturn<ResponseBase<boolean>>
{
    public appointmentId?: number;
    public caseId?: number;

    public constructor(init?: Partial<CaseIsTaxExempt>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseIsTaxExempt'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CaseIsTaxExempt as unknown)[immerable] = true;

// @Route("/cases/{Id}/highlight", "POST")
export class CaseHighlightRequest implements IReturn<ResponseBase<boolean>>, ILocationIds
{
    public id: number;
    public type: string;
    public highlights: { [index:string]: number[]; };
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<CaseHighlightRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseHighlightRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CaseHighlightRequest as unknown)[immerable] = true;

// @Route("/cases/{Id}", "GET")
export class CaseGetRequest implements IReturn<CaseDetailsDto>, ISecurityId
{
    public id: number;
    public securityId: number;

    public constructor(init?: Partial<CaseGetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseGetRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CaseDetailsDto(); }
}
(CaseGetRequest as unknown)[immerable] = true;

// @Route("/case/addCharge/{CaseId}")
export class AddChargeToCase implements IReturn<ResponseBase<BillingItemWithDetails[]>>, ISecurityId
{
    public charges: BillingItemWithDetails[];
    public caseId: number;
    public treatmentId?: number;
    public customerId: number;
    public securityId: number;

    public constructor(init?: Partial<AddChargeToCase>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddChargeToCase'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<BillingItemWithDetails[]>(); }
}
(AddChargeToCase as unknown)[immerable] = true;

export class CaseUpdateTaxStatus implements IReturn<ResponseBase<boolean>>
{
    public caseId: number;
    public taxExempt: boolean;
    public justification: string;

    public constructor(init?: Partial<CaseUpdateTaxStatus>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseUpdateTaxStatus'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CaseUpdateTaxStatus as unknown)[immerable] = true;

// @Route("/cases/new", "GET")
export class CaseNewRequest implements IReturn<CaseDetailsDto>, ILocationIds
{
    public patientId?: number;
    public appointmentId?: number;
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<CaseNewRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseNewRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CaseDetailsDto(); }
}
(CaseNewRequest as unknown)[immerable] = true;

// @Route("/cases/{Id}/upgrade")
export class CaseUpgradeRequest implements IReturn<ResponseBase<boolean>>, ILocationIds
{
    public id: number;
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<CaseUpgradeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseUpgradeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CaseUpgradeRequest as unknown)[immerable] = true;

// @Route("/cases/{id}/history")
export class CaseHistoryRequest implements IReturn<ResponseBase<HistoryResult>>, ISecurityId
{
    public id: number;
    public securityId: number;
    public formStatus: FormStatus[];

    public constructor(init?: Partial<CaseHistoryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseHistoryRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<HistoryResult>(); }
}
(CaseHistoryRequest as unknown)[immerable] = true;

// @Route("/case/{CustomerId}")
// @Route("/case")
export class CaseDropdownRequest implements IReturn<ResponseBase<CaseDropDownResposne>>, ILocationIds
{
    public skip: number;
    public take: number;
    public customerId: number;
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<CaseDropdownRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseDropdownRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CaseDropDownResposne>(); }
}
(CaseDropdownRequest as unknown)[immerable] = true;

// @Route("/case/reviewDate")
export class CaseReviewDateRequest implements IReturn<ResponseBase<boolean>>, ILocationIds
{
    public caseId: number;
    public reviewDate: string;
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<CaseReviewDateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseReviewDateRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CaseReviewDateRequest as unknown)[immerable] = true;

// @Route("/case/{CaseId}/notes/add")
export class PostCloseNotesRequest implements IReturn<ResponseBase<PostCloseNotesWithUser>>, ISecurityId
{
    public id: number;
    public caseId: number;
    public securityId: number;
    public treatmentId?: number;
    public userId: number;
    public notes: string;
    public date: string;
    public type: string;

    public constructor(init?: Partial<PostCloseNotesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostCloseNotesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<PostCloseNotesWithUser>(); }
}
(PostCloseNotesRequest as unknown)[immerable] = true;

// @Route("/case/customers/{CustomerId}/{CaseId}")
export class CaseCustomerRequest implements IReturn<ResponseBase<GeneralCustomerResponse>>, ISecurityId
{
    public customerId?: number;
    public caseId: number;
    public securityId: number;

    public constructor(init?: Partial<CaseCustomerRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseCustomerRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GeneralCustomerResponse>(); }
}
(CaseCustomerRequest as unknown)[immerable] = true;

// @Route("/casecheck/appt")
export class AppointmentCheck implements IReturn<ResponseBase<boolean>>
{
    public caseId: number;
    public appointmentId: number;

    public constructor(init?: Partial<AppointmentCheck>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AppointmentCheck'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(AppointmentCheck as unknown)[immerable] = true;

// @Route("/cases/{Id}/background", "GET, POST")
export class CaseBackgroundRequest implements IReturn<ResponseBase<CustomerBackgroundResponse>>, ISecurityId
{
    public id: number;
    public data: { [index:string]: Object; };
    public securityId: number;

    public constructor(init?: Partial<CaseBackgroundRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseBackgroundRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CustomerBackgroundResponse>(); }
}
(CaseBackgroundRequest as unknown)[immerable] = true;

// @Route("/customer/{CustomerId}/background", "GET, POST")
export class CustomerBackgroundRequest implements IReturn<ResponseBase<CustomerBackgroundResponse>>, ICustomerId
{
    public customerId: number;
    public data: { [index:string]: Object; };

    public constructor(init?: Partial<CustomerBackgroundRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerBackgroundRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CustomerBackgroundResponse>(); }
}
(CustomerBackgroundRequest as unknown)[immerable] = true;

// @Route("/background/{Id}/highlight", "POST")
export class BackgroundHighlightRequest implements IReturn<ResponseBase<boolean>>, ILocationIds
{
    public id: number;
    public highlights: { [index:string]: number[]; };
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<BackgroundHighlightRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BackgroundHighlightRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(BackgroundHighlightRequest as unknown)[immerable] = true;

// @Route("/cases/cache/all", "GET")
export class ClinicalCacheRequest implements IReturn<ClinicalCacheResponse>
{

    public constructor(init?: Partial<ClinicalCacheRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalCacheRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ClinicalCacheResponse(); }
}
(ClinicalCacheRequest as unknown)[immerable] = true;

// @Route("/clinical/logs/{CustomerId}/{CaseId}")
// @Route("/clinical/logs/{CustomerId}/{CaseId}/{Id}")
export class ClinicalLogRequest implements IReturn<ResponseBase<IPatientInfoResponse>>, ICustomerId, IDepartmentIds
{
    public id: number;
    public customerId: number;
    public caseId: number;
    public departmentIds: number[];

    public constructor(init?: Partial<ClinicalLogRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalLogRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<IPatientInfoResponse>(); }
}
(ClinicalLogRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/consultation/{TreatmentId}/items/{Id}/highlight", "POST")
export class ConsultationItemHighlightRequest implements IReturn<ResponseBase<boolean>>, ISecurityId
{
    public id: number;
    public caseId: number;
    public treatmentId: number;
    public highlights: { [index:string]: number[]; };
    public securityId: number;

    public constructor(init?: Partial<ConsultationItemHighlightRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ConsultationItemHighlightRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ConsultationItemHighlightRequest as unknown)[immerable] = true;

// @Route("/diagnosiscodes/all")
export class DiagnosisCodeRequest implements IReturn<ResponseBase<CustomListItemResponse>>
{

    public constructor(init?: Partial<DiagnosisCodeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiagnosisCodeRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CustomListItemResponse>(); }
}
(DiagnosisCodeRequest as unknown)[immerable] = true;

// @Route("/diagnosiscodes/allVals")
// @Route("/diagnosiscodes/lookupVals")
export class DiagnosisCodeLookupRequest implements IReturn<ResponseBase<DiagnosisCodeTempResponse>>
{

    public constructor(init?: Partial<DiagnosisCodeLookupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiagnosisCodeLookupRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<DiagnosisCodeTempResponse>(); }
}
(DiagnosisCodeLookupRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/diagram", "POST")
// @Route("/cases/{CaseId}/diagram/{Id}", "PUT, DELETE")
export class DiagramRequest implements IReturn<ClinicalDiagram>, ISecurityId
{
    public id?: number;
    public caseId: number;
    public securityId: number;
    public treatmentId: number;
    public dateTime: string;
    public value: { [index:string]: Object; }[];

    public constructor(init?: Partial<DiagramRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiagramRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ClinicalDiagram(); }
}
(DiagramRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/diagram/{Id}/lock", "PUT")
export class DiagramLockRequest implements IReturn<ClinicalDiagram>, ISecurityId
{
    public id: number;
    public caseId: number;
    public securityId: number;

    public constructor(init?: Partial<DiagramLockRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiagramLockRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ClinicalDiagram(); }
}
(DiagramLockRequest as unknown)[immerable] = true;

export class CreatePsfsRequest implements IReturn<ResponseBase<Psfs[]>>
{
    public caseId: number;
    public activities: NewPsfs[];
    public hasInitialValues: boolean;

    public constructor(init?: Partial<CreatePsfsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreatePsfsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<Psfs[]>(); }
}
(CreatePsfsRequest as unknown)[immerable] = true;

export class UpdatePsfsRequest implements IReturn<ResponseBase<Psfs[]>>
{
    public caseId: number;
    public psfs: Psfs[];
    public activities: NewPsfs[];

    public constructor(init?: Partial<UpdatePsfsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdatePsfsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<Psfs[]>(); }
}
(UpdatePsfsRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/consultation/{TreatmentId}/recordings", "POST")
export class CreateSessionRecordingRequest implements IReturn<ResponseBase<SessionRecordingDto>>, ISecurityId
{
    public caseId: number;
    public treatmentId: number;
    public appointmentId?: number;
    public startedAt: string;
    public endedAt?: string;
    public durationSeconds: number;
    public status: SessionRecordingStatus;
    public provider: string;
    public correlationId: string;
    public failureReason: string;
    public consentGiven: boolean;
    public segments: TranscriptSegmentDto[];
    public securityId: number;

    public constructor(init?: Partial<CreateSessionRecordingRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateSessionRecordingRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SessionRecordingDto>(); }
}
(CreateSessionRecordingRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/consultation/{TreatmentId}/recordings/{Id}", "PUT")
export class UpdateSessionRecordingRequest implements IReturn<ResponseBase<SessionRecordingDto>>, ISecurityId
{
    public id: number;
    public caseId: number;
    public treatmentId: number;
    public segments: TranscriptSegmentDto[];
    public securityId: number;

    public constructor(init?: Partial<UpdateSessionRecordingRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateSessionRecordingRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<SessionRecordingDto>(); }
}
(UpdateSessionRecordingRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/consultation/{TreatmentId}/recordings", "GET")
export class SessionRecordingListRequest implements IReturn<ResponseBase<SessionRecordingDto>>, ISecurityId
{
    public caseId: number;
    public treatmentId: number;
    public securityId: number;

    public constructor(init?: Partial<SessionRecordingListRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SessionRecordingListRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<SessionRecordingDto>(); }
}
(SessionRecordingListRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/consultation/{TreatmentId}/recordings/{Id}", "GET")
export class SessionRecordingGetRequest implements IReturn<ResponseBase<SessionRecordingDto>>, ISecurityId
{
    public id: number;
    public caseId: number;
    public treatmentId: number;
    public securityId: number;

    public constructor(init?: Partial<SessionRecordingGetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SessionRecordingGetRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<SessionRecordingDto>(); }
}
(SessionRecordingGetRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/consultation/{TreatmentId}/recordings/{Id}", "DELETE")
export class SessionRecordingDeleteRequest implements IReturn<ResponseBase<boolean>>, ISecurityId
{
    public id: number;
    public caseId: number;
    public treatmentId: number;
    public securityId: number;

    public constructor(init?: Partial<SessionRecordingDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SessionRecordingDeleteRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(SessionRecordingDeleteRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/consultation/{TreatmentId}/recordings/{RecordingId}/export", "POST")
export class ExportSessionRecordingRequest implements IReturn<ResponseBase<boolean>>, ISecurityId
{
    public caseId: number;
    public treatmentId: number;
    public recordingId: number;
    public securityId: number;

    public constructor(init?: Partial<ExportSessionRecordingRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExportSessionRecordingRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ExportSessionRecordingRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/consultation/{TreatmentId}/transcription-structuring", "POST")
export class SaveTranscriptionStructuringRequest implements IReturn<ResponseBase<boolean>>, ISecurityId
{
    public caseId: number;
    public treatmentId: number;
    public recordingId?: number;
    public model: string;
    public requestId: string;
    public matched: StructuringMatchDto[];
    public notes: string;
    public acceptedFieldGuids: string[];
    public rejectedFieldGuids: string[];
    public fieldSources: { [index:string]: string; };
    public transcriptModified: boolean;
    public notesAccepted: boolean;
    public securityId: number;

    public constructor(init?: Partial<SaveTranscriptionStructuringRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveTranscriptionStructuringRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(SaveTranscriptionStructuringRequest as unknown)[immerable] = true;

export class GetTreatmentRequest implements IReturn<ResponseBase<Treatment>>, ISecurityLocator
{
    public id: number;
    public securityLocator: Func<Object, IClientDbAccess, SecurityDto>;

    public constructor(init?: Partial<GetTreatmentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTreatmentRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<Treatment>(); }
}
(GetTreatmentRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/consultation", "POST")
// @Route("/cases/{CaseId}/consultation/{Id}", "PUT, DELETE")
export class TreatmentAutoSaveRequest implements IReturn<TreatmentResult>, ISecurityId
{
    public id: number;
    public appointmentId?: number;
    public caseId: number;
    public details: TreatmentDetails;
    public treatment: string;
    public locationId: number;
    public securityId: number;

    public constructor(init?: Partial<TreatmentAutoSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentAutoSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TreatmentResult(); }
}
(TreatmentAutoSaveRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/consultation/{Id}", "POST")
export class TreatmentSaveRequest implements IReturn<ResponseBase<boolean>>, ISecurityId
{
    public id: number;
    public caseId: number;
    public lock: boolean;
    public updates: DynamicUpdate[];
    public securityId: number;

    public constructor(init?: Partial<TreatmentSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(TreatmentSaveRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/consultation/{Id}/highlight", "POST")
export class TreatmentHighlightRequest implements IReturn<ResponseBase<boolean>>, ISecurityId
{
    public id: number;
    public caseId: number;
    public highlights: { [index:string]: number[]; };
    public securityId: number;

    public constructor(init?: Partial<TreatmentHighlightRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentHighlightRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(TreatmentHighlightRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/scores/{ScoreId}/entry", "POST")
export class ScoreEntryPostRequest extends ScoreEntryRequest implements IReturn<ResponseBase<ScoreEntryResponse>>
{

    public constructor(init?: Partial<ScoreEntryPostRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ScoreEntryPostRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ScoreEntryResponse>(); }
}
(ScoreEntryPostRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/scores/{ScoreId}/entry/{Id}", "PUT")
export class ScoreEntryPutRequest extends ScoreEntryRequest implements IReturn<ResponseBase<ScoreEntryResponse>>
{

    public constructor(init?: Partial<ScoreEntryPutRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ScoreEntryPutRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<ScoreEntryResponse>(); }
}
(ScoreEntryPutRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/scores/{ScoreId}/entry/{Id}", "DELETE")
export class ScoreEntryDeleteRequest implements IReturn<ResponseBase<boolean>>, ISecurityId
{
    public id: number;
    public caseId: number;
    public securityId: number;
    public scoreId: number;

    public constructor(init?: Partial<ScoreEntryDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScoreEntryDeleteRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ScoreEntryDeleteRequest as unknown)[immerable] = true;

// @Route("/scores/available", "POST")
export class AvailableScoresRequest implements IReturn<ResponseBase<CaseScoreGoalResponse>>
{
    public isFree: boolean;

    public constructor(init?: Partial<AvailableScoresRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AvailableScoresRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CaseScoreGoalResponse>(); }
}
(AvailableScoresRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/scores/search", "POST")
export class ScoreSearchRequest implements IReturn<ResponseBase<ScoreSearchResponse>>, ISecurityId
{
    public caseId: number;
    public securityId: number;

    public constructor(init?: Partial<ScoreSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScoreSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ScoreSearchResponse>(); }
}
(ScoreSearchRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/scores/order", "POST")
export class ScoreOrderRequest implements IReturn<ResponseBase<boolean>>, ISecurityId
{
    public caseId: number;
    public securityId: number;
    public order: number[];

    public constructor(init?: Partial<ScoreOrderRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScoreOrderRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ScoreOrderRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/scores/{Id}", "POST")
export class ScoreGetRequest implements IReturn<ScoreResponse>, ISecurityId
{
    public id: number;
    public caseId: number;
    public securityId: number;

    public constructor(init?: Partial<ScoreGetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScoreGetRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ScoreResponse(); }
}
(ScoreGetRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/scores", "POST")
export class ScorePostRequest extends ScoreRequest implements IReturn<ResponseBase<ScoreResponse>>
{

    public constructor(init?: Partial<ScorePostRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ScorePostRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ScoreResponse>(); }
}
(ScorePostRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/scores/{Id}", "PUT")
export class ScorePutRequest extends ScoreRequest implements IReturn<ResponseBase<ScoreResponse>>
{

    public constructor(init?: Partial<ScorePutRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ScorePutRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<ScoreResponse>(); }
}
(ScorePutRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/score/{Id}/", "DELETE")
export class ScoreDeleteRequest extends ScoreRequest implements IReturn<ResponseBase<ScoreResponse>>
{

    public constructor(init?: Partial<ScoreDeleteRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ScoreDeleteRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<ScoreResponse>(); }
}
(ScoreDeleteRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/goals/{GoalId}/entry", "POST")
export class GoalEntryPostRequest extends GoalEntryRequest implements IReturn<ResponseBase<GoalEntryResponse>>, ILocationId
{

    public constructor(init?: Partial<GoalEntryPostRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GoalEntryPostRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GoalEntryResponse>(); }
}
(GoalEntryPostRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/goals/{GoalId}/entry/{Id}", "PUT")
export class GoalEntryPutRequest extends GoalEntryRequest implements IReturn<ResponseBase<GoalEntryResponse>>, ILocationId
{

    public constructor(init?: Partial<GoalEntryPutRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GoalEntryPutRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<GoalEntryResponse>(); }
}
(GoalEntryPutRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/goals/{GoalId}/entry/{Id}", "DELETE")
export class GoalEntryDeleteRequest implements IReturn<ResponseBase<boolean>>, ISecurityId
{
    public id: number;
    public caseId: number;
    public securityId: number;
    public goalId: number;

    public constructor(init?: Partial<GoalEntryDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GoalEntryDeleteRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(GoalEntryDeleteRequest as unknown)[immerable] = true;

// @Route("/goals/available", "POST")
export class AvailableGoalsRequest implements IReturn<ResponseBase<CaseScoreGoalResponse>>
{

    public constructor(init?: Partial<AvailableGoalsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AvailableGoalsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CaseScoreGoalResponse>(); }
}
(AvailableGoalsRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/goals/search", "POST")
export class GoalSearchRequest implements IReturn<ResponseBase<GoalSearchResponse>>, ISecurityId
{
    public caseId: number;
    public securityId: number;

    public constructor(init?: Partial<GoalSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GoalSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GoalSearchResponse>(); }
}
(GoalSearchRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/goals/order", "POST")
export class GoalOrderRequest implements IReturn<ResponseBase<boolean>>, ISecurityId
{
    public caseId: number;
    public securityId: number;
    public order: number[];

    public constructor(init?: Partial<GoalOrderRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GoalOrderRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(GoalOrderRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/goals/{Id}", "GET")
export class GoalsGetRequest implements IReturn<GoalResponse>, ILocationId, ISecurityId
{
    public id: number;
    public caseId: number;
    public securityId: number;
    public locationId: number;

    public constructor(init?: Partial<GoalsGetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GoalsGetRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GoalResponse(); }
}
(GoalsGetRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/goals", "POST")
export class GoalPostRequest extends GoalRequest implements IReturn<ResponseBase<GoalResponse>>, ILocationId
{

    public constructor(init?: Partial<GoalPostRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GoalPostRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GoalResponse>(); }
}
(GoalPostRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/goals/{Id}", "PUT")
export class GoalPutRequest extends GoalRequest implements IReturn<ResponseBase<GoalResponse>>, ILocationId
{

    public constructor(init?: Partial<GoalPutRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GoalPutRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<GoalResponse>(); }
}
(GoalPutRequest as unknown)[immerable] = true;

// @Route("/cases/{CaseId}/goals/{Id}", "DELETE")
export class GoalDeleteRequest extends GoalRequest implements IReturn<ResponseBase<GoalResponse>>
{
    public settingId: number;

    public constructor(init?: Partial<GoalDeleteRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GoalDeleteRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<GoalResponse>(); }
}
(GoalDeleteRequest as unknown)[immerable] = true;

export class WorkflowStatusLookupReq implements IReturn<ResponseBase<WorkflowStatusLookupRes>>
{
    public type: string;

    public constructor(init?: Partial<WorkflowStatusLookupReq>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WorkflowStatusLookupReq'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<WorkflowStatusLookupRes>(); }
}
(WorkflowStatusLookupReq as unknown)[immerable] = true;

// @Route("/caseflow-lite/processes", "GET")
export class GetProcessesRequest implements IReturn<ResponseBase<ProcessSummaryDto>>
{
    public type: string;
    public skip?: number;
    public take?: number;
    public orderBy: string;
    public includeDrafts?: boolean;
    public includeInactive?: boolean;
    public collapseVersions?: boolean;
    public status?: EProcessStatus;

    public constructor(init?: Partial<GetProcessesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetProcessesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ProcessSummaryDto>(); }
}
(GetProcessesRequest as unknown)[immerable] = true;

// @Route("/caseflow-lite/processes/{ProcessId}", "GET")
export class GetProcessRequest implements IReturn<ProcessDetailDto>
{
    public processId: string;

    public constructor(init?: Partial<GetProcessRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetProcessRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ProcessDetailDto(); }
}
(GetProcessRequest as unknown)[immerable] = true;

// @Route("/caseflow-lite/processes", "POST")
export class CreateProcessRequest implements IReturn<ProcessIdResponse>
{
    public name: string;
    public type: string;

    public constructor(init?: Partial<CreateProcessRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateProcessRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ProcessIdResponse(); }
}
(CreateProcessRequest as unknown)[immerable] = true;

// @Route("/caseflow-lite/processes/{ProcessId}/draft", "GET")
export class GetProcessDraftRequest implements IReturn<ProcessDraftDto>
{
    public processId: string;

    public constructor(init?: Partial<GetProcessDraftRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetProcessDraftRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ProcessDraftDto(); }
}
(GetProcessDraftRequest as unknown)[immerable] = true;

// @Route("/caseflow-lite/processes/{ProcessId}/draft", "PUT")
export class SaveProcessDraftRequest implements IReturn<ProcessDraftDto>
{
    public processId: string;
    public draft: ProcessDraftDto;

    public constructor(init?: Partial<SaveProcessDraftRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveProcessDraftRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ProcessDraftDto(); }
}
(SaveProcessDraftRequest as unknown)[immerable] = true;

// @Route("/caseflow-lite/processes/{ProcessId}/publish", "POST")
export class PublishProcessRequest implements IReturn<ProcessIdResponse>
{
    public processId: string;
    public updateExistingJourneys: boolean;
    public updateLinkedMappings: boolean;
    public publishAsClone: boolean;

    public constructor(init?: Partial<PublishProcessRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PublishProcessRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ProcessIdResponse(); }
}
(PublishProcessRequest as unknown)[immerable] = true;

// @Route("/caseflow-lite/processes/{ProcessId}", "DELETE")
export class DeleteProcessRequest implements IReturnVoid
{
    public processId: string;

    public constructor(init?: Partial<DeleteProcessRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteProcessRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() {}
}
(DeleteProcessRequest as unknown)[immerable] = true;

// @Route("/caseflow-lite/processes/{ProcessId}/stats", "GET")
export class GetProcessStatsRequest implements IReturn<ProcessStatsDto>
{
    public processId: string;

    public constructor(init?: Partial<GetProcessStatsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetProcessStatsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ProcessStatsDto(); }
}
(GetProcessStatsRequest as unknown)[immerable] = true;

// @Route("/caseflow-lite/processes/{ProcessId}/discard", "POST")
export class DiscardProcessDraftRequest implements IReturnVoid
{
    public processId: string;

    public constructor(init?: Partial<DiscardProcessDraftRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiscardProcessDraftRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(DiscardProcessDraftRequest as unknown)[immerable] = true;

// @Route("/caseflow-lite/processes/{ProcessId}/publish-impact", "GET")
export class GetProcessPublishImpactRequest implements IReturn<ProcessPublishImpactDto>
{
    public processId: string;

    public constructor(init?: Partial<GetProcessPublishImpactRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetProcessPublishImpactRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ProcessPublishImpactDto(); }
}
(GetProcessPublishImpactRequest as unknown)[immerable] = true;

export class BulkUpdateFieldRequest implements IReturn<ResponseBase<T>>
{
    public recordType: BulkActionRecordType;

    public constructor(init?: Partial<BulkUpdateFieldRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BulkUpdateFieldRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(BulkUpdateFieldRequest as unknown)[immerable] = true;

export class DiarySMSBulkActionRequest extends DiaryBulkActionBaseRequest implements IReturn<ResponseBase<SMSBulkActionResponse>>
{
    public templateNames: string[];

    public constructor(init?: Partial<DiarySMSBulkActionRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'DiarySMSBulkActionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SMSBulkActionResponse>(); }
}
(DiarySMSBulkActionRequest as unknown)[immerable] = true;

export class DiaryEmailBulkActionRequest extends DiaryBulkActionBaseRequest implements IReturn<ResponseBase<EmailBulkActionResponse>>
{
    public templateNames: string[];

    public constructor(init?: Partial<DiaryEmailBulkActionRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'DiaryEmailBulkActionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<EmailBulkActionResponse>(); }
}
(DiaryEmailBulkActionRequest as unknown)[immerable] = true;

export class DiaryContactBulkActionRequest extends DiaryBulkActionBaseRequest implements IReturn<ResponseBase<ContactBulkActionResponse>>
{
    public customMessage: string;

    public constructor(init?: Partial<DiaryContactBulkActionRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'DiaryContactBulkActionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ContactBulkActionResponse>(); }
}
(DiaryContactBulkActionRequest as unknown)[immerable] = true;

export class DiaryFormBulkActionRequest extends DiaryBulkActionBaseRequest implements IReturn<ResponseBase<FormBulkActionResponse>>
{
    public formTemplateIds: string[];

    public constructor(init?: Partial<DiaryFormBulkActionRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'DiaryFormBulkActionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<FormBulkActionResponse>(); }
}
(DiaryFormBulkActionRequest as unknown)[immerable] = true;

export class DiaryTagBulkActionRequest extends DiaryBulkActionBaseRequest implements IReturn<ResponseBase<TagBulkActionResponse>>
{
    public tags: string[];
    public tagActionType: TagActionType;

    public constructor(init?: Partial<DiaryTagBulkActionRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'DiaryTagBulkActionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TagBulkActionResponse>(); }
}
(DiaryTagBulkActionRequest as unknown)[immerable] = true;

export class CustomerSMSBulkActionRequest extends CustomerBulkActionBaseRequest implements IReturn<ResponseBase<SMSBulkActionResponse>>
{
    public templateNames: string[];

    public constructor(init?: Partial<CustomerSMSBulkActionRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerSMSBulkActionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SMSBulkActionResponse>(); }
}
(CustomerSMSBulkActionRequest as unknown)[immerable] = true;

export class CustomerEmailBulkActionRequest extends CustomerBulkActionBaseRequest implements IReturn<ResponseBase<EmailBulkActionResponse>>
{
    public templateNames: string[];

    public constructor(init?: Partial<CustomerEmailBulkActionRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerEmailBulkActionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<EmailBulkActionResponse>(); }
}
(CustomerEmailBulkActionRequest as unknown)[immerable] = true;

export class CustomerFormBulkActionRequest extends CustomerBulkActionBaseRequest implements IReturn<ResponseBase<FormBulkActionResponse>>
{
    public formTemplateIds: string[];

    public constructor(init?: Partial<CustomerFormBulkActionRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerFormBulkActionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<FormBulkActionResponse>(); }
}
(CustomerFormBulkActionRequest as unknown)[immerable] = true;

export class CustomerTagBulkActionRequest extends CustomerBulkActionBaseRequest implements IReturn<ResponseBase<TagBulkActionResponse>>
{
    public tags: string[];
    public tagActionType: TagActionType;

    public constructor(init?: Partial<CustomerTagBulkActionRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerTagBulkActionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TagBulkActionResponse>(); }
}
(CustomerTagBulkActionRequest as unknown)[immerable] = true;

export class CustomerContactBulkActionRequest extends CustomerBulkActionBaseRequest implements IReturn<ResponseBase<ContactBulkActionResponse>>
{
    public customMessage: string;

    public constructor(init?: Partial<CustomerContactBulkActionRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerContactBulkActionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ContactBulkActionResponse>(); }
}
(CustomerContactBulkActionRequest as unknown)[immerable] = true;

export class MailChimpSubscriptionBulkActionRequest extends CustomerBulkActionBaseRequest implements IReturn<ResponseBase<MailChimpSubscriptionBulkActionResponse>>
{
    public audienceIds: string[];

    public constructor(init?: Partial<MailChimpSubscriptionBulkActionRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'MailChimpSubscriptionBulkActionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<MailChimpSubscriptionBulkActionResponse>(); }
}
(MailChimpSubscriptionBulkActionRequest as unknown)[immerable] = true;

export class GetAllAutomationEvents extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<AutomationEvent>>
{
    public showAll: boolean;

    public constructor(init?: Partial<GetAllAutomationEvents>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAllAutomationEvents'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AutomationEvent>(); }
}
(GetAllAutomationEvents as unknown)[immerable] = true;

export class GetAutomationEvent implements IReturn<ResponseBase<AutomationEvent>>
{
    public id: string;

    public constructor(init?: Partial<GetAutomationEvent>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAutomationEvent'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<AutomationEvent>(); }
}
(GetAutomationEvent as unknown)[immerable] = true;

export class SaveAutomationEvent extends AutomationEvent implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<SaveAutomationEvent>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveAutomationEvent'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(SaveAutomationEvent as unknown)[immerable] = true;

export class GetAllAutomationJobs implements IReturn<ResponseBase<AutomationJob>>
{
    public skip: number;
    public take: number;
    public sort: QueryField[];

    public constructor(init?: Partial<GetAllAutomationJobs>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAllAutomationJobs'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AutomationJob>(); }
}
(GetAllAutomationJobs as unknown)[immerable] = true;

export class ToggleAutomationJobStatus implements IReturn<ResponseBase<AutomationJob>>
{
    public id: string;
    public isActive: boolean;

    public constructor(init?: Partial<ToggleAutomationJobStatus>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ToggleAutomationJobStatus'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AutomationJob>(); }
}
(ToggleAutomationJobStatus as unknown)[immerable] = true;

export class CloneAutomationRequest implements IReturn<ResponseBase<string>>
{
    public id: string;

    public constructor(init?: Partial<CloneAutomationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CloneAutomationRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<string>(); }
}
(CloneAutomationRequest as unknown)[immerable] = true;

export class ArchiveAutomationRequest implements IReturn<ResponseBase<boolean>>
{
    public id: string;
    public archiveAutomation: boolean;

    public constructor(init?: Partial<ArchiveAutomationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ArchiveAutomationRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ArchiveAutomationRequest as unknown)[immerable] = true;

export class GetAllTags implements IReturn<ResponseBase<Tag>>
{
    public skip: number;
    public take: number;
    public showAll: boolean;
    public sort: QueryField[];

    public constructor(init?: Partial<GetAllTags>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAllTags'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<Tag>(); }
}
(GetAllTags as unknown)[immerable] = true;

export class GetTag implements IReturn<ResponseBase<Tag>>
{
    public id: string;

    public constructor(init?: Partial<GetTag>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTag'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<Tag>(); }
}
(GetTag as unknown)[immerable] = true;

export class SaveTag extends Tag implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<SaveTag>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveTag'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(SaveTag as unknown)[immerable] = true;

// @Route("/webinars")
export class WebinarRequest implements IReturn<ResponseBase<WebinarResponse>>
{

    public constructor(init?: Partial<WebinarRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WebinarRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<WebinarResponse>(); }
}
(WebinarRequest as unknown)[immerable] = true;

// @Route("/training")
export class TrainingRequest
{

    public constructor(init?: Partial<TrainingRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TrainingRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(TrainingRequest as unknown)[immerable] = true;

// @Route("/user/current", "GET")
export class GetCurrentUser implements IReturn<CurrentUser>
{

    public constructor(init?: Partial<GetCurrentUser>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCurrentUser'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CurrentUser(); }
}
(GetCurrentUser as unknown)[immerable] = true;

// @Route("/user/location/change", "Post")
// @Route("/user/location/change/{Id}", "Post")
export class ChangeLoggedInLocation implements IReturn<CurrentUser>
{
    public id: number;

    public constructor(init?: Partial<ChangeLoggedInLocation>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ChangeLoggedInLocation'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CurrentUser(); }
}
(ChangeLoggedInLocation as unknown)[immerable] = true;

// @Route("/user/all", "GET")
export class AllUsersRequest implements IReturn<SimpleUser[]>, ILocationIds
{
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<AllUsersRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AllUsersRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Array<SimpleUser>(); }
}
(AllUsersRequest as unknown)[immerable] = true;

// @Route("/user/current/roles", "GET")
export class UserRolesRequest
{

    public constructor(init?: Partial<UserRolesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UserRolesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(UserRolesRequest as unknown)[immerable] = true;

// @Route("/user/verify/{Code}", "GET")
export class VerifyCode implements IReturn<CurrentUser>
{
    public code: string;

    public constructor(init?: Partial<VerifyCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VerifyCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CurrentUser(); }
}
(VerifyCode as unknown)[immerable] = true;

// @Route("/user/reset", "Post")
export class ResetPassword implements IReturn<ResponseBase<boolean>>
{
    public email: string;

    public constructor(init?: Partial<ResetPassword>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ResetPassword'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ResetPassword as unknown)[immerable] = true;

// @Route("/user/changePassword", "Post")
export class ChangePassword implements IReturn<CurrentUser>
{
    public code: string;
    public confirmPassword: string;
    public newPassword: string;
    public score: number;

    public constructor(init?: Partial<ChangePassword>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ChangePassword'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CurrentUser(); }
}
(ChangePassword as unknown)[immerable] = true;

// @Route("/user/password/change", "Post")
export class ChangePasswordRequest implements IReturn<ResponseBase<T>>
{
    public oldPassword: string;
    public newPassword: string;
    public score: number;

    public constructor(init?: Partial<ChangePasswordRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ChangePasswordRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(ChangePasswordRequest as unknown)[immerable] = true;

export class ChangePINRequest implements IReturn<ResponseBase<string>>
{
    public password: string;
    public pin: string;

    public constructor(init?: Partial<ChangePINRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ChangePINRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<string>(); }
}
(ChangePINRequest as unknown)[immerable] = true;

export class ChangeSignatureRequest implements IReturn<ResponseBase<string>>
{
    public signature: string;

    public constructor(init?: Partial<ChangeSignatureRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ChangeSignatureRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<string>(); }
}
(ChangeSignatureRequest as unknown)[immerable] = true;

// @Route("/logout/soon")
export class LogoutSoonRequest implements IHasAutoRefresh
{
    public autoRefresh: boolean;

    public constructor(init?: Partial<LogoutSoonRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LogoutSoonRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(LogoutSoonRequest as unknown)[immerable] = true;

// @Route("/logout/now")
export class LogoutNowRequest
{

    public constructor(init?: Partial<LogoutNowRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LogoutNowRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(LogoutNowRequest as unknown)[immerable] = true;

export class GetAssertionOptions implements IReturn<AssertionOptions>
{
    public username: string;
    public userVerification: string;

    public constructor(init?: Partial<GetAssertionOptions>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAssertionOptions'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AssertionOptions(); }
}
(GetAssertionOptions as unknown)[immerable] = true;

export class MakeAssertionRequest implements IReturn<ResponseBase<boolean>>
{
    public id: string;
    public rawId: string;
    public response: AssertionResponse;
    public type?: PublicKeyCredentialType;
    public extensions: AuthenticationExtensionsClientOutputs;

    public constructor(init?: Partial<MakeAssertionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MakeAssertionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(MakeAssertionRequest as unknown)[immerable] = true;

export class MakeCredentialsOptionsRequest implements IReturn<HttpResult>
{
    public username: string;
    public displayName: string;
    public attType: string;
    public authType: string;
    public residentKey: string;
    public userVerification: string;

    public constructor(init?: Partial<MakeCredentialsOptionsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MakeCredentialsOptionsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new HttpResult(); }
}
(MakeCredentialsOptionsRequest as unknown)[immerable] = true;

export class RegisterCredentialWithServerRequest implements IReturn<ResponseBase<CredentialMakeResult>>
{
    public id: string;
    public rawId: string;
    public type?: PublicKeyCredentialType;
    public response: ResponseData;
    public extensions: AuthenticationExtensionsClientOutputs;

    public constructor(init?: Partial<RegisterCredentialWithServerRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegisterCredentialWithServerRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CredentialMakeResult>(); }
}
(RegisterCredentialWithServerRequest as unknown)[immerable] = true;

// @Route("/license")
export class LicenseRequest implements IReturn<ResponseBase<LicenseDetailsResponse>>
{

    public constructor(init?: Partial<LicenseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LicenseRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<LicenseDetailsResponse>(); }
}
(LicenseRequest as unknown)[immerable] = true;

export class ModularFeaturesRequest implements IReturn<ResponseBase<ModularLicence>>
{

    public constructor(init?: Partial<ModularFeaturesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ModularFeaturesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ModularLicence>(); }
}
(ModularFeaturesRequest as unknown)[immerable] = true;

// @Route("/current-licence-details")
export class CurrentLicenceDetailsRequest implements IReturn<ResponseBase<CurrentLicenceDetailsResponse>>
{

    public constructor(init?: Partial<CurrentLicenceDetailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CurrentLicenceDetailsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CurrentLicenceDetailsResponse>(); }
}
(CurrentLicenceDetailsRequest as unknown)[immerable] = true;

// @Route("/current-licence-details/tier", "POST")
export class UpdatePackageTierRequest implements IReturn<ResponseBase<CurrentLicenceDetailsResponse>>
{
    public tier: PackageTier;
    public packageId: string;
    public operationId: string;

    public constructor(init?: Partial<UpdatePackageTierRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdatePackageTierRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CurrentLicenceDetailsResponse>(); }
}
(UpdatePackageTierRequest as unknown)[immerable] = true;

// @Route("/current-licence-details/tier/apply-immediately", "POST")
export class ApplyPendingTierImmediatelyRequest implements IReturn<ResponseBase<CurrentLicenceDetailsResponse>>
{
    public reason: string;

    public constructor(init?: Partial<ApplyPendingTierImmediatelyRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ApplyPendingTierImmediatelyRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CurrentLicenceDetailsResponse>(); }
}
(ApplyPendingTierImmediatelyRequest as unknown)[immerable] = true;

// @Route("/current-licence-details/addon", "POST")
export class ToggleLicenceAddOnRequest implements IReturn<ResponseBase<CurrentLicenceDetailsResponse>>
{
    public addOnId: string;
    public enabled: boolean;
    public quantityDelta?: number;
    public quantity?: number;
    public operationId: string;

    public constructor(init?: Partial<ToggleLicenceAddOnRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ToggleLicenceAddOnRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CurrentLicenceDetailsResponse>(); }
}
(ToggleLicenceAddOnRequest as unknown)[immerable] = true;

// @Route("/current-licence", "GET")
export class CurrentClientLicenceRequest implements IReturn<ResponseBase<ClientLicenceUnion>>
{

    public constructor(init?: Partial<CurrentClientLicenceRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CurrentClientLicenceRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ClientLicenceUnion>(); }
}
(CurrentClientLicenceRequest as unknown)[immerable] = true;

// @Route("/current-licence/seats", "PATCH")
export class UpdateSeatCountRequest implements IReturn<ResponseBase<ModularClientLicenceResponse>>
{
    public quantity: number;
    public reason: string;
    public operationId: string;

    public constructor(init?: Partial<UpdateSeatCountRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateSeatCountRequest'; }
    public getMethod() { return 'PATCH'; }
    public createResponse() { return new ResponseBase<ModularClientLicenceResponse>(); }
}
(UpdateSeatCountRequest as unknown)[immerable] = true;

// @Route("/current-licence/custom-pricing", "POST")
export class SetCustomPricingRequest implements IReturn<ResponseBase<ModularClientLicenceResponse>>
{
    public clientId: number;
    public pricePerSeat?: number;
    public addOnRates: AddOnRate[];
    public smsPpcRate?: number;
    public automationPpcRate?: number;
    public classPpcRate?: number;
    public note: string;
    public effectiveFrom?: string;
    public effectiveTo?: string;

    public constructor(init?: Partial<SetCustomPricingRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetCustomPricingRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ModularClientLicenceResponse>(); }
}
(SetCustomPricingRequest as unknown)[immerable] = true;

// @Route("/current-licence/custom-pricing", "DELETE")
export class ClearCustomPricingRequest implements IReturn<ResponseBase<ModularClientLicenceResponse>>
{
    public clientId: number;

    public constructor(init?: Partial<ClearCustomPricingRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClearCustomPricingRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<ModularClientLicenceResponse>(); }
}
(ClearCustomPricingRequest as unknown)[immerable] = true;

// @Route("/modular-licence")
export class LicenceModulesRequest implements IReturn<string>
{

    public constructor(init?: Partial<LicenceModulesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LicenceModulesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return ''; }
}
(LicenceModulesRequest as unknown)[immerable] = true;

// @Route("/current-licence/add-ons/{AddOnId}/allocations", "GET")
export class GetAddOnAllocationsRequest implements IReturn<ResponseBase<AddOnAllocationSummaryResponse>>
{
    public addOnId: string;

    public constructor(init?: Partial<GetAddOnAllocationsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAddOnAllocationsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<AddOnAllocationSummaryResponse>(); }
}
(GetAddOnAllocationsRequest as unknown)[immerable] = true;

// @Route("/current-licence/add-ons/{AddOnId}/allocations", "POST")
export class AllocateAddOnUnitRequest implements IReturn<ResponseBase<AddOnAllocationSummaryResponse>>
{
    public addOnId: string;
    public userId: number;

    public constructor(init?: Partial<AllocateAddOnUnitRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AllocateAddOnUnitRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AddOnAllocationSummaryResponse>(); }
}
(AllocateAddOnUnitRequest as unknown)[immerable] = true;

// @Route("/current-licence/add-ons/{AddOnId}/allocations/{UserId}", "DELETE")
export class UnallocateAddOnUnitRequest implements IReturn<ResponseBase<AddOnAllocationSummaryResponse>>
{
    public addOnId: string;
    public userId: number;
    public immediate: boolean;

    public constructor(init?: Partial<UnallocateAddOnUnitRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UnallocateAddOnUnitRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<AddOnAllocationSummaryResponse>(); }
}
(UnallocateAddOnUnitRequest as unknown)[immerable] = true;

// @Route("/current-licence/add-ons/{AddOnId}/reduction-impact", "GET")
export class GetAddOnReductionImpactRequest implements IReturn<ResponseBase<AddOnReductionImpactResponse>>
{
    public addOnId: string;
    public targetQuantity: number;

    public constructor(init?: Partial<GetAddOnReductionImpactRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAddOnReductionImpactRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<AddOnReductionImpactResponse>(); }
}
(GetAddOnReductionImpactRequest as unknown)[immerable] = true;

// @Route("/current-licence/add-ons/{AddOnId}/reduction", "POST")
export class ConfirmAddOnReductionRequest implements IReturn<ResponseBase<CurrentLicenceDetailsResponse>>
{
    public addOnId: string;
    public targetQuantity: number;
    public userIds: number[];

    public constructor(init?: Partial<ConfirmAddOnReductionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ConfirmAddOnReductionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CurrentLicenceDetailsResponse>(); }
}
(ConfirmAddOnReductionRequest as unknown)[immerable] = true;

// @Route("/current-licence/add-ons/{AddOnId}/cancel", "POST")
export class CancelOwnAddOnAllocationRequest implements IReturn<ResponseBase<AddOnAllocationSummaryResponse>>
{
    public addOnId: string;

    public constructor(init?: Partial<CancelOwnAddOnAllocationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CancelOwnAddOnAllocationRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AddOnAllocationSummaryResponse>(); }
}
(CancelOwnAddOnAllocationRequest as unknown)[immerable] = true;

export class TwoFactorVerify implements IReturn<ResponseBase<boolean>>
{
    public code: string;
    public remember: boolean;

    public constructor(init?: Partial<TwoFactorVerify>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TwoFactorVerify'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(TwoFactorVerify as unknown)[immerable] = true;

export class TwoFactorRequestCode implements IReturn<ResponseBase<boolean>>
{
    public setupNew: boolean;

    public constructor(init?: Partial<TwoFactorRequestCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TwoFactorRequestCode'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(TwoFactorRequestCode as unknown)[immerable] = true;

export class TwoFactorUpdateSecret implements IReturn<ResponseBase<boolean>>
{
    public secret: string;
    public codeForExistingSecret: string;

    public constructor(init?: Partial<TwoFactorUpdateSecret>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TwoFactorUpdateSecret'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(TwoFactorUpdateSecret as unknown)[immerable] = true;

// @Route("/{HandlerName}/webhook")
// @Route("/webhook/{HandlerName}/{Other*}")
export class InboundWebHookRequest implements IReturn<HttpResult>
{
    public handlerName: string;
    public other: string;
    public requestStream: string;

    public constructor(init?: Partial<InboundWebHookRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InboundWebHookRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new HttpResult(); }
}
(InboundWebHookRequest as unknown)[immerable] = true;

export class GetCustomAttributes implements IReturn<ResponseBase<CustomAttributeDto>>
{
    public types: string[];

    public constructor(init?: Partial<GetCustomAttributes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCustomAttributes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CustomAttributeDto>(); }
}
(GetCustomAttributes as unknown)[immerable] = true;

export class GetCustomAttributeLists implements IReturn<GetCustomAttributeListsResponse[]>
{

    public constructor(init?: Partial<GetCustomAttributeLists>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCustomAttributeLists'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Array<GetCustomAttributeListsResponse>(); }
}
(GetCustomAttributeLists as unknown)[immerable] = true;

export class GetAssignedAttributes implements IReturn<ResponseBase<T>>
{
    public objectId: number;
    public objectGuid: string;
    public objectType: string;
    public customAttributeTypes: string[];

    public constructor(init?: Partial<GetAssignedAttributes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAssignedAttributes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetAssignedAttributes as unknown)[immerable] = true;

// @Route("/updatecustomattributes", "POST")
export class UpdateCustomAttributeRequest implements IReturnVoid
{
    public objectId: number;
    public objectGuid: string;
    public objectType: string;
    public attributes: AssignedCustomAttributeDto[];

    public constructor(init?: Partial<UpdateCustomAttributeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateCustomAttributeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(UpdateCustomAttributeRequest as unknown)[immerable] = true;

export class CreateNewCustomAttributeRequest implements IReturn<ResponseBase<CustomAttributes>>
{
    public typeId: string;
    public name: string;

    public constructor(init?: Partial<CreateNewCustomAttributeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateNewCustomAttributeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CustomAttributes>(); }
}
(CreateNewCustomAttributeRequest as unknown)[immerable] = true;

export class DeleteCustomAttributeRequest implements IReturnVoid
{
    public typeId: string;
    public name: string;

    public constructor(init?: Partial<DeleteCustomAttributeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteCustomAttributeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(DeleteCustomAttributeRequest as unknown)[immerable] = true;

export class GetBillingEntities implements IReturn<GetBillingEntitiesResponse>
{
    public includeInactive?: boolean;
    public skip: number;
    public take: number;

    public constructor(init?: Partial<GetBillingEntities>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetBillingEntities'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetBillingEntitiesResponse(); }
}
(GetBillingEntities as unknown)[immerable] = true;

export class GetBillingEntity implements IReturn<GetBillingEntityResponse>
{
    public id: number;

    public constructor(init?: Partial<GetBillingEntity>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetBillingEntity'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetBillingEntityResponse(); }
}
(GetBillingEntity as unknown)[immerable] = true;

export class GetBillingEntityDeactivationImpact implements IReturn<GetBillingEntityDeactivationImpactResponse>
{
    public id: number;

    public constructor(init?: Partial<GetBillingEntityDeactivationImpact>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetBillingEntityDeactivationImpact'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetBillingEntityDeactivationImpactResponse(); }
}
(GetBillingEntityDeactivationImpact as unknown)[immerable] = true;

export class CreateBillingEntity extends BillingEntitySaveRequestBase implements IReturn<CreateBillingEntityResponse>
{

    public constructor(init?: Partial<CreateBillingEntity>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateBillingEntity'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateBillingEntityResponse(); }
}
(CreateBillingEntity as unknown)[immerable] = true;

export class UpdateBillingEntity extends BillingEntitySaveRequestBase implements IReturn<UpdateBillingEntityResponse>
{
    public id: number;

    public constructor(init?: Partial<UpdateBillingEntity>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateBillingEntity'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new UpdateBillingEntityResponse(); }
}
(UpdateBillingEntity as unknown)[immerable] = true;

export class DeleteBillingEntity implements IReturn<ResponseBase<boolean>>
{
    public id: number;

    public constructor(init?: Partial<DeleteBillingEntity>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteBillingEntity'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(DeleteBillingEntity as unknown)[immerable] = true;

export class TokenSearchRequest implements IReturn<ResponseBase<TokenSearchResponse>>
{
    public customerId: number;

    public constructor(init?: Partial<TokenSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TokenSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TokenSearchResponse>(); }
}
(TokenSearchRequest as unknown)[immerable] = true;

// @Route("/finances/token/register", "POST")
export class TokenRegisterRequest implements IReturn<ResponseBase<T>>
{
    public customerId: number;
    public pan: string;
    public token: string;
    public merchant: string;
    public expiryDate: string;

    public constructor(init?: Partial<TokenRegisterRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TokenRegisterRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(TokenRegisterRequest as unknown)[immerable] = true;

export class TokenDeleteRequest implements IReturn<ResponseBase<boolean>>, ICustomerId
{
    public customerId: number;

    public constructor(init?: Partial<TokenDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TokenDeleteRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(TokenDeleteRequest as unknown)[immerable] = true;

export class EnableApplePayRequest implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<EnableApplePayRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EnableApplePayRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(EnableApplePayRequest as unknown)[immerable] = true;

// @Route("/settings/multidiscipline/servicetype/{Id}")
export class ServiceTypeRequest implements IReturn<ResponseBase<ServiceTypeResponse>>
{
    public id: number;

    public constructor(init?: Partial<ServiceTypeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServiceTypeRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ServiceTypeResponse>(); }
}
(ServiceTypeRequest as unknown)[immerable] = true;

// @Route("/settings/multidiscipline/servicetype/search")
export class ServiceTypeSearch implements IReturn<ResponseBase<ServiceTypeResponse>>
{
    public isCurrent?: boolean;

    public constructor(init?: Partial<ServiceTypeSearch>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServiceTypeSearch'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ServiceTypeResponse>(); }
}
(ServiceTypeSearch as unknown)[immerable] = true;

export class ServiceTypeSave implements IReturn<ResponseBase<ServiceTypeResponse>>
{
    public id: number;
    public name: string;
    public isCurrent: boolean;
    public clinicalAccessMode: AccessMode;
    public patientAccessMode: AccessMode;
    public usesScores: boolean;
    public usesGoals: boolean;
    public usesImages: boolean;
    public labelOverrides: { [index:string]: string; };
    public listOverrides: { [index:string]: string; };
    public configOverrides: { [index:string]: string; };
    public workflowAccessMode: AccessMode;
    public globalGuid: string;

    public constructor(init?: Partial<ServiceTypeSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServiceTypeSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ServiceTypeResponse>(); }
}
(ServiceTypeSave as unknown)[immerable] = true;

// @Route("/appointments/{Id}", "GET")
export class AppointmentGetRequest implements IReturn<ResponseBase<AppointmentDetailsResponse>>, ILocationIds, IFilterServiceTypeManually
{
    public skip: number;
    public take: number;
    public id: number;
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<AppointmentGetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AppointmentGetRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<AppointmentDetailsResponse>(); }
}
(AppointmentGetRequest as unknown)[immerable] = true;

// @Route("/appointment/update", "POST")
export class AppointmentPutRequest implements IReturn<ResponseBase<{ [index:string]: ScheduleAppointment[]; }>>, ILocationIds
{
    public id: number;
    public startDateTime: string;
    public endDateTime: string;
    public resourceMode: string;
    public yesToWarnings: boolean;
    public apptType: string;
    public practitionerId: number;
    public roomId: number;
    public caseId: number;
    public locationId: number;
    public locationIds: number[];
    public requestLocationIds: number[];
    public resendConfirmations: boolean;
    public reminderType?: string;

    public constructor(init?: Partial<AppointmentPutRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AppointmentPutRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<{ [index:string]: ScheduleAppointment[]; }>(); }
}
(AppointmentPutRequest as unknown)[immerable] = true;

// @Route("/appointment/delete", "POST")
export class AppointmentDeleteRequest implements IReturn<ResponseBase<{ [index:string]: ScheduleAppointment[]; }>>, ISecurityId
{
    public id: number;
    public securityId: number;
    public all: boolean;
    public includePast: boolean;
    public backgroundJobId: string;

    public constructor(init?: Partial<AppointmentDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AppointmentDeleteRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<{ [index:string]: ScheduleAppointment[]; }>(); }
}
(AppointmentDeleteRequest as unknown)[immerable] = true;

// @Route("/appointment/book", "POST")
export class AppointmentBookRequest implements IReturn<ResponseBase<AppointmentBookResponse>>, ILocationId
{
    public id: number;
    public tempId?: number;
    public startDateTime: string;
    public endDateTime: string;
    public locationId: number;
    public practitionerId: number;
    public roomId?: number;
    public groupId?: number;
    public authId?: number;
    public customerId?: number;
    public firstAppointment: boolean;
    public stockType: DefaultStockTypes;
    public apptType: string;
    public stockId?: number;
    public colour?: number;
    public comment: string;
    public name: string;
    public duration: number;
    public resourceMode: string;
    public recurrenceInterval: RecurrenceType;
    public yesToWarnings: boolean;
    public excludeWarnings: boolean;
    public excludeNonWorkingDays: boolean;
    public status: number;
    public subStatus: AppointmentSubStatus;
    public hexColour: string;
    public moved: boolean;
    public caseId: number;
    public bodySite: string;
    public bookingMethod: string;
    public reminderType?: string;
    public reminderDate?: string;
    public recallDate?: string;
    public stockColour?: number;
    public customDuration: number;
    public customFreq: number;
    public customInterval: string;
    public resendConfirmations: boolean;
    public meta: { [index:string]: Object; };
    public updatePatientGroupToo: boolean;
    public prontoAuditId?: string;
    public prontoServiceId?: string;
    public prontoAppointmentId?: string;
    public isProntoReferralBooking: boolean;
    public serviceTypeId: number;
    public discountCodeId?: string;
    public discountCodeAppliedDate?: string;
    public discountCodeAdvance: boolean;
    public customer: CustomerSaveRequest;
    public authCode: TreatmentAuthResponse;
    public customerGroupReference: string;
    public customerInsuranceNumber: string;
    public isVideo: boolean;
    public addToWaitingList: boolean;
    public videoCode: string;
    public videoLink: string;
    public videoMeetingHostJoinUrl: string;
    public videoMeetingParticipantJoinUrl: string;
    public videoMeetingPassword: string;
    public videoMeetingProvider?: VideoMeetingProvider;
    public videoMeetingId: string;
    public prepaymentType: PrepaymentType;
    public batchNo: number;
    public applyToAllSubsequent: boolean;
    public backgroundJobId: string;
    public stockSpecialismId?: string;
    public additionalCharges: AppointmentAdditionalChargeRequest[];
    public priorityNotes: ExtendedNotesSave[];
    public depositPaymentType?: DepositPaymentType;
    public depositPaid?: boolean;
    public procedures: AppointmentProcedureSelection[];
    public pendingAppointmentTasks: TaskSaveRequest[];

    public constructor(init?: Partial<AppointmentBookRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AppointmentBookRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AppointmentBookResponse>(); }
}
(AppointmentBookRequest as unknown)[immerable] = true;

// @Route("/appointment/complete/validate", "POST")
// @Route("/appointment/book", "POST")
export class AppointmentCompletionValidationRequest extends AppointmentBookRequest implements IReturn<ResponseBase<AppointmentBookResponse>>
{

    public constructor(init?: Partial<AppointmentCompletionValidationRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'AppointmentCompletionValidationRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AppointmentBookResponse>(); }
}
(AppointmentCompletionValidationRequest as unknown)[immerable] = true;

// @Route("/appointment/{Id}/case", "POST")
export class AppointmentCreateClickCaseRequest implements IReturn<ResponseBase<AppointmentCreateClickCaseResponse>>
{
    public appointmentId: number;

    public constructor(init?: Partial<AppointmentCreateClickCaseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AppointmentCreateClickCaseRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AppointmentCreateClickCaseResponse>(); }
}
(AppointmentCreateClickCaseRequest as unknown)[immerable] = true;

// @Route("/appointment/{id}/linkToCase/{caseId}", "POST")
export class LinkAppointmentToCaseRequest implements IReturn<ResponseBase<boolean>>, ISecurityId
{
    public id: number;
    public caseId: number;
    public securityId: number;

    public constructor(init?: Partial<LinkAppointmentToCaseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LinkAppointmentToCaseRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(LinkAppointmentToCaseRequest as unknown)[immerable] = true;

// @Route("/appointment/{Id}/case", "POST")
export class CreateCaseFromAppointmentPostRequest implements IReturn<ResponseBase<number>>
{
    public id: number;

    public constructor(init?: Partial<CreateCaseFromAppointmentPostRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateCaseFromAppointmentPostRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<number>(); }
}
(CreateCaseFromAppointmentPostRequest as unknown)[immerable] = true;

// @Route("/appointments/other", "POST")
export class CustomerOtherAppointmentsRequest implements IReturn<ResponseBase<{ [index:string]: Object; }[]>>, ICustomerId
{
    public customerId: number;
    public startDateTime: string;
    public appointmentId: number;

    public constructor(init?: Partial<CustomerOtherAppointmentsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerOtherAppointmentsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<{ [index:string]: Object; }[]>(); }
}
(CustomerOtherAppointmentsRequest as unknown)[immerable] = true;

// @Route("/appointment/alerts", "GET")
export class AppointmentAlertsRequest implements IReturn<ResponseBase<AlertResponse>>, ISecurityId
{
    public appointmentId?: number;
    public customerId?: number;
    public securityId: number;

    public constructor(init?: Partial<AppointmentAlertsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AppointmentAlertsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<AlertResponse>(); }
}
(AppointmentAlertsRequest as unknown)[immerable] = true;

export class AppointmentBookingInfoRequest implements IReturn<ResponseBase<AppointmentBookingInfoResponse>>, ICustomerId, ILocationId
{
    public caseId?: number;
    public customerId: number;
    public locationId: number;
    public serviceTypeId: number;
    public practitionerId: number;
    public groupId?: number;
    public forceFollowup: boolean;
    public stockId: number;
    public skillRestrictions: string[];
    public filterByCaseLinkedPrepaids: boolean;

    public constructor(init?: Partial<AppointmentBookingInfoRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AppointmentBookingInfoRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AppointmentBookingInfoResponse>(); }
}
(AppointmentBookingInfoRequest as unknown)[immerable] = true;

// @Route("/appointment/session-restrictions", "POST")
export class AppointmentSessionRestrictionsRequest implements IReturn<ResponseBase<AppointmentSessionRestrictionsResponse>>, ILocationId
{
    public locationId: number;
    public practitionerId: number;
    public roomId?: number;
    public startDateTime: string;
    public endDateTime: string;
    public resourceMode: string;

    public constructor(init?: Partial<AppointmentSessionRestrictionsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AppointmentSessionRestrictionsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AppointmentSessionRestrictionsResponse>(); }
}
(AppointmentSessionRestrictionsRequest as unknown)[immerable] = true;

// @Route("/appointment/temporary/create", "POST")
export class CreateTemporaryAppointmentRequest implements IReturn<ResponseBase<CreateTemporaryAppointmentResponse>>, ILocationId
{
    public practitionerId: number;
    public locationId: number;
    public roomId?: number;
    public startDateTime: string;
    public endDateTime: string;

    public constructor(init?: Partial<CreateTemporaryAppointmentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateTemporaryAppointmentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CreateTemporaryAppointmentResponse>(); }
}
(CreateTemporaryAppointmentRequest as unknown)[immerable] = true;

// @Route("/appointment/temporary/update", "POST")
export class UpdateTemporaryAppointmentRequest implements IReturn<ResponseBase<T>>, ISecurityId
{
    public id: number;
    public startDateTime: string;
    public endDateTime: string;
    public securityId: number;

    public constructor(init?: Partial<UpdateTemporaryAppointmentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateTemporaryAppointmentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(UpdateTemporaryAppointmentRequest as unknown)[immerable] = true;

// @Route("/appointment/temporary/confirm", "POST")
export class AppointmentConfirmTemporaryBookingRequest implements IReturn<ResponseBase<boolean>>, ISecurityId
{
    public id: number;
    public securityId: number;
    public customerId: number;
    public bookingMethod: string;
    public backgroundJobId: string;
    public treatmentAuthId?: number;
    public groupId?: number;

    public constructor(init?: Partial<AppointmentConfirmTemporaryBookingRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AppointmentConfirmTemporaryBookingRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(AppointmentConfirmTemporaryBookingRequest as unknown)[immerable] = true;

export class AppointmentPrepaidIncomeRequest implements IReturn<ResponseBase<AppointmentPrepaidIncomeResponse>>, ILocationId
{
    public id: number;
    public locationId: number;

    public constructor(init?: Partial<AppointmentPrepaidIncomeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AppointmentPrepaidIncomeRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<AppointmentPrepaidIncomeResponse>(); }
}
(AppointmentPrepaidIncomeRequest as unknown)[immerable] = true;

// @Route("/appointment/defaultStock")
export class GetDefaultStockRequest implements IReturn<ResponseBase<StockResponse>>, ICustomerId
{
    public practitionerId: number;
    public groupId?: number;
    public customerId: number;
    public stockType: DefaultStockTypes;
    public locationId: number;
    public serviceTypeId: number;
    public forcePrivate: boolean;
    public skillRestrictions: string[];

    public constructor(init?: Partial<GetDefaultStockRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDefaultStockRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<StockResponse>(); }
}
(GetDefaultStockRequest as unknown)[immerable] = true;

// @Route("/apideck/accounting/taxrates", "GET")
export class GetAccountingListTaxRates implements IReturn<ResponseBase<TaxRate[]>>
{
    public serviceId: string;

    public constructor(init?: Partial<GetAccountingListTaxRates>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAccountingListTaxRates'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<TaxRate[]>(); }
}

// @Route("/apideck/accounting/ledgeraccounts", "GET")
export class GetAccountingListLedgerAccounts implements IReturn<ResponseBase<LedgerAccount[]>>
{
    public serviceId: string;
    public classification?: Classification;

    public constructor(init?: Partial<GetAccountingListLedgerAccounts>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAccountingListLedgerAccounts'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<LedgerAccount[]>(); }
}

// @Route("/alert/complete/{Id}", "GET")
export class AlertCompleteRequest implements IReturn<ResponseBase<boolean>>, ISecurityLocator
{
    public id: number;

    public constructor(init?: Partial<AlertCompleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AlertCompleteRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(AlertCompleteRequest as unknown)[immerable] = true;

// @Route("/alert/acknowledge", "POST")
// @Route("/alert/acknowledge/{Id}", "POST")
export class AlertAcknowledgeRequest implements IReturn<ResponseBase<boolean>>, ILocationIds
{
    public id?: number;
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<AlertAcknowledgeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AlertAcknowledgeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(AlertAcknowledgeRequest as unknown)[immerable] = true;

// @Route("/alert/forObject", "POST")
export class AlertSearchRequest implements IReturn<Alert[]>, ISecurityId, ISecurityType, IFilterServiceTypeManually, IAlertRequest
{
    public objectId: number;
    public discriminatorType: string;
    public securityId: number;
    public securityType: string;

    public constructor(init?: Partial<AlertSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AlertSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Array<Alert>(); }
}
(AlertSearchRequest as unknown)[immerable] = true;

// @Route("/alerts/clinical/flags")
export class CaseAlertFlagsRequest implements IReturn<ResponseBase<CaseAlertFlagsResponse>>
{

    public constructor(init?: Partial<CaseAlertFlagsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseAlertFlagsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CaseAlertFlagsResponse>(); }
}
(CaseAlertFlagsRequest as unknown)[immerable] = true;

// @Route("/alerts/{Id}")
export class CaseAlertSearchRequest implements IReturn<CaseAlertSearchResponse>, ISecurityLocator, IDepartmentIds, IAlertRequest
{
    public id: number;
    public isPatientId: boolean;
    public securityId: number;
    public departmentIds: number[];
    public securityLocator: Func<Object, IClientDbAccess, SecurityDto>;

    public constructor(init?: Partial<CaseAlertSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseAlertSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CaseAlertSearchResponse(); }
}
(CaseAlertSearchRequest as unknown)[immerable] = true;

// @Route("/alert/{Id}", "GET")
export class AlertGetRequest implements IReturn<AlertDialogResponse>, ILocationId, ISecurityLocator, IFilterServiceTypeManually
{
    public id: number;
    public locationId: number;
    public securityLocator: Func<Object, IClientDbAccess, SecurityDto>;

    public constructor(init?: Partial<AlertGetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AlertGetRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AlertDialogResponse(); }
}
(AlertGetRequest as unknown)[immerable] = true;

// @Route("/alerts/{Id}/{DiscriminatorType}", "GET")
export class AlertsGetRequest implements IReturn<ResponseBase<AlertDialogResponse>>, ISecurityId, ISecurityType, IAlertRequest, IDepartmentIds
{
    public id: number;
    public discriminatorType: string;
    public securityId: number;
    public securityType: string;
    public departmentIds: number[];

    public constructor(init?: Partial<AlertsGetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AlertsGetRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<AlertDialogResponse>(); }
}
(AlertsGetRequest as unknown)[immerable] = true;

export class AlertsMultipleGetRequest implements IReturn<ResponseBase<AlertDialogResponse>>, IAlertRequest, IDepartmentIds
{
    public requestedAlerts: IdDescriminatorType[];
    public departmentIds: number[];

    public constructor(init?: Partial<AlertsMultipleGetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AlertsMultipleGetRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AlertDialogResponse>(); }
}
(AlertsMultipleGetRequest as unknown)[immerable] = true;

// @Route("/alert/{Id}", "PUT")
// @Route("/alert/save", "POST")
export class AlertPostRequest implements IReturn<ResponseBase<Alert>>, ILocationId, ISecurityId, ISecurityType, IAlertRequest, IFilterServiceTypeManually
{
    public id: number;
    public userId?: number;
    public createdByUserId?: number;
    public discriminatorType: string;
    public objectId: number;
    public title: string;
    public notes: string;
    public createdDateTime?: string;
    public startDateTime?: string;
    public requiresAcknowledgement?: boolean;
    public complete?: boolean;
    public expiryDateTime?: string;
    public diaryDateTime?: string;
    public includeInMyWork?: boolean;
    public forYourEyesOnly?: boolean;
    public flagType?: number;
    public future: boolean;
    public alertForPerson: string;
    public alertForDate: string;
    public alertExpiryDate: string;
    public locationId: number;
    public serviceTypeId?: number;
    public securityId: number;
    public securityType: string;

    public constructor(init?: Partial<AlertPostRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AlertPostRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<Alert>(); }
}
(AlertPostRequest as unknown)[immerable] = true;

// @Route("/alert/quickPicks", "PUT")
export class ClinicalQuickPickAlertPostRequest implements IReturn<CaseAlertSearchResponse>, ISecurityId, IFilterServiceTypeManually
{
    public quickPicks: Alert[];
    public caseId: number;
    public alertGenre: string;
    public securityId: number;

    public constructor(init?: Partial<ClinicalQuickPickAlertPostRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClinicalQuickPickAlertPostRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new CaseAlertSearchResponse(); }
}
(ClinicalQuickPickAlertPostRequest as unknown)[immerable] = true;

// @Route("/ai/case/summary", "POST")
// @Route("/ai/{Scope*}", "POST")
export class CaseSummary extends AiRequest implements IReturn<ResponseBase<AiResponse>>
{

    public constructor(init?: Partial<CaseSummary>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseSummary'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AiResponse>(); }
}
(CaseSummary as unknown)[immerable] = true;

// @Route("/ai/clinical/summary/{CustomerId}/latest", "GET")
export class AiClinicalSummaryLatest implements IReturn<ResponseBase<AiClinicalSummaryDto>>, ICustomerId, ISecurityId
{
    public customerId: number;
    public securityId: number;

    public constructor(init?: Partial<AiClinicalSummaryLatest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AiClinicalSummaryLatest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<AiClinicalSummaryDto>(); }
}
(AiClinicalSummaryLatest as unknown)[immerable] = true;

// @Route("/ai/clinical/summary/case/{CustomerId}", "GET")
export class AiClinicalSummaryCaseRequest implements IReturn<ResponseBase<AiClinicalSummaryCaseResponse>>, ICustomerId
{
    public customerId: number;

    public constructor(init?: Partial<AiClinicalSummaryCaseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AiClinicalSummaryCaseRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<AiClinicalSummaryCaseResponse>(); }
}
(AiClinicalSummaryCaseRequest as unknown)[immerable] = true;

// @Route("/ai/consultation/next-actions", "POST")
export class ConsultationNextActions implements IReturn<ResponseBase<ConsultationNextActionsResponse>>, ISecurityId
{
    public caseId: number;
    public consultationId: number;
    public transcript: string;
    public chatMessages: NextActionsChatMessage[];
    public initiation: string;
    public securityId: number;

    public constructor(init?: Partial<ConsultationNextActions>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ConsultationNextActions'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ConsultationNextActionsResponse>(); }
}
(ConsultationNextActions as unknown)[immerable] = true;

// @Route("/ai/consultation/structure", "POST")
export class ConsultationStructure implements IReturn<ResponseBase<ConsultationStructureResponse>>, ISecurityId
{
    public caseId: number;
    public consultationId: number;
    public recordingId?: number;
    public transcript: string;
    public fields: ConsultationFieldDto[];
    public securityId: number;

    public constructor(init?: Partial<ConsultationStructure>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ConsultationStructure'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ConsultationStructureResponse>(); }
}
(ConsultationStructure as unknown)[immerable] = true;

export class GetAllAdvancedSearchFiltersRequest implements IReturn<ResponseBase<GetAllAdvancedSearchFiltersResponse>>
{
    public searchModule?: SearchModuleEntityType;

    public constructor(init?: Partial<GetAllAdvancedSearchFiltersRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAllAdvancedSearchFiltersRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GetAllAdvancedSearchFiltersResponse>(); }
}
(GetAllAdvancedSearchFiltersRequest as unknown)[immerable] = true;

export class AdvancedSearchSaveFilterRequest extends SearchFilter implements IReturn<ResponseBase<T>>
{
    public filterConditionsToSave: SearchFilterCondition[];
    public assignmentType?: FilterAssignmentType;

    public constructor(init?: Partial<AdvancedSearchSaveFilterRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'AdvancedSearchSaveFilterRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(AdvancedSearchSaveFilterRequest as unknown)[immerable] = true;

export class AdvancedSearchDeleteFilterRequest implements IReturn<ResponseBase<boolean>>
{
    public id: string;

    public constructor(init?: Partial<AdvancedSearchDeleteFilterRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdvancedSearchDeleteFilterRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(AdvancedSearchDeleteFilterRequest as unknown)[immerable] = true;

export class GetInitialRegistrationSessionTokenRequest implements IReturn<ResponseBase<GetInitialRegistrationSessionTokenResponse>>
{
    public accountingSystemName: AccountingSystemProviderName;

    public constructor(init?: Partial<GetInitialRegistrationSessionTokenRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInitialRegistrationSessionTokenRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GetInitialRegistrationSessionTokenResponse>(); }
}
(GetInitialRegistrationSessionTokenRequest as unknown)[immerable] = true;

export class DeactivateAccountingSystemRequest implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<DeactivateAccountingSystemRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeactivateAccountingSystemRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(DeactivateAccountingSystemRequest as unknown)[immerable] = true;

// @Route("/accounting/getLedgerAccountsInfo")
export class GetLedgerAccountsRequest implements IReturn<ResponseBase<LedgerAccountInfo[]>>
{

    public constructor(init?: Partial<GetLedgerAccountsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetLedgerAccountsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<LedgerAccountInfo[]>(); }
}
(GetLedgerAccountsRequest as unknown)[immerable] = true;

export class GetTaxRatesRequest implements IReturn<ResponseBase<TaxRateInfo[]>>
{

    public constructor(init?: Partial<GetTaxRatesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTaxRatesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<TaxRateInfo[]>(); }
}
(GetTaxRatesRequest as unknown)[immerable] = true;

// @Route("/accounting/getTrackingCategories")
export class GetTrackingCategories implements IReturn<ResponseBase<AccountingTrackingCategory[]>>
{

    public constructor(init?: Partial<GetTrackingCategories>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrackingCategories'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<AccountingTrackingCategory[]>(); }
}
(GetTrackingCategories as unknown)[immerable] = true;

// @Route("/accounting/updateLocationTrackingCategory")
export class UpdateLocationTrackingCategory implements IReturn<boolean>
{
    public locationId: number;
    public trackingCategory: string;

    public constructor(init?: Partial<UpdateLocationTrackingCategory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateLocationTrackingCategory'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return false; }
}
(UpdateLocationTrackingCategory as unknown)[immerable] = true;

export class GetAccountingSettingsInfoRequest implements IReturn<ResponseBase<AllAccountingConfigAndSettings>>
{

    public constructor(init?: Partial<GetAccountingSettingsInfoRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAccountingSettingsInfoRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<AllAccountingConfigAndSettings>(); }
}
(GetAccountingSettingsInfoRequest as unknown)[immerable] = true;

export class SaveAccountingSettingsInfoRequest implements IReturn<ResponseBase<AllAccountingConfigAndSettings>>
{
    public newAccountingSettings: AccountingSettingInfo;
    public isInitialSetup: boolean;
    public isReactivation: boolean;

    public constructor(init?: Partial<SaveAccountingSettingsInfoRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveAccountingSettingsInfoRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AllAccountingConfigAndSettings>(); }
}
(SaveAccountingSettingsInfoRequest as unknown)[immerable] = true;

export class SyncPaymentUpdateFromXeroManuallyRequest implements IReturn<ResponseBase<IncomingAccountingPaymentResponse>>
{
    public paymentId: number;

    public constructor(init?: Partial<SyncPaymentUpdateFromXeroManuallyRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SyncPaymentUpdateFromXeroManuallyRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<IncomingAccountingPaymentResponse>(); }
}
(SyncPaymentUpdateFromXeroManuallyRequest as unknown)[immerable] = true;

export class AccountingApiSyncHistorySearchRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<T>>
{
    public invoiceId?: number;
    public paymentId?: number;
    public status: string;

    public constructor(init?: Partial<AccountingApiSyncHistorySearchRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'AccountingApiSyncHistorySearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(AccountingApiSyncHistorySearchRequest as unknown)[immerable] = true;

export class GetAccountingApiSyncHistoryRequest implements IReturn<ResponseBase<T>>
{
    public id: number;

    public constructor(init?: Partial<GetAccountingApiSyncHistoryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAccountingApiSyncHistoryRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetAccountingApiSyncHistoryRequest as unknown)[immerable] = true;

// @Route("/accounting/cacheApiDeckRequests", "POST")
export class CacheApiDeckRequest implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<CacheApiDeckRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CacheApiDeckRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CacheApiDeckRequest as unknown)[immerable] = true;

// @Route("/oauth/start", "GET")
export class OAuthInitiateRequest implements IReturnVoid
{

    public constructor(init?: Partial<OAuthInitiateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OAuthInitiateRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(OAuthInitiateRequest as unknown)[immerable] = true;

// @Route("/oauth/callback", "GET")
export class OAuthCallbackRequest implements IReturn<OAuthCallbackResponse>
{
    public code: string;
    public state: string;

    public constructor(init?: Partial<OAuthCallbackRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OAuthCallbackRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new OAuthCallbackResponse(); }
}
(OAuthCallbackRequest as unknown)[immerable] = true;

// @Route("/virtual-reception/patients/appointment/cancel", "POST")
export class VirtualReceptionAppointmentCancelRequest implements IReturn<VirtualReceptionAppointmentCancelResponse>, IVirtualReceptionRequest
{
    public customerId: number;
    public appointmentId: number;
    public reason: string;

    public constructor(init?: Partial<VirtualReceptionAppointmentCancelRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VirtualReceptionAppointmentCancelRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new VirtualReceptionAppointmentCancelResponse(); }
}
(VirtualReceptionAppointmentCancelRequest as unknown)[immerable] = true;

// @Route("/virtual-reception/appointments/availability", "POST")
export class VirtualReceptionAvailabilityRequest implements IReturn<VirtualReceptionAvailabilityResponse>, IVirtualReceptionRequest
{
    public customerId: number;
    public appointmentId: number;
    public serviceId?: string;
    public locationId?: number;
    public practitionerId?: number;
    public specialismId?: string;
    public practitionerGender: string;
    public timeOfDay?: TimeOfDay;
    public groupId?: number;
    public dateHint: string;
    public days?: number;

    public constructor(init?: Partial<VirtualReceptionAvailabilityRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VirtualReceptionAvailabilityRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new VirtualReceptionAvailabilityResponse(); }
}
(VirtualReceptionAvailabilityRequest as unknown)[immerable] = true;

// @Route("/virtual-reception/appointments/reschedule", "POST")
export class VirtualReceptionRescheduleRequest implements IReturn<VirtualReceptionRescheduleResponse>, IVirtualReceptionRequest
{
    public customerId: number;
    public appointmentId: number;
    public slotId: string;
    public idempotencyKey: string;

    public constructor(init?: Partial<VirtualReceptionRescheduleRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VirtualReceptionRescheduleRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new VirtualReceptionRescheduleResponse(); }
}
(VirtualReceptionRescheduleRequest as unknown)[immerable] = true;

// @Route("/virtual-reception/appointments/reserve", "POST")
export class VirtualReceptionReserveRequest implements IReturn<VirtualReceptionReserveResponse>, IVirtualReceptionRequest
{
    public slotId: string;
    public customerId: number;
    public serviceId: string;
    public groupId?: number;

    public constructor(init?: Partial<VirtualReceptionReserveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VirtualReceptionReserveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new VirtualReceptionReserveResponse(); }
}
(VirtualReceptionReserveRequest as unknown)[immerable] = true;

// @Route("/virtual-reception/appointments/release", "POST")
export class VirtualReceptionReleaseRequest implements IReturn<VirtualReceptionReleaseResponse>, IVirtualReceptionRequest
{
    public appointmentId: number;

    public constructor(init?: Partial<VirtualReceptionReleaseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VirtualReceptionReleaseRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new VirtualReceptionReleaseResponse(); }
}
(VirtualReceptionReleaseRequest as unknown)[immerable] = true;

// @Route("/virtual-reception/appointments/book", "POST")
export class VirtualReceptionBookRequest implements IReturn<VirtualReceptionBookResponse>, IVirtualReceptionRequest
{
    public appointmentId: number;

    public constructor(init?: Partial<VirtualReceptionBookRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VirtualReceptionBookRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new VirtualReceptionBookResponse(); }
}
(VirtualReceptionBookRequest as unknown)[immerable] = true;

// @Route("/virtual-reception/appointment-types/count", "GET")
export class VirtualReceptionAppointmentTypesCountRequest implements IReturn<VirtualReceptionAppointmentTypesCountResponse>
{

    public constructor(init?: Partial<VirtualReceptionAppointmentTypesCountRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VirtualReceptionAppointmentTypesCountRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new VirtualReceptionAppointmentTypesCountResponse(); }
}
(VirtualReceptionAppointmentTypesCountRequest as unknown)[immerable] = true;

// @Route("/virtual-reception/appointment-types", "GET")
export class VirtualReceptionAppointmentTypesRequest implements IReturn<VirtualReceptionAppointmentTypeResponse[]>, IVirtualReceptionRequest
{

    public constructor(init?: Partial<VirtualReceptionAppointmentTypesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VirtualReceptionAppointmentTypesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Array<VirtualReceptionAppointmentTypeResponse>(); }
}
(VirtualReceptionAppointmentTypesRequest as unknown)[immerable] = true;

// @Route("/virtual-reception/patients/search", "POST")
export class VirtualReceptionPatientSearchRequest implements IReturn<VirtualReceptionPatientSearchResponse[]>, IVirtualReceptionRequest
{
    public name: string;
    public phone: string;
    public postcode: string;
    public dateOfBirth: string;

    public constructor(init?: Partial<VirtualReceptionPatientSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VirtualReceptionPatientSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Array<VirtualReceptionPatientSearchResponse>(); }
}
(VirtualReceptionPatientSearchRequest as unknown)[immerable] = true;

// @Route("/virtual-reception/patients/appointment/search", "POST")
export class VirtualReceptionPatientAppointmentSearchRequest implements IReturn<VirtualReceptionPatientAppointmentSearchResponse>, IVirtualReceptionRequest
{
    public customerId: number;

    public constructor(init?: Partial<VirtualReceptionPatientAppointmentSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VirtualReceptionPatientAppointmentSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new VirtualReceptionPatientAppointmentSearchResponse(); }
}
(VirtualReceptionPatientAppointmentSearchRequest as unknown)[immerable] = true;

// @Route("/virtual-reception/patients/create", "POST")
export class VirtualReceptionCreatePatientRequest implements IReturn<VirtualReceptionCreatePatientResponse>, IVirtualReceptionRequest
{
    public forename: string;
    public surname: string;
    public mobileTelephone: string;
    public email: string;
    public dateOfBirth: string;
    public locationId?: number;
    public forceSave: boolean;

    public constructor(init?: Partial<VirtualReceptionCreatePatientRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VirtualReceptionCreatePatientRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new VirtualReceptionCreatePatientResponse(); }
}
(VirtualReceptionCreatePatientRequest as unknown)[immerable] = true;

// @Route("/virtual-reception/register", "POST")
export class RegisterVirtualReceptionRequest implements IReturn<ResponseBase<RegisterVirtualReceptionResponse>>
{

    public constructor(init?: Partial<RegisterVirtualReceptionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegisterVirtualReceptionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<RegisterVirtualReceptionResponse>(); }
}
(RegisterVirtualReceptionRequest as unknown)[immerable] = true;

// @Route("/virtual-reception/session", "POST")
export class CreateVirtualReceptionSessionRequest implements IReturn<ResponseBase<VirtualReceptionSessionResponse>>
{

    public constructor(init?: Partial<CreateVirtualReceptionSessionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateVirtualReceptionSessionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<VirtualReceptionSessionResponse>(); }
}
(CreateVirtualReceptionSessionRequest as unknown)[immerable] = true;

// @Route("/virtual-reception/config/sync", "POST")
export class SyncVirtualReceptionConfigRequest implements IReturn<ResponseBase<SyncVirtualReceptionConfigResponse>>
{

    public constructor(init?: Partial<SyncVirtualReceptionConfigRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SyncVirtualReceptionConfigRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SyncVirtualReceptionConfigResponse>(); }
}
(SyncVirtualReceptionConfigRequest as unknown)[immerable] = true;

// @Route("/sys/config/all")
export class SysConfigRequest implements IReturn<ResponseBase<{ [index:string]: string; }>>
{

    public constructor(init?: Partial<SysConfigRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SysConfigRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<{ [index:string]: string; }>(); }
}
(SysConfigRequest as unknown)[immerable] = true;

// @Route("/sys/config/update")
export class ConfigUpdate implements IReturn<ResponseBase<{ [index:string]: string; }>>
{
    public id: number;
    public description: string;
    public value: string;

    public constructor(init?: Partial<ConfigUpdate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ConfigUpdate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<{ [index:string]: string; }>(); }
}
(ConfigUpdate as unknown)[immerable] = true;

export class BatchConfigUpdates implements IReturn<ResponseBase<{ [index:string]: string; }>>
{
    public updates: ConfigUpdate[];

    public constructor(init?: Partial<BatchConfigUpdates>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BatchConfigUpdates'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<{ [index:string]: string; }>(); }
}
(BatchConfigUpdates as unknown)[immerable] = true;

// @Route("/test/error")
export class TestError
{

    public constructor(init?: Partial<TestError>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TestError'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(TestError as unknown)[immerable] = true;

// @Route("/locale")
export class LocaleRequest
{

    public constructor(init?: Partial<LocaleRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LocaleRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(LocaleRequest as unknown)[immerable] = true;

// @Route("/loginMode")
export class LoginModeRequest
{

    public constructor(init?: Partial<LoginModeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LoginModeRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(LoginModeRequest as unknown)[immerable] = true;

// @Route("/sys/config/features")
export class FeatureRequest implements IReturn<ResponseBase<{ [index:string]: string; }>>
{

    public constructor(init?: Partial<FeatureRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FeatureRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<{ [index:string]: string; }>(); }
}
(FeatureRequest as unknown)[immerable] = true;

export class GetPhioConfigRequest implements IReturn<ResponseBase<PhioConfigResponse>>
{

    public constructor(init?: Partial<GetPhioConfigRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPhioConfigRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<PhioConfigResponse>(); }
}
(GetPhioConfigRequest as unknown)[immerable] = true;

export class GetMediPassApiKeyRequest implements IReturn<ResponseBase<string>>
{

    public constructor(init?: Partial<GetMediPassApiKeyRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMediPassApiKeyRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<string>(); }
}
(GetMediPassApiKeyRequest as unknown)[immerable] = true;

// @Route("/admin/dev-flags")
export class GetDevFlagsRequest implements IReturn<GetDevFlagsResponse>
{

    public constructor(init?: Partial<GetDevFlagsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDevFlagsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDevFlagsResponse(); }
}
(GetDevFlagsRequest as unknown)[immerable] = true;

// @Route("/admin/feature-catalog")
// @Route("/admin/feature-catalogue")
export class GetFeatureCatalogRequest implements IReturn<GetFeatureCatalogResponse>
{

    public constructor(init?: Partial<GetFeatureCatalogRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetFeatureCatalogRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetFeatureCatalogResponse(); }
}
(GetFeatureCatalogRequest as unknown)[immerable] = true;

// @Route("/admin/feature-flags/migration-preview")
export class LegacyFeatureFlagMigrationPreviewRequest implements IReturn<LegacyFeatureFlagMigrationResponse>
{

    public constructor(init?: Partial<LegacyFeatureFlagMigrationPreviewRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LegacyFeatureFlagMigrationPreviewRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new LegacyFeatureFlagMigrationResponse(); }
}
(LegacyFeatureFlagMigrationPreviewRequest as unknown)[immerable] = true;

// @Route("/admin/feature-flags/migrate-legacy", "POST")
export class LegacyFeatureFlagMigrationRequest implements IReturn<LegacyFeatureFlagMigrationResponse>
{

    public constructor(init?: Partial<LegacyFeatureFlagMigrationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LegacyFeatureFlagMigrationRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new LegacyFeatureFlagMigrationResponse(); }
}
(LegacyFeatureFlagMigrationRequest as unknown)[immerable] = true;

// @Route("/admin/dev-flags", "POST")
export class SetDevFlagRequest implements IReturn<ResponseBase<boolean>>
{
    public key: string;
    public enabled: boolean;

    public constructor(init?: Partial<SetDevFlagRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetDevFlagRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(SetDevFlagRequest as unknown)[immerable] = true;

// @Route("/healthz_client/{clientId}")
export class HeartbeatRequest implements IReturn<ResponseBase<boolean>>
{
    public clientId?: number;
    public simulateSlow?: boolean;

    public constructor(init?: Partial<HeartbeatRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'HeartbeatRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(HeartbeatRequest as unknown)[immerable] = true;

export class GetSubscriptionRequest implements IReturn<ResponseBase<SubscriptionResponse>>
{
    public id: number;

    public constructor(init?: Partial<GetSubscriptionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSubscriptionRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<SubscriptionResponse>(); }
}
(GetSubscriptionRequest as unknown)[immerable] = true;

export class GetSubscriptionHistoryRequest implements IReturn<ResponseBase<SubscriptionHistoryResponse>>
{
    public id: number;

    public constructor(init?: Partial<GetSubscriptionHistoryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSubscriptionHistoryRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<SubscriptionHistoryResponse>(); }
}
(GetSubscriptionHistoryRequest as unknown)[immerable] = true;

export class SubscriptionSearchRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<SubscriptionResponse>>
{
    public id: number;
    public customerId?: number;
    public invoiceStatus: string;
    public status?: SubscriptionStatus;
    public amount: CurrencyRange;
    public lastRunOn: DateRange;
    public nextDue: DateRange;
    public startDate: DateRange;
    public expiryDate: DateRange;

    public constructor(init?: Partial<SubscriptionSearchRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SubscriptionSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SubscriptionResponse>(); }
}
(SubscriptionSearchRequest as unknown)[immerable] = true;

export class CreateSubscriptionRequest implements IReturn<ResponseBase<SubscriptionResponse>>, ILocationId
{
    public customer: CustomerSaveRequest;
    public locationId: number;
    public practitionerId?: number;
    public packageId: string;
    public startDate?: string;
    public billingMode: SubscriptionBillingMode;
    public paymentMode: SubscriptionPaymentMode;
    public paymentMethod: SubscriptionPaymentMethod;
    public paymentMethodOther: string;
    public terminalPayment: TerminalPaymentDto;

    public constructor(init?: Partial<CreateSubscriptionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateSubscriptionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SubscriptionResponse>(); }
}
(CreateSubscriptionRequest as unknown)[immerable] = true;

export class UpdateSubscriptionRequest implements IReturn<ResponseBase<SubscriptionResponse>>
{
    public id: number;
    public status: SubscriptionStatus;
    public startDate: string;
    public expiryDate?: string;
    public name: string;
    public packageId: string;
    public totalExVat: number;
    public vatRate: number;
    public totalIncVat: number;
    public locationId: number;
    public practitionerId?: number;
    public nextDue?: string;
    public subscriptionInterval: number;
    public subscriptionIntervalUnit: SubscriptionRecurrenceInterval;
    public earliestAllowedCancellationDate?: string;
    public bundles: PackageBundleResponse[];

    public constructor(init?: Partial<UpdateSubscriptionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateSubscriptionRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<SubscriptionResponse>(); }
}
(UpdateSubscriptionRequest as unknown)[immerable] = true;

export class BasicCardDetailsRequest implements IReturn<ResponseBase<BasicCardDetailsResponse>>
{
    public customerId: number;

    public constructor(init?: Partial<BasicCardDetailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BasicCardDetailsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<BasicCardDetailsResponse>(); }
}
(BasicCardDetailsRequest as unknown)[immerable] = true;

export class FullCardDetailsRequest implements IReturn<ResponseBase<FullCardDetailsResponse>>
{
    public customerId: number;

    public constructor(init?: Partial<FullCardDetailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FullCardDetailsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<FullCardDetailsResponse>(); }
}
(FullCardDetailsRequest as unknown)[immerable] = true;

export class DeleteCardDetailsRequest implements IReturn<ResponseBase<DeleteCardDetailsResponse>>
{
    public customerId: number;

    public constructor(init?: Partial<DeleteCardDetailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteCardDetailsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<DeleteCardDetailsResponse>(); }
}
(DeleteCardDetailsRequest as unknown)[immerable] = true;

export class GetCardDetailsRequest implements IReturn<ResponseBase<boolean>>
{
    public customerId: number;

    public constructor(init?: Partial<GetCardDetailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCardDetailsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(GetCardDetailsRequest as unknown)[immerable] = true;

export class CancelCardDetailsRequest implements IReturn<ResponseBase<boolean>>
{
    public customerId: number;

    public constructor(init?: Partial<CancelCardDetailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CancelCardDetailsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CancelCardDetailsRequest as unknown)[immerable] = true;

// @Route("/apple-developer-merchantid-domain-association")
export class SquareApplePayVerificationFileRequest implements IReturn<HttpResult>
{

    public constructor(init?: Partial<SquareApplePayVerificationFileRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SquareApplePayVerificationFileRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new HttpResult(); }
}
(SquareApplePayVerificationFileRequest as unknown)[immerable] = true;

// @Route("/square/redirect", "GET")
export class SquareRedirectRequest implements IReturn<HttpResult>
{
    public state: string;
    public code: string;
    public error: string;
    public error_Description: string;

    public constructor(init?: Partial<SquareRedirectRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SquareRedirectRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new HttpResult(); }
}
(SquareRedirectRequest as unknown)[immerable] = true;

export class SquareSaveStateRequest implements IReturn<ResponseBase<T>>
{
    public state?: string;

    public constructor(init?: Partial<SquareSaveStateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SquareSaveStateRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(SquareSaveStateRequest as unknown)[immerable] = true;

export class SquareIntegrationRequest implements IReturn<ResponseBase<SquareOAuthResponse>>
{
    public state?: string;

    public constructor(init?: Partial<SquareIntegrationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SquareIntegrationRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SquareOAuthResponse>(); }
}
(SquareIntegrationRequest as unknown)[immerable] = true;

export class SquareDeAuthRequest implements IReturn<ResponseBase<SquareOAuthResponse>>
{

    public constructor(init?: Partial<SquareDeAuthRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SquareDeAuthRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SquareOAuthResponse>(); }
}
(SquareDeAuthRequest as unknown)[immerable] = true;

export class SquareGetOAuthPermissionsRequest implements IReturn<ResponseBase<SquareOAuthPermissionsResponse>>
{

    public constructor(init?: Partial<SquareGetOAuthPermissionsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SquareGetOAuthPermissionsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<SquareOAuthPermissionsResponse>(); }
}
(SquareGetOAuthPermissionsRequest as unknown)[immerable] = true;

export class GetPackageRequest implements IReturn<ResponseBase<PackageResponse>>
{
    public packageId: string;

    public constructor(init?: Partial<GetPackageRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPackageRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<PackageResponse>(); }
}
(GetPackageRequest as unknown)[immerable] = true;

export class PackagesSearchRequest implements IReturn<ResponseBase<PackageResponse>>
{
    public term: string;
    public includeNonCurrent: boolean;

    public constructor(init?: Partial<PackagesSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PackagesSearchRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<PackageResponse>(); }
}
(PackagesSearchRequest as unknown)[immerable] = true;

export class SavePackageRequest implements IReturn<ResponseBase<PackageResponse>>, IDepartmentIds, ILocationIds
{
    public id: number;
    public reference: string;
    public totalPrice?: number;
    public description: string;
    public appointmentLength?: number;
    public groupLocationLocationId: number;
    public locationId?: number;
    public colour?: number;
    public online: boolean;
    public onlineGuid?: string;
    public inUse?: boolean;
    public priceExVAT?: number;
    public vatRate?: number;
    public vatAmount?: number;
    public costAmount?: number;
    public costVATRate?: number;
    public costExVAT?: number;
    public costVATAmount?: number;
    public longDescription: string;
    public ledgerCode: string;
    public ledgerCodeOverrides: AccountingStockLedgerLookup[];
    public legderCodeAccountId: string;
    public category?: string;
    public level?: number;
    public minimumLevel?: number;
    public displayInPriceList?: boolean;
    public totalWorth: number;
    public supplierId?: number;
    public serviceTypeId?: number;
    public isPrivateCharge?: boolean;
    public stockIsCancel: boolean;
    public stockIsFirst: boolean;
    public stockIsFollowUp: boolean;
    public stockIsDNA: boolean;
    public isMultiple?: boolean;
    public groupName: string;
    public overrides: StockOverrideResponse[];
    public validForDaysFromPurchase: number;
    public isSubscriptionType: boolean;
    public subscriptionInterval: number;
    public subscriptionIntervalUnit: SubscriptionRecurrenceInterval;
    public hasMinimumTerm: boolean;
    public minimumTermValue: number;
    public minimumTermInterval: number;
    public minimumTermIntervalUnit: SubscriptionRecurrenceInterval;
    public hasMaximumTerm: boolean;
    public maximumTermValue: number;
    public maximumTermInterval: number;
    public maximumTermIntervalUnit: SubscriptionRecurrenceInterval;
    public onePerCustomer: boolean;
    public newCustomersOnly: boolean;
    public allowDiscountCodes: boolean;
    public hasValidityPeriod: boolean;
    public validFrom?: string;
    public validTo?: string;
    public termsAndConditionsFormId?: string;
    public updateExistingSubscriptionsToUseNewBundles: boolean;
    public bundles: PackageBundleResponse[];
    public departmentIds: number[];
    public locationIds: number[];
    public requestLocationIds: number[];
    public colourCss: string;
    public urlSlug: string;
    public imageName: string;
    public isCloning: boolean;
    public expirationValue?: number;
    public quantityThreshold: number;
    public creditAmount?: number;
    public excludedStockItemIds: number[];
    public excludedClassTypeIds: number[];
    public packageType: PackageType;
    public restrictToPrivateCharges: boolean;
    public eligibleForTaxExemption: boolean;
    public tags: string[];

    public constructor(init?: Partial<SavePackageRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SavePackageRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<PackageResponse>(); }
}
(SavePackageRequest as unknown)[immerable] = true;

// @Route("/online/cases", "GET")
export class OnlineGetClientPortalCasesRequest implements IReturn<ResponseBase<OnlineClientPortalCaseResponse>>
{

    public constructor(init?: Partial<OnlineGetClientPortalCasesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineGetClientPortalCasesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<OnlineClientPortalCaseResponse>(); }
}
(OnlineGetClientPortalCasesRequest as unknown)[immerable] = true;

// @Route("/online/cases/{WorkflowId}", "GET")
export class OnlineGetClientPortalCaseRequest implements IReturn<ResponseBase<OnlineClientPortalCaseResponse>>
{
    public workflowId: number;

    public constructor(init?: Partial<OnlineGetClientPortalCaseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineGetClientPortalCaseRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<OnlineClientPortalCaseResponse>(); }
}
(OnlineGetClientPortalCaseRequest as unknown)[immerable] = true;

// @Route("/online/workflows/{WorkflowId}/files", "GET")
export class OnlineGetWorkflowFilesRequest implements IReturn<ResponseBase<OnlineMyFilesResponse>>
{
    public workflowId: number;

    public constructor(init?: Partial<OnlineGetWorkflowFilesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineGetWorkflowFilesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<OnlineMyFilesResponse>(); }
}
(OnlineGetWorkflowFilesRequest as unknown)[immerable] = true;

export class MyDiaryRequest implements IReturn<ResponseBase<MyDiaryResponse>>
{
    public subWorkflowId?: number;

    public constructor(init?: Partial<MyDiaryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MyDiaryRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<MyDiaryResponse>(); }
}
(MyDiaryRequest as unknown)[immerable] = true;

export class OnlineGetExistingWaitingListsForCustomer implements IReturn<ResponseBase<WaitingListResponse>>
{
    public patientId?: number;

    public constructor(init?: Partial<OnlineGetExistingWaitingListsForCustomer>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineGetExistingWaitingListsForCustomer'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<WaitingListResponse>(); }
}
(OnlineGetExistingWaitingListsForCustomer as unknown)[immerable] = true;

// @Route("/diary/waiting-lists/save", "POST")
export class SaveWaitingListRequest extends WaitingList implements IReturn<ResponseBase<boolean>>
{
    public days: number[];
    public customer: CustomerSaveRequest;

    public constructor(init?: Partial<SaveWaitingListRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveWaitingListRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(SaveWaitingListRequest as unknown)[immerable] = true;

// @Route("/diary/waiting-lists/save", "POST")
export class OnlineSaveWaitingListRequest extends SaveWaitingListRequest implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<OnlineSaveWaitingListRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineSaveWaitingListRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(OnlineSaveWaitingListRequest as unknown)[immerable] = true;

// @Route("/diary/waiting-list/{Id}", "DELETE")
export class DeleteWaitingListRequest implements IReturn<ResponseBase<boolean>>
{
    public id: number;

    public constructor(init?: Partial<DeleteWaitingListRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteWaitingListRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(DeleteWaitingListRequest as unknown)[immerable] = true;

// @Route("/diary/waiting-list/{Id}", "DELETE")
export class OnlineDeleteWaitingListRequest extends DeleteWaitingListRequest implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<OnlineDeleteWaitingListRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineDeleteWaitingListRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(OnlineDeleteWaitingListRequest as unknown)[immerable] = true;

// @Route("/online/appointments/confirm/dual", "PUT")
export class DualAppointmentConfirmRequest implements IReturn<ResponseBase<DualAppointmentConfirmResponse>>, IPut
{
    public primary: AppointmentConfirmRequest;
    public companion: AppointmentConfirmRequest;

    public constructor(init?: Partial<DualAppointmentConfirmRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DualAppointmentConfirmRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<DualAppointmentConfirmResponse>(); }
}
(DualAppointmentConfirmRequest as unknown)[immerable] = true;

// @Route("/online/appointments/confirm/additional-services", "PUT")
export class AdditionalServicesAppointmentConfirmRequest implements IReturn<ResponseBase<AdditionalServicesAppointmentConfirmResponse>>, IPut
{
    public primary: AppointmentConfirmRequest;
    public extendedServiceIds: string[];
    public addOns: AdditionalAppointmentConfirmItem[];

    public constructor(init?: Partial<AdditionalServicesAppointmentConfirmRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdditionalServicesAppointmentConfirmRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<AdditionalServicesAppointmentConfirmResponse>(); }
}
(AdditionalServicesAppointmentConfirmRequest as unknown)[immerable] = true;

export class OnlinePatientFormsRequest implements IReturn<ResponseBase<OnlinePatientFormResponse>>
{
    public subWorkflowId?: number;

    public constructor(init?: Partial<OnlinePatientFormsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlinePatientFormsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<OnlinePatientFormResponse>(); }
}
(OnlinePatientFormsRequest as unknown)[immerable] = true;

export class OnlineStripeDeleteCardRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<OnlineStripeDeleteCardRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineStripeDeleteCardRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(OnlineStripeDeleteCardRequest as unknown)[immerable] = true;

export class OnlineGetCardDetailsRequest implements IReturn<ResponseBase<CardDetails>>
{

    public constructor(init?: Partial<OnlineGetCardDetailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineGetCardDetailsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CardDetails>(); }
}
(OnlineGetCardDetailsRequest as unknown)[immerable] = true;

export class RecordInsuranceConsentRequest implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<RecordInsuranceConsentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RecordInsuranceConsentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(RecordInsuranceConsentRequest as unknown)[immerable] = true;

export class OnlineCancelBookingRequest implements IReturn<ResponseBase<boolean>>
{
    public appointmentId: number;
    public classAttendanceId?: number;
    public cancellationReason: string;
    public payFee: boolean;
    public takePaymentRequest: TakePaymentRequest;

    public constructor(init?: Partial<OnlineCancelBookingRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineCancelBookingRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(OnlineCancelBookingRequest as unknown)[immerable] = true;

export class OnlineCancellationOptionsRequest implements IReturn<ResponseBase<OnlineCancellationOptionsResponse>>
{
    public appointmentId: number;
    public classAttendanceId: number;

    public constructor(init?: Partial<OnlineCancellationOptionsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineCancellationOptionsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<OnlineCancellationOptionsResponse>(); }
}
(OnlineCancellationOptionsRequest as unknown)[immerable] = true;

// @Route("/invoices/{CustomerId}", "GET")
export class OnlineInvoiceListRequest implements IReturn<ResponseBase<T>>
{
    public customerId: number;

    public constructor(init?: Partial<OnlineInvoiceListRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineInvoiceListRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(OnlineInvoiceListRequest as unknown)[immerable] = true;

// @Route("/invoice/download/{InvoiceId}")
// @Route("/receipt/download/{IncomeId}")
export class OnlineInvoiceDownloadRequest implements IReturn<HttpResult>
{
    public invoiceId?: number;
    public incomeId?: number;

    public constructor(init?: Partial<OnlineInvoiceDownloadRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineInvoiceDownloadRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new HttpResult(); }
}
(OnlineInvoiceDownloadRequest as unknown)[immerable] = true;

export class OnlineGetPaymentDetailsRequest implements IReturn<ResponseBase<OnlinePaymentDetailsResponse>>
{
    public stockId?: string;
    public additionalStockIds: string[];
    public classTypeId?: number;
    public courseTypeId?: number;

    public constructor(init?: Partial<OnlineGetPaymentDetailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineGetPaymentDetailsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<OnlinePaymentDetailsResponse>(); }
}
(OnlineGetPaymentDetailsRequest as unknown)[immerable] = true;

// @Route("/packages/list", "GET")
export class OnlineCustomerPackageRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<OnlineCustomerPackageRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineCustomerPackageRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(OnlineCustomerPackageRequest as unknown)[immerable] = true;

export class BuyPackageRequest implements IReturn<ResponseBase<T>>
{
    public packageId: string;
    public isSubscription: boolean;
    public saveCard: boolean;
    public isConnectCustomer: boolean;
    public takePaymentRequest: TakePaymentRequest;
    public discountCode: string;

    public constructor(init?: Partial<BuyPackageRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BuyPackageRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(BuyPackageRequest as unknown)[immerable] = true;

export class OnlinePasswordChangeRequest implements IReturn<ResponseBase<T>>
{
    public oldPassword: string;
    public newPassword: string;
    public passwordScore: number;

    public constructor(init?: Partial<OnlinePasswordChangeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlinePasswordChangeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(OnlinePasswordChangeRequest as unknown)[immerable] = true;

export class OnlineUpdateSubscriptionRequest implements IReturn<ResponseBase<T>>
{
    public id: number;
    public status: SubscriptionStatus;

    public constructor(init?: Partial<OnlineUpdateSubscriptionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineUpdateSubscriptionRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(OnlineUpdateSubscriptionRequest as unknown)[immerable] = true;

export class GetAppointmentLocationsRequest implements IReturn<ResponseBase<T>>
{
    public serviceId: string;
    public overrideProductServiceId?: string;
    public stockId: string;
    public medicalImagingProcedureId?: number;
    public locationId: string;

    public constructor(init?: Partial<GetAppointmentLocationsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAppointmentLocationsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetAppointmentLocationsRequest as unknown)[immerable] = true;

export class GetAuthAppointmentLocationsRequest extends GetAppointmentLocationsRequest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<GetAuthAppointmentLocationsRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAuthAppointmentLocationsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetAuthAppointmentLocationsRequest as unknown)[immerable] = true;

export class OnlineCaseflowFormRequest implements IReturn<ResponseBase<T>>
{
    public productId: string;

    public constructor(init?: Partial<OnlineCaseflowFormRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineCaseflowFormRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(OnlineCaseflowFormRequest as unknown)[immerable] = true;

export class OnlineKeepAliveReservationRequest implements IReturn<ResponseBase<T>>
{
    public appointmentId: number;

    public constructor(init?: Partial<OnlineKeepAliveReservationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineKeepAliveReservationRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(OnlineKeepAliveReservationRequest as unknown)[immerable] = true;

export class OnlineCaseflowContactRoleRequest implements IReturn<ResponseBase<OnlineRole>>
{

    public constructor(init?: Partial<OnlineCaseflowContactRoleRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineCaseflowContactRoleRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<OnlineRole>(); }
}
(OnlineCaseflowContactRoleRequest as unknown)[immerable] = true;

export class OnlineCaseflowContactSearch implements IReturn<ResponseBase<OnlineCaseflowContact>>
{
    public serviceId: string;
    public skip: number;
    public take: number;
    public term: string;

    public constructor(init?: Partial<OnlineCaseflowContactSearch>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineCaseflowContactSearch'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<OnlineCaseflowContact>(); }
}
(OnlineCaseflowContactSearch as unknown)[immerable] = true;

export class ValidateOnlineDiscountCode implements IReturn<ResponseBase<DiscountCodeDto>>
{
    public discountCodeId?: string;
    public code: string;
    public appointmentDate?: string;
    public getInUseFlag: boolean;
    public enableForConnect?: boolean;
    public stockId: string;
    public sessionCount?: number;
    public isPackage?: boolean;
    public packageStockId?: number;

    public constructor(init?: Partial<ValidateOnlineDiscountCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateOnlineDiscountCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<DiscountCodeDto>(); }
}
(ValidateOnlineDiscountCode as unknown)[immerable] = true;

// @Route("/online/tempfile", "POST")
// @DataContract
export class OnlineUploadTempFile implements IReturn<OnlineUploadTempFileResponse>
{
    // @DataMember(Order=1)
    public id: string;

    public constructor(init?: Partial<OnlineUploadTempFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineUploadTempFile'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new OnlineUploadTempFileResponse(); }
}
(OnlineUploadTempFile as unknown)[immerable] = true;

// @Route("/online/tempfilelisting/{Id}", "POST")
export class OnlineGetTempFileListing implements IReturn<FilesListingResponse>
{
    public id: string;

    public constructor(init?: Partial<OnlineGetTempFileListing>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineGetTempFileListing'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FilesListingResponse(); }
}
(OnlineGetTempFileListing as unknown)[immerable] = true;

// @Route("/online/removetempfile/{Id}/{FileName}", "POST")
export class OnlineRemoveTempFile
{
    public id: string;
    public fileName: string;

    public constructor(init?: Partial<OnlineRemoveTempFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineRemoveTempFile'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(OnlineRemoveTempFile as unknown)[immerable] = true;

// @Route("/online/my/files", "GET")
export class OnlineMyFilesRequest implements IReturn<ResponseBase<OnlineMyFilesResponse>>
{

    public constructor(init?: Partial<OnlineMyFilesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineMyFilesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<OnlineMyFilesResponse>(); }
}
(OnlineMyFilesRequest as unknown)[immerable] = true;

// @Route("/online/my/reports", "GET")
export class OnlineMyReportsRequest implements IReturn<ResponseBase<OnlineMyReportsResponse>>
{
    public workflowId?: number;

    public constructor(init?: Partial<OnlineMyReportsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineMyReportsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<OnlineMyReportsResponse>(); }
}
(OnlineMyReportsRequest as unknown)[immerable] = true;

export class GetOnlineReportRequest implements IReturn<ResponseBase<GetOnlineReportResponse>>
{
    public reportId: number;

    public constructor(init?: Partial<GetOnlineReportRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetOnlineReportRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GetOnlineReportResponse>(); }
}
(GetOnlineReportRequest as unknown)[immerable] = true;

// @Route("/online/my/files/download", "GET")
export class OnlineMyFilesDownloadRequest implements IReturn<Object>
{
    public documentListingId: string;

    public constructor(init?: Partial<OnlineMyFilesDownloadRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineMyFilesDownloadRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Object(); }
}
(OnlineMyFilesDownloadRequest as unknown)[immerable] = true;

// @Route("/online/my/files/view", "HEAD, GET")
export class OnlineMyFilesViewRequest implements IReturn<Object>
{
    public documentListingId: string;

    public constructor(init?: Partial<OnlineMyFilesViewRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineMyFilesViewRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Object(); }
}
(OnlineMyFilesViewRequest as unknown)[immerable] = true;

// @Route("/online/form/{FormId}/files", "GET")
export class OnlineGetFormFilesRequest implements IReturn<ResponseBase<OnlineMyFilesResponse>>
{
    public formId: string;
    public tempFolderId: string;

    public constructor(init?: Partial<OnlineGetFormFilesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineGetFormFilesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<OnlineMyFilesResponse>(); }
}
(OnlineGetFormFilesRequest as unknown)[immerable] = true;

// @Route("/online/form/{FormId}/files/download", "HEAD, GET")
export class OnlineDownloadFormFileRequest implements IReturn<Object>
{
    public formId: string;
    public listingId: string;

    public constructor(init?: Partial<OnlineDownloadFormFileRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineDownloadFormFileRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Object(); }
}
(OnlineDownloadFormFileRequest as unknown)[immerable] = true;

export class OnlineSettingsRequest implements IReturn<OnlineSettingsResponse>
{
    public businessId?: number;

    public constructor(init?: Partial<OnlineSettingsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineSettingsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new OnlineSettingsResponse(); }
}
(OnlineSettingsRequest as unknown)[immerable] = true;

export class OnlineConnectReferralFormRequest implements IReturn<ResponseBase<T>>
{
    public serviceId: string;
    public appointmentlessIntake: boolean;

    public constructor(init?: Partial<OnlineConnectReferralFormRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineConnectReferralFormRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(OnlineConnectReferralFormRequest as unknown)[immerable] = true;

export class OnlineCurrentUserRequest implements IReturn<ResponseBase<CurrentUser>>
{

    public constructor(init?: Partial<OnlineCurrentUserRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineCurrentUserRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CurrentUser>(); }
}
(OnlineCurrentUserRequest as unknown)[immerable] = true;

export class OnlineInitialRequest implements IReturn<ResponseBase<OnlineInitialResponse>>
{

    public constructor(init?: Partial<OnlineInitialRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineInitialRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<OnlineInitialResponse>(); }
}
(OnlineInitialRequest as unknown)[immerable] = true;

export class ConnectValidateBusinessRouteRequest implements IReturn<ResponseBase<BusinessCategoryResponse>>
{
    public url: string;

    public constructor(init?: Partial<ConnectValidateBusinessRouteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ConnectValidateBusinessRouteRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<BusinessCategoryResponse>(); }
}
(ConnectValidateBusinessRouteRequest as unknown)[immerable] = true;

export class ConnectValidateAccessCodeRequest implements IReturn<ResponseBase<boolean>>
{
    public serviceId: string;
    public accessCode: string;

    public constructor(init?: Partial<ConnectValidateAccessCodeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ConnectValidateAccessCodeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ConnectValidateAccessCodeRequest as unknown)[immerable] = true;

// @Route("/availablity/sessions", "POST")
export class GetOnlineSessions implements IReturn<ResponseBase<AvailabilitySession>>
{
    public from?: string;
    public to?: string;
    public locationId: string;

    public constructor(init?: Partial<GetOnlineSessions>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetOnlineSessions'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AvailabilitySession>(); }
}
(GetOnlineSessions as unknown)[immerable] = true;

export class GetLocationOverridesRequest implements IReturn<ResponseBase<T>>
{
    public stockId: string;

    public constructor(init?: Partial<GetLocationOverridesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetLocationOverridesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetLocationOverridesRequest as unknown)[immerable] = true;

export class GetCaseflowNetworkLocationsRequest extends GetAppointmentLocationsRequest implements IReturn<ResponseBase<T>>
{
    public latLong: string;
    public postCode: string;
    public skip: number;
    public take: number;

    public constructor(init?: Partial<GetCaseflowNetworkLocationsRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCaseflowNetworkLocationsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetCaseflowNetworkLocationsRequest as unknown)[immerable] = true;

export class GetOnlineDistinctAppointmentRequest implements IReturn<AppointmentSearchResponse>
{
    public from?: string;
    public to?: string;
    public appointmentLength: number;
    public locationIds: string[];
    public heldAppointmentIds: number[];
    public serviceId: string;
    public stockId: string;
    public medicalImagingProcedureId?: number;
    public additionalServiceIds: string[];
    public allowPast: boolean;
    public overrideProductServiceId?: string;
    public isFollowUp: boolean;
    public token: string;

    public constructor(init?: Partial<GetOnlineDistinctAppointmentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetOnlineDistinctAppointmentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AppointmentSearchResponse(); }
}
(GetOnlineDistinctAppointmentRequest as unknown)[immerable] = true;

export class BookTempAppointmentRequest implements IReturn<ReserveAppointmentResponse>
{
    public practitionerGuid: string;
    public locationGuid: string;
    public roomId?: number;
    public startDateTime: string;
    public endDateTime: string;
    public stockId: string;
    public medicalImagingProcedureId?: number;
    public heldAppointmentIds: number[];
    public serviceId: string;
    public appointmentType: AppointmentType;

    public constructor(init?: Partial<BookTempAppointmentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BookTempAppointmentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ReserveAppointmentResponse(); }
}
(BookTempAppointmentRequest as unknown)[immerable] = true;

export class OnlineDeleteReservationRequest
{
    public appointmentId: number;

    public constructor(init?: Partial<OnlineDeleteReservationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineDeleteReservationRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(OnlineDeleteReservationRequest as unknown)[immerable] = true;

export class GetSsoSessionInfo implements IReturn<GetSsoSessionInfoResponse>
{

    public constructor(init?: Partial<GetSsoSessionInfo>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSsoSessionInfo'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetSsoSessionInfoResponse(); }
}
(GetSsoSessionInfo as unknown)[immerable] = true;

export class OnlineResetRequest implements IReturn<ResponseBase<boolean>>
{
    public userName: string;
    public recaptcha: string;

    public constructor(init?: Partial<OnlineResetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineResetRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(OnlineResetRequest as unknown)[immerable] = true;

export class OnlineChangePasswordByReset implements IReturn<CurrentUser>
{
    public resetCode: string;
    public newPassword: string;
    public score: number;

    public constructor(init?: Partial<OnlineChangePasswordByReset>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineChangePasswordByReset'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CurrentUser(); }
}
(OnlineChangePasswordByReset as unknown)[immerable] = true;

export class OnlineLogoutRequest implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<OnlineLogoutRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineLogoutRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(OnlineLogoutRequest as unknown)[immerable] = true;

export class OnlineVerifyRequest implements IReturn<ResponseBase<OnlineCustomerDto>>
{
    public code: string;

    public constructor(init?: Partial<OnlineVerifyRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineVerifyRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<OnlineCustomerDto>(); }
}
(OnlineVerifyRequest as unknown)[immerable] = true;

export class OnlineRegisterRequest extends OnlineCustomerDto implements IReturn<ResponseBase<OnlineRegisterResponse>>
{
    public newPassword: string;
    public passwordScore: number;
    public givenConsent: boolean;
    public recaptcha: string;
    public verifiedRegistrationToken: string;
    public bookingDraft: string;

    public constructor(init?: Partial<OnlineRegisterRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineRegisterRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<OnlineRegisterResponse>(); }
}
(OnlineRegisterRequest as unknown)[immerable] = true;

export class OnlineRegisterValidationRequest implements IReturn<ResponseBase<OnlineRegisterValidationResponse>>
{
    public email: string;
    public mobileNumber: string;
    public businessId?: number;
    public verifiedRegistrationToken: string;

    public constructor(init?: Partial<OnlineRegisterValidationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineRegisterValidationRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<OnlineRegisterValidationResponse>(); }
}
(OnlineRegisterValidationRequest as unknown)[immerable] = true;

// @Route("/online/files/bykey")
// @Route("/online/files/bykey/{Key}")
export class OnlineFileByKeyRequest implements IReturn<HttpResult>
{
    public key: string;

    public constructor(init?: Partial<OnlineFileByKeyRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineFileByKeyRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new HttpResult(); }
}
(OnlineFileByKeyRequest as unknown)[immerable] = true;

// @Route("/online/files/bypath/{Path}")
export class OnlineFileByPathRequest implements IReturn<HttpResult>
{
    public path: string;

    public constructor(init?: Partial<OnlineFileByPathRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineFileByPathRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new HttpResult(); }
}
(OnlineFileByPathRequest as unknown)[immerable] = true;

export class OnlineContentByKeyRequest implements IReturn<ResponseBase<string>>
{
    public key: string;

    public constructor(init?: Partial<OnlineContentByKeyRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineContentByKeyRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<string>(); }
}
(OnlineContentByKeyRequest as unknown)[immerable] = true;

export class AppointmentPaymentDetailsRequest implements IReturn<ResponseEnhancerBase<OnlinePaymentDetailsResponse>>
{
    public appointmentId: number;
    public totalPrice: number;

    public constructor(init?: Partial<AppointmentPaymentDetailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AppointmentPaymentDetailsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseEnhancerBase<OnlinePaymentDetailsResponse>(); }
}
(AppointmentPaymentDetailsRequest as unknown)[immerable] = true;

export class OnlinePatientFormRequest implements IReturn<ResponseBase<OnlinePatientFormResponse>>
{
    public id: string;

    public constructor(init?: Partial<OnlinePatientFormRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlinePatientFormRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<OnlinePatientFormResponse>(); }
}
(OnlinePatientFormRequest as unknown)[immerable] = true;

export class OnlinePatientFormSubmit implements IReturn<ResponseBase<boolean>>
{
    public id: string;
    public reportData: string;
    public isDraft: boolean;
    public updates: Update[];

    public constructor(init?: Partial<OnlinePatientFormSubmit>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlinePatientFormSubmit'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(OnlinePatientFormSubmit as unknown)[immerable] = true;

// @Route("/online/public/tempfile/{Id}", "POST")
export class OnlinePublicUploadTempFile implements IReturn<ResponseBase<OnlineUploadTempFileResponse>>
{
    public id: string;

    public constructor(init?: Partial<OnlinePublicUploadTempFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlinePublicUploadTempFile'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<OnlineUploadTempFileResponse>(); }
}
(OnlinePublicUploadTempFile as unknown)[immerable] = true;

// @Route("/online/public/tempfile/{Id}/{FileName}", "DELETE")
export class OnlinePublicRemoveTempFile
{
    public id: string;
    public fileName: string;

    public constructor(init?: Partial<OnlinePublicRemoveTempFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlinePublicRemoveTempFile'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() {}
}
(OnlinePublicRemoveTempFile as unknown)[immerable] = true;

export class GetOnlineWaitingListReservedRequest implements IReturn<ResponseBase<OnlineWaitingListReservationConfirmResponse>>
{
    public waitingListGlobalId: string;

    public constructor(init?: Partial<GetOnlineWaitingListReservedRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetOnlineWaitingListReservedRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<OnlineWaitingListReservationConfirmResponse>(); }
}
(GetOnlineWaitingListReservedRequest as unknown)[immerable] = true;

export class ActionWaitingListReserveRequest implements IReturn<ResponseBase<boolean>>
{
    public waitingListGlobalId: string;
    public waitingListStatus: WaitingListStatus;
    public subStatus: WaitingListSubStatus;
    public notificationType: WaitingListNotificationType;
    public pauseUntilDateTime?: string;
    public takePaymentRequest?: TakePaymentRequest;
    public paymentType: number;
    public packageId?: string;
    public discountCodeId?: string;

    public constructor(init?: Partial<ActionWaitingListReserveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ActionWaitingListReserveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ActionWaitingListReserveRequest as unknown)[immerable] = true;

export class OnlineSiteRequest implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<OnlineSiteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineSiteRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(OnlineSiteRequest as unknown)[immerable] = true;

export class GetChasedPaymentRequest implements IReturn<ResponseBase<ChasedPaymentDTO>>
{
    public id: string;

    public constructor(init?: Partial<GetChasedPaymentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetChasedPaymentRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ChasedPaymentDTO>(); }
}
(GetChasedPaymentRequest as unknown)[immerable] = true;

export class GetSquareCustomerDetailsRequest implements IReturn<ResponseBase<GetSquareCustomerDetailsResponse>>
{
    public customerId: number;

    public constructor(init?: Partial<GetSquareCustomerDetailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSquareCustomerDetailsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GetSquareCustomerDetailsResponse>(); }
}
(GetSquareCustomerDetailsRequest as unknown)[immerable] = true;

export class PayChasedPaymentRequest implements IReturn<ResponseBase<T>>
{
    public chaseSlug: string;
    public saveCard: boolean;
    public cardDetails: CardDetails;
    public takePaymentRequest: TakePaymentRequest;

    public constructor(init?: Partial<PayChasedPaymentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PayChasedPaymentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(PayChasedPaymentRequest as unknown)[immerable] = true;

export class IsTwoFactorAuthRequired implements IReturn<boolean>
{
    public token: string;

    public constructor(init?: Partial<IsTwoFactorAuthRequired>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'IsTwoFactorAuthRequired'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return false; }
}
(IsTwoFactorAuthRequired as unknown)[immerable] = true;

export class OnlineAutoLoginCodeRequest implements IReturn<boolean>
{
    public token: string;

    public constructor(init?: Partial<OnlineAutoLoginCodeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineAutoLoginCodeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return false; }
}
(OnlineAutoLoginCodeRequest as unknown)[immerable] = true;

export class VerifySsoRegistrationRequest implements IReturn<CurrentUser>
{
    public email: string;

    public constructor(init?: Partial<VerifySsoRegistrationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VerifySsoRegistrationRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CurrentUser(); }
}
(VerifySsoRegistrationRequest as unknown)[immerable] = true;

export class OnlineAutoLoginVerifyCodeRequest implements IReturn<OnlineAutoLoginVerifyCodeResponse>
{
    public token: string;
    public accessCode: string;
    public password: string;

    public constructor(init?: Partial<OnlineAutoLoginVerifyCodeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineAutoLoginVerifyCodeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new OnlineAutoLoginVerifyCodeResponse(); }
}
(OnlineAutoLoginVerifyCodeRequest as unknown)[immerable] = true;

export class OnlineRequestAccessCodeRequest implements IReturn<boolean>
{
    public email: string;
    public phoneNumber: string;
    public returnUrl: string;
    public recaptcha: string;
    public bookingDraft: string;

    public constructor(init?: Partial<OnlineRequestAccessCodeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineRequestAccessCodeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return false; }
}
(OnlineRequestAccessCodeRequest as unknown)[immerable] = true;

export class ConnectFeatureFlagsRequest implements IReturn<ResponseBase<{ [index:string]: string; }>>
{

    public constructor(init?: Partial<ConnectFeatureFlagsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ConnectFeatureFlagsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<{ [index:string]: string; }>(); }
}
(ConnectFeatureFlagsRequest as unknown)[immerable] = true;

// @Route("/booking-link/validate", "GET")
export class ValidateBookingLinkRequest implements IReturn<ResponseBase<ValidateBookingLinkResponse>>
{
    public token: string;

    public constructor(init?: Partial<ValidateBookingLinkRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateBookingLinkRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ValidateBookingLinkResponse>(); }
}
(ValidateBookingLinkRequest as unknown)[immerable] = true;

// @Route("/booking-link/confirm-card", "POST")
export class ConfirmCardFromBookingLinkRequest implements IReturn<ResponseBase<ConfirmCardFromBookingLinkResponse>>
{
    public token: string;

    public constructor(init?: Partial<ConfirmCardFromBookingLinkRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ConfirmCardFromBookingLinkRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ConfirmCardFromBookingLinkResponse>(); }
}
(ConfirmCardFromBookingLinkRequest as unknown)[immerable] = true;

// @Route("/booking-link/confirm-appointment", "PUT")
export class ConfirmAppointmentFromBookingLinkRequest extends AppointmentConfirmRequest implements IReturn<ResponseBase<AppointmentSummary>>
{

    public constructor(init?: Partial<ConfirmAppointmentFromBookingLinkRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ConfirmAppointmentFromBookingLinkRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<AppointmentSummary>(); }
}
(ConfirmAppointmentFromBookingLinkRequest as unknown)[immerable] = true;

export class OnlineStripeChangeCardRequest implements IReturn<ResponseBase<ChangeCardResponse>>
{
    public paymentMethodId: string;
    public insuranceConsentGiven: boolean;

    public constructor(init?: Partial<OnlineStripeChangeCardRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineStripeChangeCardRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<ChangeCardResponse>(); }
}
(OnlineStripeChangeCardRequest as unknown)[immerable] = true;

// @Route("/booking-link/change-stripe-card", "PUT")
export class StripeCardChangeFromBookingLinkRequest extends OnlineStripeChangeCardRequest implements IReturn<ResponseBase<ChangeCardResponse>>
{
    public token: string;

    public constructor(init?: Partial<StripeCardChangeFromBookingLinkRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'StripeCardChangeFromBookingLinkRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<ChangeCardResponse>(); }
}
(StripeCardChangeFromBookingLinkRequest as unknown)[immerable] = true;

export class UsedLicenseRequest implements IReturn<ResponseBase<number>>
{

    public constructor(init?: Partial<UsedLicenseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UsedLicenseRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<number>(); }
}
(UsedLicenseRequest as unknown)[immerable] = true;

export class SeatEntitlementRequest implements IReturn<ResponseBase<SeatEntitlementResponse>>
{

    public constructor(init?: Partial<SeatEntitlementRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SeatEntitlementRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<SeatEntitlementResponse>(); }
}
(SeatEntitlementRequest as unknown)[immerable] = true;

export class MsInvoicesRequest implements IReturn<ResponseBase<MsInvoiceResponse>>
{
    public skip: number;
    public take: number;

    public constructor(init?: Partial<MsInvoicesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MsInvoicesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<MsInvoiceResponse>(); }
}
(MsInvoicesRequest as unknown)[immerable] = true;

export class MsInvoiceRequest implements IReturn<ResponseBase<MsInvoiceResponse>>
{
    public invoiceId: number;

    public constructor(init?: Partial<MsInvoiceRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MsInvoiceRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<MsInvoiceResponse>(); }
}
(MsInvoiceRequest as unknown)[immerable] = true;

export class CurrentLicenceQuoteRequest implements IReturn<ResponseBase<Tm3License>>
{

    public constructor(init?: Partial<CurrentLicenceQuoteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CurrentLicenceQuoteRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<Tm3License>(); }
}
(CurrentLicenceQuoteRequest as unknown)[immerable] = true;

export class MsClientResponse implements IReturn<ResponseBase<MsClientResponse>>
{
    public reference: string;
    public forename: string;
    public title: string;
    public surname: string;
    public email: string;
    public homeTelephone: string;
    public addressLine1: string;
    public addressLine2: string;
    public addressLine3: string;
    public addressLine4: string;
    public postCode: string;
    public invoiceAddressLine1: string;
    public invoiceAddressLine2: string;
    public invoiceAddressLine3: string;
    public invoiceAddressLine4: string;
    public invoicePostCode: string;
    public accountHolders: MsContact[];
    public accountEmails: MsContact[];
    public supportEmails: MsContact[];
    public bzAccountManager: string;
    public bzAccountManagerEmail: string;
    public bzAccountManagerTelephone: string;
    public subscriptionMonthly: number;
    public subscriptionAnnual: number;
    public returnEmail: string;
    public useSMSCredits: boolean;
    public useSystemCredits: boolean;
    public locationID: number;

    public constructor(init?: Partial<MsClientResponse>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MsClientResponse'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<MsClientResponse>(); }
}
(MsClientResponse as unknown)[immerable] = true;

export class MsClientRequest implements IReturn<ResponseBase<MsClientResponse>>
{

    public constructor(init?: Partial<MsClientRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MsClientRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<MsClientResponse>(); }
}
(MsClientRequest as unknown)[immerable] = true;

export class MsLicenceEntitlementsRequest implements IReturn<ResponseBase<MsLicenceEntitlementsResponse>>
{

    public constructor(init?: Partial<MsLicenceEntitlementsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MsLicenceEntitlementsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<MsLicenceEntitlementsResponse>(); }
}
(MsLicenceEntitlementsRequest as unknown)[immerable] = true;

export class GetClientPricing implements IReturn<ResponseBase<GetClientPricingResponse>>
{

    public constructor(init?: Partial<GetClientPricing>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetClientPricing'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GetClientPricingResponse>(); }
}
(GetClientPricing as unknown)[immerable] = true;

// @Route("/mothership/licence-entitlements/admin", "POST")
export class MsLicenceEntitlementsAdminUpdateRequest implements IReturn<ResponseBase<MsLicenceEntitlementsResponse>>
{
    public clientId: number;
    public entitlements: MsLicenceEntitlementsResponse;

    public constructor(init?: Partial<MsLicenceEntitlementsAdminUpdateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MsLicenceEntitlementsAdminUpdateRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<MsLicenceEntitlementsResponse>(); }
}
(MsLicenceEntitlementsAdminUpdateRequest as unknown)[immerable] = true;

export class ConfirmClientSignUp implements IReturn<ResponseBase<ConfirmClientSignUpResponse>>
{
    public noOfPractitioners: number;
    public paymentMethodId: string;
    public paymentMethod: PaymentMethod;

    public constructor(init?: Partial<ConfirmClientSignUp>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ConfirmClientSignUp'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ConfirmClientSignUpResponse>(); }
}
(ConfirmClientSignUp as unknown)[immerable] = true;

export class ConfirmClickPlusSignUp implements IReturn<ResponseBase<ConfirmClientSignUpResponse>>
{
    public paymentMethodId: string;
    public paymentMethod: PaymentMethod;

    public constructor(init?: Partial<ConfirmClickPlusSignUp>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ConfirmClickPlusSignUp'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ConfirmClientSignUpResponse>(); }
}
(ConfirmClickPlusSignUp as unknown)[immerable] = true;

export class GetClientPaymentDetailsRequest implements IReturn<ResponseBase<GetClientPaymentDetailsResponse>>
{

    public constructor(init?: Partial<GetClientPaymentDetailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetClientPaymentDetailsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GetClientPaymentDetailsResponse>(); }
}
(GetClientPaymentDetailsRequest as unknown)[immerable] = true;

export class SaveClientPaymentDetailsRequest implements IReturn<ResponseBase<SaveClientPaymentDetailsResponse>>
{
    public paymentMethodId: string;
    public paymentMethod: PaymentMethod;
    public useForFutureSubscriptions: boolean;

    public constructor(init?: Partial<SaveClientPaymentDetailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveClientPaymentDetailsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SaveClientPaymentDetailsResponse>(); }
}
(SaveClientPaymentDetailsRequest as unknown)[immerable] = true;

export class ClickPPCDetailsRequest implements IReturn<ResponseBase<ClickPPCDetailsResponse>>
{

    public constructor(init?: Partial<ClickPPCDetailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickPPCDetailsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ClickPPCDetailsResponse>(); }
}
(ClickPPCDetailsRequest as unknown)[immerable] = true;

export class ClickUpgradeDetailsRequest implements IReturn<ResponseBase<ClickUpgradeDetailsResponse>>
{

    public constructor(init?: Partial<ClickUpgradeDetailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickUpgradeDetailsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ClickUpgradeDetailsResponse>(); }
}
(ClickUpgradeDetailsRequest as unknown)[immerable] = true;

export class ClickTrialRequest implements IReturn<ResponseBase<ClickTrialResponse>>
{

    public constructor(init?: Partial<ClickTrialRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickTrialRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClickTrialResponse>(); }
}
(ClickTrialRequest as unknown)[immerable] = true;

export class ClickDowngradeRequest implements IReturn<ResponseBase<ClickDowngradeResponse>>
{

    public constructor(init?: Partial<ClickDowngradeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickDowngradeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClickDowngradeResponse>(); }
}
(ClickDowngradeRequest as unknown)[immerable] = true;

export class ClientDowngradeToSingleLicenseRequest implements IReturn<ResponseBase<ClientDowngradeToSingleLicenseResponse>>
{
    public id: number;

    public constructor(init?: Partial<ClientDowngradeToSingleLicenseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClientDowngradeToSingleLicenseRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClientDowngradeToSingleLicenseResponse>(); }
}
(ClientDowngradeToSingleLicenseRequest as unknown)[immerable] = true;

export class ClientNoLongerWantsToCancelRequest implements IReturn<ResponseBase<ClientNoLongerWantsToCancelResponse>>
{

    public constructor(init?: Partial<ClientNoLongerWantsToCancelRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClientNoLongerWantsToCancelRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClientNoLongerWantsToCancelResponse>(); }
}
(ClientNoLongerWantsToCancelRequest as unknown)[immerable] = true;

export class ConfirmClientCancellation implements IReturn<ResponseBase<ConfirmClientCancellationResponse>>
{
    public trialLapsed: boolean;
    public comments: string;

    public constructor(init?: Partial<ConfirmClientCancellation>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ConfirmClientCancellation'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ConfirmClientCancellationResponse>(); }
}
(ConfirmClientCancellation as unknown)[immerable] = true;

export class HasInvalidCardRequest implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<HasInvalidCardRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'HasInvalidCardRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(HasInvalidCardRequest as unknown)[immerable] = true;

export class MSCurrencyRequest implements IReturn<ResponseBase<MSCurrencyResponse>>
{

    public constructor(init?: Partial<MSCurrencyRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MSCurrencyRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<MSCurrencyResponse>(); }
}
(MSCurrencyRequest as unknown)[immerable] = true;

export class MSSubscriptionRequest implements IReturn<ResponseBase<MSSubscriptionResponse>>
{

    public constructor(init?: Partial<MSSubscriptionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MSSubscriptionRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<MSSubscriptionResponse>(); }
}
(MSSubscriptionRequest as unknown)[immerable] = true;

export class CreditAutoTopUpAmountRequest implements IReturn<ResponseBase<CreditAutoTopUpAmountResponse>>
{
    public bundleType: string;
    public number: number;

    public constructor(init?: Partial<CreditAutoTopUpAmountRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreditAutoTopUpAmountRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CreditAutoTopUpAmountResponse>(); }
}
(CreditAutoTopUpAmountRequest as unknown)[immerable] = true;

export class SMSOrderHistoryRequest implements IReturn<ResponseBase<SMSOrderHistoryResponse>>, IHasGuidId
{
    public id: string;

    public constructor(init?: Partial<SMSOrderHistoryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SMSOrderHistoryRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<SMSOrderHistoryResponse>(); }
}
(SMSOrderHistoryRequest as unknown)[immerable] = true;

export class SMSBundlePurchaseRequest implements IReturn<ResponseBase<number>>
{
    public number: number;

    public constructor(init?: Partial<SMSBundlePurchaseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SMSBundlePurchaseRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<number>(); }
}
(SMSBundlePurchaseRequest as unknown)[immerable] = true;

export class SMSBundleOptionsRequest implements IReturn<ResponseBase<SMSBundleOptionsResponse>>
{

    public constructor(init?: Partial<SMSBundleOptionsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SMSBundleOptionsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<SMSBundleOptionsResponse>(); }
}
(SMSBundleOptionsRequest as unknown)[immerable] = true;

export class SystemCreditBundleOptionsRequest implements IReturn<ResponseBase<SystemCreditBundleOptionsResponse>>
{

    public constructor(init?: Partial<SystemCreditBundleOptionsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemCreditBundleOptionsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<SystemCreditBundleOptionsResponse>(); }
}
(SystemCreditBundleOptionsRequest as unknown)[immerable] = true;

export class CreditOrderHistoryRequest implements IReturn<ResponseBase<CreditOrderHistoryResponse>>, IHasGuidId
{
    public id: string;

    public constructor(init?: Partial<CreditOrderHistoryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreditOrderHistoryRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CreditOrderHistoryResponse>(); }
}
(CreditOrderHistoryRequest as unknown)[immerable] = true;

export class CreditBundlePurchaseRequest implements IReturn<ResponseBase<number>>
{
    public number: number;

    public constructor(init?: Partial<CreditBundlePurchaseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreditBundlePurchaseRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<number>(); }
}
(CreditBundlePurchaseRequest as unknown)[immerable] = true;

export class PayMSInvoiceRequest implements IReturn<ResponseBase<boolean>>
{
    public id: number;

    public constructor(init?: Partial<PayMSInvoiceRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PayMSInvoiceRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(PayMSInvoiceRequest as unknown)[immerable] = true;

export class DownloadMSInvoiceRequest implements IReturn<ResponseBase<string>>
{
    public invoiceId: number;

    public constructor(init?: Partial<DownloadMSInvoiceRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadMSInvoiceRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<string>(); }
}
(DownloadMSInvoiceRequest as unknown)[immerable] = true;

export class PayPerClickDetailRequest implements IReturn<ResponseBase<T>>
{
    public skip: number;
    public take: number;
    public includedInAllowance: boolean;
    public isSystemCredit: boolean;

    public constructor(init?: Partial<PayPerClickDetailRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PayPerClickDetailRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(PayPerClickDetailRequest as unknown)[immerable] = true;

export class PayPerClickSMSDetailRequest implements IReturn<ResponseBase<T>>
{
    public itemType?: ItemType;
    public skip: number;
    public take: number;
    public sort: QueryField[];
    public fromDate?: string;
    public toDate?: string;

    public constructor(init?: Partial<PayPerClickSMSDetailRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PayPerClickSMSDetailRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(PayPerClickSMSDetailRequest as unknown)[immerable] = true;

export class PayPerClickStatsRequest implements IReturn<ResponseBase<PayPerClickStatsResponse>>
{

    public constructor(init?: Partial<PayPerClickStatsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PayPerClickStatsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<PayPerClickStatsResponse>(); }
}
(PayPerClickStatsRequest as unknown)[immerable] = true;

export class AccountAccessRestrictionRequest implements IReturn<ResponseBase<AccountAccessRestrictionResponse>>
{

    public constructor(init?: Partial<AccountAccessRestrictionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AccountAccessRestrictionRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<AccountAccessRestrictionResponse>(); }
}
(AccountAccessRestrictionRequest as unknown)[immerable] = true;

export class AddAccountAccessRestrictionRequest implements IReturn<ResponseBase<AccountAccessRestrictionResponse>>
{
    public userId: number;

    public constructor(init?: Partial<AddAccountAccessRestrictionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddAccountAccessRestrictionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AccountAccessRestrictionResponse>(); }
}
(AddAccountAccessRestrictionRequest as unknown)[immerable] = true;

export class DeleteAccountAccessRestrictionRequest implements IReturn<ResponseBase<boolean>>
{
    public userId: number;

    public constructor(init?: Partial<DeleteAccountAccessRestrictionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteAccountAccessRestrictionRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(DeleteAccountAccessRestrictionRequest as unknown)[immerable] = true;

export class CanAccessMyAccountRequest implements IReturn<ResponseBase<CanAccessMyAccountResponse>>
{

    public constructor(init?: Partial<CanAccessMyAccountRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CanAccessMyAccountRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CanAccessMyAccountResponse>(); }
}
(CanAccessMyAccountRequest as unknown)[immerable] = true;

export class UnrestrictedUserRequest implements IReturn<ResponseBase<UnrestrictedUserResponse>>
{

    public constructor(init?: Partial<UnrestrictedUserRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UnrestrictedUserRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<UnrestrictedUserResponse>(); }
}
(UnrestrictedUserRequest as unknown)[immerable] = true;

export class AddUnrestrictedUserRequest implements IReturn<ResponseBase<UnrestrictedUserResponse>>
{
    public userId: number;

    public constructor(init?: Partial<AddUnrestrictedUserRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddUnrestrictedUserRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<UnrestrictedUserResponse>(); }
}
(AddUnrestrictedUserRequest as unknown)[immerable] = true;

export class DeleteUnrestrictedUserRequest implements IReturn<ResponseBase<boolean>>
{
    public userId: number;

    public constructor(init?: Partial<DeleteUnrestrictedUserRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteUnrestrictedUserRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(DeleteUnrestrictedUserRequest as unknown)[immerable] = true;

// @Route("/reports/diary/appointment-analysis")
export class DiaryAnalysisReportRequest extends BaseParamsForAllReports implements IReturn<ResponseBase<DiaryAnalysisResponse>>
{
    public diaryEventCategories: string[];
    public appointmentStatuses: number[];
    public bookingMethods: string[];
    public rooms: number[];
    public ageCategory: string[];
    public cancellationReasons: string[];

    public constructor(init?: Partial<DiaryAnalysisReportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'DiaryAnalysisReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<DiaryAnalysisResponse>(); }
}
(DiaryAnalysisReportRequest as unknown)[immerable] = true;

export class NonReturningReportRequest extends BaseParamsForAllReports implements IReturn<ResponseBase<T>>
{
    public weekCount: number;

    public constructor(init?: Partial<NonReturningReportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'NonReturningReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(NonReturningReportRequest as unknown)[immerable] = true;

export class TrafficReportRequest extends BaseParamsForAllReports implements IReturn<ResponseBase<T>>
{
    public instructor: number[];
    public paymentMethods: string[];
    public orderBy: TrafficReportOrdering;

    public constructor(init?: Partial<TrafficReportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'TrafficReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(TrafficReportRequest as unknown)[immerable] = true;

export class AutopayReportRequest extends BaseParamsForAllReports implements IReturn<ResponseBase<T>>
{
    public status: SubscriptionStatus[];
    public cardsExpiringSoon: boolean;
    public upcomingRenewals: boolean;

    public constructor(init?: Partial<AutopayReportRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'AutopayReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(AutopayReportRequest as unknown)[immerable] = true;

// @Route("/stripe/redirect", "GET")
export class StripeRedirectRequest
{
    public state: string;
    public code: string;
    public error: string;
    public error_Description: string;

    public constructor(init?: Partial<StripeRedirectRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StripeRedirectRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}
(StripeRedirectRequest as unknown)[immerable] = true;

export class StripeStateRequest
{
    public state: string;

    public constructor(init?: Partial<StripeStateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StripeStateRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(StripeStateRequest as unknown)[immerable] = true;

export class StripeIntegrationRequest implements IReturn<StripeOAuthResponse>
{
    public state?: string;

    public constructor(init?: Partial<StripeIntegrationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StripeIntegrationRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StripeOAuthResponse(); }
}
(StripeIntegrationRequest as unknown)[immerable] = true;

export class GetSettingsRequest implements IReturn<ResponseBase<GetSettingsResponse>>
{
    public id?: number;
    public businessId?: number;

    public constructor(init?: Partial<GetSettingsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSettingsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GetSettingsResponse>(); }
}
(GetSettingsRequest as unknown)[immerable] = true;

export class PutSettingsRequest extends OnlineSettings implements IReturn<ResponseBase<OnlineSettings>>
{
    // @Ignore()
    public logo: string;

    public constructor(init?: Partial<PutSettingsRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'PutSettingsRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<OnlineSettings>(); }
}
(PutSettingsRequest as unknown)[immerable] = true;

export class GetCategoryAndServicesRequest implements IReturn<ResponseBase<OnlineCategoryResponse>>, IGet
{
    public businessId?: number;

    public constructor(init?: Partial<GetCategoryAndServicesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCategoryAndServicesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<OnlineCategoryResponse>(); }
}
(GetCategoryAndServicesRequest as unknown)[immerable] = true;

export class PutServiceRequest extends OnlineClinicService implements IReturn<ResponseBase<OnlineClinicService>>, IPut
{
    public category?: string;

    public constructor(init?: Partial<PutServiceRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'PutServiceRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<OnlineClinicService>(); }
}
(PutServiceRequest as unknown)[immerable] = true;

export class PutCategoryRequest extends OnlineServiceCategory implements IReturn<ResponseBase<OnlineServiceCategory>>, IPut
{

    public constructor(init?: Partial<PutCategoryRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'PutCategoryRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<OnlineServiceCategory>(); }
}
(PutCategoryRequest as unknown)[immerable] = true;

export class GetOnlineSectionRequest implements IReturn<ResponseBase<OnlineSection>>
{

    public constructor(init?: Partial<GetOnlineSectionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetOnlineSectionRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<OnlineSection>(); }
}
(GetOnlineSectionRequest as unknown)[immerable] = true;

export class PutSectionRequest extends OnlineSection implements IReturn<ResponseBase<OnlineSection>>
{

    public constructor(init?: Partial<PutSectionRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'PutSectionRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<OnlineSection>(); }
}
(PutSectionRequest as unknown)[immerable] = true;

export class DeleteSectionRequest implements IReturn<ResponseBase<T>>
{
    public id: number;

    public constructor(init?: Partial<DeleteSectionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteSectionRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(DeleteSectionRequest as unknown)[immerable] = true;

export class PutCategoriesRequest implements IReturn<ResponseBase<OnlineServiceCategory>>, IPut
{
    public categories: PutCategoryRequest[];

    public constructor(init?: Partial<PutCategoriesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PutCategoriesRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<OnlineServiceCategory>(); }
}
(PutCategoriesRequest as unknown)[immerable] = true;

export class DeleteCategoryRequest implements IReturn<ResponseBase<T>>
{
    public id: string;
    public businessId?: number;

    public constructor(init?: Partial<DeleteCategoryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteCategoryRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(DeleteCategoryRequest as unknown)[immerable] = true;

export class PutSectionsRequest extends OnlineSection implements IReturn<ResponseBase<OnlineSection>>
{
    public sections: PutSectionRequest[];

    public constructor(init?: Partial<PutSectionsRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'PutSectionsRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<OnlineSection>(); }
}
(PutSectionsRequest as unknown)[immerable] = true;

export class CanDeleteImageRequest implements IReturn<ResponseBase<CanDeleteImageResponse>>
{
    public filename: string;

    public constructor(init?: Partial<CanDeleteImageRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CanDeleteImageRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CanDeleteImageResponse>(); }
}
(CanDeleteImageRequest as unknown)[immerable] = true;

export class GetBusinessSettingsIdRequest implements IReturn<ResponseBase<BusinessSettingsIdResponse>>
{
    public businessId: number;
    public currentSettingsId: number;

    public constructor(init?: Partial<GetBusinessSettingsIdRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetBusinessSettingsIdRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<BusinessSettingsIdResponse>(); }
}
(GetBusinessSettingsIdRequest as unknown)[immerable] = true;

export class RemoveBusinessSettingsIdRequest implements IReturn<ResponseBase<GetSettingsResponse>>
{
    public businessId: number;

    public constructor(init?: Partial<RemoveBusinessSettingsIdRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RemoveBusinessSettingsIdRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GetSettingsResponse>(); }
}
(RemoveBusinessSettingsIdRequest as unknown)[immerable] = true;

export class SearchAllClassesRequest implements IReturn<ResponseBase<ClassSearchResponse>>
{
    public date?: string;
    public locationGuid: string;
    public practitionerId: number;
    public serviceIds: string[];
    public parentServiceId?: string;

    public constructor(init?: Partial<SearchAllClassesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SearchAllClassesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClassSearchResponse>(); }
}
(SearchAllClassesRequest as unknown)[immerable] = true;

export class FindSimilarTimedClassesRequest implements IReturn<ResponseBase<SimilarClass>>
{
    public classSessionId: number;
    public serviceId: string;

    public constructor(init?: Partial<FindSimilarTimedClassesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FindSimilarTimedClassesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SimilarClass>(); }
}
(FindSimilarTimedClassesRequest as unknown)[immerable] = true;

export class BookTempClassRequest extends BookingClassResponse implements IReturn<ResponseBase<T>>
{
    public isCourse: boolean;
    public classSessionId: number;
    public serviceId: string;
    public attendanceIds: number[];
    public attendeeId?: number;

    public constructor(init?: Partial<BookTempClassRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'BookTempClassRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(BookTempClassRequest as unknown)[immerable] = true;

export class DeleteTempClassBookingRequest implements IReturnVoid
{
    public isCourse: boolean;
    public classAttendanceIds: number[];
    public attendeeId?: number;

    public constructor(init?: Partial<DeleteTempClassBookingRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteTempClassBookingRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() {}
}
(DeleteTempClassBookingRequest as unknown)[immerable] = true;

export class GetAllCoursesFromTypeRequest implements IReturn<ResponseBase<T>>
{
    public classTypeId: number;
    public serviceId: string;

    public constructor(init?: Partial<GetAllCoursesFromTypeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAllCoursesFromTypeRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetAllCoursesFromTypeRequest as unknown)[immerable] = true;

export class BookClassRequest implements IReturn<ResponseBase<T>>
{
    public classSessionId: number;
    public isCourse: boolean;
    public classAttendanceIds: number[];
    public attendeeId?: number;
    public paymentType: PaymentMode;
    public packageId?: string;
    public prePaidId?: number;
    public discountCodeId?: string;
    public takePaymentRequest: TakePaymentRequest;

    public constructor(init?: Partial<BookClassRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BookClassRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(BookClassRequest as unknown)[immerable] = true;

export class CreateConnectAppointmentlessJourneyRequest implements IReturn<ResponseBase<CreateConnectAppointmentlessJourneyResponse>>
{
    public onlineClinicServiceId: string;
    public groupId?: number;
    public customerId?: number;
    public procedureCode: string;
    public medicalImagingProcedureId?: number;
    public formTemplateId?: string;
    public formData: JsonField;
    public journeyStatusId?: string;
    public outcomeReason: string;
    public metadata: JsonField;

    public constructor(init?: Partial<CreateConnectAppointmentlessJourneyRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateConnectAppointmentlessJourneyRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CreateConnectAppointmentlessJourneyResponse>(); }
}
(CreateConnectAppointmentlessJourneyRequest as unknown)[immerable] = true;

/** @description Used to get a JWT Token and Refresh Token. */
// @Route("/token")
export class TokenRequest implements IReturn<ResponseBase<ConvertSessionToTokenResponse>>
{

    public constructor(init?: Partial<TokenRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TokenRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ConvertSessionToTokenResponse>(); }
}
(TokenRequest as unknown)[immerable] = true;

// @Route("/zoom/publicAuthorisationRedirect")
export class PublicAuthorisationRedirectRequest implements IReturn<HttpResult>
{
    public code: string;
    public stateId: string;

    public constructor(init?: Partial<PublicAuthorisationRedirectRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PublicAuthorisationRedirectRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new HttpResult(); }
}
(PublicAuthorisationRedirectRequest as unknown)[immerable] = true;

// @Route("/zoom", "POST")
export class PublicLinkToZoomRequest implements IReturn<ZoomLinkToTM3Response>
{
    public clientId: string;

    public constructor(init?: Partial<PublicLinkToZoomRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PublicLinkToZoomRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ZoomLinkToTM3Response(); }
}
(PublicLinkToZoomRequest as unknown)[immerable] = true;

// @Route("/zoom/authorisationRedirect")
export class AuthorisationRedirectRequest implements IReturn<HttpResult>
{
    public code: string;
    public stateId: string;

    public constructor(init?: Partial<AuthorisationRedirectRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AuthorisationRedirectRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new HttpResult(); }
}
(AuthorisationRedirectRequest as unknown)[immerable] = true;

export class SaveZoomStateRequest implements IReturn<ResponseBase<ZoomSaveStateResponse>>
{

    public constructor(init?: Partial<SaveZoomStateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveZoomStateRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ZoomSaveStateResponse>(); }
}
(SaveZoomStateRequest as unknown)[immerable] = true;

export class CustomRedirectRequest
{
    public redirectUri: string;

    public constructor(init?: Partial<CustomRedirectRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomRedirectRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(CustomRedirectRequest as unknown)[immerable] = true;

export class GetZoomUsersRequest implements IReturn<ResponseBase<ZoomUser>>
{

    public constructor(init?: Partial<GetZoomUsersRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetZoomUsersRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ZoomUser>(); }
}
(GetZoomUsersRequest as unknown)[immerable] = true;

export class IsZoomIntegrationConfiguredRequest implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<IsZoomIntegrationConfiguredRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'IsZoomIntegrationConfiguredRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(IsZoomIntegrationConfiguredRequest as unknown)[immerable] = true;

export class UnlinkTm3FromZoomRequest implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<UnlinkTm3FromZoomRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UnlinkTm3FromZoomRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(UnlinkTm3FromZoomRequest as unknown)[immerable] = true;

export class AreZoomTokensValid implements IReturn<ResponseBase<ZoomReauthResponse>>
{

    public constructor(init?: Partial<AreZoomTokensValid>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AreZoomTokensValid'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ZoomReauthResponse>(); }
}
(AreZoomTokensValid as unknown)[immerable] = true;

export class WaitingListsRequest implements IReturn<ResponseBase<WaitingListResponse>>, ILocationIds
{
    public patientId?: number;
    public locationIds: number[];
    public requestLocationIds: number[];

    public constructor(init?: Partial<WaitingListsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WaitingListsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<WaitingListResponse>(); }
}
(WaitingListsRequest as unknown)[immerable] = true;

export class WaitingListById implements IReturn<ResponseBase<WaitingListByIdResponse>>
{
    public id: number;

    public constructor(init?: Partial<WaitingListById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WaitingListById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<WaitingListByIdResponse>(); }
}
(WaitingListById as unknown)[immerable] = true;

export class WaitingListStateHistoryRequest implements IReturn<ResponseBase<WaitingListStateHistoryResponse[]>>
{
    public id: number;
    public customerId: number;

    public constructor(init?: Partial<WaitingListStateHistoryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WaitingListStateHistoryRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<WaitingListStateHistoryResponse[]>(); }
}
(WaitingListStateHistoryRequest as unknown)[immerable] = true;

// @Route("/teams/all", "POST")
export class AllTeamRequest implements IReturn<ResponseBase<TeamResponse>>
{
    public teamIds: string[];
    public requestTeamIds: string[];
    public skip?: number;
    public take?: number;
    public sort: QueryField[];

    public constructor(init?: Partial<AllTeamRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AllTeamRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TeamResponse>(); }
}
(AllTeamRequest as unknown)[immerable] = true;

// @Route("/teams/{Id}", "GET")
export class TeamGetRequest implements IReturn<ResponseBase<TeamResponse>>
{
    public id: string;

    public constructor(init?: Partial<TeamGetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TeamGetRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<TeamResponse>(); }
}
(TeamGetRequest as unknown)[immerable] = true;

// @Route("/teams/save", "POST")
export class TeamSaveRequest implements IReturn<ResponseBase<TeamResponse>>
{
    public id: string;
    public name: string;
    public assignmentCode: string;
    public email: string;
    public defaultTeamLeader?: string;
    public users: TeamUserDto[];
    public isCurrent: boolean;

    public constructor(init?: Partial<TeamSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TeamSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TeamResponse>(); }
}
(TeamSaveRequest as unknown)[immerable] = true;

export class AllowedIPRequest implements IReturn<ResponseBase<AllowedIPResponse>>
{

    public constructor(init?: Partial<AllowedIPRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AllowedIPRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<AllowedIPResponse>(); }
}
(AllowedIPRequest as unknown)[immerable] = true;

export class AddAllowedIPRequest implements IReturn<ResponseBase<AllowedIPResponse>>
{
    public address: string;

    public constructor(init?: Partial<AddAllowedIPRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddAllowedIPRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AllowedIPResponse>(); }
}
(AddAllowedIPRequest as unknown)[immerable] = true;

export class DeleteAllowedIPRequest implements IReturn<ResponseBase<boolean>>
{
    public id: number;

    public constructor(init?: Partial<DeleteAllowedIPRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteAllowedIPRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(DeleteAllowedIPRequest as unknown)[immerable] = true;

// @Route("/sentry/{Action}/{ClientId}")
export class SentryApmRequest implements IReturn<ResponseBase<T>>
{
    public clientId: number;
    public action: SentryApmAction;

    public constructor(init?: Partial<SentryApmRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SentryApmRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(SentryApmRequest as unknown)[immerable] = true;

// @Route("/secure-document-shares/documents/{DocumentListingId}/people", "GET")
export class SecureDocumentSharePeopleRequest implements IReturn<ResponseBase<SecureDocumentSharePeopleResponse>>
{
    public documentListingId: string;

    public constructor(init?: Partial<SecureDocumentSharePeopleRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SecureDocumentSharePeopleRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<SecureDocumentSharePeopleResponse>(); }
}
(SecureDocumentSharePeopleRequest as unknown)[immerable] = true;

// @Route("/secure-document-shares/patient-documents/{CustomerId}", "GET")
export class SecureDocumentSharePatientDocumentsRequest implements IReturn<ResponseBase<SecureDocumentSharePatientDocumentsResponse>>
{
    public customerId: number;

    public constructor(init?: Partial<SecureDocumentSharePatientDocumentsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SecureDocumentSharePatientDocumentsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<SecureDocumentSharePatientDocumentsResponse>(); }
}
(SecureDocumentSharePatientDocumentsRequest as unknown)[immerable] = true;

// @Route("/secure-document-shares/edit-status", "GET")
export class SecureDocumentShareEditStatusRequest implements IReturn<ResponseBase<SecureDocumentShareEditStatusResponse>>
{
    public path: string;

    public constructor(init?: Partial<SecureDocumentShareEditStatusRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SecureDocumentShareEditStatusRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<SecureDocumentShareEditStatusResponse>(); }
}
(SecureDocumentShareEditStatusRequest as unknown)[immerable] = true;

// @Route("/secure-document-shares", "POST")
export class CreateSecureDocumentShareRequest implements IReturn<ResponseBase<CreateSecureDocumentShareResponse>>
{
    public documentListingId: string;
    public objectType: string;
    public objectId: string;
    public customerId?: number;
    public workflowId?: number;
    public recipients: CreateSecureDocumentShareRecipientRequest[];

    public constructor(init?: Partial<CreateSecureDocumentShareRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateSecureDocumentShareRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CreateSecureDocumentShareResponse>(); }
}
(CreateSecureDocumentShareRequest as unknown)[immerable] = true;

// @Route("/secure-document-shares/edit-audit", "POST")
export class AuditSecureDocumentShareEditRequest implements IReturn<ResponseBase<AuditSecureDocumentShareEditResponse>>
{
    public documentListingId: string;
    public action: SecureDocumentShareEditAuditAction;
    public copiedPath: string;

    public constructor(init?: Partial<AuditSecureDocumentShareEditRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AuditSecureDocumentShareEditRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AuditSecureDocumentShareEditResponse>(); }
}
(AuditSecureDocumentShareEditRequest as unknown)[immerable] = true;

// @Route("/secure-document-shares/recipients/{RecipientId}", "DELETE")
export class RevokeSecureDocumentShareRecipientRequest implements IReturn<ResponseBase<SecureDocumentShareRevocationResponse>>
{
    public recipientId: string;

    public constructor(init?: Partial<RevokeSecureDocumentShareRecipientRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RevokeSecureDocumentShareRecipientRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<SecureDocumentShareRevocationResponse>(); }
}
(RevokeSecureDocumentShareRecipientRequest as unknown)[immerable] = true;

// @Route("/secure-document-shares/documents/{DocumentListingId}", "DELETE")
export class RevokeSecureDocumentShareDocumentRequest implements IReturn<ResponseBase<SecureDocumentShareRevocationResponse>>
{
    public documentListingId: string;

    public constructor(init?: Partial<RevokeSecureDocumentShareDocumentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RevokeSecureDocumentShareDocumentRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<SecureDocumentShareRevocationResponse>(); }
}
(RevokeSecureDocumentShareDocumentRequest as unknown)[immerable] = true;

// @Route("/secure-document-shares/access/{Token}", "GET")
export class SecureDocumentShareAccessChallengeRequest implements IReturn<ResponseBase<SecureDocumentShareAccessChallengeResponse>>
{
    public token: string;

    public constructor(init?: Partial<SecureDocumentShareAccessChallengeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SecureDocumentShareAccessChallengeRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<SecureDocumentShareAccessChallengeResponse>(); }
}
(SecureDocumentShareAccessChallengeRequest as unknown)[immerable] = true;

// @Route("/secure-document-shares/access/{Token}/verify-date-of-birth", "POST")
export class VerifySecureDocumentShareDateOfBirthRequest implements IReturn<ResponseBase<SecureDocumentShareVerificationResponse>>
{
    public token: string;
    public dateOfBirth: string;

    public constructor(init?: Partial<VerifySecureDocumentShareDateOfBirthRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VerifySecureDocumentShareDateOfBirthRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SecureDocumentShareVerificationResponse>(); }
}
(VerifySecureDocumentShareDateOfBirthRequest as unknown)[immerable] = true;

// @Route("/secure-document-shares/access/{Token}/verify-pin", "POST")
export class VerifySecureDocumentSharePinRequest implements IReturn<ResponseBase<SecureDocumentShareVerificationResponse>>
{
    public token: string;
    public pin: string;

    public constructor(init?: Partial<VerifySecureDocumentSharePinRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VerifySecureDocumentSharePinRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SecureDocumentShareVerificationResponse>(); }
}
(VerifySecureDocumentSharePinRequest as unknown)[immerable] = true;

// @Route("/secure-document-shares/access/{Token}/request-sms-code", "POST")
export class RequestSecureDocumentShareSmsCodeRequest implements IReturn<ResponseBase<RequestSecureDocumentShareSmsCodeResponse>>
{
    public token: string;
    public useFallback: boolean;

    public constructor(init?: Partial<RequestSecureDocumentShareSmsCodeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RequestSecureDocumentShareSmsCodeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<RequestSecureDocumentShareSmsCodeResponse>(); }
}
(RequestSecureDocumentShareSmsCodeRequest as unknown)[immerable] = true;

// @Route("/secure-document-shares/access/{Token}/verify-sms-code", "POST")
export class VerifySecureDocumentShareSmsCodeRequest implements IReturn<ResponseBase<SecureDocumentShareVerificationResponse>>
{
    public token: string;
    public code: string;
    public useFallback: boolean;

    public constructor(init?: Partial<VerifySecureDocumentShareSmsCodeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'VerifySecureDocumentShareSmsCodeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SecureDocumentShareVerificationResponse>(); }
}
(VerifySecureDocumentShareSmsCodeRequest as unknown)[immerable] = true;

// @Route("/secure-document-shares/access/{Token}/request-new-link", "POST")
export class RequestNewSecureDocumentShareLinkRequest implements IReturn<ResponseBase<RequestNewSecureDocumentShareLinkResponse>>
{
    public token: string;

    public constructor(init?: Partial<RequestNewSecureDocumentShareLinkRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RequestNewSecureDocumentShareLinkRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<RequestNewSecureDocumentShareLinkResponse>(); }
}
(RequestNewSecureDocumentShareLinkRequest as unknown)[immerable] = true;

// @Route("/secure-document-shares/access/{Token}/document/download", "GET")
export class SecureDocumentShareDocumentDownloadRequest implements IReturn<ResponseBase<SecureDocumentShareDocumentDownloadResponse>>
{
    public token: string;

    public constructor(init?: Partial<SecureDocumentShareDocumentDownloadRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SecureDocumentShareDocumentDownloadRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<SecureDocumentShareDocumentDownloadResponse>(); }
}
(SecureDocumentShareDocumentDownloadRequest as unknown)[immerable] = true;

// @Route("/secure-document-shares/access/{Token}/document/view", "HEAD, GET")
export class SecureDocumentShareDocumentViewRequest implements IReturn<Object>
{
    public token: string;

    public constructor(init?: Partial<SecureDocumentShareDocumentViewRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SecureDocumentShareDocumentViewRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Object(); }
}
(SecureDocumentShareDocumentViewRequest as unknown)[immerable] = true;

export class EmbeddableDashboardTokenRequest implements IReturn<ResponseBase<T>>
{
    public id: string;

    public constructor(init?: Partial<EmbeddableDashboardTokenRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EmbeddableDashboardTokenRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(EmbeddableDashboardTokenRequest as unknown)[immerable] = true;

export class GetCustomerGroupTheme implements IReturn<ResponseBase<ThemeResponse>>
{

    public constructor(init?: Partial<GetCustomerGroupTheme>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCustomerGroupTheme'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ThemeResponse>(); }
}
(GetCustomerGroupTheme as unknown)[immerable] = true;

export class SaveCustomerGroupTheme extends ThemeResponse implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<SaveCustomerGroupTheme>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveCustomerGroupTheme'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(SaveCustomerGroupTheme as unknown)[immerable] = true;

export class CustomerGroupHasLogo implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<CustomerGroupHasLogo>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerGroupHasLogo'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CustomerGroupHasLogo as unknown)[immerable] = true;

// @Route("/referralportal/customergroup/logo", "GET")
export class GetCustomerGroupLogo implements IReturn<HttpResult>
{

    public constructor(init?: Partial<GetCustomerGroupLogo>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCustomerGroupLogo'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new HttpResult(); }
}
(GetCustomerGroupLogo as unknown)[immerable] = true;

export class SaveCustomerGroupLogo implements IReturn<ResponseBase<boolean>>
{
    public logo: string;
    public type: string;

    public constructor(init?: Partial<SaveCustomerGroupLogo>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveCustomerGroupLogo'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(SaveCustomerGroupLogo as unknown)[immerable] = true;

export class GetAllReferralPortalAdvancedSearchFiltersRequest implements IReturn<ResponseBase<GetAllAdvancedSearchFiltersResponse>>
{
    public searchModule?: SearchModuleEntityType;

    public constructor(init?: Partial<GetAllReferralPortalAdvancedSearchFiltersRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAllReferralPortalAdvancedSearchFiltersRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<GetAllAdvancedSearchFiltersResponse>(); }
}
(GetAllReferralPortalAdvancedSearchFiltersRequest as unknown)[immerable] = true;

// @Route("/portal/appointments", "POST")
// @ApiResponse(Description="Success", StatusCode=200)
// @ApiResponse(Description="Validation Exception", StatusCode=400)
export class ReferralPortalAppointmentRequest implements IReturn<ResponseBase<ReferralPortalAppointmentSearchResult>>
{
    /** @description Available from /portal/products */
    // @ApiMember(Description="Available from /portal/products", ParameterType="model")
    public serviceIds: string[];

    /** @description Available from /portal/locations */
    // @ApiMember(Description="Available from /portal/locations", ParameterType="model")
    public locationId?: string;

    public from?: string;
    public to?: string;
    /** @description Filter by the service provider's gender, leave blank to skip */
    // @ApiMember(Description="Filter by the service provider's gender, leave blank to skip", ParameterType="model")
    public gender: string;

    /** @description Required for existing referrals only */
    // @ApiMember(Description="Required for existing referrals only", ParameterType="model")
    public workflowId?: number;

    /** @description Aggregate appointments by a specified field */
    // @ApiMember(DataType="[Enum] - NONE | DATE", Description="Aggregate appointments by a specified field", ParameterType="model")
    public aggregateBy: EReferralPortalAppointmentAggregate;

    public constructor(init?: Partial<ReferralPortalAppointmentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalAppointmentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ReferralPortalAppointmentSearchResult>(); }
}
(ReferralPortalAppointmentRequest as unknown)[immerable] = true;

// @Route("/portal/appointment/reserve", "POST")
export class ReferralPortalReserveAppointmentRequest implements IReturn<ResponseBase<ReferralPortalReserveAppointmentResponse>>
{
    /** @description LocationId */
    // @ApiMember(DataType="string", Description="LocationId", Name="LocationId", ParameterType="model", Verb="POST")
    public locationId?: string;

    // @ApiMember(ParameterType="model")
    public practitionerId?: string;

    // @ApiMember(IsRequired=true, ParameterType="model")
    public startDateTime: string;

    // @ApiMember(IsRequired=true, ParameterType="model")
    public endDateTime: string;

    // @ApiMember(IsRequired=true, ParameterType="model")
    public serviceId: string;

    // @ApiMember(ParameterType="model")
    public workflowId?: number;

    public constructor(init?: Partial<ReferralPortalReserveAppointmentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalReserveAppointmentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ReferralPortalReserveAppointmentResponse>(); }
}
(ReferralPortalReserveAppointmentRequest as unknown)[immerable] = true;

export class ReferralPortalDeleteProvisionalAppointmentRequest implements IReturn<ResponseBase<boolean>>
{
    public appointmentId: number;

    public constructor(init?: Partial<ReferralPortalDeleteProvisionalAppointmentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalDeleteProvisionalAppointmentRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ReferralPortalDeleteProvisionalAppointmentRequest as unknown)[immerable] = true;

// @Route("/portal/connect-services", "GET")
export class ReferralPortalConnectServicesRequest implements IReturn<ResponseBase<ReferralPortalConnectServiceResponse>>
{

    public constructor(init?: Partial<ReferralPortalConnectServicesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalConnectServicesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ReferralPortalConnectServiceResponse>(); }
}
(ReferralPortalConnectServicesRequest as unknown)[immerable] = true;

export class ReferralPortalContactSearchRequest implements IReturn<ResponseBase<MedicalContactResponse>>
{
    public skip: number;
    public take: number;
    public term: string;

    public constructor(init?: Partial<ReferralPortalContactSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalContactSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<MedicalContactResponse>(); }
}
(ReferralPortalContactSearchRequest as unknown)[immerable] = true;

export class ReferralPortalContactRolesRequest implements IReturn<ResponseBase<RoleResponse>>
{

    public constructor(init?: Partial<ReferralPortalContactRolesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalContactRolesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<RoleResponse>(); }
}
(ReferralPortalContactRolesRequest as unknown)[immerable] = true;

export class ReferralPortalSettingsRequest implements IReturn<ResponseBase<ReferralPortalSettingsResponse>>
{

    public constructor(init?: Partial<ReferralPortalSettingsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalSettingsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ReferralPortalSettingsResponse>(); }
}
(ReferralPortalSettingsRequest as unknown)[immerable] = true;

export class ReferralPortalCompaniesRequest implements IReturn<ResponseBase<ReferralPortalCompaniesResponse>>
{

    public constructor(init?: Partial<ReferralPortalCompaniesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalCompaniesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ReferralPortalCompaniesResponse>(); }
}
(ReferralPortalCompaniesRequest as unknown)[immerable] = true;

export class ReferralPortalSwapCompanyRequest implements IReturn<ResponseBase<boolean>>
{
    public primary: boolean;
    public companyId?: number;

    public constructor(init?: Partial<ReferralPortalSwapCompanyRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalSwapCompanyRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ReferralPortalSwapCompanyRequest as unknown)[immerable] = true;

// @Route("/portal/referral", "POST")
export class ReferralPortalCreateReferralRequest implements IReturn<ResponseBase<ReferralPortalReferralResponse>>
{
    /** @description Required when referring without an appointment. Available from `/portal/products`. */
    // @ApiMember(Description="Required when referring without an appointment. Available from `/portal/products`.", ParameterType="model")
    public serviceId: string;

    /** @description Connect service id for Caseflow Lite referrals. Available from `/portal/connect-services`. */
    // @ApiMember(Description="Connect service id for Caseflow Lite referrals. Available from `/portal/connect-services`.", ParameterType="model")
    public onlineClinicServiceId: string;

    /** @description JSON data containing referral data fields. The list of field names, and validation requirements can be retrieved from `/portal/referral/fields`. Note that it can vary by service, though mostly should be standardised.e.g.```json{    "R.forename": "John",    "R.surname": "Smith",}``` */
    // @ApiMember(Description="JSON data containing referral data fields. The list of field names, and validation requirements can be retrieved from `/portal/referral/fields`. Note that it can vary by service, though mostly should be standardised.\ne.g.\n```json\n{\n    \"R.forename\": \"John\",\n    \"R.surname\": \"Smith\",\n}\n```\n\n", ParameterType="model")
    public referralData: JsonField;

    /** @description The (optional) `AppointmentId` from a `/portal/reserve` request. */
    // @ApiMember(Description="The (optional) `AppointmentId` from a `/portal/reserve` request.", ParameterType="model")
    public appointmentId?: number;

    // @ApiMember(ExcludeInSchema=true, ParameterType="model")
    public firstOfferedDate?: string;

    // @ApiMember(ExcludeInSchema=true, ParameterType="model")
    public offeredRejectedReason: string;

    /** @description hidden until we document file upload endpoints */
    // @ApiMember(Description="hidden until we document file upload endpoints", ExcludeInSchema=true, ParameterType="model")
    public temporaryFolderId?: string;

    /** @description Use this option to configure what type of initial communications should be sent upon referral. */
    // @ApiMember(Description="Use this option to configure what type of initial communications should be sent upon referral.", ParameterType="model")
    public communicationType: ReferralCommunicationType;

    /** @description Set this to true to generate an URL for the end referrer to login to the self-service portal. The link will auto-expire after a number of days. */
    // @ApiMember(Description="Set this to true to generate an URL for the end referrer to login to the self-service portal. The link will auto-expire after a number of days.", ParameterType="model")
    public generateAutoLoginUrl: boolean;

    /** @description For the user to by-pass Client Portal and be redirected straight to the digital triage service, supply the Id of the Client Portal Digital Triage Service here */
    // @ApiMember(Description="For the user to by-pass Client Portal and be redirected straight to the digital triage service, supply the Id of the Client Portal Digital Triage Service here", ParameterType="model")
    public digitalTriageAutoLaunchServiceId: string;

    /** @description Optional template id used to render the referral form on creation */
    // @ApiMember(Description="Optional template id used to render the referral form on creation", ParameterType="model")
    public templateId?: string;

    public contractId?: string;
    public productId?: string;
    public locationId?: number;
    /** @description If GenerateAutoLoginUrl is set to true, by default MFA will be enabled, prompting the user for a code. To skip the MFA check, toggle this property to true. */
    // @ApiMember(Description="If GenerateAutoLoginUrl is set to true, by default MFA will be enabled, prompting the user for a code. To skip the MFA check, toggle this property to true.", ParameterType="model")
    public autoLoginSkipMfa: boolean;

    /** @description Add any notes to the appointment that might be useful for us, e.g. preferred contact number */
    // @ApiMember(Description="Add any notes to the appointment that might be useful for us, e.g. preferred contact number", ParameterType="model")
    public comment: string;

    public constructor(init?: Partial<ReferralPortalCreateReferralRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalCreateReferralRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ReferralPortalReferralResponse>(); }
}
(ReferralPortalCreateReferralRequest as unknown)[immerable] = true;

export class SearchReferralPortalDashboardStatisticsRequest implements IReturn<ResponseBase<SearchReferralPortalDashboardStatisticsResponse>>
{
    public userLevel: string;
    public userId: string;

    public constructor(init?: Partial<SearchReferralPortalDashboardStatisticsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SearchReferralPortalDashboardStatisticsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SearchReferralPortalDashboardStatisticsResponse>(); }
}
(SearchReferralPortalDashboardStatisticsRequest as unknown)[immerable] = true;

export class ReferralPortalTemporaryFileRequest implements IReturn<ResponseBase<ReferralPortalTemporaryFileResponse>>
{
    public id: string;

    public constructor(init?: Partial<ReferralPortalTemporaryFileRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalTemporaryFileRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ReferralPortalTemporaryFileResponse>(); }
}
(ReferralPortalTemporaryFileRequest as unknown)[immerable] = true;

export class ReferralPortalTemporaryFileListingRequest implements IReturn<ResponseBase<ReferralPortalTemporaryFileListingResponse>>
{
    public id: string;

    public constructor(init?: Partial<ReferralPortalTemporaryFileListingRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalTemporaryFileListingRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ReferralPortalTemporaryFileListingResponse>(); }
}
(ReferralPortalTemporaryFileListingRequest as unknown)[immerable] = true;

export class ReferralPortalTemporaryFileDeleteRequest implements IReturn<ResponseBase<ReferralPortalTemporaryFileDeleteResponse>>
{
    public folderId: string;
    public path: string;
    public name: string;

    public constructor(init?: Partial<ReferralPortalTemporaryFileDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalTemporaryFileDeleteRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ReferralPortalTemporaryFileDeleteResponse>(); }
}
(ReferralPortalTemporaryFileDeleteRequest as unknown)[immerable] = true;

// @Route("/referralportal/sharedfiles", "GET")
export class ReferralPortalSharedFilesRequest implements IReturn<ResponseBase<ListingFolderTree>>, IGet
{

    public constructor(init?: Partial<ReferralPortalSharedFilesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalSharedFilesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ListingFolderTree>(); }
}
(ReferralPortalSharedFilesRequest as unknown)[immerable] = true;

// @Route("/referralportal/workflow/{Id}/files", "GET")
export class ReferralPortalFilesByWorkflowIdRequest implements IReturn<ListingFolderTree>, IGet
{
    public id: number;

    public constructor(init?: Partial<ReferralPortalFilesByWorkflowIdRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalFilesByWorkflowIdRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ListingFolderTree(); }
}
(ReferralPortalFilesByWorkflowIdRequest as unknown)[immerable] = true;

// @Route("/referralportal/workflow/audit", "POST")
export class ReferralPortalAuditRequest implements IReturn<ResponseBase<ReferralPortalAuditResponse>>, IPost
{
    public workflowId: number;
    public skip: number;
    public take: number;
    public filter: ReferralPortalAuditType[];
    public sort: QueryField[];

    public constructor(init?: Partial<ReferralPortalAuditRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalAuditRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ReferralPortalAuditResponse>(); }
}
(ReferralPortalAuditRequest as unknown)[immerable] = true;

// @Route("/portal/referral/{WorkflowId}/simple-workflow", "GET")
export class ReferralPortalSimpleWorkflowRequest implements IReturn<ResponseBase<ReferralPortalSimpleWorkflowResponse>>
{
    public workflowId: number;

    public constructor(init?: Partial<ReferralPortalSimpleWorkflowRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalSimpleWorkflowRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ReferralPortalSimpleWorkflowResponse>(); }
}
(ReferralPortalSimpleWorkflowRequest as unknown)[immerable] = true;

// @Route("/referralportal/file/download", "GET")
export class ReferralPortalSharedFilesDownloadRequest implements IReturn<ResponseBase<ReferralPortalSharedFilesDownloadResponse>>
{
    public documentListingId: string;

    public constructor(init?: Partial<ReferralPortalSharedFilesDownloadRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalSharedFilesDownloadRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ReferralPortalSharedFilesDownloadResponse>(); }
}
(ReferralPortalSharedFilesDownloadRequest as unknown)[immerable] = true;

// @Route("/referralportal/file/view", "HEAD, GET")
export class ReferralPortalViewFileRequest
{
    public documentListingId: string;

    public constructor(init?: Partial<ReferralPortalViewFileRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalViewFileRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(ReferralPortalViewFileRequest as unknown)[immerable] = true;

export class ReferralPortalDownloadManagementReportRequest implements IReturn<ResponseBase<ReferralPortalSharedFilesDownloadResponse>>
{
    public documentListingId: string;

    public constructor(init?: Partial<ReferralPortalDownloadManagementReportRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalDownloadManagementReportRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ReferralPortalSharedFilesDownloadResponse>(); }
}
(ReferralPortalDownloadManagementReportRequest as unknown)[immerable] = true;

// @Route("/referralportal/hyperlinks/{WorkflowId}", "GET")
// @ApiResponse(Description="The published hyperlinks for the workflow.", StatusCode=200)
// @ApiResponse(Description="The workflow was not found or is not available to the authenticated Referral Portal user.", StatusCode=404)
export class ReferralPortalWorkflowLinksRequest implements IReturn<ResponseBase<ReferralPortalWorkflowLinkResponse>>
{
    /** @description The workflow identifier whose published Referral Portal hyperlinks should be returned. */
    // @ApiMember(Description="The workflow identifier whose published Referral Portal hyperlinks should be returned.", IsRequired=true)
    public workflowId: number;

    public constructor(init?: Partial<ReferralPortalWorkflowLinksRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalWorkflowLinksRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ReferralPortalWorkflowLinkResponse>(); }
}
(ReferralPortalWorkflowLinksRequest as unknown)[immerable] = true;

// @Route("/referralportal/hyperlinks/request-pin", "POST")
// @ApiResponse(Description="The one-time link or PIN generated for the published Intelerad link.", StatusCode=200)
// @ApiResponse(Description="The link URL is missing or the published link does not support one-time PIN access.", StatusCode=400)
// @ApiResponse(Description="The published link or Referral Portal user was not found.", StatusCode=404)
export class ReferralPortalRequestLinkPinRequest implements IReturn<ResponseBase<string>>
{
    /** @description The workflow identifier that owns the published link. */
    // @ApiMember(Description="The workflow identifier that owns the published link.", IsRequired=true, ParameterType="model")
    public workflowId: number;

    /** @description The exact URL of the published Intelerad link for which a one-time PIN is requested. */
    // @ApiMember(Description="The exact URL of the published Intelerad link for which a one-time PIN is requested.", IsRequired=true, ParameterType="model")
    public linkUrl: string;

    public constructor(init?: Partial<ReferralPortalRequestLinkPinRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalRequestLinkPinRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<string>(); }
}
(ReferralPortalRequestLinkPinRequest as unknown)[immerable] = true;

// @Route("/portal/locations", "POST")
// @ApiResponse(Description="Success", StatusCode=200)
// @ApiResponse(Description="Validation Exception", StatusCode=400)
export class ReferralPortalLocationRequest implements IReturn<ResponseBase<ReferralPortalLocationResponse>>
{
    public serviceId?: string;
    public skip: number;
    public take: number;

    public constructor(init?: Partial<ReferralPortalLocationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalLocationRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ReferralPortalLocationResponse>(); }
}
(ReferralPortalLocationRequest as unknown)[immerable] = true;

export class ReferralPortalLoginMessageRequest implements IReturn<ResponseBase<ReferralPortalLoginMessageResponse>>
{

    public constructor(init?: Partial<ReferralPortalLoginMessageRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalLoginMessageRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ReferralPortalLoginMessageResponse>(); }
}
(ReferralPortalLoginMessageRequest as unknown)[immerable] = true;

export class ReferralPortalLookupCacheRequest extends LookupCacheRequest implements IReturn<ResponseBase<LookupCacheResponse>>
{

    public constructor(init?: Partial<ReferralPortalLookupCacheRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalLookupCacheRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<LookupCacheResponse>(); }
}
(ReferralPortalLookupCacheRequest as unknown)[immerable] = true;

export class ReferralPortalCurrentUserRequest implements IReturn<ResponseBase<CurrentUser>>
{

    public constructor(init?: Partial<ReferralPortalCurrentUserRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalCurrentUserRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CurrentUser>(); }
}
(ReferralPortalCurrentUserRequest as unknown)[immerable] = true;

// @Route("/portal/contracts", "POST")
// @ApiResponse(Description="Success", StatusCode=200)
// @ApiResponse(Description="Validation Exception", StatusCode=400)
export class ReferralPortalContractRequest implements IReturn<ResponseBase<ContractWithActiveStatusDto>>
{
    /** @description If using Caseflow pre-referral information, then the age can be used to restrict the available services further. */
    // @ApiMember(Description="If using Caseflow pre-referral information, then the age can be used to restrict the available services further.", ParameterType="model")
    public patientAge?: number;

    public constructor(init?: Partial<ReferralPortalContractRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalContractRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ContractWithActiveStatusDto>(); }
}
(ReferralPortalContractRequest as unknown)[immerable] = true;

// @Route("/portal/products", "POST")
// @ApiResponse(Description="Success", StatusCode=200)
// @ApiResponse(Description="Validation Failure - look at the Response Status for further details", StatusCode=400)
export class ReferralPortalProductRequest implements IReturn<ResponseBase<ReferralPortalProductResponse>>
{
    /** @description The `contractId`, which can be retrieved from `/api/contracts`. If this is not supplied, all valid products will be returned */
    // @ApiMember(Description="The `contractId`, which can be retrieved from `/api/contracts`. If this is not supplied, all valid products will be returned", Format="uuid", ParameterType="model")
    public contractId?: string;

    public constructor(init?: Partial<ReferralPortalProductRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalProductRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ReferralPortalProductResponse>(); }
}
(ReferralPortalProductRequest as unknown)[immerable] = true;

// @Route("/portal/referral/fields/{ServiceId}", "GET")
export class ReferralPortalFieldsForServiceRequest implements IReturn<ResponseBase<ReferralPortalFieldsResponse>>
{
    public serviceId?: string;

    public constructor(init?: Partial<ReferralPortalFieldsForServiceRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalFieldsForServiceRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ReferralPortalFieldsResponse>(); }
}
(ReferralPortalFieldsForServiceRequest as unknown)[immerable] = true;

// @Route("/portal/referral/{Id}/services", "GET")
export class ReferralPortalAllowedServicesRequest implements IReturn<ResponseBase<ReferralPortalProductResponse>>
{
    public id?: number;

    public constructor(init?: Partial<ReferralPortalAllowedServicesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalAllowedServicesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ReferralPortalProductResponse>(); }
}
(ReferralPortalAllowedServicesRequest as unknown)[immerable] = true;

// @Route("/portal/referral/{WorkflowId}/appointments", "GET,POST")
export class ReferralPortalReferralAppointmentRequest implements IReturn<ResponseBase<ReferralPortalReferralAppointmentResponse>>
{
    /** @description Which Referral should the appointment relate to */
    // @ApiMember(Description="Which Referral should the appointment relate to", ParameterType="model")
    public workflowId: number;

    /** @description Pagination - how many records to skip, use in conjunction with `Take` */
    // @ApiMember(Description="Pagination - how many records to skip, use in conjunction with `Take`", ParameterType="model")
    public skip: number;

    /** @description Pagination - how many records to take, use in conjunction with `Skip` */
    // @ApiMember(Description="Pagination - how many records to take, use in conjunction with `Skip`", ParameterType="model")
    public take: number;

    public sort: QueryField[];

    public constructor(init?: Partial<ReferralPortalReferralAppointmentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalReferralAppointmentRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ReferralPortalReferralAppointmentResponse>(); }
}
(ReferralPortalReferralAppointmentRequest as unknown)[immerable] = true;

// @Route("/portal/referral/{WorkflowId}/appointment", "POST")
export class ReferralPortalAddAppointmentToReferralRequest implements IReturn<ResponseBase<ReferralPortalReferralResponse>>
{
    /** @description The `Id` from a `/portal/referral` request. */
    // @ApiMember(Description="The `Id` from a `/portal/referral` request.", IsRequired=true, ParameterType="model")
    public workflowId: number;

    /** @description The `AppointmentId` from a `/portal/reserve` request. */
    // @ApiMember(Description="The `AppointmentId` from a `/portal/reserve` request.", IsRequired=true, ParameterType="model")
    public appointmentId: number;

    /** @description Add any notes to the appointment that might be useful for us, e.g. preferred contact number */
    // @ApiMember(Description="Add any notes to the appointment that might be useful for us, e.g. preferred contact number", ParameterType="model")
    public comment: string;

    public constructor(init?: Partial<ReferralPortalAddAppointmentToReferralRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalAddAppointmentToReferralRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ReferralPortalReferralResponse>(); }
}
(ReferralPortalAddAppointmentToReferralRequest as unknown)[immerable] = true;

// @Route("/portal/referral/{WorkflowId}/appointment/{AppointmentId}/cancel", "POST")
export class ReferralPortalCancelAppointment implements IReturn<ResponseBase<boolean>>
{
    public appointmentId?: number;
    public workflowId?: number;

    public constructor(init?: Partial<ReferralPortalCancelAppointment>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalCancelAppointment'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ReferralPortalCancelAppointment as unknown)[immerable] = true;

// @Route("/portal/referral/{Id}", "GET")
// @ApiResponse(Description="Success", StatusCode=200)
// @ApiResponse(Description="Validation Exception", StatusCode=400)
export class ReferralPortalReferralRequest implements IReturn<ResponseBase<ReferralPortalReferralResponse>>
{
    /** @description The unique identifier for the referral. Can be numeric workflow id or a GUID string. */
    // @ApiMember(Description="The unique identifier for the referral. Can be numeric workflow id or a GUID string.")
    public id: number;

    public constructor(init?: Partial<ReferralPortalReferralRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalReferralRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ReferralPortalReferralResponse>(); }
}
(ReferralPortalReferralRequest as unknown)[immerable] = true;

export class ReferralPortalReferralReportRequest implements IReturn<ResponseBase<ReferralPortalReferralReportResponse>>
{
    public workflowId: number;
    public skip: number;
    public take: number;
    public sort: QueryField[];

    public constructor(init?: Partial<ReferralPortalReferralReportRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalReferralReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ReferralPortalReferralReportResponse>(); }
}
(ReferralPortalReferralReportRequest as unknown)[immerable] = true;

export class ReferralPortalReportBodyRequest implements IReturn<ResponseBase<ReferralPortalReportBodyResponse>>
{
    public workflowId: number;
    public reportId: number;

    public constructor(init?: Partial<ReferralPortalReportBodyRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalReportBodyRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ReferralPortalReportBodyResponse>(); }
}
(ReferralPortalReportBodyRequest as unknown)[immerable] = true;

export class ReferralPortalReferralSearchRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<ReferralPortalReferralSearchResponse>>
{
    public searchType: ReferralSearchType;
    public serviceId?: string;
    public statusId?: string;
    public ownerId?: string;
    public teamId?: string;
    public createdFrom?: string;
    public createdTo?: string;
    public hasAppointment?: boolean;

    public constructor(init?: Partial<ReferralPortalReferralSearchRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalReferralSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ReferralPortalReferralSearchResponse>(); }
}
(ReferralPortalReferralSearchRequest as unknown)[immerable] = true;

// @Route("/portal/referrals/filters", "GET")
// @ApiResponse(Description="Success", StatusCode=200)
export class ReferralPortalReferralFilterOptionsRequest implements IReturn<ResponseBase<ReferralPortalReferralFilterOptionsResponse>>
{

    public constructor(init?: Partial<ReferralPortalReferralFilterOptionsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalReferralFilterOptionsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ReferralPortalReferralFilterOptionsResponse>(); }
}
(ReferralPortalReferralFilterOptionsRequest as unknown)[immerable] = true;

export class ReferralPortalApproveReportRequest implements IReturn<ResponseBase<boolean>>
{
    public actionId: string;
    public notes: string;

    public constructor(init?: Partial<ReferralPortalApproveReportRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalApproveReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ReferralPortalApproveReportRequest as unknown)[immerable] = true;

export class ReferralPortalRejectReportRequest implements IReturn<ResponseBase<boolean>>
{
    public actionId: string;
    public notes: string;

    public constructor(init?: Partial<ReferralPortalRejectReportRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalRejectReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ReferralPortalRejectReportRequest as unknown)[immerable] = true;

export class ReferralPortalQueryReportRequest implements IReturn<ResponseBase<boolean>>
{
    public actionId: string;
    public notes: string;

    public constructor(init?: Partial<ReferralPortalQueryReportRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalQueryReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ReferralPortalQueryReportRequest as unknown)[immerable] = true;

// @Route("/portal/referral/template/{ServiceId}", "GET")
export class ReferralPortalTemplateForServiceRequest implements IReturn<ResponseBase<CaseflowTemplateDto>>
{
    public serviceId?: string;

    public constructor(init?: Partial<ReferralPortalTemplateForServiceRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalTemplateForServiceRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CaseflowTemplateDto>(); }
}
(ReferralPortalTemplateForServiceRequest as unknown)[immerable] = true;

export class ReferralPortalUserSearchRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<ReferralPortalUserResponse>>
{

    public constructor(init?: Partial<ReferralPortalUserSearchRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalUserSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ReferralPortalUserResponse>(); }
}
(ReferralPortalUserSearchRequest as unknown)[immerable] = true;

export class ReferralPortalEditProfileUserRequest implements IReturn<ResponseBase<ReferralPortalUserResponse>>
{

    public constructor(init?: Partial<ReferralPortalEditProfileUserRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalEditProfileUserRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ReferralPortalUserResponse>(); }
}
(ReferralPortalEditProfileUserRequest as unknown)[immerable] = true;

export class ReferralPortalUpdateUserRequest implements IReturn<ResponseBase<boolean>>
{
    public id: number;
    public email: string;
    public mobileNumber: string;
    public firstName: string;
    public lastName: string;
    public avatar: string;
    public level: string;
    public current: boolean;
    public groups: number[];

    public constructor(init?: Partial<ReferralPortalUpdateUserRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalUpdateUserRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ReferralPortalUpdateUserRequest as unknown)[immerable] = true;

export class ReferralPortalUpdateCurrentUserRequest extends ReferralPortalUpdateUserRequest implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<ReferralPortalUpdateCurrentUserRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalUpdateCurrentUserRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ReferralPortalUpdateCurrentUserRequest as unknown)[immerable] = true;

export class ReferralPortalCreateUserRequest implements IReturn<ResponseBase<boolean>>
{
    public email: string;
    public mobileNumber: string;
    public firstName: string;
    public lastName: string;
    public avatar: string;
    public level: string;
    public groups: number[];

    public constructor(init?: Partial<ReferralPortalCreateUserRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalCreateUserRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ReferralPortalCreateUserRequest as unknown)[immerable] = true;

// @Route("/referralportal/twofactortoggle", "POST")
export class ReferralPortalToggleTwoFactorAuthentication implements IReturn<ResponseBase<boolean>>
{
    public twoFactorEnabled: boolean;

    public constructor(init?: Partial<ReferralPortalToggleTwoFactorAuthentication>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalToggleTwoFactorAuthentication'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ReferralPortalToggleTwoFactorAuthentication as unknown)[immerable] = true;

// @Route("/referralportal/selfpasswordreset", "POST")
export class ReferralPortalSelfResetPasswordRequest implements IReturn<ResponseBase<boolean>>
{
    public mode: ResetMode;

    public constructor(init?: Partial<ReferralPortalSelfResetPasswordRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalSelfResetPasswordRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ReferralPortalSelfResetPasswordRequest as unknown)[immerable] = true;

// @Route("/referralportal/passwordreset", "POST")
export class ReferralPortalResetPasswordRequest implements IReturn<ResponseBase<boolean>>
{
    public userId: number;
    public mode: ResetMode;

    public constructor(init?: Partial<ReferralPortalResetPasswordRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalResetPasswordRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ReferralPortalResetPasswordRequest as unknown)[immerable] = true;

export class ReferralPortalUserRequest implements IReturn<ResponseBase<ReferralPortalUserResponse>>
{
    public userId: number;

    public constructor(init?: Partial<ReferralPortalUserRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalUserRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ReferralPortalUserResponse>(); }
}
(ReferralPortalUserRequest as unknown)[immerable] = true;

export class ReferralPortalReferralChangeOwnerRequest implements IReturn<ResponseBase<ReferralPortalReferralResponse>>
{
    public ownerId: string;
    public id: number;

    public constructor(init?: Partial<ReferralPortalReferralChangeOwnerRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalReferralChangeOwnerRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ReferralPortalReferralResponse>(); }
}
(ReferralPortalReferralChangeOwnerRequest as unknown)[immerable] = true;

export class GetAllSystemLogRequest implements IReturn<ResponseBase<SystemLogWithCustomerName>>
{
    public skip: number;
    public take: number;
    public sort: QueryField[];

    public constructor(init?: Partial<GetAllSystemLogRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAllSystemLogRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SystemLogWithCustomerName>(); }
}
(GetAllSystemLogRequest as unknown)[immerable] = true;

export class SquareGetDeviceCodeRequest implements IReturn<ResponseBase<SquareGetDeviceCodeResponse>>
{
    public locationId: number;
    public name: string;

    public constructor(init?: Partial<SquareGetDeviceCodeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SquareGetDeviceCodeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SquareGetDeviceCodeResponse>(); }
}
(SquareGetDeviceCodeRequest as unknown)[immerable] = true;

export class ClearAcceptTerminalSaveRequest implements IReturn<ResponseBase<boolean>>
{
    public locationId: number;
    public name: string;
    public merchantId: string;
    public deviceCode: string;
    public inUse?: boolean;

    public constructor(init?: Partial<ClearAcceptTerminalSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClearAcceptTerminalSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ClearAcceptTerminalSaveRequest as unknown)[immerable] = true;

export class SquareUnpairTerminalRequest implements IReturn<ResponseBase<boolean>>
{
    public deviceCode: string;

    public constructor(init?: Partial<SquareUnpairTerminalRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SquareUnpairTerminalRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(SquareUnpairTerminalRequest as unknown)[immerable] = true;

export class TerminalPairCheckRequest implements IReturn<ResponseBase<TerminalPairingResponse>>
{
    public deviceCode: string;

    public constructor(init?: Partial<TerminalPairCheckRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TerminalPairCheckRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TerminalPairingResponse>(); }
}
(TerminalPairCheckRequest as unknown)[immerable] = true;

export class TerminalListRequest implements IReturn<ResponseBase<Terminal[]>>
{

    public constructor(init?: Partial<TerminalListRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TerminalListRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<Terminal[]>(); }
}
(TerminalListRequest as unknown)[immerable] = true;

export class TerminalFailPairingRequest implements IReturn<ResponseBase<boolean>>
{
    public deviceCode: string;

    public constructor(init?: Partial<TerminalFailPairingRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TerminalFailPairingRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(TerminalFailPairingRequest as unknown)[immerable] = true;

export class SquareTerminalPaymentRequest implements IReturn<ResponseBase<SquareTerminalPaymentResponse>>
{
    public amount: number;
    public terminalId: string;
    public customerId: number;

    public constructor(init?: Partial<SquareTerminalPaymentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SquareTerminalPaymentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SquareTerminalPaymentResponse>(); }
}
(SquareTerminalPaymentRequest as unknown)[immerable] = true;

// @Route("/add-terminal-payment")
export class AddTerminalPaymentToInvoiceRequest implements IReturn<ResponseBase<boolean>>
{
    public invoiceId: number;
    public terminalPaymentDto: TerminalPaymentDto;

    public constructor(init?: Partial<AddTerminalPaymentToInvoiceRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddTerminalPaymentToInvoiceRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(AddTerminalPaymentToInvoiceRequest as unknown)[immerable] = true;

export class GetPaymentFromTerminalDto implements IReturn<ResponseBase<Income>>
{
    public terminalPaymentDto: TerminalPaymentDto;
    public appointmentId?: number;

    public constructor(init?: Partial<GetPaymentFromTerminalDto>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPaymentFromTerminalDto'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<Income>(); }
}
(GetPaymentFromTerminalDto as unknown)[immerable] = true;

export class StripeTerminalPairRequest implements IReturn<ResponseBase<StripeTerminalPairResponse>>
{
    public locationId: number;
    public stripeLocationId: string;
    public terminalId: string;
    public deviceName: string;
    public pairingCode: string;

    public constructor(init?: Partial<StripeTerminalPairRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StripeTerminalPairRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<StripeTerminalPairResponse>(); }
}
(StripeTerminalPairRequest as unknown)[immerable] = true;

export class TerminalDeleteRequest implements IReturnVoid
{
    public terminalId: string;

    public constructor(init?: Partial<TerminalDeleteRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TerminalDeleteRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(TerminalDeleteRequest as unknown)[immerable] = true;

export class CreatePaymentIntent
{
    public amount: number;
    public futureUsage?: boolean;
    public paymentMethodId: string;

    public constructor(init?: Partial<CreatePaymentIntent>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreatePaymentIntent'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(CreatePaymentIntent as unknown)[immerable] = true;

export class ValidateSaveCardUrlCodeRequest implements IReturn<ResponseBase<boolean>>
{
    public urlCode: string;

    public constructor(init?: Partial<ValidateSaveCardUrlCodeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateSaveCardUrlCodeRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ValidateSaveCardUrlCodeRequest as unknown)[immerable] = true;

export class CreateChasePaymentIntent extends CreatePaymentIntent
{
    public paymentUrlCode: string;

    public constructor(init?: Partial<CreateChasePaymentIntent>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateChasePaymentIntent'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(CreateChasePaymentIntent as unknown)[immerable] = true;

export class CreateWaitingListPaymentIntent extends CreatePaymentIntent
{
    public waitingListUrlCode: string;

    public constructor(init?: Partial<CreateWaitingListPaymentIntent>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateWaitingListPaymentIntent'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}
(CreateWaitingListPaymentIntent as unknown)[immerable] = true;

export class OnlineStripeChangeCardByCodeRequest implements IReturn<ResponseBase<ChangeCardResponse>>
{
    public urlCode: string;
    public paymentMethodId: string;

    public constructor(init?: Partial<OnlineStripeChangeCardByCodeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineStripeChangeCardByCodeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ChangeCardResponse>(); }
}
(OnlineStripeChangeCardByCodeRequest as unknown)[immerable] = true;

export class SquareStartPaymentCaptureRequest extends TakePaymentRequest implements IReturn<ResponseBase<TakePaymentRequest>>
{
    public amount: number;
    public paymentUrlCode: string;
    public cardholderName: string;

    public constructor(init?: Partial<SquareStartPaymentCaptureRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'SquareStartPaymentCaptureRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TakePaymentRequest>(); }
}
(SquareStartPaymentCaptureRequest as unknown)[immerable] = true;

export class OnlineSquareChangeCardRequest implements IReturn<ResponseBase<ChangeCardResponse>>
{
    public tokenId: string;
    public cardholderName: string;
    public verificationToken: string;

    public constructor(init?: Partial<OnlineSquareChangeCardRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OnlineSquareChangeCardRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<ChangeCardResponse>(); }
}
(OnlineSquareChangeCardRequest as unknown)[immerable] = true;

export class ClearAcceptSaveCardDetailsRequest implements IReturn<ResponseBase<boolean>>
{
    public takePaymentRequest: TakePaymentRequest;
    public urlCode: string;
    public guestToken: string;
    public insuranceConsentGiven: boolean;

    public constructor(init?: Partial<ClearAcceptSaveCardDetailsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClearAcceptSaveCardDetailsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ClearAcceptSaveCardDetailsRequest as unknown)[immerable] = true;

export class ClearAcceptRegisterInterest implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<ClearAcceptRegisterInterest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClearAcceptRegisterInterest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(ClearAcceptRegisterInterest as unknown)[immerable] = true;

export class ClearAcceptConfigRequest implements IReturn<ResponseBase<ClearAcceptConfigResponse>>
{

    public constructor(init?: Partial<ClearAcceptConfigRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClearAcceptConfigRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ClearAcceptConfigResponse>(); }
}
(ClearAcceptConfigRequest as unknown)[immerable] = true;

export class ClearAcceptSaveCardRequest implements IReturn<ResponseBase<TakePaymentRequest>>
{
    public urlCode: string;
    public customerId?: number;
    public guestToken: string;

    public constructor(init?: Partial<ClearAcceptSaveCardRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClearAcceptSaveCardRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TakePaymentRequest>(); }
}
(ClearAcceptSaveCardRequest as unknown)[immerable] = true;

export class ClearAcceptStartPaymentCaptureRequest implements IReturn<ResponseBase<TakePaymentRequest>>
{
    public amount: number;
    public locationId: number;
    public saveCard: boolean;
    public paymentUrlCode: string;
    public waitingListUrlCode: string;
    public useLocationSpecificMerchantId: boolean;
    public guestToken: string;

    public constructor(init?: Partial<ClearAcceptStartPaymentCaptureRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClearAcceptStartPaymentCaptureRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TakePaymentRequest>(); }
}
(ClearAcceptStartPaymentCaptureRequest as unknown)[immerable] = true;

export class UpdateAddressOnPaymentRequest implements IReturn<ResponseBase<boolean>>
{
    public takePaymentRequest: TakePaymentRequest;
    public paymentUrlCode: string;
    public amount: number;
    public customerId?: number;
    public waitingListUrlCode: string;
    public saveCardUrlCode: string;
    public guestToken: string;

    public constructor(init?: Partial<UpdateAddressOnPaymentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateAddressOnPaymentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(UpdateAddressOnPaymentRequest as unknown)[immerable] = true;

export class StartTerminalPaymentRequest implements IReturn<ResponseBase<TerminalPaymentDto>>
{
    public amount: number;
    public terminalId: string;
    public customerId: number;
    public locationId: number;
    public receivedAtLocationId: number;
    public practitionerId?: number;
    public invoiceId?: number;

    public constructor(init?: Partial<StartTerminalPaymentRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StartTerminalPaymentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TerminalPaymentDto>(); }
}
(StartTerminalPaymentRequest as unknown)[immerable] = true;

export class CancelTerminalCheckoutRequest implements IReturn<ResponseBase<boolean>>
{
    public terminalPayment: TerminalPaymentDto;

    public constructor(init?: Partial<CancelTerminalCheckoutRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CancelTerminalCheckoutRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CancelTerminalCheckoutRequest as unknown)[immerable] = true;

export class TerminalPaymentStatusRequest implements IReturn<ResponseBase<TerminalPaymentDto>>
{
    public terminalPayment: TerminalPaymentDto;

    public constructor(init?: Partial<TerminalPaymentStatusRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TerminalPaymentStatusRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TerminalPaymentDto>(); }
}
(TerminalPaymentStatusRequest as unknown)[immerable] = true;

export class StartVirtualTerminalPaymentCaptureRequest implements IReturn<ResponseBase<TakePaymentRequest>>
{
    public amount: number;
    public locationId: number;
    public customerId: number;
    public invoiceId?: number;

    public constructor(init?: Partial<StartVirtualTerminalPaymentCaptureRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StartVirtualTerminalPaymentCaptureRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TakePaymentRequest>(); }
}
(StartVirtualTerminalPaymentCaptureRequest as unknown)[immerable] = true;

export class CompleteVirtualTerminalPaymentCaptureRequest implements IReturn<ResponseBase<TakePaymentRequest>>
{
    public amount: number;
    public locationId?: number;
    public customerId: number;
    public invoiceId: number;
    public takePaymentRequest: TakePaymentRequest;
    public appointmentId?: number;

    public constructor(init?: Partial<CompleteVirtualTerminalPaymentCaptureRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CompleteVirtualTerminalPaymentCaptureRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<TakePaymentRequest>(); }
}
(CompleteVirtualTerminalPaymentCaptureRequest as unknown)[immerable] = true;

export class CreateApiCredentials implements IReturn<ResponseBase<T>>
{
    public notes: string;

    public constructor(init?: Partial<CreateApiCredentials>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateApiCredentials'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(CreateApiCredentials as unknown)[immerable] = true;

export class RevokeApiCredentials implements IReturn<ResponseBase<T>>
{
    public id: string;

    public constructor(init?: Partial<RevokeApiCredentials>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RevokeApiCredentials'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(RevokeApiCredentials as unknown)[immerable] = true;

export class GetApiCredentials implements IReturn<ResponseBase<T>>
{

    public constructor(init?: Partial<GetApiCredentials>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetApiCredentials'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(GetApiCredentials as unknown)[immerable] = true;

export class GetReportActionsRequest implements IReturn<ResponseBase<GetReportActionsResponse>>
{
    public reportId: number;

    public constructor(init?: Partial<GetReportActionsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetReportActionsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GetReportActionsResponse>(); }
}
(GetReportActionsRequest as unknown)[immerable] = true;

export class ApproveReportRequest implements IReturn<ResponseBase<boolean>>
{
    public reportId: number;

    public constructor(init?: Partial<ApproveReportRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ApproveReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ApproveReportRequest as unknown)[immerable] = true;

export class RejectReportRequest implements IReturn<ResponseBase<boolean>>
{
    public reportId: number;
    public comments: string;

    public constructor(init?: Partial<RejectReportRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RejectReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(RejectReportRequest as unknown)[immerable] = true;

export class QueryReportRequest implements IReturn<ResponseBase<boolean>>
{
    public reportId: number;
    public comments: string;

    public constructor(init?: Partial<QueryReportRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryReportRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(QueryReportRequest as unknown)[immerable] = true;

export class GetCreditBasedPackageLineItems implements IReturn<ResponseBase<CreditBasedPackageLineItemsResponse>>
{
    public id: number;

    public constructor(init?: Partial<GetCreditBasedPackageLineItems>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCreditBasedPackageLineItems'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CreditBasedPackageLineItemsResponse>(); }
}
(GetCreditBasedPackageLineItems as unknown)[immerable] = true;

export class ClickBillRequest implements IReturn<ResponseBase<ClickBillResponse>>
{
    public appointmentId: number;
    public useTerminalPayment: boolean;
    public requestViaPaymentProvider: boolean;
    public reminderToSetupPaymentProvider: boolean;
    public invoiceNow: boolean;
    public status: AppointmentStatus;
    public incomeId: number;

    public constructor(init?: Partial<ClickBillRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickBillRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClickBillResponse>(); }
}
(ClickBillRequest as unknown)[immerable] = true;

export class BlankInvoiceRequest implements IReturn<ResponseBase<number>>
{
    public accountId: number;

    public constructor(init?: Partial<BlankInvoiceRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BlankInvoiceRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<number>(); }
}
(BlankInvoiceRequest as unknown)[immerable] = true;

export class ClickInvoiceUsePaymentRequest extends ClickInvoiceReqBase implements IReturn<ResponseBase<T>>
{
    public paymentIds: number[];

    public constructor(init?: Partial<ClickInvoiceUsePaymentRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickInvoiceUsePaymentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(ClickInvoiceUsePaymentRequest as unknown)[immerable] = true;

export class ClickEmailInvoiceRequest extends ClickInvoiceReqBase implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<ClickEmailInvoiceRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickEmailInvoiceRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ClickEmailInvoiceRequest as unknown)[immerable] = true;

export class ClickDownloadInvoiceRequest extends ClickInvoiceReqBase implements IReturn<ResponseBase<ClickDownloadInvoiceResponse>>
{

    public constructor(init?: Partial<ClickDownloadInvoiceRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickDownloadInvoiceRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ClickDownloadInvoiceResponse>(); }
}
(ClickDownloadInvoiceRequest as unknown)[immerable] = true;

export class ClickInvoiceTransferRequest extends ClickInvoiceReqBase implements IReturn<ResponseBase<number>>
{
    public transferFullAmount: boolean;
    public charge: Charge;
    public useCredit: boolean;
    public shouldAutopay: boolean;

    public constructor(init?: Partial<ClickInvoiceTransferRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickInvoiceTransferRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<number>(); }
}
(ClickInvoiceTransferRequest as unknown)[immerable] = true;

export class ClickCreatePaymentForInvoiceRequest extends Income implements IReturn<ResponseBase<ClickCreatePaymentResponse>>
{
    public emailReceipt: boolean;
    public invoiceId: number;
    public reminderToSetupPaymentProvider: boolean;
    public downloadPDF: boolean;

    public constructor(init?: Partial<ClickCreatePaymentForInvoiceRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickCreatePaymentForInvoiceRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClickCreatePaymentResponse>(); }
}
(ClickCreatePaymentForInvoiceRequest as unknown)[immerable] = true;

export class ClickCreatePaymentRequest extends Income implements IReturn<ResponseBase<ClickCreatePaymentResponse>>
{
    public emailReceipt: boolean;
    public reminderToSetupPaymentProvider: boolean;
    public downloadPDF: boolean;
    public status: string;

    public constructor(init?: Partial<ClickCreatePaymentRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickCreatePaymentRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClickCreatePaymentResponse>(); }
}
(ClickCreatePaymentRequest as unknown)[immerable] = true;

export class ClickSendEmailReceiptRequest implements IReturn<ResponseBase<boolean>>
{
    public customerId: number;
    public groupId: number;
    public locationId: number;
    public paymentId: number;

    public constructor(init?: Partial<ClickSendEmailReceiptRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickSendEmailReceiptRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ClickSendEmailReceiptRequest as unknown)[immerable] = true;

export class ClickDownloadReceiptRequest extends ClickSendEmailReceiptRequest implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<ClickDownloadReceiptRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickDownloadReceiptRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ClickDownloadReceiptRequest as unknown)[immerable] = true;

export class ClickCommunicationRequest implements IReturn<ResponseBase<ClickCommunicationResponse>>
{
    public mode: CommunicationMode;
    public type: string;
    public typeId: number;

    public constructor(init?: Partial<ClickCommunicationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClickCommunicationRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ClickCommunicationResponse>(); }
}
(ClickCommunicationRequest as unknown)[immerable] = true;

export class GetClassSessionRequest implements IReturn<ResponseBase<ClassSessionBaseResponse>>
{
    public id: number;
    public appointmentId: number;

    public constructor(init?: Partial<GetClassSessionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetClassSessionRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ClassSessionBaseResponse>(); }
}
(GetClassSessionRequest as unknown)[immerable] = true;

export class CreateClassRequest implements IReturn<ResponseBase<CreateClassResponse>>
{
    public locationId: number;
    public roomId?: number;
    public practitionerId: number;
    public isAvailableOnline: boolean;
    public classTypeId: number;
    public dateCreateMode: ClassDateCreationMode;
    public dayOfWeek: DayOfWeek;
    public startTime: string;
    public endTime: string;
    public sessionDuration: number;
    public recurrenceStartTime?: string;
    public recurrenceEndTime?: string;
    public recurForNWeeks?: number;
    public customDates: string[];
    public minAttendees: number;
    public maxAttendees: number;
    public serviceTypeId: number;
    public colour?: number;
    public clashMode: ClashMode;
    public isVideo: boolean;
    public videoMeetingParticipantJoinUrl: string;
    public videoMeetingPassword: string;
    public videoMeetingProvider: VideoMeetingProvider;

    public constructor(init?: Partial<CreateClassRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateClassRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CreateClassResponse>(); }
}
(CreateClassRequest as unknown)[immerable] = true;

export class GetDesktopClassRequest implements IReturn<ResponseBase<GetDesktopClassResponse>>
{
    public id: number;

    public constructor(init?: Partial<GetDesktopClassRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDesktopClassRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<GetDesktopClassResponse>(); }
}
(GetDesktopClassRequest as unknown)[immerable] = true;

export class AddStudentToClassSessionRequest implements IReturn<ResponseBase<AddStudentToClassSessionResponse>>
{
    public sessionId: number;
    public customerId: number;
    public customer: CustomerSaveRequest;
    public billingMode: ClassBillingMode;
    public paymentMode: ClassPaymentMode;
    public chaseOnly?: boolean;
    public stockIdForNewBillingItem?: number;
    public cardToken: string;
    public appliesTo: SessionUpdateAppliesTo;
    public customSessionIds: number[];
    public receivedAtLocationId?: number;
    public emailReceipt: boolean;
    public emailInvoice: boolean;
    public addToWaitingListSessionIds: number[];
    public updateAttendance?: boolean;
    public clashMode: ClashMode;
    public terminalPaymentDto: TerminalPaymentDto;
    public virtualTerminalPaymentId?: number;
    public prepaidId?: number;

    public constructor(init?: Partial<AddStudentToClassSessionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddStudentToClassSessionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AddStudentToClassSessionResponse>(); }
}
(AddStudentToClassSessionRequest as unknown)[immerable] = true;

export class EditClassRequest implements IReturn<ResponseBase<EditClassResponse>>
{
    public sessionId: number;
    public editing: ClassEditType;
    public newValue?: number;
    public duration: number;
    public newDate?: string;
    public newStartDate?: string;
    public newEndDate?: string;
    public clashMode: ClashMode;
    public appliesTo: SessionUpdateAppliesTo;
    public customSessionIds: number[];

    public constructor(init?: Partial<EditClassRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EditClassRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<EditClassResponse>(); }
}
(EditClassRequest as unknown)[immerable] = true;

export class CancelClassSessionRequest implements IReturn<ResponseBase<boolean>>
{
    public id: number;

    public constructor(init?: Partial<CancelClassSessionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CancelClassSessionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CancelClassSessionRequest as unknown)[immerable] = true;

export class GetStudentOtherSessionsRequest implements IReturn<ResponseBase<ClassSessionBaseResponse>>
{
    public classTypeId: number;
    public customerId: number;

    public constructor(init?: Partial<GetStudentOtherSessionsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetStudentOtherSessionsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ClassSessionBaseResponse>(); }
}
(GetStudentOtherSessionsRequest as unknown)[immerable] = true;

export class PayForClassRequest implements IReturn<ResponseBase<PayForClassResponse>>
{
    public sessionId: number;
    public customerId: number;
    public billingMode: ClassBillingMode;
    public paymentMode: ClassPaymentMode;
    public chaseOnly?: boolean;
    public stockIdForNewBillingItem?: number;
    public updateAttendance: boolean;
    public cardToken: string;
    public receivedAtLocationId: number;
    public emailReceipt: boolean;
    public emailInvoice: boolean;
    public terminalPaymentDto: TerminalPaymentDto;
    public virtualTerminalPaymentId?: number;
    public existingPrePaidId?: number;

    public constructor(init?: Partial<PayForClassRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PayForClassRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<PayForClassResponse>(); }
}
(PayForClassRequest as unknown)[immerable] = true;

export class UseCreditRequest implements IReturn<ResponseBase<T>>
{
    public sessionId: number;
    public customerId: number;

    public constructor(init?: Partial<UseCreditRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UseCreditRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<T>(); }
}
(UseCreditRequest as unknown)[immerable] = true;

export class RemoveStudentFromSessionRequest implements IReturn<ResponseBase<CourseResponse>>
{
    public sessionId: number;
    public appliesTo: SessionUpdateAppliesTo;
    public customSessionIds: number[];
    public customerId: number;
    public cancellationFeeDue: boolean;
    public transferFeeDue: boolean;
    public transferToSessionId?: number;
    public billingMode: ClassBillingMode;
    public paymentMode: ClassPaymentMode;
    public chaseOnly?: boolean;
    public existingPrePaidId?: number;
    public stockIdForNewBillingItem?: number;
    public cardToken: string;
    public receivedAtLocationId: number;
    public emailInvoice: boolean;
    public emailReceipt: boolean;

    public constructor(init?: Partial<RemoveStudentFromSessionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RemoveStudentFromSessionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CourseResponse>(); }
}
(RemoveStudentFromSessionRequest as unknown)[immerable] = true;

export class GetClassSessionRequests implements IReturn<ResponseBase<ClassSessionBaseResponse>>
{
    public sessionId: number;

    public constructor(init?: Partial<GetClassSessionRequests>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetClassSessionRequests'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ClassSessionBaseResponse>(); }
}
(GetClassSessionRequests as unknown)[immerable] = true;

export class GetWeeklyClassSessionRequests implements IReturn<ResponseBase<ClassSessionBaseResponse>>
{
    public sessionId: number;

    public constructor(init?: Partial<GetWeeklyClassSessionRequests>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetWeeklyClassSessionRequests'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ClassSessionBaseResponse>(); }
}
(GetWeeklyClassSessionRequests as unknown)[immerable] = true;

export class MarkClassSessionAttendance implements IReturn<ResponseBase<boolean>>
{
    public sessionId: number;
    public customerId: number;
    public updateAttendance: boolean;

    public constructor(init?: Partial<MarkClassSessionAttendance>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MarkClassSessionAttendance'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(MarkClassSessionAttendance as unknown)[immerable] = true;

export class ClassCommunicationRequest implements IReturn<ResponseBase<ClassCommunicationResponse>>
{
    public id: number;
    public message: string;
    public userName: string;

    public constructor(init?: Partial<ClassCommunicationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClassCommunicationRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClassCommunicationResponse>(); }
}
(ClassCommunicationRequest as unknown)[immerable] = true;

export class CustomerPrepaidRequestForClass implements IReturn<ResponseBase<PrePaidItemsForClassResponse>>
{
    public sessionDateTime: string;
    public customerId: number;
    public classTypeId: number;

    public constructor(init?: Partial<CustomerPrepaidRequestForClass>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CustomerPrepaidRequestForClass'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<PrePaidItemsForClassResponse>(); }
}
(CustomerPrepaidRequestForClass as unknown)[immerable] = true;

export class ClassesCustomerPrepaidCreditsReq implements IReturn<ResponseBase<ClassesPrePaidCreditsResp>>
{
    public sessionDateTime: string;
    public customerId: number;
    public classTypeId: number;

    public constructor(init?: Partial<ClassesCustomerPrepaidCreditsReq>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClassesCustomerPrepaidCreditsReq'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ClassesPrePaidCreditsResp>(); }
}
(ClassesCustomerPrepaidCreditsReq as unknown)[immerable] = true;

export class DeletePayAsYouGoClassRequest implements IReturn<ResponseBase<boolean>>
{
    public sessionId: number;

    public constructor(init?: Partial<DeletePayAsYouGoClassRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeletePayAsYouGoClassRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(DeletePayAsYouGoClassRequest as unknown)[immerable] = true;

export class ClassSessionMarkAllAttendanceRequest implements IReturn<ResponseBase<boolean>>
{
    public sessionId: number;
    public allAttended: boolean;

    public constructor(init?: Partial<ClassSessionMarkAllAttendanceRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClassSessionMarkAllAttendanceRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(ClassSessionMarkAllAttendanceRequest as unknown)[immerable] = true;

export class SaveClassNotesToAttendee implements IReturn<ResponseBase<ClassSessionBaseResponse>>
{
    public data: { [index:string]: Object; };
    public templateId: string;
    public customerId?: number;
    public sessionId: number;

    public constructor(init?: Partial<SaveClassNotesToAttendee>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveClassNotesToAttendee'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClassSessionBaseResponse>(); }
}
(SaveClassNotesToAttendee as unknown)[immerable] = true;

export class GetClassTypeRequest implements IReturn<ResponseBase<ClassTypeResponse>>
{
    public id: number;

    public constructor(init?: Partial<GetClassTypeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetClassTypeRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ClassTypeResponse>(); }
}
(GetClassTypeRequest as unknown)[immerable] = true;

export class ClassTypesListRequest implements IReturn<ResponseBase<ClassTypeResponse>>
{
    public ids?: number;

    public constructor(init?: Partial<ClassTypesListRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClassTypesListRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ClassTypeResponse>(); }
}
(ClassTypesListRequest as unknown)[immerable] = true;

export class ClassTypeSaveRequest implements IReturn<ResponseBase<ClassTypeResponse>>, IDepartmentIds, ILocationIds
{
    public id: number;
    public name: string;
    public description: string;
    public imageUrl: string;
    public termsAndConditionsFormId: string;
    public colour?: number;
    public defaultSessionLength: number;
    public numberOfSessions: number;
    public defaultMinAttendees: number;
    public defaultMaxAttendees: number;
    public isCourse: boolean;
    public isAvailableOnline: boolean;
    public isCurrent: boolean;
    public isFavourite: boolean;
    public allowPayPerSession: boolean;
    public perSessionStockId?: number;
    public perSessionPrice?: number;
    public packagesToCreate: SavePackageRequest[];
    public packagesToAdd: ClassPackageResponse[];
    public packagesToRemove: ClassPackageResponse[];
    public cancellationChargeApplies: boolean;
    public cancellationHours: number;
    public cancellationStockId?: number;
    public cancellationPrice?: number;
    public lateTransferChargeApplies: boolean;
    public lateTransferHours: number;
    public lateTransferStockId?: number;
    public lateTransferPrice?: number;
    public serviceTypeId: number;
    public colourCss: string;
    public departmentIds: number[];
    public locationIds: number[];
    public requestLocationIds: number[];
    public isVideo: boolean;

    public constructor(init?: Partial<ClassTypeSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ClassTypeSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ClassTypeResponse>(); }
}
(ClassTypeSaveRequest as unknown)[immerable] = true;

export class GetCourse implements IReturn<ResponseBase<CourseResponse>>
{
    public id: number;

    public constructor(init?: Partial<GetCourse>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCourse'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CourseResponse>(); }
}
(GetCourse as unknown)[immerable] = true;

export class AddStudentToCourseRequest implements IReturn<ResponseBase<AddStudentToCourseResponse>>
{
    public courseId: number;
    public customerId: number;
    public customer: CustomerSaveRequest;
    public billingMode: CourseBillingMode;
    public paymentMode: ClassPaymentMode;
    public chaseOnly?: boolean;
    public existingPrePaidId?: number;
    public prePaidId?: number;
    public stockIdForNewBillingItem?: number;
    public cardToken: string;
    public receivedAtLocationId?: number;
    public emailInvoice: boolean;
    public emailReceipt: boolean;
    public clashMode: ClashMode;
    public addToWaitingList: boolean;
    public sessionDateTime: string;
    public terminalPaymentDto: TerminalPaymentDto;
    public virtualTerminalPaymentId?: number;

    public constructor(init?: Partial<AddStudentToCourseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddStudentToCourseRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<AddStudentToCourseResponse>(); }
}
(AddStudentToCourseRequest as unknown)[immerable] = true;

export class EditCourseRequest implements IReturn<ResponseBase<EditCourseResponse>>
{
    public courseId: number;
    public sessionId?: number;
    public editing: ClassEditType;
    public newValue?: number;
    public newDate?: string;
    public appliesTo: CourseEditAppliesTo;
    public clashMode: ClashMode;
    public newStartDate?: string;
    public newEndDate?: string;
    public duration: number;

    public constructor(init?: Partial<EditCourseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EditCourseRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<EditCourseResponse>(); }
}
(EditCourseRequest as unknown)[immerable] = true;

export class CreateCourseRequest implements IReturn<ResponseBase<CreateCourseResponse>>
{
    public locationId: number;
    public roomId?: number;
    public practitionerId: number;
    public isAvailableOnline: boolean;
    public classTypeId: number;
    public dateCreateMode: ClassDateCreationMode;
    public dayOfWeek: DayOfWeek;
    public startTime: string;
    public endTime: string;
    public sessionDuration: number;
    public recurrenceStartTime?: string;
    public recurrenceEndTime?: string;
    public recurForNWeeks?: number;
    public customDates: string[];
    public minAttendees: number;
    public maxAttendees: number;
    public serviceTypeId: number;
    public colour?: number;
    public clashMode: ClashMode;
    public isVideo: boolean;
    public videoMeetingParticipantJoinUrl: string;
    public videoMeetingPassword: string;
    public videoMeetingProvider: VideoMeetingProvider;

    public constructor(init?: Partial<CreateCourseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateCourseRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CreateCourseResponse>(); }
}
(CreateCourseRequest as unknown)[immerable] = true;

export class SwapStudentCourseSessionRequest implements IReturn<ResponseBase<CourseResponse>>
{
    public customerId: number;
    public removeFromSessionId: number;
    public addToSessionId: number;
    public courseId: number;

    public constructor(init?: Partial<SwapStudentCourseSessionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SwapStudentCourseSessionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CourseResponse>(); }
}
(SwapStudentCourseSessionRequest as unknown)[immerable] = true;

export class CancelCourseSessionRequest implements IReturn<ResponseBase<boolean>>
{
    public id: number;

    public constructor(init?: Partial<CancelCourseSessionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CancelCourseSessionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CancelCourseSessionRequest as unknown)[immerable] = true;

export class AddCourseSessionRequest implements IReturn<ResponseBase<CourseResponse>>
{
    public practitionerId: number;
    public roomId?: number;
    public courseId: number;
    public startDateTime: string;
    public endDateTime: string;

    public constructor(init?: Partial<AddCourseSessionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddCourseSessionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CourseResponse>(); }
}
(AddCourseSessionRequest as unknown)[immerable] = true;

export class GetPotentialSwapDates implements IReturn<ResponseBase<CourseResponse>>
{
    public courseTypeId: number;
    public sessionId: number;
    public courseId: number;

    public constructor(init?: Partial<GetPotentialSwapDates>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPotentialSwapDates'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CourseResponse>(); }
}
(GetPotentialSwapDates as unknown)[immerable] = true;

export class PayForCourseRequest implements IReturn<ResponseBase<PayForClassResponse>>
{
    public courseId: number;
    public customerId: number;
    public billingMode: CourseBillingMode;
    public paymentMode: ClassPaymentMode;
    public chaseOnly?: boolean;
    public existingPrePaidId?: number;
    public stockIdForNewBillingItem?: number;
    public cardToken: string;
    public sessionId?: number;
    public updateAttendance: boolean;
    public receivedAtLocationId?: number;
    public emailInvoice: boolean;
    public emailReceipt: boolean;
    public sessionDateTime: string;
    public terminalPaymentDto: TerminalPaymentDto;
    public virtualTerminalPaymentId?: number;

    public constructor(init?: Partial<PayForCourseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PayForCourseRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<PayForClassResponse>(); }
}
(PayForCourseRequest as unknown)[immerable] = true;

export class RemoveStudentFromCourseRequest implements IReturn<ResponseBase<RemoveStudentFromClassResponse>>
{
    public courseId: number;
    public customerId: number;
    public cancellationFeeDue: boolean;
    public billingMode: CourseBillingMode;
    public paymentMode: ClassPaymentMode;
    public chaseOnly?: boolean;
    public stockIdForNewBillingItem?: number;
    public cardToken: string;
    public receivedAtLocationId?: number;
    public emailInvoice: boolean;
    public emailReceipt: boolean;

    public constructor(init?: Partial<RemoveStudentFromCourseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RemoveStudentFromCourseRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<RemoveStudentFromClassResponse>(); }
}
(RemoveStudentFromCourseRequest as unknown)[immerable] = true;

export class MarkCourseSessionAttendance implements IReturn<ResponseBase<boolean>>
{
    public sessionId: number;
    public customerId: number;
    public updateAttendance: boolean;

    public constructor(init?: Partial<MarkCourseSessionAttendance>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MarkCourseSessionAttendance'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(MarkCourseSessionAttendance as unknown)[immerable] = true;

export class MarkCourseSessionDna implements IReturn<ResponseBase<boolean>>
{
    public sessionId: number;
    public customerId: number;
    public updateDna: boolean;

    public constructor(init?: Partial<MarkCourseSessionDna>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MarkCourseSessionDna'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(MarkCourseSessionDna as unknown)[immerable] = true;

export class CourseSessionMarkAllAttendanceRequest implements IReturn<ResponseBase<boolean>>
{
    public sessionId: number;
    public allAttended: boolean;

    public constructor(init?: Partial<CourseSessionMarkAllAttendanceRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CourseSessionMarkAllAttendanceRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CourseSessionMarkAllAttendanceRequest as unknown)[immerable] = true;

export class DeleteCourseRequest implements IReturn<ResponseBase<boolean>>
{
    public courseId: number;

    public constructor(init?: Partial<DeleteCourseRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteCourseRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(DeleteCourseRequest as unknown)[immerable] = true;

// @Route("/caseflow/simple-workflows/document/{DocumentId}/visibility", "GET")
export class GetDocumentVisibilityRequest implements IReturn<ResponseBase<DocumentVisibilityResponse>>
{
    public documentId: number;

    public constructor(init?: Partial<GetDocumentVisibilityRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDocumentVisibilityRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<DocumentVisibilityResponse>(); }
}
(GetDocumentVisibilityRequest as unknown)[immerable] = true;

// @Route("/caseflow/simple-workflows/document/{DocumentId}/visibility", "PUT")
export class UpdateDocumentVisibilityRequest implements IReturn<ResponseBase<DocumentVisibilityResponse>>
{
    public documentId: number;
    public isVisibleToPortal: boolean;

    public constructor(init?: Partial<UpdateDocumentVisibilityRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateDocumentVisibilityRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<DocumentVisibilityResponse>(); }
}
(UpdateDocumentVisibilityRequest as unknown)[immerable] = true;

// @Route("/caseflow/simple-workflows/workflow/{WorkflowId}/document/visibility", "GET")
export class GetWorkflowDocumentVisibilityRequest implements IReturn<ResponseBase<DocumentVisibilityResponse>>, ISecurityId
{
    public workflowId: number;
    public securityId: number;
    public filePath: string;
    public objectType: string;
    public objectId: string;

    public constructor(init?: Partial<GetWorkflowDocumentVisibilityRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetWorkflowDocumentVisibilityRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<DocumentVisibilityResponse>(); }
}
(GetWorkflowDocumentVisibilityRequest as unknown)[immerable] = true;

// @Route("/caseflow/simple-workflows/workflow/{WorkflowId}/document/visibility", "PUT")
export class UpdateWorkflowDocumentVisibilityRequest implements IReturn<ResponseBase<DocumentVisibilityResponse>>, ISecurityId
{
    public workflowId: number;
    public securityId: number;
    public filePath: string;
    public isVisibleToPortal: boolean;
    public objectType: string;
    public objectId: string;

    public constructor(init?: Partial<UpdateWorkflowDocumentVisibilityRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateWorkflowDocumentVisibilityRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<DocumentVisibilityResponse>(); }
}
(UpdateWorkflowDocumentVisibilityRequest as unknown)[immerable] = true;

// @Route("/caseflow/simple-workflows/workflow/{WorkflowId}/document/published", "GET")
export class ListWorkflowPublishedDocumentsRequest implements IReturn<ResponseBase<DocumentListingFile>>, ISecurityId
{
    public workflowId: number;
    public securityId: number;

    public constructor(init?: Partial<ListWorkflowPublishedDocumentsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ListWorkflowPublishedDocumentsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<DocumentListingFile>(); }
}
(ListWorkflowPublishedDocumentsRequest as unknown)[immerable] = true;

// @Route("/caseflow/simple-workflows/workflow/{WorkflowId}/document/resolve", "POST")
export class ResolveWorkflowDocumentPathsRequest implements IReturn<ResponseBase<ResolveWorkflowDocumentPathsResponse>>, ISecurityId
{
    public workflowId: number;
    public securityId: number;
    public filePaths: string[];
    public objectType: string;
    public objectId: string;

    public constructor(init?: Partial<ResolveWorkflowDocumentPathsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ResolveWorkflowDocumentPathsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ResolveWorkflowDocumentPathsResponse>(); }
}
(ResolveWorkflowDocumentPathsRequest as unknown)[immerable] = true;

// @Route("/caseflow/simple-workflows/workflow/{WorkflowId}/document/notify", "POST")
export class SendWorkflowDocumentNotificationRequest implements IReturn<ResponseBase<boolean>>, ISecurityId
{
    public workflowId: number;
    public securityId: number;
    public objectType: string;
    public objectId: string;
    public target: string;
    public channel: string;

    public constructor(init?: Partial<SendWorkflowDocumentNotificationRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendWorkflowDocumentNotificationRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(SendWorkflowDocumentNotificationRequest as unknown)[immerable] = true;

// @Route("/caseflow/simple-workflows/workflow/{WorkflowId}/document/notify/recipient", "GET")
export class GetWorkflowDocumentNotificationRecipientRequest implements IReturn<ResponseBase<WorkflowDocumentNotificationRecipientResponse>>, ISecurityId
{
    public workflowId: number;
    public securityId: number;
    public objectType: string;
    public objectId: string;
    public target: string;

    public constructor(init?: Partial<GetWorkflowDocumentNotificationRecipientRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetWorkflowDocumentNotificationRecipientRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<WorkflowDocumentNotificationRecipientResponse>(); }
}
(GetWorkflowDocumentNotificationRecipientRequest as unknown)[immerable] = true;

// @Route("/caseflow/simple-workflows/workflow/{WorkflowId}/portal-owner", "PUT")
export class AssignWorkflowPortalOwnerRequest implements IReturn<ResponseBase<WorkflowDocumentNotificationRecipientResponse>>, ISecurityId
{
    public workflowId: number;
    public securityId: number;
    public ownerId: string;

    public constructor(init?: Partial<AssignWorkflowPortalOwnerRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssignWorkflowPortalOwnerRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<WorkflowDocumentNotificationRecipientResponse>(); }
}
(AssignWorkflowPortalOwnerRequest as unknown)[immerable] = true;

// @Route("/caseflow-lite/branding/theme/get", "POST")
export class CaseflowLiteBrandingThemeGetRequest implements IReturn<ResponseBase<ThemeResponse>>
{

    public constructor(init?: Partial<CaseflowLiteBrandingThemeGetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseflowLiteBrandingThemeGetRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ThemeResponse>(); }
}
(CaseflowLiteBrandingThemeGetRequest as unknown)[immerable] = true;

// @Route("/caseflow-lite/branding/theme/save", "POST")
export class CaseflowLiteBrandingThemeSaveRequest extends ThemeResponse implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<CaseflowLiteBrandingThemeSaveRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseflowLiteBrandingThemeSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CaseflowLiteBrandingThemeSaveRequest as unknown)[immerable] = true;

// @Route("/caseflow-lite/branding/logo/has", "POST")
export class CaseflowLiteBrandingLogoHasRequest implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<CaseflowLiteBrandingLogoHasRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseflowLiteBrandingLogoHasRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CaseflowLiteBrandingLogoHasRequest as unknown)[immerable] = true;

// @Route("/caseflow-lite/branding/logo/save", "POST")
export class CaseflowLiteBrandingLogoSaveRequest implements IReturn<ResponseBase<boolean>>
{
    public logo: string;
    public type: string;

    public constructor(init?: Partial<CaseflowLiteBrandingLogoSaveRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseflowLiteBrandingLogoSaveRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CaseflowLiteBrandingLogoSaveRequest as unknown)[immerable] = true;

// @Route("/caseflow-lite/branding/logo/get", "GET")
export class CaseflowLiteBrandingLogoGetRequest implements IReturn<HttpResult>
{

    public constructor(init?: Partial<CaseflowLiteBrandingLogoGetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseflowLiteBrandingLogoGetRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new HttpResult(); }
}
(CaseflowLiteBrandingLogoGetRequest as unknown)[immerable] = true;

export class EditorReferralPortalLoginMessageRequest implements IReturn<ResponseBase<ReferralPortalLoginMessageResponse>>
{

    public constructor(init?: Partial<EditorReferralPortalLoginMessageRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EditorReferralPortalLoginMessageRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<ReferralPortalLoginMessageResponse>(); }
}
(EditorReferralPortalLoginMessageRequest as unknown)[immerable] = true;

export class DeleteReferralPortalLoginMessageRequest implements IReturn<ResponseBase<boolean>>
{

    public constructor(init?: Partial<DeleteReferralPortalLoginMessageRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteReferralPortalLoginMessageRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(DeleteReferralPortalLoginMessageRequest as unknown)[immerable] = true;

export class SaveReferralPortalLoginMessageRequest implements IReturn<ResponseBase<boolean>>
{
    public title: string;
    public content: string;
    public style: string;

    public constructor(init?: Partial<SaveReferralPortalLoginMessageRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveReferralPortalLoginMessageRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(SaveReferralPortalLoginMessageRequest as unknown)[immerable] = true;

export class CaseflowReferralPortalUserSearchRequest implements IReturn<ResponseBase<ReferralPortalUserResponse>>
{
    public groupId: number;
    public skip: number;
    public take: number;
    public sort: QueryField[];
    public term: string;
    public onlyReferralPortalOwners: boolean;

    public constructor(init?: Partial<CaseflowReferralPortalUserSearchRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseflowReferralPortalUserSearchRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ReferralPortalUserResponse>(); }
}
(CaseflowReferralPortalUserSearchRequest as unknown)[immerable] = true;

export class CaseflowReferralPortalUserCreateRequest extends ReferralPortalCreateUserRequest implements IReturn<ResponseBase<boolean>>, ILocationId
{
    public groupId: number;
    public locationId: number;

    public constructor(init?: Partial<CaseflowReferralPortalUserCreateRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseflowReferralPortalUserCreateRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CaseflowReferralPortalUserCreateRequest as unknown)[immerable] = true;

export class CaseflowReferralPortalUserUpdateRequest extends ReferralPortalUpdateUserRequest implements IReturn<ResponseBase<boolean>>, ILocationId
{
    public groupId: number;
    public locationId: number;

    public constructor(init?: Partial<CaseflowReferralPortalUserUpdateRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseflowReferralPortalUserUpdateRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CaseflowReferralPortalUserUpdateRequest as unknown)[immerable] = true;

export class CaseflowReferralPortalUserSetPasswordRequest implements IReturn<ResponseBase<boolean>>
{
    public userId: number;
    public password: string;

    public constructor(init?: Partial<CaseflowReferralPortalUserSetPasswordRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseflowReferralPortalUserSetPasswordRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CaseflowReferralPortalUserSetPasswordRequest as unknown)[immerable] = true;

export class CaseflowReferralPortalTwoFactorUpdateRequest implements IReturn<ResponseBase<boolean>>
{
    public required: boolean;
    public groupId: number;

    public constructor(init?: Partial<CaseflowReferralPortalTwoFactorUpdateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CaseflowReferralPortalTwoFactorUpdateRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(CaseflowReferralPortalTwoFactorUpdateRequest as unknown)[immerable] = true;

// @Route("/caseflow/simple-workflows/{GroupId}", "GET, POST")
// @Route("/caseflow/simple-workflows", "GET, POST")
export class GetSimpleWorkflowsRequest extends BaseAdvancedSearchRequest implements IReturn<ResponseBase<SimpleWorkflowListResponse>>
{
    public groupId?: number;
    public customerId?: number;
    public statusId?: string;
    public teamId?: string;
    public ownerId?: string;
    public includeClosed?: boolean;

    public constructor(init?: Partial<GetSimpleWorkflowsRequest>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSimpleWorkflowsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<SimpleWorkflowListResponse>(); }
}
(GetSimpleWorkflowsRequest as unknown)[immerable] = true;

// @Route("/caseflow/simple-workflows/workflow/{WorkflowId}", "GET")
export class GetSimpleWorkflowDetailRequest implements IReturn<ResponseBase<SimpleWorkflowDetailResponse>>, ISecurityId
{
    public workflowId: number;
    public securityId: number;

    public constructor(init?: Partial<GetSimpleWorkflowDetailRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSimpleWorkflowDetailRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<SimpleWorkflowDetailResponse>(); }
}
(GetSimpleWorkflowDetailRequest as unknown)[immerable] = true;

// @Route("/caseflow/simple-workflows/workflow/{WorkflowId}/hyperlinks", "GET")
export class GetSimpleWorkflowHyperlinksRequest implements IReturn<ResponseBase<SimpleWorkflowHyperlinkResponse>>, ISecurityId
{
    public workflowId: number;
    public securityId: number;

    public constructor(init?: Partial<GetSimpleWorkflowHyperlinksRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSimpleWorkflowHyperlinksRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<SimpleWorkflowHyperlinkResponse>(); }
}
(GetSimpleWorkflowHyperlinksRequest as unknown)[immerable] = true;

// @Route("/caseflow/simple-workflows/workflow/{WorkflowId}/hyperlinks/request-pin", "POST")
export class RequestSimpleWorkflowLinkPinRequest implements IReturn<ResponseBase<string>>, ISecurityId
{
    public workflowId: number;
    public linkUrl: string;
    public securityId: number;

    public constructor(init?: Partial<RequestSimpleWorkflowLinkPinRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RequestSimpleWorkflowLinkPinRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<string>(); }
}
(RequestSimpleWorkflowLinkPinRequest as unknown)[immerable] = true;

// @Route("/caseflow/simple-workflows/workflow/{WorkflowId}", "PUT")
export class UpdateSimpleWorkflowRequest implements IReturn<ResponseBase<SimpleWorkflowDetailResponse>>, ISecurityId
{
    public workflowId: number;
    public securityId: number;
    public statusId?: string;
    public ownerId?: string;
    public userId?: string;
    public overallOwnerId?: string;
    public referralPortalOwnerId?: string;
    public teamId?: string;
    public closed?: boolean;
    public dueDate?: string;
    public closureReason: string;
    public groupId?: number;
    public secondaryGroupId?: number;
    public billingModeId?: number;
    public caseId?: number;

    public constructor(init?: Partial<UpdateSimpleWorkflowRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateSimpleWorkflowRequest'; }
    public getMethod() { return 'PUT'; }
    public createResponse() { return new ResponseBase<SimpleWorkflowDetailResponse>(); }
}
(UpdateSimpleWorkflowRequest as unknown)[immerable] = true;

// @Route("/caseflow/simple-workflows/workflow", "POST")
export class CreateSimpleWorkflowRequest implements IReturn<ResponseBase<CreateSimpleWorkflowResponse>>
{
    public groupId?: number;
    public onlineClinicServiceId?: string;
    public processId: string;
    public initialStatusId?: string;
    public teamId?: string;
    public ownerId?: string;
    public customerId?: number;
    public customer: CustomerSaveRequest;
    public referralData: JsonField;
    public templateId?: string;
    public temporaryFolderId?: string;

    public constructor(init?: Partial<CreateSimpleWorkflowRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateSimpleWorkflowRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<CreateSimpleWorkflowResponse>(); }
}
(CreateSimpleWorkflowRequest as unknown)[immerable] = true;

// @Route("/caseflow/simple-workflows/workflow/{WorkflowId}/actions/{ActionId}", "POST")
export class ExecuteSimpleWorkflowActionRequest implements IReturn<ResponseBase<SimpleWorkflowDetailResponse>>, ISecurityId
{
    public workflowId: number;
    public securityId: number;
    public actionId: string;
    public parameterOverrides: { [index:string]: { [index:string]: Object; }; };
    public actionOverrides: ActionExecutionOverrides;

    public constructor(init?: Partial<ExecuteSimpleWorkflowActionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExecuteSimpleWorkflowActionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SimpleWorkflowDetailResponse>(); }
}
(ExecuteSimpleWorkflowActionRequest as unknown)[immerable] = true;

// @Route("/caseflow/simple-workflows/teams", "GET")
export class GetSimpleWorkflowTeamsRequest implements IReturn<ResponseBase<SimpleTeamDto[]>>
{

    public constructor(init?: Partial<GetSimpleWorkflowTeamsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSimpleWorkflowTeamsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<SimpleTeamDto[]>(); }
}
(GetSimpleWorkflowTeamsRequest as unknown)[immerable] = true;

// @Route("/caseflow/simple-workflows/owners", "GET")
export class GetSimpleWorkflowOwnersRequest implements IReturn<ResponseBase<UserDto[]>>
{

    public constructor(init?: Partial<GetSimpleWorkflowOwnersRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSimpleWorkflowOwnersRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<UserDto[]>(); }
}
(GetSimpleWorkflowOwnersRequest as unknown)[immerable] = true;

// @Route("/caseflow/simple-workflows/workflow/{WorkflowId}/referring-contact", "POST")
export class UpdateSimpleWorkflowReferringContactRequest implements IReturn<ResponseBase<SimpleWorkflowDetailResponse>>, ISecurityId
{
    public workflowId: number;
    public securityId: number;
    public referringContactId?: number;

    public constructor(init?: Partial<UpdateSimpleWorkflowReferringContactRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateSimpleWorkflowReferringContactRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SimpleWorkflowDetailResponse>(); }
}
(UpdateSimpleWorkflowReferringContactRequest as unknown)[immerable] = true;

// @Route("/caseflow/simple-workflows/workflow/{WorkflowId}/customer-resolution", "POST")
export class ResolveSimpleWorkflowCustomerRequest implements IReturn<ResponseBase<SimpleWorkflowDetailResponse>>, ISecurityId
{
    public workflowId: number;
    public securityId: number;
    public existingCustomerId?: number;
    public createNewCustomer: boolean;

    public constructor(init?: Partial<ResolveSimpleWorkflowCustomerRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ResolveSimpleWorkflowCustomerRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SimpleWorkflowDetailResponse>(); }
}
(ResolveSimpleWorkflowCustomerRequest as unknown)[immerable] = true;

// @Route("/caseflow/simple-workflows/workflow/{WorkflowId}/scheduled-actions/{JobId}/trigger", "POST")
export class TriggerScheduledActionRequest implements IReturn<ResponseBase<SimpleWorkflowDetailResponse>>, ISecurityId
{
    public workflowId: number;
    public securityId: number;
    public jobId: string;

    public constructor(init?: Partial<TriggerScheduledActionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TriggerScheduledActionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SimpleWorkflowDetailResponse>(); }
}
(TriggerScheduledActionRequest as unknown)[immerable] = true;

// @Route("/caseflow/simple-workflows/workflow/{WorkflowId}/scheduled-actions/{JobId}/cancel", "POST")
export class CancelScheduledActionRequest implements IReturn<ResponseBase<SimpleWorkflowDetailResponse>>, ISecurityId
{
    public workflowId: number;
    public securityId: number;
    public jobId: string;

    public constructor(init?: Partial<CancelScheduledActionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CancelScheduledActionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SimpleWorkflowDetailResponse>(); }
}
(CancelScheduledActionRequest as unknown)[immerable] = true;

// @Route("/portal/referral/{WorkflowId}/simple-workflow/action", "POST")
export class ReferralPortalSimpleWorkflowActionRequest implements IReturn<ResponseBase<ReferralPortalSimpleWorkflowResponse>>
{
    public workflowId: number;
    public actionCode: string;
    public ownerId?: string;
    public teamId?: string;
    public dueDate?: string;
    public note: string;

    public constructor(init?: Partial<ReferralPortalSimpleWorkflowActionRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReferralPortalSimpleWorkflowActionRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<ReferralPortalSimpleWorkflowResponse>(); }
}
(ReferralPortalSimpleWorkflowActionRequest as unknown)[immerable] = true;

// @Route("/caseflow/simple-workflow/mappings/{GroupId}", "GET")
export class GetSimpleWorkflowMappingsRequest implements IReturn<ResponseBase<SimpleWorkflowMappingsResponse>>
{
    public groupId: number;

    public constructor(init?: Partial<GetSimpleWorkflowMappingsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSimpleWorkflowMappingsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<SimpleWorkflowMappingsResponse>(); }
}
(GetSimpleWorkflowMappingsRequest as unknown)[immerable] = true;

// @Route("/caseflow/simple-workflow/mapping", "POST")
export class SaveSimpleWorkflowMappingRequest implements IReturn<ResponseBase<SimpleWorkflowMappingDto>>
{
    public groupId: number;
    public onlineClinicServiceId: string;
    public enabled: boolean;
    public allowAppointmentlessReferral: boolean;
    public portalBookingMode?: PortalBookingModes;
    public processId: string;
    public defaultStatusId?: string;
    public defaultTeamId?: string;
    public defaultOwnerId?: string;
    public templateId?: string;

    public constructor(init?: Partial<SaveSimpleWorkflowMappingRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveSimpleWorkflowMappingRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<SimpleWorkflowMappingDto>(); }
}
(SaveSimpleWorkflowMappingRequest as unknown)[immerable] = true;

// @Route("/caseflow/simple-workflow/mapping/{Id}", "DELETE")
export class DeleteSimpleWorkflowMappingRequest implements IReturn<ResponseBase<boolean>>
{
    public id: number;
    public groupId: number;

    public constructor(init?: Partial<DeleteSimpleWorkflowMappingRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteSimpleWorkflowMappingRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(DeleteSimpleWorkflowMappingRequest as unknown)[immerable] = true;

// @Route("/caseflow/simple-workflow/portal-enabled", "POST")
export class SetReferralPortalEnabledRequest implements IReturn<ResponseBase<boolean>>
{
    public groupId: number;
    public enabled: boolean;

    public constructor(init?: Partial<SetReferralPortalEnabledRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetReferralPortalEnabledRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<boolean>(); }
}
(SetReferralPortalEnabledRequest as unknown)[immerable] = true;

// @Route("/caseflow/simple-workflow/connect-services/{GroupId}", "GET")
export class GetConnectServicesForGroupRequest implements IReturn<ResponseBase<SimpleWorkflowConnectServiceResponse>>
{
    public groupId: number;
    public includeHidden: boolean;

    public constructor(init?: Partial<GetConnectServicesForGroupRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetConnectServicesForGroupRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<SimpleWorkflowConnectServiceResponse>(); }
}
(GetConnectServicesForGroupRequest as unknown)[immerable] = true;

// @Route("/caseflow/simple-workflow/connect-services/group-filter", "POST")
export class GetGroupsWithConnectServicesRequest implements IReturn<ResponseBase<number>>
{
    public groupIds: number[];
    public includeHidden: boolean;

    public constructor(init?: Partial<GetGroupsWithConnectServicesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetGroupsWithConnectServicesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseBase<number>(); }
}
(GetGroupsWithConnectServicesRequest as unknown)[immerable] = true;

// @Route("/caseflow/simple-workflow/referral-templates", "GET")
export class GetSimpleWorkflowReferralTemplatesRequest implements IReturn<ResponseBase<CaseflowTemplateDto>>
{
    public includeBody: boolean;
    public includeLists: boolean;

    public constructor(init?: Partial<GetSimpleWorkflowReferralTemplatesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSimpleWorkflowReferralTemplatesRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CaseflowTemplateDto>(); }
}
(GetSimpleWorkflowReferralTemplatesRequest as unknown)[immerable] = true;

// @Route("/caseflow/simple-workflow/referral-templates/{TemplateId}", "GET")
export class GetSimpleWorkflowReferralTemplateRequest implements IReturn<ResponseBase<CaseflowTemplateDto>>
{
    public templateId: string;
    public includeBody: boolean;
    public includeLists: boolean;

    public constructor(init?: Partial<GetSimpleWorkflowReferralTemplateRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSimpleWorkflowReferralTemplateRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<CaseflowTemplateDto>(); }
}
(GetSimpleWorkflowReferralTemplateRequest as unknown)[immerable] = true;

// @Route("/caseflow/simple-workflow/referral-templates/{TemplateId}/customer/{CustomerId}", "GET")
export class GetSimpleWorkflowReferralTemplateInitialDataRequest implements IReturn<ResponseBase<JsonField>>, ICustomerId
{
    public templateId: string;
    public customerId: number;

    public constructor(init?: Partial<GetSimpleWorkflowReferralTemplateInitialDataRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSimpleWorkflowReferralTemplateInitialDataRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ResponseBase<JsonField>(); }
}
(GetSimpleWorkflowReferralTemplateInitialDataRequest as unknown)[immerable] = true;

/** @description List auth codes */
// @Route("/v1/auth-codes", "GET")
// @Route("/v1/customers/{CustomerId}/auth-codes", "GET")
// @Api(Description="List auth codes")
export class GetAuthCodesV1Request implements IReturn<GetAuthCodesV1Response>
{
    /** @description Page number (default 1) */
    // @ApiMember(Description="Page number (default 1)")
    public page: number;

    /** @description Items per page (default 25, max 100) */
    // @ApiMember(Description="Items per page (default 25, max 100)")
    public perPage: number;

    /** @description Filter by business GUID */
    // @ApiMember(Description="Filter by business GUID")
    public businessId?: string;

    /** @description Customer GUID (path on /v1/customers/{CustomerId}/auth-codes; filter on /v1/auth-codes) */
    // @ApiMember(Description="Customer GUID (path on /v1/customers/{CustomerId}/auth-codes; filter on /v1/auth-codes)")
    public customerId?: string;

    /** @description Filter by expiration status */
    // @ApiMember(Description="Filter by expiration status")
    public isExpired?: boolean;

    /** @description Filter by exhausted status */
    // @ApiMember(Description="Filter by exhausted status")
    public isExhausted?: boolean;

    public constructor(init?: Partial<GetAuthCodesV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAuthCodesV1Request'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetAuthCodesV1Response(); }
}
(GetAuthCodesV1Request as unknown)[immerable] = true;

/** @description List customer auth codes */
// @Route("/v1/customers/{CustomerId}/auth-codes", "GET")
// @Api(Description="List customer auth codes")
export class GetCustomerAuthCodesV1Request implements IReturn<GetAuthCodesV1Response>
{
    /** @description Customer GUID */
    // @ApiMember(Description="Customer GUID", IsRequired=true, ParameterType="path")
    public customerId: string;

    /** @description Page number (default 1) */
    // @ApiMember(Description="Page number (default 1)", ParameterType="query")
    public page: number;

    /** @description Items per page (default 25, max 100) */
    // @ApiMember(Description="Items per page (default 25, max 100)", ParameterType="query")
    public perPage: number;

    /** @description Filter by business GUID */
    // @ApiMember(Description="Filter by business GUID", ParameterType="query")
    public businessId?: string;

    /** @description Filter by expiration status */
    // @ApiMember(Description="Filter by expiration status", ParameterType="query")
    public isExpired?: boolean;

    /** @description Filter by exhausted status */
    // @ApiMember(Description="Filter by exhausted status", ParameterType="query")
    public isExhausted?: boolean;

    public constructor(init?: Partial<GetCustomerAuthCodesV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCustomerAuthCodesV1Request'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetAuthCodesV1Response(); }
}
(GetCustomerAuthCodesV1Request as unknown)[immerable] = true;

/** @description Get auth code by ID */
// @Route("/v1/auth-codes/{Id}", "GET")
// @Api(Description="Get auth code by ID")
export class GetAuthCodeV1Request implements IReturn<AuthCodeV1Dto>
{
    /** @description Auth code GUID */
    // @ApiMember(Description="Auth code GUID", IsRequired=true, ParameterType="path")
    public id: string;

    public constructor(init?: Partial<GetAuthCodeV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAuthCodeV1Request'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AuthCodeV1Dto(); }
}
(GetAuthCodeV1Request as unknown)[immerable] = true;

/** @description Create auth code */
// @Route("/v1/auth-codes", "POST")
// @Api(Description="Create auth code")
export class CreateAuthCodeV1Request implements IReturn<AuthCodeV1Dto>
{
    /** @description Auth code */
    // @ApiMember(Description="Auth code", IsRequired=true, ParameterType="model")
    public code: string;

    /** @description Business GUID */
    // @ApiMember(Description="Business GUID", IsRequired=true, ParameterType="model")
    public businessId: string;

    /** @description Customer GUID */
    // @ApiMember(Description="Customer GUID", IsRequired=true, ParameterType="model")
    public customerId: string;

    /** @description Case GUID */
    // @ApiMember(Description="Case GUID", ParameterType="model")
    public caseId?: string;

    /** @description Service type GUID */
    // @ApiMember(Description="Service type GUID", ParameterType="model")
    public serviceTypeId?: string;

    /** @description Used for */
    // @ApiMember(Description="Used for", ParameterType="model")
    public usedFor: string;

    /** @description Maximum treatments */
    // @ApiMember(Description="Maximum treatments", IsRequired=true, ParameterType="model")
    public maxTreatments: number;

    /** @description Maximum value */
    // @ApiMember(Description="Maximum value", ParameterType="model")
    public maxValue?: number;

    /** @description Start date */
    // @ApiMember(Description="Start date", ParameterType="model")
    public startDate?: string;

    /** @description Expiry date */
    // @ApiMember(Description="Expiry date", ParameterType="model")
    public expiryDate?: string;

    public constructor(init?: Partial<CreateAuthCodeV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateAuthCodeV1Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AuthCodeV1Dto(); }
}
(CreateAuthCodeV1Request as unknown)[immerable] = true;

/** @description Update auth code */
// @Route("/v1/auth-codes/{Id}", "PATCH")
// @Api(Description="Update auth code")
export class UpdateAuthCodeV1Request implements IReturn<AuthCodeV1Dto>
{
    /** @description Auth code GUID */
    // @ApiMember(Description="Auth code GUID", IsRequired=true, ParameterType="path")
    public id: string;

    /** @description Updated auth code */
    // @ApiMember(Description="Updated auth code", ParameterType="model")
    public code: string;

    /** @description Updated maximum treatments */
    // @ApiMember(Description="Updated maximum treatments", ParameterType="model")
    public maxTreatments?: number;

    /** @description Updated maximum value */
    // @ApiMember(Description="Updated maximum value", ParameterType="model")
    public maxValue?: number;

    /** @description Updated start date */
    // @ApiMember(Description="Updated start date", ParameterType="model")
    public startDate?: string;

    /** @description Updated expiry date */
    // @ApiMember(Description="Updated expiry date", ParameterType="model")
    public expiryDate?: string;

    /** @description Updated used-for value */
    // @ApiMember(Description="Updated used-for value", ParameterType="model")
    public usedFor: string;

    public constructor(init?: Partial<UpdateAuthCodeV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateAuthCodeV1Request'; }
    public getMethod() { return 'PATCH'; }
    public createResponse() { return new AuthCodeV1Dto(); }
}
(UpdateAuthCodeV1Request as unknown)[immerable] = true;

/** @description Search available appointment slots */
// @Route("/v1/availability/slots", "POST")
// @Api(Description="Search available appointment slots")
export class GetAvailabilitySlotsV1Request implements IReturn<GetAvailabilitySlotsV1Response>
{
    /** @description Start date for availability search */
    // @ApiMember(Description="Start date for availability search", IsRequired=true, ParameterType="model")
    public dateFrom: string;

    /** @description End date for availability search */
    // @ApiMember(Description="End date for availability search", IsRequired=true, ParameterType="model")
    public dateTo: string;

    /** @description Filter by location GUIDs */
    // @ApiMember(Description="Filter by location GUIDs", ParameterType="model")
    public locationIds: string[];

    /** @description Filter by practitioner GUIDs */
    // @ApiMember(Description="Filter by practitioner GUIDs", ParameterType="model")
    public practitionerIds: string[];

    /** @description Filter by stock GUID */
    // @ApiMember(Description="Filter by stock GUID", ParameterType="model")
    public stockId?: string;

    /** @description Filter by service type GUID */
    // @ApiMember(Description="Filter by service type GUID", ParameterType="model")
    public serviceTypeId?: string;

    /** @description Override appointment length in minutes */
    // @ApiMember(Description="Override appointment length in minutes", ParameterType="model")
    public appointmentLengthMinutes?: number;

    /** @description Time-of-day filter */
    // @ApiMember(Description="Time-of-day filter", ParameterType="model")
    public timeOfDay: string;

    /** @description Filter by business GUID */
    // @ApiMember(Description="Filter by business GUID", ParameterType="model")
    public businessId?: string;

    public constructor(init?: Partial<GetAvailabilitySlotsV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAvailabilitySlotsV1Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetAvailabilitySlotsV1Response(); }
}
(GetAvailabilitySlotsV1Request as unknown)[immerable] = true;

/** @description Search available practitioner sessions */
// @Route("/v1/availability/sessions", "POST")
// @Api(Description="Search available practitioner sessions")
export class GetAvailabilitySessionsV1Request implements IReturn<GetAvailabilitySessionsV1Response>
{
    /** @description Start date for session search */
    // @ApiMember(Description="Start date for session search", IsRequired=true, ParameterType="model")
    public dateFrom: string;

    /** @description End date for session search */
    // @ApiMember(Description="End date for session search", IsRequired=true, ParameterType="model")
    public dateTo: string;

    /** @description Filter by location GUIDs */
    // @ApiMember(Description="Filter by location GUIDs", ParameterType="model")
    public locationIds: string[];

    /** @description Filter by practitioner GUIDs */
    // @ApiMember(Description="Filter by practitioner GUIDs", ParameterType="model")
    public practitionerIds: string[];

    /** @description Include sessions not marked for online booking */
    // @ApiMember(Description="Include sessions not marked for online booking", ParameterType="model")
    public includeNonOnlineSessions: boolean;

    public constructor(init?: Partial<GetAvailabilitySessionsV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAvailabilitySessionsV1Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetAvailabilitySessionsV1Response(); }
}
(GetAvailabilitySessionsV1Request as unknown)[immerable] = true;

/** @description Create booking */
// @Api(Description="Create booking")
export class CreateBookingV1Request implements IReturn<CreateBookingV1Response>
{
    /** @description Booking start date/time */
    // @ApiMember(Description="Booking start date/time", IsRequired=true, ParameterType="model")
    public startDateTime: string;

    /** @description Booking end date/time */
    // @ApiMember(Description="Booking end date/time", IsRequired=true, ParameterType="model")
    public endDateTime: string;

    /** @description Practitioner GUID */
    // @ApiMember(Description="Practitioner GUID", IsRequired=true, ParameterType="model")
    public practitionerId: string;

    /** @description Location GUID */
    // @ApiMember(Description="Location GUID", IsRequired=true, ParameterType="model")
    public locationId: string;

    /** @description Customer GUID */
    // @ApiMember(Description="Customer GUID", ParameterType="model")
    public customerId?: string;

    /** @description Room GUID */
    // @ApiMember(Description="Room GUID", ParameterType="model")
    public roomId?: string;

    /** @description Stock GUID */
    // @ApiMember(Description="Stock GUID", ParameterType="model")
    public stockId?: string;

    /** @description Connect service GUID */
    // @ApiMember(Description="Connect service GUID", ParameterType="model")
    public connectServiceId?: string;

    /** @description Business GUID */
    // @ApiMember(Description="Business GUID", ParameterType="model")
    public businessId?: string;

    /** @description Auth code GUID */
    // @ApiMember(Description="Auth code GUID", ParameterType="model")
    public authId?: string;

    /** @description Case GUID */
    // @ApiMember(Description="Case GUID", ParameterType="model")
    public caseId?: string;

    /** @description Workflow GUID */
    // @ApiMember(Description="Workflow GUID", ParameterType="model")
    public workflowId?: string;

    /** @description First appointment flag */
    // @ApiMember(Description="First appointment flag", ParameterType="model")
    public firstAppointment: boolean;

    /** @description Booking type. Allowed values: A = appointment, C = class/course, H = holiday, O = other, M = meeting. */
    // @ApiMember(Description="Booking type. Allowed values: A = appointment, C = class/course, H = holiday, O = other, M = meeting.", IsRequired=true, ParameterType="model")
    public type: string;

    /** @description Booking name */
    // @ApiMember(Description="Booking name", ParameterType="model")
    public name: string;

    /** @description Booking comment */
    // @ApiMember(Description="Booking comment", ParameterType="model")
    public comment: string;

    /** @description Send confirmation */
    // @ApiMember(Description="Send confirmation", ParameterType="model")
    public sendConfirmation: boolean;

    public constructor(init?: Partial<CreateBookingV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateBookingV1Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateBookingV1Response(); }
}
(CreateBookingV1Request as unknown)[immerable] = true;

/** @description Create appointment */
// @Route("/v1/appointments", "POST")
// @Api(Description="Create appointment")
export class CreateAppointmentV1Request implements IReturn<CreateBookingV1Response>
{
    /** @description Appointment start date/time */
    // @ApiMember(Description="Appointment start date/time", IsRequired=true, ParameterType="model")
    public startDateTime: string;

    /** @description Appointment end date/time */
    // @ApiMember(Description="Appointment end date/time", IsRequired=true, ParameterType="model")
    public endDateTime: string;

    /** @description Practitioner GUID */
    // @ApiMember(Description="Practitioner GUID", IsRequired=true, ParameterType="model")
    public practitionerId: string;

    /** @description Location GUID */
    // @ApiMember(Description="Location GUID", IsRequired=true, ParameterType="model")
    public locationId: string;

    /** @description Customer GUID */
    // @ApiMember(Description="Customer GUID", IsRequired=true, ParameterType="model")
    public customerId: string;

    /** @description Room GUID */
    // @ApiMember(Description="Room GUID", ParameterType="model")
    public roomId?: string;

    /** @description Stock GUID */
    // @ApiMember(Description="Stock GUID", IsRequired=true, ParameterType="model")
    public stockId: string;

    /** @description Connect service GUID */
    // @ApiMember(Description="Connect service GUID", ParameterType="model")
    public connectServiceId?: string;

    /** @description Business GUID */
    // @ApiMember(Description="Business GUID", ParameterType="model")
    public businessId?: string;

    /** @description Auth code GUID */
    // @ApiMember(Description="Auth code GUID", ParameterType="model")
    public authId?: string;

    /** @description Case GUID */
    // @ApiMember(Description="Case GUID", IsRequired=true, ParameterType="model")
    public caseId: string;

    /** @description Workflow GUID */
    // @ApiMember(Description="Workflow GUID", ParameterType="model")
    public workflowId?: string;

    /** @description First appointment flag */
    // @ApiMember(Description="First appointment flag", ParameterType="model")
    public firstAppointment: boolean;

    /** @description Appointment name */
    // @ApiMember(Description="Appointment name", ParameterType="model")
    public name: string;

    /** @description Appointment comment */
    // @ApiMember(Description="Appointment comment", ParameterType="model")
    public comment: string;

    /** @description Send confirmation */
    // @ApiMember(Description="Send confirmation", ParameterType="model")
    public sendConfirmation: boolean;

    public constructor(init?: Partial<CreateAppointmentV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateAppointmentV1Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateBookingV1Response(); }
}
(CreateAppointmentV1Request as unknown)[immerable] = true;

/** @description Get appointment by ID */
// @Route("/v1/appointments/{Id}", "GET")
// @Api(Description="Get appointment by ID")
export class GetBookingV1Request implements IReturn<BookingV1Dto>
{
    /** @description Appointment GUID */
    // @ApiMember(Description="Appointment GUID", IsRequired=true, ParameterType="path")
    public id: string;

    public constructor(init?: Partial<GetBookingV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetBookingV1Request'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BookingV1Dto(); }
}
(GetBookingV1Request as unknown)[immerable] = true;

/** @description Cancel appointment */
// @Route("/v1/appointments/{Id}", "DELETE")
// @Api(Description="Cancel appointment")
export class CancelBookingV1Request implements IReturn<BookingV1Dto>
{
    /** @description Appointment GUID */
    // @ApiMember(Description="Appointment GUID", IsRequired=true, ParameterType="path")
    public id: string;

    /** @description Cancellation reason */
    // @ApiMember(Description="Cancellation reason")
    public cancellationReason: string;

    public constructor(init?: Partial<CancelBookingV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CancelBookingV1Request'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new BookingV1Dto(); }
}
(CancelBookingV1Request as unknown)[immerable] = true;

/** @description Create appointment reservation */
// @Route("/v1/appointments/reserve", "POST")
// @Api(Description="Create appointment reservation")
export class ReserveAppointmentV1Request implements IReturn<ReserveAppointmentV1Response>
{
    /** @description Practitioner GUID */
    // @ApiMember(Description="Practitioner GUID", IsRequired=true, ParameterType="model")
    public practitionerId: string;

    /** @description Location GUID */
    // @ApiMember(Description="Location GUID", IsRequired=true, ParameterType="model")
    public locationId: string;

    /** @description Room GUID */
    // @ApiMember(Description="Room GUID", ParameterType="model")
    public roomId?: string;

    /** @description Appointment start date/time */
    // @ApiMember(Description="Appointment start date/time", IsRequired=true, ParameterType="model")
    public startDateTime: string;

    /** @description Appointment end date/time */
    // @ApiMember(Description="Appointment end date/time", IsRequired=true, ParameterType="model")
    public endDateTime: string;

    /** @description Stock GUID */
    // @ApiMember(Description="Stock GUID", IsRequired=true, ParameterType="model")
    public stockId: string;

    /** @description Case GUID */
    // @ApiMember(Description="Case GUID", ParameterType="model")
    public caseId?: string;

    public constructor(init?: Partial<ReserveAppointmentV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReserveAppointmentV1Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ReserveAppointmentV1Response(); }
}
(ReserveAppointmentV1Request as unknown)[immerable] = true;

/** @description Delete appointment reservation */
// @Route("/v1/appointments/reserve/{Id}", "DELETE")
// @Api(Description="Delete appointment reservation")
export class DeleteAppointmentReserveV1Request implements IReturn<DeletedV1Response>
{
    /** @description Temporary appointment GUID (path parameter) */
    // @ApiMember(Description="Temporary appointment GUID (path parameter)", IsRequired=true, ParameterType="path")
    public id: string;

    public constructor(init?: Partial<DeleteAppointmentReserveV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteAppointmentReserveV1Request'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new DeletedV1Response(); }
}
(DeleteAppointmentReserveV1Request as unknown)[immerable] = true;

/** @description Confirm appointment reservation */
// @Route("/v1/appointments/confirm", "POST")
// @Api(Description="Confirm appointment reservation")
export class ConfirmAppointmentReserveV1Request implements IReturn<BookingV1Dto>
{
    /** @description Temporary appointment GUID */
    // @ApiMember(Description="Temporary appointment GUID", IsRequired=true, ParameterType="model")
    public id: string;

    /** @description Customer GUID */
    // @ApiMember(Description="Customer GUID", IsRequired=true, ParameterType="model")
    public customerId: string;

    /** @description Temporary appointment cleanup job ID */
    // @ApiMember(Description="Temporary appointment cleanup job ID", ParameterType="model")
    public backgroundJobId: string;

    /** @description Booking method override */
    // @ApiMember(Description="Booking method override", ParameterType="model")
    public bookingMethod: string;

    /** @description Auth code GUID */
    // @ApiMember(Description="Auth code GUID", ParameterType="model")
    public authId?: string;

    /** @description Business GUID */
    // @ApiMember(Description="Business GUID", ParameterType="model")
    public businessId?: string;

    /** @description Stock GUID */
    // @ApiMember(Description="Stock GUID", ParameterType="model")
    public stockId?: string;

    /** @description Case GUID */
    // @ApiMember(Description="Case GUID", ParameterType="model")
    public caseId?: string;

    public constructor(init?: Partial<ConfirmAppointmentReserveV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ConfirmAppointmentReserveV1Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BookingV1Dto(); }
}
(ConfirmAppointmentReserveV1Request as unknown)[immerable] = true;

/** @description Search appointments */
// @Route("/v1/appointments/search", "POST")
// @Api(Description="Search appointments")
export class SearchBookingsV1Request implements IReturn<SearchBookingsV1Response>
{
    /** @description Filter by date from (inclusive) */
    // @ApiMember(Description="Filter by date from (inclusive)", ParameterType="model")
    public dateFrom?: string;

    /** @description Filter by date to (inclusive) */
    // @ApiMember(Description="Filter by date to (inclusive)", ParameterType="model")
    public dateTo?: string;

    /** @description Filter by location GUIDs */
    // @ApiMember(Description="Filter by location GUIDs", ParameterType="model")
    public locationIds: string[];

    /** @description Filter by practitioner GUIDs */
    // @ApiMember(Description="Filter by practitioner GUIDs", ParameterType="model")
    public practitionerIds: string[];

    /** @description Customer GUID (path on GET /v1/customers/{CustomerId}/appointments; filter on POST /v1/appointments/search) */
    // @ApiMember(Description="Customer GUID (path on GET /v1/customers/{CustomerId}/appointments; filter on POST /v1/appointments/search)", ParameterType="model")
    public customerId?: string;

    /** @description Filter by business GUID */
    // @ApiMember(Description="Filter by business GUID", ParameterType="model")
    public businessId?: string;

    /** @description Filter by booking statuses */
    // @ApiMember(Description="Filter by booking statuses", ParameterType="model")
    public statuses: number[];

    /** @description Filter by service type GUID */
    // @ApiMember(Description="Filter by service type GUID", ParameterType="model")
    public serviceTypeId?: string;

    /** @description Page number (default 1) */
    // @ApiMember(Description="Page number (default 1)", ParameterType="model")
    public page: number;

    /** @description Items per page (default 20, max 100) */
    // @ApiMember(Description="Items per page (default 20, max 100)", ParameterType="model")
    public perPage: number;

    public constructor(init?: Partial<SearchBookingsV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SearchBookingsV1Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SearchBookingsV1Response(); }
}
(SearchBookingsV1Request as unknown)[immerable] = true;

/** @description List customer appointments */
// @Route("/v1/customers/{CustomerId}/appointments", "GET")
// @Api(Description="List customer appointments")
export class GetCustomerAppointmentsV1Request implements IReturn<SearchBookingsV1Response>
{
    /** @description Customer GUID */
    // @ApiMember(Description="Customer GUID", IsRequired=true, ParameterType="path")
    public customerId: string;

    /** @description Filter by date from (inclusive) */
    // @ApiMember(Description="Filter by date from (inclusive)", ParameterType="query")
    public dateFrom?: string;

    /** @description Filter by date to (inclusive) */
    // @ApiMember(Description="Filter by date to (inclusive)", ParameterType="query")
    public dateTo?: string;

    /** @description Filter by location GUIDs */
    // @ApiMember(Description="Filter by location GUIDs", ParameterType="query")
    public locationIds: string[];

    /** @description Filter by practitioner GUIDs */
    // @ApiMember(Description="Filter by practitioner GUIDs", ParameterType="query")
    public practitionerIds: string[];

    /** @description Filter by business GUID */
    // @ApiMember(Description="Filter by business GUID", ParameterType="query")
    public businessId?: string;

    /** @description Filter by booking statuses */
    // @ApiMember(Description="Filter by booking statuses", ParameterType="query")
    public statuses: number[];

    /** @description Filter by service type GUID */
    // @ApiMember(Description="Filter by service type GUID", ParameterType="query")
    public serviceTypeId?: string;

    /** @description Page number (default 1) */
    // @ApiMember(Description="Page number (default 1)", ParameterType="query")
    public page: number;

    /** @description Items per page (default 20, max 100) */
    // @ApiMember(Description="Items per page (default 20, max 100)", ParameterType="query")
    public perPage: number;

    public constructor(init?: Partial<GetCustomerAppointmentsV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCustomerAppointmentsV1Request'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SearchBookingsV1Response(); }
}
(GetCustomerAppointmentsV1Request as unknown)[immerable] = true;

/** @description List businesses */
// @Route("/v1/businesses", "GET")
// @Api(Description="List businesses")
export class GetBusinessesV1Request implements IReturn<GetBusinessesV1Response>
{
    /** @description Page number (default 1) */
    // @ApiMember(Description="Page number (default 1)")
    public page: number;

    /** @description Items per page (default 25, max 100) */
    // @ApiMember(Description="Items per page (default 25, max 100)")
    public perPage: number;

    /** @description Filter by online-enabled status */
    // @ApiMember(Description="Filter by online-enabled status")
    public online?: boolean;

    public constructor(init?: Partial<GetBusinessesV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetBusinessesV1Request'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetBusinessesV1Response(); }
}
(GetBusinessesV1Request as unknown)[immerable] = true;

/** @description Get business by GUID */
// @Route("/v1/businesses/{Id}", "GET")
// @Api(Description="Get business by GUID")
export class GetBusinessV1Request implements IReturn<BusinessV1Dto>
{
    /** @description Business GUID */
    // @ApiMember(Description="Business GUID", IsRequired=true, ParameterType="path")
    public id: string;

    public constructor(init?: Partial<GetBusinessV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetBusinessV1Request'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BusinessV1Dto(); }
}
(GetBusinessV1Request as unknown)[immerable] = true;

/** @description Get all cases (paginated) */
// @Route("/v1/cases", "GET")
// @Api(Description="Get all cases (paginated)")
export class GetCasesV1Request implements IReturn<PaginatedResponseV1<CaseV1Dto>>
{
    /** @description Page number (default 1) */
    // @ApiMember(Description="Page number (default 1)")
    public page: number;

    /** @description Items per page (default 25, max 100) */
    // @ApiMember(Description="Items per page (default 25, max 100)")
    public perPage: number;

    /** @description Filter by status */
    // @ApiMember(Description="Filter by status")
    public status: string;

    /** @description Filter by service type GUID */
    // @ApiMember(Description="Filter by service type GUID")
    public serviceTypeId?: string;

    public constructor(init?: Partial<GetCasesV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCasesV1Request'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PaginatedResponseV1<CaseV1Dto>(); }
}
(GetCasesV1Request as unknown)[immerable] = true;

/** @description Get a single case by ID */
// @Route("/v1/cases/{Id}", "GET")
// @Api(Description="Get a single case by ID")
export class GetCaseV1Request implements IReturn<CaseV1Dto>
{
    /** @description Case GlobalId */
    // @ApiMember(Description="Case GlobalId", IsRequired=true, ParameterType="path")
    public id: string;

    public constructor(init?: Partial<GetCaseV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCaseV1Request'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CaseV1Dto(); }
}
(GetCaseV1Request as unknown)[immerable] = true;

/** @description Get all cases for a customer (paginated) */
// @Route("/v1/customers/{CustomerId}/cases", "GET")
// @Api(Description="Get all cases for a customer (paginated)")
export class GetCustomerCasesV1Request implements IReturn<PaginatedResponseV1<CaseV1Dto>>
{
    /** @description Customer GUID */
    // @ApiMember(Description="Customer GUID", IsRequired=true, ParameterType="path")
    public customerId: string;

    /** @description Page number (default 1) */
    // @ApiMember(Description="Page number (default 1)")
    public page: number;

    /** @description Items per page (default 25, max 100) */
    // @ApiMember(Description="Items per page (default 25, max 100)")
    public perPage: number;

    public constructor(init?: Partial<GetCustomerCasesV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCustomerCasesV1Request'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PaginatedResponseV1<CaseV1Dto>(); }
}
(GetCustomerCasesV1Request as unknown)[immerable] = true;

/** @description Create a new case */
// @Route("/v1/cases", "POST")
// @Api(Description="Create a new case")
export class CreateCaseV1Request implements IReturn<CaseV1Dto>
{
    /** @description Customer GUID */
    // @ApiMember(Description="Customer GUID", IsRequired=true, ParameterType="model")
    public customerId: string;

    /** @description Practitioner GUID */
    // @ApiMember(Description="Practitioner GUID", ParameterType="model")
    public practitionerId?: string;

    /** @description Service type GUID */
    // @ApiMember(Description="Service type GUID", ParameterType="model")
    public serviceTypeId?: string;

    /** @description Diagnosis */
    // @ApiMember(Description="Diagnosis", ParameterType="model")
    public diagnosis: string;

    /** @description Clinical notes */
    // @ApiMember(Description="Clinical notes", ParameterType="model")
    public notes: string;

    /** @description Admission date */
    // @ApiMember(Description="Admission date", ParameterType="model")
    public admissionDate?: string;

    /** @description Body Site */
    // @ApiMember(Description="Body Site", ParameterType="model")
    public bodySite: string;

    public constructor(init?: Partial<CreateCaseV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateCaseV1Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CaseV1Dto(); }
}
(CreateCaseV1Request as unknown)[immerable] = true;

/** @description Update an existing case */
// @Route("/v1/cases/{Id}", "PATCH")
// @Api(Description="Update an existing case")
export class UpdateCaseV1Request implements IReturn<CaseV1Dto>
{
    /** @description Case GlobalId */
    // @ApiMember(Description="Case GlobalId", IsRequired=true, ParameterType="path")
    public id: string;

    /** @description Practitioner GUID */
    // @ApiMember(Description="Practitioner GUID", ParameterType="model")
    public practitionerId?: string;

    /** @description Service type GUID */
    // @ApiMember(Description="Service type GUID", ParameterType="model")
    public serviceTypeId?: string;

    /** @description Diagnosis */
    // @ApiMember(Description="Diagnosis", ParameterType="model")
    public diagnosis: string;

    /** @description Clinical notes */
    // @ApiMember(Description="Clinical notes", ParameterType="model")
    public notes: string;

    public constructor(init?: Partial<UpdateCaseV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateCaseV1Request'; }
    public getMethod() { return 'PATCH'; }
    public createResponse() { return new CaseV1Dto(); }
}
(UpdateCaseV1Request as unknown)[immerable] = true;

/** @description Close a case */
// @Route("/v1/cases/close", "POST")
// @Api(Description="Close a case")
export class CloseCaseV1Request implements IReturn<CaseV1Dto>
{
    /** @description Case GlobalId */
    // @ApiMember(Description="Case GlobalId", IsRequired=true, ParameterType="model")
    public id: string;

    public constructor(init?: Partial<CloseCaseV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CloseCaseV1Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CaseV1Dto(); }
}
(CloseCaseV1Request as unknown)[immerable] = true;

/** @description Discharge a case */
// @Route("/v1/cases/discharge", "POST")
// @Api(Description="Discharge a case")
export class DischargeCaseV1Request implements IReturn<CaseV1Dto>
{
    /** @description Case GlobalId */
    // @ApiMember(Description="Case GlobalId", IsRequired=true, ParameterType="model")
    public id: string;

    /** @description Discharge date */
    // @ApiMember(Description="Discharge date", ParameterType="model")
    public dischargeDate?: string;

    public constructor(init?: Partial<DischargeCaseV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DischargeCaseV1Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CaseV1Dto(); }
}
(DischargeCaseV1Request as unknown)[immerable] = true;

/** @description Send an approved templated email or SMS to a customer */
// @Route("/v1/customers/{Id}/contact", "POST")
// @Api(Description="Send an approved templated email or SMS to a customer")
export class SendCustomerContactV1Request implements IReturn<SendCustomerContactV1Response>
{
    /** @description Customer GUID */
    // @ApiMember(Description="Customer GUID", IsRequired=true, ParameterType="path")
    public id: string;

    /** @description Contact type: "email" or "sms". */
    // @ApiMember(Description="Contact type: \"email\" or \"sms\".", IsRequired=true, ParameterType="model")
    public type: string;

    /** @description File path of the approved template to merge and send, e.g. "webTemplates/patients/Welcome.wtemail" (as returned by /v1/templates/search). */
    // @ApiMember(Description="File path of the approved template to merge and send, e.g. \"webTemplates/patients/Welcome.wtemail\" (as returned by /v1/templates/search).", IsRequired=true, ParameterType="model")
    public templatePath: string;

    public constructor(init?: Partial<SendCustomerContactV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendCustomerContactV1Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendCustomerContactV1Response(); }
}
(SendCustomerContactV1Request as unknown)[immerable] = true;

/** @description Create a new customer */
// @Route("/v1/customers", "POST")
// @Api(Description="Create a new customer")
// @ValidateRequest(Condition="!IsNullOrWhiteSpace(Email) || !IsNullOrWhiteSpace(MobileTelephone)", ErrorCode="ContactRequired", Message="At least one of Email or MobileTelephone is required.")
export class CreateCustomerV1Request implements IReturn<CreateCustomerV1Response>
{
    /** @description Customer forename */
    // @ApiMember(Description="Customer forename", IsRequired=true, ParameterType="model")
    public foreName: string;

    /** @description Customer surname */
    // @ApiMember(Description="Customer surname", IsRequired=true, ParameterType="model")
    public surname: string;

    /** @description Email address. At least one of Email or MobileTelephone is required. */
    // @ApiMember(Description="Email address. At least one of Email or MobileTelephone is required.", ParameterType="model")
    public email: string;

    /** @description Mobile telephone. At least one of Email or MobileTelephone is required. */
    // @ApiMember(Description="Mobile telephone. At least one of Email or MobileTelephone is required.", ParameterType="model")
    public mobileTelephone: string;

    /** @description Home telephone. Optional; not sufficient on its own to satisfy the contact requirement. */
    // @ApiMember(Description="Home telephone. Optional; not sufficient on its own to satisfy the contact requirement.", ParameterType="model")
    public homeTelephone: string;

    /** @description Work telephone. Optional; not sufficient on its own to satisfy the contact requirement. */
    // @ApiMember(Description="Work telephone. Optional; not sufficient on its own to satisfy the contact requirement.", ParameterType="model")
    public workTelephone: string;

    /** @description Title */
    // @ApiMember(Description="Title", ParameterType="model")
    public title: string;

    /** @description Date of birth */
    // @ApiMember(Description="Date of birth", ParameterType="model")
    public dateOfBirth?: string;

    /** @description Gender */
    // @ApiMember(Description="Gender", ParameterType="model")
    public gender: string;

    /** @description Address line 1 */
    // @ApiMember(Description="Address line 1", ParameterType="model")
    public addressLine1: string;

    /** @description Address line 2 */
    // @ApiMember(Description="Address line 2", ParameterType="model")
    public addressLine2: string;

    /** @description Address line 3 */
    // @ApiMember(Description="Address line 3", ParameterType="model")
    public addressLine3: string;

    /** @description Address line 4 */
    // @ApiMember(Description="Address line 4", ParameterType="model")
    public addressLine4: string;

    /** @description Postcode */
    // @ApiMember(Description="Postcode", ParameterType="model")
    public postCode: string;

    /** @description Default location GUID */
    // @ApiMember(Description="Default location GUID", ParameterType="model")
    public defaultLocationId?: string;

    /** @description Default practitioner GUID */
    // @ApiMember(Description="Default practitioner GUID", ParameterType="model")
    public defaultPractitionerId?: string;

    /** @description Business GUID */
    // @ApiMember(Description="Business GUID", ParameterType="model")
    public businessId?: string;

    /** @description External reference */
    // @ApiMember(Description="External reference", ParameterType="model")
    public externalReference: string;

    /** @description SMS consent */
    // @ApiMember(Description="SMS consent", ParameterType="model")
    public smsConsent: boolean;

    /** @description Email consent */
    // @ApiMember(Description="Email consent", ParameterType="model")
    public emailConsent: boolean;

    /** @description Phone consent */
    // @ApiMember(Description="Phone consent", ParameterType="model")
    public phoneConsent: boolean;

    /** @description Consent to treatment */
    // @ApiMember(Description="Consent to treatment", ParameterType="model")
    public givenConsent: boolean;

    /** @description Customer status: 0=Inactive, 1=Active, -1=Deceased */
    // @ApiMember(Description="Customer status: 0=Inactive, 1=Active, -1=Deceased", ParameterType="model")
    public status?: number;

    /** @description Who pays for treatment: P=customer, G=business */
    // @ApiMember(Description="Who pays for treatment: P=customer, G=business", ParameterType="model")
    public billTo: string;

    /** @description Invoice period */
    // @ApiMember(Description="Invoice period", ParameterType="model")
    public invoicePeriod: string;

    /** @description Employer */
    // @ApiMember(Description="Employer", ParameterType="model")
    public employer: string;

    /** @description Business reference */
    // @ApiMember(Description="Business reference", ParameterType="model")
    public businessReference: string;

    /** @description National insurance number */
    // @ApiMember(Description="National insurance number", ParameterType="model")
    public niNumber: string;

    /** @description Hospital code */
    // @ApiMember(Description="Hospital code", ParameterType="model")
    public hospitalNumber: string;

    /** @description Customer hospital number */
    // @ApiMember(Description="Customer hospital number", ParameterType="model")
    public customerHospitalNumber: string;

    /** @description Insurance number */
    // @ApiMember(Description="Insurance number", ParameterType="model")
    public insuranceNumber: string;

    /** @description Medical contact GUIDs to assign to the customer */
    // @ApiMember(Description="Medical contact GUIDs to assign to the customer", ParameterType="model")
    public medicalContactIds: string[];

    /** @description Create the customer as provisional */
    // @ApiMember(Description="Create the customer as provisional", ParameterType="model")
    public provisional: boolean;

    /** @description Customer reference. If omitted, one is generated automatically. */
    // @ApiMember(Description="Customer reference. If omitted, one is generated automatically.", ParameterType="model")
    public reference: string;

    /** @description Register the customer for the Connect Booking Portal (online) access. Defaults to false — the customer will not be registered unless explicitly requested. */
    // @ApiMember(Description="Register the customer for the Connect Booking Portal (online) access. Defaults to false — the customer will not be registered unless explicitly requested.", ParameterType="model")
    public registerOnConnect: boolean;

    /** @description Source of the customer */
    // @ApiMember(Description="Source of the customer")
    public enquirySource: string;

    public constructor(init?: Partial<CreateCustomerV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateCustomerV1Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateCustomerV1Response(); }
}
(CreateCustomerV1Request as unknown)[immerable] = true;

/** @description Get a customer by ID */
// @Route("/v1/customers/{Id}", "GET")
// @Api(Description="Get a customer by ID")
export class GetCustomerV1Request implements IReturn<CustomerV1Dto>
{
    /** @description Customer GUID */
    // @ApiMember(Description="Customer GUID", IsRequired=true, ParameterType="path")
    public id: string;

    public constructor(init?: Partial<GetCustomerV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCustomerV1Request'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CustomerV1Dto(); }
}
(GetCustomerV1Request as unknown)[immerable] = true;

/** @description Update a customer */
// @Route("/v1/customers/{Id}", "PATCH")
// @Api(Description="Update a customer")
export class UpdateCustomerV1Request implements IReturn<CustomerV1Dto>
{
    /** @description Customer GUID */
    // @ApiMember(Description="Customer GUID", IsRequired=true, ParameterType="path")
    public id: string;

    /** @description Updated email address */
    // @ApiMember(Description="Updated email address", ParameterType="model")
    public email: string;

    /** @description Updated mobile telephone */
    // @ApiMember(Description="Updated mobile telephone", ParameterType="model")
    public mobileTelephone: string;

    /** @description Updated home telephone */
    // @ApiMember(Description="Updated home telephone", ParameterType="model")
    public homeTelephone: string;

    /** @description Updated work telephone */
    // @ApiMember(Description="Updated work telephone", ParameterType="model")
    public workTelephone: string;

    /** @description Updated title */
    // @ApiMember(Description="Updated title", ParameterType="model")
    public title: string;

    /** @description Updated date of birth */
    // @ApiMember(Description="Updated date of birth", ParameterType="model")
    public dateOfBirth?: string;

    /** @description Updated gender */
    // @ApiMember(Description="Updated gender", ParameterType="model")
    public gender: string;

    /** @description Updated address line 1 */
    // @ApiMember(Description="Updated address line 1", ParameterType="model")
    public addressLine1: string;

    /** @description Updated address line 2 */
    // @ApiMember(Description="Updated address line 2", ParameterType="model")
    public addressLine2: string;

    /** @description Updated address line 3 */
    // @ApiMember(Description="Updated address line 3", ParameterType="model")
    public addressLine3: string;

    /** @description Updated address line 4 */
    // @ApiMember(Description="Updated address line 4", ParameterType="model")
    public addressLine4: string;

    /** @description Updated postcode */
    // @ApiMember(Description="Updated postcode", ParameterType="model")
    public postCode: string;

    /** @description Updated default location GUID */
    // @ApiMember(Description="Updated default location GUID", ParameterType="model")
    public defaultLocationId?: string;

    /** @description Updated default practitioner GUID */
    // @ApiMember(Description="Updated default practitioner GUID", ParameterType="model")
    public defaultPractitionerId?: string;

    /** @description Updated business GUID */
    // @ApiMember(Description="Updated business GUID", ParameterType="model")
    public businessId?: string;

    /** @description Updated SMS consent */
    // @ApiMember(Description="Updated SMS consent", ParameterType="model")
    public smsConsent?: boolean;

    /** @description Updated email consent */
    // @ApiMember(Description="Updated email consent", ParameterType="model")
    public emailConsent?: boolean;

    /** @description Updated phone consent */
    // @ApiMember(Description="Updated phone consent", ParameterType="model")
    public phoneConsent?: boolean;

    /** @description Updated consent to treatment */
    // @ApiMember(Description="Updated consent to treatment", ParameterType="model")
    public givenConsent?: boolean;

    /** @description Updated customer status: 0=Inactive, 1=Active, -1=Deceased */
    // @ApiMember(Description="Updated customer status: 0=Inactive, 1=Active, -1=Deceased", ParameterType="model")
    public status?: number;

    /** @description Who pays for treatment: P=customer, G=business */
    // @ApiMember(Description="Who pays for treatment: P=customer, G=business", ParameterType="model")
    public billTo: string;

    /** @description Updated invoice period */
    // @ApiMember(Description="Updated invoice period", ParameterType="model")
    public invoicePeriod: string;

    /** @description Employer */
    // @ApiMember(Description="Employer", ParameterType="model")
    public employer: string;

    /** @description Updated business reference */
    // @ApiMember(Description="Updated business reference", ParameterType="model")
    public businessReference: string;

    /** @description Updated national insurance number */
    // @ApiMember(Description="Updated national insurance number", ParameterType="model")
    public niNumber: string;

    /** @description Updated hospital code */
    // @ApiMember(Description="Updated hospital code", ParameterType="model")
    public hospitalNumber: string;

    /** @description Updated customer hospital number */
    // @ApiMember(Description="Updated customer hospital number", ParameterType="model")
    public customerHospitalNumber: string;

    /** @description Updated insurance number */
    // @ApiMember(Description="Updated insurance number", ParameterType="model")
    public insuranceNumber: string;

    /** @description Medical contact GUIDs to replace the customer's assigned contacts */
    // @ApiMember(Description="Medical contact GUIDs to replace the customer's assigned contacts", ParameterType="model")
    public medicalContactIds: string[];

    /** @description Updated customer reference */
    // @ApiMember(Description="Updated customer reference", ParameterType="model")
    public reference: string;

    public constructor(init?: Partial<UpdateCustomerV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateCustomerV1Request'; }
    public getMethod() { return 'PATCH'; }
    public createResponse() { return new CustomerV1Dto(); }
}
(UpdateCustomerV1Request as unknown)[immerable] = true;

/** @description Search for customers */
// @Route("/v1/customers/search", "POST")
// @Api(Description="Search for customers")
export class SearchCustomersV1Request implements IReturn<SearchCustomersV1Response>
{
    /** @description Filter by forename */
    // @ApiMember(Description="Filter by forename", ParameterType="model")
    public foreName: string;

    /** @description Filter by surname */
    // @ApiMember(Description="Filter by surname", ParameterType="model")
    public surname: string;

    /** @description Filter by email address */
    // @ApiMember(Description="Filter by email address", ParameterType="model")
    public email: string;

    /** @description Filter by telephone */
    // @ApiMember(Description="Filter by telephone", ParameterType="model")
    public telephone: string;

    /** @description Filter by date of birth */
    // @ApiMember(Description="Filter by date of birth", ParameterType="model")
    public dateOfBirth?: string;

    /** @description Filter by reference */
    // @ApiMember(Description="Filter by reference", ParameterType="model")
    public reference: string;

    /** @description Filter by business GUID */
    // @ApiMember(Description="Filter by business GUID", ParameterType="model")
    public businessId?: string;

    /** @description Filter by default location GUID */
    // @ApiMember(Description="Filter by default location GUID", ParameterType="model")
    public defaultLocationId?: string;

    /** @description Filter by customer status */
    // @ApiMember(Description="Filter by customer status", ParameterType="model")
    public status?: number;

    /** @description Page number (default 1) */
    // @ApiMember(Description="Page number (default 1)", ParameterType="model")
    public page: number;

    /** @description Items per page (default 25, max 100) */
    // @ApiMember(Description="Items per page (default 25, max 100)", ParameterType="model")
    public perPage: number;

    public constructor(init?: Partial<SearchCustomersV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SearchCustomersV1Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SearchCustomersV1Response(); }
}
(SearchCustomersV1Request as unknown)[immerable] = true;

/** @description List customer documents */
// @Route("/v1/customers/{CustomerId}/documents", "GET")
// @Api(Description="List customer documents")
export class GetCustomerDocumentsV1Request implements IReturn<PaginatedResponseV1<DocumentV1Dto>>
{
    /** @description Customer GUID */
    // @ApiMember(Description="Customer GUID", IsRequired=true, ParameterType="path")
    public customerId: string;

    /** @description Page number (default 1) */
    // @ApiMember(Description="Page number (default 1)")
    public page: number;

    /** @description Items per page (default 20, max 100) */
    // @ApiMember(Description="Items per page (default 20, max 100)")
    public perPage: number;

    public constructor(init?: Partial<GetCustomerDocumentsV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCustomerDocumentsV1Request'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PaginatedResponseV1<DocumentV1Dto>(); }
}
(GetCustomerDocumentsV1Request as unknown)[immerable] = true;

/** @description Upload customer document */
// @Route("/v1/customers/{CustomerId}/documents", "POST")
// @Api(Description="Upload customer document")
export class UploadCustomerDocumentV1Request implements IReturn<DocumentV1Dto>
{
    /** @description Customer GUID */
    // @ApiMember(Description="Customer GUID", IsRequired=true, ParameterType="path")
    public customerId: string;

    /** @description File name including extension (e.g. referral.pdf) */
    // @ApiMember(Description="File name including extension (e.g. referral.pdf)", IsRequired=true, ParameterType="model")
    public fileName: string;

    /** @description Base64-encoded file content */
    // @ApiMember(Description="Base64-encoded file content", IsRequired=true, ParameterType="model")
    public content: string;

    /** @description MIME content type (e.g. application/pdf). Optional. */
    // @ApiMember(Description="MIME content type (e.g. application/pdf). Optional.", ParameterType="model")
    public contentType: string;

    /** @description Optional description shown against the document */
    // @ApiMember(Description="Optional description shown against the document", ParameterType="model")
    public description: string;

    public constructor(init?: Partial<UploadCustomerDocumentV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UploadCustomerDocumentV1Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DocumentV1Dto(); }
}
(UploadCustomerDocumentV1Request as unknown)[immerable] = true;

/** @description List locations */
// @Route("/v1/locations", "GET")
// @Api(Description="List locations")
export class GetLocationsV1Request implements IReturn<GetLocationsV1Response>
{
    /** @description Page number (default 1) */
    // @ApiMember(Description="Page number (default 1)")
    public page: number;

    /** @description Items per page (default 25, max 100) */
    // @ApiMember(Description="Items per page (default 25, max 100)")
    public perPage: number;

    /** @description Filter by location status */
    // @ApiMember(Description="Filter by location status")
    public status?: number;

    public constructor(init?: Partial<GetLocationsV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetLocationsV1Request'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetLocationsV1Response(); }
}
(GetLocationsV1Request as unknown)[immerable] = true;

/** @description Get location by GUID */
// @Route("/v1/locations/{Id}", "GET")
// @Api(Description="Get location by GUID")
export class GetLocationV1Request implements IReturn<LocationV1Dto>
{
    /** @description Location GUID */
    // @ApiMember(Description="Location GUID", IsRequired=true, ParameterType="path")
    public id: string;

    public constructor(init?: Partial<GetLocationV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetLocationV1Request'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new LocationV1Dto(); }
}
(GetLocationV1Request as unknown)[immerable] = true;

/** @description List medical contacts */
// @Route("/v1/medical-contacts", "GET")
// @Api(Description="List medical contacts")
export class SearchMedicalContactsV1Request implements IReturn<PaginatedResponseV1<MedicalContactV1Dto>>
{
    /** @description Filter by forename */
    // @ApiMember(Description="Filter by forename", ParameterType="query")
    public foreName: string;

    /** @description Filter by surname */
    // @ApiMember(Description="Filter by surname", ParameterType="query")
    public surname: string;

    /** @description Filter by business name */
    // @ApiMember(Description="Filter by business name", ParameterType="query")
    public businessName: string;

    /** @description Page number (default 1) */
    // @ApiMember(Description="Page number (default 1)", ParameterType="query")
    public page: number;

    /** @description Items per page (default 25, max 100) */
    // @ApiMember(Description="Items per page (default 25, max 100)", ParameterType="query")
    public perPage: number;

    public constructor(init?: Partial<SearchMedicalContactsV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SearchMedicalContactsV1Request'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PaginatedResponseV1<MedicalContactV1Dto>(); }
}
(SearchMedicalContactsV1Request as unknown)[immerable] = true;

/** @description Get a medical contact */
// @Route("/v1/medical-contacts/{Id}", "GET")
// @Api(Description="Get a medical contact")
export class GetMedicalContactV1Request implements IReturn<MedicalContactV1Dto>
{
    /** @description Medical contact GUID */
    // @ApiMember(Description="Medical contact GUID", IsRequired=true, ParameterType="path")
    public id: string;

    public constructor(init?: Partial<GetMedicalContactV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMedicalContactV1Request'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MedicalContactV1Dto(); }
}
(GetMedicalContactV1Request as unknown)[immerable] = true;

/** @description Create a medical contact */
// @Route("/v1/medical-contacts", "POST")
// @Api(Description="Create a medical contact")
export class CreateMedicalContactV1Request extends MedicalContactV1RequestBase implements IReturn<MedicalContactV1Dto>
{
    /** @description Contact forename */
    // @ApiMember(Description="Contact forename", IsRequired=true, ParameterType="model")
    // @Validate(Validator="NotEmpty")
    public foreName: string;

    /** @description Contact surname */
    // @ApiMember(Description="Contact surname", IsRequired=true, ParameterType="model")
    // @Validate(Validator="NotEmpty")
    public surname: string;

    public constructor(init?: Partial<CreateMedicalContactV1Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateMedicalContactV1Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MedicalContactV1Dto(); }
}
(CreateMedicalContactV1Request as unknown)[immerable] = true;

/** @description Update a medical contact */
// @Route("/v1/medical-contacts/{Id}", "PATCH")
// @Api(Description="Update a medical contact")
export class UpdateMedicalContactV1Request extends MedicalContactV1RequestBase implements IReturn<MedicalContactV1Dto>
{
    /** @description Medical contact GUID */
    // @ApiMember(Description="Medical contact GUID", IsRequired=true, ParameterType="path")
    public id: string;

    /** @description Updated contact forename */
    // @ApiMember(Description="Updated contact forename", ParameterType="model")
    public foreName: string;

    /** @description Updated contact surname */
    // @ApiMember(Description="Updated contact surname", ParameterType="model")
    public surname: string;

    public constructor(init?: Partial<UpdateMedicalContactV1Request>) { super(init); (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateMedicalContactV1Request'; }
    public getMethod() { return 'PATCH'; }
    public createResponse() { return new MedicalContactV1Dto(); }
}
(UpdateMedicalContactV1Request as unknown)[immerable] = true;

/** @description List medical contacts assigned to a customer */
// @Route("/v1/customers/{CustomerId}/medical-contacts", "GET")
// @Api(Description="List medical contacts assigned to a customer")
export class GetCustomerMedicalContactsV1Request implements IReturn<MedicalContactV1Dto[]>
{
    /** @description Customer GUID */
    // @ApiMember(Description="Customer GUID", IsRequired=true, ParameterType="path")
    public customerId: string;

    public constructor(init?: Partial<GetCustomerMedicalContactsV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCustomerMedicalContactsV1Request'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Array<MedicalContactV1Dto>(); }
}
(GetCustomerMedicalContactsV1Request as unknown)[immerable] = true;

/** @description Assign a medical contact to a customer */
// @Route("/v1/customers/{CustomerId}/medical-contacts", "POST")
// @Api(Description="Assign a medical contact to a customer")
export class AssignMedicalContactV1Request implements IReturn<MedicalContactV1Dto[]>
{
    /** @description Customer GUID */
    // @ApiMember(Description="Customer GUID", IsRequired=true, ParameterType="path")
    public customerId: string;

    /** @description Medical contact GUID */
    // @ApiMember(Description="Medical contact GUID", IsRequired=true, ParameterType="model")
    public contactId: string;

    /** @description Whether this is the customer's default contact */
    // @ApiMember(Description="Whether this is the customer's default contact", ParameterType="model")
    public defaultContact?: boolean;

    /** @description Whether the contact may be contacted for this customer */
    // @ApiMember(Description="Whether the contact may be contacted for this customer", ParameterType="model")
    public contactable?: boolean;

    public constructor(init?: Partial<AssignMedicalContactV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssignMedicalContactV1Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Array<MedicalContactV1Dto>(); }
}
(AssignMedicalContactV1Request as unknown)[immerable] = true;

/** @description Remove a medical contact from a customer */
// @Route("/v1/customers/{CustomerId}/medical-contacts/{ContactId}", "DELETE")
// @Api(Description="Remove a medical contact from a customer")
export class RemoveMedicalContactV1Request implements IReturn<MedicalContactV1Dto[]>
{
    /** @description Customer GUID */
    // @ApiMember(Description="Customer GUID", IsRequired=true, ParameterType="path")
    public customerId: string;

    /** @description Medical contact GUID */
    // @ApiMember(Description="Medical contact GUID", IsRequired=true, ParameterType="path")
    public contactId: string;

    public constructor(init?: Partial<RemoveMedicalContactV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RemoveMedicalContactV1Request'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new Array<MedicalContactV1Dto>(); }
}
(RemoveMedicalContactV1Request as unknown)[immerable] = true;

/** @description List customer notes */
// @Route("/v1/customers/{CustomerId}/notes", "GET")
// @Api(Description="List customer notes")
export class GetCustomerNotesV1Request implements IReturn<PaginatedResponseV1<NoteV1Dto>>
{
    /** @description Customer GUID */
    // @ApiMember(Description="Customer GUID", IsRequired=true, ParameterType="path")
    public customerId: string;

    /** @description Page number (default 1) */
    // @ApiMember(Description="Page number (default 1)")
    public page: number;

    /** @description Items per page (default 20, max 100) */
    // @ApiMember(Description="Items per page (default 20, max 100)")
    public perPage: number;

    /** @description Filter by note type */
    // @ApiMember(Description="Filter by note type")
    public type: string;

    public constructor(init?: Partial<GetCustomerNotesV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCustomerNotesV1Request'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PaginatedResponseV1<NoteV1Dto>(); }
}
(GetCustomerNotesV1Request as unknown)[immerable] = true;

/** @description Get note by ID */
// @Route("/v1/notes/{Id}", "GET")
// @Api(Description="Get note by ID")
export class GetNoteV1Request implements IReturn<NoteV1Dto>
{
    /** @description Note GUID */
    // @ApiMember(Description="Note GUID", IsRequired=true, ParameterType="path")
    public id: string;

    public constructor(init?: Partial<GetNoteV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetNoteV1Request'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new NoteV1Dto(); }
}
(GetNoteV1Request as unknown)[immerable] = true;

/** @description Create customer note */
// @Route("/v1/customers/{CustomerId}/notes", "POST")
// @Api(Description="Create customer note")
export class CreateNoteV1Request implements IReturn<NoteV1Dto>
{
    /** @description Customer GUID */
    // @ApiMember(Description="Customer GUID", IsRequired=true, ParameterType="path")
    public customerId: string;

    /** @description Note content */
    // @ApiMember(Description="Note content", IsRequired=true, ParameterType="model")
    public content: string;

    /** @description Note type */
    // @ApiMember(Description="Note type", ParameterType="model")
    public type: string;

    /** @description Note title */
    // @ApiMember(Description="Note title", ParameterType="model")
    public title: string;

    /** @description Alert note flag */
    // @ApiMember(Description="Alert note flag", ParameterType="model")
    public isAlert: boolean;

    public constructor(init?: Partial<CreateNoteV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateNoteV1Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new NoteV1Dto(); }
}
(CreateNoteV1Request as unknown)[immerable] = true;

/** @description Update note */
// @Route("/v1/notes/{Id}", "PATCH")
// @Api(Description="Update note")
export class UpdateNoteV1Request implements IReturn<NoteV1Dto>
{
    /** @description Note GUID */
    // @ApiMember(Description="Note GUID", IsRequired=true, ParameterType="path")
    public id: string;

    /** @description Updated note content */
    // @ApiMember(Description="Updated note content", ParameterType="model")
    public content: string;

    /** @description Updated note type */
    // @ApiMember(Description="Updated note type", ParameterType="model")
    public type: string;

    /** @description Updated note title */
    // @ApiMember(Description="Updated note title", ParameterType="model")
    public title: string;

    /** @description Updated alert note flag */
    // @ApiMember(Description="Updated alert note flag", ParameterType="model")
    public isAlert?: boolean;

    public constructor(init?: Partial<UpdateNoteV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateNoteV1Request'; }
    public getMethod() { return 'PATCH'; }
    public createResponse() { return new NoteV1Dto(); }
}
(UpdateNoteV1Request as unknown)[immerable] = true;

/** @description List practitioners */
// @Route("/v1/practitioners", "GET")
// @Api(Description="List practitioners")
export class GetPractitionersV1Request implements IReturn<PaginatedResponseV1<PractitionerV1Dto>>
{
    public page?: number;
    public perPage?: number;
    public status?: number;
    public online?: boolean;
    public locationId?: string;

    public constructor(init?: Partial<GetPractitionersV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPractitionersV1Request'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PaginatedResponseV1<PractitionerV1Dto>(); }
}
(GetPractitionersV1Request as unknown)[immerable] = true;

/** @description Get practitioner by GUID */
// @Route("/v1/practitioners/{Id}", "GET")
// @Api(Description="Get practitioner by GUID")
export class GetPractitionerV1Request implements IReturn<PractitionerV1Dto>
{
    public id: string;

    public constructor(init?: Partial<GetPractitionerV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPractitionerV1Request'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PractitionerV1Dto(); }
}
(GetPractitionerV1Request as unknown)[immerable] = true;

/** @description List practitioner locations */
// @Route("/v1/practitioners/{Id}/locations", "GET")
// @Api(Description="List practitioner locations")
export class GetPractitionerLocationsV1Request implements IReturn<PaginatedResponseV1<PractitionerLocationV1Dto>>
{
    public id: string;
    public page?: number;
    public perPage?: number;

    public constructor(init?: Partial<GetPractitionerLocationsV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPractitionerLocationsV1Request'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PaginatedResponseV1<PractitionerLocationV1Dto>(); }
}
(GetPractitionerLocationsV1Request as unknown)[immerable] = true;

/** @description Rooms */
// @Route("/v1/rooms", "GET")
// @Api(Description="Rooms")
export class GetRoomsV1Request implements IReturn<PaginatedResponseV1<RoomV1Dto>>
{
    /** @description Page number (1-indexed) */
    // @ApiMember(Description="Page number (1-indexed)")
    public page?: number;

    /** @description Items per page */
    // @ApiMember(Description="Items per page")
    public perPage?: number;

    /** @description Filter by location GUID */
    // @ApiMember(Description="Filter by location GUID")
    public locationId?: string;

    /** @description Filter by active status */
    // @ApiMember(Description="Filter by active status")
    public status?: boolean;

    public constructor(init?: Partial<GetRoomsV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetRoomsV1Request'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PaginatedResponseV1<RoomV1Dto>(); }
}
(GetRoomsV1Request as unknown)[immerable] = true;

/** @description Rooms */
// @Route("/v1/rooms/{Id}", "GET")
// @Api(Description="Rooms")
export class GetRoomV1Request implements IReturn<RoomV1Dto>
{
    /** @description Room GUID */
    // @ApiMember(Description="Room GUID", IsRequired=true, ParameterType="path")
    public id: string;

    public constructor(init?: Partial<GetRoomV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetRoomV1Request'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RoomV1Dto(); }
}
(GetRoomV1Request as unknown)[immerable] = true;

/** @description List service types */
// @Route("/v1/service-types", "GET")
// @Api(Description="List service types")
export class GetServiceTypesV1Request implements IReturn<GetServiceTypesV1Response>
{
    /** @description Page number (default 1) */
    // @ApiMember(Description="Page number (default 1)")
    public page: number;

    /** @description Items per page (default 25, max 100) */
    // @ApiMember(Description="Items per page (default 25, max 100)")
    public perPage: number;

    /** @description Filter by current status */
    // @ApiMember(Description="Filter by current status")
    public isCurrent?: boolean;

    public constructor(init?: Partial<GetServiceTypesV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetServiceTypesV1Request'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetServiceTypesV1Response(); }
}
(GetServiceTypesV1Request as unknown)[immerable] = true;

/** @description List stock items */
// @Route("/v1/stock", "GET")
// @Api(Description="List stock items")
export class GetStocksV1Request implements IReturn<GetStocksV1Response>
{
    /** @description Page number (default 1) */
    // @ApiMember(Description="Page number (default 1)")
    public page: number;

    /** @description Items per page (default 25, max 100) */
    // @ApiMember(Description="Items per page (default 25, max 100)")
    public perPage: number;

    /** @description Filter by stock category */
    // @ApiMember(Description="Filter by stock category")
    public category: string;

    /** @description Filter by online availability */
    // @ApiMember(Description="Filter by online availability")
    public online?: boolean;

    /** @description Filter by in-use status */
    // @ApiMember(Description="Filter by in-use status")
    public inUse?: boolean;

    public constructor(init?: Partial<GetStocksV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetStocksV1Request'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetStocksV1Response(); }
}
(GetStocksV1Request as unknown)[immerable] = true;

/** @description Get stock item by GUID */
// @Route("/v1/stock/{Id}", "GET")
// @Api(Description="Get stock item by GUID")
export class GetStockV1Request implements IReturn<StockV1Dto>
{
    /** @description Stock GUID */
    // @ApiMember(Description="Stock GUID", IsRequired=true, ParameterType="path")
    public id: string;

    public constructor(init?: Partial<GetStockV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetStockV1Request'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new StockV1Dto(); }
}
(GetStockV1Request as unknown)[immerable] = true;

/** @description List customer tags */
// @Route("/v1/customers/{CustomerId}/tags", "GET")
// @Api(Description="List customer tags")
export class GetCustomerTagsV1Request implements IReturn<TagV1Dto[]>
{
    /** @description Customer GUID */
    // @ApiMember(Description="Customer GUID", IsRequired=true, ParameterType="path")
    public customerId: string;

    public constructor(init?: Partial<GetCustomerTagsV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCustomerTagsV1Request'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Array<TagV1Dto>(); }
}
(GetCustomerTagsV1Request as unknown)[immerable] = true;

/** @description Add customer tags */
// @Route("/v1/customers/{CustomerId}/tags", "POST")
// @Api(Description="Add customer tags")
export class AddCustomerTagsV1Request implements IReturn<TagV1Dto[]>
{
    /** @description Customer GUID */
    // @ApiMember(Description="Customer GUID", IsRequired=true, ParameterType="path")
    public customerId: string;

    /** @description Tag names to add to the customer record */
    // @ApiMember(Description="Tag names to add to the customer record", IsRequired=true, ParameterType="model")
    public tags: string[] = [];

    public constructor(init?: Partial<AddCustomerTagsV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddCustomerTagsV1Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Array<TagV1Dto>(); }
}
(AddCustomerTagsV1Request as unknown)[immerable] = true;

/** @description Remove customer tag */
// @Route("/v1/customers/{CustomerId}/tags/{Tag}", "DELETE")
// @Api(Description="Remove customer tag")
export class RemoveCustomerTagV1Request implements IReturn<TagV1Dto[]>
{
    /** @description Customer GUID */
    // @ApiMember(Description="Customer GUID", IsRequired=true, ParameterType="path")
    public customerId: string;

    /** @description Tag name to remove */
    // @ApiMember(Description="Tag name to remove", IsRequired=true, ParameterType="path")
    public tag: string;

    public constructor(init?: Partial<RemoveCustomerTagV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RemoveCustomerTagV1Request'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new Array<TagV1Dto>(); }
}
(RemoveCustomerTagV1Request as unknown)[immerable] = true;

/** @description List customer tasks */
// @Route("/v1/customers/{CustomerId}/tasks", "GET")
// @Api(Description="List customer tasks")
export class GetCustomerTasksV1Request implements IReturn<PaginatedResponseV1<TaskV1Dto>>
{
    /** @description Customer GUID */
    // @ApiMember(Description="Customer GUID", IsRequired=true, ParameterType="path")
    public customerId: string;

    /** @description Page number (default 1) */
    // @ApiMember(Description="Page number (default 1)")
    public page: number;

    /** @description Items per page (default 20, max 100) */
    // @ApiMember(Description="Items per page (default 20, max 100)")
    public perPage: number;

    /** @description Filter by status (N = not started, I = in progress, C = completed) */
    // @ApiMember(Description="Filter by status (N = not started, I = in progress, C = completed)")
    public status: string;

    public constructor(init?: Partial<GetCustomerTasksV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCustomerTasksV1Request'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PaginatedResponseV1<TaskV1Dto>(); }
}
(GetCustomerTasksV1Request as unknown)[immerable] = true;

/** @description Get task by ID */
// @Route("/v1/tasks/{Id}", "GET")
// @Api(Description="Get task by ID")
export class GetTaskV1Request implements IReturn<TaskV1Dto>
{
    /** @description Task GUID */
    // @ApiMember(Description="Task GUID", IsRequired=true, ParameterType="path")
    public id: string;

    public constructor(init?: Partial<GetTaskV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTaskV1Request'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TaskV1Dto(); }
}
(GetTaskV1Request as unknown)[immerable] = true;

/** @description Create customer task */
// @Route("/v1/customers/{CustomerId}/tasks", "POST")
// @Api(Description="Create customer task")
export class CreateCustomerTaskV1Request implements IReturn<TaskV1Dto>
{
    /** @description Customer GUID */
    // @ApiMember(Description="Customer GUID", IsRequired=true, ParameterType="path")
    public customerId: string;

    /** @description Task description */
    // @ApiMember(Description="Task description", IsRequired=true, ParameterType="model")
    public description: string;

    /** @description Optional longer detail */
    // @ApiMember(Description="Optional longer detail", ParameterType="model")
    public longDescription: string;

    /** @description Due date (defaults to tomorrow) */
    // @ApiMember(Description="Due date (defaults to tomorrow)", ParameterType="model")
    public dueDate?: string;

    /** @description Status (N = not started, I = in progress, C = completed). Defaults to N */
    // @ApiMember(Description="Status (N = not started, I = in progress, C = completed). Defaults to N", ParameterType="model")
    public status: string;

    /** @description High priority flag */
    // @ApiMember(Description="High priority flag", ParameterType="model")
    public priority: boolean;

    /** @description Reminder flag */
    // @ApiMember(Description="Reminder flag", ParameterType="model")
    public reminder: boolean;

    /** @description User the task is assigned to */
    // @ApiMember(Description="User the task is assigned to", ParameterType="model")
    public assignedUserId?: number;

    public constructor(init?: Partial<CreateCustomerTaskV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateCustomerTaskV1Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TaskV1Dto(); }
}
(CreateCustomerTaskV1Request as unknown)[immerable] = true;

/** @description Update task */
// @Route("/v1/tasks/{Id}", "PATCH")
// @Api(Description="Update task")
export class UpdateTaskV1Request implements IReturn<TaskV1Dto>
{
    /** @description Task GUID */
    // @ApiMember(Description="Task GUID", IsRequired=true, ParameterType="path")
    public id: string;

    /** @description Updated description */
    // @ApiMember(Description="Updated description", ParameterType="model")
    public description: string;

    /** @description Updated longer detail */
    // @ApiMember(Description="Updated longer detail", ParameterType="model")
    public longDescription: string;

    /** @description Updated due date */
    // @ApiMember(Description="Updated due date", ParameterType="model")
    public dueDate?: string;

    /** @description Updated status (N = not started, I = in progress, C = completed) */
    // @ApiMember(Description="Updated status (N = not started, I = in progress, C = completed)", ParameterType="model")
    public status: string;

    /** @description Updated high priority flag */
    // @ApiMember(Description="Updated high priority flag", ParameterType="model")
    public priority?: boolean;

    /** @description Updated reminder flag */
    // @ApiMember(Description="Updated reminder flag", ParameterType="model")
    public reminder?: boolean;

    /** @description User the task is assigned to */
    // @ApiMember(Description="User the task is assigned to", ParameterType="model")
    public assignedUserId?: number;

    public constructor(init?: Partial<UpdateTaskV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateTaskV1Request'; }
    public getMethod() { return 'PATCH'; }
    public createResponse() { return new TaskV1Dto(); }
}
(UpdateTaskV1Request as unknown)[immerable] = true;

/** @description Search approved customer communication templates */
// @Route("/v1/templates/search", "POST")
// @Api(Description="Search approved customer communication templates")
export class SearchTemplatesV1Request implements IReturn<SearchTemplatesV1Response>
{
    /** @description Filter by contact type: "email" or "sms". Omit to return both. */
    // @ApiMember(Description="Filter by contact type: \"email\" or \"sms\". Omit to return both.", ParameterType="model")
    public type: string;

    /** @description Filter by template name (case-insensitive contains). */
    // @ApiMember(Description="Filter by template name (case-insensitive contains).", ParameterType="model")
    public name: string;

    /** @description Page number (default 1) */
    // @ApiMember(Description="Page number (default 1)", ParameterType="model")
    public page: number;

    /** @description Items per page (default 25, max 100) */
    // @ApiMember(Description="Items per page (default 25, max 100)", ParameterType="model")
    public perPage: number;

    public constructor(init?: Partial<SearchTemplatesV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SearchTemplatesV1Request'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SearchTemplatesV1Response(); }
}
(SearchTemplatesV1Request as unknown)[immerable] = true;

/** @description Get an approved customer communication template by its file path */
// @Route("/v1/templates/{TemplatePath*}", "GET")
// @Api(Description="Get an approved customer communication template by its file path")
export class GetTemplateV1Request implements IReturn<TemplateV1Dto>
{
    /** @description Template file path, e.g. "webTemplates/patients/Welcome.wtemail" */
    // @ApiMember(Description="Template file path, e.g. \"webTemplates/patients/Welcome.wtemail\"", IsRequired=true, ParameterType="path")
    public templatePath: string;

    public constructor(init?: Partial<GetTemplateV1Request>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTemplateV1Request'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TemplateV1Dto(); }
}
(GetTemplateV1Request as unknown)[immerable] = true;

/** @description Sign In */
// @Route("/auth", "GET,POST")
// @Route("/auth/{provider}", "GET,POST")
// @Api(Description="Sign In")
// @DataContract
export class Authenticate implements IReturn<AuthenticateResponse>, IPost
{
    /** @description AuthProvider, e.g. credentials */
    // @DataMember(Order=1)
    public provider: string;

    // @DataMember(Order=2)
    public userName: string;

    // @DataMember(Order=3)
    public password: string;

    // @DataMember(Order=4)
    public rememberMe?: boolean;

    // @DataMember(Order=5)
    public accessToken: string;

    // @DataMember(Order=6)
    public accessTokenSecret: string;

    // @DataMember(Order=7)
    public returnUrl: string;

    // @DataMember(Order=8)
    public errorView: string;

    // @DataMember(Order=9)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<Authenticate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'Authenticate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AuthenticateResponse(); }
}
(Authenticate as unknown)[immerable] = true;

// @Route("/assignroles", "POST")
// @DataContract
export class AssignRoles implements IReturn<AssignRolesResponse>, IPost
{
    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public permissions: string[];

    // @DataMember(Order=3)
    public roles: string[];

    // @DataMember(Order=4)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<AssignRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssignRoles'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AssignRolesResponse(); }
}
(AssignRoles as unknown)[immerable] = true;

// @Route("/unassignroles", "POST")
// @DataContract
export class UnAssignRoles implements IReturn<UnAssignRolesResponse>, IPost
{
    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public permissions: string[];

    // @DataMember(Order=3)
    public roles: string[];

    // @DataMember(Order=4)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<UnAssignRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UnAssignRoles'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UnAssignRolesResponse(); }
}
(UnAssignRoles as unknown)[immerable] = true;

// @Route("/access-token")
// @DataContract
export class GetAccessToken implements IReturn<GetAccessTokenResponse>, IPost
{
    // @DataMember(Order=1)
    public refreshToken: string;

    // @DataMember(Order=2)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<GetAccessToken>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAccessToken'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetAccessTokenResponse(); }
}
(GetAccessToken as unknown)[immerable] = true;

